/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type FragmentType<TDocumentNode extends DocumentNode<any, any>> = TDocumentNode extends DocumentNode<  infer TType,  any>  ? TType  : never;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string | Date; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string | Date; output: string; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: string; output: string; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: object; output: object; }
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: { input: string; output: string; }
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: { input: number; output: number; }
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: { input: string | Date; output: string; }
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: { input: number; output: number; }
  /** The `ID` scalar type represents a unique MongoDB identifier in collection. MongoDB by default use 12-byte ObjectId value (https://docs.mongodb.com/manual/reference/bson-types/#objectid). But MongoDB also may accepts string or integer as correct values for _id field. */
  MongoID: { input: string; output: string; }
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: { input: number; output: number; }
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: { input: number; output: number; }
  /** Integers that will have a value greater than 0. */
  PositiveInt: { input: number; output: number; }
  /** The string representation of JavaScript regexp. You may provide it with flags "/^abc.*\/i" or without flags like "^abc.*". More info about RegExp characters and flags: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions */
  RegExpAsString: { input: string; output: string; }
  /** A field whose value is a Semantic Version: https://semver.org */
  SemVer: { input: `${number}.${number}.${number}`; output: `${number}.${number}.${number}`; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: string; output: string; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string; }
  /** Represents NULL values */
  Void: { input: void; output: void; }
};

export type Acceleration = {
  /** ft/s² */
  feetPerSecondSquared: Scalars['Float']['output'];
  /** g */
  gForce: Scalars['Float']['output'];
  metresPerSecondSquared: Scalars['Float']['output'];
};

export type AccelerationInput = {
  /** ft/s² */
  feetPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
  /** g */
  gForce?: InputMaybe<Scalars['Float']['input']>;
  metresPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type AccelerationUnitField = {
  unit: EnumAccelerationUnit;
};

export type ActivateCarDataServiceConfigResult = {
  success: Scalars['Boolean']['output'];
};

export type ActiveConfig = {
  /** Message to display in the client */
  clientMessage?: Maybe<Array<Maybe<ActiveConfigClientMessage>>>;
  /** Declared session of the timing service configuration. */
  declaredSession?: Maybe<Scalars['String']['output']>;
  /** Last message received from the timing service. */
  lastMessage?: Maybe<Scalars['Date']['output']>;
  sessionMatch?: Maybe<Session>;
  /** ID of the session match. */
  sessionMatchID?: Maybe<Scalars['MongoID']['output']>;
  /** Information about the session match. */
  sessionMatchInfo?: Maybe<Scalars['String']['output']>;
  timingServiceConfig?: Maybe<TimingServiceConfig>;
  /** ID of the timing service configuration. */
  timingServiceConfigID: Scalars['MongoID']['output'];
};

export type ActiveConfigClientMessage = {
  /** HEX color for the message */
  color?: Maybe<Scalars['String']['output']>;
  /** Message to display in the client */
  text?: Maybe<Scalars['String']['output']>;
};

export type ActiveConfigClientMessageInput = {
  /** HEX color for the message */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Message to display in the client */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ActiveConfigInput = {
  /** Message to display in the client */
  clientMessage?: InputMaybe<Array<InputMaybe<ActiveConfigClientMessageInput>>>;
  /** Declared session of the timing service configuration. */
  declaredSession?: InputMaybe<Scalars['String']['input']>;
  /** Last message received from the timing service. */
  lastMessage?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the session match. */
  sessionMatchID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Information about the session match. */
  sessionMatchInfo?: InputMaybe<Scalars['String']['input']>;
  /** ID of the timing service configuration. */
  timingServiceConfigID: Scalars['MongoID']['input'];
};

export type AddCommentResult = {
  comment?: Maybe<Comment>;
  recordId: Scalars['MongoID']['output'];
};

export type AddControlTelemetryEndOfLapResult = {
  lapID?: Maybe<Scalars['MongoID']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddControlTelemetryEndOfRunResult = {
  lapID?: Maybe<Scalars['MongoID']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddControlTelemetryStartOfDataResult = {
  lapID?: Maybe<Scalars['MongoID']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddEventContestantResult = {
  success: Scalars['Boolean']['output'];
};

export type AddFlattenedPayloadReturnType = {
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddManyEventContestantsResult = {
  success: Scalars['Boolean']['output'];
};

export type AddTyreSetsToContestantResult = {
  contestant?: Maybe<Contestant>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTyreSetsToEventContestantResult = {
  changed?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTyresToContestantResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTyresToEventContestantResult = {
  changed?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how an acceleration field can be adjusted */
export type AdjustableAcceleration = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumAccelerationUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableAccelerationInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAccelerationUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableAccelerationProperty = {
  adjustableAcceleration?: Maybe<AdjustableAcceleration>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how an angle field can be adjusted */
export type AdjustableAngle = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumAngleUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableAngleInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngleUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableAngleProperty = {
  adjustableAngle?: Maybe<AdjustableAngle>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how an angular complaince field can be adjusted */
export type AdjustableAngularCompliance = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumAngularComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableAngularComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableAngularComplianceProperty = {
  adjustableAngularCompliance?: Maybe<AdjustableAngularCompliance>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how an angular torque compliance field can be adjusted */
export type AdjustableAngularTorqueCompliance = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumAngularTorqueComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableAngularTorqueComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableAngularTorqueComplianceProperty = {
  adjustableAngularTorqueCompliance?: Maybe<AdjustableAngularTorqueCompliance>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableBoolean = {
  defaultValue?: Maybe<Scalars['Boolean']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableBooleanInput = {
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdjustableBooleanProperty = {
  adjustableBoolean?: Maybe<AdjustableBoolean>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a compliance field can be adjusted */
export type AdjustableCompliance = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableComplianceProperty = {
  adjustableCompliance?: Maybe<AdjustableCompliance>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a force field can be adjusted */
export type AdjustableForce = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumForceUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableForceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumForceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableForceProperty = {
  adjustableForce?: Maybe<AdjustableForce>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how an inertia field can be adjusted */
export type AdjustableInertia = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumInertiaUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableInertiaInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumInertiaUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableInertiaProperty = {
  adjustableInertia?: Maybe<AdjustableInertia>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a length field can be adjusted */
export type AdjustableLength = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumLengthUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableLengthInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableLengthProperty = {
  adjustableLength?: Maybe<AdjustableLength>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableLocation = {
  coordinates?: Maybe<AdjustableLocationCoordinates>;
  defaultValue?: Maybe<AdjustableLocationDefaultValue>;
};

export type AdjustableLocationCoordinates = {
  /** Coordinate value x */
  x?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value y */
  y?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value z */
  z?: Maybe<Scalars['Float']['output']>;
};

export type AdjustableLocationCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type AdjustableLocationDefaultValue = {
  /** Coordinate value x */
  x?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value y */
  y?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value z */
  z?: Maybe<Scalars['Float']['output']>;
};

export type AdjustableLocationDefaultValueInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type AdjustableLocationInput = {
  coordinates?: InputMaybe<AdjustableLocationCoordinatesInput>;
  defaultValue?: InputMaybe<AdjustableLocationDefaultValueInput>;
};

export type AdjustableLocationProperty = {
  adjustableLocation?: Maybe<AdjustableLocation>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a mass field can be adjusted */
export type AdjustableMass = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumMassUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableMassInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumMassUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableMassProperty = {
  adjustableMass?: Maybe<AdjustableMass>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a numerical field can be adjusted */
export type AdjustableNumber = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  /** Unit to display values in */
  unit?: Maybe<Scalars['String']['output']>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableNumberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  /** Unit to display values in */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableNumberProperty = {
  adjustableNumber?: Maybe<AdjustableNumber>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableOrientation = {
  defaultValue?: Maybe<AdjustableOrientationDefaultValue>;
  rotation?: Maybe<AdjustableOrientationRotation>;
};

export type AdjustableOrientationDefaultValue = {
  /** Rotation value I */
  I?: Maybe<Scalars['Float']['output']>;
  /** Rotation value J */
  J?: Maybe<Scalars['Float']['output']>;
  /** Rotation value K */
  K?: Maybe<Scalars['Float']['output']>;
};

export type AdjustableOrientationDefaultValueInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type AdjustableOrientationInput = {
  defaultValue?: InputMaybe<AdjustableOrientationDefaultValueInput>;
  rotation?: InputMaybe<AdjustableOrientationRotationInput>;
};

export type AdjustableOrientationProperty = {
  adjustableOrientation?: Maybe<AdjustableOrientation>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableOrientationRotation = {
  /** Rotation value I */
  I?: Maybe<Scalars['Float']['output']>;
  /** Rotation value J */
  J?: Maybe<Scalars['Float']['output']>;
  /** Rotation value K */
  K?: Maybe<Scalars['Float']['output']>;
};

export type AdjustableOrientationRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

/** Details about how a power field can be adjusted */
export type AdjustablePower = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumPowerUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustablePowerInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPowerUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustablePowerProperty = {
  adjustablePower?: Maybe<AdjustablePower>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a pressure field can be adjusted */
export type AdjustablePressure = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumPressureUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustablePressureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPressureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustablePressureProperty = {
  adjustablePressure?: Maybe<AdjustablePressure>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableProperty = {
  adjustableAcceleration?: Maybe<AdjustableAcceleration>;
  adjustableAngle?: Maybe<AdjustableAngle>;
  adjustableAngularCompliance?: Maybe<AdjustableAngularCompliance>;
  adjustableAngularTorqueCompliance?: Maybe<AdjustableAngularTorqueCompliance>;
  adjustableBoolean?: Maybe<AdjustableBoolean>;
  adjustableCompliance?: Maybe<AdjustableCompliance>;
  adjustableForce?: Maybe<AdjustableForce>;
  adjustableInertia?: Maybe<AdjustableInertia>;
  adjustableLength?: Maybe<AdjustableLength>;
  adjustableLocation?: Maybe<AdjustableLocation>;
  adjustableMass?: Maybe<AdjustableMass>;
  adjustableNumber?: Maybe<AdjustableNumber>;
  adjustableOrientation?: Maybe<AdjustableOrientation>;
  adjustablePower?: Maybe<AdjustablePower>;
  adjustablePressure?: Maybe<AdjustablePressure>;
  adjustableRatio?: Maybe<AdjustableRatio>;
  adjustableSpringRate?: Maybe<AdjustableSpringRate>;
  adjustableSteeringRackRatio?: Maybe<AdjustableSteeringRackRatio>;
  adjustableString?: Maybe<AdjustableString>;
  adjustableTemperature?: Maybe<AdjustableTemperature>;
  adjustableTorque?: Maybe<AdjustableTorque>;
  adjustableTorsionRate?: Maybe<AdjustableTorsionRate>;
  adjustableVolume?: Maybe<AdjustableVolume>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<EnumAdjustablePropertyType>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustablePropertyInput = {
  adjustableAcceleration?: InputMaybe<AdjustableAccelerationInput>;
  adjustableAngle?: InputMaybe<AdjustableAngleInput>;
  adjustableAngularCompliance?: InputMaybe<AdjustableAngularComplianceInput>;
  adjustableAngularTorqueCompliance?: InputMaybe<AdjustableAngularTorqueComplianceInput>;
  adjustableBoolean?: InputMaybe<AdjustableBooleanInput>;
  adjustableCompliance?: InputMaybe<AdjustableComplianceInput>;
  adjustableForce?: InputMaybe<AdjustableForceInput>;
  adjustableInertia?: InputMaybe<AdjustableInertiaInput>;
  adjustableLength?: InputMaybe<AdjustableLengthInput>;
  adjustableLocation?: InputMaybe<AdjustableLocationInput>;
  adjustableMass?: InputMaybe<AdjustableMassInput>;
  adjustableNumber?: InputMaybe<AdjustableNumberInput>;
  adjustableOrientation?: InputMaybe<AdjustableOrientationInput>;
  adjustablePower?: InputMaybe<AdjustablePowerInput>;
  adjustablePressure?: InputMaybe<AdjustablePressureInput>;
  adjustableRatio?: InputMaybe<AdjustableRatioInput>;
  adjustableSpringRate?: InputMaybe<AdjustableSpringRateInput>;
  adjustableSteeringRackRatio?: InputMaybe<AdjustableSteeringRackRatioInput>;
  adjustableString?: InputMaybe<AdjustableStringInput>;
  adjustableTemperature?: InputMaybe<AdjustableTemperatureInput>;
  adjustableTorque?: InputMaybe<AdjustableTorqueInput>;
  adjustableTorsionRate?: InputMaybe<AdjustableTorsionRateInput>;
  adjustableVolume?: InputMaybe<AdjustableVolumeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<EnumAdjustablePropertyType>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Details about how a ratio field can be adjusted */
export type AdjustableRatio = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumRatioUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableRatioProperty = {
  adjustableRatio?: Maybe<AdjustableRatio>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a spring rate field can be adjusted */
export type AdjustableSpringRate = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumSpringRateUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableSpringRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpringRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableSpringRateProperty = {
  adjustableSpringRate?: Maybe<AdjustableSpringRate>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a steering rack ratio field can be adjusted */
export type AdjustableSteeringRackRatio = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumSteeringRackRatioUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableSteeringRackRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableSteeringRackRatioProperty = {
  adjustableSteeringRackRatio?: Maybe<AdjustableSteeringRackRatio>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustableString = {
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableStringInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableStringProperty = {
  adjustableString?: Maybe<AdjustableString>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a temperature field can be adjusted */
export type AdjustableTemperature = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumTemperatureUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableTemperatureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTemperatureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableTemperatureProperty = {
  adjustableTemperature?: Maybe<AdjustableTemperature>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a torque field can be adjusted */
export type AdjustableTorque = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumTorqueUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableTorqueInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorqueUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableTorqueProperty = {
  adjustableTorque?: Maybe<AdjustableTorque>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a torsion rate field can be adjusted */
export type AdjustableTorsionRate = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumTorsionRateUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableTorsionRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorsionRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableTorsionRateProperty = {
  adjustableTorsionRate?: Maybe<AdjustableTorsionRate>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about how a volume field can be adjusted */
export type AdjustableVolume = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumVolumeUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AdjustableVolumeInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumVolumeUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type AdjustableVolumeProperty = {
  adjustableVolume?: Maybe<AdjustableVolume>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type AdvancedAssemblyFilterReturnType = {
  count: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<BaseAssembly>>>;
  pageInfo?: Maybe<PaginationInfoAssembly>;
};

export type AdvancedPartsFilterReturnType = {
  count: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<Part>>>;
  pageInfo?: Maybe<PaginationInfo>;
};

export type Aero = {
  /** Number/Position of front flaps */
  NFlapF?: Maybe<Scalars['String']['output']>;
  /** Number/Position of front-left flaps */
  NFlapFL?: Maybe<Scalars['String']['output']>;
  /** Number/Position of front-right flaps */
  NFlapFR?: Maybe<Scalars['String']['output']>;
  /** Number/Position of lower rear flaps */
  NFlapLowerR?: Maybe<Scalars['String']['output']>;
  /** Number/Position of rear flaps */
  NFlapR?: Maybe<Scalars['String']['output']>;
  /** Number/Position of rear-left flaps */
  NFlapRL?: Maybe<Scalars['String']['output']>;
  /** Number/Position of rear-right flaps */
  NFlapRR?: Maybe<Scalars['String']['output']>;
  Z400?: Maybe<Scalars['String']['output']>;
  /** Front flap angle */
  aFlapF?: Maybe<Scalars['Float']['output']>;
  /** Front-left flap angle */
  aFlapFL?: Maybe<Scalars['Float']['output']>;
  /** Front-right flap angle */
  aFlapFR?: Maybe<Scalars['Float']['output']>;
  /** Lower rear flap angle */
  aFlapLowerR?: Maybe<Scalars['Float']['output']>;
  /** Rear flap angle */
  aFlapR?: Maybe<Scalars['Float']['output']>;
  /** Rear-left flap angle */
  aFlapRL?: Maybe<Scalars['Float']['output']>;
  /** Rear-right flap angle */
  aFlapRR?: Maybe<Scalars['Float']['output']>;
  /** Front splitter angle */
  aSplitterF?: Maybe<Scalars['Float']['output']>;
  /** Complete aero package spec */
  aeroPackage?: Maybe<Scalars['String']['output']>;
  floorBB?: Maybe<Scalars['String']['output']>;
  floorGurney?: Maybe<Scalars['String']['output']>;
  floorLeadingEdgeID?: Maybe<Scalars['String']['output']>;
  /** Front flap type */
  frontFlapType?: Maybe<Scalars['String']['output']>;
  frontWheelArch?: Maybe<Scalars['String']['output']>;
  hGurneyF?: Maybe<Scalars['Float']['output']>;
  hGurneyR?: Maybe<Scalars['Float']['output']>;
  /** Splitter height at measurement points */
  hSplitterF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  lowerDrivePlane?: Maybe<Scalars['String']['output']>;
  noseID?: Maybe<Scalars['String']['output']>;
  rearWingGurney?: Maybe<Scalars['String']['output']>;
  splitterID?: Maybe<Scalars['String']['output']>;
  tailGurney?: Maybe<Scalars['String']['output']>;
  tailID?: Maybe<Scalars['String']['output']>;
  upperDrivePlane?: Maybe<Scalars['String']['output']>;
};

export type AeroElement = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  attached?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  positionName?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<AeroElementSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
};

export type AeroElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  attached?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  positionName?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AeroElementSpec = AnySpecification & NonChassisSpec & {
  CxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  aeroElementInterpolationMethod?: Maybe<EnumAeroElementInterpolationMethod>;
  aeroElementType?: Maybe<EnumAeroElementType>;
  aeroPackageSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Names of sockets that this can be plugged in to.
   * @deprecated
   */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attachable?: Maybe<Scalars['Boolean']['output']>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<AeroElementSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  polyCxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  positionNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  positions?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<EnumReadingLocation>>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AeroInput = {
  /** Number/Position of front flaps */
  NFlapF?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-left flaps */
  NFlapFL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-right flaps */
  NFlapFR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of lower rear flaps */
  NFlapLowerR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear flaps */
  NFlapR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-left flaps */
  NFlapRL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-right flaps */
  NFlapRR?: InputMaybe<Scalars['String']['input']>;
  Z400?: InputMaybe<Scalars['String']['input']>;
  /** Front flap angle */
  aFlapF?: InputMaybe<Scalars['Float']['input']>;
  /** Front-left flap angle */
  aFlapFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right flap angle */
  aFlapFR?: InputMaybe<Scalars['Float']['input']>;
  /** Lower rear flap angle */
  aFlapLowerR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear flap angle */
  aFlapR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left flap angle */
  aFlapRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right flap angle */
  aFlapRR?: InputMaybe<Scalars['Float']['input']>;
  /** Front splitter angle */
  aSplitterF?: InputMaybe<Scalars['Float']['input']>;
  /** Complete aero package spec */
  aeroPackage?: InputMaybe<Scalars['String']['input']>;
  floorBB?: InputMaybe<Scalars['String']['input']>;
  floorGurney?: InputMaybe<Scalars['String']['input']>;
  floorLeadingEdgeID?: InputMaybe<Scalars['String']['input']>;
  /** Front flap type */
  frontFlapType?: InputMaybe<Scalars['String']['input']>;
  frontWheelArch?: InputMaybe<Scalars['String']['input']>;
  hGurneyF?: InputMaybe<Scalars['Float']['input']>;
  hGurneyR?: InputMaybe<Scalars['Float']['input']>;
  /** Splitter height at measurement points */
  hSplitterF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lowerDrivePlane?: InputMaybe<Scalars['String']['input']>;
  noseID?: InputMaybe<Scalars['String']['input']>;
  rearWingGurney?: InputMaybe<Scalars['String']['input']>;
  splitterID?: InputMaybe<Scalars['String']['input']>;
  tailGurney?: InputMaybe<Scalars['String']['input']>;
  tailID?: InputMaybe<Scalars['String']['input']>;
  upperDrivePlane?: InputMaybe<Scalars['String']['input']>;
};

export type AeroPackage = {
  aeroElements?: Maybe<Array<Maybe<AeroElement>>>;
  specification?: Maybe<AeroPackageSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
};

export type AeroPackageInput = {
  aeroElements?: InputMaybe<Array<InputMaybe<AeroElementInput>>>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AeroPackageSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  aeroElementSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  aeroElementSpecs: Array<AeroElementSpec>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<AeroPackageSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Angle = {
  /** ° */
  degrees: Scalars['Float']['output'];
  /** rad */
  radians: Scalars['Float']['output'];
  /** rev */
  revolutions: Scalars['Float']['output'];
};

export type AngleInput = {
  /** ° */
  degrees?: InputMaybe<Scalars['Float']['input']>;
  /** rad */
  radians?: InputMaybe<Scalars['Float']['input']>;
  /** rev */
  revolutions?: InputMaybe<Scalars['Float']['input']>;
};

export type AngleUnitField = {
  unit: EnumAngleUnit;
};

export type AngularAccelerationUnitField = {
  unit: EnumAngularAccelerationUnit;
};

export type AngularComplianceUnitField = {
  unit: EnumAngularComplianceUnit;
};

export type AngularTorqueComplianceUnitField = {
  unit: EnumAngularTorqueComplianceUnit;
};

export type AngularVelocity = {
  /** °/s */
  degreesPerSecond: Scalars['Float']['output'];
  /** rad/s */
  radiansPerSecond: Scalars['Float']['output'];
  /** rpm */
  revolutionsPerMinute: Scalars['Float']['output'];
  /** rev/s */
  revolutionsPerSecond: Scalars['Float']['output'];
};

export type AngularVelocityInput = {
  /** °/s */
  degreesPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rad/s */
  radiansPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rpm */
  revolutionsPerMinute?: InputMaybe<Scalars['Float']['input']>;
  /** rev/s */
  revolutionsPerSecond?: InputMaybe<Scalars['Float']['input']>;
};

export type AngularVelocityUnitField = {
  unit: EnumAngularVelocityUnit;
};

export type AntiRollBar = {
  /** kARB specified in this anti roll bar's linked specification. */
  kARB?: Maybe<Scalars['Float']['output']>;
  /** Name specified in this anti roll bar's linked specification. */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Refer to position 1 and position 2 instead */
  position?: Maybe<Scalars['String']['output']>;
  position1?: Maybe<Scalars['String']['output']>;
  position2?: Maybe<Scalars['String']['output']>;
  rockerPosition?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<AntiRollBarSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
};

export type AntiRollBarConfig = {
  /** Anti-roll bar stiffness (use spring rate units) */
  kARB?: Maybe<Scalars['Float']['output']>;
  kinematicsInternalSpec: Array<KinematicsInternalSpec>;
  kinematicsInternalSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** First connection point (should be a chassis socket) */
  position1?: Maybe<Scalars['String']['output']>;
  /** Second connection point (should be a chassis socket) */
  position2?: Maybe<Scalars['String']['output']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  tags: Array<Tag>;
};

export type AntiRollBarConfigInput = {
  /** Anti-roll bar stiffness (use spring rate units) */
  kARB?: InputMaybe<Scalars['Float']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** First connection point (should be a chassis socket) */
  position1?: InputMaybe<Scalars['String']['input']>;
  /** Second connection point (should be a chassis socket) */
  position2?: InputMaybe<Scalars['String']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type AntiRollBarInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  position1?: InputMaybe<Scalars['String']['input']>;
  position2?: InputMaybe<Scalars['String']['input']>;
  rockerPosition?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AntiRollBarSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  antiRollBarConfigs?: Maybe<Array<Maybe<AntiRollBarConfig>>>;
  /** @deprecated Use readingsRequired instead */
  antiRollBarDisplayLocation?: Maybe<EnumAntiRollBarDisplayLocation>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<AntiRollBarSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<EnumReadingLocation>>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AnyAssembly = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  assemblyTemplateID?: Maybe<Scalars['MongoID']['output']>;
  /** @deprecated Use userEnumAssemblyTypeID instead */
  assemblyTypeEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetNestLevel?: Maybe<Scalars['Float']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  current?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  locationID?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  nestedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  partInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  subAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type AnyRunSheetStyleBlock = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type AnySpecification = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  name: Scalars['String']['output'];
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  rootSpecificationID: Scalars['MongoID']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AnySubAssembly = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  assemblyTemplateID?: Maybe<Scalars['MongoID']['output']>;
  assemblyTypeEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetNestLevel?: Maybe<Scalars['Float']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  current?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  locationID?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  nestedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  partInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  subAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type AnyUserEnum = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
};

export type ApplyLapSequence = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ApplyMigrationResult = {
  success: Scalars['Boolean']['output'];
};

export type ApplyPackageItemsResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplyPackageResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Area = {
  /** sq ft */
  squareFeet: Scalars['Float']['output'];
  /** sq in */
  squareInches: Scalars['Float']['output'];
  /** m² */
  squareMetres: Scalars['Float']['output'];
  /** mm² */
  squareMillimetres: Scalars['Float']['output'];
};

export type AreaInput = {
  /** sq ft */
  squareFeet?: InputMaybe<Scalars['Float']['input']>;
  /** sq in */
  squareInches?: InputMaybe<Scalars['Float']['input']>;
  /** m² */
  squareMetres?: InputMaybe<Scalars['Float']['input']>;
  /** mm² */
  squareMillimetres?: InputMaybe<Scalars['Float']['input']>;
};

export type Assembly = ChassisAssembly | SubAssembly;

/** List of items with pagination. */
export type AssemblyPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Assembly>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AssemblyPartIDs = {
  assemblyID: Scalars['MongoID']['output'];
  partIDs: Array<Scalars['MongoID']['output']>;
};

export type AssemblyTemplate = {
  _id: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requiredAssemblies?: Maybe<Array<Maybe<AssemblyTemplateRequiredAssemblies>>>;
  requiredParts?: Maybe<Array<Maybe<AssemblyTemplateRequiredParts>>>;
};

/** List of items with pagination. */
export type AssemblyTemplatePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<AssemblyTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AssemblyTemplateRequiredAssemblies = {
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type AssemblyTemplateRequiredAssembliesInput = {
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AssemblyTemplateRequiredParts = {
  /** Specify where the part type should be added in */
  location?: Maybe<EnumAssemblyTemplateRequiredPartsLocation>;
  userEnumPartTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type AssemblyTemplateRequiredPartsInput = {
  /** Specify where the part type should be added in */
  location?: InputMaybe<EnumAssemblyTemplateRequiredPartsLocation>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AssignTeamResult = {
  success: Scalars['Boolean']['output'];
};

export type AssignableToTeam =
  | 'CARSETUP'
  | 'CONTESTANT'
  | 'PERSON'
  | 'RUNSHEET';

export type AssignedGear = {
  gear?: Maybe<GearSpec>;
  gearID: Scalars['MongoID']['output'];
  useHeadGear?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignedGearInput = {
  gearID: Scalars['MongoID']['input'];
  useHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttachedFile = {
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BaseAssembly = AnyAssembly & {
  _id: Scalars['MongoID']['output'];
  allPartInstanceActive?: Maybe<Scalars['Boolean']['output']>;
  assemblyTemplateID?: Maybe<Scalars['MongoID']['output']>;
  assemblyTypeEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetNestLevel?: Maybe<Scalars['Float']['output']>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  chassisMeasurements?: Maybe<Array<Maybe<ChassisAssemblyMeasurement>>>;
  /** @deprecated User should define chassis parts as custom specs */
  chassisPartID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpecName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  nestedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  nestedPartInstances: Array<PartInstance>;
  parentID?: Maybe<Scalars['MongoID']['output']>;
  partInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  partInstances: Array<PartInstance>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  runSheetName?: Maybe<Scalars['String']['output']>;
  subAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingSourceRecords?: Maybe<Array<Maybe<ChassisAssemblyTrackingSourceRecord>>>;
  type: EnumAssemblyType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumAssemblyType?: Maybe<UserEnum>;
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type BaseSpecification = AnySpecification & {
  CxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  FSpringSetup?: Maybe<AdjustableForce>;
  _id: Scalars['MongoID']['output'];
  aCamber?: Maybe<SpecificationACamber>;
  aCaster?: Maybe<SpecificationACamber>;
  aCasterMeasurementGain?: Maybe<Scalars['Float']['output']>;
  aCasterMeasurementOffset?: Maybe<Scalars['Float']['output']>;
  aToe?: Maybe<SpecificationACamber>;
  adjustableProperties?: Maybe<Array<Maybe<AdjustableProperty>>>;
  aeroElementInterpolationMethod?: Maybe<EnumAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  aeroElementType?: Maybe<EnumAeroElementType>;
  aeroPackageSpecID?: Maybe<Scalars['MongoID']['output']>;
  aeroPackageSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  antiRollBarConfigs?: Maybe<Array<Maybe<AntiRollBarConfig>>>;
  antiRollBarDisplayLocation?: Maybe<EnumAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: Maybe<Array<Maybe<AssignedGear>>>;
  attachable?: Maybe<Scalars['Boolean']['output']>;
  axle?: Maybe<EnumAxle>;
  bevelSetSpecID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  bumpRubberReference?: Maybe<EnumKinematicsInternalReference>;
  bumpRubberSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  bumpStopGapMethod?: Maybe<EnumBumpStopGapMethod>;
  calculationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: Maybe<Scalars['String']['output']>;
  chassisMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: Maybe<Scalars['Boolean']['output']>;
  copyReferencePackageID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customSimulationModels?: Maybe<Array<Maybe<SpecificationCustomSimulationModels>>>;
  customSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  customSpecType?: Maybe<Scalars['String']['output']>;
  customTables?: Maybe<Array<Maybe<SpecificationCustomTables>>>;
  damperAdjusters?: Maybe<Array<Maybe<DamperAdjuster>>>;
  damperConfigs?: Maybe<Array<Maybe<DamperConfig>>>;
  damperSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  differentialConfigs?: Maybe<Array<Maybe<DifferentialConfig>>>;
  differentialSpecID?: Maybe<Scalars['MongoID']['output']>;
  drawingNumber?: Maybe<Scalars['String']['output']>;
  dropGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  elasticType?: Maybe<EnumElasticType>;
  forceTable?: Maybe<ForceTable>;
  gearType?: Maybe<EnumGearType>;
  hRide?: Maybe<SpecificationHRide>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  headGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  helperSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: Maybe<Scalars['Boolean']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Spring constant of the elastic element. */
  kSpring?: Maybe<Scalars['Float']['output']>;
  kinematicsExternalModels?: Maybe<Array<Maybe<KinematicsExternalModel>>>;
  kinematicsExternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  kinematicsInternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  manufacturerID?: Maybe<Scalars['MongoID']['output']>;
  manufacturerReference?: Maybe<Scalars['String']['output']>;
  mass?: Maybe<ChassisMass>;
  massProperties?: Maybe<MassProperties>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: Maybe<ChassisMeasurements>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: Maybe<Array<Maybe<EnumSimModelType>>>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  polyCxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  positionNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  positions?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  powerUnits?: Maybe<Array<Maybe<ChassisPowerUnit>>>;
  powertrain?: Maybe<ChassisPowertrain>;
  powertrainLocation?: Maybe<EnumSpecificationPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  rBrakeBias?: Maybe<AdjustableRatio>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<Maybe<EnumSpecificationReadingsAllowable>>>;
  readingsRequired?: Maybe<EnumSpecificationReadingsRequired>;
  reboundSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  reference?: Maybe<Scalars['String']['output']>;
  regulationSets?: Maybe<Array<Maybe<RegulationSet>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: Maybe<Scalars['Date']['output']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  setupChangesFilter?: Maybe<SpecificationSetupChangesFilter>;
  setupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: Maybe<Scalars['MongoID']['output']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: Maybe<Scalars['MongoID']['output']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  /** Locations/areas that components can be installed in. */
  sockets?: Maybe<Array<Maybe<ChassisSocket>>>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  specificationGroupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  springReference?: Maybe<EnumKinematicsInternalReference>;
  springSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  torsionBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurements: Array<TrackingMeasurement>;
  trackingSourceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  type: EnumSpecificationType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User-supplied version of this specification. */
  version?: Maybe<Scalars['String']['output']>;
  xBumpRubberRef?: Maybe<Scalars['Float']['output']>;
  xBumpRubberSetup?: Maybe<AdjustableLength>;
  xBumpStopGapDefault?: Maybe<Scalars['Float']['output']>;
  xDamperDroopDefault?: Maybe<Scalars['Float']['output']>;
  xDamperSetupDefault?: Maybe<Scalars['Float']['output']>;
  xDroopStopGapDefault?: Maybe<Scalars['Float']['output']>;
  /** Length of the elastic element under no force */
  xFree?: Maybe<Scalars['Float']['output']>;
  xShaftDroopDefault?: Maybe<Scalars['Float']['output']>;
  xSpringPlatformOffset?: Maybe<Scalars['Float']['output']>;
  xSpringRef?: Maybe<Scalars['Float']['output']>;
  xSpringSetup?: Maybe<AdjustableLength>;
  xToe?: Maybe<SpecificationHRide>;
};

export type BaseTypedUnitFieldInput = {
  type: EnumTypedUnitType;
  unit: EnumPossibleUnit;
};

export type BehaviourConfig = {
  /** Should job list templates be re-used from previous runs when creating new run sheets? */
  carryOverJobList?: Maybe<Scalars['Boolean']['output']>;
  /** If true, the issue block will be ticked to show only the users issues on load. */
  showMyIssuesOnRunSheetDefault?: Maybe<Scalars['Boolean']['output']>;
  /** If true, the job block will be ticked to show only the users jobs on load. */
  showMyJobsOnRunSheetDefault?: Maybe<Scalars['Boolean']['output']>;
  /** The locale to use for time formatting */
  timeLocale?: Maybe<Scalars['String']['output']>;
  /** ORH will use the users timezone selection to format times accordingly */
  timezoneSelect?: Maybe<EnumBehaviourConfigTimezoneSelect>;
};

export type BehaviourConfigInput = {
  /** Should job list templates be re-used from previous runs when creating new run sheets? */
  carryOverJobList?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the issue block will be ticked to show only the users issues on load. */
  showMyIssuesOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the job block will be ticked to show only the users jobs on load. */
  showMyJobsOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The locale to use for time formatting */
  timeLocale?: InputMaybe<Scalars['String']['input']>;
  /** ORH will use the users timezone selection to format times accordingly */
  timezoneSelect?: InputMaybe<EnumBehaviourConfigTimezoneSelect>;
};

export type BestValues = {
  _id: Scalars['MongoID']['output'];
  /** Contestant these personal bests belong to, if applicable. */
  contestant?: Maybe<Contestant>;
  /** ID of the contestant these personal bests belong to, if applicable. */
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  /** Driver these personal bests belong to, if applicable. */
  driver?: Maybe<Person>;
  /** ID of the driver these personal bests belong to, if applicable. */
  driverID?: Maybe<Scalars['MongoID']['output']>;
  fastestLap?: Maybe<BestValuesFastestLap>;
  fastestSectors?: Maybe<Array<Maybe<BestValuesFastestSector>>>;
  session?: Maybe<Session>;
  sessionID: Scalars['MongoID']['output'];
};

export type BestValuesFastestLap = {
  /** Lap number within the run sheet for this lap. */
  NLapRun?: Maybe<Scalars['Float']['output']>;
  /** Acronym of the driver that completed this lap. */
  driver?: Maybe<Scalars['String']['output']>;
  /** Run sheet that this lap can be found in. */
  runSheet?: Maybe<RunSheet>;
  /** ID of the run sheet that this lap can be found in. */
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  /** Time the lap was completed in. */
  time?: Maybe<Scalars['Float']['output']>;
};

export type BestValuesFastestLapInput = {
  /** Lap number within the run sheet for this lap. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this lap. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this lap can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the lap was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type BestValuesFastestSector = {
  /** Lap number within the run sheet for this sector. */
  NLapRun?: Maybe<Scalars['Float']['output']>;
  /** Acronym of the driver that completed this sector. */
  driver?: Maybe<Scalars['String']['output']>;
  /** Run sheet that this sector can be found in. */
  runSheet?: Maybe<RunSheet>;
  /** ID of the run sheet that this sector can be found in. */
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  /** Time the sector was completed in. */
  time?: Maybe<Scalars['Float']['output']>;
};

export type BestValuesFastestSectorInput = {
  /** Lap number within the run sheet for this sector. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this sector. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this sector can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the sector was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type BestValuesPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<BestValues>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BlankingBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type BooleanUnitField = {
  unit: EnumUntypedUnit;
};

export type Bop = {
  _id: Scalars['MongoID']['output'];
  bopFile?: Maybe<AttachedFile>;
  carBop?: Maybe<Array<Maybe<BopCarBop>>>;
  name?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Session>;
  sessionBop?: Maybe<BopSessionBop>;
  sessionID: Scalars['MongoID']['output'];
};

export type BopCarBop = {
  EStintMax?: Maybe<Scalars['Float']['output']>;
  PEngineMax?: Maybe<Scalars['Float']['output']>;
  VFuelVolumeCapacityMax?: Maybe<Scalars['Float']['output']>;
  VRefuelVolumeMax?: Maybe<Scalars['Float']['output']>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  aCamberFmax?: Maybe<Scalars['Float']['output']>;
  aCamberFmin?: Maybe<Scalars['Float']['output']>;
  aCamberRmax?: Maybe<Scalars['Float']['output']>;
  aCamberRmin?: Maybe<Scalars['Float']['output']>;
  aRakeMax?: Maybe<Scalars['Float']['output']>;
  aRakeMin?: Maybe<Scalars['Float']['output']>;
  aWingRmax?: Maybe<Scalars['Float']['output']>;
  aWingRmin?: Maybe<Scalars['Float']['output']>;
  carSpec?: Maybe<Scalars['String']['output']>;
  hRideFmin?: Maybe<Scalars['Float']['output']>;
  hRideRmin?: Maybe<Scalars['Float']['output']>;
  highlightColour?: Maybe<Scalars['String']['output']>;
  homologation?: Maybe<Scalars['String']['output']>;
  mCarBallastMin?: Maybe<Scalars['Float']['output']>;
  mCarWeightEmptyMin?: Maybe<Scalars['Float']['output']>;
  mCarWeightTotalMin?: Maybe<Scalars['Float']['output']>;
  mFuelMassCapacityMax?: Maybe<Scalars['Float']['output']>;
  mRefuelMassMax?: Maybe<Scalars['Float']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  modelYear?: Maybe<Scalars['String']['output']>;
  nEngineMax?: Maybe<Scalars['Float']['output']>;
  /** A map rpm vs boost pressure */
  pEngineBoost?: Maybe<Scalars['JSON']['output']>;
  rLambdaMin?: Maybe<Scalars['Float']['output']>;
  rPowerCurveReference?: Maybe<Scalars['Float']['output']>;
  rPowerGainAboveRefVelocity?: Maybe<Scalars['Float']['output']>;
  vCarMax?: Maybe<Scalars['Float']['output']>;
  vPowerCurveBelowRefVelocity?: Maybe<Scalars['Float']['output']>;
  vPowerGainReference?: Maybe<Scalars['Float']['output']>;
  xAirRestrictorMax?: Maybe<Scalars['Float']['output']>;
  xFuelRestrictorMax?: Maybe<Scalars['Float']['output']>;
  xRefuelRestrictorMax?: Maybe<Scalars['Float']['output']>;
  zWingMin?: Maybe<Scalars['Float']['output']>;
};

export type BopCarBopInput = {
  EStintMax?: InputMaybe<Scalars['Float']['input']>;
  PEngineMax?: InputMaybe<Scalars['Float']['input']>;
  VFuelVolumeCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelVolumeMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aCamberFmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberFmin?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmin?: InputMaybe<Scalars['Float']['input']>;
  aRakeMax?: InputMaybe<Scalars['Float']['input']>;
  aRakeMin?: InputMaybe<Scalars['Float']['input']>;
  aWingRmax?: InputMaybe<Scalars['Float']['input']>;
  aWingRmin?: InputMaybe<Scalars['Float']['input']>;
  carSpec?: InputMaybe<Scalars['String']['input']>;
  hRideFmin?: InputMaybe<Scalars['Float']['input']>;
  hRideRmin?: InputMaybe<Scalars['Float']['input']>;
  highlightColour?: InputMaybe<Scalars['String']['input']>;
  homologation?: InputMaybe<Scalars['String']['input']>;
  mCarBallastMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightEmptyMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightTotalMin?: InputMaybe<Scalars['Float']['input']>;
  mFuelMassCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  mRefuelMassMax?: InputMaybe<Scalars['Float']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['String']['input']>;
  nEngineMax?: InputMaybe<Scalars['Float']['input']>;
  /** A map rpm vs boost pressure */
  pEngineBoost?: InputMaybe<Scalars['JSON']['input']>;
  rLambdaMin?: InputMaybe<Scalars['Float']['input']>;
  rPowerCurveReference?: InputMaybe<Scalars['Float']['input']>;
  rPowerGainAboveRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vCarMax?: InputMaybe<Scalars['Float']['input']>;
  vPowerCurveBelowRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vPowerGainReference?: InputMaybe<Scalars['Float']['input']>;
  xAirRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xFuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xRefuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  zWingMin?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type BopPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Bop>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BopSessionBop = {
  EStintEnergyMax?: Maybe<Scalars['Float']['output']>;
  EStintEnergyRefillRateMax?: Maybe<Scalars['Float']['output']>;
  VRefuelRateMax?: Maybe<Scalars['Float']['output']>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  mRefuelRateMax?: Maybe<Scalars['Float']['output']>;
  pAmbientSessionOfficial?: Maybe<Scalars['Float']['output']>;
  tyreModel?: Maybe<Scalars['String']['output']>;
  xStintlengthMax?: Maybe<Scalars['Float']['output']>;
};

export type BopSessionBopInput = {
  EStintEnergyMax?: InputMaybe<Scalars['Float']['input']>;
  EStintEnergyRefillRateMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  mRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  pAmbientSessionOfficial?: InputMaybe<Scalars['Float']['input']>;
  tyreModel?: InputMaybe<Scalars['String']['input']>;
  xStintlengthMax?: InputMaybe<Scalars['Float']['input']>;
};

export type Brake = {
  /** Is brake duct enabled? */
  BBrakeDuctEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Part number of brake discs */
  NBrakeDisc?: Maybe<Scalars['Float']['output']>;
  /** Part number of left pads */
  NPadL?: Maybe<Scalars['Float']['output']>;
  /** Part number of right pads */
  NPadR?: Maybe<Scalars['Float']['output']>;
  /** Brake blanking style (top → bottom, left → right, …) */
  brakeBlankingStyle?: Maybe<Scalars['String']['output']>;
  /** Brake duct specification */
  brakeDuctSpec?: Maybe<Scalars['String']['output']>;
  /** Brake caliper blanking height */
  hBrakeCaliperBlanking?: Maybe<Scalars['Float']['output']>;
  /** Brake disc blanking height */
  hBrakeDiscBlanking?: Maybe<Scalars['Float']['output']>;
  /** Brake caliper blanking ratio */
  rBrakeCaliperBlanking?: Maybe<Scalars['Float']['output']>;
  /** Brake disc blanking ratio */
  rBrakeDiscBlanking?: Maybe<Scalars['Float']['output']>;
};

export type BrakeInput = {
  /** Is brake duct enabled? */
  BBrakeDuctEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Part number of brake discs */
  NBrakeDisc?: InputMaybe<Scalars['Float']['input']>;
  /** Part number of left pads */
  NPadL?: InputMaybe<Scalars['Float']['input']>;
  /** Part number of right pads */
  NPadR?: InputMaybe<Scalars['Float']['input']>;
  /** Brake blanking style (top → bottom, left → right, …) */
  brakeBlankingStyle?: InputMaybe<Scalars['String']['input']>;
  /** Brake duct specification */
  brakeDuctSpec?: InputMaybe<Scalars['String']['input']>;
  /** Brake caliper blanking height */
  hBrakeCaliperBlanking?: InputMaybe<Scalars['Float']['input']>;
  /** Brake disc blanking height */
  hBrakeDiscBlanking?: InputMaybe<Scalars['Float']['input']>;
  /** Brake caliper blanking ratio */
  rBrakeCaliperBlanking?: InputMaybe<Scalars['Float']['input']>;
  /** Brake disc blanking ratio */
  rBrakeDiscBlanking?: InputMaybe<Scalars['Float']['input']>;
};

export type BrakeSystem = {
  BBBSEnabled?: Maybe<Scalars['Boolean']['output']>;
  brakePadFManufacturer?: Maybe<Scalars['String']['output']>;
  brakePadFSpec?: Maybe<Scalars['String']['output']>;
  brakePadRManufacturer?: Maybe<Scalars['String']['output']>;
  brakePadRSpec?: Maybe<Scalars['String']['output']>;
  brakePedalPosition?: Maybe<Scalars['String']['output']>;
  dMasterCylinderF?: Maybe<Scalars['Float']['output']>;
  dMasterCylinderR?: Maybe<Scalars['Float']['output']>;
  kBBSSpring?: Maybe<Scalars['Float']['output']>;
  kKnockOffSpringF?: Maybe<Scalars['Float']['output']>;
  kKnockOffSpringR?: Maybe<Scalars['Float']['output']>;
  masterCylinderFSpec?: Maybe<Scalars['String']['output']>;
  masterCylinderRSpec?: Maybe<Scalars['String']['output']>;
  masterCylinderRodLengthF?: Maybe<Scalars['Float']['output']>;
  masterCylinderRodlengthR?: Maybe<Scalars['Float']['output']>;
  pBrakeBalanceRef?: Maybe<Scalars['Float']['output']>;
  rBrakeF?: Maybe<Scalars['Float']['output']>;
  rBrakePedal?: Maybe<Scalars['Float']['output']>;
  xBBSPreload?: Maybe<Scalars['Float']['output']>;
};

export type BrakeSystemInput = {
  BBBSEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  brakePadFManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadFSpec?: InputMaybe<Scalars['String']['input']>;
  brakePadRManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadRSpec?: InputMaybe<Scalars['String']['input']>;
  brakePedalPosition?: InputMaybe<Scalars['String']['input']>;
  dMasterCylinderF?: InputMaybe<Scalars['Float']['input']>;
  dMasterCylinderR?: InputMaybe<Scalars['Float']['input']>;
  kBBSSpring?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringF?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringR?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderFSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRodLengthF?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderRodlengthR?: InputMaybe<Scalars['Float']['input']>;
  pBrakeBalanceRef?: InputMaybe<Scalars['Float']['input']>;
  rBrakeF?: InputMaybe<Scalars['Float']['input']>;
  rBrakePedal?: InputMaybe<Scalars['Float']['input']>;
  xBBSPreload?: InputMaybe<Scalars['Float']['input']>;
};

export type BrakesBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  brakeFields?: Maybe<Array<Maybe<EnumBrakeBlockField>>>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** @deprecated Specify EnumBrakeBlockField.POST_RUN_BRAKE_TEMPS in `brakeFields` instead */
  showPostRunBrakeTemps?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Specify EnumBrakeBlockField.PRE_RUN_BRAKE_TEMPS in `brakeFields` instead */
  showPreRunBrakeTemps?: Maybe<Scalars['Boolean']['output']>;
  temperatureUnit?: Maybe<EnumTemperatureUnit>;
  title: Scalars['String']['output'];
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type BuildSheetStyle = {
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  blocks?: Maybe<Array<Maybe<BuildSheetStyleBlock>>>;
  chassisSpec?: Maybe<ChassisSpec>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  issue?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  targetEventType?: Maybe<EnumBuildSheetStyleTargetEventType>;
  targetRoles?: Maybe<Array<Maybe<EnumBuildSheetStyleTargetRoles>>>;
  targetUserIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  targetUsers: Array<Person>;
  type: EnumBuildSheetStyleType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type BuildSheetStyleBlock = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The height of the block within the grid */
  h: Scalars['Int']['output'];
  moved?: Maybe<Scalars['Boolean']['output']>;
  resizing?: Maybe<Scalars['Boolean']['output']>;
  static?: Maybe<Scalars['Boolean']['output']>;
  tabs?: Maybe<Array<Maybe<BuildSheetStyleTab>>>;
  /** The width of the block within the grid */
  w: Scalars['Int']['output'];
  /** The x position of the block within the grid */
  x: Scalars['Int']['output'];
  /** The y position of the block within the grid */
  y: Scalars['Int']['output'];
};

export type BuildSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  h: Scalars['Int']['input'];
  moved?: InputMaybe<Scalars['Boolean']['input']>;
  resizing?: InputMaybe<Scalars['Boolean']['input']>;
  static?: InputMaybe<Scalars['Boolean']['input']>;
  tabs?: InputMaybe<Array<InputMaybe<BuildSheetStyleTabInput>>>;
  /** The width of the block within the grid */
  w: Scalars['Int']['input'];
  /** The x position of the block within the grid */
  x: Scalars['Int']['input'];
  /** The y position of the block within the grid */
  y: Scalars['Int']['input'];
};

/** List of items with pagination. */
export type BuildSheetStylePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<BuildSheetStyle>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BuildSheetStyleTab = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  buildSheetGroupEnum?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  title: Scalars['String']['output'];
};

export type BuildSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  title: Scalars['String']['input'];
};

export type BumpStop = {
  name?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<ElasticSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  xBumpStopGap?: Maybe<Scalars['Float']['output']>;
};

export type BumpStopInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  xBumpStopGap?: InputMaybe<Scalars['Float']['input']>;
};

export type CalculateAllRunEnergiesResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CalculatePartMileageById = {
  mileage?: Maybe<Scalars['Float']['output']>;
  partID?: Maybe<Scalars['MongoID']['output']>;
};

export type CalculateRunEnergyResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Calculation = {
  _id: Scalars['MongoID']['output'];
  /** For the client to display debug information or default return values */
  debugMode?: Maybe<Scalars['Boolean']['output']>;
  displayUnit?: Maybe<EnumDisplayUnit>;
  functionString: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The name of the parameter or path to a field which this calculation gives as output. */
  parameter: Scalars['String']['output'];
  /** The names of the parameters or paths to fields which this calculation depends on. If any of these change, the calculation should be re-run. */
  trigger: Array<Scalars['String']['output']>;
  type: EnumCalculationType;
  version?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type CalculationPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Calculation>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CanopyConfig = {
  canopyID: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  simVersion: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CanopyCredentials = {
  /** Client ID for the Canopy API */
  clientID?: Maybe<Scalars['String']['output']>;
  /** Client secret for the Canopy API */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Password for the Canopy API */
  password?: Maybe<Scalars['String']['output']>;
  /** Tenant ID from the Canopy API */
  tenantID?: Maybe<Scalars['String']['output']>;
  /** User ID from the Canopy API */
  userID?: Maybe<Scalars['String']['output']>;
  /** Username for the Canopy API */
  username?: Maybe<Scalars['String']['output']>;
};

export type CanopyCredentialsInput = {
  /** Client ID for the Canopy API */
  clientID?: InputMaybe<Scalars['String']['input']>;
  /** Client secret for the Canopy API */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Password for the Canopy API */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID from the Canopy API */
  tenantID?: InputMaybe<Scalars['String']['input']>;
  /** Username for the Canopy API */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CarCorner = {
  aCamber?: Maybe<Scalars['Float']['output']>;
  aCamberMeasurement?: Maybe<Scalars['Float']['output']>;
  aCaster?: Maybe<Scalars['Float']['output']>;
  aCasterMeasurement?: Maybe<Scalars['Float']['output']>;
  /** @deprecated  */
  aFlap?: Maybe<Scalars['Float']['output']>;
  aToe?: Maybe<Scalars['Float']['output']>;
  aToeMeasurement?: Maybe<Scalars['Float']['output']>;
  /** @deprecated  */
  brake?: Maybe<Brake>;
  bumpStop?: Maybe<BumpStop>;
  damper?: Maybe<Damper>;
  droopStop?: Maybe<DroopStop>;
  externalBumpStop?: Maybe<ExternalBumpStop>;
  hRide?: Maybe<Scalars['Float']['output']>;
  hRideChassis?: Maybe<Scalars['Float']['output']>;
  hRideMeasurement?: Maybe<Scalars['Float']['output']>;
  hRideRegulation?: Maybe<Scalars['Float']['output']>;
  helperSpring?: Maybe<Spring>;
  pTyreTarget?: Maybe<Scalars['Float']['output']>;
  reboundSpring?: Maybe<Spring>;
  spring?: Maybe<Spring>;
  /** @deprecated  */
  suspension?: Maybe<Suspension>;
  xToe?: Maybe<Scalars['Float']['output']>;
  xToeMeasurement?: Maybe<Scalars['Float']['output']>;
};

export type CarCornerInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aFlap?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  brake?: InputMaybe<BrakeInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  suspension?: InputMaybe<SuspensionInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type CarDataServiceApplicationSettingsConfig = {
  DriverContestantLookup?: Maybe<Scalars['JSON']['output']>;
  FunctionsFolder?: Maybe<Scalars['String']['output']>;
  PitstopTriggers?: Maybe<Array<Maybe<CarDataServicePitstopTrigger>>>;
  ProcessedFolder?: Maybe<Scalars['String']['output']>;
  ResultsFolder?: Maybe<Scalars['String']['output']>;
  RunsheetMatching?: Maybe<EnumCarDataServiceApplicationSettingsConfigRunsheetMatching>;
};

export type CarDataServiceApplicationSettingsConfigInput = {
  DriverContestantLookup?: InputMaybe<Scalars['JSON']['input']>;
  FunctionsFolder?: InputMaybe<Scalars['String']['input']>;
  PitstopTriggers?: InputMaybe<Array<InputMaybe<CarDataServicePitstopTriggerInput>>>;
  ProcessedFolder?: InputMaybe<Scalars['String']['input']>;
  ResultsFolder?: InputMaybe<Scalars['String']['input']>;
  RunsheetMatching?: InputMaybe<EnumCarDataServiceApplicationSettingsConfigRunsheetMatching>;
};

export type CarDataServiceConfig = {
  Kpi?: Maybe<CarDataServiceKpiConfig>;
  ORHCalculationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  ORHCalculations: Array<Calculation>;
  /** Object containing parameter mappings. Format is like: { vCar: [{ "name": "car_speed", "offset": 0, "gain": 3.6 }] } */
  ParameterMap?: Maybe<Scalars['JSON']['output']>;
  PostProcessingConfig?: Maybe<CarDataServicePostProcessingConfig>;
  _id: Scalars['MongoID']['output'];
  /** Is this the currently active config for this race series? Only one is active per race series at any given time. */
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  raceSeries?: Maybe<RaceSeries>;
  raceSeriesID: Scalars['MongoID']['output'];
  version: Scalars['String']['output'];
};

/** List of items with pagination. */
export type CarDataServiceConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CarDataServiceConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CarDataServiceEventConfig = {
  EventDescription?: Maybe<Scalars['String']['output']>;
  EventId: Scalars['MongoID']['output'];
};

export type CarDataServiceEventConfigInput = {
  EventDescription?: InputMaybe<Scalars['String']['input']>;
  EventId: Scalars['MongoID']['input'];
};

export type CarDataServiceKpiConfig = {
  KpiParameters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Preconditions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Use `KpiParameters` instead */
  parameters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Use `Preconditions` instead */
  preconditions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CarDataServiceKpiConfigInput = {
  KpiParameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CarDataServicePitstopTrigger = {
  ParameterId: Scalars['String']['output'];
  Type?: Maybe<EnumCarDataServicePitstopTriggerType>;
  Value: Scalars['Float']['output'];
};

export type CarDataServicePitstopTriggerInput = {
  ParameterId: Scalars['String']['input'];
  Type?: InputMaybe<EnumCarDataServicePitstopTriggerType>;
  Value: Scalars['Float']['input'];
};

export type CarDataServicePostProcessingConfig = {
  ApplicationSettingsConfiguration?: Maybe<CarDataServiceApplicationSettingsConfig>;
  EventConfiguration?: Maybe<CarDataServiceEventConfig>;
  ProcessingEnginesConfiguration?: Maybe<CarDataServiceProcessingEnginesConfig>;
  QueueManagerConfiguration?: Maybe<CarDataServiceQueueManagerConfig>;
  SessionManagerConfiguration?: Maybe<CarDataServiceSessionManagerConfig>;
  SessionTypesConfiguration?: Maybe<CarDataServiceSessionTypesConfig>;
};

export type CarDataServicePostProcessingConfigInput = {
  ApplicationSettingsConfiguration?: InputMaybe<CarDataServiceApplicationSettingsConfigInput>;
  EventConfiguration?: InputMaybe<CarDataServiceEventConfigInput>;
  ProcessingEnginesConfiguration?: InputMaybe<CarDataServiceProcessingEnginesConfigInput>;
  QueueManagerConfiguration?: InputMaybe<CarDataServiceQueueManagerConfigInput>;
  SessionManagerConfiguration?: InputMaybe<CarDataServiceSessionManagerConfigInput>;
  SessionTypesConfiguration?: InputMaybe<CarDataServiceSessionTypesConfigInput>;
};

export type CarDataServiceProcessingEngineConfig = {
  Calculations: Array<Maybe<Scalars['String']['output']>>;
  Exporters?: Maybe<CarDataServiceProcessingEngineConfigExporters>;
  Importer: EnumCarDataServiceProcessingEngineConfigImporter;
  Instances: Scalars['Float']['output'];
  Name: Scalars['String']['output'];
  QueueName: Scalars['String']['output'];
};

export type CarDataServiceProcessingEngineConfigExporters = {
  ATLAS10_EXPORTER?: Maybe<Scalars['JSON']['output']>;
  JSONFILE_EXPORTER?: Maybe<Scalars['JSON']['output']>;
  ONERACEHUB_EXPORTER?: Maybe<Scalars['JSON']['output']>;
  PARQUETFILE_EXPORTER?: Maybe<Scalars['JSON']['output']>;
  WINTAX_EXPORTER?: Maybe<CarDataServiceProcessingEngineConfigExportersWintax_Exporter>;
};

export type CarDataServiceProcessingEngineConfigExportersInput = {
  ATLAS10_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  JSONFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  ONERACEHUB_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  PARQUETFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  WINTAX_EXPORTER?: InputMaybe<CarDataServiceProcessingEngineConfigExportersWintax_ExporterInput>;
};

export type CarDataServiceProcessingEngineConfigExportersWintax_Exporter = {
  /** NAme of paremeter in the parameter map, tracking the distance of current lap. */
  DISTANCE_CHANNEL?: Maybe<Scalars['String']['output']>;
  /** Fuel consumption of the current lap. Could be a KPI like 'sLap.Lap.Max' or a fixed value like '2453.2'. */
  FUEL_CONSUMPTION?: Maybe<Scalars['String']['output']>;
  /** Fuel level of the current lap. Could be a KPI like 'ERESSRaceFIA.Lap.Last' or a fixed value like '90.3'. */
  FUEL_LEVEL?: Maybe<Scalars['String']['output']>;
  /** Effective distance of the current lap. COuld be a KPI like 'ELap.Lap.Integral' or a fixed valued like '10.4'. */
  LAP_DISTANCE?: Maybe<Scalars['String']['output']>;
  /** Contains the folder, where the exported WinTAX files are stored. */
  OUTPUT_PATH?: Maybe<Scalars['String']['output']>;
  SIMULATE_CALLS?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the folder, where the TelDataZtx dll files are stored. */
  TELDATAZTX_PATH?: Maybe<Scalars['String']['output']>;
};

export type CarDataServiceProcessingEngineConfigExportersWintax_ExporterInput = {
  /** NAme of paremeter in the parameter map, tracking the distance of current lap. */
  DISTANCE_CHANNEL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel consumption of the current lap. Could be a KPI like 'sLap.Lap.Max' or a fixed value like '2453.2'. */
  FUEL_CONSUMPTION?: InputMaybe<Scalars['String']['input']>;
  /** Fuel level of the current lap. Could be a KPI like 'ERESSRaceFIA.Lap.Last' or a fixed value like '90.3'. */
  FUEL_LEVEL?: InputMaybe<Scalars['String']['input']>;
  /** Effective distance of the current lap. COuld be a KPI like 'ELap.Lap.Integral' or a fixed valued like '10.4'. */
  LAP_DISTANCE?: InputMaybe<Scalars['String']['input']>;
  /** Contains the folder, where the exported WinTAX files are stored. */
  OUTPUT_PATH?: InputMaybe<Scalars['String']['input']>;
  SIMULATE_CALLS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains the folder, where the TelDataZtx dll files are stored. */
  TELDATAZTX_PATH?: InputMaybe<Scalars['String']['input']>;
};

export type CarDataServiceProcessingEngineConfigInput = {
  Calculations: Array<InputMaybe<Scalars['String']['input']>>;
  Exporters?: InputMaybe<CarDataServiceProcessingEngineConfigExportersInput>;
  Importer: EnumCarDataServiceProcessingEngineConfigImporter;
  Instances: Scalars['Float']['input'];
  Name: Scalars['String']['input'];
  QueueName: Scalars['String']['input'];
};

export type CarDataServiceProcessingEnginesConfig = {
  ExportersFolder?: Maybe<Scalars['String']['output']>;
  ImportersFolder?: Maybe<Scalars['String']['output']>;
  InternalCalculationsFolder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ORHCalculationIDs the root of the car data service config instead */
  ORHCalculationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** @deprecated Look at calculations from the root of the car data service config instead */
  ORHCalculations: Array<Calculation>;
  ParameterMapFile?: Maybe<Scalars['String']['output']>;
  ProcessingEngineConfiguration?: Maybe<Array<Maybe<CarDataServiceProcessingEngineConfig>>>;
  UserCalculationsFolder?: Maybe<Scalars['String']['output']>;
};

export type CarDataServiceProcessingEnginesConfigInput = {
  ExportersFolder?: InputMaybe<Scalars['String']['input']>;
  ImportersFolder?: InputMaybe<Scalars['String']['input']>;
  InternalCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  ParameterMapFile?: InputMaybe<Scalars['String']['input']>;
  ProcessingEngineConfiguration?: InputMaybe<Array<InputMaybe<CarDataServiceProcessingEngineConfigInput>>>;
  UserCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
};

export type CarDataServiceQueueDefinition = {
  Name: Scalars['String']['output'];
  SessionType: Scalars['String']['output'];
};

export type CarDataServiceQueueDefinitionInput = {
  Name: Scalars['String']['input'];
  SessionType: Scalars['String']['input'];
};

export type CarDataServiceQueueManagerConfig = {
  Queues?: Maybe<Array<Maybe<CarDataServiceQueueDefinition>>>;
};

export type CarDataServiceQueueManagerConfigInput = {
  Queues?: InputMaybe<Array<InputMaybe<CarDataServiceQueueDefinitionInput>>>;
};

export type CarDataServiceSessionManagerConfig = {
  OffloadFolder: Scalars['String']['output'];
  OffloadSessionTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CarDataServiceSessionManagerConfigInput = {
  OffloadFolder: Scalars['String']['input'];
  OffloadSessionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CarDataServiceSessionTypeConfig = {
  exts: Array<Maybe<Scalars['String']['output']>>;
  folderUpLevel: Scalars['Int']['output'];
  ignoreLiterals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  regExpressions: Array<Maybe<Scalars['String']['output']>>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type CarDataServiceSessionTypeConfigInput = {
  exts: Array<InputMaybe<Scalars['String']['input']>>;
  folderUpLevel: Scalars['Int']['input'];
  ignoreLiterals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  regExpressions: Array<InputMaybe<Scalars['String']['input']>>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type CarDataServiceSessionTypesConfig = {
  SessionTypes?: Maybe<Array<Maybe<CarDataServiceSessionTypeConfig>>>;
};

export type CarDataServiceSessionTypesConfigInput = {
  SessionTypes?: InputMaybe<Array<InputMaybe<CarDataServiceSessionTypeConfigInput>>>;
};

export type CarEnd = {
  aCamber?: Maybe<Scalars['Float']['output']>;
  aCamberMeasurement?: Maybe<Scalars['Float']['output']>;
  aCaster?: Maybe<Scalars['Float']['output']>;
  aCasterMeasurement?: Maybe<Scalars['Float']['output']>;
  aToe?: Maybe<Scalars['Float']['output']>;
  aToeMeasurement?: Maybe<Scalars['Float']['output']>;
  antiRollBar?: Maybe<AntiRollBar>;
  bumpStop?: Maybe<BumpStop>;
  damper?: Maybe<Damper>;
  droopStop?: Maybe<DroopStop>;
  externalBumpStop?: Maybe<ExternalBumpStop>;
  hRide?: Maybe<Scalars['Float']['output']>;
  hRideChassis?: Maybe<Scalars['Float']['output']>;
  /** Point where the mechanic is measuring the ride height */
  hRideMeasurement?: Maybe<Scalars['Float']['output']>;
  /**
   * Baseline pushrod length, steering rack bumpsteer adjust might depend on the rough range of ride heights the car is running in.
   * @deprecated
   */
  hRideRange?: Maybe<Scalars['String']['output']>;
  /** Point where the regulation authority is measuring the ride height */
  hRideRegulation?: Maybe<Scalars['Float']['output']>;
  helperSpring?: Maybe<Spring>;
  /** @deprecated  */
  kinematics?: Maybe<Kinematics>;
  kinematicsExternalSpec?: Maybe<KinematicsExternalSpec>;
  kinematicsExternalSpecID?: Maybe<Scalars['MongoID']['output']>;
  kinematicsInternalSpec?: Maybe<KinematicsInternalSpec>;
  kinematicsInternalSpecID?: Maybe<Scalars['MongoID']['output']>;
  reboundSpring?: Maybe<Spring>;
  spring?: Maybe<Spring>;
  /** @deprecated  */
  thirdElement?: Maybe<ThirdElement>;
  xToe?: Maybe<Scalars['Float']['output']>;
  xToeMeasurement?: Maybe<Scalars['Float']['output']>;
};

export type CarEndInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  antiRollBar?: InputMaybe<AntiRollBarInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  /** Point where the mechanic is measuring the ride height */
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Baseline pushrod length, steering rack bumpsteer adjust might depend on the rough range of ride heights the car is running in. */
  hRideRange?: InputMaybe<Scalars['String']['input']>;
  /** Point where the regulation authority is measuring the ride height */
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  kinematics?: InputMaybe<KinematicsInput>;
  kinematicsExternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  thirdElement?: InputMaybe<ThirdElementInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type CarGpsDataPoint = {
  acronym?: Maybe<Scalars['String']['output']>;
  /** Is this point interpolated, as a result of being missing from the data source? */
  interpolated?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  startNumber?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['Date']['output'];
  /** Type of GPS data point. For example, `"Raw"` */
  type?: Maybe<Scalars['String']['output']>;
};

export type CarGpsDataPointInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  /** Is this point interpolated, as a result of being missing from the data source? */
  interpolated?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['Date']['input'];
  /** Type of GPS data point. For example, `"Raw"` */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CarInfo = {
  /** Number of changes */
  NChanges?: Maybe<Scalars['Float']['output']>;
  /** Number of issues */
  NIssue?: Maybe<Scalars['Float']['output']>;
  batteryID?: Maybe<Scalars['String']['output']>;
  chassisID?: Maybe<Scalars['String']['output']>;
  /** A map of custom IDs for this setup. Input syntax is array of key-value (string-string) tuples. */
  customIDs?: Maybe<Scalars['JSON']['output']>;
  driveshaftID?: Maybe<Scalars['String']['output']>;
  engineID?: Maybe<Scalars['String']['output']>;
  gearboxID?: Maybe<Scalars['String']['output']>;
  inverterID?: Maybe<Scalars['String']['output']>;
  setupComments?: Maybe<Scalars['String']['output']>;
  /** Tyre compound for which this setup is intended */
  tyreCompound?: Maybe<Scalars['String']['output']>;
};

export type CarInfoInput = {
  /** Number of changes */
  NChanges?: InputMaybe<Scalars['Float']['input']>;
  /** Number of issues */
  NIssue?: InputMaybe<Scalars['Float']['input']>;
  batteryID?: InputMaybe<Scalars['String']['input']>;
  chassisID?: InputMaybe<Scalars['String']['input']>;
  /** A map of custom IDs for this setup. Input syntax is array of key-value (string-string) tuples. */
  customIDs?: InputMaybe<Scalars['JSON']['input']>;
  driveshaftID?: InputMaybe<Scalars['String']['input']>;
  engineID?: InputMaybe<Scalars['String']['input']>;
  gearboxID?: InputMaybe<Scalars['String']['input']>;
  inverterID?: InputMaybe<Scalars['String']['input']>;
  setupComments?: InputMaybe<Scalars['String']['input']>;
  /** Tyre compound for which this setup is intended */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
};

export type CarMass = {
  comment?: Maybe<Scalars['String']['output']>;
  /** Front-left mass */
  mCarFL?: Maybe<Scalars['Float']['output']>;
  /** Front-right mass */
  mCarFR?: Maybe<Scalars['Float']['output']>;
  /** Rear-left mass */
  mCarRL?: Maybe<Scalars['Float']['output']>;
  /** Rear-right mass */
  mCarRR?: Maybe<Scalars['Float']['output']>;
  /** Sum of FL, FR, RL, and RR */
  mCarTotal?: Maybe<Scalars['Float']['output']>;
  /** Driver mass */
  mDriver?: Maybe<Scalars['Float']['output']>;
  /** Cross ratio ((FR_RL)/total) */
  rCarCross?: Maybe<Scalars['Float']['output']>;
  /** Portion of mass in the front of the car */
  rWeightF?: Maybe<Scalars['Float']['output']>;
  /** Target portion of mass in the front of the car */
  rWeightFTarget?: Maybe<Scalars['Float']['output']>;
};

export type CarMassInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Front-left mass */
  mCarFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right mass */
  mCarFR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left mass */
  mCarRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right mass */
  mCarRR?: InputMaybe<Scalars['Float']['input']>;
  /** Driver mass */
  mDriver?: InputMaybe<Scalars['Float']['input']>;
  /** Target portion of mass in the front of the car */
  rWeightFTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type CarSetup = {
  _id: Scalars['MongoID']['output'];
  aero?: Maybe<Aero>;
  aeroPackage?: Maybe<AeroPackage>;
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  brakeSystem?: Maybe<BrakeSystem>;
  chassis?: Maybe<Chassis>;
  chassisAssembly?: Maybe<ChassisAssembly>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  chassisID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpec?: Maybe<ChassisSpec>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpecRoot?: Maybe<ChassisSpec>;
  chassisSpecRootID?: Maybe<Scalars['MongoID']['output']>;
  cockpit?: Maybe<Cockpit>;
  /** Contestant specified in this setup's linked run sheet. */
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  custom?: Maybe<Scalars['JSON']['output']>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: Maybe<Scalars['JSON']['output']>;
  /** Enable custom simulation payload for this setup. You as a user are responsible to have meaningful data in there. */
  customSimulationPayloadEnabled?: Maybe<Scalars['Boolean']['output']>;
  driver?: Maybe<Person>;
  driverID?: Maybe<Scalars['MongoID']['output']>;
  engineer?: Maybe<Person>;
  engineerID?: Maybe<Scalars['MongoID']['output']>;
  /** Event linked to the session specified in this setup's linked run sheet. */
  eventID?: Maybe<Scalars['MongoID']['output']>;
  /** Flattened hashmap of car setup fields. Keys are associated with the `fieldKey` from setup sheet styles. */
  flattened?: Maybe<Scalars['JSON']['output']>;
  /** Flattened hashmap of car setup fields. Keys are associated with the `fieldKey` from setup sheet styles. Values are simply the values. */
  flattenedValues?: Maybe<Scalars['JSON']['output']>;
  front?: Maybe<CarEnd>;
  frontLeft?: Maybe<CarCorner>;
  frontRight?: Maybe<CarCorner>;
  history: Array<History>;
  historyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  info?: Maybe<CarInfo>;
  intendedForSession?: Maybe<EnumCarSetupIntendedForSession>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedBy?: Maybe<Person>;
  lastModifiedByID?: Maybe<Scalars['MongoID']['output']>;
  /** Map of ballast positions to their masses. Keys are names of the positions and values are the masses. Input syntax is array of key-value tuples, like `mBallasts: [["front", 10], ["rear", 20]]`. */
  mBallasts?: Maybe<Scalars['JSON']['output']>;
  manualEndMileage?: Maybe<Scalars['Float']['output']>;
  manualStartMileage?: Maybe<Scalars['Float']['output']>;
  /** Mass out of garage (with driver in the seat) */
  massOutOfGarage?: Maybe<CarMass>;
  /** Mass at the scales of the regulatory authority */
  massRegulation?: Maybe<CarMass>;
  /** Mass from car setup */
  massSetup?: Maybe<CarMass>;
  /** Mass from regulation scale replica in garage (team's scales) */
  massTeam?: Maybe<CarMass>;
  /** @deprecated Use powertrainFront, powertrainRear, powertrainCentral instead. */
  powertrain?: Maybe<Powertrain>;
  powertrainCentral?: Maybe<Powertrain>;
  powertrainFront?: Maybe<Powertrain>;
  powertrainRear?: Maybe<Powertrain>;
  rear?: Maybe<CarEnd>;
  rearLeft?: Maybe<CarCorner>;
  rearRight?: Maybe<CarCorner>;
  runSheet?: Maybe<RunSheet>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  /** Small info string */
  setupInfo?: Maybe<Scalars['String']['output']>;
  /** Override of setup sheet style, which usually comes from the chassis. */
  setupSheetStyle?: Maybe<EnumCarSetupSetupSheetStyle>;
  steering?: Maybe<Steering>;
  /** Map containing systems config comments. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigComment?: Maybe<Scalars['JSON']['output']>;
  /** Map containing systems config NIssue data. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigNIssues?: Maybe<Scalars['JSON']['output']>;
  /** Map containing systems config values. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigValues?: Maybe<Scalars['JSON']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  team?: Maybe<Team>;
  teamID?: Maybe<Scalars['MongoID']['output']>;
  time?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  /** @deprecated Use tyre set from a linked run sheet instead. */
  tyreSet?: Maybe<TyreSet>;
  /** @deprecated Use tyre set from a linked run sheet instead. */
  tyreSetID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  writeHistory?: Maybe<Scalars['Boolean']['output']>;
};

export type CarSetupChanged = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CarSetupInfo = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  setupInfo?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type CarSetupPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CarSetup>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CarTrackPosition = {
  distance?: Maybe<Scalars['Float']['output']>;
  driverTLA?: Maybe<Scalars['String']['output']>;
  onTrack?: Maybe<Scalars['Boolean']['output']>;
  pace?: Maybe<Scalars['Float']['output']>;
  startNumber: Scalars['String']['output'];
};

export type CarTrackPositionInput = {
  distance?: InputMaybe<Scalars['Float']['input']>;
  driverTLA?: InputMaybe<Scalars['String']['input']>;
  onTrack?: InputMaybe<Scalars['Boolean']['input']>;
  pace?: InputMaybe<Scalars['Float']['input']>;
  startNumber: Scalars['String']['input'];
};

export type Chassis = {
  _id: Scalars['MongoID']['output'];
  /** Allowable keys for ballast measurements in car setups that use this chassis. */
  ballastPositions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  currentlyInUse?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  manufacturerPartID?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier for the chassis */
  reference?: Maybe<Scalars['String']['output']>;
  rootAssemblies: Array<ChassisAssembly>;
  rootAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  rootSpecification?: Maybe<ChassisSpec>;
  rootSpecificationID?: Maybe<Scalars['MongoID']['output']>;
  /**
   * Map of setup sheet fields to available preset values. Keys are like `"front.kSpringF"`, and values are lists of options. Input syntax is array of key-value tuples, like `setupOptions: [["front.kSpringF", [100, 110, 120]]]`.
   * @deprecated Use the new adjustable fields instead
   */
  setupOptions?: Maybe<Scalars['JSON']['output']>;
  setupSheetStyle?: Maybe<EnumChassisSetupSheetStyle>;
  specification?: Maybe<ChassisSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  /** Allowable keys for systems config maps in car setups that use this chassis. */
  systemsConfigFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** Car type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ChassisAssembly = AnyAssembly & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  allPartInstanceActive?: Maybe<Scalars['Boolean']['output']>;
  assemblyTemplateID?: Maybe<Scalars['MongoID']['output']>;
  assemblyTypeEnum?: Maybe<UserEnumAssemblyType>;
  assemblyTypeEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocations: Array<UserEnumBuildSheetGroup>;
  buildSheetGroupEnum?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetNestLevel?: Maybe<Scalars['Float']['output']>;
  carSetup?: Maybe<CarSetup>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  chassisMeasurements?: Maybe<Array<Maybe<ChassisAssemblyMeasurement>>>;
  chassisPartID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  nestedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  nestedPartInstances: Array<PartInstance>;
  partInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  partInstances: Array<PartInstance>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  subAssemblies: Array<SubAssembly>;
  subAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingSourceRecords?: Maybe<Array<Maybe<ChassisAssemblyTrackingSourceRecord>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type ChassisAssemblyMeasurement = {
  chassisSpecMeasurement?: Maybe<ChassisMeasurement>;
  chassisSpecMeasurementID?: Maybe<Scalars['MongoID']['output']>;
  location?: Maybe<AdjustableLocation>;
  orientation?: Maybe<AdjustableOrientation>;
};

export type ChassisAssemblyMeasurementInput = {
  chassisSpecMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  location?: InputMaybe<AdjustableLocationInput>;
  orientation?: InputMaybe<AdjustableOrientationInput>;
};

export type ChassisAssemblyTrackingSourceRecord = {
  sources?: Maybe<Array<Maybe<ChassisAssemblyTrackingSourceRecordSources>>>;
  trackingSource?: Maybe<TrackingSource>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ChassisAssemblyTrackingSourceRecordInput = {
  sources?: InputMaybe<Array<InputMaybe<ChassisAssemblyTrackingSourceRecordSourcesInput>>>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ChassisAssemblyTrackingSourceRecordSources = {
  /** priority of this source. Defined on the alias but saved here for efficiency reasons */
  priority?: Maybe<Scalars['Float']['output']>;
  trackingSourceAliasID?: Maybe<Scalars['MongoID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ChassisAssemblyTrackingSourceRecordSourcesInput = {
  /** priority of this source. Defined on the alias but saved here for efficiency reasons */
  priority?: InputMaybe<Scalars['Float']['input']>;
  trackingSourceAliasID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ChassisMass = {
  /** Base mass properties of the vehicle */
  base?: Maybe<MassProperties>;
  /** Mass properties of the driver */
  driver?: Maybe<MassProperties>;
  setupEquip?: Maybe<MassProperties>;
};

export type ChassisMassInput = {
  /** Base mass properties of the vehicle */
  base?: InputMaybe<MassPropertiesInput>;
  /** Mass properties of the driver */
  driver?: InputMaybe<MassPropertiesInput>;
  setupEquip?: InputMaybe<MassPropertiesInput>;
};

export type ChassisMeasurement = {
  _id: Scalars['MongoID']['output'];
  chassisSpecID: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

/** List of items with pagination. */
export type ChassisMeasurementPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ChassisMeasurement>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ChassisMeasurements = {
  /** Default angle unit to display in setup options for this chassis */
  angles?: Maybe<EnumAngleUnit>;
  /** Default angular compliance unit to display in setup options for this chassis */
  angularCompliances?: Maybe<EnumAngularComplianceUnit>;
  /** Default angular torque compliance unit to display in setup options for this chassis */
  angularTorqueCompliances?: Maybe<EnumAngularTorqueComplianceUnit>;
  bumpPlateMeasurementMethod?: Maybe<EnumBumpPlateMeasurementMethod>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefFront?: Maybe<Scalars['Float']['output']>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefRear?: Maybe<Scalars['Float']['output']>;
  /** Default compliance unit to display in setup options for this chassis */
  compliances?: Maybe<EnumComplianceUnit>;
  /** Default force unit to display in setup options for this chassis */
  forces?: Maybe<EnumForceUnit>;
  /** Default inertia unit to display in setup options for this chassis */
  inertias?: Maybe<EnumInertiaUnit>;
  /** If true, positive camber is top leaning in. If false, negative camber is top leaning in. */
  inverseCamber?: Maybe<Scalars['Boolean']['output']>;
  kinematicsExternalReadingsRequired?: Maybe<EnumChassisMeasurementsKinematicsExternalReadingsRequired>;
  kinematicsInternalReadingsRequired?: Maybe<EnumChassisMeasurementsKinematicsInternalReadingsRequired>;
  /** Default length unit to display in setup options for this chassis */
  lengths?: Maybe<EnumLengthUnit>;
  /** Default mass unit to display in setup options for this chassis */
  masses?: Maybe<EnumMassUnit>;
  /** Default power unit to display in setup options for this chassis */
  powers?: Maybe<EnumPowerUnit>;
  /** Default pressure unit to display in setup options for this chassis */
  pressures?: Maybe<EnumPressureUnit>;
  /** Default ratio unit to display in setup options for this chassis */
  ratios?: Maybe<EnumRatioUnit>;
  /** Function to calculate front ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcFront?: Maybe<Scalars['String']['output']>;
  /** Function to calculate rear ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcRear?: Maybe<Scalars['String']['output']>;
  /** Default spring rate unit to display in setup options for this chassis */
  springRates?: Maybe<EnumSpringRateUnit>;
  /** Default steering rack ratio unit to display in setup options for this chassis */
  steeringRackRatios?: Maybe<EnumSteeringRackRatioUnit>;
  /** Default temperature unit to display in setup options for this chassis */
  temperatures?: Maybe<EnumTemperatureUnit>;
  toeMeasurementMethod?: Maybe<EnumToeMeasurementMethod>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefFront?: Maybe<Scalars['Float']['output']>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefRear?: Maybe<Scalars['Float']['output']>;
  /**
   * If true, toe measurement is given as total over axle. If false, toe measurement is per individual wheel.
   * @deprecated
   */
  toeTotal?: Maybe<Scalars['Boolean']['output']>;
  /** Default torque unit to display in setup options for this chassis */
  torques?: Maybe<EnumTorqueUnit>;
  /** Default torsion rate unit to display in setup options for this chassis */
  torsionRates?: Maybe<EnumTorsionRateUnit>;
  /** Default volume unit to display in setup options for this chassis */
  volumes?: Maybe<EnumVolumeUnit>;
  xTrackFront?: Maybe<Scalars['Float']['output']>;
  xTrackRear?: Maybe<Scalars['Float']['output']>;
  /** Wheelbase length in metres */
  xWheelbase?: Maybe<Scalars['Float']['output']>;
};

export type ChassisMeasurementsInput = {
  /** Default angle unit to display in setup options for this chassis */
  angles?: InputMaybe<EnumAngleUnit>;
  /** Default angular compliance unit to display in setup options for this chassis */
  angularCompliances?: InputMaybe<EnumAngularComplianceUnit>;
  /** Default angular torque compliance unit to display in setup options for this chassis */
  angularTorqueCompliances?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  bumpPlateMeasurementMethod?: InputMaybe<EnumBumpPlateMeasurementMethod>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** Default compliance unit to display in setup options for this chassis */
  compliances?: InputMaybe<EnumComplianceUnit>;
  /** Default force unit to display in setup options for this chassis */
  forces?: InputMaybe<EnumForceUnit>;
  /** Default inertia unit to display in setup options for this chassis */
  inertias?: InputMaybe<EnumInertiaUnit>;
  /** If true, positive camber is top leaning in. If false, negative camber is top leaning in. */
  inverseCamber?: InputMaybe<Scalars['Boolean']['input']>;
  kinematicsExternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsExternalReadingsRequired>;
  kinematicsInternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsInternalReadingsRequired>;
  /** Default length unit to display in setup options for this chassis */
  lengths?: InputMaybe<EnumLengthUnit>;
  /** Default mass unit to display in setup options for this chassis */
  masses?: InputMaybe<EnumMassUnit>;
  /** Default power unit to display in setup options for this chassis */
  powers?: InputMaybe<EnumPowerUnit>;
  /** Default pressure unit to display in setup options for this chassis */
  pressures?: InputMaybe<EnumPressureUnit>;
  /** Default ratio unit to display in setup options for this chassis */
  ratios?: InputMaybe<EnumRatioUnit>;
  /** Function to calculate front ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcFront?: InputMaybe<Scalars['String']['input']>;
  /** Function to calculate rear ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcRear?: InputMaybe<Scalars['String']['input']>;
  /** Default spring rate unit to display in setup options for this chassis */
  springRates?: InputMaybe<EnumSpringRateUnit>;
  /** Default steering rack ratio unit to display in setup options for this chassis */
  steeringRackRatios?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Default temperature unit to display in setup options for this chassis */
  temperatures?: InputMaybe<EnumTemperatureUnit>;
  toeMeasurementMethod?: InputMaybe<EnumToeMeasurementMethod>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** If true, toe measurement is given as total over axle. If false, toe measurement is per individual wheel. */
  toeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default torque unit to display in setup options for this chassis */
  torques?: InputMaybe<EnumTorqueUnit>;
  /** Default torsion rate unit to display in setup options for this chassis */
  torsionRates?: InputMaybe<EnumTorsionRateUnit>;
  /** Default volume unit to display in setup options for this chassis */
  volumes?: InputMaybe<EnumVolumeUnit>;
  xTrackFront?: InputMaybe<Scalars['Float']['input']>;
  xTrackRear?: InputMaybe<Scalars['Float']['input']>;
  /** Wheelbase length in metres */
  xWheelbase?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type ChassisPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Chassis>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ChassisPowerUnit = {
  name: Scalars['String']['output'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
};

export type ChassisPowerUnitInput = {
  name: Scalars['String']['input'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type ChassisPowertrain = {
  bevelSetSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  bevelSetSpecs: Array<GearSpec>;
  differentialSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  differentialSpecs: Array<DifferentialSpec>;
  dropGearSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  dropGearSpecs: Array<GearSpec>;
  gearBoxSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  gearBoxSpecs: Array<GearBoxSpec>;
  gearSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  gearSpecs: Array<GearSpec>;
  layout?: Maybe<EnumPowertrainLayout>;
  /** Number of gears which are expected to be in the gearbox. */
  numGears?: Maybe<Scalars['Float']['output']>;
};

export type ChassisPowertrainInput = {
  bevelSetSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  differentialSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  dropGearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearBoxSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  layout?: InputMaybe<EnumPowertrainLayout>;
  /** Number of gears which are expected to be in the gearbox. */
  numGears?: InputMaybe<Scalars['Float']['input']>;
};

export type ChassisSocket = {
  /** Unique name for this socket. */
  name: Scalars['String']['output'];
};

export type ChassisSocketInput = {
  /** Unique name for this socket. */
  name: Scalars['String']['input'];
};

export type ChassisSpec = AnySpecification & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  aeroPackageSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  aeroPackageSpecs: Array<AeroPackageSpec>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  antiRollBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  antiRollBarSpecs: Array<AntiRollBarSpec>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** The build sheet styles to use for this chassis spec. */
  buildSheetStyles: Array<BuildSheetStyle>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  bumpRubberSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  bumpRubberSpecs: Array<ElasticSpec>;
  calculationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  calculations: Array<Calculation>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: Maybe<Scalars['String']['output']>;
  chassisMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  chassisMeasurements: Array<ChassisMeasurement>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  copyReferencePackage?: Maybe<Package>;
  copyReferencePackageID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customSimulationModels?: Maybe<Array<Maybe<SpecificationCustomSimulationModels>>>;
  customSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Types of all custom specs associated with this chassis spec */
  customSpecTypes: Array<Scalars['String']['output']>;
  customSpecs: Array<CustomSpec>;
  damperSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  damperSpecs: Array<DamperSpec>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  flattened?: Maybe<Scalars['JSON']['output']>;
  /** The keys of the flattened data. This is useful for determining which fields are available for a given chassis spec. */
  flattenedKeys?: Maybe<Array<Scalars['String']['output']>>;
  helperSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  helperSpringSpecs: Array<ElasticSpec>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<ChassisSpec>;
  kinematicsExternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  kinematicsExternalSpecs: Array<KinematicsExternalSpec>;
  kinematicsInternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  kinematicsInternalSpecs: Array<KinematicsInternalSpec>;
  mass?: Maybe<ChassisMass>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: Maybe<ChassisMeasurements>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: Maybe<Array<Maybe<EnumSimModelType>>>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyles: Array<SetupSheetStyle>;
  powerUnits?: Maybe<Array<Maybe<ChassisPowerUnit>>>;
  powertrain?: Maybe<ChassisPowertrain>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  rBrakeBias?: Maybe<AdjustableRatio>;
  reboundSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  reboundSpringSpecs: Array<ElasticSpec>;
  regulationSets?: Maybe<Array<Maybe<RegulationSet>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: Maybe<Scalars['Date']['output']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  setupChangesFilter?: Maybe<SpecificationSetupChangesFilter>;
  setupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** ID of the setup sheet style to use in the simulaiton page for this chassis. */
  setupSheetStyleSimulation?: Maybe<SetupSheetStyle>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: Maybe<Scalars['MongoID']['output']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTable?: Maybe<SetupSheetStyle>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: Maybe<Scalars['MongoID']['output']>;
  /** The setup sheet styles to use for this chassis spec. */
  setupSheetStyles: Array<SetupSheetStyle>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  /** Locations/areas that components can be installed in. */
  sockets?: Maybe<Array<Maybe<ChassisSocket>>>;
  specificationGroupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  specificationGroups: Array<SpecificationGroup>;
  springSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  springSpecs: Array<ElasticSpec>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  torsionBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  torsionBarSpecs: Array<ElasticSpec>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingSourceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingSources: Array<TrackingSource>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User-supplied version of this specification. */
  version?: Maybe<Scalars['String']['output']>;
};

export type ClaimCarSetupResult = {
  success: Scalars['Boolean']['output'];
};

export type ClaimRunSheetResult = {
  success: Scalars['Boolean']['output'];
};

export type ClonePackageResolverResult = {
  recordId: Scalars['MongoID']['output'];
};

export type Cockpit = {
  /** Ratio of the throttle pedal */
  rThrottlePedal?: Maybe<Scalars['Float']['output']>;
  /** Position of the throttle pedal */
  throttlePedalPosition?: Maybe<Scalars['String']['output']>;
};

export type CockpitInput = {
  /** Ratio of the throttle pedal */
  rThrottlePedal?: InputMaybe<Scalars['Float']['input']>;
  /** Position of the throttle pedal */
  throttlePedalPosition?: InputMaybe<Scalars['String']['input']>;
};

export type Comment = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  files: Array<Maybe<AttachedFile>>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CommentBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  field: EnumCommentBlockField;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isAlwaysOpen?: Maybe<Scalars['Boolean']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type CommentInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type ComplianceUnitField = {
  unit: EnumComplianceUnit;
};

export type Contestant = {
  _id: Scalars['MongoID']['output'];
  chassis: Array<Chassis>;
  /** IDs of usable chassis */
  chassisIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Number of the chassis for this contestant. */
  chassisNumber?: Maybe<Scalars['String']['output']>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: Maybe<Scalars['String']['output']>;
  /** Default color to use for this contestant where applicable. */
  color?: Maybe<Scalars['String']['output']>;
  /** Drivers that constitute this contestant */
  driverIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  drivers: Array<Person>;
  /** Is this contestant eligible for points? */
  eligibleForPoints?: Maybe<Scalars['Boolean']['output']>;
  /** Should this contestant be hidden from users? */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturerID?: Maybe<Scalars['MongoID']['output']>;
  season?: Maybe<Season>;
  /** Season that this contestant is participating in */
  seasonID: Scalars['MongoID']['output'];
  startNumber: Scalars['String']['output'];
  team?: Maybe<Team>;
  teamID?: Maybe<Scalars['MongoID']['output']>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyContestantID?: Maybe<Scalars['String']['output']>;
  /** URI to the audio stream for this contestant in Transcribble. */
  transcribbleAudioURI?: Maybe<Scalars['String']['output']>;
  /** Tyres assigned to this contestant for the season. */
  tyreIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tyre sets assigned to this contestant for the season. */
  tyreSetIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tyreSets: Array<TyreSet>;
  tyres: Array<Tyre>;
};

/** Field to target with this mutation. */
export type ContestantField =
  /** → `chassisIDs` */
  | 'CHASSIS'
  /** → `driverIDs` */
  | 'DRIVERS';

/** List of items with pagination. */
export type ContestantPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Contestant>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CopyAssemblyResult = {
  newAssemblyID?: Maybe<Scalars['MongoID']['output']>;
};

export type CopyEventOverridesInput = {
  /** Density of the fuel */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Number of this event in the season */
  NEventSeason?: InputMaybe<Scalars['Float']['input']>;
  /** Default SoCRequired values to use during this event (assuming single track layout) */
  SoCRequired?: InputMaybe<RunEnergyInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Fuel/SoC/Energy consumptions for each track layout in this event. */
  consumptions?: InputMaybe<Array<InputMaybe<LayoutConsumptionInput>>>;
  contestants?: InputMaybe<Array<InputMaybe<EventContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumEventDebriefNotesMode>;
  /** Default energyRequired values to use during this event (assuming single track layout) */
  energyRequired?: InputMaybe<RunEnergyInput>;
  /** Energy sweep information for Formula E */
  energySweep?: InputMaybe<Scalars['JSON']['input']>;
  enumEventType?: InputMaybe<EnumEventEnumEventType>;
  enumEventVenue?: InputMaybe<EnumEventEnumEventVenue>;
  /** e.g. Race, Test, etc. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Default fuelRequired values to use during this event (assuming single track layout) */
  fuelRequired?: InputMaybe<RunEnergyInput>;
  /** Should the iRacing service populate this event when an unknown event is encountered? */
  iRacingServiceIsNextEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of issues related to this event. */
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Reference laptimes for each track layout in this event. */
  referenceLaptimes?: InputMaybe<Array<InputMaybe<EventReferenceLaptimesInput>>>;
  /** Selected authors for the event report (person reference plus a name snapshot). */
  reportAuthors?: InputMaybe<Array<InputMaybe<EventReportAuthorsInput>>>;
  /** Time of event end in local time */
  tEventEnd?: InputMaybe<Scalars['Date']['input']>;
  tLapAverage?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyEventID?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumEventType>;
  tyreDefaults?: InputMaybe<Array<InputMaybe<EventTyreDefaultsSetInput>>>;
  tyreDefaultsFL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsFR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsRL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsRR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetFL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetFR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetRL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetRR?: InputMaybe<EventTyreDefaultsInput>;
};

export type CreateBackupResult = {
  created: Scalars['String']['output'];
};

export type CreateManyJobInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  /** The id of the parent job or issue that this task is assigned to */
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyJobPayload = {
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Job>>;
};

export type CreateManyTimeSheetEntryInput = {
  /** Whether a person did work on this day */
  absent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notes about what was done during this time */
  description?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Clock-out time */
  tEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Clock-in time */
  tStart: Scalars['Date']['input'];
};

export type CreateManyTimeSheetEntryPayload = {
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<TimeSheetEntry>>;
};

export type CreateOneAssemblyInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assemblyTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  assemblyTypeEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetNestLevel?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisMeasurements?: InputMaybe<Array<InputMaybe<ChassisAssemblyMeasurementInput>>>;
  chassisPartID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  subAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceRecords?: InputMaybe<Array<InputMaybe<ChassisAssemblyTrackingSourceRecordInput>>>;
  type?: EnumAssemblyType;
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneAssemblyPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Assembly>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneAssemblyTemplateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  requiredAssemblies?: InputMaybe<Array<InputMaybe<AssemblyTemplateRequiredAssembliesInput>>>;
  requiredParts?: InputMaybe<Array<InputMaybe<AssemblyTemplateRequiredPartsInput>>>;
};

export type CreateOneAssemblyTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<AssemblyTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneBestValuesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the contestant these personal bests belong to, if applicable. */
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the driver these personal bests belong to, if applicable. */
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<BestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<BestValuesFastestSectorInput>>>;
  sessionID: Scalars['MongoID']['input'];
};

export type CreateOneBestValuesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<BestValues>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneBopInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  bopFile?: InputMaybe<Scalars['String']['input']>;
  carBop?: InputMaybe<Array<InputMaybe<BopCarBopInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sessionBop?: InputMaybe<BopSessionBopInput>;
  sessionID: Scalars['MongoID']['input'];
};

export type CreateOneBopPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Bop>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneBuildSheetStyleInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  blocks?: InputMaybe<Array<InputMaybe<BuildSheetStyleBlockInput>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  targetEventType?: InputMaybe<EnumBuildSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<InputMaybe<EnumBuildSheetStyleTargetRoles>>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumBuildSheetStyleType;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneBuildSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<BuildSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCalculationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** For the client to display debug information or default return values */
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  functionString: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** The name of the parameter or path to a field which this calculation gives as output. */
  parameter: Scalars['String']['input'];
  /** The names of the parameters or paths to fields which this calculation depends on. If any of these change, the calculation should be re-run. */
  trigger: Array<Scalars['String']['input']>;
  type: EnumCalculationType;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneCalculationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Calculation>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCarDataServiceConfigInput = {
  Kpi?: InputMaybe<CarDataServiceKpiConfigInput>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Object containing parameter mappings. Format is like: { vCar: [{ "name": "car_speed", "offset": 0, "gain": 3.6 }] } */
  ParameterMap?: InputMaybe<Scalars['JSON']['input']>;
  PostProcessingConfig?: InputMaybe<CarDataServicePostProcessingConfigInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  raceSeriesID: Scalars['MongoID']['input'];
};

export type CreateOneCarDataServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CarDataServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCarSetupInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aero?: InputMaybe<AeroInput>;
  aeroPackage?: InputMaybe<AeroPackageInput>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  brakeSystem?: InputMaybe<BrakeSystemInput>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecRootID?: InputMaybe<Scalars['MongoID']['input']>;
  cockpit?: InputMaybe<CockpitInput>;
  custom?: InputMaybe<Scalars['JSON']['input']>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  /** Enable custom simulation payload for this setup. You as a user are responsible to have meaningful data in there. */
  customSimulationPayloadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  front?: InputMaybe<CarEndInput>;
  frontLeft?: InputMaybe<CarCornerInput>;
  frontRight?: InputMaybe<CarCornerInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<CarInfoInput>;
  intendedForSession?: InputMaybe<EnumCarSetupIntendedForSession>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Map of ballast positions to their masses. Keys are names of the positions and values are the masses. Input syntax is array of key-value tuples, like `mBallasts: [["front", 10], ["rear", 20]]`. */
  mBallasts?: InputMaybe<Scalars['JSON']['input']>;
  manualEndMileage?: InputMaybe<Scalars['Float']['input']>;
  manualStartMileage?: InputMaybe<Scalars['Float']['input']>;
  /** Mass out of garage (with driver in the seat) */
  massOutOfGarage?: InputMaybe<CarMassInput>;
  /** Mass at the scales of the regulatory authority */
  massRegulation?: InputMaybe<CarMassInput>;
  /** Mass from car setup */
  massSetup?: InputMaybe<CarMassInput>;
  /** Mass from regulation scale replica in garage (team's scales) */
  massTeam?: InputMaybe<CarMassInput>;
  powertrain?: InputMaybe<PowertrainInput>;
  powertrainCentral?: InputMaybe<PowertrainInput>;
  powertrainFront?: InputMaybe<PowertrainInput>;
  powertrainRear?: InputMaybe<PowertrainInput>;
  rear?: InputMaybe<CarEndInput>;
  rearLeft?: InputMaybe<CarCornerInput>;
  rearRight?: InputMaybe<CarCornerInput>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Small info string */
  setupInfo?: InputMaybe<Scalars['String']['input']>;
  /** Override of setup sheet style, which usually comes from the chassis. */
  setupSheetStyle?: InputMaybe<EnumCarSetupSetupSheetStyle>;
  steering?: InputMaybe<SteeringInput>;
  /** Map containing systems config comments. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigComment?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config NIssue data. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigNIssues?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config values. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigValues?: InputMaybe<Scalars['JSON']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  title: Scalars['String']['input'];
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneCarSetupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CarSetup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneChassisInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Allowable keys for ballast measurements in car setups that use this chassis. */
  ballastPositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  currentlyInUse?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** Unique identifier for the chassis */
  reference?: InputMaybe<Scalars['String']['input']>;
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of setup sheet fields to available preset values. Keys are like `"front.kSpringF"`, and values are lists of options. Input syntax is array of key-value tuples, like `setupOptions: [["front.kSpringF", [100, 110, 120]]]`. */
  setupOptions?: InputMaybe<Scalars['JSON']['input']>;
  setupSheetStyle?: InputMaybe<EnumChassisSetupSheetStyle>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Allowable keys for systems config maps in car setups that use this chassis. */
  systemsConfigFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Car type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneChassisMeasurementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneChassisMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ChassisMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneChassisPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Chassis>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneContestantInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of usable chassis */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Number of the chassis for this contestant. */
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** Default color to use for this contestant where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Drivers that constitute this contestant */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Is this contestant eligible for points? */
  eligibleForPoints?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this contestant be hidden from users? */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Season that this contestant is participating in */
  seasonID: Scalars['MongoID']['input'];
  startNumber: Scalars['String']['input'];
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyContestantID?: InputMaybe<Scalars['String']['input']>;
  /** URI to the audio stream for this contestant in Transcribble. */
  transcribbleAudioURI?: InputMaybe<Scalars['String']['input']>;
  /** Tyres assigned to this contestant for the season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Tyre sets assigned to this contestant for the season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneContestantPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Contestant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneDepartmentInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateOneDepartmentPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Department>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneDynoConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<DynoConfigColumnsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneDynoConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<DynoConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneEventInput = {
  /** Density of the fuel */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Number of this event in the season */
  NEventSeason?: InputMaybe<Scalars['Float']['input']>;
  /** Default SoCRequired values to use during this event (assuming single track layout) */
  SoCRequired?: InputMaybe<RunEnergyInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Fuel/SoC/Energy consumptions for each track layout in this event. */
  consumptions?: InputMaybe<Array<InputMaybe<LayoutConsumptionInput>>>;
  contestants?: InputMaybe<Array<InputMaybe<EventContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumEventDebriefNotesMode>;
  /** Default energyRequired values to use during this event (assuming single track layout) */
  energyRequired?: InputMaybe<RunEnergyInput>;
  /** Energy sweep information for Formula E */
  energySweep?: InputMaybe<Scalars['JSON']['input']>;
  enumEventType?: InputMaybe<EnumEventEnumEventType>;
  enumEventVenue?: InputMaybe<EnumEventEnumEventVenue>;
  /** e.g. Race, Test, etc. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Default fuelRequired values to use during this event (assuming single track layout) */
  fuelRequired?: InputMaybe<RunEnergyInput>;
  /** Should the iRacing service populate this event when an unknown event is encountered? */
  iRacingServiceIsNextEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of issues related to this event. */
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name: Scalars['String']['input'];
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Reference laptimes for each track layout in this event. */
  referenceLaptimes?: InputMaybe<Array<InputMaybe<EventReferenceLaptimesInput>>>;
  /** Selected authors for the event report (person reference plus a name snapshot). */
  reportAuthors?: InputMaybe<Array<InputMaybe<EventReportAuthorsInput>>>;
  seasonID: Scalars['MongoID']['input'];
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Time of event end in local time */
  tEventEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of event start in local time */
  tEventStart?: InputMaybe<Scalars['Date']['input']>;
  tLapAverage?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyEventID?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumEventType>;
  tyreDefaults?: InputMaybe<Array<InputMaybe<EventTyreDefaultsSetInput>>>;
  tyreDefaultsFL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsFR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsRL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsRR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetFL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetFR?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetRL?: InputMaybe<EventTyreDefaultsInput>;
  tyreDefaultsWetRR?: InputMaybe<EventTyreDefaultsInput>;
};

export type CreateOneEventPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneFlexLayoutConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  globalXAxis?: InputMaybe<FlexLayoutConfigGlobalXAxisInput>;
  intendedFor: EnumFlexLayoutConfigIntendedFor;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration recognised by flexlayout-react */
  model?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** If this is non-empty, only users with one of these roles can see this config. */
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneFlexLayoutConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<FlexLayoutConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneGreeboLogInput = {
  /** Real time car positions on track */
  carPositions?: InputMaybe<Array<InputMaybe<CarTrackPositionInput>>>;
  /** Only specify if this is a greebo log for an entire event */
  eventID?: InputMaybe<Scalars['String']['input']>;
  /** GPS data from Greebo */
  gpsData?: InputMaybe<Array<InputMaybe<CarGpsDataPointInput>>>;
  /** Unprocessed lines from Greebo */
  rawLines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sessionID?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneGreeboLogPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<GreeboLog>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneIssueInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  area?: InputMaybe<Scalars['String']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<CommentInput>>>;
  containment?: InputMaybe<Scalars['String']['input']>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  departmentID?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  descriptionDetails?: InputMaybe<Scalars['String']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  issueStatus?: InputMaybe<EnumIssueIssueStatus>;
  linkedIssueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagLabelSort?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EnumIssuePriority>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  rootCause?: InputMaybe<Scalars['String']['input']>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thirdPartyIssueID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneIssuePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Issue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneJobInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  /** The id of the parent job or issue that this task is assigned to */
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneJobPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Job>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLapSequenceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  laps: Array<InputMaybe<LapSequenceLapsInput>>;
  name: Scalars['String']['input'];
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneLapSequencePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<LapSequence>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLapSequenceTemplateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  laps?: InputMaybe<Array<InputMaybe<LapSequenceTemplateLapsInput>>>;
  name: Scalars['String']['input'];
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneLapSequenceTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<LapSequenceTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneLocationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Location>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLogInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  logLevel: EnumLogLogLevel;
  /** A single log from the source service */
  message: Scalars['String']['input'];
  serviceSource: EnumLogServiceSource;
  userID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneLogPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Log>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneManufacturerInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneManufacturerPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Manufacturer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneOneTimingWeatherServiceConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event IDs to which the weather data should be published. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Weather station's latitude from geolocation */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logLevel?: InputMaybe<EnumOneTimingWeatherServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weather station's longitude from geolocation */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Name for this set of configuration settings. */
  name?: Scalars['String']['input'];
  /** One Timing server port. */
  timingPort: Scalars['Int']['input'];
  /** One Timing server address. */
  timingURL: Scalars['String']['input'];
  /** Time interval in seconds between two API data updates. */
  updateInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneOneTimingWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<OneTimingWeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePackageInput = {
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID: Scalars['MongoID']['input'];
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<PackageItemsInput>>>;
  name: Scalars['String']['input'];
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  useAsCopyReference?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOnePackagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Package>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePartInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Can this very part be used multiple times on a car. For 'virtual parts' or other special applications. Overrides the setting of the specification. */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  eligibleEventTypes?: InputMaybe<EnumPartEligibleEventTypes>;
  /** To be used for dummy parts or at user discretion for special applications. */
  isVirtualPart?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeMileage?: InputMaybe<Scalars['Float']['input']>;
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  manufacturerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  partStatus?: InputMaybe<PartStatusInput>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  readingLocationOverride?: InputMaybe<Array<InputMaybe<EnumPartReadingLocationOverride>>>;
  reference: Scalars['String']['input'];
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID: Scalars['MongoID']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementHistoryIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOnePartInstanceInput = {
  measurements?: InputMaybe<Array<InputMaybe<PartInstanceMeasurementInput>>>;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  readingLocation: EnumReadingLocation;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemReferenceDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePartInstancePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PartInstance>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePartPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Part>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePersonInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** 3-letter acronym for drivers */
  acronym?: InputMaybe<Scalars['String']['input']>;
  behaviour?: InputMaybe<BehaviourConfigInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  canopyCredentials?: InputMaybe<CanopyCredentialsInput>;
  carUpdateMethod?: InputMaybe<EnumPersonCarUpdateMethod>;
  /** IDs of contestants visible to this person when logged in. */
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultFlexLayoutConfigs?: InputMaybe<DefaultFlexLayoutConfigsInput>;
  defaultRunSheetCompareStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStylePhoneID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultTyreReferenceTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Default string for tyre set naming, where x=Chassis, i=Info, s=SetNumber, (c=Corner or a=Axle) */
  defaultTyreSetNameFormat?: InputMaybe<Scalars['String']['input']>;
  displayColor?: InputMaybe<Scalars['String']['input']>;
  dynoConfigID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of contestants editable to this person when logged in. */
  editableContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotificationConfig?: InputMaybe<NotificationConfigInput>;
  /** IDs of events visible to this person when logged in. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this user be unable to see KPIs? */
  hideKPIs?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to track his working time? */
  isTimeTracker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to see, update and approve working times for other users? */
  isTimeTrackerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequenceTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  localConnections?: InputMaybe<Array<InputMaybe<LocalConnectionInput>>>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  name: Scalars['String']['input'];
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportPicture?: InputMaybe<Scalars['String']['input']>;
  /** Collection of favourite plot page config IDs. */
  plotPageConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  privateMobile?: InputMaybe<Scalars['Float']['input']>;
  privatePhone?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<EnumPersonRole>;
  /** Collection of favourite setup overview config IDs. */
  setupOverviewConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  timeTrackerApprovalByPersonID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Collection of personal setup IDs. */
  userSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userSimulationSettings?: InputMaybe<UserSimulationSettingsInput>;
  username: Scalars['String']['input'];
  viewConfig?: InputMaybe<ViewConfigInput>;
  /** IDs of contestants visible to this person when logged in. */
  visibleContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of events visible to this person when logged in. */
  visibleEventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of teams visible to this person when logged in. */
  visibleTeamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  workMobile?: InputMaybe<Scalars['Float']['input']>;
  workPhone?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOnePersonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Person>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePlotPageConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of columns in the grid. */
  gridCols: Scalars['Int']['input'];
  /** Number of rows in the grid. */
  gridRows: Scalars['Int']['input'];
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  plots: Array<InputMaybe<PlotConfigInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOnePlotPageConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PlotPageConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePointsSystemInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of points for the fastest lap */
  laptimeDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Race position cutoff for drivers eligible for points for the fastest lap. In some race series you need to be in the top 10 to get the bonus point. */
  laptimePositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  /** Array of points for the fastest lap for the teams. In some race series only the driver receives points for fastest lap. */
  laptimeTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name: Scalars['String']['input'];
  /** How much race distance needs to be completed to be eligible for points */
  positionalCompletionMin?: InputMaybe<Scalars['Float']['input']>;
  /** How much race distance in % needs to be completed to be eligible for points */
  positionalCompletionMinRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Array of driver points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of team points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sessionType: EnumSessionType;
};

export type CreateOnePointsSystemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PointsSystem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProjectInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneProjectPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Project>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneQualityCheckActionInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<CommentInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  priority?: InputMaybe<EnumQualityCheckActionPriority>;
  status?: InputMaybe<EnumQualityCheckActionStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneQualityCheckActionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<QualityCheckAction>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneQualityCheckInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  qualityCheckActionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneQualityCheckPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<QualityCheck>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRaceSeriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultJobListIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  driversPerCar?: InputMaybe<EnumRaceSeriesDriversPerCar>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  lapTypeConfig?: InputMaybe<RaceSeriesLapTypeConfigInput>;
  name: Scalars['String']['input'];
  seasonIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  sortingIndex?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneRaceSeriesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<RaceSeries>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRadioMessageInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which the audio message arrived in the queue for transcribing. */
  arrivedInQueueAt?: InputMaybe<Scalars['Date']['input']>;
  /** This is currently a path to a file on the Transcribble server, but it should eventually be a URL to a file in something like an S3 bucket instead. */
  audioPath: Scalars['String']['input'];
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  important?: Scalars['Boolean']['input'];
  /** Length of the audio message in seconds. */
  length?: InputMaybe<Scalars['Float']['input']>;
  sessionID: Scalars['MongoID']['input'];
  /** Time at which the audio message was taken by a transcription service. */
  takenByTranscriberAt?: InputMaybe<Scalars['Date']['input']>;
  /** The text of the message, as transcribed by Transcribble. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Time at which this message began recording audio. */
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which the audio message was finished initial transcribing. */
  transcribedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneRadioMessagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<RadioMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneReportNotesTemplateInput = {
  pageAppendix?: InputMaybe<ReportNotesTemplatePageAppendixInput>;
  pageOverview?: InputMaybe<ReportNotesTemplatePageOverviewInput>;
  pageParts?: InputMaybe<ReportNotesTemplatePagePartsInput>;
  pageRunPlan?: InputMaybe<ReportNotesTemplatePageRunPlanInput>;
  pageSession?: InputMaybe<ReportNotesTemplatePageSessionInput>;
  title: Scalars['String']['input'];
};

export type CreateOneReportNotesTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ReportNotesTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneReportTemplateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  appendix?: InputMaybe<ReportTemplateAppendixInput>;
  bop?: InputMaybe<ReportTemplateBopInput>;
  carSetup?: InputMaybe<ReportTemplateCarSetupInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** File format based off a filename pattern, e.g. {raceSeries} {season} {event} */
  downloadFilenameFormat?: InputMaybe<Scalars['String']['input']>;
  excludedNoteIDs?: InputMaybe<ReportTemplateExcludedNoteIDsInput>;
  issues?: InputMaybe<ReportTemplateIssuesInput>;
  kpi?: InputMaybe<ReportTemplateKpiInput>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overview?: InputMaybe<ReportTemplateOverviewInput>;
  parts?: InputMaybe<ReportTemplatePartsInput>;
  reportTitle?: InputMaybe<Scalars['String']['input']>;
  runInfo?: InputMaybe<ReportTemplateRunInfoInput>;
  runPlan?: InputMaybe<ReportTemplateRunPlanInput>;
  sessions?: InputMaybe<ReportTemplateSessionsInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  weather?: InputMaybe<ReportTemplateWeatherInput>;
};

export type CreateOneReportTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ReportTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRunPlanInput = {
  PUEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Amount of time in seconds to increment SOC by 1% at each rSOC value. Must have same length as `chargeTimeSOCValues`. */
  chargeTimeSOCIncrements?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** rSOC values to associate with each time charge time increment. Must have same length as `chargeTimeSOCIncrements` */
  chargeTimeSOCValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contestantID: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fuelRequired?: InputMaybe<RunEnergyInput>;
  /** Full tank fuel load */
  mFuelFullTank?: InputMaybe<Scalars['Float']['input']>;
  performanceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  runs: Array<InputMaybe<RunPlanRunInput>>;
  sessionID: Scalars['MongoID']['input'];
  systemEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tLapExpected?: InputMaybe<RunLapTimeInput>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Short comment like dry run plan / wet run plan. */
  title: Scalars['String']['input'];
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneRunPlanPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<RunPlan>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRunSheetInput = {
  /** Fuel density, if working in volume (overrides `DFuel` from event) */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Run number */
  NRun?: InputMaybe<Scalars['Float']['input']>;
  /** Run number for timing services */
  NRunTiming?: InputMaybe<Scalars['Float']['input']>;
  SoCRequired?: InputMaybe<RunEnergyInput>;
  TCellMaxRunStart?: InputMaybe<Scalars['Float']['input']>;
  /** Volume of fuel added at the start of the run. This field will not be automatically calculated by the API, so should be set along with `tRefuel` and `qRefuel` as their product. */
  VFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  associatedKpiFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brakeComment?: InputMaybe<Scalars['String']['input']>;
  brakeFL?: InputMaybe<RunBrakeInput>;
  brakeFR?: InputMaybe<RunBrakeInput>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  brakeRL?: InputMaybe<RunBrakeInput>;
  brakeRR?: InputMaybe<RunBrakeInput>;
  /** Link to a cloud storage location where raw run data is kept. */
  cloudStorageURL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel/SoC/Energy consumptions for each track layout in this run sheet. Acts as an override for the consumptions from the parent event. */
  consumptions?: InputMaybe<Array<InputMaybe<LayoutConsumptionInput>>>;
  contestantID: Scalars['MongoID']['input'];
  controlsComment?: InputMaybe<Scalars['String']['input']>;
  dashboard?: InputMaybe<DashboardInput>;
  dataServiceFileNameOverride?: InputMaybe<Scalars['String']['input']>;
  dilComments?: InputMaybe<Scalars['String']['input']>;
  driverComments?: InputMaybe<Scalars['String']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Car data service run end time */
  endTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  /** Laptime service run end time */
  endTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  /** Manual run end time (used to override calculation in case run was cut short but don't want to delete the drafted laps */
  endTimeManual?: InputMaybe<Scalars['Date']['input']>;
  energyRequired?: InputMaybe<RunEnergyInput>;
  engineerComments?: InputMaybe<Scalars['String']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time by which tyre heating schedule should be finished */
  finishTyreHeatingBy?: InputMaybe<Scalars['Date']['input']>;
  /** Used for fuel calculation. If true, mFuelAdded is treated as the total fuel at run start. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  fuelRequired?: InputMaybe<RunEnergyInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isLockedByLaptimeService?: InputMaybe<Scalars['Boolean']['input']>;
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  jobIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Used to save the file name where the kpi data is retreived from */
  kpiFileName?: InputMaybe<Scalars['String']['input']>;
  kpiStatus?: InputMaybe<EnumRunSheetKpiStatus>;
  kpiUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** `addLap`, `forceAddLap`, `updateLap`, and `removeLap` mutations are preferred unless you want to completely replace the laps with new data. */
  laps?: InputMaybe<Array<InputMaybe<LapInput>>>;
  laptimeThresholds?: InputMaybe<LaptimeThresholdsInput>;
  /** Fuel added at the start of the run */
  mFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the catch tank after the run */
  mFuelDrainedCatchTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the main tank after the run */
  mFuelDrainedMainTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel used before run start i.e. for pre-run fireup */
  mFuelUsedPreRun?: InputMaybe<Scalars['Float']['input']>;
  nextRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  performanceComments?: InputMaybe<Scalars['String']['input']>;
  prevRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  problemComments?: InputMaybe<Scalars['String']['input']>;
  /** Flow rate when refuelling at the start of the run, in m³/s */
  qRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Energy charged to this value at the start of the run */
  rEnergyAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Energy level at the end of the run */
  rEnergyRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Battery charged to this value at the start of the run */
  rSOCAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Battery state of charge at the end of the run */
  rSOCRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Short comment of the objective of the run */
  runDescription?: InputMaybe<Scalars['String']['input']>;
  /** Map of run KPI fields to their values. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  runSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Running time in seconds */
  runTime?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the job list template used for this run */
  selectedJobListTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  setupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of the simulation results associated with this run. */
  simResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  skidComment?: InputMaybe<Scalars['String']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidMeasurement: [["left", 5], ["marker1", 6]]`. */
  skidMeasurement?: InputMaybe<Scalars['JSON']['input']>;
  skidPlateID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPostRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPostRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPreRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPreRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  startTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  startTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  startTimeManual?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which to start tyre heating schedule */
  startTyreHeatingAt?: InputMaybe<Scalars['Date']['input']>;
  summaryComments?: InputMaybe<Scalars['String']['input']>;
  systemsComments?: InputMaybe<Scalars['String']['input']>;
  /** Time spent refuelling at the start of the run */
  tRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Override for session time remaining (in seconds) */
  tSessionRemainingOverride?: InputMaybe<Scalars['Float']['input']>;
  /** Time spent in garage before run */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this run in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyRunID?: InputMaybe<Scalars['String']['input']>;
  /** Should the timing service pretend that this run sheet does not exist? */
  timingServiceShouldIgnore?: InputMaybe<Scalars['Boolean']['input']>;
  tyreComments?: InputMaybe<Scalars['String']['input']>;
  /** The tyre compound used, reported by the timing service. */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  tyreFL?: InputMaybe<RunTyreInput>;
  tyreFR?: InputMaybe<RunTyreInput>;
  tyrePressureSettings?: InputMaybe<TyrePressureSettingsInput>;
  tyreRL?: InputMaybe<RunTyreInput>;
  tyreRR?: InputMaybe<RunTyreInput>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  weather?: InputMaybe<WeatherDataInput>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneRunSheetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<RunSheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRunSheetStyleInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  blocks?: InputMaybe<Array<InputMaybe<GenericRunSheetStyleBlockInput>>>;
  energyType?: InputMaybe<EnumEnergyType>;
  lapFlags?: InputMaybe<LapFlagLabelsInput>;
  name: Scalars['String']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneRunSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<RunSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSandboxUnitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acceleration?: InputMaybe<AccelerationInput>;
  angle?: InputMaybe<AngleInput>;
  angularVelocity?: InputMaybe<AngularVelocityInput>;
  area?: InputMaybe<AreaInput>;
  current?: InputMaybe<CurrentInput>;
  dampingRate?: InputMaybe<DampingRateInput>;
  density?: InputMaybe<DensityInput>;
  energy?: InputMaybe<EnergyInput>;
  force?: InputMaybe<ForceInput>;
  frequency?: InputMaybe<FrequencyInput>;
  length?: InputMaybe<LengthInput>;
  mass?: InputMaybe<MassInput>;
  momentOfInertia?: InputMaybe<MomentOfInertiaInput>;
  power?: InputMaybe<PowerInput>;
  pressure?: InputMaybe<PressureInput>;
  ratio?: InputMaybe<RatioInput>;
  springRate?: InputMaybe<SpringRateInput>;
  temperature?: InputMaybe<TemperatureInput>;
  torque?: InputMaybe<TorqueInput>;
  torsionRate?: InputMaybe<TorsionRateInput>;
  velocity?: InputMaybe<VelocityInput>;
  voltage?: InputMaybe<VoltageInput>;
  volume?: InputMaybe<VolumeInput>;
};

export type CreateOneSandboxUnitsPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SandboxUnits>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSeasonInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Position after which a driver no longer gets points for fastest lap. */
  fastestLapsPositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** Championship points per fastest lap in a session. Example: `[1]` means fastest lap gets 1 point, then second and beyond gets nothing. */
  pointsPerFastestLap?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Whether the fastest lap points are awarded to the team or the driver. */
  pointsPerFastestLapTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Championship points per driver position in a race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPosition?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per driver position in a sprint race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPositionSprintRace?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per qualifying rank at an event. Example: `[3, 2, 1]` means first/second/third drivers get 3/2/1 points, then fourth and beyond gets nothing. */
  pointsPerQualifyingRank?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsSystemQualiAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemQualiDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceSeriesID: Scalars['MongoID']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyres which are owned by the team for this season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyre sets which are owned by the team for this season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneSeasonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Season>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSessionInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bestValuesID?: InputMaybe<Scalars['MongoID']['input']>;
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  contestants?: InputMaybe<Array<InputMaybe<SessionContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumSessionDebriefNotesMode>;
  disableForwardPropagation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted driver championship standings during and immediately after this session. */
  driverChampionshipStandings?: InputMaybe<Array<InputMaybe<DriverChampionshipStandingInput>>>;
  eventID: Scalars['MongoID']['input'];
  /** This flag is used to tell the laptime service that this session might span multiple timing sessions. */
  isLinkedSession?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this a timing test session, to be shown only to admin users? */
  isTimingTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted standings of this session, as they were last updated */
  liveStandings?: InputMaybe<Array<InputMaybe<LiveStandingInput>>>;
  /** Greatest lap number processed for live standings. Use to determine if the data is current and up to date. */
  liveStandingsCurrentLap?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** ID of the next session in this event */
  nextSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFRMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRRMinSession?: InputMaybe<Scalars['Float']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemOverrideIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted driver championship standings from before the start of this session. */
  prevDriverChampionshipStandings?: InputMaybe<Array<InputMaybe<DriverChampionshipStandingInput>>>;
  /** ID of the previous session in this event */
  prevSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** e.g. Test, Practice, Qualifying, Race */
  sessionType?: InputMaybe<EnumSessionType>;
  /** Short name like D1, FP2, etc. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Time of the session end in local time */
  tSessionEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of the session start in local time */
  tSessionStart?: InputMaybe<Scalars['Date']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted team championship standings during and immediately after this session. */
  teamChampionshipStandings?: InputMaybe<Array<InputMaybe<TeamChampionshipStandingInput>>>;
  /** ID of this session in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartySessionID?: InputMaybe<Scalars['String']['input']>;
  /** Seconds until end of session, updated by the timing service very infrequently. Zero if session has already ended. */
  timeRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** ID of this session for Transcribble's legacy API */
  transcribbleSessionID?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOneSessionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Session>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSetupOverviewConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** WARNING: this field should be deprecated after SI migrations have taken place */
  fields?: InputMaybe<Array<InputMaybe<SetupOverviewConfigFieldInput>>>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<SetupOverviewConfigRowInput>>>;
  title: Scalars['String']['input'];
};

export type CreateOneSetupOverviewConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SetupOverviewConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSetupSheetStyleInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blocks?: InputMaybe<Array<SetupSheetStyleBlockInput>>;
  /** Chassis specification to use for suggesting field keys. You may need to look for more recent iterations of this spec to get up-to-date field keys. */
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  hideAddPartButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to show/hide units for the input fields */
  hideUnits?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  targetEventType?: InputMaybe<EnumSetupSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumSetupSheetStyleType;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneSetupSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SetupSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSimRequestInput = {
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  relatedSimResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  requesterSlot?: InputMaybe<EnumSimRequestRequesterSlot>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
  simType?: InputMaybe<EnumSimRequestSimType>;
  simulationService?: InputMaybe<EnumSimModelType>;
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: EnumSimResultStatus;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneSimRequestPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SimRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSimResultInput = {
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<SimResultDataInput>>>;
  /** Each data channel is assumed to use this unless it specifies `channelSamplingRate` or `channelTime` */
  defaultChannelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Map containing reference values from car setup. Example: aerobalance in a car manual. Input syntax is array of key-value tuples, like `refValues: [["rAeroBalF", 48.5], ["rLatBalF", 51.4]]`. */
  refValues?: InputMaybe<Scalars['JSON']['input']>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the ORH service used to generate the sim result */
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  simType?: InputMaybe<EnumSimResultSimType>;
  simulationDriveFileID?: InputMaybe<Scalars['MongoID']['input']>;
  simulationService?: InputMaybe<EnumSimModelType>;
  /** Service which generated this sim result, for example Canopy */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Reference for this sim result, to find it in the simulation service */
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: EnumSimResultStatus;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneSimResultPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SimResult>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSimulationDriveFileInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumSimulationDriveFileStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumTypeID?: InputMaybe<Scalars['MongoID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneSimulationDriveFilePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SimulationDriveFile>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSkidPlateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  initialThickness?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneSkidPlatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SkidPlate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSpecificationGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateOneSpecificationGroupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SpecificationGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSpecificationInput = {
  CxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  FSpringSetup?: InputMaybe<AdjustableForceInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aCamber?: InputMaybe<SpecificationACamberInput>;
  aCaster?: InputMaybe<SpecificationACamberInput>;
  aCasterMeasurementGain?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurementOffset?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<SpecificationACamberInput>;
  adjustableProperties?: InputMaybe<Array<InputMaybe<AdjustablePropertyInput>>>;
  aeroElementInterpolationMethod?: InputMaybe<EnumAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  aeroElementType?: InputMaybe<EnumAeroElementType>;
  aeroPackageSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  aeroPackageSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  antiRollBarConfigs?: InputMaybe<Array<InputMaybe<AntiRollBarConfigInput>>>;
  antiRollBarDisplayLocation?: InputMaybe<EnumAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: InputMaybe<Array<InputMaybe<AssignedGearInput>>>;
  attachable?: InputMaybe<Scalars['Boolean']['input']>;
  axle?: InputMaybe<EnumAxle>;
  bevelSetSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetVisible?: InputMaybe<Scalars['Boolean']['input']>;
  bumpRubberReference?: InputMaybe<EnumKinematicsInternalReference>;
  bumpRubberSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bumpStopGapMethod?: InputMaybe<EnumBumpStopGapMethod>;
  calculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: InputMaybe<Scalars['String']['input']>;
  chassisMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  copyReferencePackageID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customSimulationModels?: InputMaybe<Array<InputMaybe<SpecificationCustomSimulationModelsInput>>>;
  customSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  customSpecType?: InputMaybe<Scalars['String']['input']>;
  customTables?: InputMaybe<Array<InputMaybe<SpecificationCustomTablesInput>>>;
  damperAdjusters?: InputMaybe<Array<InputMaybe<DamperAdjusterInput>>>;
  damperConfigs?: InputMaybe<Array<InputMaybe<DamperConfigInput>>>;
  damperSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  denominator?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  differentialConfigs?: InputMaybe<Array<InputMaybe<DifferentialConfigInput>>>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  drawingNumber?: InputMaybe<Scalars['String']['input']>;
  dropGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  elasticType?: InputMaybe<EnumElasticType>;
  forceTable?: InputMaybe<ForceTableInput>;
  gearType?: InputMaybe<EnumGearType>;
  hRide?: InputMaybe<SpecificationHRideInput>;
  hasToBeInSubAssembly?: InputMaybe<Scalars['Boolean']['input']>;
  headGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  helperSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  initialChassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spring constant of the elastic element. */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  kinematicsExternalModels?: InputMaybe<Array<InputMaybe<KinematicsExternalModelInput>>>;
  kinematicsExternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kinematicsInternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerReference?: InputMaybe<Scalars['String']['input']>;
  mass?: InputMaybe<ChassisMassInput>;
  massProperties?: InputMaybe<MassPropertiesInput>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: InputMaybe<ChassisMeasurementsInput>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  name: Scalars['String']['input'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  numerator?: InputMaybe<Scalars['Float']['input']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  polyCxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  positionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  powerUnits?: InputMaybe<Array<InputMaybe<ChassisPowerUnitInput>>>;
  powertrain?: InputMaybe<ChassisPowertrainInput>;
  powertrainLocation?: InputMaybe<EnumSpecificationPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  rBrakeBias?: InputMaybe<AdjustableRatioInput>;
  /** Position of the specification on the car */
  readingsAllowable?: InputMaybe<Array<InputMaybe<EnumSpecificationReadingsAllowable>>>;
  readingsRequired?: InputMaybe<EnumSpecificationReadingsRequired>;
  reboundSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regulationSets?: InputMaybe<Array<InputMaybe<RegulationSetInput>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: InputMaybe<Scalars['Boolean']['input']>;
  setupChangesFilter?: InputMaybe<SpecificationSetupChangesFilterInput>;
  setupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  /** Locations/areas that components can be installed in. */
  sockets?: InputMaybe<Array<InputMaybe<ChassisSocketInput>>>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationGroupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  springReference?: InputMaybe<EnumKinematicsInternalReference>;
  springSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  torsionBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumSpecificationType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** User-supplied version of this specification. */
  version?: InputMaybe<Scalars['String']['input']>;
  xBumpRubberRef?: InputMaybe<Scalars['Float']['input']>;
  xBumpRubberSetup?: InputMaybe<AdjustableLengthInput>;
  xBumpStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperSetupDefault?: InputMaybe<Scalars['Float']['input']>;
  xDroopStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  /** Length of the elastic element under no force */
  xFree?: InputMaybe<Scalars['Float']['input']>;
  xShaftDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xSpringPlatformOffset?: InputMaybe<Scalars['Float']['input']>;
  xSpringRef?: InputMaybe<Scalars['Float']['input']>;
  xSpringSetup?: InputMaybe<AdjustableLengthInput>;
  xToe?: InputMaybe<SpecificationHRideInput>;
};

export type CreateOneSpecificationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Specification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSsoProviderInput = {
  clientID: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  issuerURL: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateOneSsoProviderPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SsoProvider>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTagInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  tagType?: InputMaybe<EnumTagType>;
};

export type CreateOneTagPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTeamInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default color to use for this team where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Used only for filtering to limit which teams are displayed in a list. */
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneTeamPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Team>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTemplateJobListInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  jobs: Array<InputMaybe<TemplateJobInput>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  title: Scalars['String']['input'];
};

export type CreateOneTemplateJobListPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TemplateJobList>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTemplateSessionDebriefInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumTemplateSessionDebriefMode>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateOneTemplateSessionDebriefPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TemplateSessionDebrief>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTimeSheetEntryInput = {
  /** Whether a person did work on this day */
  absent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notes about what was done during this time */
  description?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Clock-out time */
  tEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Clock-in time */
  tStart: Scalars['Date']['input'];
};

export type CreateOneTimeSheetEntryPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TimeSheetEntry>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTimingServiceConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Whether the timingServiceConfig should be considered active by the service */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event ID. This finds the correct event by its _id field. */
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Use schedule-based session matching as fallback. */
  fallbackScheduleBasedSessionMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of timed sectors on track. Used as fallback in case timing data does not provide it. */
  fallbackTimedSectorsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Car numbers to follow. */
  followedCarNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Activate live standings to see the driver championship points live. Only working properly if all drivers of a given season are added as contestants. */
  liveStandingsActive?: InputMaybe<Scalars['Boolean']['input']>;
  logLevel?: InputMaybe<EnumTimingServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<EnumTimingServiceConfigMode>;
  /** Name for this set of configuration settings. */
  name: Scalars['String']['input'];
  /** Use string equality to match timing session names in One Racehub. Otherwise default sequence matching is used. */
  strictSessionNameMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** One Timing server port. */
  timingPort?: InputMaybe<Scalars['Int']['input']>;
  /** Race series name to filter on in the timing feed when multiple series are running at an event. */
  timingRaceSeries?: InputMaybe<Scalars['String']['input']>;
  /** One Timing server address. */
  timingURL?: InputMaybe<Scalars['String']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneTimingServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TimingServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acronym?: InputMaybe<Scalars['String']['input']>;
  /** Track height above sea level. */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  /** IDs of the available track layouts */
  layoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name: Scalars['String']['input'];
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Storage ID of track picture file in s3. */
  trackPicture?: InputMaybe<Scalars['String']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateOneTrackLayoutInput = {
  ATKModeGain?: InputMaybe<Scalars['Float']['input']>;
  ATKModeLocation?: InputMaybe<Scalars['Float']['input']>;
  ATKModePenalty?: InputMaybe<Scalars['Float']['input']>;
  FCYLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Full-course yellow probability */
  FCYProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of sectors the timing provides */
  NSectorsTiming?: InputMaybe<Scalars['Float']['input']>;
  SCLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Safety car probability */
  SCProbability?: InputMaybe<Scalars['Float']['input']>;
  SoCRequired?: InputMaybe<RunEnergyInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acronym?: InputMaybe<Scalars['String']['input']>;
  bumpiness?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code60LapTime?: InputMaybe<Scalars['Float']['input']>;
  crossoverWetToSlick?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  energyRequired?: InputMaybe<RunEnergyInput>;
  expectedRaceLaps?: InputMaybe<Scalars['Float']['input']>;
  firstLapOffset?: InputMaybe<Scalars['Float']['input']>;
  fuelRequired?: InputMaybe<RunEnergyInput>;
  inLapTime?: InputMaybe<Scalars['Float']['input']>;
  lapLengthCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapZero?: InputMaybe<Scalars['Boolean']['input']>;
  lapsUntilFullRegen?: InputMaybe<Scalars['Float']['input']>;
  mapElevation?: InputMaybe<Scalars['String']['input']>;
  mapEmergencyExits?: InputMaybe<Scalars['String']['input']>;
  mapPitLane?: InputMaybe<Scalars['String']['input']>;
  mapTrack?: InputMaybe<Scalars['String']['input']>;
  mapTrackGPS?: InputMaybe<Scalars['String']['input']>;
  mapTrackLatLonCsv?: InputMaybe<Scalars['String']['input']>;
  mapTrackXyCsv?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Layout */
  name: Scalars['String']['input'];
  outLapTime?: InputMaybe<Scalars['Float']['input']>;
  overtakingThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Whole distance from entry to exit inlcuding approach and leave */
  pitDistance?: InputMaybe<Scalars['Float']['input']>;
  /** Length of pit lane between the pit lane entry and exit loop (used for mileage calculation of pitlane lap types) */
  pitLength?: InputMaybe<Scalars['Float']['input']>;
  pitLoss?: InputMaybe<Scalars['Float']['input']>;
  pitLossDriveThrough?: InputMaybe<Scalars['Float']['input']>;
  /** Indicates whether the pole position is on the left- or right-hand side */
  polePosition?: InputMaybe<EnumTrackLayoutPolePosition>;
  prepLapTime?: InputMaybe<Scalars['Float']['input']>;
  pushLapTime?: InputMaybe<Scalars['Float']['input']>;
  sectorDistance?: InputMaybe<Scalars['Float']['input']>;
  sectorLengths?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Downforce sensitivity (seconds per 10pts) */
  sensDownforce?: InputMaybe<Scalars['Float']['input']>;
  /** Drag sensitivity (seconds per 10pts) */
  sensDrag?: InputMaybe<Scalars['Float']['input']>;
  sensEP?: InputMaybe<Scalars['Float']['input']>;
  /** Energy sensitivity (seconds per 0.1kWh) */
  sensEnergy?: InputMaybe<Scalars['Float']['input']>;
  /** Grip sensitivity (seconds per %) */
  sensGrip?: InputMaybe<Scalars['Float']['input']>;
  /** Mass sensitivity (seconds per 10kg) */
  sensMass?: InputMaybe<Scalars['Float']['input']>;
  /** Power sensitivity */
  sensPower?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Array<InputMaybe<TrackLayoutSimulationModelInput>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackEvolution?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the track this layout belongs to */
  trackID: Scalars['MongoID']['input'];
  trackLayoutType?: InputMaybe<EnumTrackLayoutTrackLayoutType>;
  trackRecordQuali?: InputMaybe<Scalars['Float']['input']>;
  trackRecordRace?: InputMaybe<Scalars['Float']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateOneTrackLayoutPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackLayout>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Track>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** ID of the original version of the specifications to track. */
  rootSpecificationID: Scalars['MongoID']['input'];
  unitType?: InputMaybe<BaseTypedUnitFieldInput>;
  /** Comparison to use when checking if the tracked value is in the warning/critical range. */
  warningDirection?: InputMaybe<EnumTrackableWarningDirection>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOneTrackablePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Trackable>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingItemInput = {
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  arrayElements?: InputMaybe<Scalars['Float']['input']>;
  criticalCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  cumulativeCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  isArray?: InputMaybe<Scalars['Boolean']['input']>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  measurementImage?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  operator?: InputMaybe<EnumTrackingItemOperator>;
  resettable?: InputMaybe<Scalars['Boolean']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
  warningCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOneTrackingItemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingMeasurementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultCoordinates?: InputMaybe<TrackingMeasurementDefaultCoordinatesInput>;
  defaultRotation?: InputMaybe<TrackingMeasurementDefaultRotationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneTrackingMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingMeasurementRecordInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  coordinates?: InputMaybe<TrackingMeasurementRecordCoordinatesInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  rotation?: InputMaybe<TrackingMeasurementRecordRotationInput>;
  trackingMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneTrackingMeasurementRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingMeasurementRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingRecordGeneralInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date: Scalars['Date']['input'];
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<ForceTableInput>;
  location?: InputMaybe<LocationInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID: Scalars['MongoID']['input'];
  qualityCheckID?: InputMaybe<Scalars['MongoID']['input']>;
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  statusEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordGeneralType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTrackingRecordGeneralPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingRecordGeneral>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingRecordInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<ForceTableInput>;
  location?: InputMaybe<LocationInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  qualityCheckID?: InputMaybe<Scalars['MongoID']['input']>;
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  statusEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTrackingRecordOverrideInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cumulativeValue: Scalars['Float']['input'];
  date: Scalars['Date']['input'];
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<ForceTableInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID: Scalars['MongoID']['input'];
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  statusEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID: Scalars['MongoID']['input'];
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordOverrideType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTrackingRecordOverridePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingRecordOverride>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingRecordValueInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<ForceTableInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID: Scalars['MongoID']['input'];
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  trackingItemID: Scalars['MongoID']['input'];
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordValueType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTrackingRecordValuePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingRecordValue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingSourceAliasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aliasString?: InputMaybe<Scalars['String']['input']>;
  aliasType?: InputMaybe<EnumTrackingSourceAliasAliasType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOneTrackingSourceAliasPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingSourceAlias>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTrackingSourceInput = {
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  chassisSpecID: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  name: Scalars['String']['input'];
  sourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneTrackingSourcePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TrackingSource>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTyreInput = {
  /** Flag if the tyre is scrapped (no longer available for use). */
  BTyreScrapped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tyre Circumference */
  CTyre?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Arbitrary string to sort or filter by */
  additionalSortProperty?: InputMaybe<Scalars['String']['input']>;
  axle?: InputMaybe<EnumTyreAxle>;
  barcodeManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Barcode from the regulatory body (e.g. FIA) */
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  barcodeRim?: InputMaybe<Scalars['String']['input']>;
  barcodeTPMS?: InputMaybe<Scalars['String']['input']>;
  batteryTPMS?: InputMaybe<Scalars['String']['input']>;
  compound?: InputMaybe<Scalars['String']['input']>;
  compoundComment?: InputMaybe<Scalars['String']['input']>;
  constructionComment?: InputMaybe<Scalars['String']['input']>;
  constructionSpec?: InputMaybe<Scalars['String']['input']>;
  heatingSchedule?: InputMaybe<Array<InputMaybe<TyreHeatingScheduleEntryInput>>>;
  initialCondition?: InputMaybe<EnumTyreInitialCondition>;
  /** Tyre Spring Rate */
  kTyre?: InputMaybe<Scalars['Float']['input']>;
  mTyre?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Tyre mold information */
  mold?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Tyre minimum pressure defined by regulation or manufacturer */
  pTyreMinRegulation?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure defined by team (i.e. chief engineer) */
  pTyreMinTeam?: InputMaybe<Scalars['Float']['input']>;
  rimPartID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Initial mileage before use in One Racehub. */
  sRunInitial?: InputMaybe<Scalars['Float']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  wearMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateOneTyrePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tyre>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTyreSetInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tyreIDFL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDFR?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRR?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneTyreSetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TyreSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTyreWearInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which this measurement was made. */
  date?: InputMaybe<Scalars['Date']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreID: Scalars['MongoID']['input'];
  /** Raw wear data formatted however the user chooses, probably from a scanner. */
  wearData?: InputMaybe<Scalars['String']['input']>;
  /** Map of marker names to wear values. Input syntax is array of key-value tuples, like `wearMarkers: [["inner", 0.8], ["1", 0.3]]`. */
  wearMarkers?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateOneTyreWearPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TyreWear>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneUserEnumInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type?: EnumUserEnumType;
};

export type CreateOneUserEnumPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<UserEnum>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneWeatherInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Height above sea level (for air density for example). */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  data: Array<InputMaybe<WeatherDataInput>>;
  /** References to events this weather data was made for, if applicable */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  /** User notes for completing a forecast for a race */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Forecast/measurement source (website, weather station, timekeeping, …) */
  source?: InputMaybe<Scalars['String']['input']>;
  /** For predictions, indicates the time at which the prediction was made. For measurements, indicates the time of the first measurement in the array. */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Prediction, measurement, historical */
  type: EnumWeatherType;
  /** Weather station ID */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneWeatherPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Weather>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneWeatherServiceConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** API Key. Used for Open Weather Map and Wunderground */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** API Secret. Used for Weather Link */
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Password. Currently used for meteomatics */
  password?: InputMaybe<Scalars['String']['input']>;
  refreshInterval: Scalars['Float']['input'];
  requestLocation?: InputMaybe<GeoLocationInput>;
  /** Location or weather station */
  requestType: EnumWeatherServiceConfigRequestType;
  /** Weather client to specify the source where to retrieve the data from. */
  source: EnumWeatherServiceConfigSource;
  type: EnumWeatherServiceConfigType;
  /** Username. Currently used for meteomatics */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Weather Station ID. Used for Weather Underground */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<WeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateSessionForFullEventInput = {
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bestValuesID?: InputMaybe<Scalars['MongoID']['input']>;
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  contestants?: InputMaybe<Array<InputMaybe<SessionContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumSessionDebriefNotesMode>;
  disableForwardPropagation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted driver championship standings during and immediately after this session. */
  driverChampionshipStandings?: InputMaybe<Array<InputMaybe<DriverChampionshipStandingInput>>>;
  /** This flag is used to tell the laptime service that this session might span multiple timing sessions. */
  isLinkedSession?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this a timing test session, to be shown only to admin users? */
  isTimingTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted standings of this session, as they were last updated */
  liveStandings?: InputMaybe<Array<InputMaybe<LiveStandingInput>>>;
  /** Greatest lap number processed for live standings. Use to determine if the data is current and up to date. */
  liveStandingsCurrentLap?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** ID of the next session in this event */
  nextSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFRMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRRMinSession?: InputMaybe<Scalars['Float']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemOverrideIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted driver championship standings from before the start of this session. */
  prevDriverChampionshipStandings?: InputMaybe<Array<InputMaybe<DriverChampionshipStandingInput>>>;
  /** ID of the previous session in this event */
  prevSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** e.g. Test, Practice, Qualifying, Race */
  sessionType?: InputMaybe<EnumSessionType>;
  /** Short name like D1, FP2, etc. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Time of the session end in local time */
  tSessionEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of the session start in local time */
  tSessionStart?: InputMaybe<Scalars['Date']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted team championship standings during and immediately after this session. */
  teamChampionshipStandings?: InputMaybe<Array<InputMaybe<TeamChampionshipStandingInput>>>;
  /** ID of this session in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartySessionID?: InputMaybe<Scalars['String']['input']>;
  /** Seconds until end of session, updated by the timing service very infrequently. Zero if session has already ended. */
  timeRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** ID of this session for Transcribble's legacy API */
  transcribbleSessionID?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTyreRecordInput = {
  /** Flag if the tyre is scrapped (no longer available for use). */
  BTyreScrapped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tyre Circumference */
  CTyre?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Arbitrary string to sort or filter by */
  additionalSortProperty?: InputMaybe<Scalars['String']['input']>;
  axle?: InputMaybe<EnumTyreAxle>;
  barcodeManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Barcode from the regulatory body (e.g. FIA) */
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  barcodeRim?: InputMaybe<Scalars['String']['input']>;
  barcodeTPMS?: InputMaybe<Scalars['String']['input']>;
  batteryTPMS?: InputMaybe<Scalars['String']['input']>;
  compound?: InputMaybe<Scalars['String']['input']>;
  compoundComment?: InputMaybe<Scalars['String']['input']>;
  constructionComment?: InputMaybe<Scalars['String']['input']>;
  constructionSpec?: InputMaybe<Scalars['String']['input']>;
  heatingSchedule?: InputMaybe<Array<InputMaybe<TyreHeatingScheduleEntryInput>>>;
  initialCondition?: InputMaybe<EnumTyreInitialCondition>;
  /** Tyre Spring Rate */
  kTyre?: InputMaybe<Scalars['Float']['input']>;
  mTyre?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Tyre mold information */
  mold?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Tyre minimum pressure defined by regulation or manufacturer */
  pTyreMinRegulation?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure defined by team (i.e. chief engineer) */
  pTyreMinTeam?: InputMaybe<Scalars['Float']['input']>;
  rimPartID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Initial mileage before use in One Racehub. */
  sRunInitial?: InputMaybe<Scalars['Float']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** Wear measurement to store for this tyre, as `[["inner", 0.8], ["1", 0.3]]`. */
  wearMarkers?: InputMaybe<Scalars['JSON']['input']>;
  wearMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type CreateTyreSetRecordInput = {
  tyreFL?: InputMaybe<CreateTyreRecordInput>;
  tyreFR?: InputMaybe<CreateTyreRecordInput>;
  tyreRL?: InputMaybe<CreateTyreRecordInput>;
  tyreRR?: InputMaybe<CreateTyreRecordInput>;
  tyreSetComment?: InputMaybe<Scalars['String']['input']>;
  tyreSetName?: InputMaybe<Scalars['String']['input']>;
  tyreSetNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTyresForContestantResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
  tyreIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tyreSetIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type CreatedChassisAssembly = {
  newChassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  newChassisAssemblyName?: Maybe<Scalars['String']['output']>;
  newChassisAssemblyReference?: Maybe<Scalars['String']['output']>;
};

export type CreatedPartInstancesResult = {
  createdPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type CreatedSetup = {
  newSetupID?: Maybe<Scalars['MongoID']['output']>;
};

export type Current = {
  /** A */
  amps: Scalars['Float']['output'];
  /** mA */
  milliamps: Scalars['Float']['output'];
};

export type CurrentInput = {
  /** A */
  amps?: InputMaybe<Scalars['Float']['input']>;
  /** mA */
  milliamps?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  adjustableProperties?: Maybe<Array<Maybe<SomeAdjustableProperty>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Names of sockets that this can be plugged in to.
   * @deprecated
   */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpec?: Maybe<Specification>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customSpecType?: Maybe<Scalars['String']['output']>;
  customTables?: Maybe<Array<Maybe<SpecificationCustomTables>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  drawingNumber?: Maybe<Scalars['String']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<CustomSpec>;
  manufacturer: Array<Maybe<Manufacturer>>;
  manufacturerID?: Maybe<Scalars['MongoID']['output']>;
  manufacturerReference?: Maybe<Scalars['String']['output']>;
  massProperties?: Maybe<MassProperties>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  readingsRequired?: Maybe<EnumCustomSpecReadingsRequired>;
  reference?: Maybe<Scalars['String']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurements: Array<TrackingMeasurement>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Damper = {
  NDamperBumpDO?: Maybe<Scalars['Float']['output']>;
  NDamperBumpDY?: Maybe<Scalars['Float']['output']>;
  NDamperBumpHS?: Maybe<Scalars['Float']['output']>;
  NDamperBumpIP?: Maybe<Scalars['Float']['output']>;
  NDamperBumpLS?: Maybe<Scalars['Float']['output']>;
  NDamperReboundDO?: Maybe<Scalars['Float']['output']>;
  NDamperReboundDY?: Maybe<Scalars['Float']['output']>;
  NDamperReboundHS?: Maybe<Scalars['Float']['output']>;
  NDamperReboundIP?: Maybe<Scalars['Float']['output']>;
  NDamperReboundLS?: Maybe<Scalars['Float']['output']>;
  adjusters?: Maybe<Array<Maybe<DamperAdjusters>>>;
  /** Name of the damper config to use for simulation */
  configName?: Maybe<Scalars['String']['output']>;
  gasPressure?: Maybe<Scalars['Float']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use specificationID instead */
  spec?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<DamperSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  valvingBumpSpec?: Maybe<Scalars['String']['output']>;
  valvingReboundSpec?: Maybe<Scalars['String']['output']>;
  xDamperMax?: Maybe<Scalars['Float']['output']>;
};

export type DamperAdjuster = {
  /** Maximum setting, if using min/max/step */
  maxSetting?: Maybe<Scalars['Float']['output']>;
  /** Minimum setting, if using min/max/step */
  minSetting?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  settingNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  settings?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Increment to suggest values in, if using min/max/step */
  step?: Maybe<Scalars['Float']['output']>;
};

export type DamperAdjusterInput = {
  /** Maximum setting, if using min/max/step */
  maxSetting?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum setting, if using min/max/step */
  minSetting?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  settingNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Increment to suggest values in, if using min/max/step */
  step?: InputMaybe<Scalars['Float']['input']>;
};

export type DamperAdjusters = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  settingName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DamperAdjustersInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settingName?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type DamperConfig = {
  forceTable?: Maybe<ForceTable>;
  name: Scalars['String']['output'];
  /** Define which damper clicks are associated with this setting */
  settings?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  simulationModels?: Maybe<Scalars['JSON']['output']>;
};

export type DamperConfigInput = {
  forceTable?: InputMaybe<ForceTableInput>;
  name: Scalars['String']['input'];
  /** Define which damper clicks are associated with this setting */
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type DamperInput = {
  NDamperBumpDO?: InputMaybe<Scalars['Float']['input']>;
  NDamperBumpDY?: InputMaybe<Scalars['Float']['input']>;
  NDamperBumpHS?: InputMaybe<Scalars['Float']['input']>;
  NDamperBumpIP?: InputMaybe<Scalars['Float']['input']>;
  NDamperBumpLS?: InputMaybe<Scalars['Float']['input']>;
  NDamperReboundDO?: InputMaybe<Scalars['Float']['input']>;
  NDamperReboundDY?: InputMaybe<Scalars['Float']['input']>;
  NDamperReboundHS?: InputMaybe<Scalars['Float']['input']>;
  NDamperReboundIP?: InputMaybe<Scalars['Float']['input']>;
  NDamperReboundLS?: InputMaybe<Scalars['Float']['input']>;
  adjusters?: InputMaybe<Array<InputMaybe<DamperAdjustersInput>>>;
  /** Name of the damper config to use for simulation */
  configName?: InputMaybe<Scalars['String']['input']>;
  gasPressure?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  valvingBumpSpec?: InputMaybe<Scalars['String']['input']>;
  valvingReboundSpec?: InputMaybe<Scalars['String']['input']>;
  xDamperMax?: InputMaybe<Scalars['Float']['input']>;
};

export type DamperSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Names of sockets that this can be plugged in to.
   * @deprecated
   */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  damperAdjusters?: Maybe<Array<Maybe<DamperAdjuster>>>;
  damperConfigs?: Maybe<Array<Maybe<DamperConfig>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<DamperSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<EnumReadingLocation>>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  xDamperDroopDefault?: Maybe<Scalars['Float']['output']>;
  xShaftDroopDefault?: Maybe<Scalars['Float']['output']>;
};

export type DampingRate = {
  /** Nms/m */
  newtonSecondsPerMetre: Scalars['Float']['output'];
  /** Nms/mm */
  newtonSecondsPerMillimetre: Scalars['Float']['output'];
  /** lbf·s/in */
  poundForceSecondsPerInch: Scalars['Float']['output'];
};

export type DampingRateInput = {
  /** Nms/m */
  newtonSecondsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** Nms/mm */
  newtonSecondsPerMillimetre?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·s/in */
  poundForceSecondsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type Dashboard = {
  /** Dashboard reading of fuel remaining at the end of the run */
  mFuelRunEnd?: Maybe<Scalars['Float']['output']>;
  /** Dashboard reading of fuel amount at the start of the run */
  mFuelRunStart?: Maybe<Scalars['Float']['output']>;
};

export type DashboardInput = {
  /** Dashboard reading of fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Dashboard reading of fuel amount at the start of the run */
  mFuelRunStart?: InputMaybe<Scalars['Float']['input']>;
};

export type DataCheckResolverReturnType = {
  message?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DefaultFlexLayoutConfigs = {
  BOP?: Maybe<Scalars['MongoID']['output']>;
  KPI?: Maybe<Scalars['MongoID']['output']>;
  REPORT?: Maybe<Scalars['MongoID']['output']>;
  RUNSHEET?: Maybe<Scalars['MongoID']['output']>;
  SETUPOVERVIEW?: Maybe<Scalars['MongoID']['output']>;
  SETUPSANDBOX?: Maybe<Scalars['MongoID']['output']>;
  SETUPSHEET?: Maybe<Scalars['MongoID']['output']>;
  SIMULATION?: Maybe<Scalars['MongoID']['output']>;
};

export type DefaultFlexLayoutConfigsInput = {
  BOP?: InputMaybe<Scalars['MongoID']['input']>;
  KPI?: InputMaybe<Scalars['MongoID']['input']>;
  REPORT?: InputMaybe<Scalars['MongoID']['input']>;
  RUNSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPOVERVIEW?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSANDBOX?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SIMULATION?: InputMaybe<Scalars['MongoID']['input']>;
};

export type Density = {
  /** kg/m³ */
  kilogramsPerCubicMetre: Scalars['Float']['output'];
  /** kg/L */
  kilogramsPerLitre: Scalars['Float']['output'];
  /** lb/ft³ */
  poundsPerCubicFoot: Scalars['Float']['output'];
};

export type DensityInput = {
  /** kg/m³ */
  kilogramsPerCubicMetre?: InputMaybe<Scalars['Float']['input']>;
  /** kg/L */
  kilogramsPerLitre?: InputMaybe<Scalars['Float']['input']>;
  /** lb/ft³ */
  poundsPerCubicFoot?: InputMaybe<Scalars['Float']['input']>;
};

export type Department = {
  _id: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
};

/** List of items with pagination. */
export type DepartmentPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Department>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type DifferentialConfig = {
  /** Is this differential config allowed to be selected in new car setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  frictionFaces?: Maybe<Scalars['String']['output']>;
  maxPreloadForce?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  rampAccel?: Maybe<Scalars['Float']['output']>;
  rampDecel?: Maybe<Scalars['Float']['output']>;
  simulationModels?: Maybe<Scalars['JSON']['output']>;
};

export type DifferentialConfigInput = {
  /** Is this differential config allowed to be selected in new car setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  maxPreloadForce?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  rampAccel?: InputMaybe<Scalars['Float']['input']>;
  rampDecel?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type DifferentialSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  differentialConfigs?: Maybe<Array<Maybe<DifferentialConfig>>>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<DifferentialSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  powertrainLocation?: Maybe<EnumSpecificationPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DoubleCommentBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  field1: Scalars['String']['output'];
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  field2: Scalars['String']['output'];
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  isAlwaysOpen?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  label1: Scalars['String']['output'];
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  label2: Scalars['String']['output'];
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  rows?: Maybe<Scalars['Float']['output']>;
  /** @deprecated The DoubleCommentBlock has been deprecated with the introduction of the CSS grid layout system. */
  title: Scalars['String']['output'];
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type DriverChampionshipStanding = {
  acronym?: Maybe<Scalars['String']['output']>;
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  driver?: Maybe<Person>;
  driverID?: Maybe<Scalars['MongoID']['output']>;
  points: Scalars['Int']['output'];
  /** Historical race finish positions of this driver in this season. Null values represent DNFs. Should only be used for pre-session standings data. */
  prevRacePositions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: Maybe<Scalars['Int']['output']>;
  startNumber?: Maybe<Scalars['String']['output']>;
};

export type DriverChampionshipStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  points: Scalars['Int']['input'];
  /** Historical race finish positions of this driver in this season. Null values represent DNFs. Should only be used for pre-session standings data. */
  prevRacePositions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DriverTiming = {
  bestLapTime?: Maybe<Scalars['Float']['output']>;
  bestLapTimeInLapNum?: Maybe<Scalars['Int']['output']>;
  contestant?: Maybe<Contestant>;
  contestantID: Scalars['String']['output'];
  currentLapNum?: Maybe<Scalars['Int']['output']>;
  currentLapTime?: Maybe<Scalars['Float']['output']>;
  currentSectorTimings: Array<DriverTimingSectorTiming>;
  /** @deprecated Use `currentLapNum` instead. */
  currentlapNum?: Maybe<Scalars['Int']['output']>;
  differenceToLastLapTime?: Maybe<Scalars['Float']['output']>;
  gapToDriverAhead?: Maybe<Scalars['Float']['output']>;
  gapToDriverAheadChange: Scalars['Float']['output'];
  gapToDriverAheadInClass?: Maybe<Scalars['Float']['output']>;
  gapToDriverAheadInClassChange: Scalars['Float']['output'];
  gapToFirstDriver?: Maybe<Scalars['Float']['output']>;
  gapToFirstDriverChange: Scalars['Float']['output'];
  gapToFirstDriverInClass?: Maybe<Scalars['Float']['output']>;
  gapToFirstDriverInClassChange: Scalars['Float']['output'];
  isBestSessionLapTime: Scalars['Boolean']['output'];
  isOwnBestLapTime: Scalars['Boolean']['output'];
  pitThroughCount: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  positionInClass: Scalars['Int']['output'];
  speedTrapSpeed?: Maybe<Scalars['Float']['output']>;
  startNumber: Scalars['String']['output'];
  tyres?: Maybe<Scalars['String']['output']>;
};

export type DriverTimingSectorTiming = {
  isOwnBest: Scalars['Boolean']['output'];
  isSessionBest: Scalars['Boolean']['output'];
  lapNum: Scalars['Int']['output'];
  speed?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

export type DroopStop = {
  name?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<ElasticSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  xDroopStopGap?: Maybe<Scalars['Float']['output']>;
};

export type DroopStopInput = {
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  xDroopStopGap?: InputMaybe<Scalars['Float']['input']>;
};

export type DynoConfig = {
  _id: Scalars['MongoID']['output'];
  columns?: Maybe<Array<Maybe<DynoConfigColumns>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DynoConfigColumns = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** runSheet.tyreSetID, setup.mCar, etc. */
  fieldKey?: Maybe<Scalars['String']['output']>;
  /** Tyre, Weight, etc. */
  header?: Maybe<Scalars['String']['output']>;
};

export type DynoConfigColumnsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** runSheet.tyreSetID, setup.mCar, etc. */
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Tyre, Weight, etc. */
  header?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type DynoConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<DynoConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ElasticSpec = AnySpecification & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Names of sockets that this can be plugged in to.
   * @deprecated
   */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  elasticType?: Maybe<EnumElasticType>;
  forceTable?: Maybe<ForceTable>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<ElasticSpec>;
  /** Spring constant of the elastic element. */
  kSpring?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<EnumReadingLocation>>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  xBumpStopGapDefault?: Maybe<Scalars['Float']['output']>;
  xDamperSetupDefault?: Maybe<Scalars['Float']['output']>;
  xDroopStopGapDefault?: Maybe<Scalars['Float']['output']>;
  /** Length of the elastic element under no force */
  xFree?: Maybe<Scalars['Float']['output']>;
};

export type Energy = {
  /** J */
  joules: Scalars['Float']['output'];
  /** kJ */
  kilojoules: Scalars['Float']['output'];
  /** kWh */
  kilowattHours: Scalars['Float']['output'];
  /** MJ */
  megajoules: Scalars['Float']['output'];
  /** Wh */
  wattHours: Scalars['Float']['output'];
};

export type EnergyInput = {
  /** J */
  joules?: InputMaybe<Scalars['Float']['input']>;
  /** kJ */
  kilojoules?: InputMaybe<Scalars['Float']['input']>;
  /** kWh */
  kilowattHours?: InputMaybe<Scalars['Float']['input']>;
  /** MJ */
  megajoules?: InputMaybe<Scalars['Float']['input']>;
  /** Wh */
  wattHours?: InputMaybe<Scalars['Float']['input']>;
};

export type EnergyUnitField = {
  unit: EnumEnergyUnit;
};

export type EnumAccelerationUnit =
  | 'FEET_PER_SECOND_SQUARED'
  | 'GFORCE'
  | 'METRES_PER_SECOND_SQUARED';

export type EnumAdjustablePropertyType =
  | 'ACCELERATION'
  | 'ANGLE'
  | 'ANGULAR_COMPLIANCE'
  | 'ANGULAR_TORQUE_COMPLIANCE'
  | 'BOOLEAN'
  | 'COMPLIANCE'
  | 'FORCE'
  | 'INERTIA'
  | 'LENGTH'
  | 'LOCATION'
  | 'MASS'
  | 'NUMBER'
  | 'ORIENTATION'
  | 'POWER'
  | 'PRESSURE'
  | 'RATIO'
  | 'SPRING_RATE'
  | 'STEERING_RACK_RATIO'
  | 'STRING'
  | 'TEMPERATURE'
  | 'TORQUE'
  | 'TORSION_RATE'
  | 'VOLUME';

export type EnumAeroElementInterpolationMethod =
  | 'AFLAP'
  | 'CLOSEST'
  | 'LINEAR'
  | 'NONE'
  | 'POLYNOMIAL'
  | 'SPLINE';

export type EnumAeroElementType =
  | 'INTERPOLATE'
  | 'POLYNOMIAL'
  | 'STRICT';

export type EnumAngleUnit =
  | 'DEGREES'
  | 'MINUTES'
  | 'RADIANS';

export type EnumAngularAccelerationUnit =
  | 'DEGREES_PER_SECOND_SQUARED'
  | 'RADIANS_PER_SECOND_SQUARED';

export type EnumAngularComplianceUnit =
  | 'DEGREES_PER_POUND'
  | 'RADIANS_PER_NEWTON';

export type EnumAngularTorqueComplianceUnit =
  | 'DEGREES_PER_FOOT_POUND'
  | 'RADIANS_PER_NEWTON_METRE';

export type EnumAngularVelocityUnit =
  | 'DEGREES_PER_SECOND'
  | 'RADIANS_PER_SECOND';

export type EnumAntiRollBarDisplayLocation =
  | 'FRONT'
  | 'REAR';

/** Specify where the part type should be added in */
export type EnumAssemblyTemplateRequiredPartsLocation =
  | 'CENTER'
  | 'ENGINE_IN'
  | 'ENGINE_OUT'
  | 'FRONT'
  | 'FRONT_LEFT'
  | 'FRONT_LEFT_FORWARD'
  | 'FRONT_LEFT_INNER'
  | 'FRONT_LEFT_LCA_FWD'
  | 'FRONT_LEFT_LCA_RWD'
  | 'FRONT_LEFT_LOWER'
  | 'FRONT_LEFT_OUTER'
  | 'FRONT_LEFT_PUSHROD'
  | 'FRONT_LEFT_REARWARD'
  | 'FRONT_LEFT_TIEROD'
  | 'FRONT_LEFT_UCA_FWD'
  | 'FRONT_LEFT_UCA_RWD'
  | 'FRONT_LEFT_UPPER'
  | 'FRONT_PRIMARY'
  | 'FRONT_RIGHT'
  | 'FRONT_RIGHT_FORWARD'
  | 'FRONT_RIGHT_INNER'
  | 'FRONT_RIGHT_LCA_FWD'
  | 'FRONT_RIGHT_LCA_RWD'
  | 'FRONT_RIGHT_LOWER'
  | 'FRONT_RIGHT_OUTER'
  | 'FRONT_RIGHT_PUSHROD'
  | 'FRONT_RIGHT_REARWARD'
  | 'FRONT_RIGHT_TIEROD'
  | 'FRONT_RIGHT_UCA_FWD'
  | 'FRONT_RIGHT_UCA_RWD'
  | 'FRONT_RIGHT_UPPER'
  | 'FRONT_SECONDARY'
  | 'GBX_IN'
  | 'GBX_OUT'
  | 'INPUT'
  | 'LEFT'
  | 'MGU_IN'
  | 'MGU_OUT'
  | 'OUTPUT'
  | 'PRIMARY'
  | 'REAR'
  | 'REAR_LEFT'
  | 'REAR_LEFT_FORWARD'
  | 'REAR_LEFT_INNER'
  | 'REAR_LEFT_LCA_FWD'
  | 'REAR_LEFT_LCA_RWD'
  | 'REAR_LEFT_LOWER'
  | 'REAR_LEFT_OUTER'
  | 'REAR_LEFT_PUSHROD'
  | 'REAR_LEFT_REARWARD'
  | 'REAR_LEFT_TIEROD'
  | 'REAR_LEFT_UCA_FWD'
  | 'REAR_LEFT_UCA_RWD'
  | 'REAR_LEFT_UPPER'
  | 'REAR_PRIMARY'
  | 'REAR_RIGHT'
  | 'REAR_RIGHT_FORWARD'
  | 'REAR_RIGHT_INNER'
  | 'REAR_RIGHT_LCA_FWD'
  | 'REAR_RIGHT_LCA_RWD'
  | 'REAR_RIGHT_LOWER'
  | 'REAR_RIGHT_OUTER'
  | 'REAR_RIGHT_PUSHROD'
  | 'REAR_RIGHT_REARWARD'
  | 'REAR_RIGHT_TIEROD'
  | 'REAR_RIGHT_UCA_FWD'
  | 'REAR_RIGHT_UCA_RWD'
  | 'REAR_RIGHT_UPPER'
  | 'REAR_SECONDARY'
  | 'RIGHT'
  | 'SECONDARY'
  | 'SINGLE'
  | 'STEERING_COLUMN'
  | 'STEERING_RACK'
  | 'STEERING_SHAFT';

export type EnumAssemblyType =
  | 'CHASSIS'
  | 'SUB_ASSEMBLY';

export type EnumAxle =
  | 'FRONT'
  | 'REAR';

/** ORH will use the users timezone selection to format times accordingly */
export type EnumBehaviourConfigTimezoneSelect =
  | 'LAPTOP'
  | 'TRACK'
  | 'UTC';

export type EnumBrakeBlockField =
  | 'POST_RUN_BRAKE_TEMPS'
  | 'POST_RUN_THICKNESS'
  | 'PRE_RUN_BRAKE_TEMPS'
  | 'PRE_RUN_THICKNESS';

export type EnumBuildSheetStyleTargetEventType =
  | 'AEROTEST'
  | 'ANY'
  | 'OVAL'
  | 'ROADCOURSE';

export type EnumBuildSheetStyleTargetRoles =
  | 'ADMIN'
  | 'CAR_ENGINEER'
  | 'CHIEF_ENGINEER'
  | 'DRIVER'
  | 'FAULT_ADMIN'
  | 'MANAGEMENT'
  | 'MECHANIC'
  | 'READ_ONLY'
  | 'SETUP_REVIEWER'
  | 'TYRE_ENGINEER'
  | 'WORKSHOP_MANAGEMENT';

export type EnumBuildSheetStyleType =
  | 'FULL'
  | 'MINI'
  | 'SIMULATION';

export type EnumBumpPlateMeasurementMethod =
  | 'ANGLE'
  | 'BOTH'
  | 'LENGTH';

export type EnumBumpStopGapMethod =
  | 'GAP_TO_BASE'
  | 'GAP_TO_TOP'
  | 'PACKER_STACK';

export type EnumCalculationType =
  | 'CAR_SETUP'
  | 'DATA_SERVICE'
  | 'KPI'
  | 'LAP'
  | 'RUN_SHEET';

export type EnumCanopyConfigType =
  | 'CAR'
  | 'TRACK'
  | 'WEATHER';

export type EnumCarDataServiceApplicationSettingsConfigRunsheetMatching =
  | 'DATA_INGEST'
  | 'RUNNUMBER'
  | 'STANDARD'
  | 'TIMESTAMP';

export type EnumCarDataServicePitstopTriggerType =
  | 'EDGE'
  | 'VALUE';

export type EnumCarDataServiceProcessingEngineConfigImporter =
  | 'AIM_IMPORTER'
  | 'ATLAS10_IMPORTER'
  | 'ATLAS10_NOSSV_IMPORTER'
  | 'ATLAS_IMPORTER'
  | 'DARAB_IMPORTER'
  | 'PITOOLBOX_IMPORTER'
  | 'SERVOTEST_IMPORTER'
  | 'TXT_IMPORTER'
  | 'WINTAX_IMPORTER';

export type EnumCarSetupIntendedForSession =
  | 'Aerotest'
  | 'Custom'
  | 'Dyno'
  | 'Free_Practice'
  | 'Pre_Event'
  | 'Qualifying'
  | 'Race'
  | 'Simulation'
  | 'Test';

/** Override of setup sheet style, which usually comes from the chassis. */
export type EnumCarSetupSetupSheetStyle =
  | 'AMGGT3C190'
  | 'AMGGT3C190HRT'
  | 'AMGGT4C190'
  | 'F218_2018'
  | 'F218_2020'
  | 'F319'
  | 'FLEX'
  | 'GDRIVE_ORECA_LMP2'
  | 'MBFES07'
  | 'MCLAREN_FES09'
  | 'MCLAREN_XE'
  | 'PHMT318'
  | 'PHMT421'
  | 'TATUUS_T318'
  | 'TATUUS_T421';

export type EnumChassisMeasurementsKinematicsExternalReadingsRequired =
  | 'CONTROL_ARM'
  | 'CORNERS'
  | 'CORNER_FORWARD_REARWARD'
  | 'CORNER_INNER_OUTER'
  | 'CORNER_LOWER_UPPER'
  | 'FRONT_REAR'
  | 'FRONT_REAR_PRIMARY_SECONDARY'
  | 'INPUT_CENTER_OUTPUT'
  | 'LEFT_RIGHT'
  | 'POWERTRAIN'
  | 'PRIMARY_SECONDARY'
  | 'SINGLE'
  | 'SUSPENSION_MEMBER';

export type EnumChassisMeasurementsKinematicsInternalReadingsRequired =
  | 'CONTROL_ARM'
  | 'CORNERS'
  | 'CORNER_FORWARD_REARWARD'
  | 'CORNER_INNER_OUTER'
  | 'CORNER_LOWER_UPPER'
  | 'FRONT_REAR'
  | 'FRONT_REAR_PRIMARY_SECONDARY'
  | 'INPUT_CENTER_OUTPUT'
  | 'LEFT_RIGHT'
  | 'POWERTRAIN'
  | 'PRIMARY_SECONDARY'
  | 'SINGLE'
  | 'SUSPENSION_MEMBER';

export type EnumChassisSetupSheetStyle =
  | 'AMGGT3C190'
  | 'AMGGT3C190HRT'
  | 'AMGGT4C190'
  | 'F218_2018'
  | 'F218_2020'
  | 'F319'
  | 'FLEX'
  | 'GDRIVE_ORECA_LMP2'
  | 'MBFES07'
  | 'MCLAREN_FES09'
  | 'MCLAREN_XE'
  | 'PHMT318'
  | 'PHMT421'
  | 'TATUUS_T318'
  | 'TATUUS_T421';

export type EnumCommentBlockField =
  | 'brakeComment'
  | 'controlsComment'
  | 'dilComments'
  | 'driverComments'
  | 'engineerComments'
  | 'performanceComments'
  | 'problemComments'
  | 'runDescription'
  | 'skidComment'
  | 'summaryComments'
  | 'systemsComments'
  | 'tyreComments';

export type EnumComplianceUnit =
  | 'INCHES_PER_POUND_FORCE'
  | 'METRES_PER_NEWTON'
  | 'MILLIMETRES_PER_NEWTON';

export type EnumCustomSpecReadingsRequired =
  | 'CONTROL_ARM'
  | 'CORNERS'
  | 'CORNER_FORWARD_REARWARD'
  | 'CORNER_INNER_OUTER'
  | 'CORNER_LOWER_UPPER'
  | 'FRONT_REAR'
  | 'FRONT_REAR_PRIMARY_SECONDARY'
  | 'INPUT_CENTER_OUTPUT'
  | 'LEFT_RIGHT'
  | 'POWERTRAIN'
  | 'PRIMARY_SECONDARY'
  | 'SINGLE'
  | 'SUSPENSION_MEMBER';

export type EnumDataCheck =
  | 'ASSEMBLY_IDS_NULL';

export type EnumDisplayUnit =
  | 'BAR'
  | 'CELSIUS'
  | 'CENTIMETRES'
  | 'DAYS'
  | 'DEGREES'
  | 'DEGREES_PER_FOOT_POUND'
  | 'DEGREES_PER_INCHES'
  | 'DEGREES_PER_MILLIMETRES'
  | 'DEGREES_PER_POUND'
  | 'DEGREES_PER_SECOND'
  | 'DEGREES_PER_SECOND_SQUARED'
  | 'FAHRENHEIT'
  | 'FEET'
  | 'FEET_PER_SECOND'
  | 'FEET_PER_SECOND_SQUARED'
  | 'GALLONS'
  | 'GFORCE'
  | 'GRAMS'
  | 'HORSEPOWER_MECHANICAL'
  | 'HOURS'
  | 'INCHES'
  | 'INCHES_OF_MERCURY'
  | 'INCHES_PER_POUND_FORCE'
  | 'JOULES'
  | 'KELVIN'
  | 'KILOGRAMS'
  | 'KILOGRAM_METRES_SQUARED'
  | 'KILOJOULES'
  | 'KILOMETRES'
  | 'KILOMETRES_PER_HOUR'
  | 'KILOPASCALS'
  | 'KILOWATTS'
  | 'KILOWATT_HOURS'
  | 'LITRES'
  | 'METRES'
  | 'METRES_CUBED'
  | 'METRES_PER_NEWTON'
  | 'METRES_PER_SECOND'
  | 'METRES_PER_SECOND_SQUARED'
  | 'MICROMETRES'
  | 'MILES'
  | 'MILES_PER_HOUR'
  | 'MILLIBAR'
  | 'MILLIGRAMS'
  | 'MILLILITRES'
  | 'MILLIMETRES'
  | 'MILLIMETRES_PER_NEWTON'
  | 'MILLISECONDS'
  | 'MINUTES'
  | 'NEWTONS'
  | 'NEWTONS_PER_METRE'
  | 'NEWTONS_PER_MILLIMETRE'
  | 'NEWTON_METRES'
  | 'NEWTON_METRES_PER_DEGREE'
  | 'NEWTON_METRES_PER_RADIAN'
  | 'NEWTON_MILLIMETRES'
  | 'NONE'
  | 'NUMBER'
  | 'OUNCES'
  | 'PASCALS'
  | 'PERCENT'
  | 'POUNDS'
  | 'POUNDS_FEET_PER_DEGREE'
  | 'POUNDS_FEET_PER_RADIAN'
  | 'POUNDS_FORCE'
  | 'POUNDS_INCHES_PER_DEGREE'
  | 'POUNDS_INCHES_PER_RADIAN'
  | 'POUNDS_PER_INCH'
  | 'POUND_FOOT_ENERGY'
  | 'POUND_FOOT_SECONDS_SQUARED'
  | 'POUND_FORCE_FEET'
  | 'POUND_FORCE_INCHES'
  | 'PSI'
  | 'RADIANS'
  | 'RADIANS_PER_NEWTON'
  | 'RADIANS_PER_NEWTON_METRE'
  | 'RADIANS_PER_SECOND'
  | 'RADIANS_PER_SECOND_SQUARED'
  | 'RATIO'
  | 'SECONDS'
  | 'STRING'
  | 'THOU'
  | 'WATTS';

export type EnumElasticType =
  | 'BUMP_RUBBER'
  | 'HELPER_SPRING'
  | 'REBOUND_SPRING'
  | 'SPRING'
  | 'TORSION_BAR';

export type EnumEnergyType =
  | 'COMBUSTION'
  | 'ELECTRIC';

export type EnumEnergyUnit =
  | 'JOULES'
  | 'KILOJOULES'
  | 'KILOWATT_HOURS'
  | 'POUND_FOOT_ENERGY';

export type EnumEventDebriefNotesMode =
  | 'markdown'
  | 'table';

export type EnumEventEnumEventType =
  | 'AERO'
  | 'DYNO'
  | 'MEDIA'
  | 'OTHER'
  | 'RACE'
  | 'SIMULATOR'
  | 'TEST';

export type EnumEventEnumEventVenue =
  | 'DIRT'
  | 'DYNO'
  | 'OTHER'
  | 'OVAL'
  | 'TRACK';

export type EnumEventReferenceLaptimesCalculationMethod =
  | 'RATIO'
  | 'TIME';

export type EnumEventType =
  | 'AERO'
  | 'DYNO'
  | 'MEDIA'
  | 'OTHER'
  | 'RACE'
  | 'SIMULATOR'
  | 'TEST';

export type EnumFlexLayoutConfigGlobalXAxisType =
  | 'DATA'
  | 'TIME';

export type EnumFlexLayoutConfigIntendedFor =
  | 'BOP'
  | 'KPI'
  | 'REPORT'
  | 'RUNSHEET'
  | 'SETUPOVERVIEW'
  | 'SETUPSANDBOX'
  | 'SETUPSHEET'
  | 'SIMULATION';

export type EnumForceUnit =
  | 'NEWTONS'
  | 'POUNDS_FORCE';

export type EnumFuelColumn =
  | 'ENERGY_TYPE'
  | 'EXTENDED_CONSUMPTION'
  | 'FUEL_DENSITY';

export type EnumGearType =
  | 'BEVEL_SET'
  | 'DROP_GEAR'
  | 'STANDARD';

export type EnumGenericRunSheetStyleBlockEnergyFieldOrder =
  | 'ATTACK'
  | 'COOL'
  | 'FCY'
  | 'IN'
  | 'OUT'
  | 'OUTIN'
  | 'PITLANE'
  | 'PREP'
  | 'PUSH'
  | 'QUALI'
  | 'SAFETYCAR'
  | 'SHAKEDOWN'
  | 'SLOW'
  | 'TARGET'
  | 'TOGRID'
  | 'TOPADDOCK'
  | 'TOPITS'
  | 'UNFINISHED';

export type EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField =
  | 'ATTACK'
  | 'COOL'
  | 'FCY'
  | 'GREEN'
  | 'IN'
  | 'NOTGREEN'
  | 'OUT'
  | 'OUTIN'
  | 'PITLANE'
  | 'PREP'
  | 'PUSH'
  | 'QUALI'
  | 'SAFETYCAR'
  | 'SHAKEDOWN'
  | 'SLOW'
  | 'TARGET'
  | 'TOGRID'
  | 'TOPADDOCK'
  | 'TOPITS'
  | 'UNFINISHED';

export type EnumGenericRunSheetStyleBlockType =
  | 'BLANKING'
  | 'BRAKES'
  | 'COMMENT'
  | 'DOUBLE_COMMENT'
  | 'FUEL'
  | 'ISSUE'
  | 'JOB_LIST'
  | 'LAP_TABLE'
  | 'LAP_TIME_THRESHOLDS'
  | 'LAP_TYPE_COUNT'
  | 'MINI_JOBLIST'
  | 'POST_RUN_MEASUREMENT'
  | 'RUN_KPI_TABLE'
  | 'SETUP_CHANGES'
  | 'SETUP_SHEET'
  | 'TYRE_TABLE'
  | 'WEATHER_BOX';

/** Only "Point" is supported */
export type EnumGeoLocationType =
  | 'Point';

export type EnumHistoryType =
  | 'CARSETUP'
  | 'RUNSHEET';

export type EnumInertiaUnit =
  | 'KILOGRAM_METRES_SQUARED'
  | 'POUND_FOOT_SECONDS_SQUARED';

export type EnumIssueIssueStatus =
  | 'CLOSED'
  | 'CLOSURE_REQUESTED'
  | 'CONTAINED_BY_DESIGN'
  | 'CONTAINED_BY_OPERATIONS'
  | 'CONTAINED_BY_PROCESS'
  | 'OPEN'
  | 'RESPONSIBLE_ASSIGNED';

export type EnumIssuePriority =
  | 'HIGH'
  | 'LOW'
  | 'MAXIMUM'
  | 'MEDIUM'
  | 'NONE'
  | 'PRIO1_MAXIMUM'
  | 'PRIO2_HIGH'
  | 'PRIO3_MEDIUM'
  | 'PRIO4_LOW'
  | 'PRIO5_NONE';

export type EnumIssueQueryIssueStatus =
  | 'CLOSED'
  | 'CLOSURE_REQUESTED'
  | 'CONTAINED_BY_DESIGN'
  | 'CONTAINED_BY_OPERATIONS'
  | 'CONTAINED_BY_PROCESS'
  | 'OPEN'
  | 'RESPONSIBLE_ASSIGNED';

export type EnumIssueQueryPriority =
  | 'HIGH'
  | 'LOW'
  | 'MAXIMUM'
  | 'MEDIUM'
  | 'NONE'
  | 'PRIO1_MAXIMUM'
  | 'PRIO2_HIGH'
  | 'PRIO3_MEDIUM'
  | 'PRIO4_LOW'
  | 'PRIO5_NONE';

export type EnumJobPriority =
  | 'HIGH'
  | 'LOW'
  | 'MAXIMUM'
  | 'MEDIUM'
  | 'NONE'
  | 'PRIO1_MAXIMUM'
  | 'PRIO2_HIGH'
  | 'PRIO3_MEDIUM'
  | 'PRIO4_LOW'
  | 'PRIO5_NONE';

/** If job is intended as a sub-task then it either belongs to an Issue or a Job. This field prevents making unnecesary database calls when assigning the sub-tasks' ID to it's parent */
export type EnumJobTarget =
  | 'ISSUE'
  | 'JOB'
  | 'JOB_SUBTASK';

export type EnumKinematicsInternalReference =
  | 'DROOP'
  | 'FORCE'
  | 'REF'
  | 'STATIC';

export type EnumLapColumnField =
  | 'DAYTIME'
  | 'DRIVER_CALLOUT'
  | 'DRIVER_CALLOUT2'
  | 'ENERGY_CONSUMPTION_LAP'
  | 'ENERGY_LAP_DATA'
  | 'ENERGY_LAP_END'
  | 'ENERGY_LAP_END_DATA'
  | 'ENERGY_LAP_START'
  | 'ENERGY_REMAINING_PUSH_LAP'
  | 'FUEL_CONSUMPTION_LAP'
  | 'FUEL_LAP_DATA'
  | 'FUEL_LAP_END'
  | 'FUEL_LAP_END_DATA'
  | 'FUEL_LAP_START'
  | 'FUEL_REMAINING_PUSH_LAP'
  | 'FUEL_VOLUME_CONSUMPTION_LAP'
  | 'FUEL_VOLUME_LAP_END'
  | 'FUEL_VOLUME_LAP_START'
  | 'FUEL_VOLUME_REMAINING_PUSH_LAP'
  | 'LAPCOMMENT'
  | 'LAPCOMMENTSYSTEMS'
  | 'LAPKPI'
  | 'LAPTIME'
  | 'LAPTYPE'
  | 'NLAPRUN'
  | 'NLAPSESSION'
  | 'NLAPSTINT'
  | 'POSITION'
  | 'POWER_MODE'
  | 'RACECONTROLMESSAGE'
  | 'SECTORSPEEDS'
  | 'SECTORTIMES'
  | 'SESSION_TIME_REMAINING'
  | 'SOC_CONSUMPTION_LAP'
  | 'SOC_LAP_DATA'
  | 'SOC_LAP_END'
  | 'SOC_LAP_END_DATA'
  | 'SOC_LAP_START'
  | 'SOC_REMAINING_PUSH_LAP'
  | 'TCELL'
  | 'TOPSPEED'
  | 'TRACK_LAYOUT'
  | 'TYRECOMPOUND';

/** Source of the lap data */
export type EnumLapDataSource =
  | 'CAR_DATA_SERVICE'
  | 'LAPTIME_SERVICE'
  | 'MANUAL';

export type EnumLapDataSourceType =
  | 'CAR_DATA_SERVICE'
  | 'LAPTIME_SERVICE'
  | 'MANUAL';

export type EnumLapSequenceLapsLapType =
  | 'ATTACK'
  | 'COOL'
  | 'FCY'
  | 'IN'
  | 'OUT'
  | 'OUTIN'
  | 'PITLANE'
  | 'PREP'
  | 'PUSH'
  | 'QUALI'
  | 'SAFETYCAR'
  | 'SHAKEDOWN'
  | 'SLOW'
  | 'TARGET'
  | 'TOGRID'
  | 'TOPADDOCK'
  | 'TOPITS'
  | 'UNFINISHED';

export type EnumLapSequenceTemplateLapsLapType =
  | 'ATTACK_LAP'
  | 'GARAGE'
  | 'PREP_LAP'
  | 'PUSH'
  | 'QUALI'
  | 'SLOW_LAP'
  | 'TARGET_LAP'
  | 'WAIT';

export type EnumLapType =
  | 'ATTACK'
  | 'COOL'
  | 'FCY'
  | 'IN'
  | 'OUT'
  | 'OUTIN'
  | 'PITLANE'
  | 'PREP'
  | 'PUSH'
  | 'QUALI'
  | 'SAFETYCAR'
  | 'SHAKEDOWN'
  | 'SLOW'
  | 'TARGET'
  | 'TOGRID'
  | 'TOPADDOCK'
  | 'TOPITS'
  | 'UNFINISHED';

export type EnumLengthUnit =
  | 'CENTIMETRES'
  | 'FEET'
  | 'INCHES'
  | 'KILOMETRES'
  | 'METRES'
  | 'MICROMETRES'
  | 'MILES'
  | 'MILLIMETRES'
  | 'THOU';

export type EnumLineStyle =
  | 'DASHED'
  | 'DASH_DOT'
  | 'DOTTED'
  | 'NONE'
  | 'SOLID';

export type EnumLiveStandingCurrentLocation =
  | 'PIT'
  | 'TRACK';

export type EnumLocalConnectionDataMapping =
  | 'Flat'
  | 'Standard';

export type EnumLogLevel =
  | 'CRITICAL'
  | 'DEBUG'
  | 'ERROR'
  | 'INFO'
  | 'WARNING';

export type EnumLogLogLevel =
  | 'CRITICAL'
  | 'DEBUG'
  | 'ERROR'
  | 'INFO'
  | 'WARNING';

export type EnumLogServiceSource =
  | 'CANOPY'
  | 'CUSTOM_SIMULATION'
  | 'TIMING'
  | 'WEATHER_STATION';

export type EnumMarkerStyle =
  | 'CIRCLE'
  | 'DIAMOND'
  | 'HEXAGON'
  | 'NONE'
  | 'PENTAGON'
  | 'SQUARE'
  | 'TRIANGLE'
  | 'X_MARK';

export type EnumMassUnit =
  | 'GRAMS'
  | 'KILOGRAMS'
  | 'MILLIGRAMS'
  | 'OUNCES'
  | 'POUNDS';

export type EnumMeCarUpdateMethod =
  | 'FORWARD_PROPAGATE'
  | 'STANDARD';

export type EnumMigration =
  | 'carSetupMissingTitle'
  | 'eventContestantsDedup'
  | 'issuePriority'
  | 'lapPitOutAndInTimeStamps'
  | 'lapSessionID'
  | 'lapsToCollection'
  | 'manualMileageCustomToCarSetup'
  | 'readingsAllowableDamperElasticSpec'
  | 'rootSpecificationID'
  | 'runDistanceTrackingItemsCumulativeCalculation'
  | 'runSheetAndLapTimeStamps'
  | 'sessionTypeToEnum'
  | 'setupSheetStyleTabs'
  | 'setupTimingServiceStatus'
  | 'teamsToTeamIDsOnPart'
  | 'trackingSourcesAndItems'
  | 'trackingUpdate202506';

export type EnumOneTimingWeatherServiceConfigLogLevel =
  | 'CRITICAL'
  | 'DEBUG'
  | 'ERROR'
  | 'INFO'
  | 'NOTSET'
  | 'WARNING';

export type EnumPackageMethod =
  | 'DELTA'
  | 'VALUE';

export type EnumPartEligibleEventTypes =
  | 'AERO'
  | 'ALL'
  | 'DYNO'
  | 'MEDIA'
  | 'OTHER'
  | 'RACE'
  | 'SIMULATOR'
  | 'TEST';

export type EnumPartReadingLocationOverride =
  | 'CENTER'
  | 'ENGINE_IN'
  | 'ENGINE_OUT'
  | 'FRONT'
  | 'FRONT_LEFT'
  | 'FRONT_LEFT_FORWARD'
  | 'FRONT_LEFT_INNER'
  | 'FRONT_LEFT_LCA_FWD'
  | 'FRONT_LEFT_LCA_RWD'
  | 'FRONT_LEFT_LOWER'
  | 'FRONT_LEFT_OUTER'
  | 'FRONT_LEFT_PUSHROD'
  | 'FRONT_LEFT_REARWARD'
  | 'FRONT_LEFT_TIEROD'
  | 'FRONT_LEFT_UCA_FWD'
  | 'FRONT_LEFT_UCA_RWD'
  | 'FRONT_LEFT_UPPER'
  | 'FRONT_PRIMARY'
  | 'FRONT_RIGHT'
  | 'FRONT_RIGHT_FORWARD'
  | 'FRONT_RIGHT_INNER'
  | 'FRONT_RIGHT_LCA_FWD'
  | 'FRONT_RIGHT_LCA_RWD'
  | 'FRONT_RIGHT_LOWER'
  | 'FRONT_RIGHT_OUTER'
  | 'FRONT_RIGHT_PUSHROD'
  | 'FRONT_RIGHT_REARWARD'
  | 'FRONT_RIGHT_TIEROD'
  | 'FRONT_RIGHT_UCA_FWD'
  | 'FRONT_RIGHT_UCA_RWD'
  | 'FRONT_RIGHT_UPPER'
  | 'FRONT_SECONDARY'
  | 'GBX_IN'
  | 'GBX_OUT'
  | 'INPUT'
  | 'LEFT'
  | 'MGU_IN'
  | 'MGU_OUT'
  | 'OUTPUT'
  | 'PRIMARY'
  | 'REAR'
  | 'REAR_LEFT'
  | 'REAR_LEFT_FORWARD'
  | 'REAR_LEFT_INNER'
  | 'REAR_LEFT_LCA_FWD'
  | 'REAR_LEFT_LCA_RWD'
  | 'REAR_LEFT_LOWER'
  | 'REAR_LEFT_OUTER'
  | 'REAR_LEFT_PUSHROD'
  | 'REAR_LEFT_REARWARD'
  | 'REAR_LEFT_TIEROD'
  | 'REAR_LEFT_UCA_FWD'
  | 'REAR_LEFT_UCA_RWD'
  | 'REAR_LEFT_UPPER'
  | 'REAR_PRIMARY'
  | 'REAR_RIGHT'
  | 'REAR_RIGHT_FORWARD'
  | 'REAR_RIGHT_INNER'
  | 'REAR_RIGHT_LCA_FWD'
  | 'REAR_RIGHT_LCA_RWD'
  | 'REAR_RIGHT_LOWER'
  | 'REAR_RIGHT_OUTER'
  | 'REAR_RIGHT_PUSHROD'
  | 'REAR_RIGHT_REARWARD'
  | 'REAR_RIGHT_TIEROD'
  | 'REAR_RIGHT_UCA_FWD'
  | 'REAR_RIGHT_UCA_RWD'
  | 'REAR_RIGHT_UPPER'
  | 'REAR_SECONDARY'
  | 'RIGHT'
  | 'SECONDARY'
  | 'SINGLE'
  | 'STEERING_COLUMN'
  | 'STEERING_RACK'
  | 'STEERING_SHAFT';

export type EnumPersonCarUpdateMethod =
  | 'FORWARD_PROPAGATE'
  | 'STANDARD';

export type EnumPersonMileageUnit =
  | 'CENTIMETRES'
  | 'FEET'
  | 'INCHES'
  | 'KILOMETRES'
  | 'METRES'
  | 'MICROMETRES'
  | 'MILES'
  | 'MILLIMETRES'
  | 'THOU';

export type EnumPersonRole =
  | 'ADMIN'
  | 'CAR_ENGINEER'
  | 'CHIEF_ENGINEER'
  | 'DRIVER'
  | 'FAULT_ADMIN'
  | 'MANAGEMENT'
  | 'MECHANIC'
  | 'READ_ONLY'
  | 'SETUP_REVIEWER'
  | 'TYRE_ENGINEER'
  | 'WORKSHOP_MANAGEMENT';

export type EnumPlotConfigXAxisType =
  | 'NUMBER'
  | 'TIME';

export type EnumPossibleUnit =
  | 'BAR'
  | 'CELSIUS'
  | 'CENTIMETRES'
  | 'DAYS'
  | 'DEGREES'
  | 'DEGREES_PER_FOOT_POUND'
  | 'DEGREES_PER_INCHES'
  | 'DEGREES_PER_MILLIMETRES'
  | 'DEGREES_PER_POUND'
  | 'DEGREES_PER_SECOND'
  | 'DEGREES_PER_SECOND_SQUARED'
  | 'FAHRENHEIT'
  | 'FEET'
  | 'FEET_PER_SECOND'
  | 'FEET_PER_SECOND_SQUARED'
  | 'GALLONS'
  | 'GFORCE'
  | 'GRAMS'
  | 'HORSEPOWER_MECHANICAL'
  | 'HOURS'
  | 'INCHES'
  | 'INCHES_OF_MERCURY'
  | 'INCHES_PER_POUND_FORCE'
  | 'JOULES'
  | 'KELVIN'
  | 'KILOGRAMS'
  | 'KILOGRAM_METRES_SQUARED'
  | 'KILOJOULES'
  | 'KILOMETRES'
  | 'KILOMETRES_PER_HOUR'
  | 'KILOPASCALS'
  | 'KILOWATTS'
  | 'KILOWATT_HOURS'
  | 'LITRES'
  | 'METRES'
  | 'METRES_CUBED'
  | 'METRES_PER_NEWTON'
  | 'METRES_PER_SECOND'
  | 'METRES_PER_SECOND_SQUARED'
  | 'MICROMETRES'
  | 'MILES'
  | 'MILES_PER_HOUR'
  | 'MILLIBAR'
  | 'MILLIGRAMS'
  | 'MILLILITRES'
  | 'MILLIMETRES'
  | 'MILLIMETRES_PER_NEWTON'
  | 'MILLISECONDS'
  | 'MINUTES'
  | 'NEWTONS'
  | 'NEWTONS_PER_METRE'
  | 'NEWTONS_PER_MILLIMETRE'
  | 'NEWTON_METRES'
  | 'NEWTON_METRES_PER_DEGREE'
  | 'NEWTON_METRES_PER_RADIAN'
  | 'NEWTON_MILLIMETRES'
  | 'NONE'
  | 'NUMBER'
  | 'OUNCES'
  | 'PASCALS'
  | 'PERCENT'
  | 'POUNDS'
  | 'POUNDS_FEET_PER_DEGREE'
  | 'POUNDS_FEET_PER_RADIAN'
  | 'POUNDS_FORCE'
  | 'POUNDS_INCHES_PER_DEGREE'
  | 'POUNDS_INCHES_PER_RADIAN'
  | 'POUNDS_PER_INCH'
  | 'POUND_FOOT_ENERGY'
  | 'POUND_FOOT_SECONDS_SQUARED'
  | 'POUND_FORCE_FEET'
  | 'POUND_FORCE_INCHES'
  | 'PSI'
  | 'RADIANS'
  | 'RADIANS_PER_NEWTON'
  | 'RADIANS_PER_NEWTON_METRE'
  | 'RADIANS_PER_SECOND'
  | 'RADIANS_PER_SECOND_SQUARED'
  | 'RATIO'
  | 'SECONDS'
  | 'STRING'
  | 'THOU'
  | 'WATTS';

export type EnumPowerUnit =
  | 'HORSEPOWER_MECHANICAL'
  | 'KILOWATTS'
  | 'WATTS';

export type EnumPowertrainLayout =
  | 'F4'
  | 'FF'
  | 'FR'
  | 'M4'
  | 'MR'
  | 'R4'
  | 'RR';

export type EnumPressureOption =
  | 'PARC_FERME_EXPECTED'
  | 'POST_RUN'
  | 'POST_RUN_BLEED'
  | 'SET_DOWN';

export type EnumPressureUnit =
  | 'BAR'
  | 'INCHES_OF_MERCURY'
  | 'KILOPASCALS'
  | 'MILLIBAR'
  | 'PASCALS'
  | 'PSI';

export type EnumQualityCheckActionPriority =
  | 'HIGH'
  | 'LOW'
  | 'MAXIMUM'
  | 'MEDIUM'
  | 'NONE'
  | 'PRIO1_MAXIMUM'
  | 'PRIO2_HIGH'
  | 'PRIO3_MEDIUM'
  | 'PRIO4_LOW'
  | 'PRIO5_NONE';

export type EnumQualityCheckActionStatus =
  | 'COMPLETE'
  | 'ONGOING'
  | 'TODO';

export type EnumRaceSeriesDriversPerCar =
  | 'multiple'
  | 'single';

export type EnumRatioUnit =
  | 'PERCENT'
  | 'RATIO';

export type EnumReadingLocation =
  | 'CENTER'
  | 'ENGINE_IN'
  | 'ENGINE_OUT'
  | 'FRONT'
  | 'FRONT_LEFT'
  | 'FRONT_LEFT_FORWARD'
  | 'FRONT_LEFT_INNER'
  | 'FRONT_LEFT_LCA_FWD'
  | 'FRONT_LEFT_LCA_RWD'
  | 'FRONT_LEFT_LOWER'
  | 'FRONT_LEFT_OUTER'
  | 'FRONT_LEFT_PUSHROD'
  | 'FRONT_LEFT_REARWARD'
  | 'FRONT_LEFT_TIEROD'
  | 'FRONT_LEFT_UCA_FWD'
  | 'FRONT_LEFT_UCA_RWD'
  | 'FRONT_LEFT_UPPER'
  | 'FRONT_PRIMARY'
  | 'FRONT_RIGHT'
  | 'FRONT_RIGHT_FORWARD'
  | 'FRONT_RIGHT_INNER'
  | 'FRONT_RIGHT_LCA_FWD'
  | 'FRONT_RIGHT_LCA_RWD'
  | 'FRONT_RIGHT_LOWER'
  | 'FRONT_RIGHT_OUTER'
  | 'FRONT_RIGHT_PUSHROD'
  | 'FRONT_RIGHT_REARWARD'
  | 'FRONT_RIGHT_TIEROD'
  | 'FRONT_RIGHT_UCA_FWD'
  | 'FRONT_RIGHT_UCA_RWD'
  | 'FRONT_RIGHT_UPPER'
  | 'FRONT_SECONDARY'
  | 'GBX_IN'
  | 'GBX_OUT'
  | 'INPUT'
  | 'LEFT'
  | 'MGU_IN'
  | 'MGU_OUT'
  | 'OUTPUT'
  | 'PRIMARY'
  | 'REAR'
  | 'REAR_LEFT'
  | 'REAR_LEFT_FORWARD'
  | 'REAR_LEFT_INNER'
  | 'REAR_LEFT_LCA_FWD'
  | 'REAR_LEFT_LCA_RWD'
  | 'REAR_LEFT_LOWER'
  | 'REAR_LEFT_OUTER'
  | 'REAR_LEFT_PUSHROD'
  | 'REAR_LEFT_REARWARD'
  | 'REAR_LEFT_TIEROD'
  | 'REAR_LEFT_UCA_FWD'
  | 'REAR_LEFT_UCA_RWD'
  | 'REAR_LEFT_UPPER'
  | 'REAR_PRIMARY'
  | 'REAR_RIGHT'
  | 'REAR_RIGHT_FORWARD'
  | 'REAR_RIGHT_INNER'
  | 'REAR_RIGHT_LCA_FWD'
  | 'REAR_RIGHT_LCA_RWD'
  | 'REAR_RIGHT_LOWER'
  | 'REAR_RIGHT_OUTER'
  | 'REAR_RIGHT_PUSHROD'
  | 'REAR_RIGHT_REARWARD'
  | 'REAR_RIGHT_TIEROD'
  | 'REAR_RIGHT_UCA_FWD'
  | 'REAR_RIGHT_UCA_RWD'
  | 'REAR_RIGHT_UPPER'
  | 'REAR_SECONDARY'
  | 'RIGHT'
  | 'SECONDARY'
  | 'SINGLE'
  | 'STEERING_COLUMN'
  | 'STEERING_RACK'
  | 'STEERING_SHAFT';

export type EnumReportNotePageAppendixNotesMode =
  | 'markdown'
  | 'table';

export type EnumReportNotePageOverviewNotesMode =
  | 'markdown'
  | 'table';

export type EnumReportNotePagePartsNotesMode =
  | 'markdown'
  | 'table';

export type EnumReportNotePageRunPlanNotesMode =
  | 'markdown'
  | 'table';

export type EnumReportNotePageSessionNotesMode =
  | 'markdown'
  | 'table';

export type EnumReportNotesTemplatePageAppendixNotesMode =
  | 'markdown'
  | 'table';

export type EnumReportNotesTemplatePageOverviewNotesMode =
  | 'markdown'
  | 'table';

export type EnumReportNotesTemplatePagePartsNotesMode =
  | 'markdown'
  | 'table';

export type EnumReportNotesTemplatePageRunPlanNotesMode =
  | 'markdown'
  | 'table';

export type EnumReportNotesTemplatePageSessionNotesMode =
  | 'markdown'
  | 'table';

export type EnumReportPage =
  | 'pageAppendix'
  | 'pageOverview'
  | 'pageParts'
  | 'pageRunPlan'
  | 'pageSession';

export type EnumReportTemplateIssuesColumnsField =
  | 'area'
  | 'assignees'
  | 'createdAt'
  | 'createdBy'
  | 'department'
  | 'description'
  | 'descriptionDetails'
  | 'issueStatus'
  | 'number'
  | 'priority'
  | 'tags'
  | 'teams'
  | 'updatedAt';

export type EnumReportTemplateIssuesGroupBy =
  | 'area'
  | 'cat'
  | 'createdBy'
  | 'customer'
  | 'department'
  | 'responsible'
  | 'status'
  | 'tags';

export type EnumReportTemplateRunInfoColumnsField =
  | 'NRunData'
  | 'NRunTiming'
  | 'TAmbient'
  | 'TTrack'
  | 'brakeComment'
  | 'controlsComment'
  | 'dilComments'
  | 'driverAcronym'
  | 'driverComments'
  | 'endTime'
  | 'engineerComments'
  | 'fastestLap'
  | 'info'
  | 'lapcount'
  | 'mFuelRunStart'
  | 'mileage'
  | 'problemComments'
  | 'runDescription'
  | 'skidComment'
  | 'startNumber'
  | 'startTime'
  | 'systemsComments'
  | 'tyreComments'
  | 'tyreSetName';

export type EnumRunEnergyField =
  | 'ATTACK'
  | 'COOL'
  | 'FCY'
  | 'IN'
  | 'OUT'
  | 'OUTIN'
  | 'PITLANE'
  | 'PREP'
  | 'PUSH'
  | 'QUALI'
  | 'SAFETYCAR'
  | 'SHAKEDOWN'
  | 'SLOW'
  | 'TARGET'
  | 'TOGRID'
  | 'TOPADDOCK'
  | 'TOPITS'
  | 'UNFINISHED';

export type EnumRunPlanRunPriority =
  | 'PRIO1_MAXIMUM'
  | 'PRIO2_HIGH'
  | 'PRIO3_MEDIUM'
  | 'PRIO4_LOW'
  | 'PRIO5_NONE';

export type EnumRunSheetKpiStatus =
  | 'AUGMENTATION'
  | 'DATA'
  | 'VTAG';

export type EnumRunSheetStyleBlockStyle =
  | 'F2'
  | 'FE'
  | 'GT'
  | 'LMP2'
  | 'WSERIES';

export type EnumServerSettingsSimulationColoringMethod =
  | 'INHERIT_FROM_RUN'
  | 'OWN_PALETTE';

export type EnumSessionDebriefNotesMode =
  | 'markdown'
  | 'table';

export type EnumSessionType =
  | 'DiL'
  | 'EventSchedule'
  | 'ExternalMeeting'
  | 'FreePractice'
  | 'Info'
  | 'InternalMeeting'
  | 'ParcFerme'
  | 'Qualifying'
  | 'Race'
  | 'SessionNotification'
  | 'Setup'
  | 'Simulation'
  | 'Team'
  | 'Test'
  | 'VirtualMeeting';

export type EnumSetupSheetStyleItemType =
  | 'CHECKBOX'
  | 'INPUT'
  | 'LABEL'
  | 'READONLY_FIELD'
  | 'SELECT'
  | 'SPACER';

export type EnumSetupSheetStyleTabType =
  | 'CHASSIS_MEASUREMENT'
  | 'CUSTOM'
  | 'MASS'
  | 'MILEAGE'
  | 'XE_CALCULATIONS';

export type EnumSetupSheetStyleTargetEventType =
  | 'AEROTEST'
  | 'ANY'
  | 'OVAL'
  | 'ROADCOURSE';

export type EnumSetupSheetStyleType =
  | 'FULL'
  | 'MINI'
  | 'SIMULATION';

export type EnumSimModelType =
  | 'CANOPY'
  | 'CHASSIS_SIM'
  | 'CUSTOM';

export type EnumSimRequestRequesterSlot =
  | 'RUN01_06'
  | 'SETUP01_02';

export type EnumSimRequestSimType =
  | 'CAR_MODEL_POST'
  | 'DATA_REPLAY'
  | 'DEVELOPMENT'
  | 'DYNAMIC_LAP'
  | 'EIGHT_POST'
  | 'KINEMATICS'
  | 'KNC'
  | 'MODEL_REQUEST'
  | 'QUASI_STATIC_LAP'
  | 'SETUP'
  | 'STEADY_STATE_LATERAL'
  | 'STEADY_STATE_STRAIGHT_LINE';

export type EnumSimResultDataInterpolationMethod =
  | 'HOLD_PREVIOUS'
  | 'LINEAR'
  | 'NEAREST'
  | 'NONE';

export type EnumSimResultSimType =
  | 'CAR_MODEL_POST'
  | 'DATA_REPLAY'
  | 'DEVELOPMENT'
  | 'DYNAMIC_LAP'
  | 'EIGHT_POST'
  | 'KINEMATICS'
  | 'KNC'
  | 'MODEL_REQUEST'
  | 'QUASI_STATIC_LAP'
  | 'SETUP'
  | 'STEADY_STATE_LATERAL'
  | 'STEADY_STATE_STRAIGHT_LINE';

export type EnumSimResultStatus =
  | 'COMPLETE'
  | 'DRAFT'
  | 'FAILED'
  | 'QUEUED'
  | 'RUNNING';

export type EnumSimulationDriveFileStatus =
  | 'ARCHIVED'
  | 'DRAFT'
  | 'RELEASED';

export type EnumSpecificationACamberReadingsRequired =
  | 'CONTROL_ARM'
  | 'CORNERS'
  | 'CORNER_FORWARD_REARWARD'
  | 'CORNER_INNER_OUTER'
  | 'CORNER_LOWER_UPPER'
  | 'FRONT_REAR'
  | 'FRONT_REAR_PRIMARY_SECONDARY'
  | 'INPUT_CENTER_OUTPUT'
  | 'LEFT_RIGHT'
  | 'POWERTRAIN'
  | 'PRIMARY_SECONDARY'
  | 'SINGLE'
  | 'SUSPENSION_MEMBER';

export type EnumSpecificationACamberUnit =
  | 'DEGREES'
  | 'MINUTES'
  | 'RADIANS';

export type EnumSpecificationAdminAeroElementInterpolationMethod =
  | 'AFLAP'
  | 'CLOSEST'
  | 'LINEAR'
  | 'NONE'
  | 'POLYNOMIAL'
  | 'SPLINE';

export type EnumSpecificationAdminAeroElementType =
  | 'INTERPOLATE'
  | 'POLYNOMIAL'
  | 'STRICT';

export type EnumSpecificationAdminAntiRollBarDisplayLocation =
  | 'FRONT'
  | 'REAR';

export type EnumSpecificationAdminAxle =
  | 'FRONT'
  | 'REAR';

export type EnumSpecificationAdminBumpRubberReference =
  | 'DROOP'
  | 'FORCE'
  | 'REF'
  | 'STATIC';

export type EnumSpecificationAdminBumpStopGapMethod =
  | 'GAP_TO_BASE'
  | 'GAP_TO_TOP'
  | 'PACKER_STACK';

export type EnumSpecificationAdminElasticType =
  | 'BUMP_RUBBER'
  | 'HELPER_SPRING'
  | 'REBOUND_SPRING'
  | 'SPRING'
  | 'TORSION_BAR';

export type EnumSpecificationAdminGearType =
  | 'BEVEL_SET'
  | 'DROP_GEAR'
  | 'STANDARD';

export type EnumSpecificationAdminModelTypes =
  | 'CANOPY'
  | 'CHASSIS_SIM'
  | 'CUSTOM';

export type EnumSpecificationAdminPowertrainLocation =
  | 'CENTRAL'
  | 'FRONT'
  | 'REAR';

export type EnumSpecificationAdminReadingsAllowable =
  | 'FRONT'
  | 'FRONT_LEFT'
  | 'FRONT_LEFT_LCA_FWD'
  | 'FRONT_LEFT_LCA_RWD'
  | 'FRONT_LEFT_UCA_FWD'
  | 'FRONT_LEFT_UCA_RWD'
  | 'FRONT_RIGHT'
  | 'FRONT_RIGHT_LCA_FWD'
  | 'FRONT_RIGHT_LCA_RWD'
  | 'FRONT_RIGHT_UCA_FWD'
  | 'FRONT_RIGHT_UCA_RWD'
  | 'LEFT'
  | 'REAR'
  | 'REAR_LEFT'
  | 'REAR_LEFT_LCA_FWD'
  | 'REAR_LEFT_LCA_RWD'
  | 'REAR_LEFT_UCA_FWD'
  | 'REAR_LEFT_UCA_RWD'
  | 'REAR_RIGHT'
  | 'REAR_RIGHT_LCA_FWD'
  | 'REAR_RIGHT_LCA_RWD'
  | 'REAR_RIGHT_UCA_FWD'
  | 'REAR_RIGHT_UCA_RWD'
  | 'RIGHT'
  | 'SINGLE';

export type EnumSpecificationAdminReadingsRequired =
  | 'CONTROL_ARM'
  | 'CORNERS'
  | 'CORNER_FORWARD_REARWARD'
  | 'CORNER_INNER_OUTER'
  | 'CORNER_LOWER_UPPER'
  | 'FRONT_REAR'
  | 'FRONT_REAR_PRIMARY_SECONDARY'
  | 'INPUT_CENTER_OUTPUT'
  | 'LEFT_RIGHT'
  | 'POWERTRAIN'
  | 'PRIMARY_SECONDARY'
  | 'SINGLE'
  | 'SUSPENSION_MEMBER';

export type EnumSpecificationAdminSpringReference =
  | 'DROOP'
  | 'FORCE'
  | 'REF'
  | 'STATIC';

export type EnumSpecificationAdminType =
  | 'AERO_ELEMENT'
  | 'AERO_PACKAGE'
  | 'ANTI_ROLL_BAR'
  | 'CHASSIS'
  | 'CUSTOM'
  | 'DAMPER'
  | 'DIFFERENTIAL'
  | 'ELASTIC'
  | 'GEAR'
  | 'GEAR_BOX'
  | 'KINEMATICS_EXTERNAL'
  | 'KINEMATICS_INTERNAL';

export type EnumSpecificationCustomSimulationModelsDataMapping =
  | 'Flat'
  | 'Standard';

export type EnumSpecificationHRideReadingsRequired =
  | 'CONTROL_ARM'
  | 'CORNERS'
  | 'CORNER_FORWARD_REARWARD'
  | 'CORNER_INNER_OUTER'
  | 'CORNER_LOWER_UPPER'
  | 'FRONT_REAR'
  | 'FRONT_REAR_PRIMARY_SECONDARY'
  | 'INPUT_CENTER_OUTPUT'
  | 'LEFT_RIGHT'
  | 'POWERTRAIN'
  | 'PRIMARY_SECONDARY'
  | 'SINGLE'
  | 'SUSPENSION_MEMBER';

export type EnumSpecificationHRideUnit =
  | 'CENTIMETRES'
  | 'FEET'
  | 'INCHES'
  | 'KILOMETRES'
  | 'METRES'
  | 'MICROMETRES'
  | 'MILES'
  | 'MILLIMETRES'
  | 'THOU';

export type EnumSpecificationPowertrainLocation =
  | 'CENTRAL'
  | 'FRONT'
  | 'REAR';

export type EnumSpecificationReadingsAllowable =
  | 'FRONT'
  | 'FRONT_LEFT'
  | 'FRONT_LEFT_LCA_FWD'
  | 'FRONT_LEFT_LCA_RWD'
  | 'FRONT_LEFT_UCA_FWD'
  | 'FRONT_LEFT_UCA_RWD'
  | 'FRONT_RIGHT'
  | 'FRONT_RIGHT_LCA_FWD'
  | 'FRONT_RIGHT_LCA_RWD'
  | 'FRONT_RIGHT_UCA_FWD'
  | 'FRONT_RIGHT_UCA_RWD'
  | 'LEFT'
  | 'REAR'
  | 'REAR_LEFT'
  | 'REAR_LEFT_LCA_FWD'
  | 'REAR_LEFT_LCA_RWD'
  | 'REAR_LEFT_UCA_FWD'
  | 'REAR_LEFT_UCA_RWD'
  | 'REAR_RIGHT'
  | 'REAR_RIGHT_LCA_FWD'
  | 'REAR_RIGHT_LCA_RWD'
  | 'REAR_RIGHT_UCA_FWD'
  | 'REAR_RIGHT_UCA_RWD'
  | 'RIGHT'
  | 'SINGLE';

export type EnumSpecificationReadingsRequired =
  | 'CONTROL_ARM'
  | 'CORNERS'
  | 'CORNER_FORWARD_REARWARD'
  | 'CORNER_INNER_OUTER'
  | 'CORNER_LOWER_UPPER'
  | 'FRONT_REAR'
  | 'FRONT_REAR_PRIMARY_SECONDARY'
  | 'INPUT_CENTER_OUTPUT'
  | 'LEFT_RIGHT'
  | 'POWERTRAIN'
  | 'PRIMARY_SECONDARY'
  | 'SINGLE'
  | 'SUSPENSION_MEMBER';

export type EnumSpecificationType =
  | 'AERO_ELEMENT'
  | 'AERO_PACKAGE'
  | 'ANTI_ROLL_BAR'
  | 'CHASSIS'
  | 'CUSTOM'
  | 'DAMPER'
  | 'DIFFERENTIAL'
  | 'ELASTIC'
  | 'GEAR'
  | 'GEAR_BOX'
  | 'KINEMATICS_EXTERNAL'
  | 'KINEMATICS_INTERNAL';

export type EnumSpringRateUnit =
  | 'NEWTONS_PER_METRE'
  | 'NEWTONS_PER_MILLIMETRE'
  | 'POUNDS_PER_INCH';

export type EnumSteeringRackRatioUnit =
  | 'DEGREES_PER_INCHES'
  | 'DEGREES_PER_MILLIMETRES';

export type EnumTagType =
  | 'ASSEMBLY'
  | 'CALCULATION'
  | 'CAR_SETUP'
  | 'CHASSIS'
  | 'GLOBAL'
  | 'ISSUE'
  | 'JOB'
  | 'LAP'
  | 'PART'
  | 'PROJECT'
  | 'RUN_SHEET'
  | 'SIM_RESULT'
  | 'TRACK';

export type EnumTemperatureOption =
  | 'PARC_FERME_EXPECTED'
  | 'POST_RUN'
  | 'POST_RUN_BLEED'
  | 'SET_DOWN';

export type EnumTemperatureUnit =
  | 'CELSIUS'
  | 'FAHRENHEIT'
  | 'KELVIN';

export type EnumTemplateSessionDebriefMode =
  | 'markdown'
  | 'table';

export type EnumTimeUnit =
  | 'DAYS'
  | 'HOURS'
  | 'MILLISECONDS'
  | 'SECONDS';

export type EnumTimingServiceConfigLogLevel =
  | 'CRITICAL'
  | 'DEBUG'
  | 'ERROR'
  | 'INFO'
  | 'NOTSET'
  | 'WARNING';

export type EnumTimingServiceConfigMode =
  | 'MILEAGE'
  | 'OFFICIAL';

export type EnumToeMeasurementMethod =
  | 'ANGLE'
  | 'BOTH'
  | 'LENGTH';

export type EnumTorqueUnit =
  | 'NEWTON_METRES'
  | 'NEWTON_MILLIMETRES'
  | 'POUND_FORCE_FEET'
  | 'POUND_FORCE_INCHES';

export type EnumTorsionRateUnit =
  | 'NEWTON_METRES_PER_DEGREE'
  | 'NEWTON_METRES_PER_RADIAN'
  | 'POUNDS_FEET_PER_DEGREE'
  | 'POUNDS_FEET_PER_RADIAN'
  | 'POUNDS_INCHES_PER_DEGREE'
  | 'POUNDS_INCHES_PER_RADIAN';

/** Indicates whether the pole position is on the left- or right-hand side */
export type EnumTrackLayoutPolePosition =
  | 'LHS'
  | 'RHS';

export type EnumTrackLayoutTrackLayoutType =
  | 'DIRT'
  | 'OVAL'
  | 'TRACK';

export type EnumTrackStateFlag =
  | 'CHEQUERED'
  | 'GREEN'
  | 'PARTIAL_YELLOW'
  | 'RED'
  | 'YELLOW';

export type EnumTrackableWarningDirection =
  | 'GREATER_THAN'
  | 'LESS_THAN';

export type EnumTrackingItemOperator =
  | 'EQUAL'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL';

export type EnumTrackingRecordGeneralType =
  | 'GENERAL'
  | 'OVERRIDE'
  | 'VALUE';

export type EnumTrackingRecordOverrideType =
  | 'GENERAL'
  | 'OVERRIDE'
  | 'VALUE';

export type EnumTrackingRecordType =
  | 'GENERAL'
  | 'OVERRIDE'
  | 'VALUE';

export type EnumTrackingRecordValueType =
  | 'GENERAL'
  | 'OVERRIDE'
  | 'VALUE';

export type EnumTrackingSourceAliasAliasType =
  | 'CarDataKPI'
  | 'Manual'
  | 'RunDistance'
  | 'RunTime';

export type EnumTypedUnitType =
  | 'ACCELERATION'
  | 'ANGLE'
  | 'ANGULAR_ACCELERATION'
  | 'ANGULAR_COMPLIANCE'
  | 'ANGULAR_TORQUE_COMPLIANCE'
  | 'ANGULAR_VELOCITY'
  | 'COMPLIANCE'
  | 'ENERGY'
  | 'FORCE'
  | 'INERTIA'
  | 'LENGTH'
  | 'MASS'
  | 'NUMBER'
  | 'POWER'
  | 'PRESSURE'
  | 'RATIO'
  | 'SPRING_RATE'
  | 'STEERING_RACK_RATIO'
  | 'STRING'
  | 'TEMPERATURE'
  | 'TIME'
  | 'TORQUE'
  | 'TORSION_RATE'
  | 'VELOCITY'
  | 'VOLUME';

export type EnumTyreAxle =
  | 'BOTH'
  | 'FRONT'
  | 'REAR';

export type EnumTyreInitialCondition =
  | 'NEW'
  | 'SCRUBBED'
  | 'USED';

export type EnumTyreTableField =
  | 'H_TYRE_TREAD'
  | 'H_TYRE_WEAR'
  | 'PRE_RUN_MILEAGE'
  | 'P_TYRE'
  | 'P_TYRE_BUILD'
  | 'P_TYRE_MINIMUM'
  | 'P_TYRE_POST_RUN'
  | 'P_TYRE_POST_RUN_BLEED'
  | 'P_TYRE_PRE_RUN_BLEED'
  | 'P_TYRE_REFERENCE'
  | 'P_TYRE_SET_DOWN'
  | 'P_TYRE_START_RUN'
  | 'P_TYRE_TARGET'
  | 'TYRE_SELECTOR'
  | 'TYRE_SET_SELECTOR'
  | 'TYRE_STAGGER'
  | 'T_AIR_REFERENCE'
  | 'T_TRACK_REFERENCE'
  | 'T_TYRE'
  | 'T_TYRE_PARC_FERME_EXPECTED'
  | 'T_TYRE_POST_RUN'
  | 'T_TYRE_POST_RUN_BLEED'
  | 'T_TYRE_REFERENCE'
  | 'T_TYRE_SET_DOWN'
  | 'T_TYRE_SURFACE';

export type EnumUnitSystem =
  | 'IMPERIAL'
  | 'METRIC';

export type EnumUntypedUnit =
  | 'NONE'
  | 'NUMBER'
  | 'STRING';

export type EnumUserEnumAssemblyTypeType =
  | 'USER_ENUM_ASSEMBLY_TYPE';

export type EnumUserEnumBuildSheetGroupType =
  | 'USER_ENUM_BUILDSHEET_GROUP';

export type EnumUserEnumPartStatusType =
  | 'USER_ENUM_PART_STATUS';

export type EnumUserEnumPartTypeType =
  | 'USER_ENUM_PART_TYPE';

export type EnumUserEnumRunPlannerActionItemType =
  | 'USER_ENUM_RUN_PLANNER_ACTION_ITEM';

export type EnumUserEnumSimulationDriveFileTypeType =
  | 'USER_ENUM_SIMULATION_DRIVE_FILE_TYPE';

export type EnumUserEnumTrackingSeverityType =
  | 'USER_ENUM_TRACKING_SEVERITY';

export type EnumUserEnumType =
  | 'USER_ENUM_ASSEMBLY_TYPE'
  | 'USER_ENUM_BUILDSHEET_GROUP'
  | 'USER_ENUM_PART_STATUS'
  | 'USER_ENUM_PART_TYPE'
  | 'USER_ENUM_RUN_PLANNER_ACTION_ITEM'
  | 'USER_ENUM_SIMULATION_DRIVE_FILE_TYPE'
  | 'USER_ENUM_TRACKING_SEVERITY';

export type EnumVelocityUnit =
  | 'FEET_PER_SECOND'
  | 'KILOMETRES_PER_HOUR'
  | 'METRES_PER_SECOND'
  | 'MILES_PER_HOUR';

export type EnumVolumeUnit =
  | 'GALLONS'
  | 'LITRES'
  | 'METRES_CUBED'
  | 'MILLILITRES';

export type EnumWeatherBlockField =
  | 'AIR_DENSITY'
  | 'AMBIENT_CONDITION'
  | 'HUMIDITY'
  | 'PRESSURE'
  | 'TRACK_CONDITION'
  | 'T_AMBIENT'
  | 'T_AMBIENT_OFFICIAL'
  | 'T_TRACK'
  | 'T_TRACK_OFFICIAL';

/** Location or weather station */
export type EnumWeatherServiceConfigRequestType =
  | 'LOCATION'
  | 'WEATHER_STATION';

/** Weather client to specify the source where to retrieve the data from. */
export type EnumWeatherServiceConfigSource =
  | 'METEOMATICS'
  | 'ONE_TIMING'
  | 'OPEN_WEATHER_MAP'
  | 'TOMORROW_IO'
  | 'WEATHER_LINK'
  | 'WEATHER_UNDERGROUND';

export type EnumWeatherServiceConfigType =
  | 'HISTORICAL'
  | 'MEASUREMENT'
  | 'PREDICTION';

export type EnumWeatherSources =
  | 'METEOMATICS'
  | 'ONE_TIMING'
  | 'OPEN_WEATHER_MAP'
  | 'TOMORROW_IO'
  | 'WEATHER_LINK'
  | 'WEATHER_UNDERGROUND';

export type EnumWeatherType =
  | 'HISTORICAL'
  | 'MEASUREMENT'
  | 'PREDICTION';

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  /** Density of the fuel */
  DFuel?: Maybe<Scalars['Float']['output']>;
  /** Number of this event in the season */
  NEventSeason?: Maybe<Scalars['Float']['output']>;
  /**
   * Default SoCRequired values to use during this event (assuming single track layout)
   * @deprecated Specify SoC required in the consumptions array instead.
   */
  SoCRequired?: Maybe<RunEnergy>;
  _id: Scalars['MongoID']['output'];
  assignedSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignedSetups: Array<CarSetup>;
  /** Fuel/SoC/Energy consumptions for each track layout in this event. */
  consumptions?: Maybe<Array<Maybe<LayoutConsumption>>>;
  contestants?: Maybe<Array<Maybe<EventContestants>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: Maybe<Scalars['JSON']['output']>;
  debriefNotes?: Maybe<Scalars['String']['output']>;
  debriefNotesMode?: Maybe<EnumEventDebriefNotesMode>;
  /**
   * Default energyRequired values to use during this event (assuming single track layout)
   * @deprecated Specify energy required in the consumptions array instead.
   */
  energyRequired?: Maybe<RunEnergy>;
  /** Energy sweep information for Formula E */
  energySweep?: Maybe<Scalars['JSON']['output']>;
  enumEventType?: Maybe<EnumEventEnumEventType>;
  enumEventVenue?: Maybe<EnumEventEnumEventVenue>;
  /**
   * e.g. Race, Test, etc.
   * @deprecated Use enum field `type` instead.
   */
  eventType?: Maybe<Scalars['String']['output']>;
  /**
   * Default fuelRequired values to use during this event (assuming single track layout)
   * @deprecated Specify fuel required in the consumptions array instead.
   */
  fuelRequired?: Maybe<RunEnergy>;
  /** Should the iRacing service populate this event when an unknown event is encountered? */
  iRacingServiceIsNextEvent?: Maybe<Scalars['Boolean']['output']>;
  /** IDs of issues related to this event. */
  issueIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  issues: Array<Issue>;
  name: Scalars['String']['output'];
  participantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  participants: Array<Person>;
  /** Reference laptimes for each track layout in this event. */
  referenceLaptimes?: Maybe<Array<Maybe<EventReferenceLaptimes>>>;
  /** Selected authors for the event report (person reference plus a name snapshot). */
  reportAuthors?: Maybe<Array<Maybe<EventReportAuthors>>>;
  season?: Maybe<Season>;
  seasonID: Scalars['MongoID']['output'];
  sessionIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  sessions: Array<Session>;
  /** Time of event end in local time */
  tEventEnd?: Maybe<Scalars['Date']['output']>;
  /** Time of event start in local time */
  tEventStart?: Maybe<Scalars['Date']['output']>;
  tLapAverage?: Maybe<Scalars['Float']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyEventID?: Maybe<Scalars['String']['output']>;
  /** @deprecated Access time zone from this event's track instead. */
  timeZone?: Maybe<Scalars['String']['output']>;
  track?: Maybe<Track>;
  trackID?: Maybe<Scalars['MongoID']['output']>;
  trackLayoutIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackLayouts: Array<TrackLayout>;
  /** @deprecated Use enumEventVenue instead. */
  type?: Maybe<EnumEventType>;
  tyreDefaults?: Maybe<Array<Maybe<EventTyreDefaultsSet>>>;
  /** @deprecated Use the tyreDefaults array instead. */
  tyreDefaultsFL?: Maybe<EventTyreDefaults>;
  /** @deprecated Use the tyreDefaults array instead. */
  tyreDefaultsFR?: Maybe<EventTyreDefaults>;
  /** @deprecated Use the tyreDefaults array instead. */
  tyreDefaultsRL?: Maybe<EventTyreDefaults>;
  /** @deprecated Use the tyreDefaults array instead. */
  tyreDefaultsRR?: Maybe<EventTyreDefaults>;
  /** @deprecated Use a wet tyre type in the tyreDefaults array instead. */
  tyreDefaultsWetFL?: Maybe<EventTyreDefaults>;
  /** @deprecated Use a wet tyre type in the tyreDefaults array instead. */
  tyreDefaultsWetFR?: Maybe<EventTyreDefaults>;
  /** @deprecated Use a wet tyre type in the tyreDefaults array instead. */
  tyreDefaultsWetRL?: Maybe<EventTyreDefaults>;
  /** @deprecated Use a wet tyre type in the tyreDefaults array instead. */
  tyreDefaultsWetRR?: Maybe<EventTyreDefaults>;
  /** IDs of weather documents linked to this event */
  weatherIDs: Array<Scalars['MongoID']['output']>;
  /** Weather documents linked to this event. */
  weathers: Array<Weather>;
};

/** Field to target with this mutation. */
export type EventContestantField =
  /** → `chassisIDs` */
  | 'CHASSIS'
  /** → `driverIDs` */
  | 'DRIVERS';

export type EventContestantTyres = {
  tyreIDs: Array<Scalars['MongoID']['output']>;
  tyreSetIDs: Array<Scalars['MongoID']['output']>;
  tyreSets: Array<TyreSet>;
  tyres: Array<Tyre>;
};

export type EventContestants = {
  _id: Scalars['MongoID']['output'];
  /** Chassis used, if different for this event. */
  chassis: Array<Chassis>;
  /** IDs of chassis used, if different for this event. */
  chassisIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: Maybe<Scalars['String']['output']>;
  /** IDs of drivers of this car, if different for this event. */
  driverIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Drivers of this car, if different for this event. */
  drivers: Array<Person>;
  /** IDs of tyres allocated to this contestant for this event (like during races where only tyres handed out at this very race are permitted). */
  tyreIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** IDs of tyre sets allocated to this contestant for this event. */
  tyreSetIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tyre sets allocated to this contestant for this event. */
  tyreSets: Array<TyreSet>;
  /** Tyres allocated to this contestant for this event (like during races where only tyres handed out at this very race are permitted). */
  tyres: Array<Tyre>;
};

export type EventContestantsInput = {
  _id: Scalars['MongoID']['input'];
  /** IDs of chassis used, if different for this event. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this event. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyres allocated to this contestant for this event (like during races where only tyres handed out at this very race are permitted). */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyre sets allocated to this contestant for this event. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** List of items with pagination. */
export type EventPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Event>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type EventReferenceLaptimes = {
  /** Reference Laptime for ATTACK lap */
  ATTACK?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for COOL lap */
  COOL?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for FCY lap */
  FCY?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for IN lap */
  IN?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for OUT lap */
  OUT?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for OUTIN lap */
  OUTIN?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for PITLANE lap */
  PITLANE?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for PREP lap */
  PREP?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for PUSH lap */
  PUSH?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for QUALI lap */
  QUALI?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for SAFETYCAR lap */
  SAFETYCAR?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for SHAKEDOWN lap */
  SHAKEDOWN?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for SLOW lap */
  SLOW?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for TARGET lap */
  TARGET?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for TOGRID lap */
  TOGRID?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for TOPADDOCK lap */
  TOPADDOCK?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for TOPITS lap */
  TOPITS?: Maybe<Scalars['Float']['output']>;
  /** Reference Laptime for UNFINISHED lap */
  UNFINISHED?: Maybe<Scalars['Float']['output']>;
  calculationMethod?: Maybe<EnumEventReferenceLaptimesCalculationMethod>;
  /** Reference Laptime when using the calculation method "RATIO" */
  referenceLaptime?: Maybe<Scalars['Float']['output']>;
  trackLayoutID: Scalars['MongoID']['output'];
};

export type EventReferenceLaptimesInput = {
  /** Reference Laptime for ATTACK lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for COOL lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for FCY lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for IN lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUT lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUTIN lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PITLANE lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PREP lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PUSH lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for QUALI lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SAFETYCAR lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SHAKEDOWN lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SLOW lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TARGET lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOGRID lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPADDOCK lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPITS lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for UNFINISHED lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  calculationMethod?: InputMaybe<EnumEventReferenceLaptimesCalculationMethod>;
  /** Reference Laptime when using the calculation method "RATIO" */
  referenceLaptime?: InputMaybe<Scalars['Float']['input']>;
  trackLayoutID: Scalars['MongoID']['input'];
};

export type EventReportAuthors = {
  name?: Maybe<Scalars['String']['output']>;
  personID?: Maybe<Scalars['MongoID']['output']>;
};

export type EventReportAuthorsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
};

/** Suggested defaults for various tyre variables, intended for setup sheets and run sheets to pull from during this event. */
export type EventTyreDefaults = {
  /** Suggested bare minimum tyre pressure for this event. */
  pTyreMin?: Maybe<Scalars['Float']['output']>;
  /**
   * Suggested minimum pressure at the start of a run for this event.
   * @deprecated Use pTyreStartRun instead
   */
  pTyreMinStartRun?: Maybe<Scalars['Float']['output']>;
  /** Suggested pressure at the start of a run for this event. */
  pTyreStartRun?: Maybe<Scalars['Float']['output']>;
  /** Suggested tyre pressure target for this event. */
  pTyreTarget?: Maybe<Scalars['Float']['output']>;
};

export type EventTyreDefaultsInput = {
  /** Suggested bare minimum tyre pressure for this event. */
  pTyreMin?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested minimum pressure at the start of a run for this event. */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested pressure at the start of a run for this event. */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested tyre pressure target for this event. */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type EventTyreDefaultsSet = {
  frontLeft?: Maybe<EventTyreDefaults>;
  frontRight?: Maybe<EventTyreDefaults>;
  rearLeft?: Maybe<EventTyreDefaults>;
  rearRight?: Maybe<EventTyreDefaults>;
  /** Which compound should these defaults be applied on? */
  tyreCompound?: Maybe<Scalars['String']['output']>;
  /** Which tyre type should these defaults be applied on? */
  tyreType?: Maybe<Scalars['String']['output']>;
};

export type EventTyreDefaultsSetInput = {
  frontLeft?: InputMaybe<EventTyreDefaultsInput>;
  frontRight?: InputMaybe<EventTyreDefaultsInput>;
  rearLeft?: InputMaybe<EventTyreDefaultsInput>;
  rearRight?: InputMaybe<EventTyreDefaultsInput>;
  /** Which compound should these defaults be applied on? */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Which tyre type should these defaults be applied on? */
  tyreType?: InputMaybe<Scalars['String']['input']>;
};

export type EventTyrePressureSettings = {
  TRimReference?: Maybe<Scalars['Float']['output']>;
  TTrackReference?: Maybe<Scalars['Float']['output']>;
  rColdToHotTeam?: Maybe<Scalars['Float']['output']>;
  rRimTempRegulation?: Maybe<Scalars['Float']['output']>;
  rRimTempTeam?: Maybe<Scalars['Float']['output']>;
  rTrackTempLongRun?: Maybe<Scalars['Float']['output']>;
  rTrackTempShortRun?: Maybe<Scalars['Float']['output']>;
};

export type EventTyrePressureSettingsInput = {
  TRimReference?: InputMaybe<Scalars['Float']['input']>;
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
  rColdToHotTeam?: InputMaybe<Scalars['Float']['input']>;
  rRimTempRegulation?: InputMaybe<Scalars['Float']['input']>;
  rRimTempTeam?: InputMaybe<Scalars['Float']['input']>;
  rTrackTempLongRun?: InputMaybe<Scalars['Float']['input']>;
  rTrackTempShortRun?: InputMaybe<Scalars['Float']['input']>;
};

export type ExternalBumpStop = {
  name?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<ElasticSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  xExternalBumpStopGap?: Maybe<Scalars['Float']['output']>;
};

export type ExternalBumpStopInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  xExternalBumpStopGap?: InputMaybe<Scalars['Float']['input']>;
};

export type FailedConfig = {
  /** Error message for the failed configuration. */
  message?: Maybe<Scalars['String']['output']>;
  timingServiceConfig?: Maybe<TimingServiceConfig>;
  /** ID of the timing service configuration. */
  timingServiceConfigID: Scalars['MongoID']['output'];
};

export type FailedConfigInput = {
  /** Error message for the failed configuration. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** ID of the timing service configuration. */
  timingServiceConfigID: Scalars['MongoID']['input'];
};

export type FilterFindManyAccelerationInput = {
  /** ft/s² */
  feetPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
  /** g */
  gForce?: InputMaybe<Scalars['Float']['input']>;
  metresPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAdjustableAccelerationInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAccelerationUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableAngleInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngleUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableAngularComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableAngularTorqueComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableBooleanInput = {
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyAdjustableComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableForceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumForceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableInertiaInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumInertiaUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableLengthInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableLocationCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAdjustableLocationDefaultValueInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAdjustableLocationInput = {
  coordinates?: InputMaybe<FilterFindManyAdjustableLocationCoordinatesInput>;
  defaultValue?: InputMaybe<FilterFindManyAdjustableLocationDefaultValueInput>;
};

export type FilterFindManyAdjustableMassInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumMassUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableNumberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  /** Unit to display values in */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableOrientationDefaultValueInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAdjustableOrientationInput = {
  defaultValue?: InputMaybe<FilterFindManyAdjustableOrientationDefaultValueInput>;
  rotation?: InputMaybe<FilterFindManyAdjustableOrientationRotationInput>;
};

export type FilterFindManyAdjustableOrientationRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAdjustablePowerInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPowerUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustablePressureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPressureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustablePropertyInput = {
  adjustableAcceleration?: InputMaybe<FilterFindManyAdjustableAccelerationInput>;
  adjustableAngle?: InputMaybe<FilterFindManyAdjustableAngleInput>;
  adjustableAngularCompliance?: InputMaybe<FilterFindManyAdjustableAngularComplianceInput>;
  adjustableAngularTorqueCompliance?: InputMaybe<FilterFindManyAdjustableAngularTorqueComplianceInput>;
  adjustableBoolean?: InputMaybe<FilterFindManyAdjustableBooleanInput>;
  adjustableCompliance?: InputMaybe<FilterFindManyAdjustableComplianceInput>;
  adjustableForce?: InputMaybe<FilterFindManyAdjustableForceInput>;
  adjustableInertia?: InputMaybe<FilterFindManyAdjustableInertiaInput>;
  adjustableLength?: InputMaybe<FilterFindManyAdjustableLengthInput>;
  adjustableLocation?: InputMaybe<FilterFindManyAdjustableLocationInput>;
  adjustableMass?: InputMaybe<FilterFindManyAdjustableMassInput>;
  adjustableNumber?: InputMaybe<FilterFindManyAdjustableNumberInput>;
  adjustableOrientation?: InputMaybe<FilterFindManyAdjustableOrientationInput>;
  adjustablePower?: InputMaybe<FilterFindManyAdjustablePowerInput>;
  adjustablePressure?: InputMaybe<FilterFindManyAdjustablePressureInput>;
  adjustableRatio?: InputMaybe<FilterFindManyAdjustableRatioInput>;
  adjustableSpringRate?: InputMaybe<FilterFindManyAdjustableSpringRateInput>;
  adjustableSteeringRackRatio?: InputMaybe<FilterFindManyAdjustableSteeringRackRatioInput>;
  adjustableString?: InputMaybe<FilterFindManyAdjustableStringInput>;
  adjustableTemperature?: InputMaybe<FilterFindManyAdjustableTemperatureInput>;
  adjustableTorque?: InputMaybe<FilterFindManyAdjustableTorqueInput>;
  adjustableTorsionRate?: InputMaybe<FilterFindManyAdjustableTorsionRateInput>;
  adjustableVolume?: InputMaybe<FilterFindManyAdjustableVolumeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAdjustablePropertyType>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyAdjustableRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableSpringRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpringRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableSteeringRackRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableStringInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableTemperatureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTemperatureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableTorqueInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorqueUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableTorsionRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorsionRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdjustableVolumeInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumVolumeUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAeroElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  attached?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  positionName?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAeroInput = {
  /** Number/Position of front flaps */
  NFlapF?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-left flaps */
  NFlapFL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-right flaps */
  NFlapFR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of lower rear flaps */
  NFlapLowerR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear flaps */
  NFlapR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-left flaps */
  NFlapRL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-right flaps */
  NFlapRR?: InputMaybe<Scalars['String']['input']>;
  Z400?: InputMaybe<Scalars['String']['input']>;
  /** Front flap angle */
  aFlapF?: InputMaybe<Scalars['Float']['input']>;
  /** Front-left flap angle */
  aFlapFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right flap angle */
  aFlapFR?: InputMaybe<Scalars['Float']['input']>;
  /** Lower rear flap angle */
  aFlapLowerR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear flap angle */
  aFlapR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left flap angle */
  aFlapRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right flap angle */
  aFlapRR?: InputMaybe<Scalars['Float']['input']>;
  /** Front splitter angle */
  aSplitterF?: InputMaybe<Scalars['Float']['input']>;
  /** Complete aero package spec */
  aeroPackage?: InputMaybe<Scalars['String']['input']>;
  floorBB?: InputMaybe<Scalars['String']['input']>;
  floorGurney?: InputMaybe<Scalars['String']['input']>;
  floorLeadingEdgeID?: InputMaybe<Scalars['String']['input']>;
  /** Front flap type */
  frontFlapType?: InputMaybe<Scalars['String']['input']>;
  frontWheelArch?: InputMaybe<Scalars['String']['input']>;
  hGurneyF?: InputMaybe<Scalars['Float']['input']>;
  hGurneyR?: InputMaybe<Scalars['Float']['input']>;
  /** Splitter height at measurement points */
  hSplitterF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lowerDrivePlane?: InputMaybe<Scalars['String']['input']>;
  noseID?: InputMaybe<Scalars['String']['input']>;
  rearWingGurney?: InputMaybe<Scalars['String']['input']>;
  splitterID?: InputMaybe<Scalars['String']['input']>;
  tailGurney?: InputMaybe<Scalars['String']['input']>;
  tailID?: InputMaybe<Scalars['String']['input']>;
  upperDrivePlane?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyAeroPackageInput = {
  aeroElements?: InputMaybe<Array<InputMaybe<FilterFindManyAeroElementInput>>>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAngleInput = {
  /** ° */
  degrees?: InputMaybe<Scalars['Float']['input']>;
  /** rad */
  radians?: InputMaybe<Scalars['Float']['input']>;
  /** rev */
  revolutions?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAngularVelocityInput = {
  /** °/s */
  degreesPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rad/s */
  radiansPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rpm */
  revolutionsPerMinute?: InputMaybe<Scalars['Float']['input']>;
  /** rev/s */
  revolutionsPerSecond?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAntiRollBarConfigInput = {
  /** Anti-roll bar stiffness (use spring rate units) */
  kARB?: InputMaybe<Scalars['Float']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** First connection point (should be a chassis socket) */
  position1?: InputMaybe<Scalars['String']['input']>;
  /** Second connection point (should be a chassis socket) */
  position2?: InputMaybe<Scalars['String']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyAreaInput = {
  /** sq ft */
  squareFeet?: InputMaybe<Scalars['Float']['input']>;
  /** sq in */
  squareInches?: InputMaybe<Scalars['Float']['input']>;
  /** m² */
  squareMetres?: InputMaybe<Scalars['Float']['input']>;
  /** mm² */
  squareMillimetres?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAssemblyCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyChassisPartIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyChassisSpecIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyCurrentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyAssemblyDecommissionedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyAssemblyInput = {
  AND?: InputMaybe<Array<FilterFindManyAssemblyInput>>;
  OR?: InputMaybe<Array<FilterFindManyAssemblyInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAssemblyOperatorsInput>;
  assemblyTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  assemblyTypeEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetNestLevel?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisMeasurements?: InputMaybe<Array<InputMaybe<FilterFindManyChassisAssemblyMeasurementInput>>>;
  chassisPartID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  subAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceRecords?: InputMaybe<Array<InputMaybe<FilterFindManyChassisAssemblyTrackingSourceRecordInput>>>;
  type?: InputMaybe<EnumAssemblyType>;
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAssemblyLocationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAssemblyOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAssembly_IdOperatorsInput>;
  carSetupID?: InputMaybe<FilterFindManyAssemblyCarSetupIdOperatorsInput>;
  chassisPartID?: InputMaybe<FilterFindManyAssemblyChassisPartIdOperatorsInput>;
  chassisSpecID?: InputMaybe<FilterFindManyAssemblyChassisSpecIdOperatorsInput>;
  current?: InputMaybe<FilterFindManyAssemblyCurrentOperatorsInput>;
  decommissioned?: InputMaybe<FilterFindManyAssemblyDecommissionedOperatorsInput>;
  locationID?: InputMaybe<FilterFindManyAssemblyLocationIdOperatorsInput>;
  name?: InputMaybe<FilterFindManyAssemblyNameOperatorsInput>;
  parentID?: InputMaybe<FilterFindManyAssemblyParentIdOperatorsInput>;
  reference?: InputMaybe<FilterFindManyAssemblyReferenceOperatorsInput>;
  type?: InputMaybe<FilterFindManyAssemblyTypeOperatorsInput>;
};

export type FilterFindManyAssemblyParentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyReferenceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAssemblyTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyAssemblyTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyAssemblyTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAssemblyTemplateOperatorsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredAssemblies?: InputMaybe<Array<InputMaybe<FilterFindManyAssemblyTemplateRequiredAssembliesInput>>>;
  requiredParts?: InputMaybe<Array<InputMaybe<FilterFindManyAssemblyTemplateRequiredPartsInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAssemblyTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAssemblyTemplate_IdOperatorsInput>;
};

export type FilterFindManyAssemblyTemplateRequiredAssembliesInput = {
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAssemblyTemplateRequiredPartsInput = {
  /** Specify where the part type should be added in */
  location?: InputMaybe<EnumAssemblyTemplateRequiredPartsLocation>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyAssemblyTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssemblyTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumAssemblyType>;
  gte?: InputMaybe<EnumAssemblyType>;
  in?: InputMaybe<Array<InputMaybe<EnumAssemblyType>>>;
  lt?: InputMaybe<EnumAssemblyType>;
  lte?: InputMaybe<EnumAssemblyType>;
  ne?: InputMaybe<EnumAssemblyType>;
  nin?: InputMaybe<Array<InputMaybe<EnumAssemblyType>>>;
};

export type FilterFindManyAssembly_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssignedGearInput = {
  gearID?: InputMaybe<Scalars['MongoID']['input']>;
  useHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyBaseTypedUnitFieldInput = {
  type?: InputMaybe<EnumTypedUnitType>;
  unit?: InputMaybe<EnumPossibleUnit>;
};

export type FilterFindManyBehaviourConfigInput = {
  /** Should job list templates be re-used from previous runs when creating new run sheets? */
  carryOverJobList?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the issue block will be ticked to show only the users issues on load. */
  showMyIssuesOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the job block will be ticked to show only the users jobs on load. */
  showMyJobsOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The locale to use for time formatting */
  timeLocale?: InputMaybe<Scalars['String']['input']>;
  /** ORH will use the users timezone selection to format times accordingly */
  timezoneSelect?: InputMaybe<EnumBehaviourConfigTimezoneSelect>;
};

export type FilterFindManyBestValuesContestantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBestValuesDriverIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBestValuesFastestLapInput = {
  /** Lap number within the run sheet for this lap. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this lap. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this lap can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the lap was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBestValuesFastestSectorInput = {
  /** Lap number within the run sheet for this sector. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this sector. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this sector can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the sector was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBestValuesInput = {
  AND?: InputMaybe<Array<FilterFindManyBestValuesInput>>;
  OR?: InputMaybe<Array<FilterFindManyBestValuesInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBestValuesOperatorsInput>;
  /** ID of the contestant these personal bests belong to, if applicable. */
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the driver these personal bests belong to, if applicable. */
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<FilterFindManyBestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<FilterFindManyBestValuesFastestSectorInput>>>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBestValuesOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBestValues_IdOperatorsInput>;
  contestantID?: InputMaybe<FilterFindManyBestValuesContestantIdOperatorsInput>;
  driverID?: InputMaybe<FilterFindManyBestValuesDriverIdOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyBestValuesSessionIdOperatorsInput>;
};

export type FilterFindManyBestValuesSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBestValues_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBopCarBopInput = {
  EStintMax?: InputMaybe<Scalars['Float']['input']>;
  PEngineMax?: InputMaybe<Scalars['Float']['input']>;
  VFuelVolumeCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelVolumeMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aCamberFmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberFmin?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmin?: InputMaybe<Scalars['Float']['input']>;
  aRakeMax?: InputMaybe<Scalars['Float']['input']>;
  aRakeMin?: InputMaybe<Scalars['Float']['input']>;
  aWingRmax?: InputMaybe<Scalars['Float']['input']>;
  aWingRmin?: InputMaybe<Scalars['Float']['input']>;
  carSpec?: InputMaybe<Scalars['String']['input']>;
  hRideFmin?: InputMaybe<Scalars['Float']['input']>;
  hRideRmin?: InputMaybe<Scalars['Float']['input']>;
  highlightColour?: InputMaybe<Scalars['String']['input']>;
  homologation?: InputMaybe<Scalars['String']['input']>;
  mCarBallastMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightEmptyMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightTotalMin?: InputMaybe<Scalars['Float']['input']>;
  mFuelMassCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  mRefuelMassMax?: InputMaybe<Scalars['Float']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['String']['input']>;
  nEngineMax?: InputMaybe<Scalars['Float']['input']>;
  /** A map rpm vs boost pressure */
  pEngineBoost?: InputMaybe<Scalars['JSON']['input']>;
  rLambdaMin?: InputMaybe<Scalars['Float']['input']>;
  rPowerCurveReference?: InputMaybe<Scalars['Float']['input']>;
  rPowerGainAboveRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vCarMax?: InputMaybe<Scalars['Float']['input']>;
  vPowerCurveBelowRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vPowerGainReference?: InputMaybe<Scalars['Float']['input']>;
  xAirRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xFuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xRefuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  zWingMin?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBopInput = {
  AND?: InputMaybe<Array<FilterFindManyBopInput>>;
  OR?: InputMaybe<Array<FilterFindManyBopInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBopOperatorsInput>;
  bopFile?: InputMaybe<Scalars['String']['input']>;
  carBop?: InputMaybe<Array<InputMaybe<FilterFindManyBopCarBopInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sessionBop?: InputMaybe<FilterFindManyBopSessionBopInput>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyBopNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBopOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBop_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyBopNameOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyBopSessionIdOperatorsInput>;
};

export type FilterFindManyBopSessionBopInput = {
  EStintEnergyMax?: InputMaybe<Scalars['Float']['input']>;
  EStintEnergyRefillRateMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  mRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  pAmbientSessionOfficial?: InputMaybe<Scalars['Float']['input']>;
  tyreModel?: InputMaybe<Scalars['String']['input']>;
  xStintlengthMax?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBopSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBop_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBrakeSystemInput = {
  BBBSEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  brakePadFManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadFSpec?: InputMaybe<Scalars['String']['input']>;
  brakePadRManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadRSpec?: InputMaybe<Scalars['String']['input']>;
  brakePedalPosition?: InputMaybe<Scalars['String']['input']>;
  dMasterCylinderF?: InputMaybe<Scalars['Float']['input']>;
  dMasterCylinderR?: InputMaybe<Scalars['Float']['input']>;
  kBBSSpring?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringF?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringR?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderFSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRodLengthF?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderRodlengthR?: InputMaybe<Scalars['Float']['input']>;
  pBrakeBalanceRef?: InputMaybe<Scalars['Float']['input']>;
  rBrakeF?: InputMaybe<Scalars['Float']['input']>;
  rBrakePedal?: InputMaybe<Scalars['Float']['input']>;
  xBBSPreload?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBuildSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  h?: InputMaybe<Scalars['Int']['input']>;
  moved?: InputMaybe<Scalars['Boolean']['input']>;
  resizing?: InputMaybe<Scalars['Boolean']['input']>;
  static?: InputMaybe<Scalars['Boolean']['input']>;
  tabs?: InputMaybe<Array<InputMaybe<FilterFindManyBuildSheetStyleTabInput>>>;
  /** The width of the block within the grid */
  w?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterFindManyBuildSheetStyleInput = {
  AND?: InputMaybe<Array<FilterFindManyBuildSheetStyleInput>>;
  OR?: InputMaybe<Array<FilterFindManyBuildSheetStyleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBuildSheetStyleOperatorsInput>;
  blocks?: InputMaybe<Array<InputMaybe<FilterFindManyBuildSheetStyleBlockInput>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetEventType?: InputMaybe<EnumBuildSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<InputMaybe<EnumBuildSheetStyleTargetRoles>>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumBuildSheetStyleType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBuildSheetStyleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBuildSheetStyle_IdOperatorsInput>;
};

export type FilterFindManyBuildSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyBuildSheetStyle_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCalculationInput = {
  AND?: InputMaybe<Array<FilterFindManyCalculationInput>>;
  OR?: InputMaybe<Array<FilterFindManyCalculationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCalculationOperatorsInput>;
  /** For the client to display debug information or default return values */
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  functionString?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The name of the parameter or path to a field which this calculation gives as output. */
  parameter?: InputMaybe<Scalars['String']['input']>;
  /** The names of the parameters or paths to fields which this calculation depends on. If any of these change, the calculation should be re-run. */
  trigger?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumCalculationType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCalculationNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCalculationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCalculation_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyCalculationNameOperatorsInput>;
};

export type FilterFindManyCalculation_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCanopyCredentialsInput = {
  /** Client ID for the Canopy API */
  clientID?: InputMaybe<Scalars['String']['input']>;
  /** Client secret for the Canopy API */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Password for the Canopy API */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID from the Canopy API */
  tenantID?: InputMaybe<Scalars['String']['input']>;
  /** Username for the Canopy API */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarCornerInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aFlap?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  brake?: InputMaybe<BrakeInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  suspension?: InputMaybe<SuspensionInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCarDataServiceApplicationSettingsConfigInput = {
  DriverContestantLookup?: InputMaybe<Scalars['JSON']['input']>;
  FunctionsFolder?: InputMaybe<Scalars['String']['input']>;
  PitstopTriggers?: InputMaybe<Array<InputMaybe<FilterFindManyCarDataServicePitstopTriggerInput>>>;
  ProcessedFolder?: InputMaybe<Scalars['String']['input']>;
  ResultsFolder?: InputMaybe<Scalars['String']['input']>;
  RunsheetMatching?: InputMaybe<EnumCarDataServiceApplicationSettingsConfigRunsheetMatching>;
};

export type FilterFindManyCarDataServiceConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyCarDataServiceConfigInput>>;
  Kpi?: InputMaybe<FilterFindManyCarDataServiceKpiConfigInput>;
  OR?: InputMaybe<Array<FilterFindManyCarDataServiceConfigInput>>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Object containing parameter mappings. Format is like: { vCar: [{ "name": "car_speed", "offset": 0, "gain": 3.6 }] } */
  ParameterMap?: InputMaybe<Scalars['JSON']['input']>;
  PostProcessingConfig?: InputMaybe<FilterFindManyCarDataServicePostProcessingConfigInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCarDataServiceConfigOperatorsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCarDataServiceConfigNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCarDataServiceConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCarDataServiceConfig_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyCarDataServiceConfigNameOperatorsInput>;
  raceSeriesID?: InputMaybe<FilterFindManyCarDataServiceConfigRaceSeriesIdOperatorsInput>;
};

export type FilterFindManyCarDataServiceConfigRaceSeriesIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarDataServiceConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarDataServiceEventConfigInput = {
  EventDescription?: InputMaybe<Scalars['String']['input']>;
  EventId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCarDataServiceKpiConfigInput = {
  KpiParameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyCarDataServicePitstopTriggerInput = {
  ParameterId?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<EnumCarDataServicePitstopTriggerType>;
  Value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCarDataServicePostProcessingConfigInput = {
  ApplicationSettingsConfiguration?: InputMaybe<FilterFindManyCarDataServiceApplicationSettingsConfigInput>;
  EventConfiguration?: InputMaybe<FilterFindManyCarDataServiceEventConfigInput>;
  ProcessingEnginesConfiguration?: InputMaybe<FilterFindManyCarDataServiceProcessingEnginesConfigInput>;
  QueueManagerConfiguration?: InputMaybe<FilterFindManyCarDataServiceQueueManagerConfigInput>;
  SessionManagerConfiguration?: InputMaybe<FilterFindManyCarDataServiceSessionManagerConfigInput>;
  SessionTypesConfiguration?: InputMaybe<FilterFindManyCarDataServiceSessionTypesConfigInput>;
};

export type FilterFindManyCarDataServiceProcessingEngineConfigExportersInput = {
  ATLAS10_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  JSONFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  ONERACEHUB_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  PARQUETFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  WINTAX_EXPORTER?: InputMaybe<FilterFindManyCarDataServiceProcessingEngineConfigExportersWintax_ExporterInput>;
};

export type FilterFindManyCarDataServiceProcessingEngineConfigExportersWintax_ExporterInput = {
  /** NAme of paremeter in the parameter map, tracking the distance of current lap. */
  DISTANCE_CHANNEL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel consumption of the current lap. Could be a KPI like 'sLap.Lap.Max' or a fixed value like '2453.2'. */
  FUEL_CONSUMPTION?: InputMaybe<Scalars['String']['input']>;
  /** Fuel level of the current lap. Could be a KPI like 'ERESSRaceFIA.Lap.Last' or a fixed value like '90.3'. */
  FUEL_LEVEL?: InputMaybe<Scalars['String']['input']>;
  /** Effective distance of the current lap. COuld be a KPI like 'ELap.Lap.Integral' or a fixed valued like '10.4'. */
  LAP_DISTANCE?: InputMaybe<Scalars['String']['input']>;
  /** Contains the folder, where the exported WinTAX files are stored. */
  OUTPUT_PATH?: InputMaybe<Scalars['String']['input']>;
  SIMULATE_CALLS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains the folder, where the TelDataZtx dll files are stored. */
  TELDATAZTX_PATH?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarDataServiceProcessingEngineConfigInput = {
  Calculations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Exporters?: InputMaybe<FilterFindManyCarDataServiceProcessingEngineConfigExportersInput>;
  Importer?: InputMaybe<EnumCarDataServiceProcessingEngineConfigImporter>;
  Instances?: InputMaybe<Scalars['Float']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  QueueName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarDataServiceProcessingEnginesConfigInput = {
  ExportersFolder?: InputMaybe<Scalars['String']['input']>;
  ImportersFolder?: InputMaybe<Scalars['String']['input']>;
  InternalCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  ParameterMapFile?: InputMaybe<Scalars['String']['input']>;
  ProcessingEngineConfiguration?: InputMaybe<Array<InputMaybe<FilterFindManyCarDataServiceProcessingEngineConfigInput>>>;
  UserCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarDataServiceQueueDefinitionInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  SessionType?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarDataServiceQueueManagerConfigInput = {
  Queues?: InputMaybe<Array<InputMaybe<FilterFindManyCarDataServiceQueueDefinitionInput>>>;
};

export type FilterFindManyCarDataServiceSessionManagerConfigInput = {
  OffloadFolder?: InputMaybe<Scalars['String']['input']>;
  OffloadSessionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyCarDataServiceSessionTypeConfigInput = {
  exts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  folderUpLevel?: InputMaybe<Scalars['Int']['input']>;
  ignoreLiterals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  regExpressions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarDataServiceSessionTypesConfigInput = {
  SessionTypes?: InputMaybe<Array<InputMaybe<FilterFindManyCarDataServiceSessionTypeConfigInput>>>;
};

export type FilterFindManyCarEndInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  antiRollBar?: InputMaybe<AntiRollBarInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  /** Point where the mechanic is measuring the ride height */
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Baseline pushrod length, steering rack bumpsteer adjust might depend on the rough range of ride heights the car is running in. */
  hRideRange?: InputMaybe<Scalars['String']['input']>;
  /** Point where the regulation authority is measuring the ride height */
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  kinematics?: InputMaybe<KinematicsInput>;
  kinematicsExternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  thirdElement?: InputMaybe<ThirdElementInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCarInfoInput = {
  /** Number of changes */
  NChanges?: InputMaybe<Scalars['Float']['input']>;
  /** Number of issues */
  NIssue?: InputMaybe<Scalars['Float']['input']>;
  batteryID?: InputMaybe<Scalars['String']['input']>;
  chassisID?: InputMaybe<Scalars['String']['input']>;
  /** A map of custom IDs for this setup. Input syntax is array of key-value (string-string) tuples. */
  customIDs?: InputMaybe<Scalars['JSON']['input']>;
  driveshaftID?: InputMaybe<Scalars['String']['input']>;
  engineID?: InputMaybe<Scalars['String']['input']>;
  gearboxID?: InputMaybe<Scalars['String']['input']>;
  inverterID?: InputMaybe<Scalars['String']['input']>;
  setupComments?: InputMaybe<Scalars['String']['input']>;
  /** Tyre compound for which this setup is intended */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCarMassInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Front-left mass */
  mCarFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right mass */
  mCarFR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left mass */
  mCarRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right mass */
  mCarRR?: InputMaybe<Scalars['Float']['input']>;
  /** Driver mass */
  mDriver?: InputMaybe<Scalars['Float']['input']>;
  /** Target portion of mass in the front of the car */
  rWeightFTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCarSetupAuthorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupChassisAssemblyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupChassisIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupChassisSpecIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupChassisSpecRootIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupDriverIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupEngineerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupInput = {
  AND?: InputMaybe<Array<FilterFindManyCarSetupInput>>;
  OR?: InputMaybe<Array<FilterFindManyCarSetupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCarSetupOperatorsInput>;
  aero?: InputMaybe<FilterFindManyAeroInput>;
  aeroPackage?: InputMaybe<FilterFindManyAeroPackageInput>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  brakeSystem?: InputMaybe<FilterFindManyBrakeSystemInput>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecRootID?: InputMaybe<Scalars['MongoID']['input']>;
  cockpit?: InputMaybe<FilterFindManyCockpitInput>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  custom?: InputMaybe<Scalars['JSON']['input']>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  /** Enable custom simulation payload for this setup. You as a user are responsible to have meaningful data in there. */
  customSimulationPayloadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  flattened?: InputMaybe<Scalars['JSON']['input']>;
  front?: InputMaybe<FilterFindManyCarEndInput>;
  frontLeft?: InputMaybe<FilterFindManyCarCornerInput>;
  frontRight?: InputMaybe<FilterFindManyCarCornerInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<FilterFindManyCarInfoInput>;
  intendedForSession?: InputMaybe<EnumCarSetupIntendedForSession>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Map of ballast positions to their masses. Keys are names of the positions and values are the masses. Input syntax is array of key-value tuples, like `mBallasts: [["front", 10], ["rear", 20]]`. */
  mBallasts?: InputMaybe<Scalars['JSON']['input']>;
  manualEndMileage?: InputMaybe<Scalars['Float']['input']>;
  manualStartMileage?: InputMaybe<Scalars['Float']['input']>;
  /** Mass out of garage (with driver in the seat) */
  massOutOfGarage?: InputMaybe<FilterFindManyCarMassInput>;
  /** Mass at the scales of the regulatory authority */
  massRegulation?: InputMaybe<FilterFindManyCarMassInput>;
  /** Mass from car setup */
  massSetup?: InputMaybe<FilterFindManyCarMassInput>;
  /** Mass from regulation scale replica in garage (team's scales) */
  massTeam?: InputMaybe<FilterFindManyCarMassInput>;
  powertrain?: InputMaybe<FilterFindManyPowertrainInput>;
  powertrainCentral?: InputMaybe<FilterFindManyPowertrainInput>;
  powertrainFront?: InputMaybe<FilterFindManyPowertrainInput>;
  powertrainRear?: InputMaybe<FilterFindManyPowertrainInput>;
  rear?: InputMaybe<FilterFindManyCarEndInput>;
  rearLeft?: InputMaybe<FilterFindManyCarCornerInput>;
  rearRight?: InputMaybe<FilterFindManyCarCornerInput>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Small info string */
  setupInfo?: InputMaybe<Scalars['String']['input']>;
  /** Override of setup sheet style, which usually comes from the chassis. */
  setupSheetStyle?: InputMaybe<EnumCarSetupSetupSheetStyle>;
  steering?: InputMaybe<FilterFindManySteeringInput>;
  /** Map containing systems config comments. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigComment?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config NIssue data. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigNIssues?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config values. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigValues?: InputMaybe<Scalars['JSON']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCarSetupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCarSetup_IdOperatorsInput>;
  authorID?: InputMaybe<FilterFindManyCarSetupAuthorIdOperatorsInput>;
  chassisAssemblyID?: InputMaybe<FilterFindManyCarSetupChassisAssemblyIdOperatorsInput>;
  chassisID?: InputMaybe<FilterFindManyCarSetupChassisIdOperatorsInput>;
  chassisSpecID?: InputMaybe<FilterFindManyCarSetupChassisSpecIdOperatorsInput>;
  chassisSpecRootID?: InputMaybe<FilterFindManyCarSetupChassisSpecRootIdOperatorsInput>;
  driverID?: InputMaybe<FilterFindManyCarSetupDriverIdOperatorsInput>;
  engineerID?: InputMaybe<FilterFindManyCarSetupEngineerIdOperatorsInput>;
  runSheetID?: InputMaybe<FilterFindManyCarSetupRunSheetIdOperatorsInput>;
  teamID?: InputMaybe<FilterFindManyCarSetupTeamIdOperatorsInput>;
  time?: InputMaybe<FilterFindManyCarSetupTimeOperatorsInput>;
  title?: InputMaybe<FilterFindManyCarSetupTitleOperatorsInput>;
  tyreSetID?: InputMaybe<FilterFindManyCarSetupTyreSetIdOperatorsInput>;
};

export type FilterFindManyCarSetupRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupTeamIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetupTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCarSetupTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyCarSetupTyreSetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCarSetup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChassisAssemblyMeasurementInput = {
  chassisSpecMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  location?: InputMaybe<FilterFindManyAdjustableLocationInput>;
  orientation?: InputMaybe<FilterFindManyAdjustableOrientationInput>;
};

export type FilterFindManyChassisAssemblyTrackingSourceRecordInput = {
  sources?: InputMaybe<Array<InputMaybe<FilterFindManyChassisAssemblyTrackingSourceRecordSourcesInput>>>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyChassisAssemblyTrackingSourceRecordSourcesInput = {
  /** priority of this source. Defined on the alias but saved here for efficiency reasons */
  priority?: InputMaybe<Scalars['Float']['input']>;
  trackingSourceAliasID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyChassisInput = {
  AND?: InputMaybe<Array<FilterFindManyChassisInput>>;
  OR?: InputMaybe<Array<FilterFindManyChassisInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyChassisOperatorsInput>;
  /** Allowable keys for ballast measurements in car setups that use this chassis. */
  ballastPositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  currentlyInUse?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** Unique identifier for the chassis */
  reference?: InputMaybe<Scalars['String']['input']>;
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of setup sheet fields to available preset values. Keys are like `"front.kSpringF"`, and values are lists of options. Input syntax is array of key-value tuples, like `setupOptions: [["front.kSpringF", [100, 110, 120]]]`. */
  setupOptions?: InputMaybe<Scalars['JSON']['input']>;
  setupSheetStyle?: InputMaybe<EnumChassisSetupSheetStyle>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Allowable keys for systems config maps in car setups that use this chassis. */
  systemsConfigFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Car type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyChassisManufacturerPartIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyChassisMassInput = {
  /** Base mass properties of the vehicle */
  base?: InputMaybe<FilterFindManyMassPropertiesInput>;
  /** Mass properties of the driver */
  driver?: InputMaybe<FilterFindManyMassPropertiesInput>;
  setupEquip?: InputMaybe<FilterFindManyMassPropertiesInput>;
};

export type FilterFindManyChassisMeasurementInput = {
  AND?: InputMaybe<Array<FilterFindManyChassisMeasurementInput>>;
  OR?: InputMaybe<Array<FilterFindManyChassisMeasurementInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyChassisMeasurementOperatorsInput>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyChassisMeasurementOperatorsInput = {
  _id?: InputMaybe<FilterFindManyChassisMeasurement_IdOperatorsInput>;
};

export type FilterFindManyChassisMeasurement_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChassisMeasurementsInput = {
  /** Default angle unit to display in setup options for this chassis */
  angles?: InputMaybe<EnumAngleUnit>;
  /** Default angular compliance unit to display in setup options for this chassis */
  angularCompliances?: InputMaybe<EnumAngularComplianceUnit>;
  /** Default angular torque compliance unit to display in setup options for this chassis */
  angularTorqueCompliances?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  bumpPlateMeasurementMethod?: InputMaybe<EnumBumpPlateMeasurementMethod>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** Default compliance unit to display in setup options for this chassis */
  compliances?: InputMaybe<EnumComplianceUnit>;
  /** Default force unit to display in setup options for this chassis */
  forces?: InputMaybe<EnumForceUnit>;
  /** Default inertia unit to display in setup options for this chassis */
  inertias?: InputMaybe<EnumInertiaUnit>;
  /** If true, positive camber is top leaning in. If false, negative camber is top leaning in. */
  inverseCamber?: InputMaybe<Scalars['Boolean']['input']>;
  kinematicsExternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsExternalReadingsRequired>;
  kinematicsInternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsInternalReadingsRequired>;
  /** Default length unit to display in setup options for this chassis */
  lengths?: InputMaybe<EnumLengthUnit>;
  /** Default mass unit to display in setup options for this chassis */
  masses?: InputMaybe<EnumMassUnit>;
  /** Default power unit to display in setup options for this chassis */
  powers?: InputMaybe<EnumPowerUnit>;
  /** Default pressure unit to display in setup options for this chassis */
  pressures?: InputMaybe<EnumPressureUnit>;
  /** Default ratio unit to display in setup options for this chassis */
  ratios?: InputMaybe<EnumRatioUnit>;
  /** Function to calculate front ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcFront?: InputMaybe<Scalars['String']['input']>;
  /** Function to calculate rear ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcRear?: InputMaybe<Scalars['String']['input']>;
  /** Default spring rate unit to display in setup options for this chassis */
  springRates?: InputMaybe<EnumSpringRateUnit>;
  /** Default steering rack ratio unit to display in setup options for this chassis */
  steeringRackRatios?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Default temperature unit to display in setup options for this chassis */
  temperatures?: InputMaybe<EnumTemperatureUnit>;
  toeMeasurementMethod?: InputMaybe<EnumToeMeasurementMethod>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** If true, toe measurement is given as total over axle. If false, toe measurement is per individual wheel. */
  toeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default torque unit to display in setup options for this chassis */
  torques?: InputMaybe<EnumTorqueUnit>;
  /** Default torsion rate unit to display in setup options for this chassis */
  torsionRates?: InputMaybe<EnumTorsionRateUnit>;
  /** Default volume unit to display in setup options for this chassis */
  volumes?: InputMaybe<EnumVolumeUnit>;
  xTrackFront?: InputMaybe<Scalars['Float']['input']>;
  xTrackRear?: InputMaybe<Scalars['Float']['input']>;
  /** Wheelbase length in metres */
  xWheelbase?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyChassisOperatorsInput = {
  _id?: InputMaybe<FilterFindManyChassis_IdOperatorsInput>;
  manufacturerPartID?: InputMaybe<FilterFindManyChassisManufacturerPartIdOperatorsInput>;
  setupSheetStyle?: InputMaybe<FilterFindManyChassisSetupSheetStyleOperatorsInput>;
  specificationID?: InputMaybe<FilterFindManyChassisSpecificationIdOperatorsInput>;
  type?: InputMaybe<FilterFindManyChassisTypeOperatorsInput>;
};

export type FilterFindManyChassisPowerUnitInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyChassisPowertrainInput = {
  bevelSetSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  differentialSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  dropGearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearBoxSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  layout?: InputMaybe<EnumPowertrainLayout>;
  /** Number of gears which are expected to be in the gearbox. */
  numGears?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyChassisSetupSheetStyleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumChassisSetupSheetStyle>;
  gte?: InputMaybe<EnumChassisSetupSheetStyle>;
  in?: InputMaybe<Array<InputMaybe<EnumChassisSetupSheetStyle>>>;
  lt?: InputMaybe<EnumChassisSetupSheetStyle>;
  lte?: InputMaybe<EnumChassisSetupSheetStyle>;
  ne?: InputMaybe<EnumChassisSetupSheetStyle>;
  nin?: InputMaybe<Array<InputMaybe<EnumChassisSetupSheetStyle>>>;
};

export type FilterFindManyChassisSocketInput = {
  /** Unique name for this socket. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyChassisSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChassisTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyChassis_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCockpitInput = {
  /** Ratio of the throttle pedal */
  rThrottlePedal?: InputMaybe<Scalars['Float']['input']>;
  /** Position of the throttle pedal */
  throttlePedalPosition?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCommentInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyContestantChassisNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContestantClassOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContestantEligibleForPointsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyContestantHiddenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyContestantInput = {
  AND?: InputMaybe<Array<FilterFindManyContestantInput>>;
  OR?: InputMaybe<Array<FilterFindManyContestantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyContestantOperatorsInput>;
  /** IDs of usable chassis */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Number of the chassis for this contestant. */
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** Default color to use for this contestant where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Drivers that constitute this contestant */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Is this contestant eligible for points? */
  eligibleForPoints?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this contestant be hidden from users? */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Season that this contestant is participating in */
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyContestantID?: InputMaybe<Scalars['String']['input']>;
  /** URI to the audio stream for this contestant in Transcribble. */
  transcribbleAudioURI?: InputMaybe<Scalars['String']['input']>;
  /** Tyres assigned to this contestant for the season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Tyre sets assigned to this contestant for the season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContestantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyContestant_IdOperatorsInput>;
  chassisNumber?: InputMaybe<FilterFindManyContestantChassisNumberOperatorsInput>;
  class?: InputMaybe<FilterFindManyContestantClassOperatorsInput>;
  eligibleForPoints?: InputMaybe<FilterFindManyContestantEligibleForPointsOperatorsInput>;
  hidden?: InputMaybe<FilterFindManyContestantHiddenOperatorsInput>;
  seasonID?: InputMaybe<FilterFindManyContestantSeasonIdOperatorsInput>;
  startNumber?: InputMaybe<FilterFindManyContestantStartNumberOperatorsInput>;
  teamID?: InputMaybe<FilterFindManyContestantTeamIdOperatorsInput>;
  thirdPartyContestantID?: InputMaybe<FilterFindManyContestantThirdPartyContestantIdOperatorsInput>;
};

export type FilterFindManyContestantSeasonIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyContestantStartNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContestantTeamIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyContestantThirdPartyContestantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContestant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCurrentInput = {
  /** A */
  amps?: InputMaybe<Scalars['Float']['input']>;
  /** mA */
  milliamps?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDamperAdjusterInput = {
  /** Maximum setting, if using min/max/step */
  maxSetting?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum setting, if using min/max/step */
  minSetting?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settingNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Increment to suggest values in, if using min/max/step */
  step?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDamperConfigInput = {
  forceTable?: InputMaybe<FilterFindManyForceTableInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Define which damper clicks are associated with this setting */
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyDampingRateInput = {
  /** Nms/m */
  newtonSecondsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** Nms/mm */
  newtonSecondsPerMillimetre?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·s/in */
  poundForceSecondsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDashboardInput = {
  /** Dashboard reading of fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Dashboard reading of fuel amount at the start of the run */
  mFuelRunStart?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDefaultFlexLayoutConfigsInput = {
  BOP?: InputMaybe<Scalars['MongoID']['input']>;
  KPI?: InputMaybe<Scalars['MongoID']['input']>;
  REPORT?: InputMaybe<Scalars['MongoID']['input']>;
  RUNSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPOVERVIEW?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSANDBOX?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SIMULATION?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyDensityInput = {
  /** kg/m³ */
  kilogramsPerCubicMetre?: InputMaybe<Scalars['Float']['input']>;
  /** kg/L */
  kilogramsPerLitre?: InputMaybe<Scalars['Float']['input']>;
  /** lb/ft³ */
  poundsPerCubicFoot?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyDepartmentInput = {
  AND?: InputMaybe<Array<FilterFindManyDepartmentInput>>;
  OR?: InputMaybe<Array<FilterFindManyDepartmentInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDepartmentOperatorsInput>;
  /** Search in a radius around a coordinates point. */
  geoNear?: InputMaybe<GeoNear>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDepartmentNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDepartmentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDepartment_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyDepartmentNameOperatorsInput>;
};

export type FilterFindManyDepartment_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDifferentialConfigInput = {
  /** Is this differential config allowed to be selected in new car setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  maxPreloadForce?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rampAccel?: InputMaybe<Scalars['Float']['input']>;
  rampDecel?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyDriverChampionshipStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  points: Scalars['Int']['input'];
  /** Historical race finish positions of this driver in this season. Null values represent DNFs. Should only be used for pre-session standings data. */
  prevRacePositions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDynoConfigColumnsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** runSheet.tyreSetID, setup.mCar, etc. */
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Tyre, Weight, etc. */
  header?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDynoConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyDynoConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyDynoConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDynoConfigOperatorsInput>;
  columns?: InputMaybe<Array<InputMaybe<FilterFindManyDynoConfigColumnsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDynoConfigNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDynoConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDynoConfig_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyDynoConfigNameOperatorsInput>;
};

export type FilterFindManyDynoConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEnergyInput = {
  /** J */
  joules?: InputMaybe<Scalars['Float']['input']>;
  /** kJ */
  kilojoules?: InputMaybe<Scalars['Float']['input']>;
  /** kWh */
  kilowattHours?: InputMaybe<Scalars['Float']['input']>;
  /** MJ */
  megajoules?: InputMaybe<Scalars['Float']['input']>;
  /** Wh */
  wattHours?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyEventContestantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of chassis used, if different for this event. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this event. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyres allocated to this contestant for this event (like during races where only tyres handed out at this very race are permitted). */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyre sets allocated to this contestant for this event. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEventInput = {
  AND?: InputMaybe<Array<FilterFindManyEventInput>>;
  /** Density of the fuel */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Number of this event in the season */
  NEventSeason?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyEventInput>>;
  /** Default SoCRequired values to use during this event (assuming single track layout) */
  SoCRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEventOperatorsInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Fuel/SoC/Energy consumptions for each track layout in this event. */
  consumptions?: InputMaybe<Array<InputMaybe<FilterFindManyLayoutConsumptionInput>>>;
  contestants?: InputMaybe<Array<InputMaybe<FilterFindManyEventContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumEventDebriefNotesMode>;
  /** Default energyRequired values to use during this event (assuming single track layout) */
  energyRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  /** Energy sweep information for Formula E */
  energySweep?: InputMaybe<Scalars['JSON']['input']>;
  enumEventType?: InputMaybe<EnumEventEnumEventType>;
  enumEventVenue?: InputMaybe<EnumEventEnumEventVenue>;
  /** e.g. Race, Test, etc. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Default fuelRequired values to use during this event (assuming single track layout) */
  fuelRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  /** Should the iRacing service populate this event when an unknown event is encountered? */
  iRacingServiceIsNextEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of issues related to this event. */
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Reference laptimes for each track layout in this event. */
  referenceLaptimes?: InputMaybe<Array<InputMaybe<FilterFindManyEventReferenceLaptimesInput>>>;
  /** Selected authors for the event report (person reference plus a name snapshot). */
  reportAuthors?: InputMaybe<Array<InputMaybe<FilterFindManyEventReportAuthorsInput>>>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Time of event end in local time */
  tEventEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of event start in local time */
  tEventStart?: InputMaybe<Scalars['Date']['input']>;
  tLapAverage?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyEventID?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumEventType>;
  tyreDefaults?: InputMaybe<Array<InputMaybe<FilterFindManyEventTyreDefaultsSetInput>>>;
  tyreDefaultsFL?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsFR?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsRL?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsRR?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsWetFL?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsWetFR?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsWetRL?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  tyreDefaultsWetRR?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
};

export type FilterFindManyEventNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEventOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEvent_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyEventNameOperatorsInput>;
  seasonID?: InputMaybe<FilterFindManyEventSeasonIdOperatorsInput>;
  tEventEnd?: InputMaybe<FilterFindManyEventTEventEndOperatorsInput>;
  tEventStart?: InputMaybe<FilterFindManyEventTEventStartOperatorsInput>;
  tLapAverage?: InputMaybe<FilterFindManyEventTLapAverageOperatorsInput>;
  thirdPartyEventID?: InputMaybe<FilterFindManyEventThirdPartyEventIdOperatorsInput>;
  trackID?: InputMaybe<FilterFindManyEventTrackIdOperatorsInput>;
};

export type FilterFindManyEventReferenceLaptimesInput = {
  /** Reference Laptime for ATTACK lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for COOL lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for FCY lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for IN lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUT lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUTIN lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PITLANE lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PREP lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PUSH lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for QUALI lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SAFETYCAR lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SHAKEDOWN lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SLOW lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TARGET lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOGRID lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPADDOCK lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPITS lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for UNFINISHED lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  calculationMethod?: InputMaybe<EnumEventReferenceLaptimesCalculationMethod>;
  /** Reference Laptime when using the calculation method "RATIO" */
  referenceLaptime?: InputMaybe<Scalars['Float']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyEventReportAuthorsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyEventSeasonIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEventTEventEndOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyEventTEventStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyEventTLapAverageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyEventThirdPartyEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyEventTrackIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEventTyreDefaultsInput = {
  /** Suggested bare minimum tyre pressure for this event. */
  pTyreMin?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested minimum pressure at the start of a run for this event. */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested pressure at the start of a run for this event. */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested tyre pressure target for this event. */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyEventTyreDefaultsSetInput = {
  frontLeft?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  frontRight?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  rearLeft?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  rearRight?: InputMaybe<FilterFindManyEventTyreDefaultsInput>;
  /** Which compound should these defaults be applied on? */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Which tyre type should these defaults be applied on? */
  tyreType?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFlexLayoutConfigGlobalXAxisInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  gain?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumFlexLayoutConfigGlobalXAxisType>;
};

export type FilterFindManyFlexLayoutConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyFlexLayoutConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyFlexLayoutConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFlexLayoutConfigOperatorsInput>;
  globalXAxis?: InputMaybe<FilterFindManyFlexLayoutConfigGlobalXAxisInput>;
  intendedFor?: InputMaybe<EnumFlexLayoutConfigIntendedFor>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration recognised by flexlayout-react */
  model?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** If this is non-empty, only users with one of these roles can see this config. */
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFlexLayoutConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFlexLayoutConfig_IdOperatorsInput>;
};

export type FilterFindManyFlexLayoutConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyForceInput = {
  /** N */
  newtons?: InputMaybe<Scalars['Float']['input']>;
  /** lbf */
  poundsForce?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyForceTableInput = {
  /** Acceleration (ddx) values */
  acceleration?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F1 */
  dampingForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F0 */
  force?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F2 */
  inertanceForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Velocity (dx) values */
  velocity?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Displacement values */
  x?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  xMax?: InputMaybe<Scalars['Float']['input']>;
  xMin?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyFrequencyInput = {
  /** Hz */
  hertz?: InputMaybe<Scalars['Float']['input']>;
  /** kHz */
  kilohertz?: InputMaybe<Scalars['Float']['input']>;
  /** MHz */
  megahertz?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyGenericRunSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  blockBackgroundColour?: InputMaybe<Scalars['String']['input']>;
  brakeFields?: InputMaybe<Array<InputMaybe<EnumBrakeBlockField>>>;
  /** A map of colorable things to colors */
  colorMap?: InputMaybe<Scalars['JSON']['input']>;
  defaultOpenState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order in which to display visible run energy fields. */
  energyFieldOrder?: InputMaybe<Array<InputMaybe<EnumGenericRunSheetStyleBlockEnergyFieldOrder>>>;
  /** Source of the lap end energy value */
  energyLapEndSource?: InputMaybe<Scalars['String']['input']>;
  energyType?: InputMaybe<EnumEnergyType>;
  field?: InputMaybe<Scalars['String']['input']>;
  /** Field name for first comment box in a double comment block. */
  field1?: InputMaybe<Scalars['String']['input']>;
  /** Field name for second comment box in a double comment block. */
  field2?: InputMaybe<Scalars['String']['input']>;
  fuelColumns?: InputMaybe<Array<EnumFuelColumn>>;
  fuelFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The height of the block within the grid */
  height?: InputMaybe<Scalars['Int']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isShownWhenFolded?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Label on first comment box in a double comment block. */
  label1?: InputMaybe<Scalars['String']['input']>;
  /** Label on second comment box in a double comment block. */
  label2?: InputMaybe<Scalars['String']['input']>;
  /** Ordered columns to show in the lap table */
  lapColumns?: InputMaybe<Array<InputMaybe<FilterFindManyLapColumnInput>>>;
  lapCountBlockFieldOrder?: InputMaybe<Array<InputMaybe<FilterFindManyGenericRunSheetStyleBlockLapCountBlockFieldOrderInput>>>;
  lapFlags?: InputMaybe<FilterFindManyLapFlagLabelsInput>;
  /** Names of lapKPI fields to show */
  lapKPIs?: InputMaybe<Array<InputMaybe<FilterFindManyGenericRunSheetStyleBlockLapKpIsInput>>>;
  manualLapInputByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  pressureUnit?: InputMaybe<EnumPressureUnit>;
  rows?: InputMaybe<Scalars['Float']['input']>;
  /** Order in which to display visible run energy fields. */
  runEnergyFieldOrder?: InputMaybe<Array<EnumRunEnergyField>>;
  runEnergyFields?: InputMaybe<FilterFindManyRunEnergyFieldLabelsInput>;
  runKPIRows?: InputMaybe<Array<InputMaybe<FilterFindManyRunKpiTableRowInput>>>;
  runKPITable?: InputMaybe<Array<InputMaybe<FilterFindManyGenericRunSheetStyleBlockRunKpiTableInput>>>;
  setupSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Defines the visibility of the ambient and track condition in the weather block */
  showAmbientAndTrackCondition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the extended combustion consumption fields. */
  showExtendedConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the fuel density input box. */
  showFuelDensityInput?: InputMaybe<Scalars['Boolean']['input']>;
  showGetPreviousRunPostPressureButton?: InputMaybe<Scalars['Boolean']['input']>;
  showGetRecommendationButton?: InputMaybe<Scalars['Boolean']['input']>;
  showLapTypeColors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the maximum amount of laps per consumption for a given fuel load fields. */
  showMaxLapsPerConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  showMinimumPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  showPostRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showPreRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showSurfaceTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showTargetPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreReferencePressure?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSelector?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSetSelector?: InputMaybe<Scalars['Boolean']['input']>;
  staggerSettings?: InputMaybe<FilterFindManyGenericRunSheetStyleBlockStaggerSettingsInput>;
  standardTyrePressureBox?: InputMaybe<FilterFindManyGenericRunSheetStyleBlockStandardTyrePressureBoxInput>;
  standardTyreTempBox?: InputMaybe<FilterFindManyGenericRunSheetStyleBlockStandardTyreTempBoxInput>;
  style?: InputMaybe<EnumRunSheetStyleBlockStyle>;
  temperatureUnit?: InputMaybe<EnumTemperatureUnit>;
  title?: InputMaybe<Scalars['String']['input']>;
  treadDepthUnit?: InputMaybe<EnumLengthUnit>;
  type?: InputMaybe<EnumGenericRunSheetStyleBlockType>;
  tyreTableRows?: InputMaybe<Array<InputMaybe<FilterFindManyTyreTableBlockRowInput>>>;
  /** Number of tread depth measurements to allow. Use `0` or `null` to hide the input. */
  tyreTreadDepthMeasurements?: InputMaybe<Scalars['Int']['input']>;
  unitSystem?: InputMaybe<EnumUnitSystem>;
  velocityUnit?: InputMaybe<EnumVelocityUnit>;
  /** Ordered weather block fields to show */
  weatherFieldOrder?: InputMaybe<Array<EnumWeatherBlockField>>;
  /** The width of the block within the grid */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterFindManyGenericRunSheetStyleBlockLapCountBlockFieldOrderInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  field?: InputMaybe<EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyGenericRunSheetStyleBlockLapKpIsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<FilterFindManyValueLimitInput>;
  upperLimit?: InputMaybe<FilterFindManyValueLimitInput>;
};

export type FilterFindManyGenericRunSheetStyleBlockRunKpiTableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  defaultEditable?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<FilterFindManyGenericRunSheetStyleBlockRunKpiTableRowsInput>>>;
};

export type FilterFindManyGenericRunSheetStyleBlockRunKpiTableRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyRunKpiTableRowFieldInput>>>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyGenericRunSheetStyleBlockStaggerSettingsInput = {
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
};

export type FilterFindManyGenericRunSheetStyleBlockStandardTyrePressureBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumPressureOption>>>;
  unit?: InputMaybe<EnumPressureUnit>;
};

export type FilterFindManyGenericRunSheetStyleBlockStandardTyreTempBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumTemperatureOption>>>;
  unit?: InputMaybe<EnumTemperatureUnit>;
};

export type FilterFindManyGeoLocationInput = {
  /** [longitude, latitude] in decimal degrees */
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Only "Point" is supported */
  type?: InputMaybe<EnumGeoLocationType>;
};

export type FilterFindManyIssueQueryAcknowledgedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryAcknowledgedByIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryAreaOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryAssigneeIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCancelledAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryCancelledByIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryClosedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryClosedByIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCommentsAuthorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCommentsCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryCommentsOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIssueQueryComments_IdOperatorsInput>;
  authorID?: InputMaybe<FilterFindManyIssueQueryCommentsAuthorIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyIssueQueryCommentsCreatedAtOperatorsInput>;
  text?: InputMaybe<FilterFindManyIssueQueryCommentsTextOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyIssueQueryCommentsUpdatedAtOperatorsInput>;
};

export type FilterFindManyIssueQueryCommentsTextOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryCommentsUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryComments_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryContainmentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryContestantIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryCreatedByIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryDepartmentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryDescriptionDetailsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyIssueQueryInput = {
  AND?: InputMaybe<Array<FilterFindManyIssueQueryInput>>;
  OR?: InputMaybe<Array<FilterFindManyIssueQueryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIssueQueryOperatorsInput>;
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  area?: InputMaybe<Scalars['String']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<FilterFindManyCommentInput>>>;
  containment?: InputMaybe<Scalars['String']['input']>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  departmentID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDetails?: InputMaybe<Scalars['String']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  issueStatus?: InputMaybe<EnumIssueQueryIssueStatus>;
  linkedIssueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagLabelSort?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EnumIssueQueryPriority>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  rootCause?: InputMaybe<Scalars['String']['input']>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thirdPartyIssueID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyIssueQueryIssueStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumIssueQueryIssueStatus>;
  gte?: InputMaybe<EnumIssueQueryIssueStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumIssueQueryIssueStatus>>>;
  lt?: InputMaybe<EnumIssueQueryIssueStatus>;
  lte?: InputMaybe<EnumIssueQueryIssueStatus>;
  ne?: InputMaybe<EnumIssueQueryIssueStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumIssueQueryIssueStatus>>>;
};

export type FilterFindManyIssueQueryLinkedIssueIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIssueQueryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIssueQuery_IdOperatorsInput>;
  acknowledgedAt?: InputMaybe<FilterFindManyIssueQueryAcknowledgedAtOperatorsInput>;
  acknowledgedByID?: InputMaybe<FilterFindManyIssueQueryAcknowledgedByIdOperatorsInput>;
  area?: InputMaybe<FilterFindManyIssueQueryAreaOperatorsInput>;
  assigneeIDs?: InputMaybe<FilterFindManyIssueQueryAssigneeIDsOperatorsInput>;
  cancelledAt?: InputMaybe<FilterFindManyIssueQueryCancelledAtOperatorsInput>;
  cancelledByID?: InputMaybe<FilterFindManyIssueQueryCancelledByIdOperatorsInput>;
  carSetupID?: InputMaybe<FilterFindManyIssueQueryCarSetupIdOperatorsInput>;
  category?: InputMaybe<FilterFindManyIssueQueryCategoryOperatorsInput>;
  closedAt?: InputMaybe<FilterFindManyIssueQueryClosedAtOperatorsInput>;
  closedByID?: InputMaybe<FilterFindManyIssueQueryClosedByIdOperatorsInput>;
  comments?: InputMaybe<FilterFindManyIssueQueryCommentsOperatorsInput>;
  containment?: InputMaybe<FilterFindManyIssueQueryContainmentOperatorsInput>;
  contestantIDs?: InputMaybe<FilterFindManyIssueQueryContestantIDsOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyIssueQueryCreatedAtOperatorsInput>;
  createdByID?: InputMaybe<FilterFindManyIssueQueryCreatedByIdOperatorsInput>;
  departmentID?: InputMaybe<FilterFindManyIssueQueryDepartmentIdOperatorsInput>;
  description?: InputMaybe<FilterFindManyIssueQueryDescriptionOperatorsInput>;
  descriptionDetails?: InputMaybe<FilterFindManyIssueQueryDescriptionDetailsOperatorsInput>;
  eventID?: InputMaybe<FilterFindManyIssueQueryEventIdOperatorsInput>;
  index?: InputMaybe<FilterFindManyIssueQueryIndexOperatorsInput>;
  issueStatus?: InputMaybe<FilterFindManyIssueQueryIssueStatusOperatorsInput>;
  linkedIssueIDs?: InputMaybe<FilterFindManyIssueQueryLinkedIssueIDsOperatorsInput>;
  number?: InputMaybe<FilterFindManyIssueQueryNumberOperatorsInput>;
  partID?: InputMaybe<FilterFindManyIssueQueryPartIdOperatorsInput>;
  primaryTagID?: InputMaybe<FilterFindManyIssueQueryPrimaryTagIdOperatorsInput>;
  primaryTagLabelSort?: InputMaybe<FilterFindManyIssueQueryPrimaryTagLabelSortOperatorsInput>;
  priority?: InputMaybe<FilterFindManyIssueQueryPriorityOperatorsInput>;
  raceSeriesID?: InputMaybe<FilterFindManyIssueQueryRaceSeriesIdOperatorsInput>;
  rootCause?: InputMaybe<FilterFindManyIssueQueryRootCauseOperatorsInput>;
  runSheetID?: InputMaybe<FilterFindManyIssueQueryRunSheetIdOperatorsInput>;
  seasonID?: InputMaybe<FilterFindManyIssueQuerySeasonIdOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyIssueQuerySessionIdOperatorsInput>;
  subTaskIDs?: InputMaybe<FilterFindManyIssueQuerySubTaskIDsOperatorsInput>;
  tagIDs?: InputMaybe<FilterFindManyIssueQueryTagIDsOperatorsInput>;
  targetDate?: InputMaybe<FilterFindManyIssueQueryTargetDateOperatorsInput>;
  teamIDs?: InputMaybe<FilterFindManyIssueQueryTeamIDsOperatorsInput>;
  thirdPartyIssueID?: InputMaybe<FilterFindManyIssueQueryThirdPartyIssueIdOperatorsInput>;
  timeInfo?: InputMaybe<FilterFindManyIssueQueryTimeInfoOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyIssueQueryUpdatedAtOperatorsInput>;
};

export type FilterFindManyIssueQueryPartIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryPrimaryTagIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryPrimaryTagLabelSortOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumIssueQueryPriority>;
  gte?: InputMaybe<EnumIssueQueryPriority>;
  in?: InputMaybe<Array<InputMaybe<EnumIssueQueryPriority>>>;
  lt?: InputMaybe<EnumIssueQueryPriority>;
  lte?: InputMaybe<EnumIssueQueryPriority>;
  ne?: InputMaybe<EnumIssueQueryPriority>;
  nin?: InputMaybe<Array<InputMaybe<EnumIssueQueryPriority>>>;
};

export type FilterFindManyIssueQueryRaceSeriesIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryRootCauseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQuerySeasonIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQuerySessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQuerySubTaskIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryTagIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryTargetDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQueryTeamIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryThirdPartyIssueIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIssueQueryTimeInfoOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIssueQueryUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyIssueQuery_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyJobAssigneeIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyJobCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyJobDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyJobIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyJobInput = {
  AND?: InputMaybe<Array<FilterFindManyJobInput>>;
  OR?: InputMaybe<Array<FilterFindManyJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyJobOperatorsInput>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  /** The id of the parent job or issue that this task is assigned to */
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyJobNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyJobOperatorsInput = {
  _id?: InputMaybe<FilterFindManyJob_IdOperatorsInput>;
  assigneeIDs?: InputMaybe<FilterFindManyJobAssigneeIDsOperatorsInput>;
  category?: InputMaybe<FilterFindManyJobCategoryOperatorsInput>;
  description?: InputMaybe<FilterFindManyJobDescriptionOperatorsInput>;
  index?: InputMaybe<FilterFindManyJobIndexOperatorsInput>;
  number?: InputMaybe<FilterFindManyJobNumberOperatorsInput>;
  parentID?: InputMaybe<FilterFindManyJobParentIdOperatorsInput>;
  priority?: InputMaybe<FilterFindManyJobPriorityOperatorsInput>;
  runSheetID?: InputMaybe<FilterFindManyJobRunSheetIdOperatorsInput>;
};

export type FilterFindManyJobParentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyJobPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumJobPriority>;
  gte?: InputMaybe<EnumJobPriority>;
  in?: InputMaybe<Array<InputMaybe<EnumJobPriority>>>;
  lt?: InputMaybe<EnumJobPriority>;
  lte?: InputMaybe<EnumJobPriority>;
  ne?: InputMaybe<EnumJobPriority>;
  nin?: InputMaybe<Array<InputMaybe<EnumJobPriority>>>;
};

export type FilterFindManyJobRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyKinematicsExternalModelInput = {
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  uprightPosition?: InputMaybe<Scalars['Float']['input']>;
  uprightPositionName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLapColumnInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<EnumLapColumnField>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<FilterFindManyValueLimitInput>;
  upperLimit?: InputMaybe<FilterFindManyValueLimitInput>;
};

export type FilterFindManyLapDataInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow and should be excluded from average calculation? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Received a Track Limit Warning from Race Control */
  BTrackLimitWarning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Coded message from driver */
  driverCallout?: InputMaybe<Scalars['String']['input']>;
  /** Coded message from driver */
  driverCallout2?: InputMaybe<Scalars['String']['input']>;
  /** Map of kpi fields to their values for analysis. Input syntax is array of tuples, like `kpi: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  kpi?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  /** Fuel mass consumption in this lap */
  mFuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel mass remaining at the end of this lap. */
  mFuelLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  /** Energy comsumption in this lap (kWh) */
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Energy remaining (kWh)  at the end of this lap. */
  rEnergyLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** SoC comsumption in this lap (%) */
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** SOC (%) remaining at the end of this lap. */
  rSOCLapEnd?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** Source of the lap data */
  source?: InputMaybe<EnumLapDataSource>;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an IN lap, indicates when the driver crossed the pit entry line. */
  tDayPitIn?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an OUT lap, indicates when the driver crossed the pit exit line. */
  tDayPitOut?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Time spent in pits if the lap started from the pit lane. */
  tInPit?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times. */
  tSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tSessionRemainingLapStart?: InputMaybe<Scalars['Float']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<FilterFindManyTrackStateInput>>>;
  /** Tyre compound information */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** Lap flag field labels mapped to their display names. Null or unset fields are not displayed. */
export type FilterFindManyLapFlagLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLapInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this an IN lap? */
  BPitIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this an OUT lap? */
  BPitOut?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lap number in run from timing */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in run from car data */
  NLapRunCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in run from manual mode */
  NLapRunManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from timing */
  NLapSession?: InputMaybe<Scalars['Int']['input']>;
  /** Lap number in session from car data */
  NLapSessionCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from manual mode */
  NLapSessionManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from timing */
  NLapStint?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from car data */
  NLapStintCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from manual mode */
  NLapStintManual?: InputMaybe<Scalars['Float']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<FilterFindManyLapDataInput>>>;
  /** Amount of energy (fuel/battery) at the start of this lap. */
  energyLapStart?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining */
  energyRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining as data input (e.g. from telemetry) */
  energyRemainingData?: InputMaybe<Scalars['Float']['input']>;
  fuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Comments made by the driver */
  lapComment?: InputMaybe<Scalars['String']['input']>;
  /** Systems info generated during the lap */
  lapCommentSystems?: InputMaybe<Scalars['String']['input']>;
  /** Map of lap KPI fields to their values for car-data-related analysis. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  laptimeServiceHash?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** The run sheet this lap belongs to. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector, provided by a timing service. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Laptime where input directly by a user. */
  tLapManual?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times given manually by a user. */
  tSectorsManual?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by an alternative official source. */
  tSectorsOfficial?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by a timing service. */
  tSectorsTiming?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of timing KPI fields to their values for timing-related analysis. Input syntax is array of tuples, like `timingKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  timingKPI?: InputMaybe<Scalars['JSON']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<FilterFindManyTrackStateInput>>>;
  /** Tyre compound information from timing stream */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyLapSequenceInput = {
  AND?: InputMaybe<Array<FilterFindManyLapSequenceInput>>;
  OR?: InputMaybe<Array<FilterFindManyLapSequenceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLapSequenceOperatorsInput>;
  laps?: InputMaybe<Array<InputMaybe<FilterFindManyLapSequenceLapsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLapSequenceLapsInput = {
  NLap?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lapType?: InputMaybe<EnumLapSequenceLapsLapType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLapSequenceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLapSequence_IdOperatorsInput>;
};

export type FilterFindManyLapSequenceTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyLapSequenceTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyLapSequenceTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLapSequenceTemplateOperatorsInput>;
  laps?: InputMaybe<Array<InputMaybe<FilterFindManyLapSequenceTemplateLapsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLapSequenceTemplateLapsInput = {
  /** Lap number in sequence */
  NLap?: InputMaybe<Scalars['Float']['input']>;
  lapType?: InputMaybe<EnumLapSequenceTemplateLapsLapType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLapSequenceTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLapSequenceTemplate_IdOperatorsInput>;
};

export type FilterFindManyLapSequenceTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLapSequence_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** Collection of tuples defining bounds to automatically classify laps. Does not apply to in/out/race control lap types. Comparisons are to be made with `<` or `>=` at aligning bounds. Minimum value is 0 and maximum value is 1000000. */
export type FilterFindManyLaptimeThresholdsInput = {
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as cool. */
  cool?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as prep. */
  prep?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as push. */
  push?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as slow. */
  slow?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as target. */
  target?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FilterFindManyLayoutConsumptionInput = {
  SoCRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  energyRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  fuelRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLengthInput = {
  /** cm */
  centimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft */
  feet?: InputMaybe<Scalars['Float']['input']>;
  /** in */
  inches?: InputMaybe<Scalars['Float']['input']>;
  /** km */
  kilometres?: InputMaybe<Scalars['Float']['input']>;
  /** m */
  metres?: InputMaybe<Scalars['Float']['input']>;
  /** μm */
  micrometres?: InputMaybe<Scalars['Float']['input']>;
  /** mi */
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** mm */
  millimetres?: InputMaybe<Scalars['Float']['input']>;
  /** thou */
  thou?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyLiveStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  currentLocation?: InputMaybe<EnumLiveStandingCurrentLocation>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<FilterFindManyBestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<FilterFindManyBestValuesFastestSectorInput>>>;
  /** Does this driver have the fastest lap in the session? Only one driver should have this true at a time. */
  hasFastestLap?: InputMaybe<Scalars['Boolean']['input']>;
  lapsCompleted?: InputMaybe<Scalars['Int']['input']>;
  /** 1-indexed rank of this driver with respect to the rest of the grid */
  position?: InputMaybe<Scalars['Int']['input']>;
  postRacePenalty?: InputMaybe<FilterFindManyLiveStandingPostRacePenaltyInput>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLiveStandingPostRacePenaltyInput = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  totalTimePenalty?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyLocalConnectionInput = {
  dataMapping?: InputMaybe<EnumLocalConnectionDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  outputFolder?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Float']['input']>;
  useSSL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyLocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<FilterFindManyGeoLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLogInput = {
  AND?: InputMaybe<Array<FilterFindManyLogInput>>;
  OR?: InputMaybe<Array<FilterFindManyLogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLogOperatorsInput>;
  logLevel?: InputMaybe<EnumLogLogLevel>;
  /** A single log from the source service */
  message?: InputMaybe<Scalars['String']['input']>;
  serviceSource?: InputMaybe<EnumLogServiceSource>;
  userID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLogLogLevelOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumLogLogLevel>;
  gte?: InputMaybe<EnumLogLogLevel>;
  in?: InputMaybe<Array<InputMaybe<EnumLogLogLevel>>>;
  lt?: InputMaybe<EnumLogLogLevel>;
  lte?: InputMaybe<EnumLogLogLevel>;
  ne?: InputMaybe<EnumLogLogLevel>;
  nin?: InputMaybe<Array<InputMaybe<EnumLogLogLevel>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLog_IdOperatorsInput>;
  logLevel?: InputMaybe<FilterFindManyLogLogLevelOperatorsInput>;
  serviceSource?: InputMaybe<FilterFindManyLogServiceSourceOperatorsInput>;
  userID?: InputMaybe<FilterFindManyLogUserIdOperatorsInput>;
};

export type FilterFindManyLogServiceSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumLogServiceSource>;
  gte?: InputMaybe<EnumLogServiceSource>;
  in?: InputMaybe<Array<InputMaybe<EnumLogServiceSource>>>;
  lt?: InputMaybe<EnumLogServiceSource>;
  lte?: InputMaybe<EnumLogServiceSource>;
  ne?: InputMaybe<EnumLogServiceSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumLogServiceSource>>>;
};

export type FilterFindManyLogUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyManufacturerInput = {
  AND?: InputMaybe<Array<FilterFindManyManufacturerInput>>;
  OR?: InputMaybe<Array<FilterFindManyManufacturerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyManufacturerOperatorsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyManufacturerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyManufacturerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyManufacturer_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyManufacturerNameOperatorsInput>;
};

export type FilterFindManyManufacturer_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMassInput = {
  /** g */
  grams?: InputMaybe<Scalars['Float']['input']>;
  /** kg */
  kilograms?: InputMaybe<Scalars['Float']['input']>;
  /** mg */
  milligrams?: InputMaybe<Scalars['Float']['input']>;
  /** oz */
  ounces?: InputMaybe<Scalars['Float']['input']>;
  /** lb */
  pounds?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyMassPropertiesInput = {
  COGx?: InputMaybe<Scalars['Float']['input']>;
  COGy?: InputMaybe<Scalars['Float']['input']>;
  COGz?: InputMaybe<Scalars['Float']['input']>;
  Ixx?: InputMaybe<Scalars['Float']['input']>;
  Iyy?: InputMaybe<Scalars['Float']['input']>;
  Izz?: InputMaybe<Scalars['Float']['input']>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  /** Allowable mass range, for when a set mass value doesn't apply */
  massRange?: InputMaybe<AdjustableMassInput>;
};

export type FilterFindManyMomentOfInertiaInput = {
  /** kgm² */
  kilogramMetresSquared?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/s² */
  poundForceFeetSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyNotificationConfigInput = {
  faultAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  faultCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  faultStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
  jobAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  jobCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  jobStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyOneTimingWeatherServiceConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyOneTimingWeatherServiceConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyOneTimingWeatherServiceConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOneTimingWeatherServiceConfigOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event IDs to which the weather data should be published. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Weather station's latitude from geolocation */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logLevel?: InputMaybe<EnumOneTimingWeatherServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weather station's longitude from geolocation */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Name for this set of configuration settings. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** One Timing server port. */
  timingPort?: InputMaybe<Scalars['Int']['input']>;
  /** One Timing server address. */
  timingURL?: InputMaybe<Scalars['String']['input']>;
  /** Time interval in seconds between two API data updates. */
  updateInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyOneTimingWeatherServiceConfigNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOneTimingWeatherServiceConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOneTimingWeatherServiceConfig_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyOneTimingWeatherServiceConfigNameOperatorsInput>;
};

export type FilterFindManyOneTimingWeatherServiceConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPackageAuthorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPackageInput = {
  AND?: InputMaybe<Array<FilterFindManyPackageInput>>;
  OR?: InputMaybe<Array<FilterFindManyPackageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPackageOperatorsInput>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<FilterFindManyPackageItemsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  useAsCopyReference?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyPackageItemsInput = {
  /** 'setup.front.hRide' or 'spec.specID.adjustables.adjIndex.LOCATION' */
  path?: InputMaybe<Scalars['String']['input']>;
  /** string | number | null (also can 'delete' certain things from a setup) */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPackageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPackage_IdOperatorsInput>;
  authorID?: InputMaybe<FilterFindManyPackageAuthorIdOperatorsInput>;
};

export type FilterFindManyPackage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPartEligibleEventTypesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumPartEligibleEventTypes>;
  gte?: InputMaybe<EnumPartEligibleEventTypes>;
  in?: InputMaybe<Array<InputMaybe<EnumPartEligibleEventTypes>>>;
  lt?: InputMaybe<EnumPartEligibleEventTypes>;
  lte?: InputMaybe<EnumPartEligibleEventTypes>;
  ne?: InputMaybe<EnumPartEligibleEventTypes>;
  nin?: InputMaybe<Array<InputMaybe<EnumPartEligibleEventTypes>>>;
};

export type FilterFindManyPartInput = {
  AND?: InputMaybe<Array<FilterFindManyPartInput>>;
  OR?: InputMaybe<Array<FilterFindManyPartInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPartOperatorsInput>;
  /** Can this very part be used multiple times on a car. For 'virtual parts' or other special applications. Overrides the setting of the specification. */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  eligibleEventTypes?: InputMaybe<EnumPartEligibleEventTypes>;
  /** To be used for dummy parts or at user discretion for special applications. */
  isVirtualPart?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeMileage?: InputMaybe<Scalars['Float']['input']>;
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  manufacturerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  partStatus?: InputMaybe<FilterFindManyPartStatusInput>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  readingLocationOverride?: InputMaybe<Array<InputMaybe<EnumPartReadingLocationOverride>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementHistoryIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPartInstanceInput = {
  AND?: InputMaybe<Array<FilterFindManyPartInstanceInput>>;
  OR?: InputMaybe<Array<FilterFindManyPartInstanceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPartInstanceOperatorsInput>;
  measurements?: InputMaybe<Array<InputMaybe<FilterFindManyPartInstanceMeasurementInput>>>;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  readingLocation?: InputMaybe<EnumReadingLocation>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemReferenceDate?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyPartInstanceMeasurementCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPartInstanceMeasurementInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<FilterFindManyPartInstanceMeasurementCoordinatesInput>;
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  idx?: InputMaybe<Scalars['Float']['input']>;
  rotation?: InputMaybe<FilterFindManyPartInstanceMeasurementRotationInput>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPartInstanceMeasurementRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPartInstanceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPartInstance_IdOperatorsInput>;
  specificationID?: InputMaybe<FilterFindManyPartInstanceSpecificationIdOperatorsInput>;
};

export type FilterFindManyPartInstanceSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartInstance_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartLifetimeMileageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyPartManufacturerPartIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPartManufacturerSerialNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPartOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPart_IdOperatorsInput>;
  description?: InputMaybe<FilterFindManyPartDescriptionOperatorsInput>;
  eligibleEventTypes?: InputMaybe<FilterFindManyPartEligibleEventTypesOperatorsInput>;
  lifetimeMileage?: InputMaybe<FilterFindManyPartLifetimeMileageOperatorsInput>;
  manufacturerPartID?: InputMaybe<FilterFindManyPartManufacturerPartIdOperatorsInput>;
  manufacturerSerialNumber?: InputMaybe<FilterFindManyPartManufacturerSerialNumberOperatorsInput>;
  partNumber?: InputMaybe<FilterFindManyPartPartNumberOperatorsInput>;
  reference?: InputMaybe<FilterFindManyPartReferenceOperatorsInput>;
  rootSpecificationID?: InputMaybe<FilterFindManyPartRootSpecificationIdOperatorsInput>;
  specificationID?: InputMaybe<FilterFindManyPartSpecificationIdOperatorsInput>;
  teamID?: InputMaybe<FilterFindManyPartTeamIdOperatorsInput>;
  teamIDs?: InputMaybe<FilterFindManyPartTeamIDsOperatorsInput>;
  userEnumPartTypeID?: InputMaybe<FilterFindManyPartUserEnumPartTypeIdOperatorsInput>;
};

export type FilterFindManyPartPartNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPartReferenceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPartRootSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartStatusInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  statusComment?: InputMaybe<Scalars['String']['input']>;
  userEnumPartStatusID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPartTeamIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartTeamIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPartUserEnumPartTypeIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPart_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPersonAcronymOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPersonBirthdayOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyPersonEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPersonInput = {
  AND?: InputMaybe<Array<FilterFindManyPersonInput>>;
  OR?: InputMaybe<Array<FilterFindManyPersonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPersonOperatorsInput>;
  /** 3-letter acronym for drivers */
  acronym?: InputMaybe<Scalars['String']['input']>;
  behaviour?: InputMaybe<FilterFindManyBehaviourConfigInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  canopyCredentials?: InputMaybe<FilterFindManyCanopyCredentialsInput>;
  carUpdateMethod?: InputMaybe<EnumPersonCarUpdateMethod>;
  /** IDs of contestants visible to this person when logged in. */
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultFlexLayoutConfigs?: InputMaybe<FilterFindManyDefaultFlexLayoutConfigsInput>;
  defaultRunSheetCompareStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStylePhoneID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultTyreReferenceTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Default string for tyre set naming, where x=Chassis, i=Info, s=SetNumber, (c=Corner or a=Axle) */
  defaultTyreSetNameFormat?: InputMaybe<Scalars['String']['input']>;
  displayColor?: InputMaybe<Scalars['String']['input']>;
  dynoConfigID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of contestants editable to this person when logged in. */
  editableContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotificationConfig?: InputMaybe<FilterFindManyNotificationConfigInput>;
  /** IDs of events visible to this person when logged in. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this user be unable to see KPIs? */
  hideKPIs?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to track his working time? */
  isTimeTracker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to see, update and approve working times for other users? */
  isTimeTrackerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequenceTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  localConnections?: InputMaybe<Array<InputMaybe<FilterFindManyLocalConnectionInput>>>;
  mileageUnit?: InputMaybe<EnumPersonMileageUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportPicture?: InputMaybe<Scalars['String']['input']>;
  /** Collection of favourite plot page config IDs. */
  plotPageConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  privateMobile?: InputMaybe<Scalars['Float']['input']>;
  privatePhone?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<EnumPersonRole>;
  /** Collection of favourite setup overview config IDs. */
  setupOverviewConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  timeTrackerApprovalByPersonID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Collection of personal setup IDs. */
  userSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userSimulationSettings?: InputMaybe<FilterFindManyUserSimulationSettingsInput>;
  username?: InputMaybe<Scalars['String']['input']>;
  viewConfig?: InputMaybe<FilterFindManyViewConfigInput>;
  /** IDs of contestants visible to this person when logged in. */
  visibleContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of events visible to this person when logged in. */
  visibleEventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of teams visible to this person when logged in. */
  visibleTeamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  workMobile?: InputMaybe<Scalars['Float']['input']>;
  workPhone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPersonIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyPersonNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPersonOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPerson_IdOperatorsInput>;
  acronym?: InputMaybe<FilterFindManyPersonAcronymOperatorsInput>;
  birthday?: InputMaybe<FilterFindManyPersonBirthdayOperatorsInput>;
  email?: InputMaybe<FilterFindManyPersonEmailOperatorsInput>;
  isActive?: InputMaybe<FilterFindManyPersonIsActiveOperatorsInput>;
  name?: InputMaybe<FilterFindManyPersonNameOperatorsInput>;
  role?: InputMaybe<FilterFindManyPersonRoleOperatorsInput>;
  teamID?: InputMaybe<FilterFindManyPersonTeamIdOperatorsInput>;
  timeTrackerApprovalByPersonID?: InputMaybe<FilterFindManyPersonTimeTrackerApprovalByPersonIdOperatorsInput>;
  username?: InputMaybe<FilterFindManyPersonUsernameOperatorsInput>;
};

export type FilterFindManyPersonRoleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumPersonRole>;
  gte?: InputMaybe<EnumPersonRole>;
  in?: InputMaybe<Array<InputMaybe<EnumPersonRole>>>;
  lt?: InputMaybe<EnumPersonRole>;
  lte?: InputMaybe<EnumPersonRole>;
  ne?: InputMaybe<EnumPersonRole>;
  nin?: InputMaybe<Array<InputMaybe<EnumPersonRole>>>;
};

export type FilterFindManyPersonTeamIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPersonTimeTrackerApprovalByPersonIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPersonUsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPerson_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPlotConfigInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  xAxisType?: InputMaybe<EnumPlotConfigXAxisType>;
  xDataSource?: InputMaybe<Scalars['String']['input']>;
  xLabel?: InputMaybe<Scalars['String']['input']>;
  /** Object containing at least `label`, and optionally `color`, `lineStyle` (from `EnumLineStyle`), and `marker` (from `EnumMarkerType`) properties */
  yData?: InputMaybe<Scalars['JSON']['input']>;
  yDataSource?: InputMaybe<Scalars['String']['input']>;
  yLabel?: InputMaybe<Scalars['String']['input']>;
  yLines?: InputMaybe<Array<InputMaybe<FilterFindManyPlotConfigLineInput>>>;
};

export type FilterFindManyPlotConfigLineInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<EnumLineStyle>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPlotPageConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyPlotPageConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlotPageConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlotPageConfigOperatorsInput>;
  /** Number of columns in the grid. */
  gridCols?: InputMaybe<Scalars['Int']['input']>;
  /** Number of rows in the grid. */
  gridRows?: InputMaybe<Scalars['Int']['input']>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  plots?: InputMaybe<Array<InputMaybe<FilterFindManyPlotConfigInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlotPageConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlotPageConfig_IdOperatorsInput>;
  title?: InputMaybe<FilterFindManyPlotPageConfigTitleOperatorsInput>;
};

export type FilterFindManyPlotPageConfigTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPlotPageConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPointsSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyPointsSystemInput>>;
  OR?: InputMaybe<Array<FilterFindManyPointsSystemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPointsSystemOperatorsInput>;
  /** Array of points for the fastest lap */
  laptimeDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Race position cutoff for drivers eligible for points for the fastest lap. In some race series you need to be in the top 10 to get the bonus point. */
  laptimePositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  /** Array of points for the fastest lap for the teams. In some race series only the driver receives points for fastest lap. */
  laptimeTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** How much race distance needs to be completed to be eligible for points */
  positionalCompletionMin?: InputMaybe<Scalars['Float']['input']>;
  /** How much race distance in % needs to be completed to be eligible for points */
  positionalCompletionMinRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Array of driver points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of team points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sessionType?: InputMaybe<EnumSessionType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPointsSystemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPointsSystem_IdOperatorsInput>;
};

export type FilterFindManyPointsSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPowerInput = {
  /** 1hp = 745.6998715822702W */
  horsepowerMechanical?: InputMaybe<Scalars['Float']['input']>;
  /** kW */
  kilowatts?: InputMaybe<Scalars['Float']['input']>;
  /** W */
  watts?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPowertrainInput = {
  MDiffPreloadCold?: InputMaybe<Scalars['Float']['input']>;
  MDiffPreloadHot?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are arbitrary numbers. Input syntax is array of key-value tuples, like `NEngineBlanking: [["left", 5], ["right", 9]]`. */
  NEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  NFrictionFaces?: InputMaybe<Scalars['Float']['input']>;
  PPowerLevel?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampCoast?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampDrive?: InputMaybe<Scalars['Float']['input']>;
  bevelSet?: InputMaybe<PowertrainGearInput>;
  /** Map of blanking fields with values. Keys are strings like `gearboxRadiatorTapes` or `hRESSBlanking`, and values are strings describing the blanking details. Input syntax is array of key-value tuples, like `blanking: [["gearboxRadiatorTapes", "5"]]`. */
  blanking?: InputMaybe<Scalars['JSON']['input']>;
  clutch?: InputMaybe<Scalars['String']['input']>;
  clutchCylinder?: InputMaybe<Scalars['String']['input']>;
  dAirRestrictor?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the selected configuration from the spec. */
  differentialConfigName?: InputMaybe<Scalars['String']['input']>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  dropGear?: InputMaybe<PowertrainGearInput>;
  /** Map of extra engine blanking measurement fields to their values. Input syntax is array of key-value tuples, like `engineBlankingComments: [["louvres", "NONE"], ["other", true]]`. */
  engineBlankingDetails?: InputMaybe<Scalars['JSON']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  gearboxGridType?: InputMaybe<Scalars['String']['input']>;
  gears?: InputMaybe<Array<InputMaybe<PowertrainStandardGearInput>>>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hEngineBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hGearboxBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
  rBevelSet?: InputMaybe<Scalars['Float']['input']>;
  rDropGear?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rEngineBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gears to their ratios. Keys are strings like `"1"` or `"R"`, and values are ratios. Input syntax is array of key-value tuples, like `rGearRatios: [["R", 0.8], ["1", 0.3]]`. */
  rGearRatios?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rGearboxBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyPressureInput = {
  /** bar */
  bar?: InputMaybe<Scalars['Float']['input']>;
  /** inHg */
  inchesOfMercury?: InputMaybe<Scalars['Float']['input']>;
  /** kPa */
  kilopascals?: InputMaybe<Scalars['Float']['input']>;
  /** mbar */
  millibar?: InputMaybe<Scalars['Float']['input']>;
  /** Pa */
  pascals?: InputMaybe<Scalars['Float']['input']>;
  /** psi */
  psi?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProjectInput = {
  AND?: InputMaybe<Array<FilterFindManyProjectInput>>;
  OR?: InputMaybe<Array<FilterFindManyProjectInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProjectOperatorsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProjectOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProject_IdOperatorsInput>;
};

export type FilterFindManyProject_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyQualityCheckActionAssigneeIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyQualityCheckActionCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyQualityCheckActionDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyQualityCheckActionInput = {
  AND?: InputMaybe<Array<FilterFindManyQualityCheckActionInput>>;
  OR?: InputMaybe<Array<FilterFindManyQualityCheckActionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyQualityCheckActionOperatorsInput>;
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<FilterFindManyCommentInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EnumQualityCheckActionPriority>;
  status?: InputMaybe<EnumQualityCheckActionStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyQualityCheckActionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyQualityCheckAction_IdOperatorsInput>;
  assigneeIDs?: InputMaybe<FilterFindManyQualityCheckActionAssigneeIDsOperatorsInput>;
  category?: InputMaybe<FilterFindManyQualityCheckActionCategoryOperatorsInput>;
  description?: InputMaybe<FilterFindManyQualityCheckActionDescriptionOperatorsInput>;
  priority?: InputMaybe<FilterFindManyQualityCheckActionPriorityOperatorsInput>;
};

export type FilterFindManyQualityCheckActionPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumQualityCheckActionPriority>;
  gte?: InputMaybe<EnumQualityCheckActionPriority>;
  in?: InputMaybe<Array<InputMaybe<EnumQualityCheckActionPriority>>>;
  lt?: InputMaybe<EnumQualityCheckActionPriority>;
  lte?: InputMaybe<EnumQualityCheckActionPriority>;
  ne?: InputMaybe<EnumQualityCheckActionPriority>;
  nin?: InputMaybe<Array<InputMaybe<EnumQualityCheckActionPriority>>>;
};

export type FilterFindManyQualityCheckAction_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyQualityCheckInput = {
  AND?: InputMaybe<Array<FilterFindManyQualityCheckInput>>;
  OR?: InputMaybe<Array<FilterFindManyQualityCheckInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyQualityCheckOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  qualityCheckActionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyQualityCheckOperatorsInput = {
  _id?: InputMaybe<FilterFindManyQualityCheck_IdOperatorsInput>;
};

export type FilterFindManyQualityCheck_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRaceSeriesInput = {
  AND?: InputMaybe<Array<FilterFindManyRaceSeriesInput>>;
  OR?: InputMaybe<Array<FilterFindManyRaceSeriesInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRaceSeriesOperatorsInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultJobListIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  driversPerCar?: InputMaybe<EnumRaceSeriesDriversPerCar>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  lapTypeConfig?: InputMaybe<FilterFindManyRaceSeriesLapTypeConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  seasonIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  sortingIndex?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRaceSeriesLapTypeConfigInput = {
  ATTACK?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  COOL?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  FCY?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  IN?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  OUT?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  OUTIN?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  PITLANE?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  PREP?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  PUSH?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  QUALI?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  SAFETYCAR?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  SHAKEDOWN?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  SLOW?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  TARGET?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  TOGRID?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  TOPADDOCK?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  TOPITS?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
  UNFINISHED?: InputMaybe<FilterFindManyRaceSeriesLapTypeEntryInput>;
};

export type FilterFindManyRaceSeriesLapTypeEntryInput = {
  displayString: Scalars['String']['input'];
  lapTypeColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type FilterFindManyRaceSeriesNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRaceSeriesOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRaceSeries_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyRaceSeriesNameOperatorsInput>;
};

export type FilterFindManyRaceSeries_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRadioMessageContestantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRadioMessageDriverIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRadioMessageInput = {
  AND?: InputMaybe<Array<FilterFindManyRadioMessageInput>>;
  OR?: InputMaybe<Array<FilterFindManyRadioMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRadioMessageOperatorsInput>;
  /** Time at which the audio message arrived in the queue for transcribing. */
  arrivedInQueueAt?: InputMaybe<Scalars['Date']['input']>;
  /** This is currently a path to a file on the Transcribble server, but it should eventually be a URL to a file in something like an S3 bucket instead. */
  audioPath?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length of the audio message in seconds. */
  length?: InputMaybe<Scalars['Float']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which the audio message was taken by a transcription service. */
  takenByTranscriberAt?: InputMaybe<Scalars['Date']['input']>;
  /** The text of the message, as transcribed by Transcribble. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Time at which this message began recording audio. */
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which the audio message was finished initial transcribing. */
  transcribedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRadioMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRadioMessage_IdOperatorsInput>;
  contestantID?: InputMaybe<FilterFindManyRadioMessageContestantIdOperatorsInput>;
  driverID?: InputMaybe<FilterFindManyRadioMessageDriverIdOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyRadioMessageSessionIdOperatorsInput>;
};

export type FilterFindManyRadioMessageSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRadioMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRatioInput = {
  /** % */
  percent?: InputMaybe<Scalars['Float']['input']>;
  /** 0 = 0%, 1 = 100%, 1.5 = 150% */
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyRegulationSetInput = {
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  hRideFrontMin?: InputMaybe<Scalars['Float']['input']>;
  hRideRearMin?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMax?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMin?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMax?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMin?: InputMaybe<Scalars['Float']['input']>;
  massMin?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyReportNotesTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyReportNotesTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyReportNotesTemplateOperatorsInput>;
  pageAppendix?: InputMaybe<FilterFindManyReportNotesTemplatePageAppendixInput>;
  pageOverview?: InputMaybe<FilterFindManyReportNotesTemplatePageOverviewInput>;
  pageParts?: InputMaybe<FilterFindManyReportNotesTemplatePagePartsInput>;
  pageRunPlan?: InputMaybe<FilterFindManyReportNotesTemplatePageRunPlanInput>;
  pageSession?: InputMaybe<FilterFindManyReportNotesTemplatePageSessionInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyReportNotesTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyReportNotesTemplate_IdOperatorsInput>;
  title?: InputMaybe<FilterFindManyReportNotesTemplateTitleOperatorsInput>;
};

export type FilterFindManyReportNotesTemplatePageAppendixInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindManyReportNotesTemplatePageAppendixNotesInput>>>;
};

export type FilterFindManyReportNotesTemplatePageAppendixNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageAppendixNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplatePageOverviewInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindManyReportNotesTemplatePageOverviewNotesInput>>>;
};

export type FilterFindManyReportNotesTemplatePageOverviewNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageOverviewNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplatePagePartsInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindManyReportNotesTemplatePagePartsNotesInput>>>;
};

export type FilterFindManyReportNotesTemplatePagePartsNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePagePartsNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplatePageRunPlanInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindManyReportNotesTemplatePageRunPlanNotesInput>>>;
};

export type FilterFindManyReportNotesTemplatePageRunPlanNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageRunPlanNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplatePageSessionInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindManyReportNotesTemplatePageSessionNotesInput>>>;
};

export type FilterFindManyReportNotesTemplatePageSessionNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageSessionNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportNotesTemplateTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyReportNotesTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyReportTemplateAppendixInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyReportTemplateBopInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bopFileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  /** Either { source: 'current-event' } or { source: 'explicit', sessionIds: string[] } */
  selectedSessions?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyReportTemplateCarSetupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyReportTemplateExcludedNoteIDsInput = {
  pageAppendix?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageOverview?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageParts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageRunPlan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageSession?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyReportTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyReportTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyReportTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyReportTemplateOperatorsInput>;
  appendix?: InputMaybe<FilterFindManyReportTemplateAppendixInput>;
  bop?: InputMaybe<FilterFindManyReportTemplateBopInput>;
  carSetup?: InputMaybe<FilterFindManyReportTemplateCarSetupInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** File format based off a filename pattern, e.g. {raceSeries} {season} {event} */
  downloadFilenameFormat?: InputMaybe<Scalars['String']['input']>;
  excludedNoteIDs?: InputMaybe<FilterFindManyReportTemplateExcludedNoteIDsInput>;
  issues?: InputMaybe<FilterFindManyReportTemplateIssuesInput>;
  kpi?: InputMaybe<FilterFindManyReportTemplateKpiInput>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overview?: InputMaybe<FilterFindManyReportTemplateOverviewInput>;
  parts?: InputMaybe<FilterFindManyReportTemplatePartsInput>;
  reportTitle?: InputMaybe<Scalars['String']['input']>;
  runInfo?: InputMaybe<FilterFindManyReportTemplateRunInfoInput>;
  runPlan?: InputMaybe<FilterFindManyReportTemplateRunPlanInput>;
  sessions?: InputMaybe<FilterFindManyReportTemplateSessionsInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  weather?: InputMaybe<FilterFindManyReportTemplateWeatherInput>;
};

export type FilterFindManyReportTemplateIssuesColumnsInput = {
  field?: InputMaybe<EnumReportTemplateIssuesColumnsField>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportTemplateIssuesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<FilterFindManyReportTemplateIssuesColumnsInput>>>;
  groupBy?: InputMaybe<EnumReportTemplateIssuesGroupBy>;
};

export type FilterFindManyReportTemplateKpiInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  showSessionLines?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyReportTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyReportTemplate_IdOperatorsInput>;
};

export type FilterFindManyReportTemplateOverviewInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showFuelConsumption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyReportTemplatePartsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  groupPartsByChassisAssemblyName?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  tableColumns?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type FilterFindManyReportTemplateRunInfoColumnsInput = {
  field?: InputMaybe<EnumReportTemplateRunInfoColumnsField>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyReportTemplateRunInfoInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<FilterFindManyReportTemplateRunInfoColumnsInput>>>;
};

export type FilterFindManyReportTemplateRunPlanInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyReportTemplateSessionsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  displayedTimeZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showTimingOverview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyReportTemplateWeatherInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  splitDataByDays?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyReportTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunBrakeInput = {
  /** Brake temperature after the run */
  TBrakePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Brake temperature before the run */
  TBrakePreRun?: InputMaybe<Scalars['Float']['input']>;
  hBrakeDiscPreRun?: InputMaybe<Scalars['Float']['input']>;
  /** Format is `Record<string, number>`, e.g. `{ "1FL": 1.2, "2": 1.3 }` */
  thicknessMeasurements?: InputMaybe<Scalars['JSON']['input']>;
};

/** Run energy field labels mapped to their display names. Null or unset fields are not displayed. */
export type FilterFindManyRunEnergyFieldLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
  attackLap?: InputMaybe<Scalars['String']['input']>;
  coolLap?: InputMaybe<Scalars['String']['input']>;
  fullCourseYellowLap?: InputMaybe<Scalars['String']['input']>;
  inLap?: InputMaybe<Scalars['String']['input']>;
  outInLap?: InputMaybe<Scalars['String']['input']>;
  outLap?: InputMaybe<Scalars['String']['input']>;
  pitlaneLap?: InputMaybe<Scalars['String']['input']>;
  prepLap?: InputMaybe<Scalars['String']['input']>;
  pushLap?: InputMaybe<Scalars['String']['input']>;
  qualiLap?: InputMaybe<Scalars['String']['input']>;
  safetyCarLap?: InputMaybe<Scalars['String']['input']>;
  shakedownLap?: InputMaybe<Scalars['String']['input']>;
  slowLap?: InputMaybe<Scalars['String']['input']>;
  targetLap?: InputMaybe<Scalars['String']['input']>;
  toGridLap?: InputMaybe<Scalars['String']['input']>;
  toPitsLap?: InputMaybe<Scalars['String']['input']>;
  unfinishedLap?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyRunEnergyInput = {
  /** Fuel/Energy/SoC required for ATTACK Lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for COOL Lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for FCY Lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for IN Lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUT Lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUTIN Lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PITLANE Lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PREP Lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PUSH Lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for QUALI Lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SAFETYCAR Lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SHAKEDOWN Lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SLOW Lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TARGET Lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOGRID Lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPADDOCK Lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPITS Lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for UNFINISHED Lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an attack mode lap */
  attackLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a cooldown lap */
  coolLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a full course yellow lap */
  fullCourseYellowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an in lap */
  inLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out-in lap */
  outInLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out lap */
  outLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a pitlane lap */
  pitlaneLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a preparation/warmup lap */
  prepLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a push lap */
  pushLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a qualifying lap */
  qualiLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a safety car lap */
  safetyCarLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a shakedown lap */
  shakedownLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a slow lap */
  slowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an target lap */
  targetLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-grid lap */
  toGridLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-pits lap */
  toPitsLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an unfinished lap */
  unfinishedLap?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyRunKpiTableRowFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<FilterFindManyValueLimitInput>;
  unit?: InputMaybe<EnumDisplayUnit>;
  upperLimit?: InputMaybe<FilterFindManyValueLimitInput>;
};

export type FilterFindManyRunKpiTableRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell, an array of two numbers for a double cell, and so on. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to try pull data from in `runKPI`, like `"vMax"`. Use an array of one key for a single cell, an array of two keys for a double cell, and so on. */
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<FilterFindManyValueLimitInput>;
  /** Text to put as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
  upperLimit?: InputMaybe<FilterFindManyValueLimitInput>;
};

export type FilterFindManyRunLapTimeInput = {
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  COOL?: InputMaybe<Scalars['Float']['input']>;
  FCY?: InputMaybe<Scalars['Float']['input']>;
  IN?: InputMaybe<Scalars['Float']['input']>;
  OUT?: InputMaybe<Scalars['Float']['input']>;
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  PREP?: InputMaybe<Scalars['Float']['input']>;
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyRunPlanContestantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunPlanInput = {
  AND?: InputMaybe<Array<FilterFindManyRunPlanInput>>;
  OR?: InputMaybe<Array<FilterFindManyRunPlanInput>>;
  PUEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRunPlanOperatorsInput>;
  /** Amount of time in seconds to increment SOC by 1% at each rSOC value. Must have same length as `chargeTimeSOCValues`. */
  chargeTimeSOCIncrements?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** rSOC values to associate with each time charge time increment. Must have same length as `chargeTimeSOCIncrements` */
  chargeTimeSOCValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fuelRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  /** Full tank fuel load */
  mFuelFullTank?: InputMaybe<Scalars['Float']['input']>;
  performanceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  runs?: InputMaybe<Array<InputMaybe<FilterFindManyRunPlanRunInput>>>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  systemEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tLapExpected?: InputMaybe<FilterFindManyRunLapTimeInput>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Short comment like dry run plan / wet run plan. */
  title?: InputMaybe<Scalars['String']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRunPlanOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRunPlan_IdOperatorsInput>;
  contestantID?: InputMaybe<FilterFindManyRunPlanContestantIdOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyRunPlanSessionIdOperatorsInput>;
};

export type FilterFindManyRunPlanRunActionItemsPreRunInput = {
  _id: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
};

export type FilterFindManyRunPlanRunInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  actionItemsPostRun?: InputMaybe<Array<InputMaybe<FilterFindManyRunPlanRunActionItemsPreRunInput>>>;
  actionItemsPreRun?: InputMaybe<Array<InputMaybe<FilterFindManyRunPlanRunActionItemsPreRunInput>>>;
  /** Background color for the run in run plan view. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Baseline Run, Option A, … */
  description?: InputMaybe<Scalars['String']['input']>;
  /** True if fuel was drained before the run. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequence?: InputMaybe<Array<InputMaybe<FilterFindManyLapSequenceLapsInput>>>;
  /** Amount of fuel to be refilled at the end of this run. */
  mFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumRunPlanRunPriority>;
  /** Things you need to remember to tell the driver. */
  reminder?: InputMaybe<Scalars['String']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  selectedDriverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Setup changes anticipated. */
  setupChanges?: InputMaybe<Scalars['String']['input']>;
  /** Amount of time for refuelling at the end of this run. */
  tFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Time to wait before starting the run. */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tyreFLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreFRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyRunPlanSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunPlan_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetContestantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetDriverIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetEndTimeCdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetEndTimeLtsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetEndTimeManualOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetEngineerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetInput = {
  AND?: InputMaybe<Array<FilterFindManyRunSheetInput>>;
  /** Fuel density, if working in volume (overrides `DFuel` from event) */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Run number */
  NRun?: InputMaybe<Scalars['Float']['input']>;
  /** Run number for timing services */
  NRunTiming?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyRunSheetInput>>;
  SoCRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  TCellMaxRunStart?: InputMaybe<Scalars['Float']['input']>;
  /** Volume of fuel added at the start of the run. This field will not be automatically calculated by the API, so should be set along with `tRefuel` and `qRefuel` as their product. */
  VFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRunSheetOperatorsInput>;
  associatedKpiFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brakeComment?: InputMaybe<Scalars['String']['input']>;
  brakeFL?: InputMaybe<FilterFindManyRunBrakeInput>;
  brakeFR?: InputMaybe<FilterFindManyRunBrakeInput>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  brakeRL?: InputMaybe<FilterFindManyRunBrakeInput>;
  brakeRR?: InputMaybe<FilterFindManyRunBrakeInput>;
  /** Link to a cloud storage location where raw run data is kept. */
  cloudStorageURL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel/SoC/Energy consumptions for each track layout in this run sheet. Acts as an override for the consumptions from the parent event. */
  consumptions?: InputMaybe<Array<InputMaybe<FilterFindManyLayoutConsumptionInput>>>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  controlsComment?: InputMaybe<Scalars['String']['input']>;
  dashboard?: InputMaybe<FilterFindManyDashboardInput>;
  dataServiceFileNameOverride?: InputMaybe<Scalars['String']['input']>;
  dilComments?: InputMaybe<Scalars['String']['input']>;
  driverComments?: InputMaybe<Scalars['String']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Car data service run end time */
  endTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  /** Laptime service run end time */
  endTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  /** Manual run end time (used to override calculation in case run was cut short but don't want to delete the drafted laps */
  endTimeManual?: InputMaybe<Scalars['Date']['input']>;
  energyRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  engineerComments?: InputMaybe<Scalars['String']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time by which tyre heating schedule should be finished */
  finishTyreHeatingBy?: InputMaybe<Scalars['Date']['input']>;
  /** Used for fuel calculation. If true, mFuelAdded is treated as the total fuel at run start. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  fuelRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isLockedByLaptimeService?: InputMaybe<Scalars['Boolean']['input']>;
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  jobIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Used to save the file name where the kpi data is retreived from */
  kpiFileName?: InputMaybe<Scalars['String']['input']>;
  kpiStatus?: InputMaybe<EnumRunSheetKpiStatus>;
  kpiUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** `addLap`, `forceAddLap`, `updateLap`, and `removeLap` mutations are preferred unless you want to completely replace the laps with new data. */
  laps?: InputMaybe<Array<InputMaybe<FilterFindManyLapInput>>>;
  laptimeThresholds?: InputMaybe<FilterFindManyLaptimeThresholdsInput>;
  /** Fuel added at the start of the run */
  mFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the catch tank after the run */
  mFuelDrainedCatchTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the main tank after the run */
  mFuelDrainedMainTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel used before run start i.e. for pre-run fireup */
  mFuelUsedPreRun?: InputMaybe<Scalars['Float']['input']>;
  nextRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  performanceComments?: InputMaybe<Scalars['String']['input']>;
  prevRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  problemComments?: InputMaybe<Scalars['String']['input']>;
  /** Flow rate when refuelling at the start of the run, in m³/s */
  qRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Energy charged to this value at the start of the run */
  rEnergyAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Energy level at the end of the run */
  rEnergyRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Battery charged to this value at the start of the run */
  rSOCAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Battery state of charge at the end of the run */
  rSOCRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Short comment of the objective of the run */
  runDescription?: InputMaybe<Scalars['String']['input']>;
  /** Map of run KPI fields to their values. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  runSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Running time in seconds */
  runTime?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the job list template used for this run */
  selectedJobListTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  setupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of the simulation results associated with this run. */
  simResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  skidComment?: InputMaybe<Scalars['String']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidMeasurement: [["left", 5], ["marker1", 6]]`. */
  skidMeasurement?: InputMaybe<Scalars['JSON']['input']>;
  skidPlateID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPostRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPostRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPreRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPreRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  startTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  startTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  startTimeManual?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which to start tyre heating schedule */
  startTyreHeatingAt?: InputMaybe<Scalars['Date']['input']>;
  summaryComments?: InputMaybe<Scalars['String']['input']>;
  systemsComments?: InputMaybe<Scalars['String']['input']>;
  /** Time spent refuelling at the start of the run */
  tRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Override for session time remaining (in seconds) */
  tSessionRemainingOverride?: InputMaybe<Scalars['Float']['input']>;
  /** Time spent in garage before run */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this run in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyRunID?: InputMaybe<Scalars['String']['input']>;
  /** Should the timing service pretend that this run sheet does not exist? */
  timingServiceShouldIgnore?: InputMaybe<Scalars['Boolean']['input']>;
  tyreComments?: InputMaybe<Scalars['String']['input']>;
  /** The tyre compound used, reported by the timing service. */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  tyreFL?: InputMaybe<FilterFindManyRunTyreInput>;
  tyreFR?: InputMaybe<FilterFindManyRunTyreInput>;
  tyrePressureSettings?: InputMaybe<FilterFindManyTyrePressureSettingsInput>;
  tyreRL?: InputMaybe<FilterFindManyRunTyreInput>;
  tyreRR?: InputMaybe<FilterFindManyRunTyreInput>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  weather?: InputMaybe<FilterFindManyWeatherDataInput>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyRunSheetNRunOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyRunSheetNRunTimingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyRunSheetNextRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRunSheetOperatorsInput = {
  NRun?: InputMaybe<FilterFindManyRunSheetNRunOperatorsInput>;
  NRunTiming?: InputMaybe<FilterFindManyRunSheetNRunTimingOperatorsInput>;
  _id?: InputMaybe<FilterFindManyRunSheet_IdOperatorsInput>;
  contestantID?: InputMaybe<FilterFindManyRunSheetContestantIdOperatorsInput>;
  driverID?: InputMaybe<FilterFindManyRunSheetDriverIdOperatorsInput>;
  endTimeCDS?: InputMaybe<FilterFindManyRunSheetEndTimeCdsOperatorsInput>;
  endTimeLTS?: InputMaybe<FilterFindManyRunSheetEndTimeLtsOperatorsInput>;
  endTimeManual?: InputMaybe<FilterFindManyRunSheetEndTimeManualOperatorsInput>;
  engineerID?: InputMaybe<FilterFindManyRunSheetEngineerIdOperatorsInput>;
  nextRunSheetID?: InputMaybe<FilterFindManyRunSheetNextRunSheetIdOperatorsInput>;
  prevRunSheetID?: InputMaybe<FilterFindManyRunSheetPrevRunSheetIdOperatorsInput>;
  runSheetStyleID?: InputMaybe<FilterFindManyRunSheetRunSheetStyleIdOperatorsInput>;
  sessionID?: InputMaybe<FilterFindManyRunSheetSessionIdOperatorsInput>;
  setupID?: InputMaybe<FilterFindManyRunSheetSetupIdOperatorsInput>;
  simResultIDs?: InputMaybe<FilterFindManyRunSheetSimResultIDsOperatorsInput>;
  startTimeCDS?: InputMaybe<FilterFindManyRunSheetStartTimeCdsOperatorsInput>;
  startTimeLTS?: InputMaybe<FilterFindManyRunSheetStartTimeLtsOperatorsInput>;
  startTimeManual?: InputMaybe<FilterFindManyRunSheetStartTimeManualOperatorsInput>;
  teamID?: InputMaybe<FilterFindManyRunSheetTeamIdOperatorsInput>;
  thirdPartyRunID?: InputMaybe<FilterFindManyRunSheetThirdPartyRunIdOperatorsInput>;
  tyreCompoundTiming?: InputMaybe<FilterFindManyRunSheetTyreCompoundTimingOperatorsInput>;
  tyreSetID?: InputMaybe<FilterFindManyRunSheetTyreSetIdOperatorsInput>;
};

export type FilterFindManyRunSheetPrevRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetRunSheetStyleIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetSimResultIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetStartTimeCdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetStartTimeLtsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetStartTimeManualOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyRunSheetStyleInput = {
  AND?: InputMaybe<Array<FilterFindManyRunSheetStyleInput>>;
  OR?: InputMaybe<Array<FilterFindManyRunSheetStyleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRunSheetStyleOperatorsInput>;
  blocks?: InputMaybe<Array<InputMaybe<FilterFindManyGenericRunSheetStyleBlockInput>>>;
  energyType?: InputMaybe<EnumEnergyType>;
  lapFlags?: InputMaybe<FilterFindManyLapFlagLabelsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetStyleNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRunSheetStyleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRunSheetStyle_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyRunSheetStyleNameOperatorsInput>;
};

export type FilterFindManyRunSheetStyle_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetTeamIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheetThirdPartyRunIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyRunSheetTyreCompoundTimingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyRunSheetTyreSetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunSheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRunTyreInput = {
  /** Track reference temperature at which the reference pressure is given */
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre temperature */
  TTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Expected tyre temperature in parc ferme */
  TTyreParcFermeExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre temperature */
  TTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed at temperature */
  TTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed at temperature */
  TTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference temperature at which the reference pressure is given */
  TTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre temperature (e.g. in the evening with cold tyre) */
  TTyreSetdown?: InputMaybe<Scalars['Float']['input']>;
  /** Array of manual surface temperature measurements */
  TTyreSurface?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of manual tyre tread depth measurements */
  hTyreTread?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Tyre pressure */
  pTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure at the start of the run */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure */
  pTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed */
  pTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed */
  pTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference pressure */
  pTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre pressure (e.g. in the evening with cold tyre) */
  pTyreSetDown?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre pressure at the start of the run */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Target tyre pressure during running */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  tyreID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManySandboxUnitsInput = {
  AND?: InputMaybe<Array<FilterFindManySandboxUnitsInput>>;
  OR?: InputMaybe<Array<FilterFindManySandboxUnitsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySandboxUnitsOperatorsInput>;
  acceleration?: InputMaybe<FilterFindManyAccelerationInput>;
  angle?: InputMaybe<FilterFindManyAngleInput>;
  angularVelocity?: InputMaybe<FilterFindManyAngularVelocityInput>;
  area?: InputMaybe<FilterFindManyAreaInput>;
  current?: InputMaybe<FilterFindManyCurrentInput>;
  dampingRate?: InputMaybe<FilterFindManyDampingRateInput>;
  density?: InputMaybe<FilterFindManyDensityInput>;
  energy?: InputMaybe<FilterFindManyEnergyInput>;
  force?: InputMaybe<FilterFindManyForceInput>;
  frequency?: InputMaybe<FilterFindManyFrequencyInput>;
  length?: InputMaybe<FilterFindManyLengthInput>;
  mass?: InputMaybe<FilterFindManyMassInput>;
  momentOfInertia?: InputMaybe<FilterFindManyMomentOfInertiaInput>;
  power?: InputMaybe<FilterFindManyPowerInput>;
  pressure?: InputMaybe<FilterFindManyPressureInput>;
  ratio?: InputMaybe<FilterFindManyRatioInput>;
  springRate?: InputMaybe<FilterFindManySpringRateInput>;
  temperature?: InputMaybe<FilterFindManyTemperatureInput>;
  torque?: InputMaybe<FilterFindManyTorqueInput>;
  torsionRate?: InputMaybe<FilterFindManyTorsionRateInput>;
  velocity?: InputMaybe<FilterFindManyVelocityInput>;
  voltage?: InputMaybe<FilterFindManyVoltageInput>;
  volume?: InputMaybe<FilterFindManyVolumeInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySandboxUnitsOperatorsInput = {
  _id?: InputMaybe<FilterFindManySandboxUnits_IdOperatorsInput>;
};

export type FilterFindManySandboxUnits_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySeasonInput = {
  AND?: InputMaybe<Array<FilterFindManySeasonInput>>;
  OR?: InputMaybe<Array<FilterFindManySeasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySeasonOperatorsInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Position after which a driver no longer gets points for fastest lap. */
  fastestLapsPositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Championship points per fastest lap in a session. Example: `[1]` means fastest lap gets 1 point, then second and beyond gets nothing. */
  pointsPerFastestLap?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Whether the fastest lap points are awarded to the team or the driver. */
  pointsPerFastestLapTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Championship points per driver position in a race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPosition?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per driver position in a sprint race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPositionSprintRace?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per qualifying rank at an event. Example: `[3, 2, 1]` means first/second/third drivers get 3/2/1 points, then fourth and beyond gets nothing. */
  pointsPerQualifyingRank?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsSystemQualiAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemQualiDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyres which are owned by the team for this season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyre sets which are owned by the team for this season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySeasonNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySeasonOperatorsInput = {
  _id?: InputMaybe<FilterFindManySeason_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManySeasonNameOperatorsInput>;
  raceSeriesID?: InputMaybe<FilterFindManySeasonRaceSeriesIdOperatorsInput>;
};

export type FilterFindManySeasonRaceSeriesIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySeason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySessionContestantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of the chassis used, if different for this session. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this session. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySessionEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySessionInput = {
  AND?: InputMaybe<Array<FilterFindManySessionInput>>;
  OR?: InputMaybe<Array<FilterFindManySessionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySessionOperatorsInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bestValuesID?: InputMaybe<Scalars['MongoID']['input']>;
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  contestants?: InputMaybe<Array<InputMaybe<FilterFindManySessionContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumSessionDebriefNotesMode>;
  disableForwardPropagation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted driver championship standings during and immediately after this session. */
  driverChampionshipStandings?: InputMaybe<Array<InputMaybe<FilterFindManyDriverChampionshipStandingInput>>>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  /** This flag is used to tell the laptime service that this session might span multiple timing sessions. */
  isLinkedSession?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this a timing test session, to be shown only to admin users? */
  isTimingTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted standings of this session, as they were last updated */
  liveStandings?: InputMaybe<Array<InputMaybe<FilterFindManyLiveStandingInput>>>;
  /** Greatest lap number processed for live standings. Use to determine if the data is current and up to date. */
  liveStandingsCurrentLap?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the next session in this event */
  nextSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFRMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRRMinSession?: InputMaybe<Scalars['Float']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemOverrideIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted driver championship standings from before the start of this session. */
  prevDriverChampionshipStandings?: InputMaybe<Array<InputMaybe<FilterFindManyDriverChampionshipStandingInput>>>;
  /** ID of the previous session in this event */
  prevSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** e.g. Test, Practice, Qualifying, Race */
  sessionType?: InputMaybe<EnumSessionType>;
  /** Short name like D1, FP2, etc. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Time of the session end in local time */
  tSessionEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of the session start in local time */
  tSessionStart?: InputMaybe<Scalars['Date']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted team championship standings during and immediately after this session. */
  teamChampionshipStandings?: InputMaybe<Array<InputMaybe<FilterFindManyTeamChampionshipStandingInput>>>;
  /** ID of this session in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartySessionID?: InputMaybe<Scalars['String']['input']>;
  /** Seconds until end of session, updated by the timing service very infrequently. Zero if session has already ended. */
  timeRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** ID of this session for Transcribble's legacy API */
  transcribbleSessionID?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterFindManySessionNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySessionOperatorsInput = {
  _id?: InputMaybe<FilterFindManySession_IdOperatorsInput>;
  eventID?: InputMaybe<FilterFindManySessionEventIdOperatorsInput>;
  name?: InputMaybe<FilterFindManySessionNameOperatorsInput>;
  shortName?: InputMaybe<FilterFindManySessionShortNameOperatorsInput>;
  tSessionEnd?: InputMaybe<FilterFindManySessionTSessionEndOperatorsInput>;
  tSessionStart?: InputMaybe<FilterFindManySessionTSessionStartOperatorsInput>;
  thirdPartySessionID?: InputMaybe<FilterFindManySessionThirdPartySessionIdOperatorsInput>;
  transcribbleSessionID?: InputMaybe<FilterFindManySessionTranscribbleSessionIdOperatorsInput>;
};

export type FilterFindManySessionShortNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySessionTSessionEndOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManySessionTSessionStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManySessionThirdPartySessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySessionTranscribbleSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type FilterFindManySession_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySetupOverviewConfigFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell and an array of two numbers for a double cell. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to pull data from in the car setup, like `"frontLeft.hRide"`. Use an array of one key for a single cell, and an array of two keys for a double cell. */
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Suffix to show as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySetupOverviewConfigInput = {
  AND?: InputMaybe<Array<FilterFindManySetupOverviewConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManySetupOverviewConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySetupOverviewConfigOperatorsInput>;
  /** WARNING: this field should be deprecated after SI migrations have taken place */
  fields?: InputMaybe<Array<InputMaybe<FilterFindManySetupOverviewConfigFieldInput>>>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<FilterFindManySetupOverviewConfigRowInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySetupOverviewConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManySetupOverviewConfig_IdOperatorsInput>;
  title?: InputMaybe<FilterFindManySetupOverviewConfigTitleOperatorsInput>;
};

export type FilterFindManySetupOverviewConfigRowElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Path of field in car setup, e.g. aero.aFlapF */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Gain to apply to the value. */
  gain?: InputMaybe<Scalars['Float']['input']>;
  /** Suffix to put as a unit for values. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<FilterFindManyBaseTypedUnitFieldInput>;
};

export type FilterFindManySetupOverviewConfigRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  elements?: InputMaybe<Array<InputMaybe<FilterFindManySetupOverviewConfigRowElementInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySetupOverviewConfigTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySetupOverviewConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySetupSheetGroupInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Array<FilterFindManySetupSheetStyleRowInput>>;
};

export type FilterFindManySetupSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  height?: InputMaybe<Scalars['Int']['input']>;
  tabs?: InputMaybe<Array<FilterFindManySetupSheetStyleTabInput>>;
  /** The width of the block within the grid */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterFindManySetupSheetStyleInput = {
  AND?: InputMaybe<Array<FilterFindManySetupSheetStyleInput>>;
  OR?: InputMaybe<Array<FilterFindManySetupSheetStyleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySetupSheetStyleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blocks?: InputMaybe<Array<FilterFindManySetupSheetStyleBlockInput>>;
  /** Chassis specification to use for suggesting field keys. You may need to look for more recent iterations of this spec to get up-to-date field keys. */
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  hideAddPartButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to show/hide units for the input fields */
  hideUnits?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetEventType?: InputMaybe<EnumSetupSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumSetupSheetStyleType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySetupSheetStyleOperatorsInput = {
  _id?: InputMaybe<FilterFindManySetupSheetStyle_IdOperatorsInput>;
};

export type FilterFindManySetupSheetStyleRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  items: Array<SetupSheetStyleItemInput>;
};

export type FilterFindManySetupSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  groups?: InputMaybe<Array<FilterFindManySetupSheetGroupInput>>;
  massConfig?: InputMaybe<FilterFindManySetupSheetStyleTabMassConfigInput>;
  mileageConfig?: InputMaybe<FilterFindManySetupSheetStyleTabMileageConfigInput>;
  rows?: InputMaybe<Array<FilterFindManySetupSheetStyleRowInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumSetupSheetStyleTabType>;
};

export type FilterFindManySetupSheetStyleTabMassConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  massOption?: InputMaybe<Scalars['String']['input']>;
  showMinWeightFromSpec?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManySetupSheetStyleTabMileageConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  showManualInput?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManySetupSheetStyle_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestInput = {
  AND?: InputMaybe<Array<FilterFindManySimRequestInput>>;
  OR?: InputMaybe<Array<FilterFindManySimRequestInput>>;
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySimRequestOperatorsInput>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  relatedSimResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  requesterSlot?: InputMaybe<EnumSimRequestRequesterSlot>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
  simType?: InputMaybe<EnumSimRequestSimType>;
  simulationService?: InputMaybe<EnumSimModelType>;
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySimRequestOperatorsInput = {
  _id?: InputMaybe<FilterFindManySimRequest_IdOperatorsInput>;
  carSetupID?: InputMaybe<FilterFindManySimRequestCarSetupIdOperatorsInput>;
  requesterID?: InputMaybe<FilterFindManySimRequestRequesterIdOperatorsInput>;
  runSheetID?: InputMaybe<FilterFindManySimRequestRunSheetIdOperatorsInput>;
  simResultID?: InputMaybe<FilterFindManySimRequestSimResultIdOperatorsInput>;
  simType?: InputMaybe<FilterFindManySimRequestSimTypeOperatorsInput>;
  simulationService?: InputMaybe<FilterFindManySimRequestSimulationServiceOperatorsInput>;
  specificationID?: InputMaybe<FilterFindManySimRequestSpecificationIdOperatorsInput>;
  trackLayoutID?: InputMaybe<FilterFindManySimRequestTrackLayoutIdOperatorsInput>;
  version?: InputMaybe<FilterFindManySimRequestVersionOperatorsInput>;
};

export type FilterFindManySimRequestRequesterIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestSimResultIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestSimTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimRequestSimType>;
  gte?: InputMaybe<EnumSimRequestSimType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimRequestSimType>>>;
  lt?: InputMaybe<EnumSimRequestSimType>;
  lte?: InputMaybe<EnumSimRequestSimType>;
  ne?: InputMaybe<EnumSimRequestSimType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimRequestSimType>>>;
};

export type FilterFindManySimRequestSimulationServiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimModelType>;
  gte?: InputMaybe<EnumSimModelType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  lt?: InputMaybe<EnumSimModelType>;
  lte?: InputMaybe<EnumSimModelType>;
  ne?: InputMaybe<EnumSimModelType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
};

export type FilterFindManySimRequestSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestTrackLayoutIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimRequestVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySimRequest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** Sampling rate of the channel in Hz, if overriding `defaultChannelTime` without `channelTime` */
  channelSamplingRate?: InputMaybe<Scalars['Float']['input']>;
  /** Use this to override `defaultChannelTime` */
  channelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Actual channel data values */
  channelValue?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  interpolationMethod?: InputMaybe<EnumSimResultDataInterpolationMethod>;
  /** Should values in this channel be treated as timestamps? */
  isTimeChannel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display unit of channel values (e.g. m/s) */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySimResultInput = {
  AND?: InputMaybe<Array<FilterFindManySimResultInput>>;
  OR?: InputMaybe<Array<FilterFindManySimResultInput>>;
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySimResultOperatorsInput>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<FilterFindManySimResultDataInput>>>;
  /** Each data channel is assumed to use this unless it specifies `channelSamplingRate` or `channelTime` */
  defaultChannelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Map containing reference values from car setup. Example: aerobalance in a car manual. Input syntax is array of key-value tuples, like `refValues: [["rAeroBalF", 48.5], ["rLatBalF", 51.4]]`. */
  refValues?: InputMaybe<Scalars['JSON']['input']>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the ORH service used to generate the sim result */
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  simType?: InputMaybe<EnumSimResultSimType>;
  simulationDriveFileID?: InputMaybe<Scalars['MongoID']['input']>;
  simulationService?: InputMaybe<EnumSimModelType>;
  /** Service which generated this sim result, for example Canopy */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Reference for this sim result, to find it in the simulation service */
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySimResultOperatorsInput = {
  _id?: InputMaybe<FilterFindManySimResult_IdOperatorsInput>;
  carSetupID?: InputMaybe<FilterFindManySimResultCarSetupIdOperatorsInput>;
  requesterID?: InputMaybe<FilterFindManySimResultRequesterIdOperatorsInput>;
  runSheetID?: InputMaybe<FilterFindManySimResultRunSheetIdOperatorsInput>;
  serviceVersion?: InputMaybe<FilterFindManySimResultServiceVersionOperatorsInput>;
  simType?: InputMaybe<FilterFindManySimResultSimTypeOperatorsInput>;
  simulationService?: InputMaybe<FilterFindManySimResultSimulationServiceOperatorsInput>;
  source?: InputMaybe<FilterFindManySimResultSourceOperatorsInput>;
  sourceReferenceID?: InputMaybe<FilterFindManySimResultSourceReferenceIdOperatorsInput>;
  specificationID?: InputMaybe<FilterFindManySimResultSpecificationIdOperatorsInput>;
  trackLayoutID?: InputMaybe<FilterFindManySimResultTrackLayoutIdOperatorsInput>;
  version?: InputMaybe<FilterFindManySimResultVersionOperatorsInput>;
};

export type FilterFindManySimResultRequesterIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultServiceVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySimResultSimTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimResultSimType>;
  gte?: InputMaybe<EnumSimResultSimType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimResultSimType>>>;
  lt?: InputMaybe<EnumSimResultSimType>;
  lte?: InputMaybe<EnumSimResultSimType>;
  ne?: InputMaybe<EnumSimResultSimType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimResultSimType>>>;
};

export type FilterFindManySimResultSimulationServiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimModelType>;
  gte?: InputMaybe<EnumSimModelType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  lt?: InputMaybe<EnumSimModelType>;
  lte?: InputMaybe<EnumSimModelType>;
  ne?: InputMaybe<EnumSimModelType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
};

export type FilterFindManySimResultSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySimResultSourceReferenceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySimResultSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultTrackLayoutIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimResultVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySimResult_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimulationDriveFileInput = {
  AND?: InputMaybe<Array<FilterFindManySimulationDriveFileInput>>;
  OR?: InputMaybe<Array<FilterFindManySimulationDriveFileInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySimulationDriveFileOperatorsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumSimulationDriveFileStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumTypeID?: InputMaybe<Scalars['MongoID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySimulationDriveFileOperatorsInput = {
  _id?: InputMaybe<FilterFindManySimulationDriveFile_IdOperatorsInput>;
  status?: InputMaybe<FilterFindManySimulationDriveFileStatusOperatorsInput>;
  userEnumTypeID?: InputMaybe<FilterFindManySimulationDriveFileUserEnumTypeIdOperatorsInput>;
};

export type FilterFindManySimulationDriveFileStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimulationDriveFileStatus>;
  gte?: InputMaybe<EnumSimulationDriveFileStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumSimulationDriveFileStatus>>>;
  lt?: InputMaybe<EnumSimulationDriveFileStatus>;
  lte?: InputMaybe<EnumSimulationDriveFileStatus>;
  ne?: InputMaybe<EnumSimulationDriveFileStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimulationDriveFileStatus>>>;
};

export type FilterFindManySimulationDriveFileUserEnumTypeIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySimulationDriveFile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySkidPlateBarcodeRegulationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySkidPlateInitialThicknessOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManySkidPlateInput = {
  AND?: InputMaybe<Array<FilterFindManySkidPlateInput>>;
  OR?: InputMaybe<Array<FilterFindManySkidPlateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySkidPlateOperatorsInput>;
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  initialThickness?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySkidPlateNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySkidPlateOperatorsInput = {
  _id?: InputMaybe<FilterFindManySkidPlate_IdOperatorsInput>;
  barcodeRegulation?: InputMaybe<FilterFindManySkidPlateBarcodeRegulationOperatorsInput>;
  initialThickness?: InputMaybe<FilterFindManySkidPlateInitialThicknessOperatorsInput>;
  name?: InputMaybe<FilterFindManySkidPlateNameOperatorsInput>;
};

export type FilterFindManySkidPlate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpecificationACamberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationACamberReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationACamberUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManySpecificationAllowableParentSpecIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpecificationCanopyVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySpecificationChassisSpecIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpecificationCustomSimulationModelsInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  dataMapping?: InputMaybe<EnumSpecificationCustomSimulationModelsDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serverPort?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySpecificationCustomTablesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<FilterFindManyTableInput>;
};

export type FilterFindManySpecificationHRideInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationHRideReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationHRideUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindManySpecificationInput>>;
  CxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  FSpringSetup?: InputMaybe<FilterFindManyAdjustableForceInput>;
  OR?: InputMaybe<Array<FilterFindManySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySpecificationOperatorsInput>;
  aCamber?: InputMaybe<FilterFindManySpecificationACamberInput>;
  aCaster?: InputMaybe<FilterFindManySpecificationACamberInput>;
  aCasterMeasurementGain?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurementOffset?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<FilterFindManySpecificationACamberInput>;
  adjustableProperties?: InputMaybe<Array<InputMaybe<FilterFindManyAdjustablePropertyInput>>>;
  aeroElementInterpolationMethod?: InputMaybe<EnumAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  aeroElementType?: InputMaybe<EnumAeroElementType>;
  aeroPackageSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  aeroPackageSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  antiRollBarConfigs?: InputMaybe<Array<InputMaybe<FilterFindManyAntiRollBarConfigInput>>>;
  antiRollBarDisplayLocation?: InputMaybe<EnumAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: InputMaybe<Array<InputMaybe<FilterFindManyAssignedGearInput>>>;
  attachable?: InputMaybe<Scalars['Boolean']['input']>;
  axle?: InputMaybe<EnumAxle>;
  bevelSetSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetVisible?: InputMaybe<Scalars['Boolean']['input']>;
  bumpRubberReference?: InputMaybe<EnumKinematicsInternalReference>;
  bumpRubberSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bumpStopGapMethod?: InputMaybe<EnumBumpStopGapMethod>;
  calculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: InputMaybe<Scalars['String']['input']>;
  chassisMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  copyReferencePackageID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customSimulationModels?: InputMaybe<Array<InputMaybe<FilterFindManySpecificationCustomSimulationModelsInput>>>;
  customSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  customSpecType?: InputMaybe<Scalars['String']['input']>;
  customTables?: InputMaybe<Array<InputMaybe<FilterFindManySpecificationCustomTablesInput>>>;
  damperAdjusters?: InputMaybe<Array<InputMaybe<FilterFindManyDamperAdjusterInput>>>;
  damperConfigs?: InputMaybe<Array<InputMaybe<FilterFindManyDamperConfigInput>>>;
  damperSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  denominator?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  differentialConfigs?: InputMaybe<Array<InputMaybe<FilterFindManyDifferentialConfigInput>>>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  drawingNumber?: InputMaybe<Scalars['String']['input']>;
  dropGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  elasticType?: InputMaybe<EnumElasticType>;
  forceTable?: InputMaybe<FilterFindManyForceTableInput>;
  gearType?: InputMaybe<EnumGearType>;
  hRide?: InputMaybe<FilterFindManySpecificationHRideInput>;
  hasToBeInSubAssembly?: InputMaybe<Scalars['Boolean']['input']>;
  headGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  helperSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  initialChassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spring constant of the elastic element. */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  kinematicsExternalModels?: InputMaybe<Array<InputMaybe<FilterFindManyKinematicsExternalModelInput>>>;
  kinematicsExternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kinematicsInternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerReference?: InputMaybe<Scalars['String']['input']>;
  mass?: InputMaybe<FilterFindManyChassisMassInput>;
  massProperties?: InputMaybe<FilterFindManyMassPropertiesInput>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: InputMaybe<FilterFindManyChassisMeasurementsInput>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  numerator?: InputMaybe<Scalars['Float']['input']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  polyCxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  positionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  powerUnits?: InputMaybe<Array<InputMaybe<FilterFindManyChassisPowerUnitInput>>>;
  powertrain?: InputMaybe<FilterFindManyChassisPowertrainInput>;
  powertrainLocation?: InputMaybe<EnumSpecificationPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  rBrakeBias?: InputMaybe<FilterFindManyAdjustableRatioInput>;
  /** Position of the specification on the car */
  readingsAllowable?: InputMaybe<Array<InputMaybe<EnumSpecificationReadingsAllowable>>>;
  readingsRequired?: InputMaybe<EnumSpecificationReadingsRequired>;
  reboundSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regulationSets?: InputMaybe<Array<InputMaybe<FilterFindManyRegulationSetInput>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: InputMaybe<Scalars['Boolean']['input']>;
  setupChangesFilter?: InputMaybe<FilterFindManySpecificationSetupChangesFilterInput>;
  setupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  /** Locations/areas that components can be installed in. */
  sockets?: InputMaybe<Array<InputMaybe<FilterFindManyChassisSocketInput>>>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationGroupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  springReference?: InputMaybe<EnumKinematicsInternalReference>;
  springSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  torsionBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumSpecificationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** User-supplied version of this specification. */
  version?: InputMaybe<Scalars['String']['input']>;
  xBumpRubberRef?: InputMaybe<Scalars['Float']['input']>;
  xBumpRubberSetup?: InputMaybe<FilterFindManyAdjustableLengthInput>;
  xBumpStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperSetupDefault?: InputMaybe<Scalars['Float']['input']>;
  xDroopStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  /** Length of the elastic element under no force */
  xFree?: InputMaybe<Scalars['Float']['input']>;
  xShaftDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xSpringPlatformOffset?: InputMaybe<Scalars['Float']['input']>;
  xSpringRef?: InputMaybe<Scalars['Float']['input']>;
  xSpringSetup?: InputMaybe<FilterFindManyAdjustableLengthInput>;
  xToe?: InputMaybe<FilterFindManySpecificationHRideInput>;
};

export type FilterFindManySpecificationNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySpecificationNextIterationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManySpecification_IdOperatorsInput>;
  allowableParentSpecIDs?: InputMaybe<FilterFindManySpecificationAllowableParentSpecIDsOperatorsInput>;
  canopyVersion?: InputMaybe<FilterFindManySpecificationCanopyVersionOperatorsInput>;
  chassisSpecID?: InputMaybe<FilterFindManySpecificationChassisSpecIdOperatorsInput>;
  name?: InputMaybe<FilterFindManySpecificationNameOperatorsInput>;
  nextIterationID?: InputMaybe<FilterFindManySpecificationNextIterationIdOperatorsInput>;
  prevIterationID?: InputMaybe<FilterFindManySpecificationPrevIterationIdOperatorsInput>;
  specificationGroupIDs?: InputMaybe<FilterFindManySpecificationSpecificationGroupIDsOperatorsInput>;
  version?: InputMaybe<FilterFindManySpecificationVersionOperatorsInput>;
};

export type FilterFindManySpecificationPrevIterationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpecificationSetupChangesFilterInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of setup fields to hide */
  blackListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of setup fields to show */
  whiteListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManySpecificationSpecificationGroupIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpecificationVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySpringRateInput = {
  /** N/m */
  newtonsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** N/mm */
  newtonsPerMillimetre?: InputMaybe<Scalars['Float']['input']>;
  /** lb/in */
  poundsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManySsoProviderInput = {
  AND?: InputMaybe<Array<FilterFindManySsoProviderInput>>;
  OR?: InputMaybe<Array<FilterFindManySsoProviderInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySsoProviderOperatorsInput>;
  clientID?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  issuerURL?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySsoProviderNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySsoProviderOperatorsInput = {
  _id?: InputMaybe<FilterFindManySsoProvider_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManySsoProviderNameOperatorsInput>;
};

export type FilterFindManySsoProvider_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySteeringInput = {
  rSteerF?: InputMaybe<Scalars['Float']['input']>;
  steeringArm?: InputMaybe<Scalars['String']['input']>;
  steeringPinion?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyTableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  columnNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columnValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Table data in 1d vector. It's up to the consumer to reshape appropriately. OneRacehub internally uses row chunks. */
  data?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  decimals?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  rowNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTagInput = {
  AND?: InputMaybe<Array<FilterFindManyTagInput>>;
  OR?: InputMaybe<Array<FilterFindManyTagInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTagOperatorsInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<EnumTagType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTagOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTag_IdOperatorsInput>;
};

export type FilterFindManyTag_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTeamChampionshipStandingInput = {
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  points?: InputMaybe<Scalars['Int']['input']>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  teamDrivers?: InputMaybe<Array<InputMaybe<FilterFindManyDriverChampionshipStandingInput>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyTeamInput = {
  AND?: InputMaybe<Array<FilterFindManyTeamInput>>;
  OR?: InputMaybe<Array<FilterFindManyTeamInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTeamOperatorsInput>;
  /** Default color to use for this team where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Used only for filtering to limit which teams are displayed in a list. */
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTeamNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTeamOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTeam_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyTeamNameOperatorsInput>;
  raceSeriesID?: InputMaybe<FilterFindManyTeamRaceSeriesIdOperatorsInput>;
  shortName?: InputMaybe<FilterFindManyTeamShortNameOperatorsInput>;
};

export type FilterFindManyTeamRaceSeriesIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTeamShortNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTeam_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTemperatureInput = {
  /** °C */
  celsius?: InputMaybe<Scalars['Float']['input']>;
  /** °F */
  fahrenheit?: InputMaybe<Scalars['Float']['input']>;
  /** °K */
  kelvin?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTemplateJobInput = {
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
};

export type FilterFindManyTemplateJobListIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyTemplateJobListInput = {
  AND?: InputMaybe<Array<FilterFindManyTemplateJobListInput>>;
  OR?: InputMaybe<Array<FilterFindManyTemplateJobListInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTemplateJobListOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  jobs?: InputMaybe<Array<InputMaybe<FilterFindManyTemplateJobInput>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTemplateJobListOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTemplateJobList_IdOperatorsInput>;
  index?: InputMaybe<FilterFindManyTemplateJobListIndexOperatorsInput>;
  title?: InputMaybe<FilterFindManyTemplateJobListTitleOperatorsInput>;
};

export type FilterFindManyTemplateJobListTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTemplateJobList_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTemplateSessionDebriefInput = {
  AND?: InputMaybe<Array<FilterFindManyTemplateSessionDebriefInput>>;
  OR?: InputMaybe<Array<FilterFindManyTemplateSessionDebriefInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTemplateSessionDebriefOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumTemplateSessionDebriefMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTemplateSessionDebriefOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTemplateSessionDebrief_IdOperatorsInput>;
};

export type FilterFindManyTemplateSessionDebrief_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTimeSheetEntryInput = {
  AND?: InputMaybe<Array<FilterFindManyTimeSheetEntryInput>>;
  OR?: InputMaybe<Array<FilterFindManyTimeSheetEntryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTimeSheetEntryOperatorsInput>;
  /** Whether a person did work on this day */
  absent?: InputMaybe<Scalars['Boolean']['input']>;
  approvedAt?: InputMaybe<Scalars['Date']['input']>;
  approvedByID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Notes about what was done during this time */
  description?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Clock-out time */
  tEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Clock-in time */
  tStart?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTimeSheetEntryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTimeSheetEntry_IdOperatorsInput>;
  projectID?: InputMaybe<FilterFindManyTimeSheetEntryProjectIdOperatorsInput>;
  tEnd?: InputMaybe<FilterFindManyTimeSheetEntryTEndOperatorsInput>;
  tStart?: InputMaybe<FilterFindManyTimeSheetEntryTStartOperatorsInput>;
};

export type FilterFindManyTimeSheetEntryProjectIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTimeSheetEntryTEndOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyTimeSheetEntryTStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyTimeSheetEntry_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTimingServiceConfigEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTimingServiceConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyTimingServiceConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyTimingServiceConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTimingServiceConfigOperatorsInput>;
  /** Whether the timingServiceConfig should be considered active by the service */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event ID. This finds the correct event by its _id field. */
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Use schedule-based session matching as fallback. */
  fallbackScheduleBasedSessionMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of timed sectors on track. Used as fallback in case timing data does not provide it. */
  fallbackTimedSectorsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Car numbers to follow. */
  followedCarNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Activate live standings to see the driver championship points live. Only working properly if all drivers of a given season are added as contestants. */
  liveStandingsActive?: InputMaybe<Scalars['Boolean']['input']>;
  logLevel?: InputMaybe<EnumTimingServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<EnumTimingServiceConfigMode>;
  /** Name for this set of configuration settings. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Use string equality to match timing session names in One Racehub. Otherwise default sequence matching is used. */
  strictSessionNameMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** One Timing server port. */
  timingPort?: InputMaybe<Scalars['Int']['input']>;
  /** Race series name to filter on in the timing feed when multiple series are running at an event. */
  timingRaceSeries?: InputMaybe<Scalars['String']['input']>;
  /** One Timing server address. */
  timingURL?: InputMaybe<Scalars['String']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyTimingServiceConfigNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTimingServiceConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTimingServiceConfig_IdOperatorsInput>;
  eventID?: InputMaybe<FilterFindManyTimingServiceConfigEventIdOperatorsInput>;
  name?: InputMaybe<FilterFindManyTimingServiceConfigNameOperatorsInput>;
};

export type FilterFindManyTimingServiceConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTorqueInput = {
  /** Nm */
  newtonMetres?: InputMaybe<Scalars['Float']['input']>;
  /** Nmm */
  newtonMillimetres?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft */
  poundForceFeet?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·in */
  poundForceInches?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTorsionRateInput = {
  /** Nm/° */
  newtonMetresPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** Nm/rad */
  newtonMetresPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/° */
  poundForceFeetPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/rad */
  poundForceFeetPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/° */
  poundForceInchesPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/rad */
  poundForceInchesPerRadian?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackAcronymOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTrackInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackOperatorsInput>;
  acronym?: InputMaybe<Scalars['String']['input']>;
  /** Track height above sea level. */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  geoLocation?: InputMaybe<FilterFindManyGeoLocationInput>;
  /** Search in a radius around a coordinates point. */
  geoNear?: InputMaybe<GeoNear>;
  /** IDs of the available track layouts */
  layoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Storage ID of track picture file in s3. */
  trackPicture?: InputMaybe<Scalars['String']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyTrackLayoutAcronymOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTrackLayoutInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackLayoutInput>>;
  ATKModeGain?: InputMaybe<Scalars['Float']['input']>;
  ATKModeLocation?: InputMaybe<Scalars['Float']['input']>;
  ATKModePenalty?: InputMaybe<Scalars['Float']['input']>;
  FCYLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Full-course yellow probability */
  FCYProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of sectors the timing provides */
  NSectorsTiming?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyTrackLayoutInput>>;
  SCLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Safety car probability */
  SCProbability?: InputMaybe<Scalars['Float']['input']>;
  SoCRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackLayoutOperatorsInput>;
  acronym?: InputMaybe<Scalars['String']['input']>;
  bumpiness?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code60LapTime?: InputMaybe<Scalars['Float']['input']>;
  crossoverWetToSlick?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  energyRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  expectedRaceLaps?: InputMaybe<Scalars['Float']['input']>;
  firstLapOffset?: InputMaybe<Scalars['Float']['input']>;
  fuelRequired?: InputMaybe<FilterFindManyRunEnergyInput>;
  inLapTime?: InputMaybe<Scalars['Float']['input']>;
  lapLengthCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapZero?: InputMaybe<Scalars['Boolean']['input']>;
  lapsUntilFullRegen?: InputMaybe<Scalars['Float']['input']>;
  mapElevation?: InputMaybe<Scalars['String']['input']>;
  mapEmergencyExits?: InputMaybe<Scalars['String']['input']>;
  mapPitLane?: InputMaybe<Scalars['String']['input']>;
  mapTrack?: InputMaybe<Scalars['String']['input']>;
  mapTrackGPS?: InputMaybe<Scalars['String']['input']>;
  mapTrackLatLonCsv?: InputMaybe<Scalars['String']['input']>;
  mapTrackXyCsv?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Layout */
  name?: InputMaybe<Scalars['String']['input']>;
  outLapTime?: InputMaybe<Scalars['Float']['input']>;
  overtakingThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Whole distance from entry to exit inlcuding approach and leave */
  pitDistance?: InputMaybe<Scalars['Float']['input']>;
  /** Length of pit lane between the pit lane entry and exit loop (used for mileage calculation of pitlane lap types) */
  pitLength?: InputMaybe<Scalars['Float']['input']>;
  pitLoss?: InputMaybe<Scalars['Float']['input']>;
  pitLossDriveThrough?: InputMaybe<Scalars['Float']['input']>;
  /** Indicates whether the pole position is on the left- or right-hand side */
  polePosition?: InputMaybe<EnumTrackLayoutPolePosition>;
  prepLapTime?: InputMaybe<Scalars['Float']['input']>;
  pushLapTime?: InputMaybe<Scalars['Float']['input']>;
  sectorDistance?: InputMaybe<Scalars['Float']['input']>;
  sectorLengths?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Downforce sensitivity (seconds per 10pts) */
  sensDownforce?: InputMaybe<Scalars['Float']['input']>;
  /** Drag sensitivity (seconds per 10pts) */
  sensDrag?: InputMaybe<Scalars['Float']['input']>;
  sensEP?: InputMaybe<Scalars['Float']['input']>;
  /** Energy sensitivity (seconds per 0.1kWh) */
  sensEnergy?: InputMaybe<Scalars['Float']['input']>;
  /** Grip sensitivity (seconds per %) */
  sensGrip?: InputMaybe<Scalars['Float']['input']>;
  /** Mass sensitivity (seconds per 10kg) */
  sensMass?: InputMaybe<Scalars['Float']['input']>;
  /** Power sensitivity */
  sensPower?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Array<InputMaybe<FilterFindManyTrackLayoutSimulationModelInput>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackEvolution?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the track this layout belongs to */
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutType?: InputMaybe<EnumTrackLayoutTrackLayoutType>;
  trackRecordQuali?: InputMaybe<Scalars['Float']['input']>;
  trackRecordRace?: InputMaybe<Scalars['Float']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyTrackLayoutLapLengthOfficialOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackLayoutOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackLayout_IdOperatorsInput>;
  acronym?: InputMaybe<FilterFindManyTrackLayoutAcronymOperatorsInput>;
  lapLengthOfficial?: InputMaybe<FilterFindManyTrackLayoutLapLengthOfficialOperatorsInput>;
  trackID?: InputMaybe<FilterFindManyTrackLayoutTrackIdOperatorsInput>;
};

export type FilterFindManyTrackLayoutSimulationModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  canopyID?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<EnumSimModelType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyTrackLayoutTrackIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackLayout_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrack_IdOperatorsInput>;
  acronym?: InputMaybe<FilterFindManyTrackAcronymOperatorsInput>;
  name?: InputMaybe<FilterFindManyTrackNameOperatorsInput>;
};

export type FilterFindManyTrackStateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  flag?: InputMaybe<EnumTrackStateFlag>;
  message?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyTrack_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackableInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackableInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackableInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackableOperatorsInput>;
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the original version of the specifications to track. */
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  unitType?: InputMaybe<FilterFindManyBaseTypedUnitFieldInput>;
  /** Comparison to use when checking if the tracked value is in the warning/critical range. */
  warningDirection?: InputMaybe<EnumTrackableWarningDirection>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackableNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackableOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackable_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyTrackableNameOperatorsInput>;
  rootSpecificationID?: InputMaybe<FilterFindManyTrackableRootSpecificationIdOperatorsInput>;
};

export type FilterFindManyTrackableRootSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackable_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingItemInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingItemInput>>;
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyTrackingItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingItemOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  arrayElements?: InputMaybe<Scalars['Float']['input']>;
  criticalCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  cumulativeCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  isArray?: InputMaybe<Scalars['Boolean']['input']>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  measurementImage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<EnumTrackingItemOperator>;
  resettable?: InputMaybe<Scalars['Boolean']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
  warningCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingItem_IdOperatorsInput>;
};

export type FilterFindManyTrackingItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingMeasurementDefaultCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackingMeasurementDefaultRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackingMeasurementInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingMeasurementInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackingMeasurementInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingMeasurementOperatorsInput>;
  defaultCoordinates?: InputMaybe<FilterFindManyTrackingMeasurementDefaultCoordinatesInput>;
  defaultRotation?: InputMaybe<FilterFindManyTrackingMeasurementDefaultRotationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingMeasurementOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingMeasurement_IdOperatorsInput>;
};

export type FilterFindManyTrackingMeasurementRecordCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackingMeasurementRecordInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingMeasurementRecordInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackingMeasurementRecordInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingMeasurementRecordOperatorsInput>;
  assemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  coordinates?: InputMaybe<FilterFindManyTrackingMeasurementRecordCoordinatesInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  rotation?: InputMaybe<FilterFindManyTrackingMeasurementRecordRotationInput>;
  trackingMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingMeasurementRecordOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingMeasurementRecord_IdOperatorsInput>;
};

export type FilterFindManyTrackingMeasurementRecordRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTrackingMeasurementRecord_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingMeasurement_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingRecordInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingRecordInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackingRecordInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingRecordOperatorsInput>;
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<FilterFindManyForceTableInput>;
  location?: InputMaybe<FilterFindManyLocationInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  qualityCheckID?: InputMaybe<Scalars['MongoID']['input']>;
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  statusEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingRecordOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingRecord_IdOperatorsInput>;
  partID?: InputMaybe<FilterFindManyTrackingRecordPartIdOperatorsInput>;
};

export type FilterFindManyTrackingRecordPartIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingRecord_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingSourceAliasInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingSourceAliasInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackingSourceAliasInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingSourceAliasOperatorsInput>;
  aliasString?: InputMaybe<Scalars['String']['input']>;
  aliasType?: InputMaybe<EnumTrackingSourceAliasAliasType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingSourceAliasOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingSourceAlias_IdOperatorsInput>;
};

export type FilterFindManyTrackingSourceAlias_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingSourceInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingSourceInput>>;
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyTrackingSourceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingSourceOperatorsInput>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingSourceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTrackingSource_IdOperatorsInput>;
};

export type FilterFindManyTrackingSource_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreAdditionalSortPropertyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreBarcodeManufacturerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreBarcodeRegulationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreBarcodeRimOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreBarcodeTpmsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreBatteryTpmsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreCompoundOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreHeatingScheduleEntryInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTyreInput = {
  AND?: InputMaybe<Array<FilterFindManyTyreInput>>;
  /** Flag if the tyre is scrapped (no longer available for use). */
  BTyreScrapped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tyre Circumference */
  CTyre?: InputMaybe<Scalars['Float']['input']>;
  OR?: InputMaybe<Array<FilterFindManyTyreInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTyreOperatorsInput>;
  /** Arbitrary string to sort or filter by */
  additionalSortProperty?: InputMaybe<Scalars['String']['input']>;
  axle?: InputMaybe<EnumTyreAxle>;
  barcodeManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Barcode from the regulatory body (e.g. FIA) */
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  barcodeRim?: InputMaybe<Scalars['String']['input']>;
  barcodeTPMS?: InputMaybe<Scalars['String']['input']>;
  batteryTPMS?: InputMaybe<Scalars['String']['input']>;
  compound?: InputMaybe<Scalars['String']['input']>;
  compoundComment?: InputMaybe<Scalars['String']['input']>;
  constructionComment?: InputMaybe<Scalars['String']['input']>;
  constructionSpec?: InputMaybe<Scalars['String']['input']>;
  heatingSchedule?: InputMaybe<Array<InputMaybe<FilterFindManyTyreHeatingScheduleEntryInput>>>;
  initialCondition?: InputMaybe<EnumTyreInitialCondition>;
  /** Tyre Spring Rate */
  kTyre?: InputMaybe<Scalars['Float']['input']>;
  mTyre?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Tyre mold information */
  mold?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Tyre minimum pressure defined by regulation or manufacturer */
  pTyreMinRegulation?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure defined by team (i.e. chief engineer) */
  pTyreMinTeam?: InputMaybe<Scalars['Float']['input']>;
  rimPartID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Initial mileage before use in One Racehub. */
  sRunInitial?: InputMaybe<Scalars['Float']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  wearMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreMTyreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyTyreManufacturerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTyreOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTyre_IdOperatorsInput>;
  additionalSortProperty?: InputMaybe<FilterFindManyTyreAdditionalSortPropertyOperatorsInput>;
  barcodeManufacturer?: InputMaybe<FilterFindManyTyreBarcodeManufacturerOperatorsInput>;
  barcodeRegulation?: InputMaybe<FilterFindManyTyreBarcodeRegulationOperatorsInput>;
  barcodeRim?: InputMaybe<FilterFindManyTyreBarcodeRimOperatorsInput>;
  barcodeTPMS?: InputMaybe<FilterFindManyTyreBarcodeTpmsOperatorsInput>;
  batteryTPMS?: InputMaybe<FilterFindManyTyreBatteryTpmsOperatorsInput>;
  compound?: InputMaybe<FilterFindManyTyreCompoundOperatorsInput>;
  mTyre?: InputMaybe<FilterFindManyTyreMTyreOperatorsInput>;
  manufacturer?: InputMaybe<FilterFindManyTyreManufacturerOperatorsInput>;
  name?: InputMaybe<FilterFindManyTyreNameOperatorsInput>;
  seasonID?: InputMaybe<FilterFindManyTyreSeasonIdOperatorsInput>;
  type?: InputMaybe<FilterFindManyTyreTypeOperatorsInput>;
};

export type FilterFindManyTyrePressureSettingsInput = {
  TAirReference?: InputMaybe<Scalars['Float']['input']>;
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTyreSeasonIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreSetInput = {
  AND?: InputMaybe<Array<FilterFindManyTyreSetInput>>;
  OR?: InputMaybe<Array<FilterFindManyTyreSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTyreSetOperatorsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Hide fully scrapped tyre sets from a paginated tyre set query. */
  hideScrapped?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tyreIDFL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDFR?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRR?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyTyreSetNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreSetNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTyreSetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTyreSet_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyTyreSetNameOperatorsInput>;
  number?: InputMaybe<FilterFindManyTyreSetNumberOperatorsInput>;
  tyreIDFL?: InputMaybe<FilterFindManyTyreSetTyreIdflOperatorsInput>;
  tyreIDFR?: InputMaybe<FilterFindManyTyreSetTyreIdfrOperatorsInput>;
  tyreIDRL?: InputMaybe<FilterFindManyTyreSetTyreIdrlOperatorsInput>;
  tyreIDRR?: InputMaybe<FilterFindManyTyreSetTyreIdrrOperatorsInput>;
};

export type FilterFindManyTyreSetTyreIdflOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreSetTyreIdfrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreSetTyreIdrlOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreSetTyreIdrrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreTableBlockRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<EnumTyreTableField>;
  highlightChanges?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<FilterFindManyValueLimitInput>;
  upperLimit?: InputMaybe<FilterFindManyValueLimitInput>;
};

export type FilterFindManyTyreTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyTyreWearDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyTyreWearInput = {
  AND?: InputMaybe<Array<FilterFindManyTyreWearInput>>;
  OR?: InputMaybe<Array<FilterFindManyTyreWearInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTyreWearOperatorsInput>;
  /** Time at which this measurement was made. */
  date?: InputMaybe<Scalars['Date']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Raw wear data formatted however the user chooses, probably from a scanner. */
  wearData?: InputMaybe<Scalars['String']['input']>;
  /** Map of marker names to wear values. Input syntax is array of key-value tuples, like `wearMarkers: [["inner", 0.8], ["1", 0.3]]`. */
  wearMarkers?: InputMaybe<Scalars['JSON']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTyreWearOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTyreWear_IdOperatorsInput>;
  date?: InputMaybe<FilterFindManyTyreWearDateOperatorsInput>;
  tyreID?: InputMaybe<FilterFindManyTyreWearTyreIdOperatorsInput>;
};

export type FilterFindManyTyreWearTyreIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyreWear_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTyre_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserEnumActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyUserEnumInput = {
  AND?: InputMaybe<Array<FilterFindManyUserEnumInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserEnumInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserEnumOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserEnumType>;
};

export type FilterFindManyUserEnumNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserEnumOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUserEnum_IdOperatorsInput>;
  active?: InputMaybe<FilterFindManyUserEnumActiveOperatorsInput>;
  name?: InputMaybe<FilterFindManyUserEnumNameOperatorsInput>;
  type?: InputMaybe<FilterFindManyUserEnumTypeOperatorsInput>;
};

export type FilterFindManyUserEnumTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserEnumType>;
  gte?: InputMaybe<EnumUserEnumType>;
  in?: InputMaybe<Array<InputMaybe<EnumUserEnumType>>>;
  lt?: InputMaybe<EnumUserEnumType>;
  lte?: InputMaybe<EnumUserEnumType>;
  ne?: InputMaybe<EnumUserEnumType>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserEnumType>>>;
};

export type FilterFindManyUserEnum_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserSimulationSettingsInput = {
  TAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  pAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  rHumidityPreferred?: InputMaybe<Scalars['Float']['input']>;
  /** User defined run sim slot colours, index corresponds to run slot number. */
  runSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** User defined setup sim slot colours, index corresponds to setup slot number. */
  setupSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** IDs of the two user defined setups */
  userDefinedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyValueLimitInput = {
  /** Background color to use if the value goes beyond this limit. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Text color to use if the value goes beyond this limit. */
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyVelocityInput = {
  /** ft/s */
  feetPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** kph */
  kilometresPerHour?: InputMaybe<Scalars['Float']['input']>;
  /** m/s */
  metresPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** mph */
  milesPerHour?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyViewConfigInput = {
  /** Should tyre mileages be highlighted according to `yellowTyreMileageThreshold` and `redTyreMileageThreshold`? */
  highlightTyreMileages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted red instead of yellow. */
  redTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Should the user see runsheet via scrolling or via tabs? */
  showRunSheetsAsTabs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted yellow instead of green. */
  yellowTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyVoltageInput = {
  /** mV */
  millivolts?: InputMaybe<Scalars['Float']['input']>;
  /** V */
  volts?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyVolumeInput = {
  /** cm³ */
  cubicCentimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft³ */
  cubicFeet?: InputMaybe<Scalars['Float']['input']>;
  /** in³ */
  cubicInches?: InputMaybe<Scalars['Float']['input']>;
  /** m³ */
  cubicMetres?: InputMaybe<Scalars['Float']['input']>;
  /** gal (US fluid) */
  gallonsUS?: InputMaybe<Scalars['Float']['input']>;
  /** L */
  litres?: InputMaybe<Scalars['Float']['input']>;
  /** mL */
  millilitres?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyWeatherDataInput = {
  /** Air temperature (mean in historical data) */
  TAir?: InputMaybe<Scalars['Float']['input']>;
  /** Predicted air temperature for given session. E.g. for tyre pressure calculation */
  TAirExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum air temperature (for use in historical data) */
  TAirMax?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum air temperature (for use in historical data) */
  TAirMin?: InputMaybe<Scalars['Float']['input']>;
  /** Air temperature from official sources (e.g. FIA) */
  TAirOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient temperature */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Temperature to which air must be cooled to become saturated with water vapor */
  TDewPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station internal temperature */
  TInternal?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature */
  TTrack?: InputMaybe<Scalars['Float']['input']>;
  /** Expected track temperature. E.g. for tyre pressure calculation */
  TTrackExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature from official sources (e.g. FIA) */
  TTrackOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Wind chill factor */
  TWindChill?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station battery voltage */
  VBattery?: InputMaybe<Scalars['Float']['input']>;
  /** Wind direction in radians (0 = North, π/2 = East, π = South, 3π/2 = West) */
  aWind?: InputMaybe<Scalars['Float']['input']>;
  /** Main wind direction during the saving interval */
  aWindMain?: InputMaybe<Scalars['Float']['input']>;
  /** Verbal describing ambient condition like cloudy, sunny, overcast, miserable, … */
  ambientCondition?: InputMaybe<Scalars['String']['input']>;
  globalRadiation?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient pressure */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Humidity ratio */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of rain in m³/m² (so m) */
  rainIntensity?: InputMaybe<Scalars['Float']['input']>;
  /** Rain chance as a ratio */
  rainProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Time stamp for this datum */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Verbal describing track condition like dry, damp, … */
  trackCondition?: InputMaybe<Scalars['String']['input']>;
  /** Wind velocity */
  vWind?: InputMaybe<Scalars['Float']['input']>;
  /** Average wind velocity */
  vWindAverage?: InputMaybe<Scalars['Float']['input']>;
  /** Peak wind velocity */
  vWindPeak?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyWeatherEventIDsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWeatherInput = {
  AND?: InputMaybe<Array<FilterFindManyWeatherInput>>;
  OR?: InputMaybe<Array<FilterFindManyWeatherInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWeatherOperatorsInput>;
  /** Height above sea level (for air density for example). */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  data?: InputMaybe<Array<InputMaybe<FilterFindManyWeatherDataInput>>>;
  /** References to events this weather data was made for, if applicable */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  geoLocation?: InputMaybe<FilterFindManyGeoLocationInput>;
  /** Search in a radius around a coordinates point. */
  geoNear?: InputMaybe<GeoNear>;
  /** User notes for completing a forecast for a race */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Forecast/measurement source (website, weather station, timekeeping, …) */
  source?: InputMaybe<Scalars['String']['input']>;
  /** For predictions, indicates the time at which the prediction was made. For measurements, indicates the time of the first measurement in the array. */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Prediction, measurement, historical */
  type?: InputMaybe<EnumWeatherType>;
  /** Weather station ID */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWeatherOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWeather_IdOperatorsInput>;
  eventIDs?: InputMaybe<FilterFindManyWeatherEventIDsOperatorsInput>;
  source?: InputMaybe<FilterFindManyWeatherSourceOperatorsInput>;
  time?: InputMaybe<FilterFindManyWeatherTimeOperatorsInput>;
  type?: InputMaybe<FilterFindManyWeatherTypeOperatorsInput>;
};

export type FilterFindManyWeatherServiceConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyWeatherServiceConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyWeatherServiceConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWeatherServiceConfigOperatorsInput>;
  /** API Key. Used for Open Weather Map and Wunderground */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** API Secret. Used for Weather Link */
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Password. Currently used for meteomatics */
  password?: InputMaybe<Scalars['String']['input']>;
  refreshInterval?: InputMaybe<Scalars['Float']['input']>;
  requestLocation?: InputMaybe<FilterFindManyGeoLocationInput>;
  /** Location or weather station */
  requestType?: InputMaybe<EnumWeatherServiceConfigRequestType>;
  /** Weather client to specify the source where to retrieve the data from. */
  source?: InputMaybe<EnumWeatherServiceConfigSource>;
  type?: InputMaybe<EnumWeatherServiceConfigType>;
  /** Username. Currently used for meteomatics */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Weather Station ID. Used for Weather Underground */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWeatherServiceConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWeatherServiceConfig_IdOperatorsInput>;
  type?: InputMaybe<FilterFindManyWeatherServiceConfigTypeOperatorsInput>;
};

export type FilterFindManyWeatherServiceConfigTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumWeatherServiceConfigType>;
  gte?: InputMaybe<EnumWeatherServiceConfigType>;
  in?: InputMaybe<Array<InputMaybe<EnumWeatherServiceConfigType>>>;
  lt?: InputMaybe<EnumWeatherServiceConfigType>;
  lte?: InputMaybe<EnumWeatherServiceConfigType>;
  ne?: InputMaybe<EnumWeatherServiceConfigType>;
  nin?: InputMaybe<Array<InputMaybe<EnumWeatherServiceConfigType>>>;
};

export type FilterFindManyWeatherServiceConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWeatherSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyWeatherTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyWeatherTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumWeatherType>;
  gte?: InputMaybe<EnumWeatherType>;
  in?: InputMaybe<Array<InputMaybe<EnumWeatherType>>>;
  lt?: InputMaybe<EnumWeatherType>;
  lte?: InputMaybe<EnumWeatherType>;
  ne?: InputMaybe<EnumWeatherType>;
  nin?: InputMaybe<Array<InputMaybe<EnumWeatherType>>>;
};

export type FilterFindManyWeather_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneReportNoteEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneReportNoteInput = {
  AND?: InputMaybe<Array<FilterFindOneReportNoteInput>>;
  OR?: InputMaybe<Array<FilterFindOneReportNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneReportNoteOperatorsInput>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  pageAppendix?: InputMaybe<FilterFindOneReportNotePageAppendixInput>;
  pageOverview?: InputMaybe<FilterFindOneReportNotePageOverviewInput>;
  pageParts?: InputMaybe<FilterFindOneReportNotePagePartsInput>;
  pageRunPlan?: InputMaybe<FilterFindOneReportNotePageRunPlanInput>;
  pageSession?: InputMaybe<FilterFindOneReportNotePageSessionInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneReportNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindOneReportNote_IdOperatorsInput>;
  eventID?: InputMaybe<FilterFindOneReportNoteEventIdOperatorsInput>;
};

export type FilterFindOneReportNotePageAppendixInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneReportNotePageAppendixNotesInput>>>;
};

export type FilterFindOneReportNotePageAppendixNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotePageAppendixNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneReportNotePageOverviewInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneReportNotePageOverviewNotesInput>>>;
};

export type FilterFindOneReportNotePageOverviewNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotePageOverviewNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneReportNotePagePartsInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneReportNotePagePartsNotesInput>>>;
};

export type FilterFindOneReportNotePagePartsNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotePagePartsNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneReportNotePageRunPlanInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneReportNotePageRunPlanNotesInput>>>;
};

export type FilterFindOneReportNotePageRunPlanNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotePageRunPlanNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneReportNotePageSessionInput = {
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneReportNotePageSessionNotesInput>>>;
};

export type FilterFindOneReportNotePageSessionNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotePageSessionNotesMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneReportNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestInput = {
  AND?: InputMaybe<Array<FilterRemoveManySimRequestInput>>;
  OR?: InputMaybe<Array<FilterRemoveManySimRequestInput>>;
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterRemoveManySimRequestOperatorsInput>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  relatedSimResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  requesterSlot?: InputMaybe<EnumSimRequestRequesterSlot>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
  simType?: InputMaybe<EnumSimRequestSimType>;
  simulationService?: InputMaybe<EnumSimModelType>;
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterRemoveManySimRequestOperatorsInput = {
  _id?: InputMaybe<FilterRemoveManySimRequest_IdOperatorsInput>;
  carSetupID?: InputMaybe<FilterRemoveManySimRequestCarSetupIdOperatorsInput>;
  requesterID?: InputMaybe<FilterRemoveManySimRequestRequesterIdOperatorsInput>;
  runSheetID?: InputMaybe<FilterRemoveManySimRequestRunSheetIdOperatorsInput>;
  simResultID?: InputMaybe<FilterRemoveManySimRequestSimResultIdOperatorsInput>;
  simType?: InputMaybe<FilterRemoveManySimRequestSimTypeOperatorsInput>;
  simulationService?: InputMaybe<FilterRemoveManySimRequestSimulationServiceOperatorsInput>;
  specificationID?: InputMaybe<FilterRemoveManySimRequestSpecificationIdOperatorsInput>;
  trackLayoutID?: InputMaybe<FilterRemoveManySimRequestTrackLayoutIdOperatorsInput>;
  version?: InputMaybe<FilterRemoveManySimRequestVersionOperatorsInput>;
};

export type FilterRemoveManySimRequestRequesterIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestSimResultIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestSimTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimRequestSimType>;
  gte?: InputMaybe<EnumSimRequestSimType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimRequestSimType>>>;
  lt?: InputMaybe<EnumSimRequestSimType>;
  lte?: InputMaybe<EnumSimRequestSimType>;
  ne?: InputMaybe<EnumSimRequestSimType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimRequestSimType>>>;
};

export type FilterRemoveManySimRequestSimulationServiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimModelType>;
  gte?: InputMaybe<EnumSimModelType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  lt?: InputMaybe<EnumSimModelType>;
  lte?: InputMaybe<EnumSimModelType>;
  ne?: InputMaybe<EnumSimModelType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
};

export type FilterRemoveManySimRequestSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestTrackLayoutIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimRequestVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveManySimRequest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultCarSetupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** Sampling rate of the channel in Hz, if overriding `defaultChannelTime` without `channelTime` */
  channelSamplingRate?: InputMaybe<Scalars['Float']['input']>;
  /** Use this to override `defaultChannelTime` */
  channelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Actual channel data values */
  channelValue?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  interpolationMethod?: InputMaybe<EnumSimResultDataInterpolationMethod>;
  /** Should values in this channel be treated as timestamps? */
  isTimeChannel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display unit of channel values (e.g. m/s) */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterRemoveManySimResultInput = {
  AND?: InputMaybe<Array<FilterRemoveManySimResultInput>>;
  OR?: InputMaybe<Array<FilterRemoveManySimResultInput>>;
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterRemoveManySimResultOperatorsInput>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<FilterRemoveManySimResultDataInput>>>;
  /** Each data channel is assumed to use this unless it specifies `channelSamplingRate` or `channelTime` */
  defaultChannelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Map containing reference values from car setup. Example: aerobalance in a car manual. Input syntax is array of key-value tuples, like `refValues: [["rAeroBalF", 48.5], ["rLatBalF", 51.4]]`. */
  refValues?: InputMaybe<Scalars['JSON']['input']>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the ORH service used to generate the sim result */
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  simType?: InputMaybe<EnumSimResultSimType>;
  simulationDriveFileID?: InputMaybe<Scalars['MongoID']['input']>;
  simulationService?: InputMaybe<EnumSimModelType>;
  /** Service which generated this sim result, for example Canopy */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Reference for this sim result, to find it in the simulation service */
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterRemoveManySimResultOperatorsInput = {
  _id?: InputMaybe<FilterRemoveManySimResult_IdOperatorsInput>;
  carSetupID?: InputMaybe<FilterRemoveManySimResultCarSetupIdOperatorsInput>;
  requesterID?: InputMaybe<FilterRemoveManySimResultRequesterIdOperatorsInput>;
  runSheetID?: InputMaybe<FilterRemoveManySimResultRunSheetIdOperatorsInput>;
  serviceVersion?: InputMaybe<FilterRemoveManySimResultServiceVersionOperatorsInput>;
  simType?: InputMaybe<FilterRemoveManySimResultSimTypeOperatorsInput>;
  simulationService?: InputMaybe<FilterRemoveManySimResultSimulationServiceOperatorsInput>;
  source?: InputMaybe<FilterRemoveManySimResultSourceOperatorsInput>;
  sourceReferenceID?: InputMaybe<FilterRemoveManySimResultSourceReferenceIdOperatorsInput>;
  specificationID?: InputMaybe<FilterRemoveManySimResultSpecificationIdOperatorsInput>;
  trackLayoutID?: InputMaybe<FilterRemoveManySimResultTrackLayoutIdOperatorsInput>;
  version?: InputMaybe<FilterRemoveManySimResultVersionOperatorsInput>;
};

export type FilterRemoveManySimResultRequesterIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultRunSheetIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultServiceVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveManySimResultSimTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimResultSimType>;
  gte?: InputMaybe<EnumSimResultSimType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimResultSimType>>>;
  lt?: InputMaybe<EnumSimResultSimType>;
  lte?: InputMaybe<EnumSimResultSimType>;
  ne?: InputMaybe<EnumSimResultSimType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimResultSimType>>>;
};

export type FilterRemoveManySimResultSimulationServiceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumSimModelType>;
  gte?: InputMaybe<EnumSimModelType>;
  in?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  lt?: InputMaybe<EnumSimModelType>;
  lte?: InputMaybe<EnumSimModelType>;
  ne?: InputMaybe<EnumSimModelType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
};

export type FilterRemoveManySimResultSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveManySimResultSourceReferenceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveManySimResultSpecificationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultTrackLayoutIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveManySimResultVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveManySimResult_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FixAssemblyTracking = {
  deletedCount: Scalars['Int']['output'];
  insertedRecords: Array<TrackingRecord>;
};

export type FixPartInstanceArrayResult = {
  success?: Maybe<Scalars['MongoID']['output']>;
};

export type FixPartInstancesByPartId = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FixPartTrackingHistory = {
  removedRecords?: Maybe<Scalars['Int']['output']>;
};

export type FixTrackingForAssemblyParts = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FlexLayoutConfig = {
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  globalXAxis?: Maybe<FlexLayoutConfigGlobalXAxis>;
  intendedFor: EnumFlexLayoutConfigIntendedFor;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /** JSON configuration recognised by flexlayout-react */
  model?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  /** If this is non-empty, only users with one of these roles can see this config. */
  targetRoles?: Maybe<Array<EnumPersonRole>>;
  targetUserIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  targetUsers?: Maybe<Person>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type FlexLayoutConfigGlobalXAxis = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  gain?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offset?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<EnumFlexLayoutConfigGlobalXAxisType>;
};

export type FlexLayoutConfigGlobalXAxisInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  gain?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumFlexLayoutConfigGlobalXAxisType>;
};

/** List of items with pagination. */
export type FlexLayoutConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<FlexLayoutConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Force = {
  /** N */
  newtons: Scalars['Float']['output'];
  /** lbf */
  poundsForce: Scalars['Float']['output'];
};

export type ForceInput = {
  /** N */
  newtons?: InputMaybe<Scalars['Float']['input']>;
  /** lbf */
  poundsForce?: InputMaybe<Scalars['Float']['input']>;
};

export type ForceTable = {
  /** Acceleration (ddx) values */
  acceleration?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Also known as F1 */
  dampingForce?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Also known as F0 */
  force?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Also known as F2 */
  inertanceForce?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Velocity (dx) values */
  velocity?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Displacement values */
  x?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  xMax?: Maybe<Scalars['Float']['output']>;
  xMin?: Maybe<Scalars['Float']['output']>;
};

export type ForceTableInput = {
  /** Acceleration (ddx) values */
  acceleration?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F1 */
  dampingForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F0 */
  force?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F2 */
  inertanceForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Velocity (dx) values */
  velocity?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Displacement values */
  x?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  xMax?: InputMaybe<Scalars['Float']['input']>;
  xMin?: InputMaybe<Scalars['Float']['input']>;
};

export type ForceUnitField = {
  unit: EnumForceUnit;
};

export type ForgotPasswordResult = {
  result: Scalars['String']['output'];
};

export type ForwardUpsertPartInstanceResult = {
  updatedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type Frequency = {
  /** Hz */
  hertz: Scalars['Float']['output'];
  /** kHz */
  kilohertz: Scalars['Float']['output'];
  /** MHz */
  megahertz: Scalars['Float']['output'];
};

export type FrequencyInput = {
  /** Hz */
  hertz?: InputMaybe<Scalars['Float']['input']>;
  /** kHz */
  kilohertz?: InputMaybe<Scalars['Float']['input']>;
  /** MHz */
  megahertz?: InputMaybe<Scalars['Float']['input']>;
};

export type FuelBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Specify EnumFuelColumn.ENERGY_TYPE in `fuelColumns` instead */
  energyType?: Maybe<EnumEnergyType>;
  fuelColumns?: Maybe<Array<EnumFuelColumn>>;
  /** @deprecated Use runEnergyFields instead */
  fuelFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** Order in which to display visible run energy fields. */
  runEnergyFieldOrder?: Maybe<Array<EnumRunEnergyField>>;
  runEnergyFields?: Maybe<RunEnergyFieldLabels>;
  /**
   * Show the extended combustion consumption fields.
   * @deprecated Specify EnumFuelColumn.EXTENDED_CONSUMPTION in `fuelColumns` instead.
   */
  showExtendedConsumptionFields?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Show the fuel density input box.
   * @deprecated Specify EnumFuelColumn.FUEL_DENSITY in `fuelColumns` instead.
   */
  showFuelDensityInput?: Maybe<Scalars['Boolean']['output']>;
  /** Show the maximum amount of laps per consumption for a given fuel load fields. */
  showMaxLapsPerConsumptionFields?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use other fields to style the block instead */
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type GearBoxSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: Maybe<Array<Maybe<AssignedGear>>>;
  bevelSetSpec?: Maybe<GearSpec>;
  bevelSetSpecID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  differentialSpec?: Maybe<DifferentialSpec>;
  differentialSpecID?: Maybe<Scalars['MongoID']['output']>;
  dropGearSpec?: Maybe<GearSpec>;
  dropGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  headGearSpec?: Maybe<GearSpec>;
  headGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<GearBoxSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type GearSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  denominator: Scalars['Float']['output'];
  gearType?: Maybe<EnumGearType>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /**
   * If true, this gear is the head gear of the gear box, applies to standard gears only
   * @deprecated Use `useHeadGear` boolean inside a GearBox instead.
   */
  isHeadGear?: Maybe<Scalars['Boolean']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<GearSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  numerator: Scalars['Float']['output'];
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type GenericRunSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  blockBackgroundColour?: InputMaybe<Scalars['String']['input']>;
  brakeFields?: InputMaybe<Array<InputMaybe<EnumBrakeBlockField>>>;
  /** A map of colorable things to colors */
  colorMap?: InputMaybe<Scalars['JSON']['input']>;
  defaultOpenState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order in which to display visible run energy fields. */
  energyFieldOrder?: InputMaybe<Array<InputMaybe<EnumGenericRunSheetStyleBlockEnergyFieldOrder>>>;
  /** Source of the lap end energy value */
  energyLapEndSource?: InputMaybe<Scalars['String']['input']>;
  energyType?: InputMaybe<EnumEnergyType>;
  field?: InputMaybe<Scalars['String']['input']>;
  /** Field name for first comment box in a double comment block. */
  field1?: InputMaybe<Scalars['String']['input']>;
  /** Field name for second comment box in a double comment block. */
  field2?: InputMaybe<Scalars['String']['input']>;
  fuelColumns?: InputMaybe<Array<EnumFuelColumn>>;
  fuelFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The height of the block within the grid */
  height?: InputMaybe<Scalars['Int']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isShownWhenFolded?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Label on first comment box in a double comment block. */
  label1?: InputMaybe<Scalars['String']['input']>;
  /** Label on second comment box in a double comment block. */
  label2?: InputMaybe<Scalars['String']['input']>;
  /** Ordered columns to show in the lap table */
  lapColumns?: InputMaybe<Array<InputMaybe<LapColumnInput>>>;
  lapCountBlockFieldOrder?: InputMaybe<Array<InputMaybe<GenericRunSheetStyleBlockLapCountBlockFieldOrderInput>>>;
  lapFlags?: InputMaybe<LapFlagLabelsInput>;
  /** Names of lapKPI fields to show */
  lapKPIs?: InputMaybe<Array<InputMaybe<GenericRunSheetStyleBlockLapKpIsInput>>>;
  manualLapInputByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  pressureUnit?: InputMaybe<EnumPressureUnit>;
  rows?: InputMaybe<Scalars['Float']['input']>;
  /** Order in which to display visible run energy fields. */
  runEnergyFieldOrder?: InputMaybe<Array<EnumRunEnergyField>>;
  runEnergyFields?: InputMaybe<RunEnergyFieldLabelsInput>;
  runKPIRows?: InputMaybe<Array<InputMaybe<RunKpiTableRowInput>>>;
  runKPITable?: InputMaybe<Array<InputMaybe<GenericRunSheetStyleBlockRunKpiTableInput>>>;
  setupSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Defines the visibility of the ambient and track condition in the weather block */
  showAmbientAndTrackCondition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the extended combustion consumption fields. */
  showExtendedConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the fuel density input box. */
  showFuelDensityInput?: InputMaybe<Scalars['Boolean']['input']>;
  showGetPreviousRunPostPressureButton?: InputMaybe<Scalars['Boolean']['input']>;
  showGetRecommendationButton?: InputMaybe<Scalars['Boolean']['input']>;
  showLapTypeColors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the maximum amount of laps per consumption for a given fuel load fields. */
  showMaxLapsPerConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  showMinimumPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  showPostRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showPreRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showSurfaceTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showTargetPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreReferencePressure?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSelector?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSetSelector?: InputMaybe<Scalars['Boolean']['input']>;
  staggerSettings?: InputMaybe<GenericRunSheetStyleBlockStaggerSettingsInput>;
  standardTyrePressureBox?: InputMaybe<GenericRunSheetStyleBlockStandardTyrePressureBoxInput>;
  standardTyreTempBox?: InputMaybe<GenericRunSheetStyleBlockStandardTyreTempBoxInput>;
  style?: InputMaybe<EnumRunSheetStyleBlockStyle>;
  temperatureUnit?: InputMaybe<EnumTemperatureUnit>;
  title?: InputMaybe<Scalars['String']['input']>;
  treadDepthUnit?: InputMaybe<EnumLengthUnit>;
  type: EnumGenericRunSheetStyleBlockType;
  tyreTableRows?: InputMaybe<Array<InputMaybe<TyreTableBlockRowInput>>>;
  /** Number of tread depth measurements to allow. Use `0` or `null` to hide the input. */
  tyreTreadDepthMeasurements?: InputMaybe<Scalars['Int']['input']>;
  unitSystem?: InputMaybe<EnumUnitSystem>;
  velocityUnit?: InputMaybe<EnumVelocityUnit>;
  /** Ordered weather block fields to show */
  weatherFieldOrder?: InputMaybe<Array<EnumWeatherBlockField>>;
  /** The width of the block within the grid */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericRunSheetStyleBlockLapCountBlockFieldOrder = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  field?: Maybe<EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField>;
  show?: Maybe<Scalars['Boolean']['output']>;
};

export type GenericRunSheetStyleBlockLapCountBlockFieldOrderInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  field?: InputMaybe<EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenericRunSheetStyleBlockLapKpIs = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lowerLimit?: Maybe<ValueLimit>;
  upperLimit?: Maybe<ValueLimit>;
};

export type GenericRunSheetStyleBlockLapKpIsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<ValueLimitInput>;
  upperLimit?: InputMaybe<ValueLimitInput>;
};

export type GenericRunSheetStyleBlockRunKpiTable = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Default background color for the cell/s. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  defaultEditable?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Array<Maybe<GenericRunSheetStyleBlockRunKpiTableRows>>>;
};

export type GenericRunSheetStyleBlockRunKpiTableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  defaultEditable?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<GenericRunSheetStyleBlockRunKpiTableRowsInput>>>;
};

export type GenericRunSheetStyleBlockRunKpiTableRows = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Default background color for the cell/s. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<RunKpiTableRowField>>>;
  label?: Maybe<Scalars['String']['output']>;
};

export type GenericRunSheetStyleBlockRunKpiTableRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<RunKpiTableRowFieldInput>>>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type GenericRunSheetStyleBlockStaggerSettingsInput = {
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
};

export type GenericRunSheetStyleBlockStandardTyrePressureBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumPressureOption>>>;
  unit?: InputMaybe<EnumPressureUnit>;
};

export type GenericRunSheetStyleBlockStandardTyreTempBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumTemperatureOption>>>;
  unit?: InputMaybe<EnumTemperatureUnit>;
};

export type GeoLocation = {
  /** [longitude, latitude] in decimal degrees */
  coordinates: Array<Maybe<Scalars['Float']['output']>>;
  /** Only "Point" is supported */
  type: EnumGeoLocationType;
};

export type GeoLocationInput = {
  /** [longitude, latitude] in decimal degrees */
  coordinates: Array<InputMaybe<Scalars['Float']['input']>>;
  /** Only "Point" is supported */
  type: EnumGeoLocationType;
};

export type GeoNear = {
  /** Latitude of the coordinates to search near. */
  lat: Scalars['Float']['input'];
  /** Longitude of the coordinates to search near. */
  long: Scalars['Float']['input'];
  /** Radius around the given coordinates in kilometres. */
  radius: Scalars['Float']['input'];
};

export type GreeboLog = {
  _id: Scalars['MongoID']['output'];
  /** Real time car positions on track */
  carPositions?: Maybe<Array<Maybe<CarTrackPosition>>>;
  /** Only specify if this is a greebo log for an entire event */
  eventID?: Maybe<Scalars['String']['output']>;
  /** GPS data from Greebo */
  gpsData?: Maybe<Array<Maybe<CarGpsDataPoint>>>;
  /** Unprocessed lines from Greebo */
  rawLines?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sessionID?: Maybe<Scalars['String']['output']>;
};

export type History = {
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<EnumHistoryType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<Person>;
  userID?: Maybe<Scalars['MongoID']['output']>;
  valuesChanged?: Maybe<Array<Maybe<HistoryValuesChanged>>>;
};

export type HistoryValuesChanged = {
  field?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IncrementRunSheetPayload = {
  isNewRunSheet?: Maybe<Scalars['Boolean']['output']>;
  runSheet: RunSheet;
};

export type IncrementSpecificationResult = {
  existingSpec?: Maybe<NonChassisSpecificationUnion>;
  iteratedSpec?: Maybe<NonChassisSpecificationUnion>;
};

export type InertiaUnitField = {
  unit: EnumInertiaUnit;
};

export type InsertRunPayload = {
  message?: Maybe<Scalars['String']['output']>;
  newRunSheetID?: Maybe<Scalars['MongoID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Issue = {
  _id: Scalars['MongoID']['output'];
  acknowledgedAt?: Maybe<Scalars['Date']['output']>;
  acknowledgedByID?: Maybe<Scalars['MongoID']['output']>;
  area?: Maybe<Scalars['String']['output']>;
  assigneeIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledByID?: Maybe<Scalars['MongoID']['output']>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Date']['output']>;
  closedByID?: Maybe<Scalars['MongoID']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  containment?: Maybe<Scalars['String']['output']>;
  contestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdByID?: Maybe<Scalars['MongoID']['output']>;
  departmentID?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  descriptionDetails?: Maybe<Scalars['String']['output']>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  issueStatus?: Maybe<EnumIssueIssueStatus>;
  linkedIssueIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  number?: Maybe<Scalars['String']['output']>;
  part?: Maybe<Part>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  primaryTagID?: Maybe<Scalars['MongoID']['output']>;
  primaryTagLabelSort?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<EnumIssuePriority>;
  raceSeriesID?: Maybe<Scalars['MongoID']['output']>;
  rootCause?: Maybe<Scalars['String']['output']>;
  /** ID of run sheet associated with this job */
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  seasonID?: Maybe<Scalars['MongoID']['output']>;
  sessionID?: Maybe<Scalars['MongoID']['output']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: Maybe<Scalars['Date']['output']>;
  teamIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  thirdPartyIssueID?: Maybe<Scalars['MongoID']['output']>;
  /** Reference to a car data timestamp */
  timeInfo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type IssueAction =
  | 'CLOSE'
  | 'REOPEN';

export type IssueBlock = {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type IssueQuery = {
  _id: Scalars['MongoID']['output'];
  acknowledgedAt?: Maybe<Scalars['Date']['output']>;
  acknowledgedBy?: Maybe<Person>;
  acknowledgedByID?: Maybe<Scalars['MongoID']['output']>;
  area?: Maybe<Scalars['String']['output']>;
  assigneeIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignees: Array<Person>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledBy?: Maybe<Person>;
  cancelledByID?: Maybe<Scalars['MongoID']['output']>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Date']['output']>;
  closedBy?: Maybe<Person>;
  closedByID?: Maybe<Scalars['MongoID']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  containment?: Maybe<Scalars['String']['output']>;
  contestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  contestants: Array<Contestant>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Person>;
  createdByID?: Maybe<Scalars['MongoID']['output']>;
  department?: Maybe<Department>;
  departmentID?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  descriptionDetails?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  issueStatus?: Maybe<EnumIssueQueryIssueStatus>;
  linkedIssueIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  number?: Maybe<Scalars['String']['output']>;
  oneWordStatus: IssueStatus;
  partID?: Maybe<Scalars['MongoID']['output']>;
  primaryTagID?: Maybe<Scalars['MongoID']['output']>;
  primaryTagLabelSort?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<EnumIssueQueryPriority>;
  raceSeries?: Maybe<RaceSeries>;
  raceSeriesID?: Maybe<Scalars['MongoID']['output']>;
  rootCause?: Maybe<Scalars['String']['output']>;
  runSheet?: Maybe<RunSheet>;
  /** ID of run sheet associated with this job */
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  season?: Maybe<Season>;
  seasonID?: Maybe<Scalars['MongoID']['output']>;
  session?: Maybe<Session>;
  sessionID?: Maybe<Scalars['MongoID']['output']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  subTasks: Array<Job>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** Date by which the issue should be resolved */
  targetDate?: Maybe<Scalars['Date']['output']>;
  teamIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  teams: Array<Team>;
  thirdPartyIssueID?: Maybe<Scalars['MongoID']['output']>;
  /** Reference to a car data timestamp */
  timeInfo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type IssueQueryPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<IssueQuery>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type IssueStatus =
  | 'ACKNOWLEDGED'
  | 'CANCELLED'
  | 'CLOSED'
  | 'OPEN';

export type Job = {
  _id: Scalars['MongoID']['output'];
  acknowledgedAt?: Maybe<Scalars['Date']['output']>;
  acknowledgedBy?: Maybe<Person>;
  acknowledgedByID?: Maybe<Scalars['MongoID']['output']>;
  assigneeIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignees: Array<Person>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledBy?: Maybe<Person>;
  cancelledByID?: Maybe<Scalars['MongoID']['output']>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Date']['output']>;
  closedBy?: Maybe<Person>;
  closedByID?: Maybe<Scalars['MongoID']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Person>;
  createdByID?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  oneWordStatus: JobStatus;
  /** The id of the parent job or issue that this task is assigned to */
  parentID?: Maybe<Scalars['MongoID']['output']>;
  /** Parent issue that this task is assigned to */
  parentIssue?: Maybe<Issue>;
  /** Parent job or issue that this task is assigned to */
  parentJob?: Maybe<Job>;
  priority?: Maybe<EnumJobPriority>;
  /** Run sheet associated with this job */
  runSheet?: Maybe<RunSheet>;
  /** ID of run sheet associated with this job */
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  subTasks: Array<Job>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  /** Date by which the issue should be resolved */
  targetDate?: Maybe<Scalars['Date']['output']>;
  /** Reference to a car data timestamp */
  timeInfo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type JobAction =
  | 'ACKNOWLEDGE'
  | 'CANCEL'
  | 'CLOSE'
  | 'REINSTATE'
  | 'REOPEN'
  | 'UNACKNOWLEDGE';

export type JobListBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

/** List of items with pagination. */
export type JobPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Job>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type JobStatus =
  | 'ACKNOWLEDGED'
  | 'CANCELLED'
  | 'CLOSED'
  | 'OPEN';

export type Kinematics = {
  /** Polynomial motion ratio. Limit to 5th order. */
  motionRatioPoly?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Map of damper travel (xDamper) to wheel travel (wWheel) in metres. Input syntax is array of key-value tuples, like `motionRatioTable: [["0", 0], ["0.001", 0.0005], ["0.002", 0.001]]`. */
  motionRatioTable?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type KinematicsExternalModel = {
  aCaster?: Maybe<Scalars['Float']['output']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  uprightPosition?: Maybe<Scalars['Float']['output']>;
  uprightPositionName?: Maybe<Scalars['String']['output']>;
};

export type KinematicsExternalModelInput = {
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  uprightPosition?: InputMaybe<Scalars['Float']['input']>;
  uprightPositionName?: InputMaybe<Scalars['String']['input']>;
};

export type KinematicsExternalSpec = AnySpecification & NonChassisSpec & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  aCamber?: Maybe<SpecificationACamber>;
  aCaster?: Maybe<SpecificationACamber>;
  aCasterMeasurementGain?: Maybe<Scalars['Float']['output']>;
  aCasterMeasurementOffset?: Maybe<Scalars['Float']['output']>;
  aToe?: Maybe<SpecificationACamber>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  axle?: Maybe<EnumAxle>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hRide?: Maybe<SpecificationHRide>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<KinematicsExternalSpec>;
  kinematicsExternalModels?: Maybe<Array<Maybe<KinematicsExternalModel>>>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  xToe?: Maybe<SpecificationHRide>;
};

export type KinematicsInput = {
  /** Polynomial motion ratio. Limit to 5th order. */
  motionRatioPoly?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Map of damper travel (xDamper) to wheel travel (wWheel) in metres. Input syntax is array of key-value tuples, like `motionRatioTable: [["0", 0], ["0.001", 0.0005], ["0.002", 0.001]]`. */
  motionRatioTable?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KinematicsInternalSpec = AnySpecification & NonChassisSpec & {
  FSpringSetup?: Maybe<AdjustableForce>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  axle?: Maybe<EnumAxle>;
  buildSheetDisplayLocation?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  bumpRubberReference?: Maybe<EnumKinematicsInternalReference>;
  bumpStopGapMethod?: Maybe<EnumBumpStopGapMethod>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  iterations: Array<KinematicsInternalSpec>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  springReference?: Maybe<EnumKinematicsInternalReference>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Tracking items populated from the trackingItemIDs field on the root specification. PLEASE INCLUDE rootSpecID in query to return results. */
  trackingItems: Array<Maybe<TrackingItem>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  xBumpRubberRef?: Maybe<Scalars['Float']['output']>;
  xBumpRubberSetup?: Maybe<AdjustableLength>;
  xDamperDroopDefault?: Maybe<Scalars['Float']['output']>;
  xSpringPlatformOffset?: Maybe<Scalars['Float']['output']>;
  xSpringRef?: Maybe<Scalars['Float']['output']>;
  xSpringSetup?: Maybe<AdjustableLength>;
};

export type Lap = {
  /**
   * Was DRS used in this lap?
   * @deprecated Use `data` instead.
   */
  BDRSUsed?: Maybe<Scalars['Boolean']['output']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Is this laptime slow? */
  BLapIsSlow?: Maybe<Scalars['Boolean']['output']>;
  /** Is this an IN lap? */
  BPitIn: Scalars['Boolean']['output'];
  /** Is this an OUT lap? */
  BPitOut: Scalars['Boolean']['output'];
  /** Lap number in run from timing */
  NLapRun: Scalars['Float']['output'];
  /** Lap number in run from car data */
  NLapRunCarData?: Maybe<Scalars['Float']['output']>;
  /** Lap number in run from manual mode */
  NLapRunManual?: Maybe<Scalars['Float']['output']>;
  /** Lap number in session from timing */
  NLapSession?: Maybe<Scalars['Int']['output']>;
  /** Lap number in session from car data */
  NLapSessionCarData?: Maybe<Scalars['Float']['output']>;
  /** Lap number in session from manual mode */
  NLapSessionManual?: Maybe<Scalars['Float']['output']>;
  /** Lap number in stint from timing */
  NLapStint?: Maybe<Scalars['Float']['output']>;
  /** Lap number in stint from car data */
  NLapStintCarData?: Maybe<Scalars['Float']['output']>;
  /** Lap number in stint from manual mode */
  NLapStintManual?: Maybe<Scalars['Float']['output']>;
  /**
   * Cell temperature
   * @deprecated Use `data` instead.
   */
  TCell?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  /** The contestant this lap belongs to. */
  contestantID: Scalars['MongoID']['output'];
  data?: Maybe<Array<Maybe<LapData>>>;
  /**
   * Amount of energy (fuel/battery) at the start of this lap.
   * @deprecated Use `data` instead.
   */
  energyLapStart?: Maybe<Scalars['Float']['output']>;
  /**
   * Energy or fuel remaining
   * @deprecated Use `data` instead.
   */
  energyRemaining?: Maybe<Scalars['Float']['output']>;
  /**
   * Energy or fuel remaining as data input (e.g. from telemetry)
   * @deprecated Use `data` instead.
   */
  energyRemainingData?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use mFuelConsumptionThisLap instead. */
  fuelConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Comments made by the driver */
  lapComment?: Maybe<Scalars['String']['output']>;
  /** Systems info generated during the lap */
  lapCommentSystems?: Maybe<Scalars['String']['output']>;
  /**
   * Map of lap KPI fields to their values for car-data-related analysis. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data.
   * @deprecated Use `data` instead.
   */
  lapKPI?: Maybe<Scalars['JSON']['output']>;
  lapType?: Maybe<EnumLapType>;
  laptimeServiceHash?: Maybe<Scalars['String']['output']>;
  /** Resolved fuel consumption for this lap MANUAL >> DATA */
  mFuelConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Resolved fuel load at lap end MANUAL >> DATA */
  mFuelLapEnd?: Maybe<Scalars['Float']['output']>;
  /**
   * Fuel mass remaining at the start of this lap.
   * @deprecated Use `data` instead.
   */
  mFuelLapStart?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  /**
   * Highest power mode used this lap (for electric vehicles).
   * @deprecated Use `data` instead.
   */
  powerMode?: Maybe<Scalars['Float']['output']>;
  /** Resolved energy consumption for this lap MANUAL >> DATA (negative = charge) */
  rEnergyConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Resolved total energy used at lap end MANUAL >> DATA */
  rEnergyLapEnd?: Maybe<Scalars['Float']['output']>;
  /**
   * Energy remaining at the start of this lap.
   * @deprecated Use `data` instead.
   */
  rEnergyLapStart?: Maybe<Scalars['Float']['output']>;
  /** Resolved state of charge consumption for this lap MANUAL >> DATA (negative = charge) */
  rSOCConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Resolved state of charge at lap end MANUAL >> DATA */
  rSOCLapEnd?: Maybe<Scalars['Float']['output']>;
  /**
   * SOC remaining at the start of this lap.
   * @deprecated Use `data` instead.
   */
  rSOCLapStart?: Maybe<Scalars['Float']['output']>;
  raceControlMessage?: Maybe<Scalars['String']['output']>;
  /** The run sheet this lap belongs to. */
  runSheetID: Scalars['MongoID']['output'];
  /** The session this lap belongs to. */
  sessionID: Scalars['MongoID']['output'];
  /** Resolved daytime. Either from Timing or calculated from runsheet start time and laptimes up to this point in time */
  tDay?: Maybe<Scalars['Date']['output']>;
  /**
   * If this is an IN lap, indicates when the driver crossed the pit entry line.
   * @deprecated Use `data` instead.
   */
  tDayPitIn?: Maybe<Scalars['Date']['output']>;
  /**
   * If this is an OUT lap, indicates when the driver crossed the pit exit line.
   * @deprecated Use `data` instead.
   */
  tDayPitOut?: Maybe<Scalars['Date']['output']>;
  /**
   * Time of day of each sector, provided by a timing service.
   * @deprecated Use `data` instead.
   */
  tDaySectors?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  /** Laptime where input directly by a user. */
  tLapManual?: Maybe<Scalars['Float']['output']>;
  /** Laptime */
  tLapMax?: Maybe<Scalars['Float']['output']>;
  /**
   * Sectore times given manually by a user.
   * @deprecated Use `data` instead.
   */
  tSectorsManual?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /**
   * Sector times as given by an alternative official source.
   * @deprecated Use `data` instead.
   */
  tSectorsOfficial?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /**
   * Sector times as given by a timing service.
   * @deprecated Use `data` instead.
   */
  tSectorsTiming?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  /**
   * Map of timing KPI fields to their values for timing-related analysis. Input syntax is array of tuples, like `timingKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data.
   * @deprecated Use `data` instead.
   */
  timingKPI?: Maybe<Scalars['JSON']['output']>;
  trackLayout?: Maybe<TrackLayout>;
  trackLayoutID?: Maybe<Scalars['MongoID']['output']>;
  /** @deprecated Use `data` instead. */
  trackStates?: Maybe<Array<Maybe<TrackState>>>;
  /**
   * Tyre compound information from timing stream
   * @deprecated Use `data` instead.
   */
  tyreCompoundTiming?: Maybe<Scalars['String']['output']>;
  /**
   * Official topspeed measurement
   * @deprecated Use `data` instead.
   */
  vCarLapMax?: Maybe<Scalars['Float']['output']>;
  /**
   * Official speed measurements per sector
   * @deprecated Use `data` instead.
   */
  vCarSectors?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};


export type LapLapKpiArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type LapTimingKpiArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LapColumn = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  field: EnumLapColumnField;
  label?: Maybe<Scalars['String']['output']>;
  lowerLimit?: Maybe<ValueLimit>;
  upperLimit?: Maybe<ValueLimit>;
};

export type LapColumnInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field: EnumLapColumnField;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<ValueLimitInput>;
  upperLimit?: InputMaybe<ValueLimitInput>;
};

export type LapData = {
  /** Was DRS used in this lap? */
  BDRSUsed?: Maybe<Scalars['Boolean']['output']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Is this laptime slow and should be excluded from average calculation? */
  BLapIsSlow?: Maybe<Scalars['Boolean']['output']>;
  /** Received a Track Limit Warning from Race Control */
  BTrackLimitWarning?: Maybe<Scalars['Boolean']['output']>;
  /** Cell temperature */
  TCell?: Maybe<Scalars['Float']['output']>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Coded message from driver */
  driverCallout?: Maybe<Scalars['String']['output']>;
  /** Coded message from driver */
  driverCallout2?: Maybe<Scalars['String']['output']>;
  /** Map of kpi fields to their values for analysis. Input syntax is array of tuples, like `kpi: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  kpi?: Maybe<Scalars['JSON']['output']>;
  lapType?: Maybe<EnumLapType>;
  /** Fuel mass consumption in this lap */
  mFuelConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel mass remaining at the end of this lap. */
  mFuelLapEnd?: Maybe<Scalars['Float']['output']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: Maybe<Scalars['Float']['output']>;
  /** Energy comsumption in this lap (kWh) */
  rEnergyConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** Energy remaining (kWh)  at the end of this lap. */
  rEnergyLapEnd?: Maybe<Scalars['Float']['output']>;
  /** SoC comsumption in this lap (%) */
  rSOCConsumptionThisLap?: Maybe<Scalars['Float']['output']>;
  /** SOC (%) remaining at the end of this lap. */
  rSOCLapEnd?: Maybe<Scalars['Float']['output']>;
  raceControlMessage?: Maybe<Scalars['String']['output']>;
  /** Source of the lap data */
  source: EnumLapDataSource;
  /** Time at which this lap was completed. */
  tDay?: Maybe<Scalars['Date']['output']>;
  /** If this is an IN lap, indicates when the driver crossed the pit entry line. */
  tDayPitIn?: Maybe<Scalars['Date']['output']>;
  /** If this is an OUT lap, indicates when the driver crossed the pit exit line. */
  tDayPitOut?: Maybe<Scalars['Date']['output']>;
  /** Time of day of each sector. */
  tDaySectors?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  /** Time spent in pits if the lap started from the pit lane. */
  tInPit?: Maybe<Scalars['Float']['output']>;
  /** Laptime */
  tLapMax?: Maybe<Scalars['Float']['output']>;
  /** Sectore times. */
  tSectors?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  tSessionRemainingLapStart?: Maybe<Scalars['Float']['output']>;
  trackStates?: Maybe<Array<Maybe<TrackState>>>;
  /** Tyre compound information */
  tyreCompound?: Maybe<Scalars['String']['output']>;
  /** Official topspeed measurement */
  vCarLapMax?: Maybe<Scalars['Float']['output']>;
  /** Official speed measurements per sector */
  vCarSectors?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type LapDataInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow and should be excluded from average calculation? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Received a Track Limit Warning from Race Control */
  BTrackLimitWarning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Coded message from driver */
  driverCallout?: InputMaybe<Scalars['String']['input']>;
  /** Coded message from driver */
  driverCallout2?: InputMaybe<Scalars['String']['input']>;
  /** Map of kpi fields to their values for analysis. Input syntax is array of tuples, like `kpi: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  kpi?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  /** Fuel mass consumption in this lap */
  mFuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel mass remaining at the end of this lap. */
  mFuelLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  /** Energy comsumption in this lap (kWh) */
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Energy remaining (kWh)  at the end of this lap. */
  rEnergyLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** SoC comsumption in this lap (%) */
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** SOC (%) remaining at the end of this lap. */
  rSOCLapEnd?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** Source of the lap data */
  source: EnumLapDataSource;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an IN lap, indicates when the driver crossed the pit entry line. */
  tDayPitIn?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an OUT lap, indicates when the driver crossed the pit exit line. */
  tDayPitOut?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Time spent in pits if the lap started from the pit lane. */
  tInPit?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times. */
  tSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tSessionRemainingLapStart?: InputMaybe<Scalars['Float']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<TrackStateInput>>>;
  /** Tyre compound information */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** Lap flag field labels mapped to their display names. Null or unset fields are not displayed. */
export type LapFlagLabels = {
  ATTACK?: Maybe<Scalars['String']['output']>;
  COOL?: Maybe<Scalars['String']['output']>;
  FCY?: Maybe<Scalars['String']['output']>;
  IN?: Maybe<Scalars['String']['output']>;
  OUT?: Maybe<Scalars['String']['output']>;
  OUTIN?: Maybe<Scalars['String']['output']>;
  PITLANE?: Maybe<Scalars['String']['output']>;
  PREP?: Maybe<Scalars['String']['output']>;
  PUSH?: Maybe<Scalars['String']['output']>;
  QUALI?: Maybe<Scalars['String']['output']>;
  SAFETYCAR?: Maybe<Scalars['String']['output']>;
  SHAKEDOWN?: Maybe<Scalars['String']['output']>;
  SLOW?: Maybe<Scalars['String']['output']>;
  TARGET?: Maybe<Scalars['String']['output']>;
  TOGRID?: Maybe<Scalars['String']['output']>;
  TOPADDOCK?: Maybe<Scalars['String']['output']>;
  TOPITS?: Maybe<Scalars['String']['output']>;
  UNFINISHED?: Maybe<Scalars['String']['output']>;
};

/** Lap flag field labels mapped to their display names. Null or unset fields are not displayed. */
export type LapFlagLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
};

export type LapInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this an IN lap? */
  BPitIn: Scalars['Boolean']['input'];
  /** Is this an OUT lap? */
  BPitOut: Scalars['Boolean']['input'];
  /** Lap number in run from timing */
  NLapRun: Scalars['Float']['input'];
  /** Lap number in run from car data */
  NLapRunCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in run from manual mode */
  NLapRunManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from timing */
  NLapSession?: InputMaybe<Scalars['Int']['input']>;
  /** Lap number in session from car data */
  NLapSessionCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from manual mode */
  NLapSessionManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from timing */
  NLapStint?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from car data */
  NLapStintCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from manual mode */
  NLapStintManual?: InputMaybe<Scalars['Float']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<LapDataInput>>>;
  /** Amount of energy (fuel/battery) at the start of this lap. */
  energyLapStart?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining */
  energyRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining as data input (e.g. from telemetry) */
  energyRemainingData?: InputMaybe<Scalars['Float']['input']>;
  fuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Comments made by the driver */
  lapComment?: InputMaybe<Scalars['String']['input']>;
  /** Systems info generated during the lap */
  lapCommentSystems?: InputMaybe<Scalars['String']['input']>;
  /** Map of lap KPI fields to their values for car-data-related analysis. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  laptimeServiceHash?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** The run sheet this lap belongs to. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector, provided by a timing service. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Laptime where input directly by a user. */
  tLapManual?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times given manually by a user. */
  tSectorsManual?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by an alternative official source. */
  tSectorsOfficial?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by a timing service. */
  tSectorsTiming?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of timing KPI fields to their values for timing-related analysis. Input syntax is array of tuples, like `timingKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  timingKPI?: InputMaybe<Scalars['JSON']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<TrackStateInput>>>;
  /** Tyre compound information from timing stream */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** List of items with pagination. */
export type LapPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Lap>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LapSequence = {
  _id: Scalars['MongoID']['output'];
  laps: Array<Maybe<LapSequenceLaps>>;
  name: Scalars['String']['output'];
  raceSeriesID?: Maybe<Scalars['MongoID']['output']>;
};

export type LapSequenceLaps = {
  NLap: Scalars['Float']['output'];
  _id?: Maybe<Scalars['MongoID']['output']>;
  lapType: EnumLapSequenceLapsLapType;
};

export type LapSequenceLapsInput = {
  NLap: Scalars['Float']['input'];
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lapType: EnumLapSequenceLapsLapType;
};

/** List of items with pagination. */
export type LapSequencePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<LapSequence>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LapSequenceTemplate = {
  _id: Scalars['MongoID']['output'];
  laps?: Maybe<Array<Maybe<LapSequenceTemplateLaps>>>;
  name: Scalars['String']['output'];
  raceSeriesID?: Maybe<Scalars['MongoID']['output']>;
};

export type LapSequenceTemplateLaps = {
  /** Lap number in sequence */
  NLap: Scalars['Float']['output'];
  lapType: EnumLapSequenceTemplateLapsLapType;
};

export type LapSequenceTemplateLapsInput = {
  /** Lap number in sequence */
  NLap: Scalars['Float']['input'];
  lapType: EnumLapSequenceTemplateLapsLapType;
};

/** List of items with pagination. */
export type LapSequenceTemplatePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<LapSequenceTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LapTableBlock = {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** Source of the lap end energy value */
  energyLapEndSource?: Maybe<Scalars['String']['output']>;
  /** @deprecated Specify energy type at the root of the run sheet style instead. */
  energyType?: Maybe<EnumEnergyType>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** Ordered columns to show in the lap table */
  lapColumns?: Maybe<Array<Maybe<LapColumn>>>;
  /** @deprecated Use `lapFlags` at the root of the run sheet style instead. */
  lapFlags?: Maybe<LapFlagLabels>;
  /** Names of lapKPI fields to show */
  lapKPIs?: Maybe<Array<Maybe<GenericRunSheetStyleBlockLapKpIs>>>;
  manualLapInputByDefault?: Maybe<Scalars['Boolean']['output']>;
  showLapTypeColors?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use other fields to style the block instead */
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  velocityUnit?: Maybe<EnumVelocityUnit>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type LapTimeThresholdsBlock = {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type LapTypeCountBlock = {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  lapCountBlockFieldOrder?: Maybe<Array<Maybe<GenericRunSheetStyleBlockLapCountBlockFieldOrder>>>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

/** Collection of tuples defining bounds to automatically classify laps. Does not apply to in/out/race control lap types. Comparisons are to be made with `<` or `>=` at aligning bounds. Minimum value is 0 and maximum value is 1000000. */
export type LaptimeThresholds = {
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as cool. */
  cool?: Maybe<Array<Scalars['Float']['output']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as prep. */
  prep?: Maybe<Array<Scalars['Float']['output']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as push. */
  push?: Maybe<Array<Scalars['Float']['output']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as slow. */
  slow?: Maybe<Array<Scalars['Float']['output']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as target. */
  target?: Maybe<Array<Scalars['Float']['output']>>;
};

/** Collection of tuples defining bounds to automatically classify laps. Does not apply to in/out/race control lap types. Comparisons are to be made with `<` or `>=` at aligning bounds. Minimum value is 0 and maximum value is 1000000. */
export type LaptimeThresholdsInput = {
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as cool. */
  cool?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as prep. */
  prep?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as push. */
  push?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as slow. */
  slow?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as target. */
  target?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type LayoutConsumption = {
  SoCRequired?: Maybe<RunEnergy>;
  energyRequired?: Maybe<RunEnergy>;
  fuelRequired?: Maybe<RunEnergy>;
  trackLayout?: Maybe<TrackLayout>;
  trackLayoutID: Scalars['MongoID']['output'];
};

export type LayoutConsumptionInput = {
  SoCRequired?: InputMaybe<RunEnergyInput>;
  energyRequired?: InputMaybe<RunEnergyInput>;
  fuelRequired?: InputMaybe<RunEnergyInput>;
  trackLayoutID: Scalars['MongoID']['input'];
};

export type Length = {
  /** cm */
  centimetres: Scalars['Float']['output'];
  /** ft */
  feet: Scalars['Float']['output'];
  /** in */
  inches: Scalars['Float']['output'];
  /** km */
  kilometres: Scalars['Float']['output'];
  /** m */
  metres: Scalars['Float']['output'];
  /** μm */
  micrometres: Scalars['Float']['output'];
  /** mi */
  miles: Scalars['Float']['output'];
  /** mm */
  millimetres: Scalars['Float']['output'];
  /** thou */
  thou: Scalars['Float']['output'];
};

export type LengthInput = {
  /** cm */
  centimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft */
  feet?: InputMaybe<Scalars['Float']['input']>;
  /** in */
  inches?: InputMaybe<Scalars['Float']['input']>;
  /** km */
  kilometres?: InputMaybe<Scalars['Float']['input']>;
  /** m */
  metres?: InputMaybe<Scalars['Float']['input']>;
  /** μm */
  micrometres?: InputMaybe<Scalars['Float']['input']>;
  /** mi */
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** mm */
  millimetres?: InputMaybe<Scalars['Float']['input']>;
  /** thou */
  thou?: InputMaybe<Scalars['Float']['input']>;
};

export type LengthUnitField = {
  unit: EnumLengthUnit;
};

export type LicenseFeatures = {
  dyno: Scalars['Boolean']['output'];
  lightVersion: Scalars['Boolean']['output'];
  /** Should this server be configured for hybrid cloud deployment? */
  moveServer: Scalars['Boolean']['output'];
  /** Can data still be accessed if license has expired? */
  readOnlyAfterLicenseExpiry: Scalars['Boolean']['output'];
  sevenPost: Scalars['Boolean']['output'];
  /** Can the car data service be used? */
  simulation: Scalars['Boolean']['output'];
  /** Should team access control be enforced? */
  teams: Scalars['Boolean']['output'];
  tyreSetStatistics: Scalars['Boolean']['output'];
};

export type LicenseOptions = {
  services: LicenseServices;
  setupSheetStyles: Array<EnumChassisSetupSheetStyle>;
};

export type LicenseProperties = {
  customer?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  expired: Scalars['Boolean']['output'];
  features: LicenseFeatures;
  options: LicenseOptions;
  valid: Scalars['Boolean']['output'];
};

export type LicenseServices = {
  carData: Scalars['Boolean']['output'];
  chassisSimulation: Scalars['Boolean']['output'];
  oneTimingWeather: Scalars['Boolean']['output'];
  timing: Scalars['Boolean']['output'];
  weather: Scalars['Boolean']['output'];
};

export type LinkTrackingItemsToSpecification = {
  danglingTrackingItems?: Maybe<Scalars['Int']['output']>;
  updatedRecords?: Maybe<Scalars['Int']['output']>;
};

export type LinkTrackingSourcesToChassisSpecs = {
  danglingTrackingItems?: Maybe<Scalars['Int']['output']>;
  updatedRecords?: Maybe<Scalars['Int']['output']>;
};

export type LiveStanding = {
  acronym?: Maybe<Scalars['String']['output']>;
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  currentLocation?: Maybe<EnumLiveStandingCurrentLocation>;
  driverID?: Maybe<Scalars['MongoID']['output']>;
  fastestLap?: Maybe<BestValuesFastestLap>;
  fastestSectors?: Maybe<Array<Maybe<BestValuesFastestSector>>>;
  /** Does this driver have the fastest lap in the session? Only one driver should have this true at a time. */
  hasFastestLap?: Maybe<Scalars['Boolean']['output']>;
  lapsCompleted?: Maybe<Scalars['Int']['output']>;
  /** 1-indexed rank of this driver with respect to the rest of the grid */
  position: Scalars['Int']['output'];
  postRacePenalty?: Maybe<LiveStandingPostRacePenalty>;
  startNumber?: Maybe<Scalars['String']['output']>;
};

export type LiveStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  currentLocation?: InputMaybe<EnumLiveStandingCurrentLocation>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<BestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<BestValuesFastestSectorInput>>>;
  /** Does this driver have the fastest lap in the session? Only one driver should have this true at a time. */
  hasFastestLap?: InputMaybe<Scalars['Boolean']['input']>;
  lapsCompleted?: InputMaybe<Scalars['Int']['input']>;
  /** 1-indexed rank of this driver with respect to the rest of the grid */
  position: Scalars['Int']['input'];
  postRacePenalty?: InputMaybe<LiveStandingPostRacePenaltyInput>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type LiveStandingPostRacePenalty = {
  contestantID: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  totalTimePenalty?: Maybe<Scalars['Float']['output']>;
};

export type LiveStandingPostRacePenaltyInput = {
  contestantID: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  totalTimePenalty?: InputMaybe<Scalars['Float']['input']>;
};

export type LiveStandingsStartResult = {
  success: Scalars['Boolean']['output'];
};

export type LiveStandingsStopResult = {
  success: Scalars['Boolean']['output'];
};

export type LocalConnection = {
  dataMapping?: Maybe<EnumLocalConnectionDataMapping>;
  endPoint?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  outputFolder?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  useSSL?: Maybe<Scalars['Boolean']['output']>;
};

export type LocalConnectionInput = {
  dataMapping?: InputMaybe<EnumLocalConnectionDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  outputFolder?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Float']['input']>;
  useSSL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Location = {
  _id: Scalars['MongoID']['output'];
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  geoLocation?: Maybe<GeoLocation>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type LocationPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Location>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LocationUnitField = {
  unit: EnumUntypedUnit;
};

export type Log = {
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  logLevel?: Maybe<EnumLogLevel>;
  /** A single log from the source service */
  message: Scalars['String']['output'];
  serviceSource?: Maybe<EnumLogServiceSource>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<Person>;
  userID?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type LogPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Log>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LoginToken = {
  token: Scalars['String']['output'];
};

export type Manufacturer = {
  _id: Scalars['MongoID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
};

/** List of items with pagination. */
export type ManufacturerPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Manufacturer>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type MapTrackLatLon = {
  coordinates: Array<TrackXyCoordinate>;
  keyValueData: Array<TrackKeyValueEntry>;
  labels: Array<TrackLabel>;
  latLonCoordinates: Array<TrackLatLonCoordinate>;
  sectorPositions: Array<Scalars['Float']['output']>;
  svg: TrackSvg;
  warnings: Array<Scalars['String']['output']>;
};

export type MapTrackXy = {
  coordinates: Array<TrackXyCoordinate>;
  keyValueData: Array<TrackKeyValueEntry>;
  labels: Array<TrackLabel>;
  sectorPositions: Array<Scalars['Float']['output']>;
  svg: TrackSvg;
  warnings: Array<Scalars['String']['output']>;
};

export type Mass = {
  /** g */
  grams: Scalars['Float']['output'];
  /** kg */
  kilograms: Scalars['Float']['output'];
  /** mg */
  milligrams: Scalars['Float']['output'];
  /** oz */
  ounces: Scalars['Float']['output'];
  /** lb */
  pounds: Scalars['Float']['output'];
};

export type MassInput = {
  /** g */
  grams?: InputMaybe<Scalars['Float']['input']>;
  /** kg */
  kilograms?: InputMaybe<Scalars['Float']['input']>;
  /** mg */
  milligrams?: InputMaybe<Scalars['Float']['input']>;
  /** oz */
  ounces?: InputMaybe<Scalars['Float']['input']>;
  /** lb */
  pounds?: InputMaybe<Scalars['Float']['input']>;
};

export type MassProperties = {
  COGx?: Maybe<Scalars['Float']['output']>;
  COGy?: Maybe<Scalars['Float']['output']>;
  COGz?: Maybe<Scalars['Float']['output']>;
  Ixx?: Maybe<Scalars['Float']['output']>;
  Iyy?: Maybe<Scalars['Float']['output']>;
  Izz?: Maybe<Scalars['Float']['output']>;
  mass?: Maybe<Scalars['Float']['output']>;
  /** Allowable mass range, for when a set mass value doesn't apply */
  massRange?: Maybe<AdjustableMass>;
};

export type MassPropertiesInput = {
  COGx?: InputMaybe<Scalars['Float']['input']>;
  COGy?: InputMaybe<Scalars['Float']['input']>;
  COGz?: InputMaybe<Scalars['Float']['input']>;
  Ixx?: InputMaybe<Scalars['Float']['input']>;
  Iyy?: InputMaybe<Scalars['Float']['input']>;
  Izz?: InputMaybe<Scalars['Float']['input']>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  /** Allowable mass range, for when a set mass value doesn't apply */
  massRange?: InputMaybe<AdjustableMassInput>;
};

export type MassUnitField = {
  unit: EnumMassUnit;
};

export type Migrations = {
  carSetupMissingTitle: Scalars['Boolean']['output'];
  /** Date when this deployment was first ever booted. This should help with understanding how old certain data might be. */
  deployedAt?: Maybe<Scalars['Date']['output']>;
  eventContestantsDedup: Scalars['Boolean']['output'];
  /** @deprecated  */
  everythingToSI: Scalars['Boolean']['output'];
  issuePriority: Scalars['Boolean']['output'];
  lapPitOutAndInTimeStamps: Scalars['Boolean']['output'];
  lapSessionID?: Maybe<Scalars['Boolean']['output']>;
  lapsToCollection: Scalars['Boolean']['output'];
  manualMileageCustomToCarSetup: Scalars['Boolean']['output'];
  rootSpecificationID: Scalars['Boolean']['output'];
  runSheetAndLapTimeStamps: Scalars['Boolean']['output'];
  sessionTypeToEnum: Scalars['Boolean']['output'];
  setupSheetStyleTabs: Scalars['Boolean']['output'];
  setupTimingServiceStatus: Scalars['Boolean']['output'];
  teamsToTeamIDsOnPart: Scalars['Boolean']['output'];
  trackingSourcesAndItems: Scalars['Boolean']['output'];
  trackingUpdate202506: Scalars['Boolean']['output'];
  /** @deprecated  */
  tyreBlockPressuresToSI: Scalars['Boolean']['output'];
  /** Date when any migration was last updated. */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MigrationsInput = {
  carSetupMissingTitle?: InputMaybe<Scalars['Boolean']['input']>;
  eventContestantsDedup?: InputMaybe<Scalars['Boolean']['input']>;
  everythingToSI?: InputMaybe<Scalars['Boolean']['input']>;
  issuePriority?: InputMaybe<Scalars['Boolean']['input']>;
  lapPitOutAndInTimeStamps?: InputMaybe<Scalars['Boolean']['input']>;
  lapSessionID?: InputMaybe<Scalars['Boolean']['input']>;
  lapsToCollection?: InputMaybe<Scalars['Boolean']['input']>;
  manualMileageCustomToCarSetup?: InputMaybe<Scalars['Boolean']['input']>;
  rootSpecificationID?: InputMaybe<Scalars['Boolean']['input']>;
  runSheetAndLapTimeStamps?: InputMaybe<Scalars['Boolean']['input']>;
  sessionTypeToEnum?: InputMaybe<Scalars['Boolean']['input']>;
  setupSheetStyleTabs?: InputMaybe<Scalars['Boolean']['input']>;
  setupTimingServiceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  teamsToTeamIDsOnPart?: InputMaybe<Scalars['Boolean']['input']>;
  trackingSourcesAndItems?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUpdate202506?: InputMaybe<Scalars['Boolean']['input']>;
  tyreBlockPressuresToSI?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MileageAtRunStart = {
  endMileage?: Maybe<Scalars['Float']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  startMileage?: Maybe<Scalars['Float']['output']>;
};

export type MiniJobListBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type MomentOfInertia = {
  /** kgm² */
  kilogramMetresSquared: Scalars['Float']['output'];
  /** lbf·ft/s² */
  poundForceFeetSecondSquared: Scalars['Float']['output'];
};

export type MomentOfInertiaInput = {
  /** kgm² */
  kilogramMetresSquared?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/s² */
  poundForceFeetSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type MongoError = ErrorInterface & {
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  /** Activate a car data service configuration for its race series. This action deactivates the currently active one for the race series. */
  activateCarDataServiceConfig?: Maybe<ActivateCarDataServiceConfigResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addAssembly?: Maybe<CreateOneAssemblyPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addAssemblyTemplate?: Maybe<CreateOneAssemblyTemplatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addBestValues?: Maybe<CreateOneBestValuesPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addBop?: Maybe<CreateOneBopPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addBuildSheetStyle?: Maybe<CreateOneBuildSheetStylePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addCalculation?: Maybe<CreateOneCalculationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addCarDataServiceConfig?: Maybe<CreateOneCarDataServiceConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addCarSetup?: Maybe<CreateOneCarSetupPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addChassis?: Maybe<CreateOneChassisPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addChassisMeasurement?: Maybe<CreateOneChassisMeasurementPayload>;
  addComment?: Maybe<AddCommentResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addContestant?: Maybe<CreateOneContestantPayload>;
  /** Add data from control telemetry. This is the mutation for the 'end of lap' scenario. */
  addControlTelemetryEndOfLap?: Maybe<AddControlTelemetryEndOfLapResult>;
  /** Add data from control telemetry. This is the mutation for the 'end of run' scenario. */
  addControlTelemetryEndOfRun?: Maybe<AddControlTelemetryEndOfRunResult>;
  /** Add data from control telemetry. This is the mutation for the 'start of' scenario. */
  addControlTelemetryStartOfData?: Maybe<AddControlTelemetryStartOfDataResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addDepartment?: Maybe<CreateOneDepartmentPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addDynoConfig?: Maybe<CreateOneDynoConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addEvent?: Maybe<CreateOneEventPayload>;
  /** Add a contestant to an event. */
  addEventContestant?: Maybe<AddEventContestantResult>;
  /** Add flattened simulation payload to car setup and part instances */
  addFlattenedSimulationPayload?: Maybe<AddFlattenedPayloadReturnType>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addFlexLayoutConfig?: Maybe<CreateOneFlexLayoutConfigPayload>;
  /** Create an event with sessions */
  addFullEvent?: Maybe<Event>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addGreeboLog?: Maybe<CreateOneGreeboLogPayload>;
  addHistoricalWeather?: Maybe<Weather>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addIssue?: Maybe<CreateOneIssuePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addJob?: Maybe<CreateOneJobPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  addJobsMany?: Maybe<CreateManyJobPayload>;
  /** Add a lap to a run sheet. Duplicate `NLapRun` or `tDay` values are not allowed; use `forceAddLap` if you must override this behaviour */
  addLap?: Maybe<RunSheet>;
  addLapByService?: Maybe<RunSheet>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addLapSequence?: Maybe<CreateOneLapSequencePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addLapSequenceTemplate?: Maybe<CreateOneLapSequenceTemplatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addLocation?: Maybe<CreateOneLocationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addLog?: Maybe<CreateOneLogPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addManufacturer?: Maybe<CreateOneManufacturerPayload>;
  /** Add contestant(s) to an event. */
  addManyEventContestants?: Maybe<AddManyEventContestantsResult>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  addManyTimeSheetEntries?: Maybe<CreateManyTimeSheetEntryPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addOneTimingWeatherServiceConfig?: Maybe<CreateOneOneTimingWeatherServiceConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPackage?: Maybe<CreateOnePackagePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPart?: Maybe<CreateOnePartPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPartInstance?: Maybe<CreateOnePartInstancePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPartInstanceForCopyAssembly?: Maybe<CreateOnePartInstancePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPerson?: Maybe<CreateOnePersonPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPlotPageConfig?: Maybe<CreateOnePlotPageConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addPointsSystem?: Maybe<CreateOnePointsSystemPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addProject?: Maybe<CreateOneProjectPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addQualityCheck?: Maybe<CreateOneQualityCheckPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addQualityCheckAction?: Maybe<CreateOneQualityCheckActionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addRaceSeries?: Maybe<CreateOneRaceSeriesPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addRadioMessage?: Maybe<CreateOneRadioMessagePayload>;
  /** Add a note to a page on the report */
  addReportNote?: Maybe<ReportNote>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addReportNotesTemplate?: Maybe<CreateOneReportNotesTemplatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addReportTemplate?: Maybe<CreateOneReportTemplatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addRunPlan?: Maybe<CreateOneRunPlanPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addRunSheet?: Maybe<CreateOneRunSheetPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addRunSheetStyle?: Maybe<CreateOneRunSheetStylePayload>;
  /** Add a run to an existing run plan. */
  addRunToRunPlan?: Maybe<RunPlan>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSeason?: Maybe<CreateOneSeasonPayload>;
  addSector?: Maybe<RunSheet>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSession?: Maybe<CreateOneSessionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSessionDebriefTemplate?: Maybe<CreateOneTemplateSessionDebriefPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSetupOverviewConfig?: Maybe<CreateOneSetupOverviewConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSetupSheetStyle?: Maybe<CreateOneSetupSheetStylePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSimRequest?: Maybe<CreateOneSimRequestPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSimResult?: Maybe<CreateOneSimResultPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSimulationDriveFile?: Maybe<CreateOneSimulationDriveFilePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSkidPlate?: Maybe<CreateOneSkidPlatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSpecification?: Maybe<CreateOneSpecificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSpecificationGroup?: Maybe<CreateOneSpecificationGroupPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addSsoProvider?: Maybe<CreateOneSsoProviderPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTag?: Maybe<CreateOneTagPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTeam?: Maybe<CreateOneTeamPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTemplateJobList?: Maybe<CreateOneTemplateJobListPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTestUser?: Maybe<CreateOnePersonPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTimeSheetEntry?: Maybe<CreateOneTimeSheetEntryPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTimingServiceConfig?: Maybe<CreateOneTimingServiceConfigPayload>;
  /** Append to an array of IDs on a contestant. */
  addToContestant?: Maybe<Contestant>;
  /** Append to an array of IDs within an event's `contestants` array. The contestant is added to the event if not already present there. */
  addToEventContestant?: Maybe<Event>;
  /** Append to an array of IDs within a session's `contestants` array. The contestant is added to the session if not already present there. */
  addToSessionContestant?: Maybe<Session>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrack?: Maybe<CreateOneTrackPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackLayout?: Maybe<CreateOneTrackLayoutPayload>;
  addTrackState?: Maybe<RunSheet>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackable?: Maybe<CreateOneTrackablePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingItem?: Maybe<CreateOneTrackingItemPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingMeasurement?: Maybe<CreateOneTrackingMeasurementPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingMeasurementRecord?: Maybe<CreateOneTrackingMeasurementRecordPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingRecord?: Maybe<CreateOneTrackingRecordPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingRecordGeneral?: Maybe<CreateOneTrackingRecordGeneralPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingRecordOverride?: Maybe<CreateOneTrackingRecordOverridePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingRecordValue?: Maybe<CreateOneTrackingRecordValuePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingSource?: Maybe<CreateOneTrackingSourcePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTrackingSourceAlias?: Maybe<CreateOneTrackingSourceAliasPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTyre?: Maybe<CreateOneTyrePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTyreSet?: Maybe<CreateOneTyreSetPayload>;
  /** Add / assign tyre set to contestant */
  addTyreSetsToContestant?: Maybe<AddTyreSetsToContestantResult>;
  /** Add / assign tyre set to event contestant */
  addTyreSetsToEventContestant?: Maybe<AddTyreSetsToEventContestantResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addTyreWear?: Maybe<CreateOneTyreWearPayload>;
  /** Add / assign tyres to contestant */
  addTyresToContestant?: Maybe<AddTyresToContestantResult>;
  /** Add / assign tyres to event contestant */
  addTyresToEventContestant?: Maybe<AddTyresToEventContestantResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addUserEnum?: Maybe<CreateOneUserEnumPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addWeather?: Maybe<CreateOneWeatherPayload>;
  addWeatherFromSource?: Maybe<Weather>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addWeatherServiceConfig?: Maybe<CreateOneWeatherServiceConfigPayload>;
  addvCarSector?: Maybe<RunSheet>;
  appendWeather?: Maybe<Weather>;
  /** Add a lap sequence to a runsheet */
  applyLapSequence?: Maybe<ApplyLapSequence>;
  /** Apply a migration on demand. */
  applyMigration?: Maybe<ApplyMigrationResult>;
  applyPackage?: Maybe<ApplyPackageResult>;
  applyPackageItems?: Maybe<ApplyPackageItemsResult>;
  approveTimeSheetEntries?: Maybe<Scalars['Boolean']['output']>;
  approveTimeSheetEntry?: Maybe<TimeSheetEntry>;
  /** Assign something to any team. */
  assignTeam?: Maybe<AssignTeamResult>;
  /** Forcibly calculate all run sheet mileages */
  calculateAllMileages: Scalars['Boolean']['output'];
  /** Calculate run energy (fuel/energy/SOC) for all run sheets */
  calculateAllRunEnergies?: Maybe<CalculateAllRunEnergiesResult>;
  /** Forcibly calculate selected run sheet mileages */
  calculateMileagesByRunSheetIDs: Scalars['Boolean']['output'];
  /** Calculate run energy (fuel/energy/SOC) for a run sheet and its subsequent runsheets */
  calculateRunEnergy?: Maybe<CalculateRunEnergyResult>;
  /** Claim a car setup for your team, preventing write access for anyone from other teams. */
  claimCarSetup?: Maybe<ClaimCarSetupResult>;
  /** Claim a run sheet (and any connected run sheets) for your team, preventing write access for anyone from other teams. */
  claimRunSheet?: Maybe<ClaimRunSheetResult>;
  /** Clone an existing package */
  clonePackage?: Maybe<ClonePackageResolverResult>;
  /** Clone a run plan */
  cloneRunPlan?: Maybe<RunPlan>;
  /** Copy an assembly and its subassemblies to new documents */
  copyAssembly?: Maybe<CopyAssemblyResult>;
  /** Create a new car setup using an existing one as a starting point. */
  copyCarSetup?: Maybe<CreatedSetup>;
  /** Create a new chassis assembly using the source chassis assembly's values, and link it to the destination car setup. */
  copyChassisAssembly?: Maybe<CreatedChassisAssembly>;
  /** Use an existing event as a template for creating a new one. Child sessions are partially re-created, with end times calculated based on offsets from the source event. */
  copyEvent?: Maybe<Event>;
  /** Create a database backup. Returns the name of the backup. You may specify a name to attach to the end of the auto-generated text. */
  createBackup?: Maybe<CreateBackupResult>;
  /** Creates go look at assembly records for a given chassis assembly. It will update all related parts */
  createGoLookAtAssemblyRecord?: Maybe<Scalars['Boolean']['output']>;
  createPackage?: Maybe<Package>;
  /** Create tyres and assign them to a contestant in one call. `tyres` are created on their own, `sets` are created as four tyres grouped into a TyreSet. With an `eventID` everything is assigned to that event's contestant, without one to the season contestant. */
  createTyresForContestant?: Maybe<CreateTyresForContestantResult>;
  /** Runs data checks */
  dataCheck?: Maybe<DataCheckResolverReturnType>;
  /** Copy notes from an RNT into an event's ReportNote, replacing content on the selected pages */
  draftNotesFromTemplate?: Maybe<ReportNote>;
  /** Updates linked run sheets with data from the run plan (driver, tyres, fuel, laps) */
  draftRunSheets?: Maybe<RunPlan>;
  /** Creates go look at assembly records for a given chassis assembly and removes all previous tracking records with this chassis assemblyID */
  fixAssemblyTracking?: Maybe<FixAssemblyTracking>;
  /** Fixes part instance and nested part instance id arrays on chassis assembly */
  fixPartInstanceArrays?: Maybe<FixPartInstanceArrayResult>;
  /** Check and reset part instances and tracking records */
  fixPartInstancesResolver?: Maybe<FixPartInstancesByPartId>;
  /** Clean part tracking history. Remove tracking history entries for inactive tracking items and dead assemblies */
  fixPartTrackingHistory?: Maybe<FixPartTrackingHistory>;
  /** Run the clean part tracking history function for a full assembly */
  fixTrackingForAssemblyParts?: Maybe<FixTrackingForAssemblyParts>;
  /** Add a lap to a run sheet, allowing any `NLapRun` and `tDay` value. If a lap with that `NLapRun` exists, it and all following laps will have their `NLapRun` incremented. */
  forceAddLap?: Maybe<RunSheet>;
  /** Send an email with a password reset link to the requested account, if it exists. */
  forgotPassword?: Maybe<ForgotPasswordResult>;
  forwardAddPartInstance?: Maybe<CreatedPartInstancesResult>;
  /** Update a car setup value to all future runs in a session, until the original value is different from the baseline value of the car setup provided.Field input must be provided in dot notation ("title" or "frontLeft.hRide") */
  forwardUpdateCarSetup?: Maybe<UpdateCarSetupResult>;
  forwardUpsertPartInstance?: Maybe<ForwardUpsertPartInstanceResult>;
  greeboLogPushGPSData?: Maybe<GreeboLog>;
  greeboLogPushRawLines?: Maybe<GreeboLog>;
  greeboLogUpdateCarPositions?: Maybe<GreeboLog>;
  /** Create a new runsheet using the source runsheet as a reference. Copies many values, increments `NRun`(`Timing`), and calculates energy/fuel available based on energy/fuel required. Use `record` to specify any overrides. */
  incrementRunSheet?: Maybe<IncrementRunSheetPayload>;
  /** Create a new car setup using the source runsheet's linked setup's values, and link it to the destination runsheet. */
  incrementSetupSheet?: Maybe<CreatedSetup>;
  incrementSpecification?: Maybe<IncrementSpecificationResult>;
  /** Insert a new lap lap before another */
  insertLap?: Maybe<Lap>;
  insertRun?: Maybe<InsertRunPayload>;
  /** Insert a run into an existing run plan. */
  insertRunInRunPlan?: Maybe<RunPlan>;
  insertRunIntoSession?: Maybe<InsertRunPayload>;
  /** Re-establishes broken links between tracking items and specifications */
  linkTrackingItemsToSpecification?: Maybe<LinkTrackingItemsToSpecification>;
  /** Re-establishes broken links between tracking items and specifications */
  linkTrackingSourcesToChassisSpecs?: Maybe<LinkTrackingSourcesToChassisSpecs>;
  liveStandingsStart?: Maybe<LiveStandingsStartResult>;
  liveStandingsStop?: Maybe<LiveStandingsStopResult>;
  login?: Maybe<LoginToken>;
  /** Perform an action on a issue as the logged in user. */
  manageIssue: Issue;
  /** Perform an action on a job as the logged in user. */
  manageJob: Job;
  oneTimingWeatherServiceConfigure?: Maybe<TimingConfigureResult>;
  oneTimingWeatherServiceStart?: Maybe<OneTimingWeatherServiceStartResult>;
  oneTimingWeatherServiceStop?: Maybe<OneTimingWeatherServiceStopResult>;
  /** Calculate part lifetime mileage by its ID */
  recalculatePartMileageByIDResolver?: Maybe<CalculatePartMileageById>;
  /** Regenerate part tracking history. Remove tracking history entries for inactive tracking items and dead assemblies */
  regeneratePartTrackingHistory?: Maybe<RegeneratePartTrackingHistory>;
  releaseChassisSpec?: Maybe<ReleaseChassisSpecResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeAssembly?: Maybe<RemoveByIdAssemblyPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeAssemblyTemplate?: Maybe<RemoveByIdAssemblyTemplatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeBestValues?: Maybe<RemoveByIdBestValuesPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeBop?: Maybe<RemoveByIdBopPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeBuildSheetStyle?: Maybe<RemoveByIdBuildSheetStylePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeCalculation?: Maybe<RemoveByIdCalculationPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeCarDataServiceConfig?: Maybe<RemoveByIdCarDataServiceConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeCarSetup?: Maybe<RemoveByIdCarSetupPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeChassis?: Maybe<RemoveByIdChassisPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeChassisMeasurement?: Maybe<RemoveByIdChassisMeasurementPayload>;
  removeComment?: Maybe<RemoveCommentResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeContestant?: Maybe<RemoveByIdContestantPayload>;
  /** Removes tracking records from the DB with trackingItemID: null and trackingSourceID: null */
  removeDeadTrackingRecords?: Maybe<RemoveDeadTrackingRecords>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeDepartment?: Maybe<RemoveByIdDepartmentPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeDynoConfig?: Maybe<RemoveByIdDynoConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeEvent?: Maybe<RemoveByIdEventPayload>;
  /** Remove a contestant from an event. */
  removeEventContestant?: Maybe<RemoveEventContestantResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeFlexLayoutConfig?: Maybe<RemoveByIdFlexLayoutConfigPayload>;
  /** Pop from an array of IDs on a contestant. */
  removeFromContestant?: Maybe<Contestant>;
  /** Pop from an array of IDs within an event's `contestants` array. */
  removeFromEventContestant?: Maybe<Event>;
  /** Pop from an array of IDs within an session's `contestants` array. */
  removeFromSessionContestant?: Maybe<Session>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeIssue?: Maybe<RemoveByIdIssuePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeJob?: Maybe<RemoveByIdJobPayload>;
  /** Remove a lap from a run sheet. If it's not the final lap, laps that come after it will have their `NLapRun` adjusted to suit. */
  removeLap?: Maybe<RunSheet>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeLapByID?: Maybe<RemoveByIdLapPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeLapByIDByService?: Maybe<RemoveByIdLapPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeLapSequence?: Maybe<RemoveByIdLapSequencePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeLapSequenceTemplate?: Maybe<RemoveByIdLapSequenceTemplatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeLocation?: Maybe<RemoveByIdLocationPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeManufacturer?: Maybe<RemoveByIdManufacturerPayload>;
  /** Remove many contestants from an event. */
  removeManyEventContestants?: Maybe<RemoveManyEventContestantsResult>;
  /** Remove many jobs by _id or runSheetID. */
  removeManyJobs?: Maybe<RemoveManyJobsResult>;
  /** Remove many documents without returning them: Use Query.remove mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  removeManySimRequests?: Maybe<RemoveManySimRequestPayload>;
  /** Remove many documents without returning them: Use Query.remove mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  removeManySimResults?: Maybe<RemoveManySimResultPayload>;
  /** Remove many timesheet entries by _id */
  removeManyTimeSheetEntries?: Maybe<RemoveManyTimeSheetEntriesResult>;
  /** Remove many tyreSets by _id */
  removeManyTyreSets?: Maybe<RemoveManyTyreSetsResult>;
  /** Remove many tyres by _id */
  removeManyTyres?: Maybe<RemoveManyTyresResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeOneTimingWeatherServiceConfig?: Maybe<RemoveByIdOneTimingWeatherServiceConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePackage?: Maybe<RemoveByIdPackagePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePart?: Maybe<RemoveByIdPartPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePartInstance?: Maybe<RemoveByIdPartInstancePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePerson?: Maybe<RemoveByIdPersonPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePlotPageConfig?: Maybe<RemoveByIdPlotPageConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removePointsSystem?: Maybe<RemoveByIdPointsSystemPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeProject?: Maybe<RemoveByIdProjectPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeQualityCheck?: Maybe<RemoveByIdQualityCheckPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeQualityCheckAction?: Maybe<RemoveByIdQualityCheckActionPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeRaceSeries?: Maybe<RemoveByIdRaceSeriesPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeRadioMessage?: Maybe<RemoveByIdRadioMessagePayload>;
  /** Remove a note from a report page */
  removeReportNote?: Maybe<ReportNote>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeReportNotesTemplate?: Maybe<RemoveByIdReportNotesTemplatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeReportTemplate?: Maybe<RemoveByIdReportTemplatePayload>;
  /** Remove a planned run from an existing run plan. */
  removeRunFromRunPlan?: Maybe<RunPlan>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeRunPlan?: Maybe<RemoveByIdRunPlanPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeRunSheet?: Maybe<RemoveByIdRunSheetPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeRunSheetStyle?: Maybe<RemoveByIdRunSheetStylePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSeason?: Maybe<RemoveByIdSeasonPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSession?: Maybe<RemoveByIdSessionPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSessionDebriefTemplate?: Maybe<RemoveByIdTemplateSessionDebriefPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSetupOverviewConfig?: Maybe<RemoveByIdSetupOverviewConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSetupSheetStyle?: Maybe<RemoveByIdSetupSheetStylePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSimRequest?: Maybe<RemoveByIdSimRequestPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSimResult?: Maybe<RemoveByIdSimResultPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSimulationDriveFile?: Maybe<RemoveByIdSimulationDriveFilePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSkidPlate?: Maybe<RemoveByIdSkidPlatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSpecification?: Maybe<RemoveByIdSpecificationPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSpecificationGroup?: Maybe<RemoveByIdSpecificationGroupPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeSsoProvider?: Maybe<RemoveByIdSsoProviderPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTag?: Maybe<RemoveByIdTagPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTeam?: Maybe<RemoveByIdTeamPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTemplateJobList?: Maybe<RemoveByIdTemplateJobListPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTimeSheetEntry?: Maybe<RemoveByIdTimeSheetEntryPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTimingServiceConfig?: Maybe<RemoveByIdTimingServiceConfigPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrack?: Maybe<RemoveByIdTrackPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackLayout?: Maybe<RemoveByIdTrackLayoutPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackable?: Maybe<RemoveByIdTrackablePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingItem?: Maybe<RemoveByIdTrackingItemPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingMeasurement?: Maybe<RemoveByIdTrackingMeasurementPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingMeasurementRecord?: Maybe<RemoveByIdTrackingMeasurementRecordPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingRecord?: Maybe<RemoveByIdTrackingRecordPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingSource?: Maybe<RemoveByIdTrackingSourcePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTrackingSourceAlias?: Maybe<RemoveByIdTrackingSourceAliasPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTyre?: Maybe<RemoveByIdTyrePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTyreSet?: Maybe<RemoveByIdTyreSetPayload>;
  /** Remove assigned tyre set from contestant */
  removeTyreSetsFromContestant?: Maybe<RemoveTyreSetsFromContestantResult>;
  /** Remove assigned tyre set from event contestant */
  removeTyreSetsFromEventContestant?: Maybe<RemoveTyreSetsFromEventContestantResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeTyreWear?: Maybe<RemoveByIdTyreWearPayload>;
  /** Remove assigned tyres from contestant */
  removeTyresFromContestant?: Maybe<RemoveTyresFromContestantResult>;
  /** Remove assigned tyres from event contestant */
  removeTyresFromEventContestant?: Maybe<RemoveTyreFromEventContestantResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeUserEnum?: Maybe<RemoveByIdUserEnumPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeWeather?: Maybe<RemoveByIdWeatherPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeWeatherServiceConfig?: Maybe<RemoveByIdWeatherServiceConfigPayload>;
  renameSpecification?: Maybe<RenameSpecificationResult>;
  /** Reorder run plan runs */
  reorderRunPlanRuns?: Maybe<RunPlan>;
  resetPassword?: Maybe<ResetPasswordResult>;
  resetTyrePressureSheet?: Maybe<ResetTyrePressureSheetResult>;
  /** Restore a database backup by name. A backup will automatically be created before restoring. */
  restoreBackup?: Maybe<RestoreBackupResult>;
  sandbox?: Maybe<SandboxMutations>;
  /** Scrap many tyres by _id */
  scrapManyTyres?: Maybe<ScrapManyTyresResult>;
  /** Reset a password with a link obtained from using the "Forgot your password?" button. */
  selfResetPassword?: Maybe<SelfResetPasswordResult>;
  setAllTimingServiceConfigsInactive?: Maybe<SetAllTimingServiceConfigsInactive>;
  setPassword?: Maybe<SetPasswordResult>;
  /** Split a run sheet into two */
  splitRunSheet?: Maybe<RunSheet>;
  swapPartInstance?: Maybe<SwapPartInstanceResult>;
  unapproveTimeSheetEntries?: Maybe<Scalars['Boolean']['output']>;
  unapproveTimeSheetEntry?: Maybe<TimeSheetEntry>;
  /** Revoke team ownership for a car setup. */
  unclaimCarSetup?: Maybe<UnclaimCarSetupResult>;
  /** Revoke team ownership of a run sheet (and any connected run sheets). */
  unclaimRunSheet?: Maybe<UnclaimRunSheetResult>;
  unreleaseChassisSpec?: Maybe<ChassisSpec>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateAssembly?: Maybe<UpdateByIdAssemblyPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateAssemblyTemplate?: Maybe<UpdateByIdAssemblyTemplatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateBestValues?: Maybe<UpdateByIdBestValuesPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateBop?: Maybe<UpdateByIdBopPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateBuildSheetStyle?: Maybe<UpdateByIdBuildSheetStylePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateCalculation?: Maybe<UpdateByIdCalculationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateCarDataServiceConfig?: Maybe<UpdateByIdCarDataServiceConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateCarSetup?: Maybe<UpdateByIdCarSetupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateChassis?: Maybe<UpdateByIdChassisPayload>;
  /** Recalculate all tracking items for given chassis assembly. Update all parts within that assembly. */
  updateChassisAssemblyTracking?: Maybe<Scalars['JSON']['output']>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateChassisMeasurement?: Maybe<UpdateByIdChassisMeasurementPayload>;
  /** Update the chassisSpecVersion on all car setups that have a chassisAssemblyID set to their respective latest versions. */
  updateChassisSpecVersionOnCarSetups?: Maybe<UpdatedChassisSpecVersionOnCarSetups>;
  updateComment?: Maybe<UpdateCommentResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateContestant?: Maybe<UpdateByIdContestantPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateDepartment?: Maybe<UpdateByIdDepartmentPayload>;
  /** Update the drivers of a contestant in an event. */
  updateDriversInEventContestant?: Maybe<Event>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateDynoConfig?: Maybe<UpdateByIdDynoConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateEvent?: Maybe<UpdateByIdEventPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateFlexLayoutConfig?: Maybe<UpdateByIdFlexLayoutConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateIssue?: Maybe<UpdateByIdIssuePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateJob?: Maybe<UpdateByIdJobPayload>;
  updateLap?: Maybe<RunSheet>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLapByID?: Maybe<UpdateByIdLapPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLapByIDByService?: Maybe<UpdateByIdLapPayload>;
  updateLapDataByID?: Maybe<Lap>;
  updateLapInSession?: Maybe<Lap>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLapSequence?: Maybe<UpdateByIdLapSequencePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLapSequenceTemplate?: Maybe<UpdateByIdLapSequenceTemplatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLocation?: Maybe<UpdateByIdLocationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateLog?: Maybe<UpdateByIdLogPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  updateLogByID?: Maybe<RemoveByIdLogPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateManufacturer?: Maybe<UpdateByIdManufacturerPayload>;
  /** Update fields on the currently logged in user. */
  updateMe?: Maybe<UpdateByIdPersonPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateMigrations?: Maybe<UpdateMigrationsResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateOneTimingWeatherServiceConfig?: Maybe<UpdateByIdOneTimingWeatherServiceConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePackage?: Maybe<UpdateByIdPackagePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePart?: Maybe<UpdateByIdPartPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePartInstance?: Maybe<UpdateByIdPartInstancePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePerson?: Maybe<UpdateByIdPersonPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePlotPageConfig?: Maybe<UpdateByIdPlotPageConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePointsSystem?: Maybe<UpdateByIdPointsSystemPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateProject?: Maybe<UpdateByIdProjectPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateQualityCheck?: Maybe<UpdateByIdQualityCheckPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateQualityCheckAction?: Maybe<UpdateByIdQualityCheckActionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRaceSeries?: Maybe<UpdateByIdRaceSeriesPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRadioMessage?: Maybe<UpdateByIdRadioMessagePayload>;
  /** Update an existing note on a report */
  updateReportNote?: Maybe<ReportNote>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateReportTemplate?: Maybe<UpdateByIdReportTemplatePayload>;
  /** Update a planned run in an existing run plan. */
  updateRunInRunPlan?: Maybe<RunPlan>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRunPlan?: Maybe<UpdateByIdRunPlanPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRunSheet?: Maybe<UpdateByIdRunSheetPayload>;
  /** Updates the lap KPI of a given runsheet for all laps.Laps withing the run are matched by NLapRun.Example: laps: [{NLapRun: 1, lapKPI: [['one',{min: 1, max:2}],['ten',{min:11, max:12}]]}]  */
  updateRunSheetLapKPI?: Maybe<UpdateRunSheetLapKpiPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRunSheetStyle?: Maybe<UpdateByIdRunSheetStylePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSeason?: Maybe<UpdateByIdSeasonPayload>;
  updateServerSettings?: Maybe<UpdateServerSettingsResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSession?: Maybe<UpdateByIdSessionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSessionDebriefTemplate?: Maybe<UpdateByIdTemplateSessionDebriefPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSetupOverviewConfig?: Maybe<UpdateByIdSetupOverviewConfigPayload>;
  updateSetupSheetLayoutChassisSpec?: Maybe<UpdateSetupSheetLayoutChassisSpecResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSetupSheetStyle?: Maybe<UpdateByIdSetupSheetStylePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSimRequest?: Maybe<UpdateByIdSimRequestPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSimResult?: Maybe<UpdateByIdSimResultPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSimulationDriveFile?: Maybe<UpdateByIdSimulationDriveFilePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSkidPlate?: Maybe<UpdateByIdSkidPlatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSpecification?: Maybe<UpdateByIdSpecificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSpecificationAdmin?: Maybe<UpdateByIdSpecificationAdminPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateSpecificationGroup?: Maybe<UpdateByIdSpecificationGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTag?: Maybe<UpdateByIdTagPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTeam?: Maybe<UpdateByIdTeamPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTemplateJobList?: Maybe<UpdateByIdTemplateJobListPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTimeSheetEntry?: Maybe<UpdateByIdTimeSheetEntryPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTimingServiceConfig?: Maybe<UpdateByIdTimingServiceConfigPayload>;
  updateTimingServiceStatus?: Maybe<UpdateTimingStatusResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrack?: Maybe<UpdateByIdTrackPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackLayout?: Maybe<UpdateByIdTrackLayoutPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackable?: Maybe<UpdateByIdTrackablePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingItem?: Maybe<UpdateByIdTrackingItemPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingMeasurement?: Maybe<UpdateByIdTrackingMeasurementPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingMeasurementRecord?: Maybe<UpdateByIdTrackingMeasurementRecordPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingRecord?: Maybe<UpdateByIdTrackingRecordPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingSource?: Maybe<UpdateByIdTrackingSourcePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTrackingSourceAlias?: Maybe<UpdateByIdTrackingSourceAliasPayload>;
  /** Updates the value for a given tracking source source inside a chassis assembly. (e.g. manual mileage entry) */
  updateTrackingSourceSourceValueInAssembly?: Maybe<UpdateTrackingSourceSourceValueInAssemblyResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTyre?: Maybe<UpdateByIdTyrePayload>;
  updateTyrePressureSheet: TyrePressureSheet;
  updateTyrePressureSheetData: TyrePressureSheet;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTyreSet?: Maybe<UpdateByIdTyreSetPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateTyreWear?: Maybe<UpdateByIdTyreWearPayload>;
  /** Update all tyres within a set */
  updateTyresInSet?: Maybe<UpdateTyresInSetResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateUserEnum?: Maybe<UpdateByIdUserEnumPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateWeather?: Maybe<UpdateByIdWeatherPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateWeatherServiceConfig?: Maybe<UpdateByIdWeatherServiceConfigPayload>;
  /** Deletes an existing BOP with a new BOP, useful to update/create bop and not have to deal with the existing BOP */
  upsertBop?: Maybe<Bop>;
  /** Add set of partIDs and locations to 'assemble' a full car */
  upsertCarBuild?: Maybe<UpsertCarBuildResult>;
  upsertPartInstance?: Maybe<PartInstanceUpdateResult>;
};


export type MutationActivateCarDataServiceConfigArgs = {
  carDataServiceConfigID: Scalars['MongoID']['input'];
};


export type MutationAddAssemblyArgs = {
  record: CreateOneAssemblyInput;
};


export type MutationAddAssemblyTemplateArgs = {
  record: CreateOneAssemblyTemplateInput;
};


export type MutationAddBestValuesArgs = {
  record: CreateOneBestValuesInput;
};


export type MutationAddBopArgs = {
  record: CreateOneBopInput;
};


export type MutationAddBuildSheetStyleArgs = {
  record: CreateOneBuildSheetStyleInput;
};


export type MutationAddCalculationArgs = {
  record: CreateOneCalculationInput;
};


export type MutationAddCarDataServiceConfigArgs = {
  record: CreateOneCarDataServiceConfigInput;
};


export type MutationAddCarSetupArgs = {
  record: CreateOneCarSetupInput;
};


export type MutationAddChassisArgs = {
  record: CreateOneChassisInput;
};


export type MutationAddChassisMeasurementArgs = {
  record: CreateOneChassisMeasurementInput;
};


export type MutationAddCommentArgs = {
  subjectID: Scalars['MongoID']['input'];
  target?: InputMaybe<EnumJobTarget>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddContestantArgs = {
  record: CreateOneContestantInput;
};


export type MutationAddControlTelemetryEndOfLapArgs = {
  NLap: Scalars['Float']['input'];
  NRun: Scalars['Float']['input'];
  contestantID: Scalars['MongoID']['input'];
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  tLapMax: Scalars['Float']['input'];
  timestamp: Scalars['Date']['input'];
};


export type MutationAddControlTelemetryEndOfRunArgs = {
  NLap: Scalars['Float']['input'];
  NRun: Scalars['Float']['input'];
  contestantID: Scalars['MongoID']['input'];
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  tLapMax: Scalars['Float']['input'];
  timestamp: Scalars['Date']['input'];
};


export type MutationAddControlTelemetryStartOfDataArgs = {
  NLap: Scalars['Float']['input'];
  NRun: Scalars['Float']['input'];
  contestantID: Scalars['MongoID']['input'];
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  tLapMax: Scalars['Float']['input'];
  timestamp: Scalars['Date']['input'];
};


export type MutationAddDepartmentArgs = {
  record: CreateOneDepartmentInput;
};


export type MutationAddDynoConfigArgs = {
  record: CreateOneDynoConfigInput;
};


export type MutationAddEventArgs = {
  record: CreateOneEventInput;
};


export type MutationAddEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
};


export type MutationAddFlattenedSimulationPayloadArgs = {
  carSetupID: Scalars['MongoID']['input'];
  record?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationAddFlexLayoutConfigArgs = {
  record: CreateOneFlexLayoutConfigInput;
};


export type MutationAddFullEventArgs = {
  eventRecord: CreateOneEventInput;
  sessions?: InputMaybe<Array<CreateSessionForFullEventInput>>;
};


export type MutationAddGreeboLogArgs = {
  record: CreateOneGreeboLogInput;
};


export type MutationAddHistoricalWeatherArgs = {
  weatherServiceConfigID: Scalars['MongoID']['input'];
};


export type MutationAddIssueArgs = {
  record: CreateOneIssueInput;
};


export type MutationAddJobArgs = {
  record: CreateOneJobInput;
  target?: InputMaybe<EnumJobTarget>;
};


export type MutationAddJobsManyArgs = {
  records: Array<CreateManyJobInput>;
};


export type MutationAddLapArgs = {
  lap: LapInput;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationAddLapByServiceArgs = {
  newLapData: LapDataInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  previousLapID?: InputMaybe<Scalars['MongoID']['input']>;
  referenceLapID?: InputMaybe<Scalars['MongoID']['input']>;
  runNo?: InputMaybe<Scalars['Int']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  sourceType: EnumLapDataSourceType;
};


export type MutationAddLapSequenceArgs = {
  record: CreateOneLapSequenceInput;
};


export type MutationAddLapSequenceTemplateArgs = {
  record: CreateOneLapSequenceTemplateInput;
};


export type MutationAddLocationArgs = {
  record: CreateOneLocationInput;
};


export type MutationAddLogArgs = {
  record: CreateOneLogInput;
};


export type MutationAddManufacturerArgs = {
  record: CreateOneManufacturerInput;
};


export type MutationAddManyEventContestantsArgs = {
  contestantIDs: Array<Scalars['MongoID']['input']>;
  eventID: Scalars['MongoID']['input'];
};


export type MutationAddManyTimeSheetEntriesArgs = {
  records: Array<CreateManyTimeSheetEntryInput>;
};


export type MutationAddOneTimingWeatherServiceConfigArgs = {
  record: CreateOneOneTimingWeatherServiceConfigInput;
};


export type MutationAddPackageArgs = {
  record: CreateOnePackageInput;
};


export type MutationAddPartArgs = {
  record: CreateOnePartInput;
};


export type MutationAddPartInstanceArgs = {
  record: CreateOnePartInstanceInput;
};


export type MutationAddPartInstanceForCopyAssemblyArgs = {
  record: CreateOnePartInstanceInput;
};


export type MutationAddPersonArgs = {
  record: CreateOnePersonInput;
};


export type MutationAddPlotPageConfigArgs = {
  record: CreateOnePlotPageConfigInput;
};


export type MutationAddPointsSystemArgs = {
  record: CreateOnePointsSystemInput;
};


export type MutationAddProjectArgs = {
  record: CreateOneProjectInput;
};


export type MutationAddQualityCheckArgs = {
  record: CreateOneQualityCheckInput;
};


export type MutationAddQualityCheckActionArgs = {
  record: CreateOneQualityCheckActionInput;
};


export type MutationAddRaceSeriesArgs = {
  record: CreateOneRaceSeriesInput;
};


export type MutationAddRadioMessageArgs = {
  record: CreateOneRadioMessageInput;
};


export type MutationAddReportNoteArgs = {
  eventID: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  page: EnumReportPage;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddReportNotesTemplateArgs = {
  record: CreateOneReportNotesTemplateInput;
};


export type MutationAddReportTemplateArgs = {
  record: CreateOneReportTemplateInput;
};


export type MutationAddRunPlanArgs = {
  record: CreateOneRunPlanInput;
};


export type MutationAddRunSheetArgs = {
  record: CreateOneRunSheetInput;
};


export type MutationAddRunSheetStyleArgs = {
  record: CreateOneRunSheetStyleInput;
};


export type MutationAddRunToRunPlanArgs = {
  runPlanID: Scalars['MongoID']['input'];
  runs: Array<InputMaybe<RunPlanRunInput>>;
};


export type MutationAddSeasonArgs = {
  record: CreateOneSeasonInput;
};


export type MutationAddSectorArgs = {
  NLapRun: Scalars['Int']['input'];
  runSheetID: Scalars['MongoID']['input'];
  sectorTime?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationAddSessionArgs = {
  record: CreateOneSessionInput;
};


export type MutationAddSessionDebriefTemplateArgs = {
  record: CreateOneTemplateSessionDebriefInput;
};


export type MutationAddSetupOverviewConfigArgs = {
  record: CreateOneSetupOverviewConfigInput;
};


export type MutationAddSetupSheetStyleArgs = {
  record: CreateOneSetupSheetStyleInput;
};


export type MutationAddSimRequestArgs = {
  record: CreateOneSimRequestInput;
};


export type MutationAddSimResultArgs = {
  record: CreateOneSimResultInput;
};


export type MutationAddSimulationDriveFileArgs = {
  record: CreateOneSimulationDriveFileInput;
};


export type MutationAddSkidPlateArgs = {
  record: CreateOneSkidPlateInput;
};


export type MutationAddSpecificationArgs = {
  record: CreateOneSpecificationInput;
};


export type MutationAddSpecificationGroupArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
  record: CreateOneSpecificationGroupInput;
};


export type MutationAddSsoProviderArgs = {
  record: CreateOneSsoProviderInput;
};


export type MutationAddTagArgs = {
  record: CreateOneTagInput;
};


export type MutationAddTeamArgs = {
  record: CreateOneTeamInput;
};


export type MutationAddTemplateJobListArgs = {
  record: CreateOneTemplateJobListInput;
};


export type MutationAddTestUserArgs = {
  record: CreateOnePersonInput;
};


export type MutationAddTimeSheetEntryArgs = {
  record: CreateOneTimeSheetEntryInput;
};


export type MutationAddTimingServiceConfigArgs = {
  record: CreateOneTimingServiceConfigInput;
};


export type MutationAddToContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  target: ContestantField;
  toAdd: Scalars['MongoID']['input'];
};


export type MutationAddToEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  target: EventContestantField;
  toAdd: Scalars['MongoID']['input'];
};


export type MutationAddToSessionContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
  target: SessionContestantField;
  toAdd: Scalars['MongoID']['input'];
};


export type MutationAddTrackArgs = {
  record: CreateOneTrackInput;
};


export type MutationAddTrackLayoutArgs = {
  record: CreateOneTrackLayoutInput;
};


export type MutationAddTrackStateArgs = {
  NLapRun: Scalars['Int']['input'];
  runSheetID: Scalars['MongoID']['input'];
  trackState?: InputMaybe<TrackStateInput>;
};


export type MutationAddTrackableArgs = {
  record: CreateOneTrackableInput;
};


export type MutationAddTrackingItemArgs = {
  record: CreateOneTrackingItemInput;
};


export type MutationAddTrackingMeasurementArgs = {
  record: CreateOneTrackingMeasurementInput;
};


export type MutationAddTrackingMeasurementRecordArgs = {
  record: CreateOneTrackingMeasurementRecordInput;
};


export type MutationAddTrackingRecordArgs = {
  record: CreateOneTrackingRecordInput;
};


export type MutationAddTrackingRecordGeneralArgs = {
  record: CreateOneTrackingRecordGeneralInput;
};


export type MutationAddTrackingRecordOverrideArgs = {
  record: CreateOneTrackingRecordOverrideInput;
};


export type MutationAddTrackingRecordValueArgs = {
  record: CreateOneTrackingRecordValueInput;
};


export type MutationAddTrackingSourceArgs = {
  record: CreateOneTrackingSourceInput;
};


export type MutationAddTrackingSourceAliasArgs = {
  record: CreateOneTrackingSourceAliasInput;
};


export type MutationAddTyreArgs = {
  record: CreateOneTyreInput;
};


export type MutationAddTyreSetArgs = {
  record: CreateOneTyreSetInput;
};


export type MutationAddTyreSetsToContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationAddTyreSetsToEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationAddTyreWearArgs = {
  record: CreateOneTyreWearInput;
};


export type MutationAddTyresToContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationAddTyresToEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationAddUserEnumArgs = {
  record: CreateOneUserEnumInput;
};


export type MutationAddWeatherArgs = {
  record: CreateOneWeatherInput;
};


export type MutationAddWeatherFromSourceArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  source: EnumWeatherSources;
  type?: InputMaybe<EnumWeatherType>;
  weatherID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationAddWeatherServiceConfigArgs = {
  record: CreateOneWeatherServiceConfigInput;
};


export type MutationAddvCarSectorArgs = {
  NLapRun: Scalars['Int']['input'];
  runSheetID: Scalars['MongoID']['input'];
  vCar?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationAppendWeatherArgs = {
  data: WeatherDataInput;
  weatherID: Scalars['MongoID']['input'];
};


export type MutationApplyLapSequenceArgs = {
  lapCount?: InputMaybe<Scalars['Int']['input']>;
  lapSequenceID?: InputMaybe<Scalars['MongoID']['input']>;
  lapTime?: InputMaybe<Scalars['Float']['input']>;
  lapType?: InputMaybe<EnumLapType>;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationApplyMigrationArgs = {
  migration: EnumMigration;
};


export type MutationApplyPackageArgs = {
  carSetupIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  packageID: Scalars['MongoID']['input'];
};


export type MutationApplyPackageItemsArgs = {
  carSetupIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  packageItems?: InputMaybe<Array<InputMaybe<UpdateByIdPackageItemsInput>>>;
};


export type MutationApproveTimeSheetEntriesArgs = {
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  tStartAfter: Scalars['Date']['input'];
  tStartBefore: Scalars['Date']['input'];
};


export type MutationApproveTimeSheetEntryArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationAssignTeamArgs = {
  objectID: Scalars['MongoID']['input'];
  teamID: Scalars['MongoID']['input'];
  type: AssignableToTeam;
};


export type MutationCalculateMileagesByRunSheetIDsArgs = {
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  runSheetIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationCalculateRunEnergyArgs = {
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationClaimCarSetupArgs = {
  carSetupID: Scalars['MongoID']['input'];
};


export type MutationClaimRunSheetArgs = {
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationClonePackageArgs = {
  name: Scalars['String']['input'];
  packageID: Scalars['MongoID']['input'];
};


export type MutationCloneRunPlanArgs = {
  contestantID: Scalars['MongoID']['input'];
  runPlanID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
};


export type MutationCopyAssemblyArgs = {
  assemblyToCopyID: Scalars['MongoID']['input'];
  dummyPart?: InputMaybe<Scalars['Boolean']['input']>;
  newRootAssemblyName?: InputMaybe<Scalars['String']['input']>;
  newRootReference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCopyCarSetupArgs = {
  newAuthorID?: InputMaybe<Scalars['MongoID']['input']>;
  newTitle?: InputMaybe<Scalars['String']['input']>;
  sourceSetupID: Scalars['MongoID']['input'];
  targetRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationCopyChassisAssemblyArgs = {
  chassisAssemblyID: Scalars['MongoID']['input'];
  newCarSetupID: Scalars['MongoID']['input'];
};


export type MutationCopyEventArgs = {
  calculateSessionTimes?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  overrides?: InputMaybe<CopyEventOverridesInput>;
  sourceEventID: Scalars['MongoID']['input'];
  tEventStart: Scalars['Date']['input'];
  targetSeasonID: Scalars['MongoID']['input'];
};


export type MutationCreateBackupArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  omitMetadata?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateGoLookAtAssemblyRecordArgs = {
  chassisAssemblyID: Scalars['MongoID']['input'];
};


export type MutationCreatePackageArgs = {
  baselineSetupID: Scalars['MongoID']['input'];
  candidateSetupID: Scalars['MongoID']['input'];
  copyReferencePackageID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  method?: InputMaybe<EnumPackageMethod>;
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  useAsCopyReference?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateTyresForContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  sets?: InputMaybe<Array<CreateTyreSetRecordInput>>;
  tyres?: InputMaybe<Array<CreateTyreRecordInput>>;
};


export type MutationDataCheckArgs = {
  actions?: InputMaybe<Array<InputMaybe<EnumDataCheck>>>;
  writeData: Scalars['Boolean']['input'];
};


export type MutationDraftNotesFromTemplateArgs = {
  eventID: Scalars['String']['input'];
  notesTemplateId: Scalars['MongoID']['input'];
  pages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDraftRunSheetsArgs = {
  runPlanID: Scalars['MongoID']['input'];
  runSheetIDS?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationFixAssemblyTrackingArgs = {
  chassisAssemblyIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationFixPartInstanceArraysArgs = {
  assemblyID: Scalars['MongoID']['input'];
};


export type MutationFixPartInstancesResolverArgs = {
  partIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationFixPartTrackingHistoryArgs = {
  partID: Scalars['MongoID']['input'];
};


export type MutationFixTrackingForAssemblyPartsArgs = {
  chassisAssemblyID: Scalars['MongoID']['input'];
};


export type MutationForceAddLapArgs = {
  lap: LapInput;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationForgotPasswordArgs = {
  clientRoot?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};


export type MutationForwardAddPartInstanceArgs = {
  chassisAssemblyID: Scalars['MongoID']['input'];
  partID: Scalars['MongoID']['input'];
  readingLocation?: InputMaybe<EnumReadingLocation>;
  sessionID: Scalars['MongoID']['input'];
};


export type MutationForwardUpdateCarSetupArgs = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  carSetupID: Scalars['MongoID']['input'];
  field: Scalars['String']['input'];
  stringValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationForwardUpsertPartInstanceArgs = {
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  measurementIndex?: InputMaybe<Scalars['Int']['input']>;
  measurements?: InputMaybe<PartInstanceMeasurementInput>;
  newPartID?: InputMaybe<Scalars['MongoID']['input']>;
  readingLocation: EnumReadingLocation;
  specificationID: Scalars['MongoID']['input'];
  trackingItemReferenceDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationGreeboLogPushGpsDataArgs = {
  data: Array<CarGpsDataPointInput>;
  eventID?: InputMaybe<Scalars['String']['input']>;
  sessionID?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGreeboLogPushRawLinesArgs = {
  eventID?: InputMaybe<Scalars['String']['input']>;
  lines: Array<Scalars['String']['input']>;
  sessionID?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGreeboLogUpdateCarPositionsArgs = {
  carPositions: Array<CarTrackPositionInput>;
  eventID?: InputMaybe<Scalars['String']['input']>;
  sessionID?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIncrementRunSheetArgs = {
  prevRunSheetID: Scalars['MongoID']['input'];
  record?: InputMaybe<UpdateByIdRunSheetInput>;
};


export type MutationIncrementSetupSheetArgs = {
  destRunSheetID: Scalars['MongoID']['input'];
  sourceRunSheetID: Scalars['MongoID']['input'];
};


export type MutationIncrementSpecificationArgs = {
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID: Scalars['MongoID']['input'];
};


export type MutationInsertLapArgs = {
  lapToInsertBeforeID: Scalars['MongoID']['input'];
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationInsertRunArgs = {
  copyCarSetup?: InputMaybe<Scalars['Boolean']['input']>;
  insertAfterRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  insertBeforeRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  sourceRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  sourceSetupID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationInsertRunInRunPlanArgs = {
  NRun: Scalars['Int']['input'];
  run: RunPlanRunInput;
  runPlanID: Scalars['MongoID']['input'];
};


export type MutationInsertRunIntoSessionArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
  sourceRunSheetID: Scalars['MongoID']['input'];
};


export type MutationLiveStandingsStartArgs = {
  configID: Scalars['MongoID']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationManageIssueArgs = {
  action: IssueAction;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedBy?: InputMaybe<Scalars['MongoID']['input']>;
  issueID: Scalars['MongoID']['input'];
};


export type MutationManageJobArgs = {
  action: JobAction;
  jobID: Scalars['MongoID']['input'];
  target?: InputMaybe<EnumJobTarget>;
};


export type MutationOneTimingWeatherServiceConfigureArgs = {
  config: OneTimingWeatherServiceConfigInput;
};


export type MutationOneTimingWeatherServiceStartArgs = {
  configID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationRecalculatePartMileageByIdResolverArgs = {
  partID: Scalars['MongoID']['input'];
};


export type MutationRegeneratePartTrackingHistoryArgs = {
  partIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationReleaseChassisSpecArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveAssemblyArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveAssemblyTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveBestValuesArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveBopArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveBuildSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveCalculationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveCarDataServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveCarSetupArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveChassisArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveChassisMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveCommentArgs = {
  commentID: Scalars['MongoID']['input'];
  subjectID: Scalars['MongoID']['input'];
  target?: InputMaybe<EnumJobTarget>;
};


export type MutationRemoveContestantArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveDepartmentArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveDynoConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveEventArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
};


export type MutationRemoveFlexLayoutConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveFromContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  target: ContestantField;
  toRemove: Scalars['MongoID']['input'];
};


export type MutationRemoveFromEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  target: EventContestantField;
  toRemove: Scalars['MongoID']['input'];
};


export type MutationRemoveFromSessionContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionID: Scalars['MongoID']['input'];
  target: SessionContestantField;
  toRemove: Scalars['MongoID']['input'];
};


export type MutationRemoveIssueArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveJobArgs = {
  _id: Scalars['MongoID']['input'];
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  target?: InputMaybe<EnumJobTarget>;
};


export type MutationRemoveLapArgs = {
  NLapRun: Scalars['Int']['input'];
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationRemoveLapByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveLapByIdByServiceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveLapSequenceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveLapSequenceTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveLocationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveManufacturerArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveManyEventContestantsArgs = {
  contestantIDs: Array<Scalars['MongoID']['input']>;
  eventID: Scalars['MongoID']['input'];
};


export type MutationRemoveManyJobsArgs = {
  jobIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationRemoveManySimRequestsArgs = {
  filter: FilterRemoveManySimRequestInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveManySimResultsArgs = {
  filter: FilterRemoveManySimResultInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveManyTimeSheetEntriesArgs = {
  timeSheetEntryIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationRemoveManyTyreSetsArgs = {
  tyreSetIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationRemoveManyTyresArgs = {
  tyreIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationRemoveOneTimingWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePackageArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePartArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePartInstanceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePersonArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePlotPageConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemovePointsSystemArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveProjectArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveQualityCheckArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveQualityCheckActionArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveRaceSeriesArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveRadioMessageArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveReportNoteArgs = {
  eventID: Scalars['String']['input'];
  noteID: Scalars['String']['input'];
  page: EnumReportPage;
};


export type MutationRemoveReportNotesTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveReportTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveRunFromRunPlanArgs = {
  NRun: Scalars['Int']['input'];
  runPlanID: Scalars['MongoID']['input'];
};


export type MutationRemoveRunPlanArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveRunSheetArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveRunSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSeasonArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSessionArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSessionDebriefTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSetupOverviewConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSetupSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSimRequestArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSimResultArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSimulationDriveFileArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSkidPlateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSpecificationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSpecificationGroupArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveSsoProviderArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTagArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTeamArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTemplateJobListArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTimeSheetEntryArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTimingServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackLayoutArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackableArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingItemArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingMeasurementRecordArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingRecordArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingSourceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTrackingSourceAliasArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTyreArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTyreSetArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTyreSetsFromContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationRemoveTyreSetsFromEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreSetIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationRemoveTyreWearArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveTyresFromContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationRemoveTyresFromEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  tyreIDs: Array<Scalars['MongoID']['input']>;
};


export type MutationRemoveUserEnumArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveWeatherArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRemoveWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRenameSpecificationArgs = {
  name: Scalars['String']['input'];
  specificationID: Scalars['MongoID']['input'];
};


export type MutationReorderRunPlanRunsArgs = {
  newNRunOrder?: InputMaybe<Array<Scalars['Int']['input']>>;
  runPlanID: Scalars['MongoID']['input'];
};


export type MutationResetPasswordArgs = {
  username: Scalars['String']['input'];
};


export type MutationResetTyrePressureSheetArgs = {
  tyrePressureSheetID: Scalars['MongoID']['input'];
};


export type MutationRestoreBackupArgs = {
  name: Scalars['String']['input'];
  skipSafetyBackup?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationScrapManyTyresArgs = {
  tyreIDs?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationSelfResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationSplitRunSheetArgs = {
  lapID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationSwapPartInstanceArgs = {
  parentID: Scalars['MongoID']['input'];
  partID: Scalars['MongoID']['input'];
  readingLocation?: InputMaybe<EnumReadingLocation>;
  specificationID: Scalars['MongoID']['input'];
};


export type MutationUnapproveTimeSheetEntriesArgs = {
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  tStartAfter: Scalars['Date']['input'];
  tStartBefore: Scalars['Date']['input'];
};


export type MutationUnapproveTimeSheetEntryArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationUnclaimCarSetupArgs = {
  carSetupID: Scalars['MongoID']['input'];
};


export type MutationUnclaimRunSheetArgs = {
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationUnreleaseChassisSpecArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
};


export type MutationUpdateAssemblyArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdAssemblyInput;
};


export type MutationUpdateAssemblyTemplateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdAssemblyTemplateInput;
};


export type MutationUpdateBestValuesArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdBestValuesInput;
};


export type MutationUpdateBopArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdBopInput;
};


export type MutationUpdateBuildSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdBuildSheetStyleInput;
};


export type MutationUpdateCalculationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCalculationInput;
};


export type MutationUpdateCarDataServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCarDataServiceConfigInput;
};


export type MutationUpdateCarSetupArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCarSetupInput;
};


export type MutationUpdateChassisArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdChassisInput;
};


export type MutationUpdateChassisAssemblyTrackingArgs = {
  chassisAssemblyID: Scalars['MongoID']['input'];
};


export type MutationUpdateChassisMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdChassisMeasurementInput;
};


export type MutationUpdateChassisSpecVersionOnCarSetupsArgs = {
  rootSpecificationID: Scalars['MongoID']['input'];
  timeRangeEnd?: InputMaybe<Scalars['Date']['input']>;
  timeRangeStart?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationUpdateCommentArgs = {
  commentID: Scalars['MongoID']['input'];
  subjectID: Scalars['MongoID']['input'];
  target?: InputMaybe<EnumJobTarget>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateContestantArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdContestantInput;
};


export type MutationUpdateDepartmentArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdDepartmentInput;
};


export type MutationUpdateDriversInEventContestantArgs = {
  contestantID: Scalars['MongoID']['input'];
  driverIDs: Array<Scalars['MongoID']['input']>;
  eventID: Scalars['MongoID']['input'];
};


export type MutationUpdateDynoConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdDynoConfigInput;
};


export type MutationUpdateEventArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdEventInput;
};


export type MutationUpdateFlexLayoutConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdFlexLayoutConfigInput;
};


export type MutationUpdateIssueArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdIssueInput;
};


export type MutationUpdateJobArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdJobInput;
  target?: InputMaybe<EnumJobTarget>;
};


export type MutationUpdateLapArgs = {
  NLapRun: Scalars['Int']['input'];
  lap: UpdateByIdLapInput;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationUpdateLapByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLapInput;
};


export type MutationUpdateLapByIdByServiceArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLapInput;
};


export type MutationUpdateLapDataByIdArgs = {
  _id: Scalars['MongoID']['input'];
  data?: InputMaybe<UpdateByIdLapDataInput>;
  source: EnumLapDataSource;
};


export type MutationUpdateLapInSessionArgs = {
  NLapSession: Scalars['Int']['input'];
  contestantID: Scalars['MongoID']['input'];
  lap: UpdateByIdLapInput;
  sessionID: Scalars['MongoID']['input'];
};


export type MutationUpdateLapSequenceArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLapSequenceInput;
};


export type MutationUpdateLapSequenceTemplateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLapSequenceTemplateInput;
};


export type MutationUpdateLocationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLocationInput;
};


export type MutationUpdateLogArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLogInput;
};


export type MutationUpdateLogByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationUpdateManufacturerArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdManufacturerInput;
};


export type MutationUpdateMeArgs = {
  record: UpdateMeInput;
};


export type MutationUpdateMigrationsArgs = {
  record: MigrationsInput;
};


export type MutationUpdateOneTimingWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdOneTimingWeatherServiceConfigInput;
};


export type MutationUpdatePackageArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPackageInput;
};


export type MutationUpdatePartArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPartInput;
};


export type MutationUpdatePartInstanceArgs = {
  _id: Scalars['MongoID']['input'];
  doNotTriggerCarSetupUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  record: UpdateByIdPartInstanceInput;
};


export type MutationUpdatePersonArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPersonInput;
};


export type MutationUpdatePlotPageConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPlotPageConfigInput;
};


export type MutationUpdatePointsSystemArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPointsSystemInput;
};


export type MutationUpdateProjectArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProjectInput;
};


export type MutationUpdateQualityCheckArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdQualityCheckInput;
};


export type MutationUpdateQualityCheckActionArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdQualityCheckActionInput;
};


export type MutationUpdateRaceSeriesArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRaceSeriesInput;
};


export type MutationUpdateRadioMessageArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRadioMessageInput;
};


export type MutationUpdateReportNoteArgs = {
  eventID: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  noteID: Scalars['String']['input'];
  page: EnumReportPage;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateReportTemplateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdReportTemplateInput;
};


export type MutationUpdateRunInRunPlanArgs = {
  NRun: Scalars['Int']['input'];
  runPlanID: Scalars['MongoID']['input'];
  updatedFields: UpdateByIdRunPlanRunInput;
};


export type MutationUpdateRunPlanArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRunPlanInput;
};


export type MutationUpdateRunSheetArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRunSheetInput;
};


export type MutationUpdateRunSheetLapKpiArgs = {
  laps?: InputMaybe<Array<UpdateByIdLapInput>>;
  runSheetID: Scalars['MongoID']['input'];
};


export type MutationUpdateRunSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRunSheetStyleInput;
};


export type MutationUpdateSeasonArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSeasonInput;
};


export type MutationUpdateServerSettingsArgs = {
  serverSettings: ServerSettingsInput;
};


export type MutationUpdateSessionArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSessionInput;
};


export type MutationUpdateSessionDebriefTemplateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTemplateSessionDebriefInput;
};


export type MutationUpdateSetupOverviewConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSetupOverviewConfigInput;
};


export type MutationUpdateSetupSheetLayoutChassisSpecArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
  setupSheetLayoutID: Scalars['MongoID']['input'];
};


export type MutationUpdateSetupSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSetupSheetStyleInput;
};


export type MutationUpdateSimRequestArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSimRequestInput;
};


export type MutationUpdateSimResultArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSimResultInput;
};


export type MutationUpdateSimulationDriveFileArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSimulationDriveFileInput;
};


export type MutationUpdateSkidPlateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSkidPlateInput;
};


export type MutationUpdateSpecificationArgs = {
  _id: Scalars['MongoID']['input'];
  confirmUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  currentChassisSpecID: Scalars['MongoID']['input'];
  record: UpdateByIdSpecificationInput;
};


export type MutationUpdateSpecificationAdminArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSpecificationAdminInput;
};


export type MutationUpdateSpecificationGroupArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSpecificationGroupInput;
};


export type MutationUpdateTagArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTagInput;
};


export type MutationUpdateTeamArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTeamInput;
};


export type MutationUpdateTemplateJobListArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTemplateJobListInput;
};


export type MutationUpdateTimeSheetEntryArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTimeSheetEntryInput;
};


export type MutationUpdateTimingServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTimingServiceConfigInput;
};


export type MutationUpdateTimingServiceStatusArgs = {
  timingServiceStatus: TimingServiceStatusInput;
};


export type MutationUpdateTrackArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackInput;
};


export type MutationUpdateTrackLayoutArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackLayoutInput;
};


export type MutationUpdateTrackableArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackableInput;
};


export type MutationUpdateTrackingItemArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingItemInput;
};


export type MutationUpdateTrackingMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingMeasurementInput;
};


export type MutationUpdateTrackingMeasurementRecordArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingMeasurementRecordInput;
};


export type MutationUpdateTrackingRecordArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingRecordInput;
};


export type MutationUpdateTrackingSourceArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingSourceInput;
};


export type MutationUpdateTrackingSourceAliasArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTrackingSourceAliasInput;
};


export type MutationUpdateTrackingSourceSourceValueInAssemblyArgs = {
  assemblyID: Scalars['MongoID']['input'];
  trackingSourceAliasID: Scalars['MongoID']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateTyreArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTyreInput;
};


export type MutationUpdateTyrePressureSheetArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  record: TyrePressureSheetInput;
};


export type MutationUpdateTyrePressureSheetDataArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
  record: TyreSetupDataInput;
  sessionID: Scalars['MongoID']['input'];
  tyreSetID: Scalars['MongoID']['input'];
};


export type MutationUpdateTyreSetArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTyreSetInput;
};


export type MutationUpdateTyreWearArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTyreWearInput;
};


export type MutationUpdateTyresInSetArgs = {
  record: UpdateByIdTyreInput;
  tyreSetID: Scalars['MongoID']['input'];
};


export type MutationUpdateUserEnumArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdUserEnumInput;
};


export type MutationUpdateWeatherArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdWeatherInput;
};


export type MutationUpdateWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdWeatherServiceConfigInput;
};


export type MutationUpsertBopArgs = {
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  record: CreateOneBopInput;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationUpsertCarBuildArgs = {
  NRun: Scalars['Float']['input'];
  contestantID: Scalars['MongoID']['input'];
  parts?: InputMaybe<Scalars['JSON']['input']>;
  timestamp: Scalars['Date']['input'];
};


export type MutationUpsertPartInstanceArgs = {
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  measurementIndex: Scalars['Int']['input'];
  measurements?: InputMaybe<PartInstanceMeasurementInput>;
  parentID: Scalars['MongoID']['input'];
  readingLocation: EnumReadingLocation;
  specificationID: Scalars['MongoID']['input'];
};

export type NonChassisSpec = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
};

export type NonChassisSpecificationUnion = AeroElementSpec | AeroPackageSpec | AntiRollBarSpec | CustomSpec | DamperSpec | DifferentialSpec | ElasticSpec | GearBoxSpec | GearSpec | KinematicsExternalSpec | KinematicsInternalSpec;

export type NotificationConfig = {
  faultAssigned?: Maybe<Scalars['Boolean']['output']>;
  faultCommentedOn?: Maybe<Scalars['Boolean']['output']>;
  faultStatusChanged?: Maybe<Scalars['Boolean']['output']>;
  jobAssigned?: Maybe<Scalars['Boolean']['output']>;
  jobCommentedOn?: Maybe<Scalars['Boolean']['output']>;
  jobStatusChanged?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationConfigInput = {
  faultAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  faultCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  faultStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
  jobAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  jobCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  jobStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberUnitField = {
  unit: EnumUntypedUnit;
};

export type OneTimingWeatherServiceConfig = {
  _id: Scalars['MongoID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** API event IDs to which the weather data should be published. */
  eventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Weather station's latitude from geolocation */
  latitude?: Maybe<Scalars['Float']['output']>;
  logLevel?: Maybe<EnumOneTimingWeatherServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: Maybe<Scalars['Boolean']['output']>;
  /** Weather station's longitude from geolocation */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Name for this set of configuration settings. */
  name: Scalars['String']['output'];
  /** One Timing server port. */
  timingPort: Scalars['Int']['output'];
  /** One Timing server address. */
  timingURL: Scalars['String']['output'];
  /** Time interval in seconds between two API data updates. */
  updateInterval?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: Maybe<Scalars['Boolean']['output']>;
};

export type OneTimingWeatherServiceConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event IDs to which the weather data should be published. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Weather station's latitude from geolocation */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logLevel?: InputMaybe<EnumOneTimingWeatherServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weather station's longitude from geolocation */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Name for this set of configuration settings. */
  name: Scalars['String']['input'];
  /** One Timing server port. */
  timingPort: Scalars['Int']['input'];
  /** One Timing server address. */
  timingURL: Scalars['String']['input'];
  /** Time interval in seconds between two API data updates. */
  updateInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

/** List of items with pagination. */
export type OneTimingWeatherServiceConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<OneTimingWeatherServiceConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OneTimingWeatherServiceStartResult = {
  success: Scalars['Boolean']['output'];
};

export type OneTimingWeatherServiceStatus =
  /** Stopped due to error. See log for details. */
  | 'ERROR'
  /** Stopped due to end of event. */
  | 'FINISHED'
  /** Ready to receive a start command. */
  | 'READY'
  /** Watching and acting on timing data. */
  | 'RUNNING'
  /** Stopped by user. */
  | 'STOPPED';

export type OneTimingWeatherServiceStopResult = {
  success: Scalars['Boolean']['output'];
};

export type OrientationUnitField = {
  unit: EnumUntypedUnit;
};

export type Package = {
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  chassisSpec?: Maybe<ChassisSpec>;
  chassisSpecID: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<PackageItems>>>;
  name: Scalars['String']['output'];
  teamIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  teams: Array<Team>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  useAsCopyReference?: Maybe<Scalars['Boolean']['output']>;
};

export type PackageItems = {
  /** 'setup.front.hRide' or 'spec.specID.adjustables.adjIndex.LOCATION' */
  path?: Maybe<Scalars['String']['output']>;
  /** string | number | null (also can 'delete' certain things from a setup) */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type PackageItemsInput = {
  /** 'setup.front.hRide' or 'spec.specID.adjustables.adjIndex.LOCATION' */
  path?: InputMaybe<Scalars['String']['input']>;
  /** string | number | null (also can 'delete' certain things from a setup) */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** List of items with pagination. */
export type PackagePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Package>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PaginationInfo = {
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  perPage?: Maybe<Scalars['Int']['output']>;
};

export type PaginationInfoAssembly = {
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
};

export type Part = {
  _id: Scalars['MongoID']['output'];
  chassisSpecName?: Maybe<Scalars['String']['output']>;
  /** Can this very part be used multiple times on a car. For 'virtual parts' or other special applications. Overrides the setting of the specification. */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentlyInUse?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  eligibleEventTypes?: Maybe<EnumPartEligibleEventTypes>;
  /** To be used for dummy parts or at user discretion for special applications. */
  isVirtualPart?: Maybe<Scalars['Boolean']['output']>;
  lifetimeMileage?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Location>;
  locationID?: Maybe<Scalars['MongoID']['output']>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturerID?: Maybe<Scalars['MongoID']['output']>;
  manufacturerPartID?: Maybe<Scalars['String']['output']>;
  manufacturerSerialNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partNumber?: Maybe<Scalars['String']['output']>;
  partStatus?: Maybe<PartStatus>;
  properties?: Maybe<Scalars['JSON']['output']>;
  readingLocationOverride?: Maybe<Array<Maybe<EnumPartReadingLocationOverride>>>;
  reference: Scalars['String']['output'];
  rootAssemblies: Array<Assembly>;
  rootAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  rootSpecification?: Maybe<Specification>;
  rootSpecificationID?: Maybe<Scalars['MongoID']['output']>;
  specification?: Maybe<BaseSpecification>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  team?: Maybe<Team>;
  /** @deprecated Use teamIDs */
  teamID?: Maybe<Scalars['MongoID']['output']>;
  teamIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  teams: Array<Team>;
  /** Tracking */
  tracking?: Maybe<Array<Maybe<TrackingEntry>>>;
  trackingHistory: Array<TrackingRecord>;
  trackingHistoryFullAndSnapshot?: Maybe<PartReturnTrackingHistoryFullandSnapshot>;
  trackingHistoryIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurementHistory: Array<TrackingMeasurementRecord>;
  trackingMeasurementHistoryIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumPartType?: Maybe<UserEnumPartType>;
  userEnumPartTypeID?: Maybe<Scalars['MongoID']['output']>;
};


export type PartTrackingArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  historyFromDate?: InputMaybe<Scalars['Date']['input']>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingItemNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PartInEvent = {
  part?: Maybe<Part>;
  runDistance?: Maybe<Scalars['Float']['output']>;
  runs?: Maybe<Array<Maybe<PartInEventRun>>>;
  serviceMileage?: Maybe<Scalars['Float']['output']>;
};

export type PartInEventRun = {
  assemblyID?: Maybe<Scalars['String']['output']>;
  assemblyName?: Maybe<Scalars['String']['output']>;
  carSetupID?: Maybe<Scalars['String']['output']>;
  carSetupTitle?: Maybe<Scalars['String']['output']>;
  contestantID?: Maybe<Scalars['String']['output']>;
  mileage?: Maybe<Scalars['Float']['output']>;
  runID?: Maybe<Scalars['String']['output']>;
  runName?: Maybe<Scalars['String']['output']>;
  runTime?: Maybe<Scalars['Float']['output']>;
};

export type PartInstance = {
  _id: Scalars['MongoID']['output'];
  measurements?: Maybe<Array<Maybe<PartInstanceMeasurement>>>;
  parent?: Maybe<Assembly>;
  parentID?: Maybe<Scalars['MongoID']['output']>;
  part?: Maybe<Part>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  readingLocation?: Maybe<EnumReadingLocation>;
  specification?: Maybe<Specification>;
  specificationGroup?: Maybe<Specification>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  superParentID?: Maybe<Scalars['MongoID']['output']>;
  trackingItemReferenceDate?: Maybe<Scalars['Date']['output']>;
};

export type PartInstanceMeasurement = {
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  coordinates?: Maybe<PartInstanceMeasurementCoordinates>;
  floatValue?: Maybe<Scalars['Float']['output']>;
  idx?: Maybe<Scalars['Float']['output']>;
  rotation?: Maybe<PartInstanceMeasurementRotation>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the fields `floatValue`, `stringValue`, or `booleanValue` instead. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PartInstanceMeasurementCoordinates = {
  /** Coordinate value x */
  x?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value y */
  y?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value z */
  z?: Maybe<Scalars['Float']['output']>;
};

export type PartInstanceMeasurementCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type PartInstanceMeasurementInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<PartInstanceMeasurementCoordinatesInput>;
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  idx?: InputMaybe<Scalars['Float']['input']>;
  rotation?: InputMaybe<PartInstanceMeasurementRotationInput>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type PartInstanceMeasurementRotation = {
  /** Rotation value I */
  I?: Maybe<Scalars['Float']['output']>;
  /** Rotation value J */
  J?: Maybe<Scalars['Float']['output']>;
  /** Rotation value K */
  K?: Maybe<Scalars['Float']['output']>;
};

export type PartInstanceMeasurementRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type PartInstancePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PartInstance>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PartInstanceUpdateResult = {
  error?: Maybe<ErrorInterface>;
  record?: Maybe<PartInstance>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type PartPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Part>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PartReturnTrackingHistoryFullandSnapshot = {
  trackingHistoryFull?: Maybe<Array<Maybe<PartTrackingHistoryFullandSnapshot>>>;
  trackingSnapshot?: Maybe<Array<Maybe<PartTrackingHistoryFullandSnapshot>>>;
};

export type PartStatus = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  statusComment?: Maybe<Scalars['String']['output']>;
  userEnumPartStatus?: Maybe<UserEnumPartStatus>;
  userEnumPartStatusID?: Maybe<Scalars['MongoID']['output']>;
  userEnumPartStatusName?: Maybe<Scalars['String']['output']>;
};

export type PartStatusInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  statusComment?: InputMaybe<Scalars['String']['input']>;
  userEnumPartStatusID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type PartTrackingHistoryFullandSnapshot = {
  active?: Maybe<Scalars['Boolean']['output']>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cumulativeValue?: Maybe<Scalars['Float']['output']>;
  dateResolved?: Maybe<Scalars['Date']['output']>;
  limitCritical?: Maybe<Scalars['Boolean']['output']>;
  limitWarning?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<GeoLocation>;
  mass?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  qualityCheckID?: Maybe<Scalars['MongoID']['output']>;
  recordErrors?: Maybe<Scalars['String']['output']>;
  reset?: Maybe<Scalars['Boolean']['output']>;
  statusEnumID?: Maybe<Scalars['MongoID']['output']>;
  trackingItem?: Maybe<TrackingItem>;
  trackingItemID?: Maybe<Scalars['MongoID']['output']>;
  trackingRecordID?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumPartStatusName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type PartsInEventResult = {
  count: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<PartInEvent>>>;
  pageInfo?: Maybe<PaginationInfo>;
};

export type Person = {
  _id: Scalars['MongoID']['output'];
  /** 3-letter acronym for drivers */
  acronym?: Maybe<Scalars['String']['output']>;
  behaviour?: Maybe<BehaviourConfig>;
  birthday?: Maybe<Scalars['Date']['output']>;
  canopyCredentials?: Maybe<CanopyCredentials>;
  carUpdateMethod?: Maybe<EnumPersonCarUpdateMethod>;
  /**
   * IDs of contestants visible to this person when logged in.
   * @deprecated Use `visibleContestantIDs` instead
   */
  contestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Contestants visible to this person when logged in.
   * @deprecated Use `visibleContestants` instead
   */
  contestants: Array<Contestant>;
  defaultFlexLayoutConfigs?: Maybe<DefaultFlexLayoutConfigs>;
  defaultRunSheetCompareStyle?: Maybe<RunSheetStyle>;
  defaultRunSheetCompareStyleID?: Maybe<Scalars['MongoID']['output']>;
  defaultRunSheetStyle?: Maybe<RunSheetStyle>;
  defaultRunSheetStyleID?: Maybe<Scalars['MongoID']['output']>;
  defaultRunSheetStylePhone?: Maybe<RunSheetStyle>;
  defaultRunSheetStylePhoneID?: Maybe<Scalars['MongoID']['output']>;
  defaultTyreReferenceTemperature?: Maybe<Scalars['Float']['output']>;
  /** Default string for tyre set naming, where x=Chassis, i=Info, s=SetNumber, (c=Corner or a=Axle) */
  defaultTyreSetNameFormat?: Maybe<Scalars['String']['output']>;
  displayColor?: Maybe<Scalars['String']['output']>;
  dynoConfig?: Maybe<DynoConfig>;
  dynoConfigID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of contestants editable to this person when logged in. */
  editableContestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  email?: Maybe<Scalars['String']['output']>;
  emailNotificationConfig?: Maybe<NotificationConfig>;
  /**
   * IDs of events visible to this person when logged in.
   * @deprecated Use `visibleEventIDs` instead
   */
  eventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /**
   * Events visible to this person when logged in.
   * @deprecated Use `visibleEvents` instead
   */
  events: Array<Event>;
  /** Should this user be unable to see KPIs? */
  hideKPIs?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Should this user be able to track his working time? */
  isTimeTracker?: Maybe<Scalars['Boolean']['output']>;
  /** Should this user be able to see, update and approve working times for other users? */
  isTimeTrackerAdmin?: Maybe<Scalars['Boolean']['output']>;
  lapSequenceTemplateIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  lapSequenceTemplates: Array<LapSequenceTemplate>;
  localConnections?: Maybe<Array<Maybe<LocalConnection>>>;
  mileageUnit?: Maybe<EnumLengthUnit>;
  name: Scalars['String']['output'];
  passportNumber?: Maybe<Scalars['String']['output']>;
  passportPicture?: Maybe<Scalars['String']['output']>;
  /** Collection of favourite plot page config IDs. */
  plotPageConfigIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Collection of favourite plot page configs. */
  plotPageConfigs: Array<PlotPageConfig>;
  privateMobile?: Maybe<Scalars['Float']['output']>;
  privatePhone?: Maybe<Scalars['Float']['output']>;
  role?: Maybe<EnumPersonRole>;
  /** Collection of favourite setup overview config IDs. */
  setupOverviewConfigIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  team?: Maybe<Team>;
  teamID?: Maybe<Scalars['MongoID']['output']>;
  timeApprovees: Array<Person>;
  timeSheetEntries?: Maybe<Array<Maybe<TimeSheetEntry>>>;
  timeTrackerApprovalByPersonID?: Maybe<Scalars['MongoID']['output']>;
  /** Collection of personal setup IDs. */
  userSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Collection of personal setups. */
  userSetups: Array<CarSetup>;
  userSimulationSettings?: Maybe<UserSimulationSettings>;
  username: Scalars['String']['output'];
  viewConfig?: Maybe<ViewConfig>;
  /** IDs of contestants visible to this person when logged in. */
  visibleContestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Contestants visible to this person when logged in. */
  visibleContestants: Array<Contestant>;
  /** IDs of events visible to this person when logged in. */
  visibleEventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Events visible to this person when logged in. */
  visibleEvents: Array<Event>;
  /** IDs of teams visible to this person when logged in. */
  visibleTeamIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  workMobile?: Maybe<Scalars['Float']['output']>;
  workPhone?: Maybe<Scalars['Float']['output']>;
};


export type PersonTimeApproveesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPersonInput>;
};


export type PersonTimeSheetEntriesArgs = {
  tStartAfter: Scalars['Date']['input'];
  tStartBefore: Scalars['Date']['input'];
};

/** List of items with pagination. */
export type PersonPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Person>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlotConfig = {
  index: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  xAxisType: EnumPlotConfigXAxisType;
  xDataSource: Scalars['String']['output'];
  xLabel: Scalars['String']['output'];
  /** Object containing at least `label`, and optionally `color`, `lineStyle` (from `EnumLineStyle`), and `marker` (from `EnumMarkerType`) properties */
  yData: Scalars['JSON']['output'];
  /** @deprecated Use as a key in `yData` instead. */
  yDataSource?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use as a value in `yData` instead. */
  yLabel?: Maybe<Scalars['String']['output']>;
  yLines?: Maybe<Array<Maybe<PlotConfigLine>>>;
};

export type PlotConfigInput = {
  index: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  xAxisType: EnumPlotConfigXAxisType;
  xDataSource: Scalars['String']['input'];
  xLabel: Scalars['String']['input'];
  /** Object containing at least `label`, and optionally `color`, `lineStyle` (from `EnumLineStyle`), and `marker` (from `EnumMarkerType`) properties */
  yData: Scalars['JSON']['input'];
  yDataSource?: InputMaybe<Scalars['String']['input']>;
  yLabel?: InputMaybe<Scalars['String']['input']>;
  yLines?: InputMaybe<Array<InputMaybe<PlotConfigLineInput>>>;
};

export type PlotConfigLine = {
  color?: Maybe<Scalars['String']['output']>;
  style?: Maybe<EnumLineStyle>;
  value: Scalars['Float']['output'];
};

export type PlotConfigLineInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<EnumLineStyle>;
  value: Scalars['Float']['input'];
};

export type PlotPageConfig = {
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  /** Number of columns in the grid. */
  gridCols: Scalars['Int']['output'];
  /** Number of rows in the grid. */
  gridRows: Scalars['Int']['output'];
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  plots: Array<Maybe<PlotConfig>>;
  title?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type PlotPageConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PlotPageConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PointsSystem = {
  _id: Scalars['MongoID']['output'];
  /** Array of points for the fastest lap */
  laptimeDriverPoints?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Race position cutoff for drivers eligible for points for the fastest lap. In some race series you need to be in the top 10 to get the bonus point. */
  laptimePositionCutoff?: Maybe<Scalars['Float']['output']>;
  /** Array of points for the fastest lap for the teams. In some race series only the driver receives points for fastest lap. */
  laptimeTeamPoints?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  name: Scalars['String']['output'];
  /** How much race distance needs to be completed to be eligible for points */
  positionalCompletionMin?: Maybe<Scalars['Float']['output']>;
  /** How much race distance in % needs to be completed to be eligible for points */
  positionalCompletionMinRatio?: Maybe<Scalars['Float']['output']>;
  /** Array of driver points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalDriverPoints?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Array of team points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalTeamPoints?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  sessionType?: Maybe<EnumSessionType>;
};

/** List of items with pagination. */
export type PointsSystemPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PointsSystem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PostRunMeasurementBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type Power = {
  /** 1hp = 745.6998715822702W */
  horsepowerMechanical: Scalars['Float']['output'];
  /** kW */
  kilowatts: Scalars['Float']['output'];
  /** W */
  watts: Scalars['Float']['output'];
};

export type PowerInput = {
  /** 1hp = 745.6998715822702W */
  horsepowerMechanical?: InputMaybe<Scalars['Float']['input']>;
  /** kW */
  kilowatts?: InputMaybe<Scalars['Float']['input']>;
  /** W */
  watts?: InputMaybe<Scalars['Float']['input']>;
};

export type PowerUnitField = {
  unit: EnumPowerUnit;
};

export type Powertrain = {
  MDiffPreloadCold?: Maybe<Scalars['Float']['output']>;
  MDiffPreloadHot?: Maybe<Scalars['Float']['output']>;
  /**
   * Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are arbitrary numbers. Input syntax is array of key-value tuples, like `NEngineBlanking: [["left", 5], ["right", 9]]`.
   * @deprecated Use blanking field instead.
   */
  NEngineBlanking?: Maybe<Scalars['JSON']['output']>;
  NFrictionFaces?: Maybe<Scalars['Float']['output']>;
  PPowerLevel?: Maybe<Scalars['Float']['output']>;
  aDiffRampCoast?: Maybe<Scalars['Float']['output']>;
  aDiffRampDrive?: Maybe<Scalars['Float']['output']>;
  bevelSet?: Maybe<PowertrainGear>;
  /** Map of blanking fields with values. Keys are strings like `gearboxRadiatorTapes` or `hRESSBlanking`, and values are strings describing the blanking details. Input syntax is array of key-value tuples, like `blanking: [["gearboxRadiatorTapes", "5"]]`. */
  blanking?: Maybe<Scalars['JSON']['output']>;
  clutch?: Maybe<Scalars['String']['output']>;
  clutchCylinder?: Maybe<Scalars['String']['output']>;
  dAirRestrictor?: Maybe<Scalars['Float']['output']>;
  /** Name of the selected configuration from the spec. */
  differentialConfigName?: Maybe<Scalars['String']['output']>;
  differentialSpec?: Maybe<DifferentialSpec>;
  differentialSpecID?: Maybe<Scalars['MongoID']['output']>;
  dropGear?: Maybe<PowertrainGear>;
  /**
   * Map of extra engine blanking measurement fields to their values. Input syntax is array of key-value tuples, like `engineBlankingComments: [["louvres", "NONE"], ["other", true]]`.
   * @deprecated Use blanking field instead.
   */
  engineBlankingDetails?: Maybe<Scalars['JSON']['output']>;
  frictionFaces?: Maybe<Scalars['String']['output']>;
  gearboxGridType?: Maybe<Scalars['String']['output']>;
  gears?: Maybe<Array<Maybe<PowertrainStandardGear>>>;
  /**
   * Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hEngineBlanking: [["left", 0.003], ["right", 0.004]]`.
   * @deprecated Use blanking field instead.
   */
  hEngineBlanking?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hGearboxBlanking: [["left", 0.003], ["right", 0.004]]`.
   * @deprecated Use blanking field instead.
   */
  hGearboxBlanking?: Maybe<Scalars['JSON']['output']>;
  rBevelSet?: Maybe<Scalars['Float']['output']>;
  rDropGear?: Maybe<Scalars['Float']['output']>;
  /**
   * Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rEngineBlanking: [["left", 0.05], ["right", 0.06]]`.
   * @deprecated Use blanking field instead.
   */
  rEngineBlanking?: Maybe<Scalars['JSON']['output']>;
  /** Map of gears to their ratios. Keys are strings like `"1"` or `"R"`, and values are ratios. Input syntax is array of key-value tuples, like `rGearRatios: [["R", 0.8], ["1", 0.3]]`. */
  rGearRatios?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rGearboxBlanking: [["left", 0.05], ["right", 0.06]]`.
   * @deprecated Use blanking field instead.
   */
  rGearboxBlanking?: Maybe<Scalars['JSON']['output']>;
};

export type PowertrainGear = {
  specification?: Maybe<GearSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
};

export type PowertrainGearInput = {
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type PowertrainInput = {
  MDiffPreloadCold?: InputMaybe<Scalars['Float']['input']>;
  MDiffPreloadHot?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are arbitrary numbers. Input syntax is array of key-value tuples, like `NEngineBlanking: [["left", 5], ["right", 9]]`. */
  NEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  NFrictionFaces?: InputMaybe<Scalars['Float']['input']>;
  PPowerLevel?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampCoast?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampDrive?: InputMaybe<Scalars['Float']['input']>;
  bevelSet?: InputMaybe<PowertrainGearInput>;
  /** Map of blanking fields with values. Keys are strings like `gearboxRadiatorTapes` or `hRESSBlanking`, and values are strings describing the blanking details. Input syntax is array of key-value tuples, like `blanking: [["gearboxRadiatorTapes", "5"]]`. */
  blanking?: InputMaybe<Scalars['JSON']['input']>;
  clutch?: InputMaybe<Scalars['String']['input']>;
  clutchCylinder?: InputMaybe<Scalars['String']['input']>;
  dAirRestrictor?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the selected configuration from the spec. */
  differentialConfigName?: InputMaybe<Scalars['String']['input']>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  dropGear?: InputMaybe<PowertrainGearInput>;
  /** Map of extra engine blanking measurement fields to their values. Input syntax is array of key-value tuples, like `engineBlankingComments: [["louvres", "NONE"], ["other", true]]`. */
  engineBlankingDetails?: InputMaybe<Scalars['JSON']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  gearboxGridType?: InputMaybe<Scalars['String']['input']>;
  gears?: InputMaybe<Array<InputMaybe<PowertrainStandardGearInput>>>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hEngineBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hGearboxBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
  rBevelSet?: InputMaybe<Scalars['Float']['input']>;
  rDropGear?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rEngineBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gears to their ratios. Keys are strings like `"1"` or `"R"`, and values are ratios. Input syntax is array of key-value tuples, like `rGearRatios: [["R", 0.8], ["1", 0.3]]`. */
  rGearRatios?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rGearboxBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
};

export type PowertrainStandardGear = {
  /** e.g. "R", "1", "2", etc. */
  gearNumber: Scalars['String']['output'];
  specification?: Maybe<GearSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
};

export type PowertrainStandardGearInput = {
  /** e.g. "R", "1", "2", etc. */
  gearNumber: Scalars['String']['input'];
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type Pressure = {
  /** bar */
  bar: Scalars['Float']['output'];
  /** inHg */
  inchesOfMercury: Scalars['Float']['output'];
  /** kPa */
  kilopascals: Scalars['Float']['output'];
  /** mbar */
  millibar: Scalars['Float']['output'];
  /** Pa */
  pascals: Scalars['Float']['output'];
  /** psi */
  psi: Scalars['Float']['output'];
};

export type PressureInput = {
  /** bar */
  bar?: InputMaybe<Scalars['Float']['input']>;
  /** inHg */
  inchesOfMercury?: InputMaybe<Scalars['Float']['input']>;
  /** kPa */
  kilopascals?: InputMaybe<Scalars['Float']['input']>;
  /** mbar */
  millibar?: InputMaybe<Scalars['Float']['input']>;
  /** Pa */
  pascals?: InputMaybe<Scalars['Float']['input']>;
  /** psi */
  psi?: InputMaybe<Scalars['Float']['input']>;
};

export type PressureUnitField = {
  unit: EnumPressureUnit;
};

export type Project = {
  _id: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Run sheet associated with this job */
  tags?: Maybe<Tag>;
};

/** List of items with pagination. */
export type ProjectPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Project>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type QualityCheck = {
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  qualityCheckActionIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  qualityCheckActions: Array<QualityCheckAction>;
  status?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type QualityCheckAction = {
  _id: Scalars['MongoID']['output'];
  acknowledgedAt?: Maybe<Scalars['Date']['output']>;
  acknowledgedBy?: Maybe<Person>;
  acknowledgedByID?: Maybe<Scalars['MongoID']['output']>;
  assigneeIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignees: Array<Person>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledBy?: Maybe<Person>;
  cancelledByID?: Maybe<Scalars['MongoID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Date']['output']>;
  closedBy?: Maybe<Person>;
  closedByID?: Maybe<Scalars['MongoID']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Person>;
  createdByID?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  priority?: Maybe<EnumQualityCheckActionPriority>;
  status?: Maybe<EnumQualityCheckActionStatus>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type QualityCheckActionPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<QualityCheckAction>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type QualityCheckPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<QualityCheck>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Query = {
  activeCarDataServiceConfig?: Maybe<CarDataServiceConfig>;
  assemblies?: Maybe<AssemblyPagination>;
  /** Returns assemblies that has all associated parts active if allPartInstancesActive is true, otherwise returns all assemblies. With pagination, default perPage is 24 */
  assembliesAdvancedFilter?: Maybe<AdvancedAssemblyFilterReturnType>;
  assembly?: Maybe<Assembly>;
  /** Part ids of all nested part instances per assembly, resolved with two batched lean queries instead of expanding every part instance through GraphQL. */
  assemblyPartIDs: Array<AssemblyPartIDs>;
  assemblyTemplate?: Maybe<AssemblyTemplate>;
  assemblyTemplates?: Maybe<AssemblyTemplatePagination>;
  bestValues?: Maybe<BestValues>;
  bestValuesAll?: Maybe<BestValuesPagination>;
  bestValuesFallback?: Maybe<BestValues>;
  bop?: Maybe<Bop>;
  bops?: Maybe<BopPagination>;
  buildSheetStyle?: Maybe<BuildSheetStyle>;
  buildSheetStyles?: Maybe<BuildSheetStylePagination>;
  calculation?: Maybe<Calculation>;
  calculations?: Maybe<CalculationPagination>;
  carDataServiceConfig?: Maybe<CarDataServiceConfig>;
  carDataServiceConfigs?: Maybe<CarDataServiceConfigPagination>;
  carSetup?: Maybe<CarSetup>;
  carSetups?: Maybe<CarSetupPagination>;
  carSetupsMany: Array<CarSetup>;
  chassis?: Maybe<Chassis>;
  chassisAll?: Maybe<ChassisPagination>;
  chassisMeasurement?: Maybe<ChassisMeasurement>;
  chassisMeasurements?: Maybe<ChassisMeasurementPagination>;
  /** Use this to compare two chassis specs and see if there are changes between them */
  compareChassisSpecs: Scalars['Boolean']['output'];
  contestant?: Maybe<Contestant>;
  contestants?: Maybe<ContestantPagination>;
  /** Get a list of backup names currently stored on this server */
  databaseBackups: Array<Scalars['String']['output']>;
  department?: Maybe<Department>;
  departments?: Maybe<DepartmentPagination>;
  dynoConfig?: Maybe<DynoConfig>;
  dynoConfigs?: Maybe<DynoConfigPagination>;
  event?: Maybe<Event>;
  /** Query tyres for an event contestant. */
  eventContestantTyres?: Maybe<EventContestantTyres>;
  events?: Maybe<EventPagination>;
  findCanopyConfigs: Array<CanopyConfig>;
  /** Get a flattened car setup for simulation, including custom simulation payload. */
  flattenedSetupForSimulation?: Maybe<Scalars['JSON']['output']>;
  flexLayoutConfig?: Maybe<FlexLayoutConfig>;
  flexLayoutConfigs?: Maybe<FlexLayoutConfigPagination>;
  /** Generate an issue number from selected race series and season */
  generateIssueNumber: Issue;
  greeboLog?: Maybe<GreeboLog>;
  issue?: Maybe<IssueQuery>;
  issues?: Maybe<IssueQueryPagination>;
  job?: Maybe<Job>;
  jobs?: Maybe<JobPagination>;
  lap?: Maybe<Lap>;
  lapSequence?: Maybe<LapSequence>;
  lapSequenceTemplate?: Maybe<LapSequenceTemplate>;
  lapSequenceTemplates?: Maybe<LapSequenceTemplatePagination>;
  lapSequences?: Maybe<LapSequencePagination>;
  laps?: Maybe<LapPagination>;
  lapsMany: Array<Lap>;
  license: LicenseProperties;
  location?: Maybe<Location>;
  locations?: Maybe<LocationPagination>;
  log?: Maybe<Log>;
  logs?: Maybe<LogPagination>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturers?: Maybe<ManufacturerPagination>;
  migrations?: Maybe<Migrations>;
  /** Query the config that the OneTiming weather service will use when started. */
  oneTimingWeatherServiceCheckConfig?: Maybe<OneTimingWeatherServiceConfig>;
  oneTimingWeatherServiceConfig?: Maybe<OneTimingWeatherServiceConfig>;
  oneTimingWeatherServiceConfigs?: Maybe<OneTimingWeatherServiceConfigPagination>;
  /** Get the most recent lines from the One Timing weather service logs. */
  oneTimingWeatherServiceLogs?: Maybe<Scalars['String']['output']>;
  oneTimingWeatherServiceStatus: OneTimingWeatherServiceStatus;
  /** Order runsheets for forward propagation */
  orderRunSheetsForForwardPropagation?: Maybe<Scalars['JSON']['output']>;
  package?: Maybe<Package>;
  packages?: Maybe<PackagePagination>;
  part?: Maybe<Part>;
  partInstance?: Maybe<PartInstance>;
  partInstances?: Maybe<PartInstancePagination>;
  /** Get full tracking history and snapshot for a part */
  partReturnTrackingHistoryFullandSnapshot?: Maybe<PartReturnTrackingHistoryFullandSnapshot>;
  /** Get full tracking history and snapshot for a part */
  partTracking: Array<Maybe<TrackingEntry>>;
  parts?: Maybe<PartPagination>;
  /** Get parts by specification type with pagination, default perPage is 24 */
  partsAdvancedFilter?: Maybe<AdvancedPartsFilterReturnType>;
  /** Get parts by chassis specification */
  partsForChassisSpec?: Maybe<AdvancedPartsFilterReturnType>;
  /** Get parts in event. Accepts eventId and searches through all the run sheets and setups to return all the partIDs used in this event */
  partsInEvent?: Maybe<PartsInEventResult>;
  people?: Maybe<PersonPagination>;
  person?: Maybe<Person>;
  plotPageConfig?: Maybe<PlotPageConfig>;
  plotPageConfigs?: Maybe<PlotPageConfigPagination>;
  pointsSystem?: Maybe<PointsSystem>;
  pointsSystems?: Maybe<PointsSystemPagination>;
  project?: Maybe<Project>;
  projects?: Maybe<ProjectPagination>;
  qualityCheck?: Maybe<QualityCheck>;
  qualityCheckAction?: Maybe<QualityCheckAction>;
  qualityChecks?: Maybe<QualityCheckPagination>;
  qualityChecksAction?: Maybe<QualityCheckActionPagination>;
  raceSeries?: Maybe<RaceSeries>;
  raceSeriesAll?: Maybe<RaceSeriesPagination>;
  radioMessage?: Maybe<RadioMessage>;
  radioMessages?: Maybe<RadioMessagePagination>;
  reportNotes?: Maybe<ReportNote>;
  reportNotesTemplates: Array<ReportNotesTemplate>;
  reportTemplate?: Maybe<ReportTemplate>;
  reportTemplates?: Maybe<ReportTemplatePagination>;
  requiredClientVersion: Scalars['SemVer']['output'];
  runPlan?: Maybe<RunPlan>;
  runPlans?: Maybe<RunPlanPagination>;
  runSheet?: Maybe<RunSheet>;
  runSheetStyle?: Maybe<RunSheetStyle>;
  runSheetStyles?: Maybe<RunSheetStylePagination>;
  runSheets?: Maybe<RunSheetPagination>;
  /** Get run sheets by associated KPI files */
  runSheetsByAssociatedKPIFiles?: Maybe<Array<Maybe<RunSheet>>>;
  runSheetsMany: Array<RunSheet>;
  sandbox?: Maybe<SandboxQueries>;
  season?: Maybe<Season>;
  seasons?: Maybe<SeasonPagination>;
  serverSettings?: Maybe<ServerSettings>;
  session?: Maybe<Session>;
  sessionDebrief?: Maybe<TemplateSessionDebrief>;
  sessionDebriefs?: Maybe<TemplateSessionDebriefPagination>;
  sessions?: Maybe<SessionPagination>;
  setupOverviewConfig?: Maybe<SetupOverviewConfig>;
  setupOverviewConfigs?: Maybe<SetupOverviewConfigPagination>;
  setupSheetStyle?: Maybe<SetupSheetStyle>;
  setupSheetStyles?: Maybe<SetupSheetStylePagination>;
  simRequest?: Maybe<SimRequest>;
  simRequests?: Maybe<SimRequestPagination>;
  simResult?: Maybe<SimResult>;
  simResults?: Maybe<SimResultPagination>;
  simulationDriveFile?: Maybe<SimulationDriveFile>;
  simulationDriveFiles?: Maybe<SimulationDriveFilePagination>;
  skidPlate?: Maybe<SkidPlate>;
  skidPlates?: Maybe<SkidPlatePagination>;
  specification?: Maybe<Specification>;
  specificationBase?: Maybe<BaseSpecification>;
  specificationGroup?: Maybe<SpecificationGroup>;
  specifications?: Maybe<SpecificationPagination>;
  ssoProvider?: Maybe<SsoProvider>;
  ssoProviders: Array<SsoProvider>;
  tag?: Maybe<Tag>;
  tags?: Maybe<TagPagination>;
  team?: Maybe<Team>;
  teams?: Maybe<TeamPagination>;
  templateJobList?: Maybe<TemplateJobList>;
  templateJobLists?: Maybe<TemplateJobListPagination>;
  timeSheetEntries?: Maybe<TimeSheetEntryPagination>;
  timeSheetEntry?: Maybe<TimeSheetEntry>;
  timingServiceConfig?: Maybe<TimingServiceConfig>;
  timingServiceConfigs?: Maybe<TimingServiceConfigPagination>;
  timingServiceStatus?: Maybe<TimingServiceStatus>;
  track?: Maybe<Track>;
  trackLayout?: Maybe<TrackLayout>;
  trackLayouts?: Maybe<TrackLayoutPagination>;
  trackable?: Maybe<Trackable>;
  trackables?: Maybe<TrackablePagination>;
  trackingItem?: Maybe<TrackingItem>;
  /** Distinct tracking item names for all parts used in the run sheets of the given sessions. Walks run sheets -> setups -> chassis assemblies -> part instances -> parts -> specifications with lean, batched queries instead of resolving per-part tracking histories. */
  trackingItemNamesForSessions: Array<Scalars['String']['output']>;
  trackingItems?: Maybe<TrackingItemPagination>;
  trackingMeasurement?: Maybe<TrackingMeasurement>;
  trackingMeasurementRecord?: Maybe<TrackingMeasurementRecord>;
  trackingMeasurementRecords?: Maybe<TrackingMeasurementRecordPagination>;
  trackingMeasurements?: Maybe<TrackingMeasurementPagination>;
  trackingRecord?: Maybe<TrackingRecord>;
  trackingRecords?: Maybe<TrackingRecordPagination>;
  trackingSource?: Maybe<TrackingSource>;
  trackingSourceAlias?: Maybe<TrackingSourceAlias>;
  trackingSourceAliases?: Maybe<TrackingSourceAliasPagination>;
  trackingSources?: Maybe<TrackingSourcePagination>;
  tracks?: Maybe<TrackPagination>;
  tyre?: Maybe<Tyre>;
  tyreMileageAtSessionStart?: Maybe<TyreMileageAtSessionStart>;
  tyreMileageGraph?: Maybe<TyreMileageGraph>;
  tyrePressureSheet: TyrePressureSheet;
  tyreSet?: Maybe<TyreSet>;
  tyreSets?: Maybe<TyreSetPagination>;
  tyreWear?: Maybe<TyreWear>;
  tyreWears?: Maybe<TyreWearPagination>;
  tyres?: Maybe<TyrePagination>;
  userEnum?: Maybe<UserEnum>;
  userEnums?: Maybe<UserEnumPagination>;
  version: Scalars['SemVer']['output'];
  weather?: Maybe<Weather>;
  weatherAll?: Maybe<WeatherPagination>;
  weatherServiceConfig?: Maybe<WeatherServiceConfig>;
  weatherServiceConfigs?: Maybe<WeatherServiceConfigPagination>;
  whoami: TokenClaims;
};


export type QueryActiveCarDataServiceConfigArgs = {
  raceSeriesID: Scalars['MongoID']['input'];
};


export type QueryAssembliesArgs = {
  filter?: InputMaybe<FilterFindManyAssemblyInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssemblyInput>;
};


export type QueryAssembliesAdvancedFilterArgs = {
  allPartInstancesActive?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FilterFindManyAssemblyInput>;
  hideAssembliesUsedInRunSheets?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssemblyInput>;
};


export type QueryAssemblyArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryAssemblyPartIDsArgs = {
  assemblyIDs: Array<Scalars['MongoID']['input']>;
};


export type QueryAssemblyTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryAssemblyTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyAssemblyTemplateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssemblyTemplateInput>;
};


export type QueryBestValuesArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryBestValuesAllArgs = {
  filter?: InputMaybe<FilterFindManyBestValuesInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBestValuesInput>;
};


export type QueryBestValuesFallbackArgs = {
  contestantID?: InputMaybe<Scalars['String']['input']>;
  driverID?: InputMaybe<Scalars['String']['input']>;
  sessionID: Scalars['String']['input'];
};


export type QueryBopArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryBopsArgs = {
  filter?: InputMaybe<FilterFindManyBopInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBopInput>;
};


export type QueryBuildSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryBuildSheetStylesArgs = {
  filter?: InputMaybe<FilterFindManyBuildSheetStyleInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBuildSheetStyleInput>;
};


export type QueryCalculationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCalculationsArgs = {
  filter?: InputMaybe<FilterFindManyCalculationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCalculationInput>;
};


export type QueryCarDataServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCarDataServiceConfigsArgs = {
  filter?: InputMaybe<FilterFindManyCarDataServiceConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCarDataServiceConfigInput>;
};


export type QueryCarSetupArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCarSetupsArgs = {
  filter?: InputMaybe<FilterFindManyCarSetupInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCarSetupInput>;
};


export type QueryCarSetupsManyArgs = {
  filter?: InputMaybe<FilterFindManyCarSetupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCarSetupInput>;
};


export type QueryChassisArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryChassisAllArgs = {
  filter?: InputMaybe<FilterFindManyChassisInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChassisInput>;
};


export type QueryChassisMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryChassisMeasurementsArgs = {
  filter?: InputMaybe<FilterFindManyChassisMeasurementInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChassisMeasurementInput>;
};


export type QueryCompareChassisSpecsArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
  chassisSpecToCompareID: Scalars['MongoID']['input'];
};


export type QueryContestantArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryContestantsArgs = {
  filter?: InputMaybe<FilterFindManyContestantInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyContestantInput>;
};


export type QueryDepartmentArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryDepartmentsArgs = {
  filter?: InputMaybe<FilterFindManyDepartmentInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDepartmentInput>;
};


export type QueryDynoConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryDynoConfigsArgs = {
  filter?: InputMaybe<FilterFindManyDynoConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDynoConfigInput>;
};


export type QueryEventArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryEventContestantTyresArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
};


export type QueryEventsArgs = {
  filter?: InputMaybe<FilterFindManyEventInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyEventInput>;
};


export type QueryFindCanopyConfigsArgs = {
  configType: EnumCanopyConfigType;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFlattenedSetupForSimulationArgs = {
  carSetupID: Scalars['MongoID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  outputFolder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFlexLayoutConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryFlexLayoutConfigsArgs = {
  filter?: InputMaybe<FilterFindManyFlexLayoutConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFlexLayoutConfigInput>;
};


export type QueryGenerateIssueNumberArgs = {
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryGreeboLogArgs = {
  eventID?: InputMaybe<Scalars['String']['input']>;
  sessionID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIssueArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryIssuesArgs = {
  filter?: InputMaybe<FilterFindManyIssueQueryInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIssueQueryInput>;
};


export type QueryJobArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryJobsArgs = {
  filter?: InputMaybe<FilterFindManyJobInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyJobInput>;
};


export type QueryLapArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLapSequenceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLapSequenceTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLapSequenceTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyLapSequenceTemplateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLapSequenceTemplateInput>;
};


export type QueryLapSequencesArgs = {
  filter?: InputMaybe<FilterFindManyLapSequenceInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLapSequenceInput>;
};


export type QueryLapsArgs = {
  filter?: InputMaybe<FilterFindManyLapInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLapInput>;
};


export type QueryLapsManyArgs = {
  filter?: InputMaybe<FilterFindManyLapInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLapInput>;
};


export type QueryLocationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLocationsArgs = {
  filter?: InputMaybe<FilterFindManyLocationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLocationInput>;
};


export type QueryLogArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLogsArgs = {
  filter?: InputMaybe<FilterFindManyLogInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLogInput>;
};


export type QueryManufacturerArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryManufacturersArgs = {
  filter?: InputMaybe<FilterFindManyManufacturerInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyManufacturerInput>;
};


export type QueryOneTimingWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryOneTimingWeatherServiceConfigsArgs = {
  filter?: InputMaybe<FilterFindManyOneTimingWeatherServiceConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOneTimingWeatherServiceConfigInput>;
};


export type QueryOneTimingWeatherServiceLogsArgs = {
  numLines?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderRunSheetsForForwardPropagationArgs = {
  runSheetID: Scalars['MongoID']['input'];
};


export type QueryPackageArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPackagesArgs = {
  filter?: InputMaybe<FilterFindManyPackageInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPackageInput>;
};


export type QueryPartArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPartInstanceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPartInstancesArgs = {
  filter?: InputMaybe<FilterFindManyPartInstanceInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPartInstanceInput>;
};


export type QueryPartReturnTrackingHistoryFullandSnapshotArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  partID: Scalars['MongoID']['input'];
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};


export type QueryPartTrackingArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  partID: Scalars['MongoID']['input'];
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};


export type QueryPartsArgs = {
  filter?: InputMaybe<FilterFindManyPartInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPartInput>;
};


export type QueryPartsAdvancedFilterArgs = {
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibleEventTypes?: InputMaybe<Array<InputMaybe<EnumPartEligibleEventTypes>>>;
  filter?: InputMaybe<FilterFindManyPartInput>;
  hideDummyParts?: InputMaybe<Scalars['Boolean']['input']>;
  locationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  manufacturerIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  manufacturerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  mileageMax?: InputMaybe<Scalars['Float']['input']>;
  mileageMin?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  partReference?: InputMaybe<Scalars['String']['input']>;
  partType?: InputMaybe<Scalars['MongoID']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  sort?: InputMaybe<SortFindManyPartInput>;
  specName?: InputMaybe<Scalars['String']['input']>;
  specTypes?: InputMaybe<Array<InputMaybe<EnumSpecificationType>>>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumPartStatusActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPartsForChassisSpecArgs = {
  chassisSpecID: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterFindManyPartInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partActive?: InputMaybe<Scalars['Boolean']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortFindManyPartInput>;
  specName?: InputMaybe<Scalars['String']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumPartStatusID?: InputMaybe<Scalars['MongoID']['input']>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryPartsInEventArgs = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID: Scalars['MongoID']['input'];
};


export type QueryPeopleArgs = {
  filter?: InputMaybe<FilterFindManyPersonInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPersonInput>;
};


export type QueryPersonArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPlotPageConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPlotPageConfigsArgs = {
  filter?: InputMaybe<FilterFindManyPlotPageConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPlotPageConfigInput>;
};


export type QueryPointsSystemArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPointsSystemsArgs = {
  filter?: InputMaybe<FilterFindManyPointsSystemInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPointsSystemInput>;
};


export type QueryProjectArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProjectsArgs = {
  filter?: InputMaybe<FilterFindManyProjectInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProjectInput>;
};


export type QueryQualityCheckArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryQualityCheckActionArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryQualityChecksArgs = {
  filter?: InputMaybe<FilterFindManyQualityCheckInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyQualityCheckInput>;
};


export type QueryQualityChecksActionArgs = {
  filter?: InputMaybe<FilterFindManyQualityCheckActionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyQualityCheckActionInput>;
};


export type QueryRaceSeriesArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRaceSeriesAllArgs = {
  filter?: InputMaybe<FilterFindManyRaceSeriesInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRaceSeriesInput>;
};


export type QueryRadioMessageArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRadioMessagesArgs = {
  filter?: InputMaybe<FilterFindManyRadioMessageInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRadioMessageInput>;
};


export type QueryReportNotesArgs = {
  eventID: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterFindOneReportNoteInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneReportNoteInput>;
};


export type QueryReportNotesTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyReportNotesTemplateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyReportNotesTemplateInput>;
};


export type QueryReportTemplateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryReportTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyReportTemplateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyReportTemplateInput>;
};


export type QueryRunPlanArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRunPlansArgs = {
  filter?: InputMaybe<FilterFindManyRunPlanInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRunPlanInput>;
};


export type QueryRunSheetArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRunSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRunSheetStylesArgs = {
  filter?: InputMaybe<FilterFindManyRunSheetStyleInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRunSheetStyleInput>;
};


export type QueryRunSheetsArgs = {
  filter?: InputMaybe<FilterFindManyRunSheetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRunSheetInput>;
};


export type QueryRunSheetsByAssociatedKpiFilesArgs = {
  kpiFileNames: Array<Scalars['String']['input']>;
};


export type QueryRunSheetsManyArgs = {
  filter?: InputMaybe<FilterFindManyRunSheetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRunSheetInput>;
};


export type QuerySeasonArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySeasonsArgs = {
  filter?: InputMaybe<FilterFindManySeasonInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySeasonInput>;
};


export type QuerySessionArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySessionDebriefArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySessionDebriefsArgs = {
  filter?: InputMaybe<FilterFindManyTemplateSessionDebriefInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTemplateSessionDebriefInput>;
};


export type QuerySessionsArgs = {
  filter?: InputMaybe<FilterFindManySessionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySessionInput>;
};


export type QuerySetupOverviewConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySetupOverviewConfigsArgs = {
  filter?: InputMaybe<FilterFindManySetupOverviewConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySetupOverviewConfigInput>;
};


export type QuerySetupSheetStyleArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySetupSheetStylesArgs = {
  filter?: InputMaybe<FilterFindManySetupSheetStyleInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySetupSheetStyleInput>;
};


export type QuerySimRequestArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySimRequestsArgs = {
  filter?: InputMaybe<FilterFindManySimRequestInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySimRequestInput>;
};


export type QuerySimResultArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySimResultsArgs = {
  filter?: InputMaybe<FilterFindManySimResultInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySimResultInput>;
};


export type QuerySimulationDriveFileArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySimulationDriveFilesArgs = {
  filter?: InputMaybe<FilterFindManySimulationDriveFileInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySimulationDriveFileInput>;
};


export type QuerySkidPlateArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySkidPlatesArgs = {
  filter?: InputMaybe<FilterFindManySkidPlateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySkidPlateInput>;
};


export type QuerySpecificationArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySpecificationBaseArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySpecificationGroupArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySpecificationsArgs = {
  filter?: InputMaybe<FilterFindManySpecificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySpecificationInput>;
};


export type QuerySsoProviderArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySsoProvidersArgs = {
  filter?: InputMaybe<FilterFindManySsoProviderInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySsoProviderInput>;
};


export type QueryTagArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTagsArgs = {
  filter?: InputMaybe<FilterFindManyTagInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTagInput>;
};


export type QueryTeamArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTeamsArgs = {
  filter?: InputMaybe<FilterFindManyTeamInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTeamInput>;
};


export type QueryTemplateJobListArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTemplateJobListsArgs = {
  filter?: InputMaybe<FilterFindManyTemplateJobListInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTemplateJobListInput>;
};


export type QueryTimeSheetEntriesArgs = {
  filter?: InputMaybe<FilterFindManyTimeSheetEntryInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTimeSheetEntryInput>;
};


export type QueryTimeSheetEntryArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTimingServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTimingServiceConfigsArgs = {
  filter?: InputMaybe<FilterFindManyTimingServiceConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTimingServiceConfigInput>;
};


export type QueryTrackArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackLayoutArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackLayoutsArgs = {
  filter?: InputMaybe<FilterFindManyTrackLayoutInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackLayoutInput>;
};


export type QueryTrackableArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackablesArgs = {
  filter?: InputMaybe<FilterFindManyTrackableInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackableInput>;
};


export type QueryTrackingItemArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingItemNamesForSessionsArgs = {
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type QueryTrackingItemsArgs = {
  filter?: InputMaybe<FilterFindManyTrackingItemInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingItemInput>;
};


export type QueryTrackingMeasurementArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingMeasurementRecordArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingMeasurementRecordsArgs = {
  filter?: InputMaybe<FilterFindManyTrackingMeasurementRecordInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingMeasurementRecordInput>;
};


export type QueryTrackingMeasurementsArgs = {
  filter?: InputMaybe<FilterFindManyTrackingMeasurementInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingMeasurementInput>;
};


export type QueryTrackingRecordArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingRecordsArgs = {
  filter?: InputMaybe<FilterFindManyTrackingRecordInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingRecordInput>;
};


export type QueryTrackingSourceArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingSourceAliasArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTrackingSourceAliasesArgs = {
  filter?: InputMaybe<FilterFindManyTrackingSourceAliasInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingSourceAliasInput>;
};


export type QueryTrackingSourcesArgs = {
  filter?: InputMaybe<FilterFindManyTrackingSourceInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackingSourceInput>;
};


export type QueryTracksArgs = {
  filter?: InputMaybe<FilterFindManyTrackInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTrackInput>;
};


export type QueryTyreArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTyreMileageAtSessionStartArgs = {
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};


export type QueryTyreMileageGraphArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
};


export type QueryTyrePressureSheetArgs = {
  contestantID: Scalars['MongoID']['input'];
  eventID: Scalars['MongoID']['input'];
};


export type QueryTyreSetArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTyreSetsArgs = {
  filter?: InputMaybe<FilterFindManyTyreSetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTyreSetInput>;
};


export type QueryTyreWearArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTyreWearsArgs = {
  filter?: InputMaybe<FilterFindManyTyreWearInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTyreWearInput>;
};


export type QueryTyresArgs = {
  filter?: InputMaybe<FilterFindManyTyreInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTyreInput>;
};


export type QueryUserEnumArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryUserEnumsArgs = {
  filter?: InputMaybe<FilterFindManyUserEnumInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserEnumInput>;
};


export type QueryWeatherArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWeatherAllArgs = {
  filter?: InputMaybe<FilterFindManyWeatherInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWeatherInput>;
};


export type QueryWeatherServiceConfigArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWeatherServiceConfigsArgs = {
  filter?: InputMaybe<FilterFindManyWeatherServiceConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWeatherServiceConfigInput>;
};

export type RaceSeries = {
  _id: Scalars['MongoID']['output'];
  assignedSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignedSetups: Array<CarSetup>;
  defaultJobListIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  defaultJobLists: Array<TemplateJobList>;
  defaultRunSheetStyle?: Maybe<RunSheetStyle>;
  defaultRunSheetStyleID?: Maybe<Scalars['MongoID']['output']>;
  driversPerCar?: Maybe<EnumRaceSeriesDriversPerCar>;
  groupName?: Maybe<Scalars['String']['output']>;
  lapTypeConfig?: Maybe<RaceSeriesLapTypeConfig>;
  name: Scalars['String']['output'];
  seasonIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  seasons: Array<Season>;
  shortName?: Maybe<Scalars['String']['output']>;
  sortingIndex?: Maybe<Scalars['Float']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
};

export type RaceSeriesLapTypeConfig = {
  ATTACK?: Maybe<RaceSeriesLapTypeEntry>;
  COOL?: Maybe<RaceSeriesLapTypeEntry>;
  FCY?: Maybe<RaceSeriesLapTypeEntry>;
  IN?: Maybe<RaceSeriesLapTypeEntry>;
  OUT?: Maybe<RaceSeriesLapTypeEntry>;
  OUTIN?: Maybe<RaceSeriesLapTypeEntry>;
  PITLANE?: Maybe<RaceSeriesLapTypeEntry>;
  PREP?: Maybe<RaceSeriesLapTypeEntry>;
  PUSH?: Maybe<RaceSeriesLapTypeEntry>;
  QUALI?: Maybe<RaceSeriesLapTypeEntry>;
  SAFETYCAR?: Maybe<RaceSeriesLapTypeEntry>;
  SHAKEDOWN?: Maybe<RaceSeriesLapTypeEntry>;
  SLOW?: Maybe<RaceSeriesLapTypeEntry>;
  TARGET?: Maybe<RaceSeriesLapTypeEntry>;
  TOGRID?: Maybe<RaceSeriesLapTypeEntry>;
  TOPADDOCK?: Maybe<RaceSeriesLapTypeEntry>;
  TOPITS?: Maybe<RaceSeriesLapTypeEntry>;
  UNFINISHED?: Maybe<RaceSeriesLapTypeEntry>;
};

export type RaceSeriesLapTypeConfigInput = {
  ATTACK?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  COOL?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  FCY?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  IN?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  OUT?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  OUTIN?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  PITLANE?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  PREP?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  PUSH?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  QUALI?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  SAFETYCAR?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  SHAKEDOWN?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  SLOW?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  TARGET?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  TOGRID?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  TOPADDOCK?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  TOPITS?: InputMaybe<RaceSeriesLapTypeEntryInput>;
  UNFINISHED?: InputMaybe<RaceSeriesLapTypeEntryInput>;
};

export type RaceSeriesLapTypeEntry = {
  displayString: Scalars['String']['output'];
  lapTypeColor?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type RaceSeriesLapTypeEntryInput = {
  displayString: Scalars['String']['input'];
  lapTypeColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** List of items with pagination. */
export type RaceSeriesPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RaceSeries>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type RadioMessage = {
  _id: Scalars['MongoID']['output'];
  /** Time at which the audio message arrived in the queue for transcribing. */
  arrivedInQueueAt?: Maybe<Scalars['Date']['output']>;
  /** This is currently a path to a file on the Transcribble server, but it should eventually be a URL to a file in something like an S3 bucket instead. */
  audioPath: Scalars['String']['output'];
  contestant?: Maybe<Contestant>;
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  driver?: Maybe<Person>;
  driverID?: Maybe<Scalars['MongoID']['output']>;
  important: Scalars['Boolean']['output'];
  /** Length of the audio message in seconds. */
  length?: Maybe<Scalars['Float']['output']>;
  session?: Maybe<Session>;
  sessionID: Scalars['MongoID']['output'];
  /** Time at which the audio message was taken by a transcription service. */
  takenByTranscriberAt?: Maybe<Scalars['Date']['output']>;
  /** The text of the message, as transcribed by Transcribble. */
  text?: Maybe<Scalars['String']['output']>;
  /** Time at which this message began recording audio. */
  timestamp?: Maybe<Scalars['Date']['output']>;
  transcribed: Scalars['Boolean']['output'];
  /** Time at which the audio message was finished initial transcribing. */
  transcribedAt?: Maybe<Scalars['Date']['output']>;
  transcriptionEdited: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type RadioMessagePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RadioMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Ratio = {
  /** % */
  percent: Scalars['Float']['output'];
  /** 0 = 0%, 1 = 100%, 1.5 = 150% */
  ratio: Scalars['Float']['output'];
};

export type RatioInput = {
  /** % */
  percent?: InputMaybe<Scalars['Float']['input']>;
  /** 0 = 0%, 1 = 100%, 1.5 = 150% */
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type RatioUnitField = {
  unit: EnumRatioUnit;
};

export type RegeneratePartTrackingHistory = {
  updatedRecords?: Maybe<Scalars['Int']['output']>;
};

export type RegulationSet = {
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  hRideFrontMin?: Maybe<Scalars['Float']['output']>;
  hRideRearMin?: Maybe<Scalars['Float']['output']>;
  massDistRunningMax?: Maybe<Scalars['Float']['output']>;
  massDistRunningMin?: Maybe<Scalars['Float']['output']>;
  massDistStaticMax?: Maybe<Scalars['Float']['output']>;
  massDistStaticMin?: Maybe<Scalars['Float']['output']>;
  massMin?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type RegulationSetInput = {
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  hRideFrontMin?: InputMaybe<Scalars['Float']['input']>;
  hRideRearMin?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMax?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMin?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMax?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMin?: InputMaybe<Scalars['Float']['input']>;
  massMin?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type ReleaseChassisSpecResult = {
  iteratedChassisSpec?: Maybe<ChassisSpec>;
  releasedChassisSpec?: Maybe<ChassisSpec>;
};

export type RemoveByIdAssemblyPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Assembly>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdAssemblyTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<AssemblyTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdBestValuesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<BestValues>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdBopPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Bop>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdBuildSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<BuildSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCalculationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Calculation>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCarDataServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<CarDataServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCarSetupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<CarSetup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdChassisMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ChassisMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdChassisPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Chassis>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdContestantPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Contestant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdDepartmentPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Department>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdDynoConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<DynoConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdEventPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdFlexLayoutConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<FlexLayoutConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdIssuePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Issue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdJobPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Job>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLapPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Lap>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLapSequencePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<LapSequence>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLapSequenceTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<LapSequenceTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLocationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Location>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLogPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Log>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdManufacturerPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Manufacturer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdOneTimingWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<OneTimingWeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPackagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Package>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPartInstancePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<PartInstance>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPartPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Part>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPersonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Person>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPlotPageConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<PlotPageConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPointsSystemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<PointsSystem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdProjectPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Project>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdQualityCheckActionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<QualityCheckAction>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdQualityCheckPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<QualityCheck>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRaceSeriesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<RaceSeries>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRadioMessagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<RadioMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdReportNotesTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ReportNotesTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdReportTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ReportTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRunPlanPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<RunPlan>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRunSheetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<RunSheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRunSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<RunSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSandboxUnitsPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SandboxUnits>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSeasonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Season>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSessionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Session>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSetupOverviewConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SetupOverviewConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSetupSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SetupSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSimRequestPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SimRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSimResultPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SimResult>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSimulationDriveFilePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SimulationDriveFile>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSkidPlatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SkidPlate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSpecificationGroupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SpecificationGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSpecificationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Specification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSsoProviderPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<SsoProvider>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTagPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTeamPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Team>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTemplateJobListPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TemplateJobList>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTemplateSessionDebriefPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TemplateSessionDebrief>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTimeSheetEntryPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TimeSheetEntry>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTimingServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TimingServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackLayoutPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackLayout>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Track>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackablePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Trackable>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingItemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingMeasurementRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingMeasurementRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingSourceAliasPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingSourceAlias>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTrackingSourcePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TrackingSource>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTyrePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Tyre>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTyreSetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TyreSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTyreWearPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TyreWear>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdUserEnumPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<UserEnum>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdWeatherPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Weather>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<WeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveCommentResult = {
  comment?: Maybe<Comment>;
  recordId: Scalars['MongoID']['output'];
};

export type RemoveDeadTrackingRecords = {
  deadRecords?: Maybe<Scalars['Int']['output']>;
  deletedCount?: Maybe<Scalars['Int']['output']>;
  invalidAssemblies?: Maybe<Scalars['Int']['output']>;
  invalidChassisAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveEventContestantResult = {
  success: Scalars['Boolean']['output'];
};

export type RemoveManyEventContestantsResult = {
  success: Scalars['Boolean']['output'];
};

export type RemoveManyJobsResult = {
  deletedCount: Scalars['Int']['output'];
};

export type RemoveManySimRequestPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type RemoveManySimResultPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type RemoveManyTimeSheetEntriesResult = {
  deletedCount: Scalars['Int']['output'];
};

export type RemoveManyTyreSetsResult = {
  deletedCount: Scalars['Int']['output'];
};

export type RemoveManyTyresResult = {
  deletedCount: Scalars['Int']['output'];
};

export type RemoveTyreFromEventContestantResult = {
  changed?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveTyreSetsFromContestantResult = {
  contestant?: Maybe<Contestant>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveTyreSetsFromEventContestantResult = {
  changed?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveTyresFromContestantResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemovedRunSheet = {
  _id?: Maybe<Scalars['MongoID']['output']>;
};

export type RenameSpecificationResult = {
  success: Scalars['Boolean']['output'];
};

export type ReportNote = {
  _id: Scalars['MongoID']['output'];
  eventID?: Maybe<Scalars['MongoID']['output']>;
  pageAppendix?: Maybe<ReportNotePageAppendix>;
  pageOverview?: Maybe<ReportNotePageOverview>;
  pageParts?: Maybe<ReportNotePageParts>;
  pageRunPlan?: Maybe<ReportNotePageRunPlan>;
  pageSession?: Maybe<ReportNotePageSession>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotePageAppendix = {
  notes?: Maybe<Array<Maybe<ReportNotePageAppendixNotes>>>;
};

export type ReportNotePageAppendixNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotePageAppendixNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotePageOverview = {
  notes?: Maybe<Array<Maybe<ReportNotePageOverviewNotes>>>;
};

export type ReportNotePageOverviewNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotePageOverviewNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotePageParts = {
  notes?: Maybe<Array<Maybe<ReportNotePagePartsNotes>>>;
};

export type ReportNotePagePartsNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotePagePartsNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotePageRunPlan = {
  notes?: Maybe<Array<Maybe<ReportNotePageRunPlanNotes>>>;
};

export type ReportNotePageRunPlanNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotePageRunPlanNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotePageSession = {
  notes?: Maybe<Array<Maybe<ReportNotePageSessionNotes>>>;
};

export type ReportNotePageSessionNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotePageSessionNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplate = {
  _id: Scalars['MongoID']['output'];
  pageAppendix?: Maybe<ReportNotesTemplatePageAppendix>;
  pageOverview?: Maybe<ReportNotesTemplatePageOverview>;
  pageParts?: Maybe<ReportNotesTemplatePageParts>;
  pageRunPlan?: Maybe<ReportNotesTemplatePageRunPlan>;
  pageSession?: Maybe<ReportNotesTemplatePageSession>;
  title: Scalars['String']['output'];
};

export type ReportNotesTemplatePageAppendix = {
  notes?: Maybe<Array<Maybe<ReportNotesTemplatePageAppendixNotes>>>;
};

export type ReportNotesTemplatePageAppendixInput = {
  notes?: InputMaybe<Array<InputMaybe<ReportNotesTemplatePageAppendixNotesInput>>>;
};

export type ReportNotesTemplatePageAppendixNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotesTemplatePageAppendixNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplatePageAppendixNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageAppendixNotesMode>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportNotesTemplatePageOverview = {
  notes?: Maybe<Array<Maybe<ReportNotesTemplatePageOverviewNotes>>>;
};

export type ReportNotesTemplatePageOverviewInput = {
  notes?: InputMaybe<Array<InputMaybe<ReportNotesTemplatePageOverviewNotesInput>>>;
};

export type ReportNotesTemplatePageOverviewNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotesTemplatePageOverviewNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplatePageOverviewNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageOverviewNotesMode>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportNotesTemplatePageParts = {
  notes?: Maybe<Array<Maybe<ReportNotesTemplatePagePartsNotes>>>;
};

export type ReportNotesTemplatePagePartsInput = {
  notes?: InputMaybe<Array<InputMaybe<ReportNotesTemplatePagePartsNotesInput>>>;
};

export type ReportNotesTemplatePagePartsNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotesTemplatePagePartsNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplatePagePartsNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePagePartsNotesMode>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportNotesTemplatePageRunPlan = {
  notes?: Maybe<Array<Maybe<ReportNotesTemplatePageRunPlanNotes>>>;
};

export type ReportNotesTemplatePageRunPlanInput = {
  notes?: InputMaybe<Array<InputMaybe<ReportNotesTemplatePageRunPlanNotesInput>>>;
};

export type ReportNotesTemplatePageRunPlanNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotesTemplatePageRunPlanNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplatePageRunPlanNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageRunPlanNotesMode>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportNotesTemplatePageSession = {
  notes?: Maybe<Array<Maybe<ReportNotesTemplatePageSessionNotes>>>;
};

export type ReportNotesTemplatePageSessionInput = {
  notes?: InputMaybe<Array<InputMaybe<ReportNotesTemplatePageSessionNotesInput>>>;
};

export type ReportNotesTemplatePageSessionNotes = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumReportNotesTemplatePageSessionNotesMode>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportNotesTemplatePageSessionNotesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumReportNotesTemplatePageSessionNotesMode>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplate = {
  _id: Scalars['MongoID']['output'];
  appendix?: Maybe<ReportTemplateAppendix>;
  bop?: Maybe<ReportTemplateBop>;
  carSetup?: Maybe<ReportTemplateCarSetup>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** File format based off a filename pattern, e.g. {raceSeries} {season} {event} */
  downloadFilenameFormat?: Maybe<Scalars['String']['output']>;
  excludedNoteIDs?: Maybe<ReportTemplateExcludedNoteIDs>;
  issues?: Maybe<ReportTemplateIssues>;
  kpi?: Maybe<ReportTemplateKpi>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overview?: Maybe<ReportTemplateOverview>;
  parts?: Maybe<ReportTemplateParts>;
  reportTitle?: Maybe<Scalars['String']['output']>;
  runInfo?: Maybe<ReportTemplateRunInfo>;
  runPlan?: Maybe<ReportTemplateRunPlan>;
  sessions?: Maybe<ReportTemplateSessions>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weather?: Maybe<ReportTemplateWeather>;
};

export type ReportTemplateAppendix = {
  active?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateAppendixInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportTemplateBop = {
  active?: Maybe<Scalars['Boolean']['output']>;
  bopFileOnly?: Maybe<Scalars['Boolean']['output']>;
  /** JSON configuration or zod? */
  layout?: Maybe<Scalars['JSON']['output']>;
  /** Either { source: 'current-event' } or { source: 'explicit', sessionIds: string[] } */
  selectedSessions?: Maybe<Scalars['JSON']['output']>;
};

export type ReportTemplateBopInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bopFileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  /** Either { source: 'current-event' } or { source: 'explicit', sessionIds: string[] } */
  selectedSessions?: InputMaybe<Scalars['JSON']['input']>;
};

export type ReportTemplateCarSetup = {
  active?: Maybe<Scalars['Boolean']['output']>;
  /** JSON configuration or zod? */
  tableConfig?: Maybe<Scalars['JSON']['output']>;
};

export type ReportTemplateCarSetupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type ReportTemplateExcludedNoteIDs = {
  pageAppendix?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageOverview?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageParts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageRunPlan?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageSession?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ReportTemplateExcludedNoteIDsInput = {
  pageAppendix?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageOverview?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageParts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageRunPlan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageSession?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReportTemplateIssues = {
  active?: Maybe<Scalars['Boolean']['output']>;
  columns?: Maybe<Array<Maybe<ReportTemplateIssuesColumns>>>;
  groupBy?: Maybe<EnumReportTemplateIssuesGroupBy>;
};

export type ReportTemplateIssuesColumns = {
  field: EnumReportTemplateIssuesColumnsField;
  label?: Maybe<Scalars['String']['output']>;
};

export type ReportTemplateIssuesColumnsInput = {
  field: EnumReportTemplateIssuesColumnsField;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplateIssuesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ReportTemplateIssuesColumnsInput>>>;
  groupBy?: InputMaybe<EnumReportTemplateIssuesGroupBy>;
};

export type ReportTemplateKpi = {
  active?: Maybe<Scalars['Boolean']['output']>;
  /** JSON configuration or zod? */
  layout?: Maybe<Scalars['JSON']['output']>;
  showSessionLines?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateKpiInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  showSessionLines?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportTemplateOverview = {
  active?: Maybe<Scalars['Boolean']['output']>;
  noteTitle?: Maybe<Scalars['String']['output']>;
  showFuelConsumption?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateOverviewInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showFuelConsumption?: InputMaybe<Scalars['Boolean']['input']>;
};

/** List of items with pagination. */
export type ReportTemplatePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ReportTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ReportTemplateParts = {
  active?: Maybe<Scalars['Boolean']['output']>;
  groupPartsByChassisAssemblyName?: Maybe<Scalars['Boolean']['output']>;
  noteTitle?: Maybe<Scalars['String']['output']>;
  tableColumns?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
};

export type ReportTemplatePartsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  groupPartsByChassisAssemblyName?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  tableColumns?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type ReportTemplateRunInfo = {
  active?: Maybe<Scalars['Boolean']['output']>;
  columns?: Maybe<Array<Maybe<ReportTemplateRunInfoColumns>>>;
};

export type ReportTemplateRunInfoColumns = {
  field: EnumReportTemplateRunInfoColumnsField;
  label?: Maybe<Scalars['String']['output']>;
};

export type ReportTemplateRunInfoColumnsInput = {
  field: EnumReportTemplateRunInfoColumnsField;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplateRunInfoInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ReportTemplateRunInfoColumnsInput>>>;
};

export type ReportTemplateRunPlan = {
  active?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateRunPlanInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportTemplateSessions = {
  active?: Maybe<Scalars['Boolean']['output']>;
  displayedTimeZones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  noteTitle?: Maybe<Scalars['String']['output']>;
  showTimingOverview?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateSessionsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  displayedTimeZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showTimingOverview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportTemplateWeather = {
  active?: Maybe<Scalars['Boolean']['output']>;
  splitDataByDays?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportTemplateWeatherInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  splitDataByDays?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResetPasswordResult = {
  password: Scalars['String']['output'];
};

export type ResetTyrePressureSheetResult = {
  success: Scalars['Boolean']['output'];
};

export type RestoreBackupResult = {
  success: Scalars['Boolean']['output'];
};

export type RunBrake = {
  /** Brake temperature after the run */
  TBrakePostRun?: Maybe<Scalars['Float']['output']>;
  /** Brake temperature before the run */
  TBrakePreRun?: Maybe<Scalars['Float']['output']>;
  hBrakeDiscPreRun?: Maybe<Scalars['Float']['output']>;
  /** Format is `Record<string, number>`, e.g. `{ "1FL": 1.2, "2": 1.3 }` */
  thicknessMeasurements?: Maybe<Scalars['JSON']['output']>;
};

export type RunBrakeInput = {
  /** Brake temperature after the run */
  TBrakePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Brake temperature before the run */
  TBrakePreRun?: InputMaybe<Scalars['Float']['input']>;
  hBrakeDiscPreRun?: InputMaybe<Scalars['Float']['input']>;
  /** Format is `Record<string, number>`, e.g. `{ "1FL": 1.2, "2": 1.3 }` */
  thicknessMeasurements?: InputMaybe<Scalars['JSON']['input']>;
};

export type RunEnergy = {
  /** Fuel/Energy/SoC required for ATTACK Lap */
  ATTACK?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for COOL Lap */
  COOL?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for FCY Lap */
  FCY?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for IN Lap */
  IN?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for OUT Lap */
  OUT?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for OUTIN Lap */
  OUTIN?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for PITLANE Lap */
  PITLANE?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for PREP Lap */
  PREP?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for PUSH Lap */
  PUSH?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for QUALI Lap */
  QUALI?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for SAFETYCAR Lap */
  SAFETYCAR?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for SHAKEDOWN Lap */
  SHAKEDOWN?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for SLOW Lap */
  SLOW?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for TARGET Lap */
  TARGET?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for TOGRID Lap */
  TOGRID?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for TOPADDOCK Lap */
  TOPADDOCK?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for TOPITS Lap */
  TOPITS?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for UNFINISHED Lap */
  UNFINISHED?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an attack mode lap */
  attackLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a cooldown lap */
  coolLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a full course yellow lap */
  fullCourseYellowLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an in lap */
  inLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an out-in lap */
  outInLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an out lap */
  outLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a pitlane lap */
  pitlaneLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a preparation/warmup lap */
  prepLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a push lap */
  pushLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a qualifying lap */
  qualiLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a safety car lap */
  safetyCarLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a shakedown lap */
  shakedownLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a slow lap */
  slowLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an target lap */
  targetLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a to-grid lap */
  toGridLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for a to-pits lap */
  toPitsLap?: Maybe<Scalars['Float']['output']>;
  /** Fuel/Energy/SoC required for an unfinished lap */
  unfinishedLap?: Maybe<Scalars['Float']['output']>;
};

/** Run energy field labels mapped to their display names. Null or unset fields are not displayed. */
export type RunEnergyFieldLabels = {
  ATTACK?: Maybe<Scalars['String']['output']>;
  COOL?: Maybe<Scalars['String']['output']>;
  FCY?: Maybe<Scalars['String']['output']>;
  IN?: Maybe<Scalars['String']['output']>;
  OUT?: Maybe<Scalars['String']['output']>;
  OUTIN?: Maybe<Scalars['String']['output']>;
  PITLANE?: Maybe<Scalars['String']['output']>;
  PREP?: Maybe<Scalars['String']['output']>;
  PUSH?: Maybe<Scalars['String']['output']>;
  QUALI?: Maybe<Scalars['String']['output']>;
  SAFETYCAR?: Maybe<Scalars['String']['output']>;
  SHAKEDOWN?: Maybe<Scalars['String']['output']>;
  SLOW?: Maybe<Scalars['String']['output']>;
  TARGET?: Maybe<Scalars['String']['output']>;
  TOGRID?: Maybe<Scalars['String']['output']>;
  TOPADDOCK?: Maybe<Scalars['String']['output']>;
  TOPITS?: Maybe<Scalars['String']['output']>;
  UNFINISHED?: Maybe<Scalars['String']['output']>;
  attackLap?: Maybe<Scalars['String']['output']>;
  coolLap?: Maybe<Scalars['String']['output']>;
  fullCourseYellowLap?: Maybe<Scalars['String']['output']>;
  inLap?: Maybe<Scalars['String']['output']>;
  outInLap?: Maybe<Scalars['String']['output']>;
  outLap?: Maybe<Scalars['String']['output']>;
  pitlaneLap?: Maybe<Scalars['String']['output']>;
  prepLap?: Maybe<Scalars['String']['output']>;
  pushLap?: Maybe<Scalars['String']['output']>;
  qualiLap?: Maybe<Scalars['String']['output']>;
  safetyCarLap?: Maybe<Scalars['String']['output']>;
  shakedownLap?: Maybe<Scalars['String']['output']>;
  slowLap?: Maybe<Scalars['String']['output']>;
  targetLap?: Maybe<Scalars['String']['output']>;
  toGridLap?: Maybe<Scalars['String']['output']>;
  toPitsLap?: Maybe<Scalars['String']['output']>;
  unfinishedLap?: Maybe<Scalars['String']['output']>;
};

/** Run energy field labels mapped to their display names. Null or unset fields are not displayed. */
export type RunEnergyFieldLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
  attackLap?: InputMaybe<Scalars['String']['input']>;
  coolLap?: InputMaybe<Scalars['String']['input']>;
  fullCourseYellowLap?: InputMaybe<Scalars['String']['input']>;
  inLap?: InputMaybe<Scalars['String']['input']>;
  outInLap?: InputMaybe<Scalars['String']['input']>;
  outLap?: InputMaybe<Scalars['String']['input']>;
  pitlaneLap?: InputMaybe<Scalars['String']['input']>;
  prepLap?: InputMaybe<Scalars['String']['input']>;
  pushLap?: InputMaybe<Scalars['String']['input']>;
  qualiLap?: InputMaybe<Scalars['String']['input']>;
  safetyCarLap?: InputMaybe<Scalars['String']['input']>;
  shakedownLap?: InputMaybe<Scalars['String']['input']>;
  slowLap?: InputMaybe<Scalars['String']['input']>;
  targetLap?: InputMaybe<Scalars['String']['input']>;
  toGridLap?: InputMaybe<Scalars['String']['input']>;
  toPitsLap?: InputMaybe<Scalars['String']['input']>;
  unfinishedLap?: InputMaybe<Scalars['String']['input']>;
};

export type RunEnergyInput = {
  /** Fuel/Energy/SoC required for ATTACK Lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for COOL Lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for FCY Lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for IN Lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUT Lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUTIN Lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PITLANE Lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PREP Lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PUSH Lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for QUALI Lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SAFETYCAR Lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SHAKEDOWN Lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SLOW Lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TARGET Lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOGRID Lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPADDOCK Lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPITS Lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for UNFINISHED Lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an attack mode lap */
  attackLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a cooldown lap */
  coolLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a full course yellow lap */
  fullCourseYellowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an in lap */
  inLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out-in lap */
  outInLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out lap */
  outLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a pitlane lap */
  pitlaneLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a preparation/warmup lap */
  prepLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a push lap */
  pushLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a qualifying lap */
  qualiLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a safety car lap */
  safetyCarLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a shakedown lap */
  shakedownLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a slow lap */
  slowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an target lap */
  targetLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-grid lap */
  toGridLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-pits lap */
  toPitsLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an unfinished lap */
  unfinishedLap?: InputMaybe<Scalars['Float']['input']>;
};

export type RunKpiTableBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  runKPIRows?: Maybe<Array<Maybe<RunKpiTableRow>>>;
  runKPITable?: Maybe<Array<Maybe<GenericRunSheetStyleBlockRunKpiTable>>>;
  /** @deprecated Use other fields to style the block instead */
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type RunKpiTableRow = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Default background color for the cell/s. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Number of decimal places to display. */
  decimals?: Maybe<Scalars['Int']['output']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell, an array of two numbers for a double cell, and so on. */
  gain?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Field names to try pull data from in `runKPI`, like `"vMax"`. Use an array of one key for a single cell, an array of two keys for a double cell, and so on. */
  keys: Array<Maybe<Scalars['String']['output']>>;
  label: Scalars['String']['output'];
  lowerLimit?: Maybe<ValueLimit>;
  /** Text to put as a unit for values. */
  unit?: Maybe<Scalars['String']['output']>;
  upperLimit?: Maybe<ValueLimit>;
};

export type RunKpiTableRowField = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Default background color for the cell/s. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Number of decimal places to display. */
  decimals?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lowerLimit?: Maybe<ValueLimit>;
  unit?: Maybe<EnumDisplayUnit>;
  upperLimit?: Maybe<ValueLimit>;
};

export type RunKpiTableRowFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<ValueLimitInput>;
  unit?: InputMaybe<EnumDisplayUnit>;
  upperLimit?: InputMaybe<ValueLimitInput>;
};

export type RunKpiTableRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell, an array of two numbers for a double cell, and so on. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to try pull data from in `runKPI`, like `"vMax"`. Use an array of one key for a single cell, an array of two keys for a double cell, and so on. */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  label: Scalars['String']['input'];
  lowerLimit?: InputMaybe<ValueLimitInput>;
  /** Text to put as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
  upperLimit?: InputMaybe<ValueLimitInput>;
};

export type RunLapTime = {
  ATTACK?: Maybe<Scalars['Float']['output']>;
  COOL?: Maybe<Scalars['Float']['output']>;
  FCY?: Maybe<Scalars['Float']['output']>;
  IN?: Maybe<Scalars['Float']['output']>;
  OUT?: Maybe<Scalars['Float']['output']>;
  OUTIN?: Maybe<Scalars['Float']['output']>;
  PITLANE?: Maybe<Scalars['Float']['output']>;
  PREP?: Maybe<Scalars['Float']['output']>;
  PUSH?: Maybe<Scalars['Float']['output']>;
  QUALI?: Maybe<Scalars['Float']['output']>;
  SAFETYCAR?: Maybe<Scalars['Float']['output']>;
  SHAKEDOWN?: Maybe<Scalars['Float']['output']>;
  SLOW?: Maybe<Scalars['Float']['output']>;
  TARGET?: Maybe<Scalars['Float']['output']>;
  TOGRID?: Maybe<Scalars['Float']['output']>;
  TOPADDOCK?: Maybe<Scalars['Float']['output']>;
  TOPITS?: Maybe<Scalars['Float']['output']>;
  UNFINISHED?: Maybe<Scalars['Float']['output']>;
};

export type RunLapTimeInput = {
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  COOL?: InputMaybe<Scalars['Float']['input']>;
  FCY?: InputMaybe<Scalars['Float']['input']>;
  IN?: InputMaybe<Scalars['Float']['input']>;
  OUT?: InputMaybe<Scalars['Float']['input']>;
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  PREP?: InputMaybe<Scalars['Float']['input']>;
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
};

export type RunPlan = {
  PUEngineerIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  PUEngineers: Array<Person>;
  _id: Scalars['MongoID']['output'];
  /** Amount of time in seconds to increment SOC by 1% at each rSOC value. Must have same length as `chargeTimeSOCValues`. */
  chargeTimeSOCIncrements?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** rSOC values to associate with each time charge time increment. Must have same length as `chargeTimeSOCIncrements` */
  chargeTimeSOCValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  contestant?: Maybe<Contestant>;
  contestantID: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  fuelRequired?: Maybe<RunEnergy>;
  /** Full tank fuel load */
  mFuelFullTank?: Maybe<Scalars['Float']['output']>;
  performanceEngineerIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  performanceEngineers: Array<Person>;
  raceEngineerIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  raceEngineers: Array<Person>;
  runs: Array<Maybe<RunPlanRun>>;
  session?: Maybe<Session>;
  sessionID: Scalars['MongoID']['output'];
  systemEngineerIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  systemEngineers: Array<Person>;
  tLapExpected?: Maybe<RunLapTime>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  /** Short comment like dry run plan / wet run plan. */
  title: Scalars['String']['output'];
  trackLayout?: Maybe<TrackLayout>;
  trackLayoutID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type RunPlanLap = {
  NLap: Scalars['Int']['output'];
  _id?: Maybe<Scalars['MongoID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** Custom fields for the lap; must be of form `Record<string, any>`. */
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Generic energy expected at lap start, with type depending on the energy type of the run plan. */
  energyLapStart?: Maybe<Scalars['Float']['output']>;
  tDayLapStart?: Maybe<Scalars['Date']['output']>;
  tyreSet?: Maybe<TyreSet>;
  tyreSetID?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type RunPlanPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RunPlan>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type RunPlanRun = {
  /**
   * Number of fireups planned.
   * @deprecated This field is deprecated - use actionItemsPreRun instead
   */
  NFireups?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of push laps planned in attack mode power.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsAttackPower?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of prep laps planned.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsPrep?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of push laps planned in standard power.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsPush?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of push laps planned in qualifying power.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsQualiPower?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of slow laps planned.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsSlow?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of target laps planned.
   * @deprecated This field is deprecated. Use lap sequence instead
   */
  NLapsTarget?: Maybe<Scalars['Float']['output']>;
  /**
   * Number of pitstops planned.
   * @deprecated This field is deprecated - use actionItemsPreRun instead
   */
  NPitstops?: Maybe<Scalars['Float']['output']>;
  /** Run number */
  NRun: Scalars['Float']['output'];
  /**
   * Number of starts planned.
   * @deprecated This field is deprecated - use actionItemsPreRun instead
   */
  NStarts?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  actionItemsPostRun?: Maybe<Array<Maybe<RunPlanRunActionItemsPreRun>>>;
  actionItemsPreRun?: Maybe<Array<Maybe<RunPlanRunActionItemsPreRun>>>;
  /** Background color for the run in run plan view. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** e.g. Baseline Run, Option A, … */
  description?: Maybe<Scalars['String']['output']>;
  /** True if fuel was drained before the run. */
  fuelDrainedBeforeRun?: Maybe<Scalars['Boolean']['output']>;
  lapSequence?: Maybe<Array<Maybe<LapSequenceLaps>>>;
  /** @deprecated This field is deprecated. Use lap sequence instead */
  laps?: Maybe<Array<Maybe<RunPlanLap>>>;
  /** Amount of fuel to be refilled at the end of this run. */
  mFuelRefuel?: Maybe<Scalars['Float']['output']>;
  /**
   * Fuel at run's end.
   * @deprecated This field is deprecated - it should be calculated from lap type consumptions set in the run plan or event
   */
  mFuelRunEnd?: Maybe<Scalars['Float']['output']>;
  /**
   * Fuel at the start of the run.
   * @deprecated This field is deprecated - it should be calculated from mFuelRefuel, fuelDrainedBeforeRun and the previous runs
   */
  mFuelRunStart?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<RunPlanRunPriority>;
  /** Things you need to remember to tell the driver. */
  reminder?: Maybe<Scalars['String']['output']>;
  runSheet?: Maybe<RunSheet>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  selectedDriver?: Maybe<Person>;
  selectedDriverID?: Maybe<Scalars['MongoID']['output']>;
  /** Setup changes anticipated. */
  setupChanges?: Maybe<Scalars['String']['output']>;
  /** Amount of time for refuelling at the end of this run. */
  tFuelRefuel?: Maybe<Scalars['Float']['output']>;
  /**
   * Time in garage which is planned for setup changes, fuel, charging, etc.
   * @deprecated This field is deprecated. Only wait before should be used
   */
  tGarageTurnaround?: Maybe<Scalars['Float']['output']>;
  /**
   * Time of day when run end is planned - dynamic by lap numbers and lap times.
   * @deprecated This field is deprecated. It should be calculated from the lap sequence and lap times
   */
  tRunEnd?: Maybe<Scalars['Date']['output']>;
  /**
   * Time of day when run start is planned.
   * @deprecated This field is deprecated. It should be calculated from the previous run or session start and waiting time
   */
  tRunStart?: Maybe<Scalars['Date']['output']>;
  /** Time to wait before starting the run. */
  tWaitBeforeRun?: Maybe<Scalars['Float']['output']>;
  tyreFL?: Maybe<Tyre>;
  tyreFLID?: Maybe<Scalars['MongoID']['output']>;
  tyreFR?: Maybe<Tyre>;
  tyreFRID?: Maybe<Scalars['MongoID']['output']>;
  tyreRL?: Maybe<Tyre>;
  tyreRLID?: Maybe<Scalars['MongoID']['output']>;
  tyreRR?: Maybe<Tyre>;
  tyreRRID?: Maybe<Scalars['MongoID']['output']>;
  tyreSet?: Maybe<TyreSet>;
  tyreSetID?: Maybe<Scalars['MongoID']['output']>;
};

export type RunPlanRunActionItemsPreRun = {
  _id: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
};

export type RunPlanRunActionItemsPreRunInput = {
  _id: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
};

export type RunPlanRunInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  actionItemsPostRun?: InputMaybe<Array<InputMaybe<RunPlanRunActionItemsPreRunInput>>>;
  actionItemsPreRun?: InputMaybe<Array<InputMaybe<RunPlanRunActionItemsPreRunInput>>>;
  /** Background color for the run in run plan view. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Baseline Run, Option A, … */
  description?: InputMaybe<Scalars['String']['input']>;
  /** True if fuel was drained before the run. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequence?: InputMaybe<Array<InputMaybe<LapSequenceLapsInput>>>;
  /** Amount of fuel to be refilled at the end of this run. */
  mFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumRunPlanRunPriority>;
  /** Things you need to remember to tell the driver. */
  reminder?: InputMaybe<Scalars['String']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  selectedDriverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Setup changes anticipated. */
  setupChanges?: InputMaybe<Scalars['String']['input']>;
  /** Amount of time for refuelling at the end of this run. */
  tFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Time to wait before starting the run. */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tyreFLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreFRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type RunPlanRunPriority =
  | 'PRIO1_MAXIMUM'
  | 'PRIO2_HIGH'
  | 'PRIO3_MEDIUM'
  | 'PRIO4_LOW'
  | 'PRIO5_NONE';

export type RunSheet = {
  /** Fuel density, if working in volume (overrides `DFuel` from event) */
  DFuel?: Maybe<Scalars['Float']['output']>;
  /** Run number */
  NRun?: Maybe<Scalars['Float']['output']>;
  /** Run number for timing services */
  NRunTiming?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Specify SoC required in event.consumptions instead */
  SoCRequired?: Maybe<RunEnergy>;
  TCellMaxRunStart?: Maybe<Scalars['Float']['output']>;
  /** Volume of fuel added at the start of the run. This field will not be automatically calculated by the API, so should be set along with `tRefuel` and `qRefuel` as their product. */
  VFuelAdded?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  associatedKpiFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brakeComment?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use parts and tracking items instead */
  brakeFL?: Maybe<RunBrake>;
  /** @deprecated Use parts and tracking items instead */
  brakeFR?: Maybe<RunBrake>;
  /**
   * Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use brakePreRunMeasurementsFL or brakePostRunMeasurementsFL
   */
  brakeMeasurementsFL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use brakePreRunMeasurementsFR or brakePostRunMeasurementsFR
   */
  brakeMeasurementsFR?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use brakePreRunMeasurementsRL or brakePostRunMeasurementsRL
   */
  brakeMeasurementsRL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use brakePreRunMeasurementsRR or brakePostRunMeasurementsRR
   */
  brakeMeasurementsRR?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePostRunMeasurementsFL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePostRunMeasurementsFR?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePostRunMeasurementsRL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePostRunMeasurementsRR?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePreRunMeasurementsFL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePreRunMeasurementsFR?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRL: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePreRunMeasurementsRL?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRR: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  brakePreRunMeasurementsRR?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Use parts and tracking items instead */
  brakeRL?: Maybe<RunBrake>;
  /** @deprecated Use parts and tracking items instead */
  brakeRR?: Maybe<RunBrake>;
  /** Chassis assembly derived from the linked setup */
  chassisAssembly?: Maybe<ChassisAssembly>;
  /** Chassis assembly ID derived from the linked setup */
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  /** Link to a cloud storage location where raw run data is kept. */
  cloudStorageURL?: Maybe<Scalars['String']['output']>;
  /** Fuel/SoC/Energy consumptions for each track layout in this run sheet. Acts as an override for the consumptions from the parent event. */
  consumptions?: Maybe<Array<Maybe<LayoutConsumption>>>;
  contestant?: Maybe<Contestant>;
  contestantID: Scalars['MongoID']['output'];
  controlsComment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dashboard?: Maybe<Dashboard>;
  dataServiceFileNameOverride?: Maybe<Scalars['String']['output']>;
  dilComments?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Person>;
  driverComments?: Maybe<Scalars['String']['output']>;
  driverID?: Maybe<Scalars['MongoID']['output']>;
  /** Resolved end time. Order: end time from laptime service, end time from manual, calculated end time via start time and laptimes */
  endTime?: Maybe<Scalars['Date']['output']>;
  /** Car data service run end time */
  endTimeCDS?: Maybe<Scalars['Date']['output']>;
  /** Laptime service run end time */
  endTimeLTS?: Maybe<Scalars['Date']['output']>;
  /** Manual run end time (used to override calculation in case run was cut short but don't want to delete the drafted laps */
  endTimeManual?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Specify energy required in event.consumptions instead */
  energyRequired?: Maybe<RunEnergy>;
  engineer?: Maybe<Person>;
  engineerComments?: Maybe<Scalars['String']['output']>;
  engineerID?: Maybe<Scalars['MongoID']['output']>;
  fastestLap?: Maybe<Scalars['Float']['output']>;
  /** Time by which tyre heating schedule should be finished */
  finishTyreHeatingBy?: Maybe<Scalars['Date']['output']>;
  /** Used for fuel calculation. If true, mFuelAdded is treated as the total fuel at run start. */
  fuelDrainedBeforeRun?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Specify fuel required in event.consumptions instead */
  fuelRequired?: Maybe<RunEnergy>;
  /** Resolved garage time. Laptime service timestamps */
  garageTime?: Maybe<Scalars['Float']['output']>;
  history: Array<History>;
  historyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  info?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isLockedByLaptimeService?: Maybe<Scalars['Boolean']['output']>;
  issueIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  jobIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  jobs: Array<Job>;
  /** Used to save the file name where the kpi data is retreived from */
  kpiFileName?: Maybe<Scalars['String']['output']>;
  kpiStatus?: Maybe<EnumRunSheetKpiStatus>;
  kpiUpdatedAt?: Maybe<Scalars['Date']['output']>;
  lapCount: Scalars['Int']['output'];
  lapIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  laps: Array<Lap>;
  laptimeThresholds?: Maybe<LaptimeThresholds>;
  lastModifiedBy?: Maybe<Person>;
  lastModifiedByID?: Maybe<Scalars['MongoID']['output']>;
  /** Fuel added at the start of the run */
  mFuelAdded?: Maybe<Scalars['Float']['output']>;
  /** Fuel removed from the catch tank after the run */
  mFuelDrainedCatchTank?: Maybe<Scalars['Float']['output']>;
  /** Fuel removed from the main tank after the run */
  mFuelDrainedMainTank?: Maybe<Scalars['Float']['output']>;
  /** Fuel remaining at the end of the run */
  mFuelRunEnd?: Maybe<Scalars['Float']['output']>;
  /** Fuel remaining at the start of the run */
  mFuelRunStart?: Maybe<Scalars['Float']['output']>;
  /** Fuel used before run start i.e. for pre-run fireup */
  mFuelUsedPreRun?: Maybe<Scalars['Float']['output']>;
  /** Calculated mileage of the run. */
  mileage?: Maybe<Scalars['Float']['output']>;
  nextRunSheetID?: Maybe<Scalars['MongoID']['output']>;
  performanceComments?: Maybe<Scalars['String']['output']>;
  prevRunSheetID?: Maybe<Scalars['MongoID']['output']>;
  problemComments?: Maybe<Scalars['String']['output']>;
  /** Flow rate when refuelling at the start of the run, in m³/s */
  qRefuel?: Maybe<Scalars['Float']['output']>;
  /** Energy charged to this value at the start of the run */
  rEnergyAdded?: Maybe<Scalars['Float']['output']>;
  /** Energy level at the end of the run */
  rEnergyRunEnd?: Maybe<Scalars['Float']['output']>;
  /** Energy level at the start of the run => calculated */
  rEnergyRunStart?: Maybe<Scalars['Float']['output']>;
  /** Battery charged to this value at the start of the run */
  rSOCAdded?: Maybe<Scalars['Float']['output']>;
  /** Battery state of charge at the end of the run */
  rSOCRunEnd?: Maybe<Scalars['Float']['output']>;
  /** Battery state of charge at the start of the run */
  rSOCRunStart?: Maybe<Scalars['Float']['output']>;
  /** Short comment of the objective of the run */
  runDescription?: Maybe<Scalars['String']['output']>;
  /** Map of run KPI fields to their values. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  runKPI?: Maybe<Scalars['JSON']['output']>;
  runSheetStyle?: Maybe<RunSheetStyle>;
  runSheetStyleID?: Maybe<Scalars['MongoID']['output']>;
  /** Running time in seconds */
  runTime?: Maybe<Scalars['Float']['output']>;
  /** ID of the job list template used for this run */
  selectedJobListTemplateID?: Maybe<Scalars['MongoID']['output']>;
  session?: Maybe<Session>;
  sessionID?: Maybe<Scalars['MongoID']['output']>;
  setup?: Maybe<CarSetup>;
  setupID?: Maybe<Scalars['MongoID']['output']>;
  /** IDs of the simulation results associated with this run. */
  simResultIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  simResults: Array<SimResult>;
  skidComment?: Maybe<Scalars['String']['output']>;
  /**
   * Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidMeasurement: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use skidPreRunMeasurements or skidPostRunMeasurements
   */
  skidMeasurement?: Maybe<Scalars['JSON']['output']>;
  skidPlate?: Maybe<SkidPlate>;
  /** @deprecated Use parts and tracking items instead */
  skidPlateID?: Maybe<Scalars['MongoID']['output']>;
  /**
   * Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPostRunMeasurements: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  skidPostRunMeasurements?: Maybe<Scalars['JSON']['output']>;
  /**
   * Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPreRunMeasurements: [["left", 5], ["marker1", 6]]`.
   * @deprecated Use parts and tracking items instead
   */
  skidPreRunMeasurements?: Maybe<Scalars['JSON']['output']>;
  /** Resolved start time. Start time from Laptime service has priority over manual */
  startTime?: Maybe<Scalars['Date']['output']>;
  startTimeCDS?: Maybe<Scalars['Date']['output']>;
  startTimeLTS?: Maybe<Scalars['Date']['output']>;
  startTimeManual?: Maybe<Scalars['Date']['output']>;
  /** Time at which to start tyre heating schedule */
  startTyreHeatingAt?: Maybe<Scalars['Date']['output']>;
  summaryComments?: Maybe<Scalars['String']['output']>;
  systemsComments?: Maybe<Scalars['String']['output']>;
  /** Time spent in garage after run */
  tGarageTurnaround?: Maybe<Scalars['Float']['output']>;
  /** Time spent refuelling at the start of the run */
  tRefuel?: Maybe<Scalars['Float']['output']>;
  /** Override for session time remaining (in seconds) */
  tSessionRemainingOverride?: Maybe<Scalars['Float']['output']>;
  /** Session time remaining at the start of the run (in seconds). Resolved from previous runs if needed */
  tSessionRemainingStartRun?: Maybe<Scalars['Float']['output']>;
  /** Time spent in garage before run */
  tWaitBeforeRun?: Maybe<Scalars['Float']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  team?: Maybe<Team>;
  teamID?: Maybe<Scalars['MongoID']['output']>;
  /** ID of this run in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyRunID?: Maybe<Scalars['String']['output']>;
  /** Should the timing service pretend that this run sheet does not exist? */
  timingServiceShouldIgnore?: Maybe<Scalars['Boolean']['output']>;
  tyreComments?: Maybe<Scalars['String']['output']>;
  /** The tyre compound used, reported by the timing service. */
  tyreCompoundTiming?: Maybe<Scalars['String']['output']>;
  tyreFL?: Maybe<RunTyre>;
  tyreFR?: Maybe<RunTyre>;
  tyrePressureSettings?: Maybe<TyrePressureSettings>;
  tyreRL?: Maybe<RunTyre>;
  tyreRR?: Maybe<RunTyre>;
  tyreSet?: Maybe<TyreSet>;
  tyreSetID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weather?: Maybe<WeatherData>;
  writeHistory?: Maybe<Scalars['Boolean']['output']>;
};


export type RunSheetRunKpiArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RunSheetInfo = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  info?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type RunSheetPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RunSheet>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type RunSheetStyle = {
  _id: Scalars['MongoID']['output'];
  blocks?: Maybe<Array<Maybe<RunSheetStyleBlock>>>;
  energyType?: Maybe<EnumEnergyType>;
  lapFlags?: Maybe<LapFlagLabels>;
  name: Scalars['String']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
};

export type RunSheetStyleBlock = BlankingBlock | BrakesBlock | CommentBlock | DoubleCommentBlock | FuelBlock | IssueBlock | JobListBlock | LapTableBlock | LapTimeThresholdsBlock | LapTypeCountBlock | MiniJobListBlock | PostRunMeasurementBlock | RunKpiTableBlock | SetupChangesBlock | SetupSheetBlock | TyreTableBlock | WeatherBoxBlock;

/** List of items with pagination. */
export type RunSheetStylePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<RunSheetStyle>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type RunTyre = {
  /**
   * Track reference temperature at which the reference pressure is given
   * @deprecated Use tyrePressureSettings.TTrackReference instead
   */
  TTrackReference?: Maybe<Scalars['Float']['output']>;
  /** Tyre temperature */
  TTyre?: Maybe<Scalars['Float']['output']>;
  /** Expected tyre temperature in parc ferme */
  TTyreParcFermeExpected?: Maybe<Scalars['Float']['output']>;
  /** Post-run tyre temperature */
  TTyrePostRun?: Maybe<Scalars['Float']['output']>;
  /** Post-run tyre pressure bleed at temperature */
  TTyrePostRunBleed?: Maybe<Scalars['Float']['output']>;
  /** Pre-run tyre pressure bleed at temperature */
  TTyrePreRunBleed?: Maybe<Scalars['Float']['output']>;
  /** Tyre reference temperature at which the reference pressure is given */
  TTyreReference?: Maybe<Scalars['Float']['output']>;
  /** Set down tyre temperature (e.g. in the evening with cold tyre) */
  TTyreSetdown?: Maybe<Scalars['Float']['output']>;
  /** Array of manual surface temperature measurements */
  TTyreSurface?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Array of manual tyre tread depth measurements */
  hTyreTread?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Calculated mileage from all previous run sheets */
  mileagePreRun?: Maybe<Scalars['Float']['output']>;
  /** Tyre pressure */
  pTyre?: Maybe<Scalars['Float']['output']>;
  /**
   * Tyre minimum pressure at the start of the run
   * @deprecated Use pTyreStartRun instead
   */
  pTyreMinStartRun?: Maybe<Scalars['Float']['output']>;
  /** Post-run tyre pressure */
  pTyrePostRun?: Maybe<Scalars['Float']['output']>;
  /** Post-run tyre pressure bleed */
  pTyrePostRunBleed?: Maybe<Scalars['Float']['output']>;
  /** Pre-run tyre pressure bleed */
  pTyrePreRunBleed?: Maybe<Scalars['Float']['output']>;
  /** Tyre reference pressure */
  pTyreReference?: Maybe<Scalars['Float']['output']>;
  /** Set down tyre pressure (e.g. in the evening with cold tyre) */
  pTyreSetDown?: Maybe<Scalars['Float']['output']>;
  /** Tyre pressure at the start of the run */
  pTyreStartRun?: Maybe<Scalars['Float']['output']>;
  /** Target tyre pressure during running */
  pTyreTarget?: Maybe<Scalars['Float']['output']>;
  tyre?: Maybe<Tyre>;
  tyreID?: Maybe<Scalars['MongoID']['output']>;
};

export type RunTyreInput = {
  /** Track reference temperature at which the reference pressure is given */
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre temperature */
  TTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Expected tyre temperature in parc ferme */
  TTyreParcFermeExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre temperature */
  TTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed at temperature */
  TTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed at temperature */
  TTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference temperature at which the reference pressure is given */
  TTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre temperature (e.g. in the evening with cold tyre) */
  TTyreSetdown?: InputMaybe<Scalars['Float']['input']>;
  /** Array of manual surface temperature measurements */
  TTyreSurface?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of manual tyre tread depth measurements */
  hTyreTread?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Tyre pressure */
  pTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure at the start of the run */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure */
  pTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed */
  pTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed */
  pTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference pressure */
  pTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre pressure (e.g. in the evening with cold tyre) */
  pTyreSetDown?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre pressure at the start of the run */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Target tyre pressure during running */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  tyreID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type RuntimeError = ErrorInterface & {
  /** Runtime error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type SandboxMutations = {
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addUnit?: Maybe<CreateOneSandboxUnitsPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeUnit?: Maybe<RemoveByIdSandboxUnitsPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateUnit?: Maybe<UpdateByIdSandboxUnitsPayload>;
};


export type SandboxMutationsAddUnitArgs = {
  record: CreateOneSandboxUnitsInput;
};


export type SandboxMutationsRemoveUnitArgs = {
  _id: Scalars['MongoID']['input'];
};


export type SandboxMutationsUpdateUnitArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSandboxUnitsInput;
};

export type SandboxQueries = {
  unit?: Maybe<SandboxUnits>;
  units?: Maybe<SandboxUnitsPagination>;
};


export type SandboxQueriesUnitArgs = {
  _id: Scalars['MongoID']['input'];
};


export type SandboxQueriesUnitsArgs = {
  filter?: InputMaybe<FilterFindManySandboxUnitsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySandboxUnitsInput>;
};

export type SandboxUnits = {
  _id: Scalars['MongoID']['output'];
  acceleration?: Maybe<Acceleration>;
  angle?: Maybe<Angle>;
  angularVelocity?: Maybe<AngularVelocity>;
  area?: Maybe<Area>;
  current?: Maybe<Current>;
  dampingRate?: Maybe<DampingRate>;
  density?: Maybe<Density>;
  energy?: Maybe<Energy>;
  force?: Maybe<Force>;
  frequency?: Maybe<Frequency>;
  length?: Maybe<Length>;
  mass?: Maybe<Mass>;
  momentOfInertia?: Maybe<MomentOfInertia>;
  power?: Maybe<Power>;
  pressure?: Maybe<Pressure>;
  ratio?: Maybe<Ratio>;
  springRate?: Maybe<SpringRate>;
  temperature?: Maybe<Temperature>;
  torque?: Maybe<Torque>;
  torsionRate?: Maybe<TorsionRate>;
  velocity?: Maybe<Velocity>;
  voltage?: Maybe<Voltage>;
  volume?: Maybe<Volume>;
};

/** List of items with pagination. */
export type SandboxUnitsPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SandboxUnits>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ScrapManyTyresResult = {
  updatedCount: Scalars['Int']['output'];
};

export type Season = {
  _id: Scalars['MongoID']['output'];
  assignedSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignedSetups: Array<CarSetup>;
  contestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  contestants: Array<Contestant>;
  /** The most recent session that has awarded points, within this season. Currently selected purely based on the existence of driver championship standings data, not reliant on live standings data.  */
  currentPointsSession?: Maybe<Session>;
  /** The most recent or currently active session within this season. Currently selected purely based on the existence of live standings data, but may be made more intelligent in future. */
  currentSession?: Maybe<Session>;
  eventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  events: Array<Event>;
  /** Position after which a driver no longer gets points for fastest lap. */
  fastestLapsPositionCutoff?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Championship points per fastest lap in a session. Example: `[1]` means fastest lap gets 1 point, then second and beyond gets nothing. */
  pointsPerFastestLap?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Whether the fastest lap points are awarded to the team or the driver. */
  pointsPerFastestLapTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Championship points per driver position in a race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPosition?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Championship points per driver position in a sprint race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPositionSprintRace?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Championship points per qualifying rank at an event. Example: `[3, 2, 1]` means first/second/third drivers get 3/2/1 points, then fourth and beyond gets nothing. */
  pointsPerQualifyingRank?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  pointsSystemQualiAlternateIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  pointsSystemQualiAlternates: Array<PointsSystem>;
  pointsSystemQualiDefaultIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  pointsSystemQualiDefaults: Array<PointsSystem>;
  pointsSystemRaceAlternateIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  pointsSystemRaceAlternates: Array<PointsSystem>;
  pointsSystemRaceDefaultIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  pointsSystemRaceDefaults: Array<PointsSystem>;
  raceSeries?: Maybe<RaceSeries>;
  raceSeriesID: Scalars['MongoID']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** IDs of all tyres which are owned by the team for this season. */
  tyreIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** IDs of all tyre sets which are owned by the team for this season. */
  tyreSetIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tyreSets: Array<TyreSet>;
  tyres: Array<Tyre>;
};

/** List of items with pagination. */
export type SeasonPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Season>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SelfResetPasswordResult = {
  success: Scalars['Boolean']['output'];
};

export type ServerSettings = {
  _id: Scalars['MongoID']['output'];
  copyAssembly?: Maybe<ServerSettingsCopyAssembly>;
  simulationColoring?: Maybe<ServerSettingsSimulationColoring>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ServerSettingsCopyAssembly = {
  copyInactiveParts?: Maybe<Scalars['Boolean']['output']>;
};

export type ServerSettingsCopyAssemblyInput = {
  copyInactiveParts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServerSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  copyAssembly?: InputMaybe<ServerSettingsCopyAssemblyInput>;
  simulationColoring?: InputMaybe<ServerSettingsSimulationColoringInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ServerSettingsSimulationColoring = {
  method?: Maybe<EnumServerSettingsSimulationColoringMethod>;
};

export type ServerSettingsSimulationColoringInput = {
  method?: InputMaybe<EnumServerSettingsSimulationColoringMethod>;
};

export type Session = {
  _id: Scalars['MongoID']['output'];
  assignedSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignedSetups: Array<CarSetup>;
  bestValues?: Maybe<BestValues>;
  bestValuesID?: Maybe<Scalars['MongoID']['output']>;
  bop?: Maybe<Bop>;
  bopID?: Maybe<Scalars['MongoID']['output']>;
  contestants?: Maybe<Array<Maybe<SessionContestants>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: Maybe<Scalars['JSON']['output']>;
  debriefNotes?: Maybe<Scalars['String']['output']>;
  debriefNotesMode?: Maybe<EnumSessionDebriefNotesMode>;
  disableForwardPropagation?: Maybe<Scalars['Boolean']['output']>;
  /** Sorted driver championship standings during and immediately after this session. */
  driverChampionshipStandings?: Maybe<Array<Maybe<DriverChampionshipStanding>>>;
  /** Driver Timings resolved from runsheets */
  driverTimings: Array<DriverTiming>;
  event?: Maybe<Event>;
  eventID: Scalars['MongoID']['output'];
  /** This flag is used to tell the laptime service that this session might span multiple timing sessions. */
  isLinkedSession?: Maybe<Scalars['Boolean']['output']>;
  /** Is this a timing test session, to be shown only to admin users? */
  isTimingTest?: Maybe<Scalars['Boolean']['output']>;
  /** Sorted standings of this session, as they were last updated */
  liveStandings?: Maybe<Array<Maybe<LiveStanding>>>;
  /** Greatest lap number processed for live standings. Use to determine if the data is current and up to date. */
  liveStandingsCurrentLap?: Maybe<Scalars['Float']['output']>;
  /** Time of last update of `liveStandings` and `driverChampionshipStandings` */
  liveStandingsUpdatedAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  /** ID of the next session in this event */
  nextSessionID?: Maybe<Scalars['MongoID']['output']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFLMinSession?: Maybe<Scalars['Float']['output']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFRMinSession?: Maybe<Scalars['Float']['output']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRLMinSession?: Maybe<Scalars['Float']['output']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRRMinSession?: Maybe<Scalars['Float']['output']>;
  participantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  participants: Array<Person>;
  pointsSystemOverrideIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  pointsSystemOverrides: Array<PointsSystem>;
  /** Sorted driver championship standings from before the start of this session. */
  prevDriverChampionshipStandings?: Maybe<Array<Maybe<DriverChampionshipStanding>>>;
  /** ID of the previous session in this event */
  prevSessionID?: Maybe<Scalars['MongoID']['output']>;
  /** e.g. Test, Practice, Qualifying, Race */
  sessionType?: Maybe<EnumSessionType>;
  /** Short name like D1, FP2, etc. */
  shortName?: Maybe<Scalars['String']['output']>;
  /** Time of the session end in local time */
  tSessionEnd?: Maybe<Scalars['Date']['output']>;
  /** Time of the session start in local time */
  tSessionStart?: Maybe<Scalars['Date']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** Sorted team championship standings during and immediately after this session. */
  teamChampionshipStandings?: Maybe<Array<Maybe<TeamChampionshipStanding>>>;
  /** ID of this session in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartySessionID?: Maybe<Scalars['String']['output']>;
  /** Seconds until end of session, updated by the timing service very infrequently. Zero if session has already ended. */
  timeRemaining?: Maybe<Scalars['Float']['output']>;
  /** Time of last update of `timeRemaining` (automatically updated). */
  timeRemainingUpdatedAt?: Maybe<Scalars['Date']['output']>;
  /** ID of this session for Transcribble's legacy API */
  transcribbleSessionID?: Maybe<Scalars['Int']['output']>;
};


export type SessionDriverTimingsArgs = {
  filterByCarClasses?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Field to target with this mutation. */
export type SessionContestantField =
  /** → `chassisIDs` */
  | 'CHASSIS'
  /** → `driverIDs` */
  | 'DRIVERS';

export type SessionContestants = {
  _id: Scalars['MongoID']['output'];
  /** Chassis used, if different for this session. */
  chassis: Array<Chassis>;
  /** IDs of the chassis used, if different for this session. */
  chassisIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: Maybe<Scalars['String']['output']>;
  /** IDs of drivers of this car, if different for this session. */
  driverIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Drivers of this car, if different for this session. */
  drivers: Array<Person>;
};

export type SessionContestantsInput = {
  _id: Scalars['MongoID']['input'];
  /** IDs of the chassis used, if different for this session. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this session. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** List of items with pagination. */
export type SessionPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Session>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SetAllTimingServiceConfigsInactive = {
  modifiedCount?: Maybe<Scalars['Int']['output']>;
};

export type SetPasswordResult = {
  success: Scalars['Boolean']['output'];
};

export type SetupChangesBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type SetupOverviewConfig = {
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  /** WARNING: this field should be deprecated after SI migrations have taken place */
  fields?: Maybe<Array<Maybe<SetupOverviewConfigField>>>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Array<Maybe<SetupOverviewConfigRow>>>;
  title: Scalars['String']['output'];
};

export type SetupOverviewConfigField = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Number of decimal places to display. */
  decimals?: Maybe<Scalars['Int']['output']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell and an array of two numbers for a double cell. */
  gain?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Field names to pull data from in the car setup, like `"frontLeft.hRide"`. Use an array of one key for a single cell, and an array of two keys for a double cell. */
  keys: Array<Maybe<Scalars['String']['output']>>;
  label: Scalars['String']['output'];
  /** Suffix to show as a unit for values. */
  unit?: Maybe<Scalars['String']['output']>;
};

export type SetupOverviewConfigFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell and an array of two numbers for a double cell. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to pull data from in the car setup, like `"frontLeft.hRide"`. Use an array of one key for a single cell, and an array of two keys for a double cell. */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  label: Scalars['String']['input'];
  /** Suffix to show as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type SetupOverviewConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SetupOverviewConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SetupOverviewConfigRow = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  elements?: Maybe<Array<Maybe<SetupOverviewConfigRowElement>>>;
  title: Scalars['String']['output'];
};

export type SetupOverviewConfigRowElement = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** Number of decimal places to display. */
  decimals?: Maybe<Scalars['Int']['output']>;
  /** Path of field in car setup, e.g. aero.aFlapF */
  field: Scalars['String']['output'];
  /** Gain to apply to the value. */
  gain?: Maybe<Scalars['Float']['output']>;
  /** Suffix to put as a unit for values. */
  suffix?: Maybe<Scalars['String']['output']>;
  unitType: TypedUnitField;
};

export type SetupOverviewConfigRowElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Path of field in car setup, e.g. aero.aFlapF */
  field: Scalars['String']['input'];
  /** Gain to apply to the value. */
  gain?: InputMaybe<Scalars['Float']['input']>;
  /** Suffix to put as a unit for values. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  unitType: BaseTypedUnitFieldInput;
};

export type SetupOverviewConfigRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  elements?: InputMaybe<Array<InputMaybe<SetupOverviewConfigRowElementInput>>>;
  title: Scalars['String']['input'];
};

export type SetupSheetBlock = {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  setupSheetStyle?: Maybe<SetupSheetStyle>;
  setupSheetStyleID?: Maybe<Scalars['MongoID']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type SetupSheetGroup = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  rows: Array<SetupSheetStyleRow>;
};

export type SetupSheetGroupInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  rows: Array<SetupSheetStyleRowInput>;
};

export type SetupSheetStyle = {
  _id: Scalars['MongoID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  author?: Maybe<Person>;
  authorID?: Maybe<Scalars['MongoID']['output']>;
  blocks: Array<SetupSheetStyleBlock>;
  /** Chassis specification to use for suggesting field keys. You may need to look for more recent iterations of this spec to get up-to-date field keys. */
  chassisSpec?: Maybe<ChassisSpec>;
  /** Chassis specification to use for suggesting field keys. You may need to look for more recent iterations of this spec to get up-to-date field keys. */
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  hideAddPartButton?: Maybe<Scalars['Boolean']['output']>;
  /** Toggle to show/hide units for the input fields */
  hideUnits?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  targetEventType?: Maybe<EnumSetupSheetStyleTargetEventType>;
  targetRoles?: Maybe<Array<EnumPersonRole>>;
  targetUserIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  targetUsers: Array<Person>;
  type: EnumSetupSheetStyleType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SetupSheetStyleBlock = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The height of the block within the grid */
  height: Scalars['Int']['output'];
  tabs: Array<SetupSheetStyleTab>;
  /** The width of the block within the grid */
  width: Scalars['Int']['output'];
  /** The x position of the block within the grid */
  x: Scalars['Int']['output'];
  /** The y position of the block within the grid */
  y: Scalars['Int']['output'];
};

export type SetupSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  height: Scalars['Int']['input'];
  tabs?: InputMaybe<Array<SetupSheetStyleTabInput>>;
  /** The width of the block within the grid */
  width: Scalars['Int']['input'];
  /** The x position of the block within the grid */
  x: Scalars['Int']['input'];
  /** The y position of the block within the grid */
  y: Scalars['Int']['input'];
};

export type SetupSheetStyleItem = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  alignment?: Maybe<Scalars['String']['output']>;
  /** Background color for this item; overrides the setting from the parent block. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  colSpan?: Maybe<Scalars['Int']['output']>;
  decimals?: Maybe<Scalars['Float']['output']>;
  fieldKey?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** Use an inclusive OR of this flag with the `readOnly` field in flattened car setup data. */
  readOnly: Scalars['Boolean']['output'];
  /** If this is non-empty, only users with one of these roles can edit the value of this field. */
  restrictedToRoles: Array<EnumPersonRole>;
  type: EnumSetupSheetStyleItemType;
  /** Portion of the containing row to take up. Takes precedence over colSpan if defined. */
  widthRatio?: Maybe<Scalars['Float']['output']>;
};

export type SetupSheetStyleItemInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  /** Background color for this item; overrides the setting from the parent block. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  colSpan?: InputMaybe<Scalars['Int']['input']>;
  decimals?: InputMaybe<Scalars['Float']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Use an inclusive OR of this flag with the `readOnly` field in flattened car setup data. */
  readOnly?: Scalars['Boolean']['input'];
  /** If this is non-empty, only users with one of these roles can edit the value of this field. */
  restrictedToRoles?: Array<EnumPersonRole>;
  type: EnumSetupSheetStyleItemType;
  /** Portion of the containing row to take up. Takes precedence over colSpan if defined. */
  widthRatio?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type SetupSheetStylePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SetupSheetStyle>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SetupSheetStyleRow = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  items: Array<SetupSheetStyleItem>;
};

export type SetupSheetStyleRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  items: Array<SetupSheetStyleItemInput>;
};

export type SetupSheetStyleTab = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  groups: Array<SetupSheetGroup>;
  massConfig?: Maybe<SetupSheetStyleTabMassConfig>;
  mileageConfig?: Maybe<SetupSheetStyleTabMileageConfig>;
  rows: Array<SetupSheetStyleRow>;
  title: Scalars['String']['output'];
  type?: Maybe<EnumSetupSheetStyleTabType>;
};

export type SetupSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  groups?: InputMaybe<Array<SetupSheetGroupInput>>;
  massConfig?: InputMaybe<SetupSheetStyleTabMassConfigInput>;
  mileageConfig?: InputMaybe<SetupSheetStyleTabMileageConfigInput>;
  rows?: InputMaybe<Array<SetupSheetStyleRowInput>>;
  title: Scalars['String']['input'];
  type?: InputMaybe<EnumSetupSheetStyleTabType>;
};

export type SetupSheetStyleTabMassConfig = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  massOption?: Maybe<Scalars['String']['output']>;
  showMinWeightFromSpec?: Maybe<Scalars['Boolean']['output']>;
};

export type SetupSheetStyleTabMassConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  massOption?: InputMaybe<Scalars['String']['input']>;
  showMinWeightFromSpec?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetupSheetStyleTabMileageConfig = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  showManualInput?: Maybe<Scalars['Boolean']['output']>;
};

export type SetupSheetStyleTabMileageConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  showManualInput?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SimRequest = {
  /** Ambient temperature in °K */
  TAmbient?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  carSetup?: Maybe<CarSetup>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Ambient pressure in Pa */
  pAmbient?: Maybe<Scalars['Float']['output']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: Maybe<Scalars['Float']['output']>;
  relatedSimResultIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  requester?: Maybe<Person>;
  requesterID?: Maybe<Scalars['MongoID']['output']>;
  requesterSlot?: Maybe<EnumSimRequestRequesterSlot>;
  runSheet?: Maybe<RunSheet>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  simResult?: Maybe<SimResult>;
  simResultID?: Maybe<Scalars['MongoID']['output']>;
  simType?: Maybe<EnumSimRequestSimType>;
  simulationService?: Maybe<EnumSimModelType>;
  sourceReferenceID?: Maybe<Scalars['String']['output']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  status?: Maybe<EnumSimResultStatus>;
  trackLayout?: Maybe<TrackLayout>;
  trackLayoutID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Version of the third-party service used to generate the sim result */
  version?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type SimRequestPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SimRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SimResult = {
  /** Ambient temperature in °K */
  TAmbient?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  carSetup?: Maybe<CarSetup>;
  carSetupID?: Maybe<Scalars['MongoID']['output']>;
  /** When the car setup was last modified at time of request. Used to ensure that the sim result is up to date when it is retrieved. */
  carSetupModifiedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  data?: Maybe<Array<Maybe<SimResultData>>>;
  /** Each data channel is assumed to use this unless it specifies `channelSamplingRate` or `channelTime` */
  defaultChannelTime?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Has the car setup changed since this request/result was created? Returns null if unknown or not applicable. */
  isCarSetupChanged?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Ambient pressure in Pa */
  pAmbient?: Maybe<Scalars['Float']['output']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: Maybe<Scalars['Float']['output']>;
  /** Map containing reference values from car setup. Example: aerobalance in a car manual. Input syntax is array of key-value tuples, like `refValues: [["rAeroBalF", 48.5], ["rLatBalF", 51.4]]`. */
  refValues?: Maybe<Scalars['JSON']['output']>;
  requester?: Maybe<Person>;
  requesterID?: Maybe<Scalars['MongoID']['output']>;
  runSheet?: Maybe<RunSheet>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  /** Version of the ORH service used to generate the sim result */
  serviceVersion?: Maybe<Scalars['String']['output']>;
  simType?: Maybe<EnumSimResultSimType>;
  simulationDriveFile?: Maybe<SimulationDriveFile>;
  simulationDriveFileID?: Maybe<Scalars['MongoID']['output']>;
  simulationService?: Maybe<EnumSimModelType>;
  /** Service which generated this sim result, for example Canopy */
  source?: Maybe<Scalars['String']['output']>;
  /** Reference for this sim result, to find it in the simulation service */
  sourceReferenceID?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<Specification>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  status?: Maybe<EnumSimResultStatus>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  trackLayout?: Maybe<TrackLayout>;
  trackLayoutID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Version of the third-party service used to generate the sim result */
  version?: Maybe<Scalars['String']['output']>;
};

export type SimResultData = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  /** Sampling rate of the channel in Hz, if overriding `defaultChannelTime` without `channelTime` */
  channelSamplingRate?: Maybe<Scalars['Float']['output']>;
  /** Use this to override `defaultChannelTime` */
  channelTime?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Actual channel data values */
  channelValue?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  interpolationMethod?: Maybe<EnumSimResultDataInterpolationMethod>;
  /** Should values in this channel be treated as timestamps? */
  isTimeChannel?: Maybe<Scalars['Boolean']['output']>;
  /** Display unit of channel values (e.g. m/s) */
  unit?: Maybe<Scalars['String']['output']>;
};

export type SimResultDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** Sampling rate of the channel in Hz, if overriding `defaultChannelTime` without `channelTime` */
  channelSamplingRate?: InputMaybe<Scalars['Float']['input']>;
  /** Use this to override `defaultChannelTime` */
  channelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Actual channel data values */
  channelValue?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  interpolationMethod?: InputMaybe<EnumSimResultDataInterpolationMethod>;
  /** Should values in this channel be treated as timestamps? */
  isTimeChannel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display unit of channel values (e.g. m/s) */
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type SimResultPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SimResult>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SimulationDriveFile = {
  _id: Scalars['MongoID']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnumSimulationDriveFileStatus>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  userEnumType?: Maybe<UserEnum>;
  userEnumTypeID?: Maybe<Scalars['MongoID']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type SimulationDriveFilePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SimulationDriveFile>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SingleTyreMileageAtSessionStart = {
  sessions?: Maybe<Array<Maybe<TyreMileageAtSessionStartData>>>;
  tyreID?: Maybe<Scalars['MongoID']['output']>;
};

export type SkidPlate = {
  _id: Scalars['MongoID']['output'];
  barcodeRegulation?: Maybe<Scalars['String']['output']>;
  initialThickness?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
};

/** List of items with pagination. */
export type SkidPlatePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<SkidPlate>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SomeAdjustableProperty = AdjustableAccelerationProperty | AdjustableAngleProperty | AdjustableAngularComplianceProperty | AdjustableAngularTorqueComplianceProperty | AdjustableBooleanProperty | AdjustableComplianceProperty | AdjustableForceProperty | AdjustableInertiaProperty | AdjustableLengthProperty | AdjustableLocationProperty | AdjustableMassProperty | AdjustableNumberProperty | AdjustableOrientationProperty | AdjustablePowerProperty | AdjustablePressureProperty | AdjustableRatioProperty | AdjustableSpringRateProperty | AdjustableSteeringRackRatioProperty | AdjustableStringProperty | AdjustableTemperatureProperty | AdjustableTorqueProperty | AdjustableTorsionRateProperty | AdjustableVolumeProperty;

export type SortFindManyAssemblyInput =
  | 'CARSETUPID_ASC'
  | 'CARSETUPID_DESC'
  | 'CHASSISPARTID_ASC'
  | 'CHASSISPARTID_DESC'
  | 'CHASSISSPECID_ASC'
  | 'CHASSISSPECID_DESC'
  | 'CREATEDAT_ASC'
  | 'CREATEDAT_DESC'
  | 'CURRENT_ASC'
  | 'CURRENT_DESC'
  | 'DECOMMISSIONED_ASC'
  | 'DECOMMISSIONED_DESC'
  | 'LOCATIONID_ASC'
  | 'LOCATIONID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NESTEDPARTINSTANCEIDS_ASC'
  | 'NESTEDPARTINSTANCEIDS_DESC'
  | 'PARENTID_ASC'
  | 'PARENTID_DESC'
  | 'PARTINSTANCEIDS_ASC'
  | 'PARTINSTANCEIDS_DESC'
  | 'REFERENCE_ASC'
  | 'REFERENCE_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'UPDATEDAT_ASC'
  | 'UPDATEDAT_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyAssemblyTemplateInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyBestValuesInput =
  | 'CONTESTANTID_ASC'
  | 'CONTESTANTID_DESC'
  | 'DRIVERID_ASC'
  | 'DRIVERID_DESC'
  | 'SESSIONID_ASC'
  | 'SESSIONID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyBopInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'SESSIONID_ASC'
  | 'SESSIONID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyBuildSheetStyleInput =
  | 'AUTHORID_ASC'
  | 'AUTHORID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyCalculationInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyCarDataServiceConfigInput =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'RACESERIESID_ASC'
  | 'RACESERIESID_DESC'
  | 'VERSION_ASC'
  | 'VERSION_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyCarSetupInput =
  | 'AUTHORID_ASC'
  | 'AUTHORID_DESC'
  | 'CHASSISASSEMBLYID_ASC'
  | 'CHASSISASSEMBLYID_DESC'
  | 'CHASSISID_ASC'
  | 'CHASSISID_DESC'
  | 'CHASSISSPECID_ASC'
  | 'CHASSISSPECID_DESC'
  | 'CHASSISSPECROOTID_ASC'
  | 'CHASSISSPECROOTID_DESC'
  | 'DRIVERID_ASC'
  | 'DRIVERID_DESC'
  | 'ENGINEERID_ASC'
  | 'ENGINEERID_DESC'
  | 'RUNSHEETID_ASC'
  | 'RUNSHEETID_DESC'
  | 'TEAMID_ASC'
  | 'TEAMID_DESC'
  | 'TIME_ASC'
  | 'TIME_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | 'TYRESETID_ASC'
  | 'TYRESETID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyChassisInput =
  | 'MANUFACTURERPARTID_ASC'
  | 'MANUFACTURERPARTID_DESC'
  | 'ROOTSPECIFICATIONID_ASC'
  | 'ROOTSPECIFICATIONID_DESC'
  | 'SETUPSHEETSTYLE_ASC'
  | 'SETUPSHEETSTYLE_DESC'
  | 'SPECIFICATIONID_ASC'
  | 'SPECIFICATIONID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyChassisMeasurementInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyContestantInput =
  | 'CHASSISNUMBER_ASC'
  | 'CHASSISNUMBER_DESC'
  | 'CLASS_ASC'
  | 'CLASS_DESC'
  | 'ELIGIBLEFORPOINTS_ASC'
  | 'ELIGIBLEFORPOINTS_DESC'
  | 'HIDDEN_ASC'
  | 'HIDDEN_DESC'
  | 'SEASONID_ASC'
  | 'SEASONID_DESC'
  | 'SEASONID__STARTNUMBER_ASC'
  | 'SEASONID__STARTNUMBER_DESC'
  | 'STARTNUMBER_ASC'
  | 'STARTNUMBER_DESC'
  | 'TEAMID_ASC'
  | 'TEAMID_DESC'
  | 'THIRDPARTYCONTESTANTID_ASC'
  | 'THIRDPARTYCONTESTANTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyDepartmentInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyDynoConfigInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyEventInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'SEASONID_ASC'
  | 'SEASONID_DESC'
  | 'TEVENTEND_ASC'
  | 'TEVENTEND_DESC'
  | 'TEVENTSTART_ASC'
  | 'TEVENTSTART_DESC'
  | 'THIRDPARTYEVENTID_ASC'
  | 'THIRDPARTYEVENTID_DESC'
  | 'TLAPAVERAGE_ASC'
  | 'TLAPAVERAGE_DESC'
  | 'TRACKID_ASC'
  | 'TRACKID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyFlexLayoutConfigInput =
  | 'AUTHORID_ASC'
  | 'AUTHORID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyIssueQueryInput =
  | 'AREA_ASC'
  | 'AREA_DESC'
  | 'ASSIGNEEIDS_ASC'
  | 'ASSIGNEEIDS_DESC'
  | 'CATEGORY_ASC'
  | 'CATEGORY_DESC'
  | 'CREATEDAT_ASC'
  | 'CREATEDAT_DESC'
  | 'CREATED_BY_NAME_ASC'
  | 'CREATED_BY_NAME_DESC'
  | 'DEPARTMENT_NAME_ASC'
  | 'DEPARTMENT_NAME_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'INDEX_ASC'
  | 'INDEX_DESC'
  | 'ISSUESTATUS_ASC'
  | 'ISSUESTATUS_DESC'
  | 'NUMBER_ASC'
  | 'NUMBER_DESC'
  | 'PRIMARYTAGID_ASC'
  | 'PRIMARYTAGID_DESC'
  | 'PRIMARYTAGLABELSORT_ASC'
  | 'PRIMARYTAGLABELSORT_DESC'
  | 'PRIMARY_ASSIGNEE_NAME_ASC'
  | 'PRIMARY_ASSIGNEE_NAME_DESC'
  | 'PRIMARY_TAG_LABEL_ASC'
  | 'PRIMARY_TAG_LABEL_DESC'
  | 'PRIMARY_TEAM_NAME_ASC'
  | 'PRIMARY_TEAM_NAME_DESC'
  | 'PRIORITY_ASC'
  | 'PRIORITY_DESC'
  | 'RUNSHEETID_ASC'
  | 'RUNSHEETID_DESC'
  | 'UPDATEDAT_ASC'
  | 'UPDATEDAT_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyJobInput =
  | 'ASSIGNEEIDS_ASC'
  | 'ASSIGNEEIDS_DESC'
  | 'CATEGORY_ASC'
  | 'CATEGORY_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'INDEX_ASC'
  | 'INDEX_DESC'
  | 'NUMBER_ASC'
  | 'NUMBER_DESC'
  | 'PARENTID_ASC'
  | 'PARENTID_DESC'
  | 'PRIORITY_ASC'
  | 'PRIORITY_DESC'
  | 'RUNSHEETID_ASC'
  | 'RUNSHEETID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyLapInput =
  | 'BLAPCANCELLED_ASC'
  | 'BLAPCANCELLED_DESC'
  | 'BLAPISSLOW_ASC'
  | 'BLAPISSLOW_DESC'
  | 'BPITIN_ASC'
  | 'BPITIN_DESC'
  | 'BPITOUT_ASC'
  | 'BPITOUT_DESC'
  | 'CONTESTANTID_ASC'
  | 'CONTESTANTID_DESC'
  | 'NLAPRUNCARDATA_ASC'
  | 'NLAPRUNCARDATA_DESC'
  | 'NLAPRUNMANUAL_ASC'
  | 'NLAPRUNMANUAL_DESC'
  | 'NLAPRUN_ASC'
  | 'NLAPRUN_DESC'
  | 'NLAPSESSIONCARDATA_ASC'
  | 'NLAPSESSIONCARDATA_DESC'
  | 'NLAPSESSIONMANUAL_ASC'
  | 'NLAPSESSIONMANUAL_DESC'
  | 'NLAPSESSION_ASC'
  | 'NLAPSESSION_DESC'
  | 'NLAPSTINTCARDATA_ASC'
  | 'NLAPSTINTCARDATA_DESC'
  | 'NLAPSTINTMANUAL_ASC'
  | 'NLAPSTINTMANUAL_DESC'
  | 'NLAPSTINT_ASC'
  | 'NLAPSTINT_DESC'
  | 'RUNSHEETID_ASC'
  | 'RUNSHEETID_DESC'
  | 'SESSIONID_ASC'
  | 'SESSIONID_DESC'
  | 'TDAY_ASC'
  | 'TDAY_DESC'
  | 'TLAPMANUAL_ASC'
  | 'TLAPMANUAL_DESC'
  | 'TLAPMAX_ASC'
  | 'TLAPMAX_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyLapSequenceInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyLapSequenceTemplateInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyLocationInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyLogInput =
  | 'CREATEDAT_ASC'
  | 'CREATEDAT_DESC'
  | 'LOGLEVEL_ASC'
  | 'LOGLEVEL_DESC'
  | 'SERVICESOURCE_ASC'
  | 'SERVICESOURCE_DESC'
  | 'UPDATEDAT_ASC'
  | 'UPDATEDAT_DESC'
  | 'USERID_ASC'
  | 'USERID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyManufacturerInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyOneTimingWeatherServiceConfigInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyPackageInput =
  | 'AUTHORID_ASC'
  | 'AUTHORID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyPartInput =
  | 'CREATEDAT_ASC'
  | 'CREATEDAT_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'ELIGIBLEEVENTTYPES_ASC'
  | 'ELIGIBLEEVENTTYPES_DESC'
  | 'LIFETIMEMILEAGE_ASC'
  | 'LIFETIMEMILEAGE_DESC'
  | 'LOCATION_NAME_ASC'
  | 'LOCATION_NAME_DESC'
  | 'MANUFACTURERPARTID_ASC'
  | 'MANUFACTURERPARTID_DESC'
  | 'MANUFACTURERSERIALNUMBER_ASC'
  | 'MANUFACTURERSERIALNUMBER_DESC'
  | 'MANUFACTURER_NAME_ASC'
  | 'MANUFACTURER_NAME_DESC'
  | 'PARTNUMBER_ASC'
  | 'PARTNUMBER_DESC'
  | 'REFERENCE_ASC'
  | 'REFERENCE_DESC'
  | 'REFERENCE__ROOTSPECIFICATIONID_ASC'
  | 'REFERENCE__ROOTSPECIFICATIONID_DESC'
  | 'ROOTSPECIFICATIONID_ASC'
  | 'ROOTSPECIFICATIONID_DESC'
  | 'SPECIFICATIONID_ASC'
  | 'SPECIFICATIONID_DESC'
  | 'TEAMIDS_ASC'
  | 'TEAMIDS_DESC'
  | 'TEAMID_ASC'
  | 'TEAMID_DESC'
  | 'TEAM_NAME_ASC'
  | 'TEAM_NAME_DESC'
  | 'UPDATEDAT_ASC'
  | 'UPDATEDAT_DESC'
  | 'USERENUMPARTTYPEID_ASC'
  | 'USERENUMPARTTYPEID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyPartInstanceInput =
  | 'SPECIFICATIONID_ASC'
  | 'SPECIFICATIONID_DESC'
  | 'SUPERPARENTID_ASC'
  | 'SUPERPARENTID_DESC'
  | 'SUPERPARENTID__SPECIFICATIONID_ASC'
  | 'SUPERPARENTID__SPECIFICATIONID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyPersonInput =
  | 'ACRONYM_ASC'
  | 'ACRONYM_DESC'
  | 'BIRTHDAY_ASC'
  | 'BIRTHDAY_DESC'
  | 'EMAIL_ASC'
  | 'EMAIL_DESC'
  | 'ISACTIVE_ASC'
  | 'ISACTIVE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'ROLE_ASC'
  | 'ROLE_DESC'
  | 'TEAMID_ASC'
  | 'TEAMID_DESC'
  | 'TIMETRACKERAPPROVALBYPERSONID_ASC'
  | 'TIMETRACKERAPPROVALBYPERSONID_DESC'
  | 'USERNAME_ASC'
  | 'USERNAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyPlotPageConfigInput =
  | 'AUTHORID_ASC'
  | 'AUTHORID_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyPointsSystemInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyProjectInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyQualityCheckActionInput =
  | 'ASSIGNEEIDS_ASC'
  | 'ASSIGNEEIDS_DESC'
  | 'CATEGORY_ASC'
  | 'CATEGORY_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'PRIORITY_ASC'
  | 'PRIORITY_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyQualityCheckInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyRaceSeriesInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyRadioMessageInput =
  | 'CONTESTANTID_ASC'
  | 'CONTESTANTID_DESC'
  | 'DRIVERID_ASC'
  | 'DRIVERID_DESC'
  | 'SESSIONID_ASC'
  | 'SESSIONID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyReportNotesTemplateInput =
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyReportTemplateInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyRunPlanInput =
  | 'CONTESTANTID_ASC'
  | 'CONTESTANTID_DESC'
  | 'SESSIONID_ASC'
  | 'SESSIONID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyRunSheetInput =
  | 'CONTESTANTID_ASC'
  | 'CONTESTANTID_DESC'
  | 'DRIVERID_ASC'
  | 'DRIVERID_DESC'
  | 'ENDTIMECDS_ASC'
  | 'ENDTIMECDS_DESC'
  | 'ENDTIMELTS_ASC'
  | 'ENDTIMELTS_DESC'
  | 'ENDTIMEMANUAL_ASC'
  | 'ENDTIMEMANUAL_DESC'
  | 'ENGINEERID_ASC'
  | 'ENGINEERID_DESC'
  | 'NEXTRUNSHEETID_ASC'
  | 'NEXTRUNSHEETID_DESC'
  | 'NRUNTIMING_ASC'
  | 'NRUNTIMING_DESC'
  | 'NRUN_ASC'
  | 'NRUN_DESC'
  | 'PREVRUNSHEETID_ASC'
  | 'PREVRUNSHEETID_DESC'
  | 'RUNSHEETSTYLEID_ASC'
  | 'RUNSHEETSTYLEID_DESC'
  | 'SESSIONID_ASC'
  | 'SESSIONID_DESC'
  | 'SETUPID_ASC'
  | 'SETUPID_DESC'
  | 'SIMRESULTIDS_ASC'
  | 'SIMRESULTIDS_DESC'
  | 'STARTTIMECDS_ASC'
  | 'STARTTIMECDS_DESC'
  | 'STARTTIMELTS_ASC'
  | 'STARTTIMELTS_DESC'
  | 'STARTTIMEMANUAL_ASC'
  | 'STARTTIMEMANUAL_DESC'
  | 'TEAMID_ASC'
  | 'TEAMID_DESC'
  | 'THIRDPARTYRUNID_ASC'
  | 'THIRDPARTYRUNID_DESC'
  | 'TYRECOMPOUNDTIMING_ASC'
  | 'TYRECOMPOUNDTIMING_DESC'
  | 'TYRESETID_ASC'
  | 'TYRESETID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyRunSheetStyleInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySandboxUnitsInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySeasonInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'RACESERIESID_ASC'
  | 'RACESERIESID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySessionInput =
  | 'EVENTID_ASC'
  | 'EVENTID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'SHORTNAME_ASC'
  | 'SHORTNAME_DESC'
  | 'THIRDPARTYSESSIONID_ASC'
  | 'THIRDPARTYSESSIONID_DESC'
  | 'TRANSCRIBBLESESSIONID_ASC'
  | 'TRANSCRIBBLESESSIONID_DESC'
  | 'TSESSIONEND_ASC'
  | 'TSESSIONEND_DESC'
  | 'TSESSIONSTART_ASC'
  | 'TSESSIONSTART_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySetupOverviewConfigInput =
  | 'AUTHORID_ASC'
  | 'AUTHORID_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySetupSheetStyleInput =
  | 'AUTHORID_ASC'
  | 'AUTHORID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySimRequestInput =
  | 'CARSETUPID_ASC'
  | 'CARSETUPID_DESC'
  | 'CREATEDAT_ASC'
  | 'CREATEDAT_DESC'
  | 'REQUESTERID_ASC'
  | 'REQUESTERID_DESC'
  | 'RUNSHEETID_ASC'
  | 'RUNSHEETID_DESC'
  | 'SIMRESULTID_ASC'
  | 'SIMRESULTID_DESC'
  | 'SIMTYPE_ASC'
  | 'SIMTYPE_DESC'
  | 'SIMULATIONSERVICE_ASC'
  | 'SIMULATIONSERVICE_DESC'
  | 'SPECIFICATIONID_ASC'
  | 'SPECIFICATIONID_DESC'
  | 'TRACKLAYOUTID_ASC'
  | 'TRACKLAYOUTID_DESC'
  | 'UPDATEDAT_ASC'
  | 'UPDATEDAT_DESC'
  | 'VERSION_ASC'
  | 'VERSION_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySimResultInput =
  | 'CARSETUPID_ASC'
  | 'CARSETUPID_DESC'
  | 'CREATEDAT_ASC'
  | 'CREATEDAT_DESC'
  | 'REQUESTERID_ASC'
  | 'REQUESTERID_DESC'
  | 'RUNSHEETID_ASC'
  | 'RUNSHEETID_DESC'
  | 'SERVICEVERSION_ASC'
  | 'SERVICEVERSION_DESC'
  | 'SIMTYPE_ASC'
  | 'SIMTYPE_DESC'
  | 'SIMULATIONSERVICE_ASC'
  | 'SIMULATIONSERVICE_DESC'
  | 'SOURCEREFERENCEID_ASC'
  | 'SOURCEREFERENCEID_DESC'
  | 'SOURCE_ASC'
  | 'SOURCE_DESC'
  | 'SPECIFICATIONID_ASC'
  | 'SPECIFICATIONID_DESC'
  | 'TRACKLAYOUTID_ASC'
  | 'TRACKLAYOUTID_DESC'
  | 'UPDATEDAT_ASC'
  | 'UPDATEDAT_DESC'
  | 'VERSION_ASC'
  | 'VERSION_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySimulationDriveFileInput =
  | 'STATUS_ASC'
  | 'STATUS_DESC'
  | 'USERENUMTYPEID_ASC'
  | 'USERENUMTYPEID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySkidPlateInput =
  | 'BARCODEREGULATION_ASC'
  | 'BARCODEREGULATION_DESC'
  | 'INITIALTHICKNESS_ASC'
  | 'INITIALTHICKNESS_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySpecificationInput =
  | 'ALLOWABLEPARENTSPECIDS_ASC'
  | 'ALLOWABLEPARENTSPECIDS_DESC'
  | 'CANOPYVERSION_ASC'
  | 'CANOPYVERSION_DESC'
  | 'CHASSISSPECID_ASC'
  | 'CHASSISSPECID_DESC'
  | 'ITERATIONIDS_ASC'
  | 'ITERATIONIDS_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NEXTITERATIONID_ASC'
  | 'NEXTITERATIONID_DESC'
  | 'PREVITERATIONID_ASC'
  | 'PREVITERATIONID_DESC'
  | 'ROOTSPECIFICATIONID_ASC'
  | 'ROOTSPECIFICATIONID_DESC'
  | 'SPECIFICATIONGROUPIDS_ASC'
  | 'SPECIFICATIONGROUPIDS_DESC'
  | 'VERSION_ASC'
  | 'VERSION_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySsoProviderInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTagInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTeamInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'RACESERIESID_ASC'
  | 'RACESERIESID_DESC'
  | 'SHORTNAME_ASC'
  | 'SHORTNAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTemplateJobListInput =
  | 'INDEX_ASC'
  | 'INDEX_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTemplateSessionDebriefInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTimeSheetEntryInput =
  | 'PROJECTID_ASC'
  | 'PROJECTID_DESC'
  | 'TEND_ASC'
  | 'TEND_DESC'
  | 'TSTART_ASC'
  | 'TSTART_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTimingServiceConfigInput =
  | 'EVENTID_ASC'
  | 'EVENTID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'UPDATEDAT_ASC'
  | 'UPDATEDAT_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTrackInput =
  | 'ACRONYM_ASC'
  | 'ACRONYM_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTrackLayoutInput =
  | 'ACRONYM_ASC'
  | 'ACRONYM_DESC'
  | 'LAPLENGTHOFFICIAL_ASC'
  | 'LAPLENGTHOFFICIAL_DESC'
  | 'TRACKID_ASC'
  | 'TRACKID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTrackableInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'ROOTSPECIFICATIONID_ASC'
  | 'ROOTSPECIFICATIONID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTrackingItemInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTrackingMeasurementInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTrackingMeasurementRecordInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTrackingRecordInput =
  | 'PARTID_ASC'
  | 'PARTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTrackingSourceAliasInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTrackingSourceInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTyreInput =
  | 'ADDITIONALSORTPROPERTY_ASC'
  | 'ADDITIONALSORTPROPERTY_DESC'
  | 'BARCODEMANUFACTURER_ASC'
  | 'BARCODEMANUFACTURER_DESC'
  | 'BARCODEREGULATION_ASC'
  | 'BARCODEREGULATION_DESC'
  | 'BARCODERIM_ASC'
  | 'BARCODERIM_DESC'
  | 'BARCODETPMS_ASC'
  | 'BARCODETPMS_DESC'
  | 'BATTERYTPMS_ASC'
  | 'BATTERYTPMS_DESC'
  | 'COMPOUND_ASC'
  | 'COMPOUND_DESC'
  | 'MANUFACTURER_ASC'
  | 'MANUFACTURER_DESC'
  | 'MTYRE_ASC'
  | 'MTYRE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'SEASONID_ASC'
  | 'SEASONID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTyreSetInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NUMBER_ASC'
  | 'NUMBER_DESC'
  | 'TYREIDFL_ASC'
  | 'TYREIDFL_DESC'
  | 'TYREIDFR_ASC'
  | 'TYREIDFR_DESC'
  | 'TYREIDRL_ASC'
  | 'TYREIDRL_DESC'
  | 'TYREIDRR_ASC'
  | 'TYREIDRR_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTyreWearInput =
  | 'DATE_ASC'
  | 'DATE_DESC'
  | 'TYREID_ASC'
  | 'TYREID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyUserEnumInput =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyWeatherInput =
  | 'EVENTIDS_ASC'
  | 'EVENTIDS_DESC'
  | 'SOURCE_ASC'
  | 'SOURCE_DESC'
  | 'TIME_ASC'
  | 'TIME_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyWeatherServiceConfigInput =
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneReportNoteInput =
  | 'EVENTID_ASC'
  | 'EVENTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type Specification = AeroElementSpec | AeroPackageSpec | AntiRollBarSpec | ChassisSpec | CustomSpec | DamperSpec | DifferentialSpec | ElasticSpec | GearBoxSpec | GearSpec | KinematicsExternalSpec | KinematicsInternalSpec;

export type SpecificationACamber = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  readingsRequired?: Maybe<EnumSpecificationACamberReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumSpecificationACamberUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type SpecificationACamberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationACamberReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationACamberUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type SpecificationAdmin = {
  CxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  CzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  FSpringSetup?: Maybe<AdjustableForce>;
  _id: Scalars['MongoID']['output'];
  aCamber?: Maybe<SpecificationACamber>;
  aCaster?: Maybe<SpecificationACamber>;
  aCasterMeasurementGain?: Maybe<Scalars['Float']['output']>;
  aCasterMeasurementOffset?: Maybe<Scalars['Float']['output']>;
  aToe?: Maybe<SpecificationACamber>;
  adjustableProperties?: Maybe<Array<Maybe<AdjustableProperty>>>;
  aeroElementInterpolationMethod?: Maybe<EnumSpecificationAdminAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  aeroElementType?: Maybe<EnumSpecificationAdminAeroElementType>;
  aeroPackageSpecID?: Maybe<Scalars['MongoID']['output']>;
  aeroPackageSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  antiRollBarConfigs?: Maybe<Array<Maybe<AntiRollBarConfig>>>;
  antiRollBarDisplayLocation?: Maybe<EnumSpecificationAdminAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: Maybe<Array<Maybe<AssignedGear>>>;
  attachable?: Maybe<Scalars['Boolean']['output']>;
  axle?: Maybe<EnumSpecificationAdminAxle>;
  bevelSetSpecID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetVisible?: Maybe<Scalars['Boolean']['output']>;
  bumpRubberReference?: Maybe<EnumSpecificationAdminBumpRubberReference>;
  bumpRubberSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  bumpStopGapMethod?: Maybe<EnumSpecificationAdminBumpStopGapMethod>;
  calculationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: Maybe<Scalars['String']['output']>;
  chassisMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: Maybe<Scalars['Boolean']['output']>;
  copyReferencePackageID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customSimulationModels?: Maybe<Array<Maybe<SpecificationCustomSimulationModels>>>;
  customSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  customSpecType?: Maybe<Scalars['String']['output']>;
  customTables?: Maybe<Array<Maybe<SpecificationCustomTables>>>;
  damperAdjusters?: Maybe<Array<Maybe<DamperAdjuster>>>;
  damperConfigs?: Maybe<Array<Maybe<DamperConfig>>>;
  damperSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  denominator?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  differentialConfigs?: Maybe<Array<Maybe<DifferentialConfig>>>;
  differentialSpecID?: Maybe<Scalars['MongoID']['output']>;
  drawingNumber?: Maybe<Scalars['String']['output']>;
  dropGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  elasticType?: Maybe<EnumSpecificationAdminElasticType>;
  forceTable?: Maybe<ForceTable>;
  gearType?: Maybe<EnumSpecificationAdminGearType>;
  hRide?: Maybe<SpecificationHRide>;
  hasToBeInSubAssembly?: Maybe<Scalars['Boolean']['output']>;
  headGearSpecID?: Maybe<Scalars['MongoID']['output']>;
  helperSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  initialChassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: Maybe<Scalars['Boolean']['output']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Spring constant of the elastic element. */
  kSpring?: Maybe<Scalars['Float']['output']>;
  kinematicsExternalModels?: Maybe<Array<Maybe<KinematicsExternalModel>>>;
  kinematicsExternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  kinematicsInternalSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  manufacturerID?: Maybe<Scalars['MongoID']['output']>;
  manufacturerReference?: Maybe<Scalars['String']['output']>;
  mass?: Maybe<ChassisMass>;
  massProperties?: Maybe<MassProperties>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: Maybe<ChassisMeasurements>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: Maybe<Array<Maybe<EnumSpecificationAdminModelTypes>>>;
  name: Scalars['String']['output'];
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: Maybe<Scalars['MongoID']['output']>;
  numerator?: Maybe<Scalars['Float']['output']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  polyCxT?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzF?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  polyCzR?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  positionNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  positions?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  powerUnits?: Maybe<Array<Maybe<ChassisPowerUnit>>>;
  powertrain?: Maybe<ChassisPowertrain>;
  powertrainLocation?: Maybe<EnumSpecificationAdminPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: Maybe<Scalars['MongoID']['output']>;
  rBrakeBias?: Maybe<AdjustableRatio>;
  /** Position of the specification on the car */
  readingsAllowable?: Maybe<Array<Maybe<EnumSpecificationAdminReadingsAllowable>>>;
  readingsRequired?: Maybe<EnumSpecificationAdminReadingsRequired>;
  reboundSpringSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  reference?: Maybe<Scalars['String']['output']>;
  regulationSets?: Maybe<Array<Maybe<RegulationSet>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: Maybe<Scalars['Date']['output']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: Maybe<Scalars['Boolean']['output']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID: Scalars['MongoID']['output'];
  setupChangesFilter?: Maybe<SpecificationSetupChangesFilter>;
  setupSheetStyleIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: Maybe<Scalars['MongoID']['output']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: Maybe<Scalars['MongoID']['output']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: Maybe<Scalars['JSON']['output']>;
  /** Locations/areas that components can be installed in. */
  sockets?: Maybe<Array<Maybe<ChassisSocket>>>;
  specificationGroupID?: Maybe<Scalars['MongoID']['output']>;
  specificationGroupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  springReference?: Maybe<EnumSpecificationAdminSpringReference>;
  springSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  torsionBarSpecIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingItemIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  trackingSourceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  type: EnumSpecificationAdminType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User-supplied version of this specification. */
  version?: Maybe<Scalars['String']['output']>;
  xBumpRubberRef?: Maybe<Scalars['Float']['output']>;
  xBumpRubberSetup?: Maybe<AdjustableLength>;
  xBumpStopGapDefault?: Maybe<Scalars['Float']['output']>;
  xDamperDroopDefault?: Maybe<Scalars['Float']['output']>;
  xDamperSetupDefault?: Maybe<Scalars['Float']['output']>;
  xDroopStopGapDefault?: Maybe<Scalars['Float']['output']>;
  /** Length of the elastic element under no force */
  xFree?: Maybe<Scalars['Float']['output']>;
  xShaftDroopDefault?: Maybe<Scalars['Float']['output']>;
  xSpringPlatformOffset?: Maybe<Scalars['Float']['output']>;
  xSpringRef?: Maybe<Scalars['Float']['output']>;
  xSpringSetup?: Maybe<AdjustableLength>;
  xToe?: Maybe<SpecificationHRide>;
};

export type SpecificationCustomSimulationModels = {
  data?: Maybe<Scalars['JSON']['output']>;
  dataMapping?: Maybe<EnumSpecificationCustomSimulationModelsDataMapping>;
  endPoint?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  serverPort?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SpecificationCustomSimulationModelsInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  dataMapping?: InputMaybe<EnumSpecificationCustomSimulationModelsDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serverPort?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type SpecificationCustomTables = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Table>;
};

export type SpecificationCustomTablesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<TableInput>;
};

export type SpecificationGroup = {
  _id: Scalars['MongoID']['output'];
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  specificationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  specifications: Array<BaseSpecification>;
};

export type SpecificationHRide = {
  defaultValue?: Maybe<Scalars['Float']['output']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: Maybe<Scalars['Boolean']['output']>;
  fixedPoint?: Maybe<Scalars['Float']['output']>;
  /** Maximum value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum value */
  minValue?: Maybe<Scalars['Float']['output']>;
  readingsRequired?: Maybe<EnumSpecificationHRideReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: Maybe<Scalars['Boolean']['output']>;
  /** Increment to suggest values in, if applicable */
  step?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumSpecificationHRideUnit>;
  /** Names to associate with values array */
  valueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type SpecificationHRideInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationHRideReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationHRideUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** List of items with pagination. */
export type SpecificationPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Specification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SpecificationSetupChangesFilter = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  /** List of setup fields to hide */
  blackListFilter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of setup fields to show */
  whiteListFilter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SpecificationSetupChangesFilterInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of setup fields to hide */
  blackListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of setup fields to show */
  whiteListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Spring = {
  /**
   * Diameter of the spring/torsion bar
   * @deprecated
   */
  dSpring?: Maybe<Scalars['Float']['output']>;
  /**
   * Helper spring constant (SI)
   * @deprecated
   */
  kHelperSpring?: Maybe<Scalars['Float']['output']>;
  /**
   * Helper spring constant (imperial)
   * @deprecated
   */
  kHelperSpringLbsIn?: Maybe<Scalars['Float']['output']>;
  /**
   * Spring constant (SI) - N/m (take care of motion ratio)
   * @deprecated
   */
  kSpring?: Maybe<Scalars['Float']['output']>;
  /**
   * Spring constant (imperial)
   * @deprecated
   */
  kSpringLbsIn?: Maybe<Scalars['Float']['output']>;
  specification?: Maybe<ElasticSpec>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  /**
   * Map of spring travel (xSpring) in mm to spring force (FSpring) in N. Input syntax is array of key-value tuples, like `springForceTable: [["0", 0], ["0.5", 0.1], ["1", 0.2]]`.
   * @deprecated
   */
  springForceTable?: Maybe<Scalars['JSON']['output']>;
  /** Transition gap for double coil spring setups */
  xSecondSpringTransition?: Maybe<Scalars['Float']['output']>;
  /** Spring preload (mm) */
  xSpringPreload?: Maybe<Scalars['Float']['output']>;
};

export type SpringInput = {
  /** Diameter of the spring/torsion bar */
  dSpring?: InputMaybe<Scalars['Float']['input']>;
  /** Helper spring constant (SI) */
  kHelperSpring?: InputMaybe<Scalars['Float']['input']>;
  /** Helper spring constant (imperial) */
  kHelperSpringLbsIn?: InputMaybe<Scalars['Float']['input']>;
  /** Spring constant (SI) - N/m (take care of motion ratio) */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  /** Spring constant (imperial) */
  kSpringLbsIn?: InputMaybe<Scalars['Float']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Map of spring travel (xSpring) in mm to spring force (FSpring) in N. Input syntax is array of key-value tuples, like `springForceTable: [["0", 0], ["0.5", 0.1], ["1", 0.2]]`. */
  springForceTable?: InputMaybe<Scalars['JSON']['input']>;
  /** Transition gap for double coil spring setups */
  xSecondSpringTransition?: InputMaybe<Scalars['Float']['input']>;
  /** Spring preload (mm) */
  xSpringPreload?: InputMaybe<Scalars['Float']['input']>;
};

export type SpringRate = {
  /** N/m */
  newtonsPerMetre: Scalars['Float']['output'];
  /** N/mm */
  newtonsPerMillimetre: Scalars['Float']['output'];
  /** lb/in */
  poundsPerInch: Scalars['Float']['output'];
};

export type SpringRateInput = {
  /** N/m */
  newtonsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** N/mm */
  newtonsPerMillimetre: Scalars['Float']['input'];
  /** lb/in */
  poundsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type SpringRateUnitField = {
  unit: EnumSpringRateUnit;
};

export type SsoProvider = {
  _id: Scalars['MongoID']['output'];
  clientID: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  issuerURL: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Steering = {
  rSteerF?: Maybe<Scalars['Float']['output']>;
  steeringArm?: Maybe<Scalars['String']['output']>;
  steeringPinion?: Maybe<Scalars['String']['output']>;
};

export type SteeringInput = {
  rSteerF?: InputMaybe<Scalars['Float']['input']>;
  steeringArm?: InputMaybe<Scalars['String']['input']>;
  steeringPinion?: InputMaybe<Scalars['String']['input']>;
};

export type SteeringRackRatioUnitField = {
  unit: EnumSteeringRackRatioUnit;
};

export type StringUnitField = {
  unit: EnumUntypedUnit;
};

export type SubAssembly = AnyAssembly & AnySubAssembly & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  allPartInstanceActive?: Maybe<Scalars['Boolean']['output']>;
  assemblyTemplateID?: Maybe<Scalars['MongoID']['output']>;
  assemblyTypeEnum?: Maybe<UserEnumAssemblyType>;
  assemblyTypeEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetDisplayLocationIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  buildSheetDisplayLocations: Array<UserEnumBuildSheetGroup>;
  buildSheetGroupEnum?: Maybe<UserEnumBuildSheetGroup>;
  buildSheetGroupEnumID?: Maybe<Scalars['MongoID']['output']>;
  buildSheetNestLevel?: Maybe<Scalars['Float']['output']>;
  carSetup?: Maybe<CarSetup>;
  chassisSpecID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: Maybe<Scalars['Boolean']['output']>;
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  nestedPartInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  nestedPartInstances: Array<PartInstance>;
  parentID?: Maybe<Scalars['MongoID']['output']>;
  partInstanceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  partInstances: Array<PartInstance>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  subAssemblies: Array<SubAssembly>;
  subAssemblyIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  superParentName?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userEnumAssemblyTypeID?: Maybe<Scalars['MongoID']['output']>;
};

export type Subscription = {
  assemblyAdded?: Maybe<BaseAssembly>;
  assemblyRemoved?: Maybe<BaseAssembly>;
  assemblyUpdated?: Maybe<BaseAssembly>;
  /** If contestantID or driverID are not supplied, this will *only* watch for overall bests. */
  bestValuesAdded?: Maybe<BestValues>;
  bestValuesUpdated?: Maybe<BestValues>;
  carSetupChangedInSessions?: Maybe<CarSetupChanged>;
  carSetupInfoInSessionsUpdated?: Maybe<CarSetupInfo>;
  carSetupRemoved?: Maybe<CarSetup>;
  carSetupUpdated?: Maybe<CarSetup>;
  eventUpdated?: Maybe<Event>;
  greeboLogCarPositions: Array<CarTrackPosition>;
  greeboLogGPSData: Array<CarGpsDataPoint>;
  greeboLogRawLines: Array<Scalars['String']['output']>;
  jobAdded?: Maybe<Job>;
  jobRemoved?: Maybe<Job>;
  jobUpdated?: Maybe<Job>;
  logAdded?: Maybe<Log>;
  oneTimingWeatherServiceConfigAdded?: Maybe<OneTimingWeatherServiceConfig>;
  oneTimingWeatherServiceConfigRemoved?: Maybe<OneTimingWeatherServiceConfig>;
  oneTimingWeatherServiceConfigUpdated?: Maybe<OneTimingWeatherServiceConfig>;
  partAdded?: Maybe<Part>;
  partInstanceAdded?: Maybe<PartInstance>;
  partInstanceRemoved?: Maybe<PartInstance>;
  partInstanceUpdated?: Maybe<PartInstance>;
  partRemoved?: Maybe<Part>;
  partUpdated?: Maybe<Part>;
  reportNoteUpdated?: Maybe<ReportNote>;
  runPlanAdded?: Maybe<RunPlan>;
  runPlanRemoved?: Maybe<RunPlan>;
  runPlanUpdated?: Maybe<RunPlan>;
  runSheetAdded?: Maybe<RunSheet>;
  runSheetInSessionsAdded?: Maybe<RunSheet>;
  runSheetInSessionsRemoved?: Maybe<RemovedRunSheet>;
  runSheetInSessionsUpdated?: Maybe<RunSheet>;
  runSheetInfoInSessionsUpdated?: Maybe<RunSheetInfo>;
  runSheetRemoved?: Maybe<RemovedRunSheet>;
  runSheetUpdated?: Maybe<RunSheet>;
  sessionUpdated?: Maybe<Session>;
  simRequestAdded?: Maybe<SimRequest>;
  simRequestRemoved?: Maybe<SimRequest>;
  simRequestUpdated?: Maybe<SimRequest>;
  simResultAdded?: Maybe<SimResult>;
  simResultRemoved?: Maybe<SimResult>;
  simResultUpdated?: Maybe<SimResult>;
  timingServiceConfigAdded?: Maybe<TimingServiceConfig>;
  timingServiceConfigRemoved?: Maybe<TimingServiceConfig>;
  timingServiceConfigUpdated?: Maybe<TimingServiceConfig>;
  timingServiceStatusUpdated?: Maybe<TimingServiceStatus>;
  timingsUpdated: Array<DriverTiming>;
  weatherAdded?: Maybe<Weather>;
  weatherRemoved?: Maybe<Weather>;
  weatherServiceConfigUpdated?: Maybe<WeatherServiceConfig>;
  weatherUpdated?: Maybe<Weather>;
};


export type SubscriptionAssemblyAddedArgs = {
  assemblyID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionAssemblyRemovedArgs = {
  assemblyID: Scalars['MongoID']['input'];
};


export type SubscriptionAssemblyUpdatedArgs = {
  assemblyID: Scalars['MongoID']['input'];
};


export type SubscriptionBestValuesAddedArgs = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID: Scalars['MongoID']['input'];
};


export type SubscriptionBestValuesUpdatedArgs = {
  bestValuesID: Scalars['MongoID']['input'];
};


export type SubscriptionCarSetupChangedInSessionsArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionCarSetupInfoInSessionsUpdatedArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionCarSetupRemovedArgs = {
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionCarSetupUpdatedArgs = {
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionEventUpdatedArgs = {
  eventID: Scalars['MongoID']['input'];
};


export type SubscriptionGreeboLogCarPositionsArgs = {
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionGreeboLogGpsDataArgs = {
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionGreeboLogRawLinesArgs = {
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionJobAddedArgs = {
  assigneeID?: InputMaybe<Scalars['MongoID']['input']>;
  jobID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionJobRemovedArgs = {
  assigneeID?: InputMaybe<Scalars['MongoID']['input']>;
  jobID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionJobUpdatedArgs = {
  assigneeID?: InputMaybe<Scalars['MongoID']['input']>;
  jobID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionLogAddedArgs = {
  serviceSource?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOneTimingWeatherServiceConfigRemovedArgs = {
  weatherServiceConfigID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionOneTimingWeatherServiceConfigUpdatedArgs = {
  weatherServiceConfigID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionPartAddedArgs = {
  partID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionPartInstanceAddedArgs = {
  partInstanceID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionPartInstanceRemovedArgs = {
  partInstanceID: Scalars['MongoID']['input'];
};


export type SubscriptionPartInstanceUpdatedArgs = {
  partInstanceID: Scalars['MongoID']['input'];
};


export type SubscriptionPartRemovedArgs = {
  partID: Scalars['MongoID']['input'];
};


export type SubscriptionPartUpdatedArgs = {
  partID: Scalars['MongoID']['input'];
};


export type SubscriptionReportNoteUpdatedArgs = {
  eventID: Scalars['MongoID']['input'];
};


export type SubscriptionRunPlanUpdatedArgs = {
  runPlanID: Scalars['MongoID']['input'];
};


export type SubscriptionRunSheetAddedArgs = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetInSessionsAddedArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetInSessionsRemovedArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetInSessionsUpdatedArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetInfoInSessionsUpdatedArgs = {
  contestantID: Scalars['MongoID']['input'];
  sessionIDs: Array<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetRemovedArgs = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionRunSheetUpdatedArgs = {
  runSheetID: Scalars['MongoID']['input'];
};


export type SubscriptionSessionUpdatedArgs = {
  sessionID: Scalars['MongoID']['input'];
};


export type SubscriptionSimRequestAddedArgs = {
  simRequestID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionSimRequestRemovedArgs = {
  simRequestID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionSimRequestUpdatedArgs = {
  simRequestID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
};


export type SubscriptionSimResultRemovedArgs = {
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionSimResultUpdatedArgs = {
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
};


export type SubscriptionTimingServiceConfigRemovedArgs = {
  timingServiceConfigID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionTimingServiceConfigUpdatedArgs = {
  timingServiceConfigID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionTimingServiceStatusUpdatedArgs = {
  timingServiceStatusID?: InputMaybe<Scalars['MongoID']['input']>;
};


export type SubscriptionTimingsUpdatedArgs = {
  sessionID: Scalars['MongoID']['input'];
};


export type SubscriptionWeatherServiceConfigUpdatedArgs = {
  weatherServiceConfigID: Scalars['MongoID']['input'];
};


export type SubscriptionWeatherUpdatedArgs = {
  weatherID: Scalars['MongoID']['input'];
};

export type Suspension = {
  /** Camber angle */
  aCamber?: Maybe<Scalars['Float']['output']>;
  /** Camber angle measurement in radians (if `aCamber` should be used as a target) */
  aCamberMeasurement?: Maybe<Scalars['Float']['output']>;
  /** Camber shim angle */
  aCamberShim?: Maybe<Scalars['Float']['output']>;
  /** Caster angle */
  aCaster?: Maybe<Scalars['Float']['output']>;
  /** Caster angle measurement (if direct measurement isn't possible or aCaster should be used as a target) */
  aCasterMeasurement?: Maybe<Scalars['Float']['output']>;
  /** Caster option */
  aCasterOption?: Maybe<Scalars['String']['output']>;
  /** Toe angle */
  aToe?: Maybe<Scalars['Float']['output']>;
  /** Toe angle measurement in radians (if `aToe` should be used as a target) */
  aToeMeasurement?: Maybe<Scalars['Float']['output']>;
  hBumpStopPacker?: Maybe<Scalars['Float']['output']>;
  hBumpStopStack?: Maybe<Scalars['Float']['output']>;
  /** Camber shim height */
  hCamberShim?: Maybe<Scalars['Float']['output']>;
  /** Push rod shim height */
  hPushRodShim?: Maybe<Scalars['Float']['output']>;
  /** Toe link sleeve height to adjust vertical position */
  hToeLinkSleeveBottom?: Maybe<Scalars['Float']['output']>;
  /** Toe link sleeve height to adjust vertical position */
  hToeLinkSleeveTop?: Maybe<Scalars['Float']['output']>;
  /** Toe shim height */
  hToeShim?: Maybe<Scalars['Float']['output']>;
  /** Pushrod-on-upright bracket */
  prouBracket?: Maybe<Scalars['String']['output']>;
  /** Pushrod-on-upright position */
  prouPosition?: Maybe<Scalars['String']['output']>;
  xBumpStopGap?: Maybe<Scalars['Float']['output']>;
  /** Camber angle measurement in metres (if direct angle measurement isn't possible) */
  xCamberMeasurement?: Maybe<Scalars['Float']['output']>;
  xDroopStopGap?: Maybe<Scalars['Float']['output']>;
  /** Toe as measured in metres */
  xToe?: Maybe<Scalars['Float']['output']>;
  /** Toe angle measurement in metres (if direct angle measurement isn't possible) */
  xToeMeasurement?: Maybe<Scalars['Float']['output']>;
};

export type SuspensionInput = {
  /** Camber angle */
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  /** Camber angle measurement in radians (if `aCamber` should be used as a target) */
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Camber shim angle */
  aCamberShim?: InputMaybe<Scalars['Float']['input']>;
  /** Caster angle */
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  /** Caster angle measurement (if direct measurement isn't possible or aCaster should be used as a target) */
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Caster option */
  aCasterOption?: InputMaybe<Scalars['String']['input']>;
  /** Toe angle */
  aToe?: InputMaybe<Scalars['Float']['input']>;
  /** Toe angle measurement in radians (if `aToe` should be used as a target) */
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  hBumpStopPacker?: InputMaybe<Scalars['Float']['input']>;
  hBumpStopStack?: InputMaybe<Scalars['Float']['input']>;
  /** Camber shim height */
  hCamberShim?: InputMaybe<Scalars['Float']['input']>;
  /** Push rod shim height */
  hPushRodShim?: InputMaybe<Scalars['Float']['input']>;
  /** Toe link sleeve height to adjust vertical position */
  hToeLinkSleeveBottom?: InputMaybe<Scalars['Float']['input']>;
  /** Toe link sleeve height to adjust vertical position */
  hToeLinkSleeveTop?: InputMaybe<Scalars['Float']['input']>;
  /** Toe shim height */
  hToeShim?: InputMaybe<Scalars['Float']['input']>;
  /** Pushrod-on-upright bracket */
  prouBracket?: InputMaybe<Scalars['String']['input']>;
  /** Pushrod-on-upright position */
  prouPosition?: InputMaybe<Scalars['String']['input']>;
  xBumpStopGap?: InputMaybe<Scalars['Float']['input']>;
  /** Camber angle measurement in metres (if direct angle measurement isn't possible) */
  xCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  xDroopStopGap?: InputMaybe<Scalars['Float']['input']>;
  /** Toe as measured in metres */
  xToe?: InputMaybe<Scalars['Float']['input']>;
  /** Toe angle measurement in metres (if direct angle measurement isn't possible) */
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type SwapPartInstanceResult = {
  newPartInstanceID: Scalars['MongoID']['output'];
};

export type Table = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  columnNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  columnValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Table data in 1d vector. It's up to the consumer to reshape appropriately. OneRacehub internally uses row chunks. */
  data: Array<Maybe<Scalars['Float']['output']>>;
  decimals?: Maybe<Scalars['Float']['output']>;
  depth?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  rowNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sliceNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sliceValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  width: Scalars['Float']['output'];
};

export type TableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  columnNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columnValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Table data in 1d vector. It's up to the consumer to reshape appropriately. OneRacehub internally uses row chunks. */
  data: Array<InputMaybe<Scalars['Float']['input']>>;
  decimals?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  rowNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  width: Scalars['Float']['input'];
};

export type Tag = {
  _id: Scalars['MongoID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  tagType?: Maybe<EnumTagType>;
};

/** List of items with pagination. */
export type TagPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Tag>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Team = {
  _id: Scalars['MongoID']['output'];
  /** Default color to use for this team where applicable. */
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  raceSeries?: Maybe<RaceSeries>;
  /** Used only for filtering to limit which teams are displayed in a list. */
  raceSeriesID?: Maybe<Scalars['MongoID']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
};

export type TeamChampionshipStanding = {
  contestantIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  contestants: Array<Contestant>;
  points: Scalars['Int']['output'];
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: Maybe<Scalars['Int']['output']>;
  team?: Maybe<Team>;
  teamDrivers?: Maybe<Array<Maybe<DriverChampionshipStanding>>>;
  teamID: Scalars['MongoID']['output'];
};

export type TeamChampionshipStandingInput = {
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  points: Scalars['Int']['input'];
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  teamDrivers?: InputMaybe<Array<InputMaybe<DriverChampionshipStandingInput>>>;
  teamID: Scalars['MongoID']['input'];
};

/** List of items with pagination. */
export type TeamPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Team>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Temperature = {
  /** °C */
  celsius: Scalars['Float']['output'];
  /** °F */
  fahrenheit: Scalars['Float']['output'];
  /** °K */
  kelvin: Scalars['Float']['output'];
};

export type TemperatureInput = {
  /** °C */
  celsius?: InputMaybe<Scalars['Float']['input']>;
  /** °F */
  fahrenheit?: InputMaybe<Scalars['Float']['input']>;
  /** °K */
  kelvin?: InputMaybe<Scalars['Float']['input']>;
};

export type TemperatureUnitField = {
  unit: EnumTemperatureUnit;
};

export type TemplateJob = {
  assigneeIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  assignees: Array<Person>;
  category?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<EnumJobPriority>;
};

export type TemplateJobInput = {
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
};

export type TemplateJobList = {
  _id: Scalars['MongoID']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  jobs: Array<Maybe<TemplateJob>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags?: Maybe<Tag>;
  title: Scalars['String']['output'];
};

/** List of items with pagination. */
export type TemplateJobListPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TemplateJobList>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TemplateSessionDebrief = {
  _id: Scalars['MongoID']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumTemplateSessionDebriefMode>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** List of items with pagination. */
export type TemplateSessionDebriefPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TemplateSessionDebrief>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ThirdElement = {
  bumpStop?: Maybe<ThirdElementBumpStop>;
  hBumpStopPacker?: Maybe<Scalars['Float']['output']>;
  /** Helper spring constant (SI) */
  kHelperSpring?: Maybe<Scalars['Float']['output']>;
  /** Helper spring constant (imperial) */
  kHelperSpringLbsIn?: Maybe<Scalars['Float']['output']>;
  /** Spring constant (SI) */
  kSpring?: Maybe<Scalars['Float']['output']>;
  /** Spring constant (imperial) */
  kSpringLbsIn?: Maybe<Scalars['Float']['output']>;
  xBumpStopGap?: Maybe<Scalars['Float']['output']>;
  /** Spring preload (mm) */
  xSpringPreload?: Maybe<Scalars['Float']['output']>;
};

export type ThirdElementBumpStop = {
  name?: Maybe<Scalars['String']['output']>;
};

export type ThirdElementBumpStopInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ThirdElementInput = {
  bumpStop?: InputMaybe<ThirdElementBumpStopInput>;
  hBumpStopPacker?: InputMaybe<Scalars['Float']['input']>;
  /** Helper spring constant (SI) */
  kHelperSpring?: InputMaybe<Scalars['Float']['input']>;
  /** Helper spring constant (imperial) */
  kHelperSpringLbsIn?: InputMaybe<Scalars['Float']['input']>;
  /** Spring constant (SI) */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  /** Spring constant (imperial) */
  kSpringLbsIn?: InputMaybe<Scalars['Float']['input']>;
  xBumpStopGap?: InputMaybe<Scalars['Float']['input']>;
  /** Spring preload (mm) */
  xSpringPreload?: InputMaybe<Scalars['Float']['input']>;
};

export type TimeSheetEntry = {
  _id: Scalars['MongoID']['output'];
  /** Whether a person did work on this day */
  absent?: Maybe<Scalars['Boolean']['output']>;
  approvedAt?: Maybe<Scalars['Date']['output']>;
  approvedBy?: Maybe<Person>;
  approvedByID?: Maybe<Scalars['MongoID']['output']>;
  /** Notes about what was done during this time */
  description?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Person>;
  personID: Scalars['MongoID']['output'];
  project?: Maybe<Project>;
  projectID?: Maybe<Scalars['MongoID']['output']>;
  /** Clock-out time */
  tEnd?: Maybe<Scalars['Date']['output']>;
  /** Clock-in time */
  tStart: Scalars['Date']['output'];
};

/** List of items with pagination. */
export type TimeSheetEntryPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TimeSheetEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TimeUnitField = {
  unit: EnumTimeUnit;
};

export type TimingConfigureResult = {
  success: Scalars['Boolean']['output'];
};

export type TimingServiceConfig = {
  _id: Scalars['MongoID']['output'];
  /** Whether the timingServiceConfig should be considered active by the service */
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** API event ID. This finds the correct event by its _id field. */
  eventID?: Maybe<Scalars['MongoID']['output']>;
  /** Use schedule-based session matching as fallback. */
  fallbackScheduleBasedSessionMatching?: Maybe<Scalars['Boolean']['output']>;
  /** Number of timed sectors on track. Used as fallback in case timing data does not provide it. */
  fallbackTimedSectorsCount?: Maybe<Scalars['Int']['output']>;
  /** Car numbers to follow. */
  followedCarNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Activate live standings to see the driver championship points live. Only working properly if all drivers of a given season are added as contestants. */
  liveStandingsActive?: Maybe<Scalars['Boolean']['output']>;
  logLevel?: Maybe<EnumTimingServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: Maybe<Scalars['Boolean']['output']>;
  mode?: Maybe<EnumTimingServiceConfigMode>;
  /** Name for this set of configuration settings. */
  name: Scalars['String']['output'];
  /** Use string equality to match timing session names in One Racehub. Otherwise default sequence matching is used. */
  strictSessionNameMatching?: Maybe<Scalars['Boolean']['output']>;
  /** One Timing server port. */
  timingPort?: Maybe<Scalars['Int']['output']>;
  /** Race series name to filter on in the timing feed when multiple series are running at an event. */
  timingRaceSeries?: Maybe<Scalars['String']['output']>;
  /** One Timing server address. */
  timingURL?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: Maybe<Scalars['Boolean']['output']>;
};

/** List of items with pagination. */
export type TimingServiceConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TimingServiceConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TimingServiceStatus = {
  _id: Scalars['MongoID']['output'];
  /** List of active timing service configurations. */
  activeConfigs?: Maybe<Array<Maybe<ActiveConfig>>>;
  /** List of failed timing service configurations. */
  failedConfigs?: Maybe<Array<Maybe<FailedConfig>>>;
};

export type TimingServiceStatusInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of active timing service configurations. */
  activeConfigs?: InputMaybe<Array<InputMaybe<ActiveConfigInput>>>;
  /** List of failed timing service configurations. */
  failedConfigs?: InputMaybe<Array<InputMaybe<FailedConfigInput>>>;
};

export type TokenClaims = {
  /** Query JWT claims, giving an error if the token is invalid. */
  claims: Scalars['JSON']['output'];
  /** The currently authenticated person. */
  person: Person;
};

export type Torque = {
  /** Nm */
  newtonMetres: Scalars['Float']['output'];
  /** Nmm */
  newtonMillimetres: Scalars['Float']['output'];
  /** lbf·ft */
  poundForceFeet: Scalars['Float']['output'];
  /** lbf·in */
  poundForceInches: Scalars['Float']['output'];
};

export type TorqueInput = {
  /** Nm */
  newtonMetres?: InputMaybe<Scalars['Float']['input']>;
  /** Nmm */
  newtonMillimetres?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft */
  poundForceFeet?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·in */
  poundForceInches?: InputMaybe<Scalars['Float']['input']>;
};

export type TorqueUnitField = {
  unit: EnumTorqueUnit;
};

export type TorsionRate = {
  /** Nm/° */
  newtonMetresPerDegree: Scalars['Float']['output'];
  /** Nm/rad */
  newtonMetresPerRadian: Scalars['Float']['output'];
  /** lbf·ft/° */
  poundForceFeetPerDegree: Scalars['Float']['output'];
  /** lbf·ft/rad */
  poundForceFeetPerRadian: Scalars['Float']['output'];
  /** lbf-in/° */
  poundForceInchesPerDegree: Scalars['Float']['output'];
  /** lbf-in/rad */
  poundForceInchesPerRadian: Scalars['Float']['output'];
};

export type TorsionRateInput = {
  /** Nm/° */
  newtonMetresPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** Nm/rad */
  newtonMetresPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/° */
  poundForceFeetPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/rad */
  poundForceFeetPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/° */
  poundForceInchesPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/rad */
  poundForceInchesPerRadian?: InputMaybe<Scalars['Float']['input']>;
};

export type TorsionRateUnitField = {
  unit: EnumTorsionRateUnit;
};

export type Track = {
  _id: Scalars['MongoID']['output'];
  acronym?: Maybe<Scalars['String']['output']>;
  /** Track height above sea level. */
  altitude?: Maybe<Scalars['Float']['output']>;
  cameras?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  geoLocation?: Maybe<GeoLocation>;
  /** IDs of the available track layouts */
  layoutIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Available track layouts */
  layouts: Array<TrackLayout>;
  name: Scalars['String']['output'];
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: Maybe<Scalars['String']['output']>;
  trackPicture?: Maybe<AttachedFile>;
  weatherStations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TrackKeyValueEntry = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TrackLabel = {
  alignment: TrackLabelAlignment;
  name: Scalars['String']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type TrackLabelAlignment =
  | 'Bottom'
  | 'BottomLeft'
  | 'BottomRight'
  | 'Centered'
  | 'Left'
  | 'Right'
  | 'Top'
  | 'TopLeft'
  | 'TopRight';

export type TrackLatLonCoordinate = {
  distance: Scalars['Float']['output'];
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
  time: Scalars['Float']['output'];
};

export type TrackLayout = {
  ATKModeGain?: Maybe<Scalars['Float']['output']>;
  ATKModeLocation?: Maybe<Scalars['Float']['output']>;
  ATKModePenalty?: Maybe<Scalars['Float']['output']>;
  FCYLapTime?: Maybe<Scalars['Float']['output']>;
  /** Full-course yellow probability */
  FCYProbability?: Maybe<Scalars['Float']['output']>;
  /** Amount of sectors the timing provides */
  NSectorsTiming?: Maybe<Scalars['Float']['output']>;
  SCLapTime?: Maybe<Scalars['Float']['output']>;
  /** Safety car probability */
  SCProbability?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Specify SoC required in event.consumptions instead. */
  SoCRequired?: Maybe<RunEnergy>;
  _id: Scalars['MongoID']['output'];
  acronym?: Maybe<Scalars['String']['output']>;
  bumpiness?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Specify cameras on the parent track object instead. */
  cameras?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code60LapTime?: Maybe<Scalars['Float']['output']>;
  crossoverWetToSlick?: Maybe<Scalars['Float']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  /** @deprecated Specify energy required in event.consumptions instead. */
  energyRequired?: Maybe<RunEnergy>;
  expectedRaceLaps?: Maybe<Scalars['Float']['output']>;
  firstLapOffset?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Specify fuel required in event.consumptions instead. */
  fuelRequired?: Maybe<RunEnergy>;
  inLapTime?: Maybe<Scalars['Float']['output']>;
  lapLengthCarData?: Maybe<Scalars['Float']['output']>;
  lapLengthInLapCarData?: Maybe<Scalars['Float']['output']>;
  lapLengthInLapOfficial?: Maybe<Scalars['Float']['output']>;
  lapLengthInLapRoulette?: Maybe<Scalars['Float']['output']>;
  lapLengthOfficial?: Maybe<Scalars['Float']['output']>;
  lapLengthOutLapCarData?: Maybe<Scalars['Float']['output']>;
  lapLengthOutLapOfficial?: Maybe<Scalars['Float']['output']>;
  lapLengthOutLapRoulette?: Maybe<Scalars['Float']['output']>;
  lapLengthRoulette?: Maybe<Scalars['Float']['output']>;
  lapZero?: Maybe<Scalars['Boolean']['output']>;
  lapsUntilFullRegen?: Maybe<Scalars['Float']['output']>;
  mapElevation?: Maybe<Scalars['String']['output']>;
  mapEmergencyExits?: Maybe<Scalars['String']['output']>;
  mapPitLane?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `mapTrackXyCsv` instead */
  mapTrack?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `mapTrackLatLonCsv` instead */
  mapTrackGPS?: Maybe<Scalars['String']['output']>;
  mapTrackLatLon?: Maybe<MapTrackLatLon>;
  mapTrackLatLonCsv?: Maybe<Scalars['String']['output']>;
  mapTrackXy?: Maybe<MapTrackXy>;
  mapTrackXyCsv?: Maybe<Scalars['String']['output']>;
  /** Name of the Layout */
  name: Scalars['String']['output'];
  outLapTime?: Maybe<Scalars['Float']['output']>;
  overtakingThreshold?: Maybe<Scalars['Float']['output']>;
  /** Whole distance from entry to exit inlcuding approach and leave */
  pitDistance?: Maybe<Scalars['Float']['output']>;
  /** Length of pit lane between the pit lane entry and exit loop (used for mileage calculation of pitlane lap types) */
  pitLength?: Maybe<Scalars['Float']['output']>;
  pitLoss?: Maybe<Scalars['Float']['output']>;
  pitLossDriveThrough?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether the pole position is on the left- or right-hand side */
  polePosition?: Maybe<EnumTrackLayoutPolePosition>;
  prepLapTime?: Maybe<Scalars['Float']['output']>;
  pushLapTime?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use sectorLengths field instead. */
  sectorDistance?: Maybe<Scalars['Float']['output']>;
  sectorLengths?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Downforce sensitivity (seconds per 10pts) */
  sensDownforce?: Maybe<Scalars['Float']['output']>;
  /** Drag sensitivity (seconds per 10pts) */
  sensDrag?: Maybe<Scalars['Float']['output']>;
  sensEP?: Maybe<Scalars['Float']['output']>;
  /** Energy sensitivity (seconds per 0.1kWh) */
  sensEnergy?: Maybe<Scalars['Float']['output']>;
  /** Grip sensitivity (seconds per %) */
  sensGrip?: Maybe<Scalars['Float']['output']>;
  /** Mass sensitivity (seconds per 10kg) */
  sensMass?: Maybe<Scalars['Float']['output']>;
  /** Power sensitivity */
  sensPower?: Maybe<Scalars['Float']['output']>;
  simulationModels?: Maybe<Array<Maybe<TrackLayoutSimulationModel>>>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  track?: Maybe<Track>;
  trackEvolution?: Maybe<Scalars['Float']['output']>;
  /** ID of the track this layout belongs to */
  trackID: Scalars['MongoID']['output'];
  trackLayoutType?: Maybe<EnumTrackLayoutTrackLayoutType>;
  trackRecordQuali?: Maybe<Scalars['Float']['output']>;
  trackRecordRace?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Specify weatherStations on the parent track object instead. */
  weatherStations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** List of items with pagination. */
export type TrackLayoutPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackLayout>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackLayoutSimulationModel = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  canopyID?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  provider: EnumSimModelType;
  version?: Maybe<Scalars['String']['output']>;
};

export type TrackLayoutSimulationModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  canopyID?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  provider: EnumSimModelType;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type TrackPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Track>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackState = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  flag?: Maybe<EnumTrackStateFlag>;
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
};

export type TrackStateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  flag?: InputMaybe<EnumTrackStateFlag>;
  message?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type TrackSvg = {
  height: Scalars['Float']['output'];
  svgPath: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type TrackXyCoordinate = {
  distance: Scalars['Float']['output'];
  time: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type Trackable = {
  _id: Scalars['MongoID']['output'];
  criticalValue?: Maybe<Scalars['Float']['output']>;
  defaultValue?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** ID of the original version of the specifications to track. */
  rootSpecificationID: Scalars['MongoID']['output'];
  unitType?: Maybe<TypedUnitField>;
  /** Comparison to use when checking if the tracked value is in the warning/critical range. */
  warningDirection?: Maybe<EnumTrackableWarningDirection>;
  warningValue?: Maybe<Scalars['Float']['output']>;
};

/** List of items with pagination. */
export type TrackablePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Trackable>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackingEntry = {
  history: Array<TrackingRecord>;
  snapshot?: Maybe<TrackingRecord>;
  trackingItem?: Maybe<TrackingItem>;
  trackingItemID: Scalars['MongoID']['output'];
};

export type TrackingItem = {
  NDecimals?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  arrayElements?: Maybe<Scalars['Float']['output']>;
  criticalCumulativeValue?: Maybe<Scalars['Float']['output']>;
  criticalValue?: Maybe<Scalars['Float']['output']>;
  cumulativeCalculation?: Maybe<Scalars['Boolean']['output']>;
  defaultValue?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayUnit?: Maybe<EnumDisplayUnit>;
  isArray?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  measurementImage?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operator?: Maybe<EnumTrackingItemOperator>;
  resettable?: Maybe<Scalars['Boolean']['output']>;
  specification?: Maybe<BaseSpecification>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  trackingSource?: Maybe<TrackingSource>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
  warningCumulativeValue?: Maybe<Scalars['Float']['output']>;
  warningValue?: Maybe<Scalars['Float']['output']>;
};

/** List of items with pagination. */
export type TrackingItemPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingItem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackingMeasurement = {
  _id: Scalars['MongoID']['output'];
  defaultCoordinates?: Maybe<TrackingMeasurementDefaultCoordinates>;
  defaultRotation?: Maybe<TrackingMeasurementDefaultRotation>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  specification?: Maybe<BaseSpecification>;
  specificationID?: Maybe<Scalars['MongoID']['output']>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: Maybe<Scalars['Boolean']['output']>;
};

export type TrackingMeasurementDefaultCoordinates = {
  /** Coordinate value x */
  x?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value y */
  y?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value z */
  z?: Maybe<Scalars['Float']['output']>;
};

export type TrackingMeasurementDefaultCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackingMeasurementDefaultRotation = {
  /** Rotation value I */
  I?: Maybe<Scalars['Float']['output']>;
  /** Rotation value J */
  J?: Maybe<Scalars['Float']['output']>;
  /** Rotation value K */
  K?: Maybe<Scalars['Float']['output']>;
};

export type TrackingMeasurementDefaultRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type TrackingMeasurementPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingMeasurement>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackingMeasurementRecord = {
  _id: Scalars['MongoID']['output'];
  assembly?: Maybe<ChassisAssembly>;
  assemblyID?: Maybe<Scalars['MongoID']['output']>;
  coordinates?: Maybe<TrackingMeasurementRecordCoordinates>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  part?: Maybe<Part>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  rotation?: Maybe<TrackingMeasurementRecordRotation>;
  trackingMeasurement?: Maybe<TrackingMeasurement>;
  trackingMeasurementID?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TrackingMeasurementRecordCoordinates = {
  /** Coordinate value x */
  x?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value y */
  y?: Maybe<Scalars['Float']['output']>;
  /** Coordinate value z */
  z?: Maybe<Scalars['Float']['output']>;
};

export type TrackingMeasurementRecordCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type TrackingMeasurementRecordPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingMeasurementRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackingMeasurementRecordRotation = {
  /** Rotation value I */
  I?: Maybe<Scalars['Float']['output']>;
  /** Rotation value J */
  J?: Maybe<Scalars['Float']['output']>;
  /** Rotation value K */
  K?: Maybe<Scalars['Float']['output']>;
};

export type TrackingMeasurementRecordRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackingRecord = {
  _id: Scalars['MongoID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  arrayValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  chassisAssembly?: Maybe<ChassisAssembly>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cumulativeValue?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  dateResolved?: Maybe<Scalars['Date']['output']>;
  forceTable?: Maybe<ForceTable>;
  limitCritical?: Maybe<Scalars['Boolean']['output']>;
  limitWarning?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  mass?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  part?: Maybe<Part>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  qualityCheckID?: Maybe<Scalars['MongoID']['output']>;
  recordErrors?: Maybe<Scalars['String']['output']>;
  reset?: Maybe<Scalars['Boolean']['output']>;
  statusEnum?: Maybe<UserEnumPartStatus>;
  statusEnumID?: Maybe<Scalars['MongoID']['output']>;
  trackingItem?: Maybe<TrackingItem>;
  trackingItemID?: Maybe<Scalars['MongoID']['output']>;
  trackingSource?: Maybe<TrackingSource>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumTrackingRecordType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedByID?: Maybe<Scalars['MongoID']['output']>;
  userEnumPartStatusName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type TrackingRecordGeneral = {
  _id: Scalars['MongoID']['output'];
  arrayValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cumulativeValue?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  dateResolved?: Maybe<Scalars['Date']['output']>;
  forceTable?: Maybe<ForceTable>;
  location?: Maybe<Location>;
  mass?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  qualityCheckID?: Maybe<Scalars['MongoID']['output']>;
  recordErrors?: Maybe<Scalars['String']['output']>;
  reset?: Maybe<Scalars['Boolean']['output']>;
  statusEnumID?: Maybe<Scalars['MongoID']['output']>;
  trackingItemID?: Maybe<Scalars['MongoID']['output']>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumTrackingRecordGeneralType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedByID?: Maybe<Scalars['MongoID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type TrackingRecordOverride = {
  _id: Scalars['MongoID']['output'];
  arrayValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cumulativeValue?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  dateResolved?: Maybe<Scalars['Date']['output']>;
  forceTable?: Maybe<ForceTable>;
  location?: Maybe<Location>;
  mass?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  qualityCheckID?: Maybe<Scalars['MongoID']['output']>;
  recordErrors?: Maybe<Scalars['String']['output']>;
  reset?: Maybe<Scalars['Boolean']['output']>;
  statusEnumID?: Maybe<Scalars['MongoID']['output']>;
  trackingItemID?: Maybe<Scalars['MongoID']['output']>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumTrackingRecordOverrideType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedByID?: Maybe<Scalars['MongoID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type TrackingRecordPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TrackingRecordValue = {
  _id: Scalars['MongoID']['output'];
  arrayValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cumulativeValue?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  dateResolved?: Maybe<Scalars['Date']['output']>;
  forceTable?: Maybe<ForceTable>;
  location?: Maybe<Location>;
  mass?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partID?: Maybe<Scalars['MongoID']['output']>;
  qualityCheckID?: Maybe<Scalars['MongoID']['output']>;
  recordErrors?: Maybe<Scalars['String']['output']>;
  reset?: Maybe<Scalars['Boolean']['output']>;
  statusEnumID?: Maybe<Scalars['MongoID']['output']>;
  trackingItemID?: Maybe<Scalars['MongoID']['output']>;
  trackingSourceID?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumTrackingRecordValueType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedByID?: Maybe<Scalars['MongoID']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type TrackingSource = {
  NDecimals?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  chassisSpecID: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayUnit?: Maybe<EnumDisplayUnit>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  sourceIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  sources: Array<TrackingSourceAlias>;
};

export type TrackingSourceAlias = {
  _id: Scalars['MongoID']['output'];
  aliasString?: Maybe<Scalars['String']['output']>;
  aliasType?: Maybe<EnumTrackingSourceAliasAliasType>;
  description?: Maybe<Scalars['String']['output']>;
  displayUnit?: Maybe<EnumDisplayUnit>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** List of items with pagination. */
export type TrackingSourceAliasPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingSourceAlias>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type TrackingSourcePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TrackingSource>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TypedUnitField = AccelerationUnitField | AngleUnitField | AngularAccelerationUnitField | AngularComplianceUnitField | AngularTorqueComplianceUnitField | AngularVelocityUnitField | BooleanUnitField | ComplianceUnitField | EnergyUnitField | ForceUnitField | InertiaUnitField | LengthUnitField | LocationUnitField | MassUnitField | NumberUnitField | OrientationUnitField | PowerUnitField | PressureUnitField | RatioUnitField | SpringRateUnitField | SteeringRackRatioUnitField | StringUnitField | TemperatureUnitField | TimeUnitField | TorqueUnitField | TorsionRateUnitField | VelocityUnitField | VolumeUnitField;

export type Tyre = {
  /** Flag if the tyre is scrapped (no longer available for use). */
  BTyreScrapped?: Maybe<Scalars['Boolean']['output']>;
  /** Tyre Circumference */
  CTyre?: Maybe<Scalars['Float']['output']>;
  _id: Scalars['MongoID']['output'];
  /** Arbitrary string to sort or filter by */
  additionalSortProperty?: Maybe<Scalars['String']['output']>;
  axle?: Maybe<EnumTyreAxle>;
  barcodeManufacturer?: Maybe<Scalars['String']['output']>;
  /** Barcode from the regulatory body (e.g. FIA) */
  barcodeRegulation?: Maybe<Scalars['String']['output']>;
  barcodeRim?: Maybe<Scalars['String']['output']>;
  barcodeTPMS?: Maybe<Scalars['String']['output']>;
  batteryTPMS?: Maybe<Scalars['String']['output']>;
  compound?: Maybe<Scalars['String']['output']>;
  compoundComment?: Maybe<Scalars['String']['output']>;
  constructionComment?: Maybe<Scalars['String']['output']>;
  constructionSpec?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  heatingSchedule?: Maybe<Array<Maybe<TyreHeatingScheduleEntry>>>;
  initialCondition?: Maybe<EnumTyreInitialCondition>;
  /** Tyre Spring Rate */
  kTyre?: Maybe<Scalars['Float']['output']>;
  mTyre?: Maybe<Scalars['Float']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturingDate?: Maybe<Scalars['Date']['output']>;
  /** Calculate total mileage */
  mileage?: Maybe<Scalars['Float']['output']>;
  /** Tyre mold information */
  mold?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Tyre minimum pressure defined by regulation or manufacturer */
  pTyreMinRegulation?: Maybe<Scalars['Float']['output']>;
  /** Tyre minimum pressure defined by team (i.e. chief engineer) */
  pTyreMinTeam?: Maybe<Scalars['Float']['output']>;
  rimPart?: Maybe<Part>;
  rimPartID?: Maybe<Scalars['MongoID']['output']>;
  /** Initial mileage before use in One Racehub. */
  sRunInitial?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Season>;
  seasonID?: Maybe<Scalars['MongoID']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  wearMeasurementIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  wearMeasurements: Array<TyreWear>;
};

export type TyreHeatingScheduleEntry = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  duration: Scalars['Float']['output'];
  temperature: Scalars['Float']['output'];
};

export type TyreHeatingScheduleEntryInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  duration: Scalars['Float']['input'];
  temperature: Scalars['Float']['input'];
};

export type TyreMileageAtSessionStart = {
  tyreMileages?: Maybe<Array<Maybe<SingleTyreMileageAtSessionStart>>>;
  tyreSetMileages?: Maybe<Array<Maybe<TyreSetMileageAtSessionStart>>>;
};

export type TyreMileageAtSessionStartData = {
  endMileage?: Maybe<Scalars['Float']['output']>;
  runs?: Maybe<Array<Maybe<MileageAtRunStart>>>;
  sessionID?: Maybe<Scalars['MongoID']['output']>;
  startMileage?: Maybe<Scalars['Float']['output']>;
};

export type TyreMileageGraph = {
  eventMileages?: Maybe<TyreMileageGraphEventMileages>;
  fullMileages?: Maybe<TyreMileageGraphFullMileages>;
};

export type TyreMileageGraphEventMileageItem = {
  _id: Scalars['MongoID']['output'];
  eventEndMileage: Scalars['Float']['output'];
  eventStartMileage: Scalars['Float']['output'];
  eventTotalMileage: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  runMileages?: Maybe<Array<Maybe<TyreMileageGraphEventMileageItemRunMileageItem>>>;
  sessionMileages?: Maybe<Array<Maybe<TyreMileageGraphEventMileageItemSessionMileageItem>>>;
};

export type TyreMileageGraphEventMileageItemRunMileageItem = {
  NRun: Scalars['Int']['output'];
  NRunConsecutive: Scalars['Int']['output'];
  NRunTiming: Scalars['String']['output'];
  endMileage: Scalars['Float']['output'];
  runMileage: Scalars['Float']['output'];
  runSheetID: Scalars['MongoID']['output'];
  sessionID: Scalars['MongoID']['output'];
  startMileage: Scalars['Float']['output'];
};

export type TyreMileageGraphEventMileageItemSessionMileageItem = {
  endMileage: Scalars['Float']['output'];
  sessionID: Scalars['MongoID']['output'];
  startMileage: Scalars['Float']['output'];
  totalMileage: Scalars['Float']['output'];
};

export type TyreMileageGraphEventMileages = {
  tyreSets?: Maybe<Array<Maybe<TyreMileageGraphEventMileageItem>>>;
  tyres?: Maybe<Array<Maybe<TyreMileageGraphEventMileageItem>>>;
};

export type TyreMileageGraphFullMileageItem = {
  _id: Scalars['MongoID']['output'];
  mileages?: Maybe<Array<Maybe<TyreMileageGraphFullMileageItemMileageItem>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TyreMileageGraphFullMileageItemMileageItem = {
  endMileage: Scalars['Float']['output'];
  runMileage: Scalars['Float']['output'];
  runSheetID: Scalars['MongoID']['output'];
  startMileage: Scalars['Float']['output'];
};

export type TyreMileageGraphFullMileages = {
  tyreSets?: Maybe<Array<Maybe<TyreMileageGraphFullMileageItem>>>;
  tyres?: Maybe<Array<Maybe<TyreMileageGraphFullMileageItem>>>;
};

/** List of items with pagination. */
export type TyrePagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Tyre>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TyrePressureSettings = {
  TAirReference?: Maybe<Scalars['Float']['output']>;
  TTrackReference?: Maybe<Scalars['Float']['output']>;
};

export type TyrePressureSettingsInput = {
  TAirReference?: InputMaybe<Scalars['Float']['input']>;
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
};

export type TyrePressureSheet = {
  _id: Scalars['MongoID']['output'];
  contestant?: Maybe<Contestant>;
  contestantID?: Maybe<Scalars['MongoID']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['MongoID']['output']>;
  pressureUnit?: Maybe<EnumPressureUnit>;
  sessions?: Maybe<Array<Maybe<TyrePressureSheetSession>>>;
  temperatureUnit?: Maybe<EnumTemperatureUnit>;
  tyrePressureSettings: EventTyrePressureSettings;
};

export type TyrePressureSheetInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  pressureUnit?: InputMaybe<EnumPressureUnit>;
  temperatureUnit?: InputMaybe<EnumTemperatureUnit>;
  tyrePressureSettings?: InputMaybe<EventTyrePressureSettingsInput>;
};

export type TyrePressureSheetSession = {
  session?: Maybe<Session>;
  sessionID: Scalars['MongoID']['output'];
  tyreSetupData: Array<TyreSetupData>;
};

export type TyreSet = {
  _id: Scalars['MongoID']['output'];
  assignment?: Maybe<TyreSetAssignment>;
  comment?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  tagIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tags: Array<Tag>;
  /** Mileage of the highest-mileage corner in the set, in metres. The four tyres run together, so the worst corner governs the set - this is a maximum, not a sum. */
  totalMileage?: Maybe<Scalars['Float']['output']>;
  tyreFL?: Maybe<Tyre>;
  tyreFR?: Maybe<Tyre>;
  tyreIDFL?: Maybe<Scalars['MongoID']['output']>;
  tyreIDFR?: Maybe<Scalars['MongoID']['output']>;
  tyreIDRL?: Maybe<Scalars['MongoID']['output']>;
  tyreIDRR?: Maybe<Scalars['MongoID']['output']>;
  tyreRL?: Maybe<Tyre>;
  tyreRR?: Maybe<Tyre>;
};

export type TyreSetAssignment = {
  eventContestants: Array<Contestant>;
  events: Array<Event>;
  seasonContestants: Array<Contestant>;
  seasons: Array<Season>;
};

export type TyreSetMileageAtSessionStart = {
  sessions?: Maybe<Array<Maybe<TyreMileageAtSessionStartData>>>;
  tyreSetID?: Maybe<Scalars['MongoID']['output']>;
};

/** List of items with pagination. */
export type TyreSetPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TyreSet>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TyreSetupData = {
  TAirRegulation?: Maybe<Scalars['Float']['output']>;
  TRimParcFermeExpected?: Maybe<Scalars['Float']['output']>;
  TRimSetdown: TyreValues;
  TRimSetup: TyreValues;
  TTrackExpected?: Maybe<Scalars['Float']['output']>;
  TTrackRegulation?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  pTyreMinimum: TyreValues;
  pTyreReference: TyreValues;
  pTyreSetdown: TyreValues;
  pTyreSetup: TyreValues;
  pTyreTarget: TyreValues;
  rTrackTemperature?: Maybe<Scalars['Float']['output']>;
  selected: Scalars['Boolean']['output'];
  tyreSet?: Maybe<TyreSet>;
  tyreSetID: Scalars['MongoID']['output'];
};

export type TyreSetupDataInput = {
  TAirRegulation?: InputMaybe<Scalars['Float']['input']>;
  TRimParcFermeExpected?: InputMaybe<Scalars['Float']['input']>;
  TRimSetdown?: InputMaybe<TyreValuesInput>;
  TRimSetup?: InputMaybe<TyreValuesInput>;
  TTrackExpected?: InputMaybe<Scalars['Float']['input']>;
  TTrackRegulation?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  pTyreMinimum?: InputMaybe<TyreValuesInput>;
  pTyreReference?: InputMaybe<TyreValuesInput>;
  pTyreSetdown?: InputMaybe<TyreValuesInput>;
  pTyreSetup?: InputMaybe<TyreValuesInput>;
  pTyreTarget?: InputMaybe<TyreValuesInput>;
  rTrackTemperature?: InputMaybe<Scalars['Float']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type TyreTableBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  mileageUnit?: Maybe<EnumLengthUnit>;
  pressureUnit?: Maybe<EnumPressureUnit>;
  showGetPreviousRunPostPressureButton?: Maybe<Scalars['Boolean']['output']>;
  showGetRecommendationButton?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showMinimumPressures?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showSurfaceTemps?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showTargetPressures?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showTyreReferencePressure?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showTyreSelector?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  showTyreSetSelector?: Maybe<Scalars['Boolean']['output']>;
  staggerSettings?: Maybe<TyreTableBlockStaggerSettings>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  standardTyrePressureBox?: Maybe<TyreTableBlockStandardTyrePressureBox>;
  /** @deprecated Use `tyreTableRows` to toggle fields instead */
  standardTyreTempBox?: Maybe<TyreTableBlockStandardTyreTempBox>;
  /** @deprecated Use other fields to style the block instead */
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  temperatureUnit?: Maybe<EnumTemperatureUnit>;
  treadDepthUnit?: Maybe<EnumLengthUnit>;
  tyreTableRows?: Maybe<Array<Maybe<TyreTableBlockRow>>>;
  /** Number of tread depth measurements to allow. Use `0` or `null` to hide the input. */
  tyreTreadDepthMeasurements?: Maybe<Scalars['Int']['output']>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type TyreTableBlockRow = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  field?: Maybe<EnumTyreTableField>;
  highlightChanges?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lowerLimit?: Maybe<ValueLimit>;
  upperLimit?: Maybe<ValueLimit>;
};

export type TyreTableBlockRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<EnumTyreTableField>;
  highlightChanges?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<ValueLimitInput>;
  upperLimit?: InputMaybe<ValueLimitInput>;
};

export type TyreTableBlockStaggerSettings = {
  /** Number of decimal places to display. */
  decimals?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EnumLengthUnit>;
};

export type TyreTableBlockStandardTyrePressureBox = {
  decimalPlaces?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<EnumPressureOption>>>;
  unit?: Maybe<EnumPressureUnit>;
};

export type TyreTableBlockStandardTyreTempBox = {
  decimalPlaces?: Maybe<Scalars['Float']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<EnumTemperatureOption>>>;
  unit?: Maybe<EnumTemperatureUnit>;
};

export type TyreValues = {
  FL?: Maybe<Scalars['Float']['output']>;
  FR?: Maybe<Scalars['Float']['output']>;
  RL?: Maybe<Scalars['Float']['output']>;
  RR?: Maybe<Scalars['Float']['output']>;
};

export type TyreValuesInput = {
  FL?: InputMaybe<Scalars['Float']['input']>;
  FR?: InputMaybe<Scalars['Float']['input']>;
  RL?: InputMaybe<Scalars['Float']['input']>;
  RR?: InputMaybe<Scalars['Float']['input']>;
};

export type TyreWear = {
  _id: Scalars['MongoID']['output'];
  /** Time at which this measurement was made. */
  date?: Maybe<Scalars['Date']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  tyre?: Maybe<Tyre>;
  tyreID: Scalars['MongoID']['output'];
  /** Raw wear data formatted however the user chooses, probably from a scanner. */
  wearData?: Maybe<Scalars['String']['output']>;
  /** Map of marker names to wear values. Input syntax is array of key-value tuples, like `wearMarkers: [["inner", 0.8], ["1", 0.3]]`. */
  wearMarkers?: Maybe<Scalars['JSON']['output']>;
};

/** List of items with pagination. */
export type TyreWearPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TyreWear>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UnclaimCarSetupResult = {
  success: Scalars['Boolean']['output'];
};

export type UnclaimRunSheetResult = {
  success: Scalars['Boolean']['output'];
};

export type UpdateByIdAccelerationInput = {
  /** ft/s² */
  feetPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
  /** g */
  gForce?: InputMaybe<Scalars['Float']['input']>;
  metresPerSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAdjustableAccelerationInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAccelerationUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableAngleInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngleUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableAngularComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableAngularTorqueComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableBooleanInput = {
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdAdjustableComplianceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumComplianceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableForceInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumForceUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableInertiaInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumInertiaUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableLengthInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableLocationCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAdjustableLocationDefaultValueInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAdjustableLocationInput = {
  coordinates?: InputMaybe<UpdateByIdAdjustableLocationCoordinatesInput>;
  defaultValue?: InputMaybe<UpdateByIdAdjustableLocationDefaultValueInput>;
};

export type UpdateByIdAdjustableMassInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumMassUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableNumberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  /** Unit to display values in */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableOrientationDefaultValueInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAdjustableOrientationInput = {
  defaultValue?: InputMaybe<UpdateByIdAdjustableOrientationDefaultValueInput>;
  rotation?: InputMaybe<UpdateByIdAdjustableOrientationRotationInput>;
};

export type UpdateByIdAdjustableOrientationRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAdjustablePowerInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPowerUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustablePressureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumPressureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustablePropertyInput = {
  adjustableAcceleration?: InputMaybe<UpdateByIdAdjustableAccelerationInput>;
  adjustableAngle?: InputMaybe<UpdateByIdAdjustableAngleInput>;
  adjustableAngularCompliance?: InputMaybe<UpdateByIdAdjustableAngularComplianceInput>;
  adjustableAngularTorqueCompliance?: InputMaybe<UpdateByIdAdjustableAngularTorqueComplianceInput>;
  adjustableBoolean?: InputMaybe<UpdateByIdAdjustableBooleanInput>;
  adjustableCompliance?: InputMaybe<UpdateByIdAdjustableComplianceInput>;
  adjustableForce?: InputMaybe<UpdateByIdAdjustableForceInput>;
  adjustableInertia?: InputMaybe<UpdateByIdAdjustableInertiaInput>;
  adjustableLength?: InputMaybe<UpdateByIdAdjustableLengthInput>;
  adjustableLocation?: InputMaybe<UpdateByIdAdjustableLocationInput>;
  adjustableMass?: InputMaybe<UpdateByIdAdjustableMassInput>;
  adjustableNumber?: InputMaybe<UpdateByIdAdjustableNumberInput>;
  adjustableOrientation?: InputMaybe<UpdateByIdAdjustableOrientationInput>;
  adjustablePower?: InputMaybe<UpdateByIdAdjustablePowerInput>;
  adjustablePressure?: InputMaybe<UpdateByIdAdjustablePressureInput>;
  adjustableRatio?: InputMaybe<UpdateByIdAdjustableRatioInput>;
  adjustableSpringRate?: InputMaybe<UpdateByIdAdjustableSpringRateInput>;
  adjustableSteeringRackRatio?: InputMaybe<UpdateByIdAdjustableSteeringRackRatioInput>;
  adjustableString?: InputMaybe<UpdateByIdAdjustableStringInput>;
  adjustableTemperature?: InputMaybe<UpdateByIdAdjustableTemperatureInput>;
  adjustableTorque?: InputMaybe<UpdateByIdAdjustableTorqueInput>;
  adjustableTorsionRate?: InputMaybe<UpdateByIdAdjustableTorsionRateInput>;
  adjustableVolume?: InputMaybe<UpdateByIdAdjustableVolumeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAdjustablePropertyType>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdAdjustableRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableSpringRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpringRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableSteeringRackRatioInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableStringInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableTemperatureInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTemperatureUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableTorqueInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorqueUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableTorsionRateInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumTorsionRateUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAdjustableVolumeInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumVolumeUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdAeroElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  attached?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  positionName?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdAeroInput = {
  /** Number/Position of front flaps */
  NFlapF?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-left flaps */
  NFlapFL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of front-right flaps */
  NFlapFR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of lower rear flaps */
  NFlapLowerR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear flaps */
  NFlapR?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-left flaps */
  NFlapRL?: InputMaybe<Scalars['String']['input']>;
  /** Number/Position of rear-right flaps */
  NFlapRR?: InputMaybe<Scalars['String']['input']>;
  Z400?: InputMaybe<Scalars['String']['input']>;
  /** Front flap angle */
  aFlapF?: InputMaybe<Scalars['Float']['input']>;
  /** Front-left flap angle */
  aFlapFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right flap angle */
  aFlapFR?: InputMaybe<Scalars['Float']['input']>;
  /** Lower rear flap angle */
  aFlapLowerR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear flap angle */
  aFlapR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left flap angle */
  aFlapRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right flap angle */
  aFlapRR?: InputMaybe<Scalars['Float']['input']>;
  /** Front splitter angle */
  aSplitterF?: InputMaybe<Scalars['Float']['input']>;
  /** Complete aero package spec */
  aeroPackage?: InputMaybe<Scalars['String']['input']>;
  floorBB?: InputMaybe<Scalars['String']['input']>;
  floorGurney?: InputMaybe<Scalars['String']['input']>;
  floorLeadingEdgeID?: InputMaybe<Scalars['String']['input']>;
  /** Front flap type */
  frontFlapType?: InputMaybe<Scalars['String']['input']>;
  frontWheelArch?: InputMaybe<Scalars['String']['input']>;
  hGurneyF?: InputMaybe<Scalars['Float']['input']>;
  hGurneyR?: InputMaybe<Scalars['Float']['input']>;
  /** Splitter height at measurement points */
  hSplitterF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lowerDrivePlane?: InputMaybe<Scalars['String']['input']>;
  noseID?: InputMaybe<Scalars['String']['input']>;
  rearWingGurney?: InputMaybe<Scalars['String']['input']>;
  splitterID?: InputMaybe<Scalars['String']['input']>;
  tailGurney?: InputMaybe<Scalars['String']['input']>;
  tailID?: InputMaybe<Scalars['String']['input']>;
  upperDrivePlane?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdAeroPackageInput = {
  aeroElements?: InputMaybe<Array<InputMaybe<UpdateByIdAeroElementInput>>>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdAngleInput = {
  /** ° */
  degrees?: InputMaybe<Scalars['Float']['input']>;
  /** rad */
  radians?: InputMaybe<Scalars['Float']['input']>;
  /** rev */
  revolutions?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAngularVelocityInput = {
  /** °/s */
  degreesPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rad/s */
  radiansPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** rpm */
  revolutionsPerMinute?: InputMaybe<Scalars['Float']['input']>;
  /** rev/s */
  revolutionsPerSecond?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAntiRollBarConfigInput = {
  /** Anti-roll bar stiffness (use spring rate units) */
  kARB?: InputMaybe<Scalars['Float']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** First connection point (should be a chassis socket) */
  position1?: InputMaybe<Scalars['String']['input']>;
  /** Second connection point (should be a chassis socket) */
  position2?: InputMaybe<Scalars['String']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdAreaInput = {
  /** sq ft */
  squareFeet?: InputMaybe<Scalars['Float']['input']>;
  /** sq in */
  squareInches?: InputMaybe<Scalars['Float']['input']>;
  /** m² */
  squareMetres?: InputMaybe<Scalars['Float']['input']>;
  /** mm² */
  squareMillimetres?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAssemblyInput = {
  assemblyTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  assemblyTypeEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetNestLevel?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisMeasurements?: InputMaybe<Array<InputMaybe<UpdateByIdChassisAssemblyMeasurementInput>>>;
  chassisPartID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this the current version of this assembly, or just a historical snapshot? */
  current?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Location of this assembly referring to a socket. For example, `frontLeft` or `cockpit`. */
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  subAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceRecords?: InputMaybe<Array<InputMaybe<UpdateByIdChassisAssemblyTrackingSourceRecordInput>>>;
  type?: InputMaybe<EnumAssemblyType>;
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdAssemblyPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Assembly>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdAssemblyTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredAssemblies?: InputMaybe<Array<InputMaybe<UpdateByIdAssemblyTemplateRequiredAssembliesInput>>>;
  requiredParts?: InputMaybe<Array<InputMaybe<UpdateByIdAssemblyTemplateRequiredPartsInput>>>;
};

export type UpdateByIdAssemblyTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<AssemblyTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdAssemblyTemplateRequiredAssembliesInput = {
  userEnumAssemblyTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdAssemblyTemplateRequiredPartsInput = {
  /** Specify where the part type should be added in */
  location?: InputMaybe<EnumAssemblyTemplateRequiredPartsLocation>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdAssignedGearInput = {
  gearID?: InputMaybe<Scalars['MongoID']['input']>;
  useHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdBaseTypedUnitFieldInput = {
  type?: InputMaybe<EnumTypedUnitType>;
  unit?: InputMaybe<EnumPossibleUnit>;
};

export type UpdateByIdBehaviourConfigInput = {
  /** Should job list templates be re-used from previous runs when creating new run sheets? */
  carryOverJobList?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the issue block will be ticked to show only the users issues on load. */
  showMyIssuesOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the job block will be ticked to show only the users jobs on load. */
  showMyJobsOnRunSheetDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The locale to use for time formatting */
  timeLocale?: InputMaybe<Scalars['String']['input']>;
  /** ORH will use the users timezone selection to format times accordingly */
  timezoneSelect?: InputMaybe<EnumBehaviourConfigTimezoneSelect>;
};

export type UpdateByIdBestValuesFastestLapInput = {
  /** Lap number within the run sheet for this lap. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this lap. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this lap can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the lap was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBestValuesFastestSectorInput = {
  /** Lap number within the run sheet for this sector. */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Acronym of the driver that completed this sector. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** ID of the run sheet that this sector can be found in. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time the sector was completed in. */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBestValuesInput = {
  /** ID of the contestant these personal bests belong to, if applicable. */
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the driver these personal bests belong to, if applicable. */
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<UpdateByIdBestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<UpdateByIdBestValuesFastestSectorInput>>>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdBestValuesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<BestValues>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdBopCarBopInput = {
  EStintMax?: InputMaybe<Scalars['Float']['input']>;
  PEngineMax?: InputMaybe<Scalars['Float']['input']>;
  VFuelVolumeCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelVolumeMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  aCamberFmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberFmin?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmax?: InputMaybe<Scalars['Float']['input']>;
  aCamberRmin?: InputMaybe<Scalars['Float']['input']>;
  aRakeMax?: InputMaybe<Scalars['Float']['input']>;
  aRakeMin?: InputMaybe<Scalars['Float']['input']>;
  aWingRmax?: InputMaybe<Scalars['Float']['input']>;
  aWingRmin?: InputMaybe<Scalars['Float']['input']>;
  carSpec?: InputMaybe<Scalars['String']['input']>;
  hRideFmin?: InputMaybe<Scalars['Float']['input']>;
  hRideRmin?: InputMaybe<Scalars['Float']['input']>;
  highlightColour?: InputMaybe<Scalars['String']['input']>;
  homologation?: InputMaybe<Scalars['String']['input']>;
  mCarBallastMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightEmptyMin?: InputMaybe<Scalars['Float']['input']>;
  mCarWeightTotalMin?: InputMaybe<Scalars['Float']['input']>;
  mFuelMassCapacityMax?: InputMaybe<Scalars['Float']['input']>;
  mRefuelMassMax?: InputMaybe<Scalars['Float']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['String']['input']>;
  nEngineMax?: InputMaybe<Scalars['Float']['input']>;
  /** A map rpm vs boost pressure */
  pEngineBoost?: InputMaybe<Scalars['JSON']['input']>;
  rLambdaMin?: InputMaybe<Scalars['Float']['input']>;
  rPowerCurveReference?: InputMaybe<Scalars['Float']['input']>;
  rPowerGainAboveRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vCarMax?: InputMaybe<Scalars['Float']['input']>;
  vPowerCurveBelowRefVelocity?: InputMaybe<Scalars['Float']['input']>;
  vPowerGainReference?: InputMaybe<Scalars['Float']['input']>;
  xAirRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xFuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  xRefuelRestrictorMax?: InputMaybe<Scalars['Float']['input']>;
  zWingMin?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBopInput = {
  bopFile?: InputMaybe<Scalars['String']['input']>;
  carBop?: InputMaybe<Array<InputMaybe<UpdateByIdBopCarBopInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sessionBop?: InputMaybe<UpdateByIdBopSessionBopInput>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdBopPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Bop>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdBopSessionBopInput = {
  EStintEnergyMax?: InputMaybe<Scalars['Float']['input']>;
  EStintEnergyRefillRateMax?: InputMaybe<Scalars['Float']['input']>;
  VRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  mRefuelRateMax?: InputMaybe<Scalars['Float']['input']>;
  pAmbientSessionOfficial?: InputMaybe<Scalars['Float']['input']>;
  tyreModel?: InputMaybe<Scalars['String']['input']>;
  xStintlengthMax?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBrakeSystemInput = {
  BBBSEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  brakePadFManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadFSpec?: InputMaybe<Scalars['String']['input']>;
  brakePadRManufacturer?: InputMaybe<Scalars['String']['input']>;
  brakePadRSpec?: InputMaybe<Scalars['String']['input']>;
  brakePedalPosition?: InputMaybe<Scalars['String']['input']>;
  dMasterCylinderF?: InputMaybe<Scalars['Float']['input']>;
  dMasterCylinderR?: InputMaybe<Scalars['Float']['input']>;
  kBBSSpring?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringF?: InputMaybe<Scalars['Float']['input']>;
  kKnockOffSpringR?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderFSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRSpec?: InputMaybe<Scalars['String']['input']>;
  masterCylinderRodLengthF?: InputMaybe<Scalars['Float']['input']>;
  masterCylinderRodlengthR?: InputMaybe<Scalars['Float']['input']>;
  pBrakeBalanceRef?: InputMaybe<Scalars['Float']['input']>;
  rBrakeF?: InputMaybe<Scalars['Float']['input']>;
  rBrakePedal?: InputMaybe<Scalars['Float']['input']>;
  xBBSPreload?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBuildSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  h?: InputMaybe<Scalars['Int']['input']>;
  moved?: InputMaybe<Scalars['Boolean']['input']>;
  resizing?: InputMaybe<Scalars['Boolean']['input']>;
  static?: InputMaybe<Scalars['Boolean']['input']>;
  tabs?: InputMaybe<Array<InputMaybe<UpdateByIdBuildSheetStyleTabInput>>>;
  /** The width of the block within the grid */
  w?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateByIdBuildSheetStyleInput = {
  blocks?: InputMaybe<Array<InputMaybe<UpdateByIdBuildSheetStyleBlockInput>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetEventType?: InputMaybe<EnumBuildSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<InputMaybe<EnumBuildSheetStyleTargetRoles>>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumBuildSheetStyleType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdBuildSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<BuildSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdBuildSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetGroupEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCalculationInput = {
  /** For the client to display debug information or default return values */
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  functionString?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The name of the parameter or path to a field which this calculation gives as output. */
  parameter?: InputMaybe<Scalars['String']['input']>;
  /** The names of the parameters or paths to fields which this calculation depends on. If any of these change, the calculation should be re-run. */
  trigger?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumCalculationType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCalculationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Calculation>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCanopyCredentialsInput = {
  /** Client ID for the Canopy API */
  clientID?: InputMaybe<Scalars['String']['input']>;
  /** Client secret for the Canopy API */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Password for the Canopy API */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Tenant ID from the Canopy API */
  tenantID?: InputMaybe<Scalars['String']['input']>;
  /** Username for the Canopy API */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarCornerInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aFlap?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  brake?: InputMaybe<BrakeInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  suspension?: InputMaybe<SuspensionInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCarDataServiceApplicationSettingsConfigInput = {
  DriverContestantLookup?: InputMaybe<Scalars['JSON']['input']>;
  FunctionsFolder?: InputMaybe<Scalars['String']['input']>;
  PitstopTriggers?: InputMaybe<Array<InputMaybe<UpdateByIdCarDataServicePitstopTriggerInput>>>;
  ProcessedFolder?: InputMaybe<Scalars['String']['input']>;
  ResultsFolder?: InputMaybe<Scalars['String']['input']>;
  RunsheetMatching?: InputMaybe<EnumCarDataServiceApplicationSettingsConfigRunsheetMatching>;
};

export type UpdateByIdCarDataServiceConfigInput = {
  Kpi?: InputMaybe<UpdateByIdCarDataServiceKpiConfigInput>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Object containing parameter mappings. Format is like: { vCar: [{ "name": "car_speed", "offset": 0, "gain": 3.6 }] } */
  ParameterMap?: InputMaybe<Scalars['JSON']['input']>;
  PostProcessingConfig?: InputMaybe<UpdateByIdCarDataServicePostProcessingConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CarDataServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCarDataServiceEventConfigInput = {
  EventDescription?: InputMaybe<Scalars['String']['input']>;
  EventId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCarDataServiceKpiConfigInput = {
  KpiParameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parameters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preconditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdCarDataServicePitstopTriggerInput = {
  ParameterId?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<EnumCarDataServicePitstopTriggerType>;
  Value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCarDataServicePostProcessingConfigInput = {
  ApplicationSettingsConfiguration?: InputMaybe<UpdateByIdCarDataServiceApplicationSettingsConfigInput>;
  EventConfiguration?: InputMaybe<UpdateByIdCarDataServiceEventConfigInput>;
  ProcessingEnginesConfiguration?: InputMaybe<UpdateByIdCarDataServiceProcessingEnginesConfigInput>;
  QueueManagerConfiguration?: InputMaybe<UpdateByIdCarDataServiceQueueManagerConfigInput>;
  SessionManagerConfiguration?: InputMaybe<UpdateByIdCarDataServiceSessionManagerConfigInput>;
  SessionTypesConfiguration?: InputMaybe<UpdateByIdCarDataServiceSessionTypesConfigInput>;
};

export type UpdateByIdCarDataServiceProcessingEngineConfigExportersInput = {
  ATLAS10_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  JSONFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  ONERACEHUB_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  PARQUETFILE_EXPORTER?: InputMaybe<Scalars['JSON']['input']>;
  WINTAX_EXPORTER?: InputMaybe<UpdateByIdCarDataServiceProcessingEngineConfigExportersWintax_ExporterInput>;
};

export type UpdateByIdCarDataServiceProcessingEngineConfigExportersWintax_ExporterInput = {
  /** NAme of paremeter in the parameter map, tracking the distance of current lap. */
  DISTANCE_CHANNEL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel consumption of the current lap. Could be a KPI like 'sLap.Lap.Max' or a fixed value like '2453.2'. */
  FUEL_CONSUMPTION?: InputMaybe<Scalars['String']['input']>;
  /** Fuel level of the current lap. Could be a KPI like 'ERESSRaceFIA.Lap.Last' or a fixed value like '90.3'. */
  FUEL_LEVEL?: InputMaybe<Scalars['String']['input']>;
  /** Effective distance of the current lap. COuld be a KPI like 'ELap.Lap.Integral' or a fixed valued like '10.4'. */
  LAP_DISTANCE?: InputMaybe<Scalars['String']['input']>;
  /** Contains the folder, where the exported WinTAX files are stored. */
  OUTPUT_PATH?: InputMaybe<Scalars['String']['input']>;
  SIMULATE_CALLS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains the folder, where the TelDataZtx dll files are stored. */
  TELDATAZTX_PATH?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceProcessingEngineConfigInput = {
  Calculations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Exporters?: InputMaybe<UpdateByIdCarDataServiceProcessingEngineConfigExportersInput>;
  Importer?: InputMaybe<EnumCarDataServiceProcessingEngineConfigImporter>;
  Instances?: InputMaybe<Scalars['Float']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  QueueName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceProcessingEnginesConfigInput = {
  ExportersFolder?: InputMaybe<Scalars['String']['input']>;
  ImportersFolder?: InputMaybe<Scalars['String']['input']>;
  InternalCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
  ORHCalculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  ParameterMapFile?: InputMaybe<Scalars['String']['input']>;
  ProcessingEngineConfiguration?: InputMaybe<Array<InputMaybe<UpdateByIdCarDataServiceProcessingEngineConfigInput>>>;
  UserCalculationsFolder?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceQueueDefinitionInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  SessionType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceQueueManagerConfigInput = {
  Queues?: InputMaybe<Array<InputMaybe<UpdateByIdCarDataServiceQueueDefinitionInput>>>;
};

export type UpdateByIdCarDataServiceSessionManagerConfigInput = {
  OffloadFolder?: InputMaybe<Scalars['String']['input']>;
  OffloadSessionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdCarDataServiceSessionTypeConfigInput = {
  exts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  folderUpLevel?: InputMaybe<Scalars['Int']['input']>;
  ignoreLiterals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  regExpressions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarDataServiceSessionTypesConfigInput = {
  SessionTypes?: InputMaybe<Array<InputMaybe<UpdateByIdCarDataServiceSessionTypeConfigInput>>>;
};

export type UpdateByIdCarEndInput = {
  aCamber?: InputMaybe<Scalars['Float']['input']>;
  aCamberMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurement?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<Scalars['Float']['input']>;
  aToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
  antiRollBar?: InputMaybe<AntiRollBarInput>;
  bumpStop?: InputMaybe<BumpStopInput>;
  damper?: InputMaybe<DamperInput>;
  droopStop?: InputMaybe<DroopStopInput>;
  externalBumpStop?: InputMaybe<ExternalBumpStopInput>;
  hRide?: InputMaybe<Scalars['Float']['input']>;
  hRideChassis?: InputMaybe<Scalars['Float']['input']>;
  /** Point where the mechanic is measuring the ride height */
  hRideMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Baseline pushrod length, steering rack bumpsteer adjust might depend on the rough range of ride heights the car is running in. */
  hRideRange?: InputMaybe<Scalars['String']['input']>;
  /** Point where the regulation authority is measuring the ride height */
  hRideRegulation?: InputMaybe<Scalars['Float']['input']>;
  helperSpring?: InputMaybe<SpringInput>;
  kinematics?: InputMaybe<KinematicsInput>;
  kinematicsExternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  kinematicsInternalSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  reboundSpring?: InputMaybe<SpringInput>;
  spring?: InputMaybe<SpringInput>;
  thirdElement?: InputMaybe<ThirdElementInput>;
  xToe?: InputMaybe<Scalars['Float']['input']>;
  xToeMeasurement?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCarInfoInput = {
  /** Number of changes */
  NChanges?: InputMaybe<Scalars['Float']['input']>;
  /** Number of issues */
  NIssue?: InputMaybe<Scalars['Float']['input']>;
  batteryID?: InputMaybe<Scalars['String']['input']>;
  chassisID?: InputMaybe<Scalars['String']['input']>;
  /** A map of custom IDs for this setup. Input syntax is array of key-value (string-string) tuples. */
  customIDs?: InputMaybe<Scalars['JSON']['input']>;
  driveshaftID?: InputMaybe<Scalars['String']['input']>;
  engineID?: InputMaybe<Scalars['String']['input']>;
  gearboxID?: InputMaybe<Scalars['String']['input']>;
  inverterID?: InputMaybe<Scalars['String']['input']>;
  setupComments?: InputMaybe<Scalars['String']['input']>;
  /** Tyre compound for which this setup is intended */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCarMassInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Front-left mass */
  mCarFL?: InputMaybe<Scalars['Float']['input']>;
  /** Front-right mass */
  mCarFR?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-left mass */
  mCarRL?: InputMaybe<Scalars['Float']['input']>;
  /** Rear-right mass */
  mCarRR?: InputMaybe<Scalars['Float']['input']>;
  /** Driver mass */
  mDriver?: InputMaybe<Scalars['Float']['input']>;
  /** Target portion of mass in the front of the car */
  rWeightFTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCarSetupInput = {
  aero?: InputMaybe<UpdateByIdAeroInput>;
  aeroPackage?: InputMaybe<UpdateByIdAeroPackageInput>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  brakeSystem?: InputMaybe<UpdateByIdBrakeSystemInput>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecRootID?: InputMaybe<Scalars['MongoID']['input']>;
  cockpit?: InputMaybe<UpdateByIdCockpitInput>;
  custom?: InputMaybe<Scalars['JSON']['input']>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  /** Enable custom simulation payload for this setup. You as a user are responsible to have meaningful data in there. */
  customSimulationPayloadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  flattened?: InputMaybe<Scalars['JSON']['input']>;
  front?: InputMaybe<UpdateByIdCarEndInput>;
  frontLeft?: InputMaybe<UpdateByIdCarCornerInput>;
  frontRight?: InputMaybe<UpdateByIdCarCornerInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<UpdateByIdCarInfoInput>;
  intendedForSession?: InputMaybe<EnumCarSetupIntendedForSession>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Map of ballast positions to their masses. Keys are names of the positions and values are the masses. Input syntax is array of key-value tuples, like `mBallasts: [["front", 10], ["rear", 20]]`. */
  mBallasts?: InputMaybe<Scalars['JSON']['input']>;
  manualEndMileage?: InputMaybe<Scalars['Float']['input']>;
  manualStartMileage?: InputMaybe<Scalars['Float']['input']>;
  /** Mass out of garage (with driver in the seat) */
  massOutOfGarage?: InputMaybe<UpdateByIdCarMassInput>;
  /** Mass at the scales of the regulatory authority */
  massRegulation?: InputMaybe<UpdateByIdCarMassInput>;
  /** Mass from car setup */
  massSetup?: InputMaybe<UpdateByIdCarMassInput>;
  /** Mass from regulation scale replica in garage (team's scales) */
  massTeam?: InputMaybe<UpdateByIdCarMassInput>;
  powertrain?: InputMaybe<UpdateByIdPowertrainInput>;
  powertrainCentral?: InputMaybe<UpdateByIdPowertrainInput>;
  powertrainFront?: InputMaybe<UpdateByIdPowertrainInput>;
  powertrainRear?: InputMaybe<UpdateByIdPowertrainInput>;
  rear?: InputMaybe<UpdateByIdCarEndInput>;
  rearLeft?: InputMaybe<UpdateByIdCarCornerInput>;
  rearRight?: InputMaybe<UpdateByIdCarCornerInput>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Small info string */
  setupInfo?: InputMaybe<Scalars['String']['input']>;
  /** Override of setup sheet style, which usually comes from the chassis. */
  setupSheetStyle?: InputMaybe<EnumCarSetupSetupSheetStyle>;
  steering?: InputMaybe<UpdateByIdSteeringInput>;
  /** Map containing systems config comments. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigComment?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config NIssue data. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigNIssues?: InputMaybe<Scalars['JSON']['input']>;
  /** Map containing systems config values. Allowable keys are defined by `systemsConfigFields` from the chassis. Input syntax is array of key-value tuples. */
  systemsConfigValues?: InputMaybe<Scalars['JSON']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdCarSetupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CarSetup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdChassisAssemblyMeasurementInput = {
  chassisSpecMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  location?: InputMaybe<UpdateByIdAdjustableLocationInput>;
  orientation?: InputMaybe<UpdateByIdAdjustableOrientationInput>;
};

export type UpdateByIdChassisAssemblyTrackingSourceRecordInput = {
  sources?: InputMaybe<Array<InputMaybe<UpdateByIdChassisAssemblyTrackingSourceRecordSourcesInput>>>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdChassisAssemblyTrackingSourceRecordSourcesInput = {
  /** priority of this source. Defined on the alias but saved here for efficiency reasons */
  priority?: InputMaybe<Scalars['Float']['input']>;
  trackingSourceAliasID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdChassisInput = {
  /** Allowable keys for ballast measurements in car setups that use this chassis. */
  ballastPositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  currentlyInUse?: InputMaybe<Scalars['Boolean']['input']>;
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** Unique identifier for the chassis */
  reference?: InputMaybe<Scalars['String']['input']>;
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of setup sheet fields to available preset values. Keys are like `"front.kSpringF"`, and values are lists of options. Input syntax is array of key-value tuples, like `setupOptions: [["front.kSpringF", [100, 110, 120]]]`. */
  setupOptions?: InputMaybe<Scalars['JSON']['input']>;
  setupSheetStyle?: InputMaybe<EnumChassisSetupSheetStyle>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Allowable keys for systems config maps in car setups that use this chassis. */
  systemsConfigFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Car type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdChassisMassInput = {
  /** Base mass properties of the vehicle */
  base?: InputMaybe<UpdateByIdMassPropertiesInput>;
  /** Mass properties of the driver */
  driver?: InputMaybe<UpdateByIdMassPropertiesInput>;
  setupEquip?: InputMaybe<UpdateByIdMassPropertiesInput>;
};

export type UpdateByIdChassisMeasurementInput = {
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdChassisMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ChassisMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdChassisMeasurementsInput = {
  /** Default angle unit to display in setup options for this chassis */
  angles?: InputMaybe<EnumAngleUnit>;
  /** Default angular compliance unit to display in setup options for this chassis */
  angularCompliances?: InputMaybe<EnumAngularComplianceUnit>;
  /** Default angular torque compliance unit to display in setup options for this chassis */
  angularTorqueCompliances?: InputMaybe<EnumAngularTorqueComplianceUnit>;
  bumpPlateMeasurementMethod?: InputMaybe<EnumBumpPlateMeasurementMethod>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** bumpPlate[rad] = atan(bumpPlate[m] / bumpPlateRef[m]) */
  bumpPlateRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** Default compliance unit to display in setup options for this chassis */
  compliances?: InputMaybe<EnumComplianceUnit>;
  /** Default force unit to display in setup options for this chassis */
  forces?: InputMaybe<EnumForceUnit>;
  /** Default inertia unit to display in setup options for this chassis */
  inertias?: InputMaybe<EnumInertiaUnit>;
  /** If true, positive camber is top leaning in. If false, negative camber is top leaning in. */
  inverseCamber?: InputMaybe<Scalars['Boolean']['input']>;
  kinematicsExternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsExternalReadingsRequired>;
  kinematicsInternalReadingsRequired?: InputMaybe<EnumChassisMeasurementsKinematicsInternalReadingsRequired>;
  /** Default length unit to display in setup options for this chassis */
  lengths?: InputMaybe<EnumLengthUnit>;
  /** Default mass unit to display in setup options for this chassis */
  masses?: InputMaybe<EnumMassUnit>;
  /** Default power unit to display in setup options for this chassis */
  powers?: InputMaybe<EnumPowerUnit>;
  /** Default pressure unit to display in setup options for this chassis */
  pressures?: InputMaybe<EnumPressureUnit>;
  /** Default ratio unit to display in setup options for this chassis */
  ratios?: InputMaybe<EnumRatioUnit>;
  /** Function to calculate front ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcFront?: InputMaybe<Scalars['String']['input']>;
  /** Function to calculate rear ride height from measurement. "hRideMeasurement + hTyre" */
  rideHeightCalcRear?: InputMaybe<Scalars['String']['input']>;
  /** Default spring rate unit to display in setup options for this chassis */
  springRates?: InputMaybe<EnumSpringRateUnit>;
  /** Default steering rack ratio unit to display in setup options for this chassis */
  steeringRackRatios?: InputMaybe<EnumSteeringRackRatioUnit>;
  /** Default temperature unit to display in setup options for this chassis */
  temperatures?: InputMaybe<EnumTemperatureUnit>;
  toeMeasurementMethod?: InputMaybe<EnumToeMeasurementMethod>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefFront?: InputMaybe<Scalars['Float']['input']>;
  /** toe[rad] = atan(toe[m] / toeRef[m]) */
  toeRefRear?: InputMaybe<Scalars['Float']['input']>;
  /** If true, toe measurement is given as total over axle. If false, toe measurement is per individual wheel. */
  toeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default torque unit to display in setup options for this chassis */
  torques?: InputMaybe<EnumTorqueUnit>;
  /** Default torsion rate unit to display in setup options for this chassis */
  torsionRates?: InputMaybe<EnumTorsionRateUnit>;
  /** Default volume unit to display in setup options for this chassis */
  volumes?: InputMaybe<EnumVolumeUnit>;
  xTrackFront?: InputMaybe<Scalars['Float']['input']>;
  xTrackRear?: InputMaybe<Scalars['Float']['input']>;
  /** Wheelbase length in metres */
  xWheelbase?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdChassisPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Chassis>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdChassisPowerUnitInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdChassisPowertrainInput = {
  bevelSetSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  differentialSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  dropGearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearBoxSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  gearSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  layout?: InputMaybe<EnumPowertrainLayout>;
  /** Number of gears which are expected to be in the gearbox. */
  numGears?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdChassisSocketInput = {
  /** Unique name for this socket. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCockpitInput = {
  /** Ratio of the throttle pedal */
  rThrottlePedal?: InputMaybe<Scalars['Float']['input']>;
  /** Position of the throttle pedal */
  throttlePedalPosition?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCommentInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdContestantInput = {
  /** IDs of usable chassis */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Number of the chassis for this contestant. */
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** Default color to use for this contestant where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Drivers that constitute this contestant */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Is this contestant eligible for points? */
  eligibleForPoints?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this contestant be hidden from users? */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Season that this contestant is participating in */
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyContestantID?: InputMaybe<Scalars['String']['input']>;
  /** URI to the audio stream for this contestant in Transcribble. */
  transcribbleAudioURI?: InputMaybe<Scalars['String']['input']>;
  /** Tyres assigned to this contestant for the season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Tyre sets assigned to this contestant for the season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdContestantPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Contestant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCurrentInput = {
  /** A */
  amps?: InputMaybe<Scalars['Float']['input']>;
  /** mA */
  milliamps?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDamperAdjusterInput = {
  /** Maximum setting, if using min/max/step */
  maxSetting?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum setting, if using min/max/step */
  minSetting?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settingNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Increment to suggest values in, if using min/max/step */
  step?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDamperConfigInput = {
  forceTable?: InputMaybe<UpdateByIdForceTableInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Define which damper clicks are associated with this setting */
  settings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdDampingRateInput = {
  /** Nms/m */
  newtonSecondsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** Nms/mm */
  newtonSecondsPerMillimetre?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·s/in */
  poundForceSecondsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDashboardInput = {
  /** Dashboard reading of fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Dashboard reading of fuel amount at the start of the run */
  mFuelRunStart?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDefaultFlexLayoutConfigsInput = {
  BOP?: InputMaybe<Scalars['MongoID']['input']>;
  KPI?: InputMaybe<Scalars['MongoID']['input']>;
  REPORT?: InputMaybe<Scalars['MongoID']['input']>;
  RUNSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPOVERVIEW?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSANDBOX?: InputMaybe<Scalars['MongoID']['input']>;
  SETUPSHEET?: InputMaybe<Scalars['MongoID']['input']>;
  SIMULATION?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdDensityInput = {
  /** kg/m³ */
  kilogramsPerCubicMetre?: InputMaybe<Scalars['Float']['input']>;
  /** kg/L */
  kilogramsPerLitre?: InputMaybe<Scalars['Float']['input']>;
  /** lb/ft³ */
  poundsPerCubicFoot?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdDepartmentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDepartmentPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Department>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdDifferentialConfigInput = {
  /** Is this differential config allowed to be selected in new car setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  maxPreloadForce?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rampAccel?: InputMaybe<Scalars['Float']['input']>;
  rampDecel?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdDriverChampionshipStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  points: Scalars['Int']['input'];
  /** Historical race finish positions of this driver in this season. Null values represent DNFs. Should only be used for pre-session standings data. */
  prevRacePositions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDynoConfigColumnsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** runSheet.tyreSetID, setup.mCar, etc. */
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Tyre, Weight, etc. */
  header?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDynoConfigInput = {
  columns?: InputMaybe<Array<InputMaybe<UpdateByIdDynoConfigColumnsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDynoConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<DynoConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdEnergyInput = {
  /** J */
  joules?: InputMaybe<Scalars['Float']['input']>;
  /** kJ */
  kilojoules?: InputMaybe<Scalars['Float']['input']>;
  /** kWh */
  kilowattHours?: InputMaybe<Scalars['Float']['input']>;
  /** MJ */
  megajoules?: InputMaybe<Scalars['Float']['input']>;
  /** Wh */
  wattHours?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdEventContestantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of chassis used, if different for this event. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this event. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyres allocated to this contestant for this event (like during races where only tyres handed out at this very race are permitted). */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of tyre sets allocated to this contestant for this event. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdEventInput = {
  /** Density of the fuel */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Number of this event in the season */
  NEventSeason?: InputMaybe<Scalars['Float']['input']>;
  /** Default SoCRequired values to use during this event (assuming single track layout) */
  SoCRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Fuel/SoC/Energy consumptions for each track layout in this event. */
  consumptions?: InputMaybe<Array<InputMaybe<UpdateByIdLayoutConsumptionInput>>>;
  contestants?: InputMaybe<Array<InputMaybe<UpdateByIdEventContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumEventDebriefNotesMode>;
  /** Default energyRequired values to use during this event (assuming single track layout) */
  energyRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  /** Energy sweep information for Formula E */
  energySweep?: InputMaybe<Scalars['JSON']['input']>;
  enumEventType?: InputMaybe<EnumEventEnumEventType>;
  enumEventVenue?: InputMaybe<EnumEventEnumEventVenue>;
  /** e.g. Race, Test, etc. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Default fuelRequired values to use during this event (assuming single track layout) */
  fuelRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  /** Should the iRacing service populate this event when an unknown event is encountered? */
  iRacingServiceIsNextEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of issues related to this event. */
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Reference laptimes for each track layout in this event. */
  referenceLaptimes?: InputMaybe<Array<InputMaybe<UpdateByIdEventReferenceLaptimesInput>>>;
  /** Selected authors for the event report (person reference plus a name snapshot). */
  reportAuthors?: InputMaybe<Array<InputMaybe<UpdateByIdEventReportAuthorsInput>>>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Time of event end in local time */
  tEventEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of event start in local time */
  tEventStart?: InputMaybe<Scalars['Date']['input']>;
  tLapAverage?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of this event in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyEventID?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumEventType>;
  tyreDefaults?: InputMaybe<Array<InputMaybe<UpdateByIdEventTyreDefaultsSetInput>>>;
  tyreDefaultsFL?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsFR?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsRL?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsRR?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsWetFL?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsWetFR?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsWetRL?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  tyreDefaultsWetRR?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
};

export type UpdateByIdEventPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdEventReferenceLaptimesInput = {
  /** Reference Laptime for ATTACK lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for COOL lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for FCY lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for IN lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUT lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for OUTIN lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PITLANE lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PREP lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for PUSH lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for QUALI lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SAFETYCAR lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SHAKEDOWN lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for SLOW lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TARGET lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOGRID lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPADDOCK lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for TOPITS lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Reference Laptime for UNFINISHED lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  calculationMethod?: InputMaybe<EnumEventReferenceLaptimesCalculationMethod>;
  /** Reference Laptime when using the calculation method "RATIO" */
  referenceLaptime?: InputMaybe<Scalars['Float']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdEventReportAuthorsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdEventTyreDefaultsInput = {
  /** Suggested bare minimum tyre pressure for this event. */
  pTyreMin?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested minimum pressure at the start of a run for this event. */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested pressure at the start of a run for this event. */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Suggested tyre pressure target for this event. */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdEventTyreDefaultsSetInput = {
  frontLeft?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  frontRight?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  rearLeft?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  rearRight?: InputMaybe<UpdateByIdEventTyreDefaultsInput>;
  /** Which compound should these defaults be applied on? */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Which tyre type should these defaults be applied on? */
  tyreType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFlexLayoutConfigGlobalXAxisInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  gain?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumFlexLayoutConfigGlobalXAxisType>;
};

export type UpdateByIdFlexLayoutConfigInput = {
  globalXAxis?: InputMaybe<UpdateByIdFlexLayoutConfigGlobalXAxisInput>;
  intendedFor?: InputMaybe<EnumFlexLayoutConfigIntendedFor>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration recognised by flexlayout-react */
  model?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** If this is non-empty, only users with one of these roles can see this config. */
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFlexLayoutConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<FlexLayoutConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdForceInput = {
  /** N */
  newtons?: InputMaybe<Scalars['Float']['input']>;
  /** lbf */
  poundsForce?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdForceTableInput = {
  /** Acceleration (ddx) values */
  acceleration?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F1 */
  dampingForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F0 */
  force?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Also known as F2 */
  inertanceForce?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Velocity (dx) values */
  velocity?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Displacement values */
  x?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  xMax?: InputMaybe<Scalars['Float']['input']>;
  xMin?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdFrequencyInput = {
  /** Hz */
  hertz?: InputMaybe<Scalars['Float']['input']>;
  /** kHz */
  kilohertz?: InputMaybe<Scalars['Float']['input']>;
  /** MHz */
  megahertz?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdGenericRunSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  blockBackgroundColour?: InputMaybe<Scalars['String']['input']>;
  brakeFields?: InputMaybe<Array<InputMaybe<EnumBrakeBlockField>>>;
  /** A map of colorable things to colors */
  colorMap?: InputMaybe<Scalars['JSON']['input']>;
  defaultOpenState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order in which to display visible run energy fields. */
  energyFieldOrder?: InputMaybe<Array<InputMaybe<EnumGenericRunSheetStyleBlockEnergyFieldOrder>>>;
  /** Source of the lap end energy value */
  energyLapEndSource?: InputMaybe<Scalars['String']['input']>;
  energyType?: InputMaybe<EnumEnergyType>;
  field?: InputMaybe<Scalars['String']['input']>;
  /** Field name for first comment box in a double comment block. */
  field1?: InputMaybe<Scalars['String']['input']>;
  /** Field name for second comment box in a double comment block. */
  field2?: InputMaybe<Scalars['String']['input']>;
  fuelColumns?: InputMaybe<Array<EnumFuelColumn>>;
  fuelFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The height of the block within the grid */
  height?: InputMaybe<Scalars['Int']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isShownWhenFolded?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Label on first comment box in a double comment block. */
  label1?: InputMaybe<Scalars['String']['input']>;
  /** Label on second comment box in a double comment block. */
  label2?: InputMaybe<Scalars['String']['input']>;
  /** Ordered columns to show in the lap table */
  lapColumns?: InputMaybe<Array<InputMaybe<UpdateByIdLapColumnInput>>>;
  lapCountBlockFieldOrder?: InputMaybe<Array<InputMaybe<UpdateByIdGenericRunSheetStyleBlockLapCountBlockFieldOrderInput>>>;
  lapFlags?: InputMaybe<UpdateByIdLapFlagLabelsInput>;
  /** Names of lapKPI fields to show */
  lapKPIs?: InputMaybe<Array<InputMaybe<UpdateByIdGenericRunSheetStyleBlockLapKpIsInput>>>;
  manualLapInputByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  pressureUnit?: InputMaybe<EnumPressureUnit>;
  rows?: InputMaybe<Scalars['Float']['input']>;
  /** Order in which to display visible run energy fields. */
  runEnergyFieldOrder?: InputMaybe<Array<EnumRunEnergyField>>;
  runEnergyFields?: InputMaybe<UpdateByIdRunEnergyFieldLabelsInput>;
  runKPIRows?: InputMaybe<Array<InputMaybe<UpdateByIdRunKpiTableRowInput>>>;
  runKPITable?: InputMaybe<Array<InputMaybe<UpdateByIdGenericRunSheetStyleBlockRunKpiTableInput>>>;
  setupSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Defines the visibility of the ambient and track condition in the weather block */
  showAmbientAndTrackCondition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the extended combustion consumption fields. */
  showExtendedConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the fuel density input box. */
  showFuelDensityInput?: InputMaybe<Scalars['Boolean']['input']>;
  showGetPreviousRunPostPressureButton?: InputMaybe<Scalars['Boolean']['input']>;
  showGetRecommendationButton?: InputMaybe<Scalars['Boolean']['input']>;
  showLapTypeColors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show the maximum amount of laps per consumption for a given fuel load fields. */
  showMaxLapsPerConsumptionFields?: InputMaybe<Scalars['Boolean']['input']>;
  showMinimumPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  showPostRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showPreRunBrakeTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showSurfaceTemps?: InputMaybe<Scalars['Boolean']['input']>;
  showTargetPressures?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreReferencePressure?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSelector?: InputMaybe<Scalars['Boolean']['input']>;
  showTyreSetSelector?: InputMaybe<Scalars['Boolean']['input']>;
  staggerSettings?: InputMaybe<UpdateByIdGenericRunSheetStyleBlockStaggerSettingsInput>;
  standardTyrePressureBox?: InputMaybe<UpdateByIdGenericRunSheetStyleBlockStandardTyrePressureBoxInput>;
  standardTyreTempBox?: InputMaybe<UpdateByIdGenericRunSheetStyleBlockStandardTyreTempBoxInput>;
  style?: InputMaybe<EnumRunSheetStyleBlockStyle>;
  temperatureUnit?: InputMaybe<EnumTemperatureUnit>;
  title?: InputMaybe<Scalars['String']['input']>;
  treadDepthUnit?: InputMaybe<EnumLengthUnit>;
  type?: InputMaybe<EnumGenericRunSheetStyleBlockType>;
  tyreTableRows?: InputMaybe<Array<InputMaybe<UpdateByIdTyreTableBlockRowInput>>>;
  /** Number of tread depth measurements to allow. Use `0` or `null` to hide the input. */
  tyreTreadDepthMeasurements?: InputMaybe<Scalars['Int']['input']>;
  unitSystem?: InputMaybe<EnumUnitSystem>;
  velocityUnit?: InputMaybe<EnumVelocityUnit>;
  /** Ordered weather block fields to show */
  weatherFieldOrder?: InputMaybe<Array<EnumWeatherBlockField>>;
  /** The width of the block within the grid */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateByIdGenericRunSheetStyleBlockLapCountBlockFieldOrderInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  field?: InputMaybe<EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdGenericRunSheetStyleBlockLapKpIsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<UpdateByIdValueLimitInput>;
  upperLimit?: InputMaybe<UpdateByIdValueLimitInput>;
};

export type UpdateByIdGenericRunSheetStyleBlockRunKpiTableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  defaultEditable?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<UpdateByIdGenericRunSheetStyleBlockRunKpiTableRowsInput>>>;
};

export type UpdateByIdGenericRunSheetStyleBlockRunKpiTableRowsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdRunKpiTableRowFieldInput>>>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdGenericRunSheetStyleBlockStaggerSettingsInput = {
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumLengthUnit>;
};

export type UpdateByIdGenericRunSheetStyleBlockStandardTyrePressureBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumPressureOption>>>;
  unit?: InputMaybe<EnumPressureUnit>;
};

export type UpdateByIdGenericRunSheetStyleBlockStandardTyreTempBoxInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<EnumTemperatureOption>>>;
  unit?: InputMaybe<EnumTemperatureUnit>;
};

export type UpdateByIdGeoLocationInput = {
  /** [longitude, latitude] in decimal degrees */
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Only "Point" is supported */
  type?: InputMaybe<EnumGeoLocationType>;
};

export type UpdateByIdIssueInput = {
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  area?: InputMaybe<Scalars['String']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<UpdateByIdCommentInput>>>;
  containment?: InputMaybe<Scalars['String']['input']>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  departmentID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDetails?: InputMaybe<Scalars['String']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  issueStatus?: InputMaybe<EnumIssueIssueStatus>;
  linkedIssueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagID?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTagLabelSort?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EnumIssuePriority>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  rootCause?: InputMaybe<Scalars['String']['input']>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thirdPartyIssueID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdIssuePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Issue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdJobInput = {
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  /** The id of the parent job or issue that this task is assigned to */
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
  /** ID of run sheet associated with this job */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Array of sub-task IDs associated with this issue */
  subTaskIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Date by which the issue should be resolved */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  /** Reference to a car data timestamp */
  timeInfo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdJobPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Job>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdKinematicsExternalModelInput = {
  aCaster?: InputMaybe<Scalars['Float']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  uprightPosition?: InputMaybe<Scalars['Float']['input']>;
  uprightPositionName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLapColumnInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<EnumLapColumnField>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<UpdateByIdValueLimitInput>;
  upperLimit?: InputMaybe<UpdateByIdValueLimitInput>;
};

export type UpdateByIdLapDataInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow and should be excluded from average calculation? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Received a Track Limit Warning from Race Control */
  BTrackLimitWarning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Coded message from driver */
  driverCallout?: InputMaybe<Scalars['String']['input']>;
  /** Coded message from driver */
  driverCallout2?: InputMaybe<Scalars['String']['input']>;
  /** Map of kpi fields to their values for analysis. Input syntax is array of tuples, like `kpi: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  kpi?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  /** Fuel mass consumption in this lap */
  mFuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel mass remaining at the end of this lap. */
  mFuelLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  /** Energy comsumption in this lap (kWh) */
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Energy remaining (kWh)  at the end of this lap. */
  rEnergyLapEnd?: InputMaybe<Scalars['Float']['input']>;
  /** SoC comsumption in this lap (%) */
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** SOC (%) remaining at the end of this lap. */
  rSOCLapEnd?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** Source of the lap data */
  source?: InputMaybe<EnumLapDataSource>;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an IN lap, indicates when the driver crossed the pit entry line. */
  tDayPitIn?: InputMaybe<Scalars['Date']['input']>;
  /** If this is an OUT lap, indicates when the driver crossed the pit exit line. */
  tDayPitOut?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Time spent in pits if the lap started from the pit lane. */
  tInPit?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times. */
  tSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tSessionRemainingLapStart?: InputMaybe<Scalars['Float']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<UpdateByIdTrackStateInput>>>;
  /** Tyre compound information */
  tyreCompound?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** Lap flag field labels mapped to their display names. Null or unset fields are not displayed. */
export type UpdateByIdLapFlagLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLapInput = {
  /** Was DRS used in this lap? */
  BDRSUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Was this laptime cancelled? */
  BLapCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this laptime slow? */
  BLapIsSlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this an IN lap? */
  BPitIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this an OUT lap? */
  BPitOut?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lap number in run from timing */
  NLapRun?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in run from car data */
  NLapRunCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in run from manual mode */
  NLapRunManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from timing */
  NLapSession?: InputMaybe<Scalars['Int']['input']>;
  /** Lap number in session from car data */
  NLapSessionCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in session from manual mode */
  NLapSessionManual?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from timing */
  NLapStint?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from car data */
  NLapStintCarData?: InputMaybe<Scalars['Float']['input']>;
  /** Lap number in stint from manual mode */
  NLapStintManual?: InputMaybe<Scalars['Float']['input']>;
  /** Cell temperature */
  TCell?: InputMaybe<Scalars['Float']['input']>;
  data?: InputMaybe<Array<InputMaybe<UpdateByIdLapDataInput>>>;
  /** Amount of energy (fuel/battery) at the start of this lap. */
  energyLapStart?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining */
  energyRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** Energy or fuel remaining as data input (e.g. from telemetry) */
  energyRemainingData?: InputMaybe<Scalars['Float']['input']>;
  fuelConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  /** Comments made by the driver */
  lapComment?: InputMaybe<Scalars['String']['input']>;
  /** Systems info generated during the lap */
  lapCommentSystems?: InputMaybe<Scalars['String']['input']>;
  /** Map of lap KPI fields to their values for car-data-related analysis. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  lapKPI?: InputMaybe<Scalars['JSON']['input']>;
  lapType?: InputMaybe<Scalars['String']['input']>;
  laptimeServiceHash?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  /** Highest power mode used this lap (for electric vehicles). */
  powerMode?: InputMaybe<Scalars['Float']['input']>;
  rEnergyConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  rSOCConsumptionThisLap?: InputMaybe<Scalars['Float']['input']>;
  raceControlMessage?: InputMaybe<Scalars['String']['input']>;
  /** The run sheet this lap belongs to. */
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time at which this lap was completed. */
  tDay?: InputMaybe<Scalars['Date']['input']>;
  /** Time of day of each sector, provided by a timing service. */
  tDaySectors?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** Laptime where input directly by a user. */
  tLapManual?: InputMaybe<Scalars['Float']['input']>;
  /** Laptime */
  tLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Sectore times given manually by a user. */
  tSectorsManual?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by an alternative official source. */
  tSectorsOfficial?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sector times as given by a timing service. */
  tSectorsTiming?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Map of timing KPI fields to their values for timing-related analysis. Input syntax is array of tuples, like `timingKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  timingKPI?: InputMaybe<Scalars['JSON']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  trackStates?: InputMaybe<Array<InputMaybe<UpdateByIdTrackStateInput>>>;
  /** Tyre compound information from timing stream */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  /** Official topspeed measurement */
  vCarLapMax?: InputMaybe<Scalars['Float']['input']>;
  /** Official speed measurements per sector */
  vCarSectors?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdLapPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Lap>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLapSequenceInput = {
  laps?: InputMaybe<Array<InputMaybe<UpdateByIdLapSequenceLapsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLapSequenceLapsInput = {
  NLap?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lapType?: InputMaybe<EnumLapSequenceLapsLapType>;
};

export type UpdateByIdLapSequencePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<LapSequence>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLapSequenceTemplateInput = {
  laps?: InputMaybe<Array<InputMaybe<UpdateByIdLapSequenceTemplateLapsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLapSequenceTemplateLapsInput = {
  /** Lap number in sequence */
  NLap?: InputMaybe<Scalars['Float']['input']>;
  lapType?: InputMaybe<EnumLapSequenceTemplateLapsLapType>;
};

export type UpdateByIdLapSequenceTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<LapSequenceTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

/** Collection of tuples defining bounds to automatically classify laps. Does not apply to in/out/race control lap types. Comparisons are to be made with `<` or `>=` at aligning bounds. Minimum value is 0 and maximum value is 1000000. */
export type UpdateByIdLaptimeThresholdsInput = {
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as cool. */
  cool?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as prep. */
  prep?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as push. */
  push?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as slow. */
  slow?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Tuple defining [lower, upper] lap time bounds, within which a lap should be marked as target. */
  target?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type UpdateByIdLayoutConsumptionInput = {
  SoCRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  energyRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  fuelRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLengthInput = {
  /** cm */
  centimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft */
  feet?: InputMaybe<Scalars['Float']['input']>;
  /** in */
  inches?: InputMaybe<Scalars['Float']['input']>;
  /** km */
  kilometres?: InputMaybe<Scalars['Float']['input']>;
  /** m */
  metres?: InputMaybe<Scalars['Float']['input']>;
  /** μm */
  micrometres?: InputMaybe<Scalars['Float']['input']>;
  /** mi */
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** mm */
  millimetres?: InputMaybe<Scalars['Float']['input']>;
  /** thou */
  thou?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdLiveStandingInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  currentLocation?: InputMaybe<EnumLiveStandingCurrentLocation>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  fastestLap?: InputMaybe<UpdateByIdBestValuesFastestLapInput>;
  fastestSectors?: InputMaybe<Array<InputMaybe<UpdateByIdBestValuesFastestSectorInput>>>;
  /** Does this driver have the fastest lap in the session? Only one driver should have this true at a time. */
  hasFastestLap?: InputMaybe<Scalars['Boolean']['input']>;
  lapsCompleted?: InputMaybe<Scalars['Int']['input']>;
  /** 1-indexed rank of this driver with respect to the rest of the grid */
  position?: InputMaybe<Scalars['Int']['input']>;
  postRacePenalty?: InputMaybe<UpdateByIdLiveStandingPostRacePenaltyInput>;
  startNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLiveStandingPostRacePenaltyInput = {
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  totalTimePenalty?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdLocalConnectionInput = {
  dataMapping?: InputMaybe<EnumLocalConnectionDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  outputFolder?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Float']['input']>;
  useSSL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdLocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<UpdateByIdGeoLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLocationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Location>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLogInput = {
  logLevel?: InputMaybe<EnumLogLogLevel>;
  /** A single log from the source service */
  message?: InputMaybe<Scalars['String']['input']>;
  serviceSource?: InputMaybe<EnumLogServiceSource>;
  userID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLogPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Log>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdManufacturerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdManufacturerPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Manufacturer>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdMassInput = {
  /** g */
  grams?: InputMaybe<Scalars['Float']['input']>;
  /** kg */
  kilograms?: InputMaybe<Scalars['Float']['input']>;
  /** mg */
  milligrams?: InputMaybe<Scalars['Float']['input']>;
  /** oz */
  ounces?: InputMaybe<Scalars['Float']['input']>;
  /** lb */
  pounds?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdMassPropertiesInput = {
  COGx?: InputMaybe<Scalars['Float']['input']>;
  COGy?: InputMaybe<Scalars['Float']['input']>;
  COGz?: InputMaybe<Scalars['Float']['input']>;
  Ixx?: InputMaybe<Scalars['Float']['input']>;
  Iyy?: InputMaybe<Scalars['Float']['input']>;
  Izz?: InputMaybe<Scalars['Float']['input']>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  /** Allowable mass range, for when a set mass value doesn't apply */
  massRange?: InputMaybe<AdjustableMassInput>;
};

export type UpdateByIdMomentOfInertiaInput = {
  /** kgm² */
  kilogramMetresSquared?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/s² */
  poundForceFeetSecondSquared?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdNotificationConfigInput = {
  faultAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  faultCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  faultStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
  jobAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  jobCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  jobStatusChanged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdOneTimingWeatherServiceConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event IDs to which the weather data should be published. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Weather station's latitude from geolocation */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  logLevel?: InputMaybe<EnumOneTimingWeatherServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weather station's longitude from geolocation */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Name for this set of configuration settings. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** One Timing server port. */
  timingPort?: InputMaybe<Scalars['Int']['input']>;
  /** One Timing server address. */
  timingURL?: InputMaybe<Scalars['String']['input']>;
  /** Time interval in seconds between two API data updates. */
  updateInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdOneTimingWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<OneTimingWeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPackageInput = {
  authorID?: InputMaybe<Scalars['MongoID']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<UpdateByIdPackageItemsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  useAsCopyReference?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdPackageItemsInput = {
  /** 'setup.front.hRide' or 'spec.specID.adjustables.adjIndex.LOCATION' */
  path?: InputMaybe<Scalars['String']['input']>;
  /** string | number | null (also can 'delete' certain things from a setup) */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdPackagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Package>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPartInput = {
  /** Can this very part be used multiple times on a car. For 'virtual parts' or other special applications. Overrides the setting of the specification. */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  eligibleEventTypes?: InputMaybe<EnumPartEligibleEventTypes>;
  /** To be used for dummy parts or at user discretion for special applications. */
  isVirtualPart?: InputMaybe<Scalars['Boolean']['input']>;
  lifetimeMileage?: InputMaybe<Scalars['Float']['input']>;
  locationID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerPartID?: InputMaybe<Scalars['String']['input']>;
  manufacturerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  partStatus?: InputMaybe<UpdateByIdPartStatusInput>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  readingLocationOverride?: InputMaybe<Array<InputMaybe<EnumPartReadingLocationOverride>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  rootAssemblyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  teamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementHistoryIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumPartTypeID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdPartInstanceInput = {
  measurements?: InputMaybe<Array<InputMaybe<UpdateByIdPartInstanceMeasurementInput>>>;
  parentID?: InputMaybe<Scalars['MongoID']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  readingLocation?: InputMaybe<EnumReadingLocation>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemReferenceDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPartInstanceMeasurementCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPartInstanceMeasurementInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<UpdateByIdPartInstanceMeasurementCoordinatesInput>;
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  idx?: InputMaybe<Scalars['Float']['input']>;
  rotation?: InputMaybe<UpdateByIdPartInstanceMeasurementRotationInput>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPartInstanceMeasurementRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPartInstancePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PartInstance>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPartPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Part>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPartStatusInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  statusComment?: InputMaybe<Scalars['String']['input']>;
  userEnumPartStatusID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdPersonInput = {
  /** 3-letter acronym for drivers */
  acronym?: InputMaybe<Scalars['String']['input']>;
  behaviour?: InputMaybe<UpdateByIdBehaviourConfigInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  canopyCredentials?: InputMaybe<UpdateByIdCanopyCredentialsInput>;
  carUpdateMethod?: InputMaybe<EnumPersonCarUpdateMethod>;
  /** IDs of contestants visible to this person when logged in. */
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultFlexLayoutConfigs?: InputMaybe<UpdateByIdDefaultFlexLayoutConfigsInput>;
  defaultRunSheetCompareStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStylePhoneID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultTyreReferenceTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Default string for tyre set naming, where x=Chassis, i=Info, s=SetNumber, (c=Corner or a=Axle) */
  defaultTyreSetNameFormat?: InputMaybe<Scalars['String']['input']>;
  displayColor?: InputMaybe<Scalars['String']['input']>;
  dynoConfigID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of contestants editable to this person when logged in. */
  editableContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotificationConfig?: InputMaybe<UpdateByIdNotificationConfigInput>;
  /** IDs of events visible to this person when logged in. */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this user be unable to see KPIs? */
  hideKPIs?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to track his working time? */
  isTimeTracker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to see, update and approve working times for other users? */
  isTimeTrackerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequenceTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  localConnections?: InputMaybe<Array<InputMaybe<UpdateByIdLocalConnectionInput>>>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportPicture?: InputMaybe<Scalars['String']['input']>;
  /** Collection of favourite plot page config IDs. */
  plotPageConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  privateMobile?: InputMaybe<Scalars['Float']['input']>;
  privatePhone?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<EnumPersonRole>;
  /** Collection of favourite setup overview config IDs. */
  setupOverviewConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  timeTrackerApprovalByPersonID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Collection of personal setup IDs. */
  userSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userSimulationSettings?: InputMaybe<UpdateByIdUserSimulationSettingsInput>;
  username?: InputMaybe<Scalars['String']['input']>;
  viewConfig?: InputMaybe<UpdateByIdViewConfigInput>;
  /** IDs of contestants visible to this person when logged in. */
  visibleContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of events visible to this person when logged in. */
  visibleEventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of teams visible to this person when logged in. */
  visibleTeamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  workMobile?: InputMaybe<Scalars['Float']['input']>;
  workPhone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPersonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Person>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPlotConfigInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  xAxisType?: InputMaybe<EnumPlotConfigXAxisType>;
  xDataSource?: InputMaybe<Scalars['String']['input']>;
  xLabel?: InputMaybe<Scalars['String']['input']>;
  /** Object containing at least `label`, and optionally `color`, `lineStyle` (from `EnumLineStyle`), and `marker` (from `EnumMarkerType`) properties */
  yData?: InputMaybe<Scalars['JSON']['input']>;
  yDataSource?: InputMaybe<Scalars['String']['input']>;
  yLabel?: InputMaybe<Scalars['String']['input']>;
  yLines?: InputMaybe<Array<InputMaybe<UpdateByIdPlotConfigLineInput>>>;
};

export type UpdateByIdPlotConfigLineInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<EnumLineStyle>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPlotPageConfigInput = {
  /** Number of columns in the grid. */
  gridCols?: InputMaybe<Scalars['Int']['input']>;
  /** Number of rows in the grid. */
  gridRows?: InputMaybe<Scalars['Int']['input']>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  plots?: InputMaybe<Array<InputMaybe<UpdateByIdPlotConfigInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdPlotPageConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PlotPageConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPointsSystemInput = {
  /** Array of points for the fastest lap */
  laptimeDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Race position cutoff for drivers eligible for points for the fastest lap. In some race series you need to be in the top 10 to get the bonus point. */
  laptimePositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  /** Array of points for the fastest lap for the teams. In some race series only the driver receives points for fastest lap. */
  laptimeTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** How much race distance needs to be completed to be eligible for points */
  positionalCompletionMin?: InputMaybe<Scalars['Float']['input']>;
  /** How much race distance in % needs to be completed to be eligible for points */
  positionalCompletionMinRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Array of driver points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalDriverPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of team points per final position. E.g 25,18,15,12,10,8,6,4,2,1 for 2024 F1 Points system */
  positionalTeamPoints?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sessionType?: InputMaybe<EnumSessionType>;
};

export type UpdateByIdPointsSystemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PointsSystem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPowerInput = {
  /** 1hp = 745.6998715822702W */
  horsepowerMechanical?: InputMaybe<Scalars['Float']['input']>;
  /** kW */
  kilowatts?: InputMaybe<Scalars['Float']['input']>;
  /** W */
  watts?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPowertrainInput = {
  MDiffPreloadCold?: InputMaybe<Scalars['Float']['input']>;
  MDiffPreloadHot?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are arbitrary numbers. Input syntax is array of key-value tuples, like `NEngineBlanking: [["left", 5], ["right", 9]]`. */
  NEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  NFrictionFaces?: InputMaybe<Scalars['Float']['input']>;
  PPowerLevel?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampCoast?: InputMaybe<Scalars['Float']['input']>;
  aDiffRampDrive?: InputMaybe<Scalars['Float']['input']>;
  bevelSet?: InputMaybe<PowertrainGearInput>;
  /** Map of blanking fields with values. Keys are strings like `gearboxRadiatorTapes` or `hRESSBlanking`, and values are strings describing the blanking details. Input syntax is array of key-value tuples, like `blanking: [["gearboxRadiatorTapes", "5"]]`. */
  blanking?: InputMaybe<Scalars['JSON']['input']>;
  clutch?: InputMaybe<Scalars['String']['input']>;
  clutchCylinder?: InputMaybe<Scalars['String']['input']>;
  dAirRestrictor?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the selected configuration from the spec. */
  differentialConfigName?: InputMaybe<Scalars['String']['input']>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  dropGear?: InputMaybe<PowertrainGearInput>;
  /** Map of extra engine blanking measurement fields to their values. Input syntax is array of key-value tuples, like `engineBlankingComments: [["louvres", "NONE"], ["other", true]]`. */
  engineBlankingDetails?: InputMaybe<Scalars['JSON']['input']>;
  frictionFaces?: InputMaybe<Scalars['String']['input']>;
  gearboxGridType?: InputMaybe<Scalars['String']['input']>;
  gears?: InputMaybe<Array<InputMaybe<PowertrainStandardGearInput>>>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hEngineBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are measurements. Input syntax is array of key-value tuples, like `hGearboxBlanking: [["left", 0.003], ["right", 0.004]]`. */
  hGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
  rBevelSet?: InputMaybe<Scalars['Float']['input']>;
  rDropGear?: InputMaybe<Scalars['Float']['input']>;
  /** Map of engine blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rEngineBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rEngineBlanking?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gears to their ratios. Keys are strings like `"1"` or `"R"`, and values are ratios. Input syntax is array of key-value tuples, like `rGearRatios: [["R", 0.8], ["1", 0.3]]`. */
  rGearRatios?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of gearbox blanking measurement points to their thicknesses. Keys are names for the points, and values are ratios. Input syntax is array of key-value tuples, like `rGearboxBlanking: [["left", 0.05], ["right", 0.06]]`. */
  rGearboxBlanking?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdPressureInput = {
  /** bar */
  bar?: InputMaybe<Scalars['Float']['input']>;
  /** inHg */
  inchesOfMercury?: InputMaybe<Scalars['Float']['input']>;
  /** kPa */
  kilopascals?: InputMaybe<Scalars['Float']['input']>;
  /** mbar */
  millibar?: InputMaybe<Scalars['Float']['input']>;
  /** Pa */
  pascals?: InputMaybe<Scalars['Float']['input']>;
  /** psi */
  psi?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdProjectPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Project>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdQualityCheckActionInput = {
  acknowledgedAt?: InputMaybe<Scalars['Date']['input']>;
  acknowledgedByID?: InputMaybe<Scalars['MongoID']['input']>;
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledByID?: InputMaybe<Scalars['MongoID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  closedAt?: InputMaybe<Scalars['Date']['input']>;
  closedByID?: InputMaybe<Scalars['MongoID']['input']>;
  comments?: InputMaybe<Array<InputMaybe<UpdateByIdCommentInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdByID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EnumQualityCheckActionPriority>;
  status?: InputMaybe<EnumQualityCheckActionStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdQualityCheckActionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<QualityCheckAction>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdQualityCheckInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  qualityCheckActionIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdQualityCheckPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<QualityCheck>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRaceSeriesInput = {
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultJobListIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  driversPerCar?: InputMaybe<EnumRaceSeriesDriversPerCar>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  lapTypeConfig?: InputMaybe<UpdateByIdRaceSeriesLapTypeConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  seasonIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  sortingIndex?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdRaceSeriesLapTypeConfigInput = {
  ATTACK?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  COOL?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  FCY?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  IN?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  OUT?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  OUTIN?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  PITLANE?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  PREP?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  PUSH?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  QUALI?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  SAFETYCAR?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  SHAKEDOWN?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  SLOW?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  TARGET?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  TOGRID?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  TOPADDOCK?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  TOPITS?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
  UNFINISHED?: InputMaybe<UpdateByIdRaceSeriesLapTypeEntryInput>;
};

export type UpdateByIdRaceSeriesLapTypeEntryInput = {
  displayString: Scalars['String']['input'];
  lapTypeColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateByIdRaceSeriesPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<RaceSeries>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRadioMessageInput = {
  /** Time at which the audio message arrived in the queue for transcribing. */
  arrivedInQueueAt?: InputMaybe<Scalars['Date']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length of the audio message in seconds. */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** Time at which the audio message was taken by a transcription service. */
  takenByTranscriberAt?: InputMaybe<Scalars['Date']['input']>;
  /** The text of the message, as transcribed by Transcribble. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Time at which this message began recording audio. */
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which the audio message was finished initial transcribing. */
  transcribedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdRadioMessagePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<RadioMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRatioInput = {
  /** % */
  percent?: InputMaybe<Scalars['Float']['input']>;
  /** 0 = 0%, 1 = 100%, 1.5 = 150% */
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdRegulationSetInput = {
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  hRideFrontMin?: InputMaybe<Scalars['Float']['input']>;
  hRideRearMin?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMax?: InputMaybe<Scalars['Float']['input']>;
  massDistRunningMin?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMax?: InputMaybe<Scalars['Float']['input']>;
  massDistStaticMin?: InputMaybe<Scalars['Float']['input']>;
  massMin?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdReportTemplateAppendixInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdReportTemplateBopInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bopFileOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  /** Either { source: 'current-event' } or { source: 'explicit', sessionIds: string[] } */
  selectedSessions?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdReportTemplateCarSetupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdReportTemplateExcludedNoteIDsInput = {
  pageAppendix?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageOverview?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageParts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageRunPlan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageSession?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdReportTemplateInput = {
  appendix?: InputMaybe<UpdateByIdReportTemplateAppendixInput>;
  bop?: InputMaybe<UpdateByIdReportTemplateBopInput>;
  carSetup?: InputMaybe<UpdateByIdReportTemplateCarSetupInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** File format based off a filename pattern, e.g. {raceSeries} {season} {event} */
  downloadFilenameFormat?: InputMaybe<Scalars['String']['input']>;
  excludedNoteIDs?: InputMaybe<UpdateByIdReportTemplateExcludedNoteIDsInput>;
  issues?: InputMaybe<UpdateByIdReportTemplateIssuesInput>;
  kpi?: InputMaybe<UpdateByIdReportTemplateKpiInput>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overview?: InputMaybe<UpdateByIdReportTemplateOverviewInput>;
  parts?: InputMaybe<UpdateByIdReportTemplatePartsInput>;
  reportTitle?: InputMaybe<Scalars['String']['input']>;
  runInfo?: InputMaybe<UpdateByIdReportTemplateRunInfoInput>;
  runPlan?: InputMaybe<UpdateByIdReportTemplateRunPlanInput>;
  sessions?: InputMaybe<UpdateByIdReportTemplateSessionsInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  weather?: InputMaybe<UpdateByIdReportTemplateWeatherInput>;
};

export type UpdateByIdReportTemplateIssuesColumnsInput = {
  field?: InputMaybe<EnumReportTemplateIssuesColumnsField>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdReportTemplateIssuesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<UpdateByIdReportTemplateIssuesColumnsInput>>>;
  groupBy?: InputMaybe<EnumReportTemplateIssuesGroupBy>;
};

export type UpdateByIdReportTemplateKpiInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON configuration or zod? */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  showSessionLines?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdReportTemplateOverviewInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showFuelConsumption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdReportTemplatePartsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  groupPartsByChassisAssemblyName?: InputMaybe<Scalars['Boolean']['input']>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  tableColumns?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type UpdateByIdReportTemplatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ReportTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdReportTemplateRunInfoColumnsInput = {
  field?: InputMaybe<EnumReportTemplateRunInfoColumnsField>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdReportTemplateRunInfoInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<UpdateByIdReportTemplateRunInfoColumnsInput>>>;
};

export type UpdateByIdReportTemplateRunPlanInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdReportTemplateSessionsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  displayedTimeZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noteTitle?: InputMaybe<Scalars['String']['input']>;
  showTimingOverview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdReportTemplateWeatherInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  splitDataByDays?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdRunBrakeInput = {
  /** Brake temperature after the run */
  TBrakePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Brake temperature before the run */
  TBrakePreRun?: InputMaybe<Scalars['Float']['input']>;
  hBrakeDiscPreRun?: InputMaybe<Scalars['Float']['input']>;
  /** Format is `Record<string, number>`, e.g. `{ "1FL": 1.2, "2": 1.3 }` */
  thicknessMeasurements?: InputMaybe<Scalars['JSON']['input']>;
};

/** Run energy field labels mapped to their display names. Null or unset fields are not displayed. */
export type UpdateByIdRunEnergyFieldLabelsInput = {
  ATTACK?: InputMaybe<Scalars['String']['input']>;
  COOL?: InputMaybe<Scalars['String']['input']>;
  FCY?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Scalars['String']['input']>;
  OUT?: InputMaybe<Scalars['String']['input']>;
  OUTIN?: InputMaybe<Scalars['String']['input']>;
  PITLANE?: InputMaybe<Scalars['String']['input']>;
  PREP?: InputMaybe<Scalars['String']['input']>;
  PUSH?: InputMaybe<Scalars['String']['input']>;
  QUALI?: InputMaybe<Scalars['String']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['String']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['String']['input']>;
  SLOW?: InputMaybe<Scalars['String']['input']>;
  TARGET?: InputMaybe<Scalars['String']['input']>;
  TOGRID?: InputMaybe<Scalars['String']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['String']['input']>;
  TOPITS?: InputMaybe<Scalars['String']['input']>;
  UNFINISHED?: InputMaybe<Scalars['String']['input']>;
  attackLap?: InputMaybe<Scalars['String']['input']>;
  coolLap?: InputMaybe<Scalars['String']['input']>;
  fullCourseYellowLap?: InputMaybe<Scalars['String']['input']>;
  inLap?: InputMaybe<Scalars['String']['input']>;
  outInLap?: InputMaybe<Scalars['String']['input']>;
  outLap?: InputMaybe<Scalars['String']['input']>;
  pitlaneLap?: InputMaybe<Scalars['String']['input']>;
  prepLap?: InputMaybe<Scalars['String']['input']>;
  pushLap?: InputMaybe<Scalars['String']['input']>;
  qualiLap?: InputMaybe<Scalars['String']['input']>;
  safetyCarLap?: InputMaybe<Scalars['String']['input']>;
  shakedownLap?: InputMaybe<Scalars['String']['input']>;
  slowLap?: InputMaybe<Scalars['String']['input']>;
  targetLap?: InputMaybe<Scalars['String']['input']>;
  toGridLap?: InputMaybe<Scalars['String']['input']>;
  toPitsLap?: InputMaybe<Scalars['String']['input']>;
  unfinishedLap?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdRunEnergyInput = {
  /** Fuel/Energy/SoC required for ATTACK Lap */
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for COOL Lap */
  COOL?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for FCY Lap */
  FCY?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for IN Lap */
  IN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUT Lap */
  OUT?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for OUTIN Lap */
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PITLANE Lap */
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PREP Lap */
  PREP?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for PUSH Lap */
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for QUALI Lap */
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SAFETYCAR Lap */
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SHAKEDOWN Lap */
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for SLOW Lap */
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TARGET Lap */
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOGRID Lap */
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPADDOCK Lap */
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for TOPITS Lap */
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for UNFINISHED Lap */
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an attack mode lap */
  attackLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a cooldown lap */
  coolLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a full course yellow lap */
  fullCourseYellowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an in lap */
  inLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out-in lap */
  outInLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an out lap */
  outLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a pitlane lap */
  pitlaneLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a preparation/warmup lap */
  prepLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a push lap */
  pushLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a qualifying lap */
  qualiLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a safety car lap */
  safetyCarLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a shakedown lap */
  shakedownLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a slow lap */
  slowLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an target lap */
  targetLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-grid lap */
  toGridLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for a to-pits lap */
  toPitsLap?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel/Energy/SoC required for an unfinished lap */
  unfinishedLap?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdRunKpiTableRowFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<UpdateByIdValueLimitInput>;
  unit?: InputMaybe<EnumDisplayUnit>;
  upperLimit?: InputMaybe<UpdateByIdValueLimitInput>;
};

export type UpdateByIdRunKpiTableRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Default background color for the cell/s. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell, an array of two numbers for a double cell, and so on. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to try pull data from in `runKPI`, like `"vMax"`. Use an array of one key for a single cell, an array of two keys for a double cell, and so on. */
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<UpdateByIdValueLimitInput>;
  /** Text to put as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
  upperLimit?: InputMaybe<UpdateByIdValueLimitInput>;
};

export type UpdateByIdRunLapTimeInput = {
  ATTACK?: InputMaybe<Scalars['Float']['input']>;
  COOL?: InputMaybe<Scalars['Float']['input']>;
  FCY?: InputMaybe<Scalars['Float']['input']>;
  IN?: InputMaybe<Scalars['Float']['input']>;
  OUT?: InputMaybe<Scalars['Float']['input']>;
  OUTIN?: InputMaybe<Scalars['Float']['input']>;
  PITLANE?: InputMaybe<Scalars['Float']['input']>;
  PREP?: InputMaybe<Scalars['Float']['input']>;
  PUSH?: InputMaybe<Scalars['Float']['input']>;
  QUALI?: InputMaybe<Scalars['Float']['input']>;
  SAFETYCAR?: InputMaybe<Scalars['Float']['input']>;
  SHAKEDOWN?: InputMaybe<Scalars['Float']['input']>;
  SLOW?: InputMaybe<Scalars['Float']['input']>;
  TARGET?: InputMaybe<Scalars['Float']['input']>;
  TOGRID?: InputMaybe<Scalars['Float']['input']>;
  TOPADDOCK?: InputMaybe<Scalars['Float']['input']>;
  TOPITS?: InputMaybe<Scalars['Float']['input']>;
  UNFINISHED?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdRunPlanInput = {
  PUEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Amount of time in seconds to increment SOC by 1% at each rSOC value. Must have same length as `chargeTimeSOCValues`. */
  chargeTimeSOCIncrements?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** rSOC values to associate with each time charge time increment. Must have same length as `chargeTimeSOCIncrements` */
  chargeTimeSOCValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fuelRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  /** Full tank fuel load */
  mFuelFullTank?: InputMaybe<Scalars['Float']['input']>;
  performanceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  runs?: InputMaybe<Array<InputMaybe<UpdateByIdRunPlanRunInput>>>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  systemEngineerIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tLapExpected?: InputMaybe<UpdateByIdRunLapTimeInput>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Short comment like dry run plan / wet run plan. */
  title?: InputMaybe<Scalars['String']['input']>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdRunPlanPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<RunPlan>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRunPlanRunActionItemsPreRunInput = {
  _id: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateByIdRunPlanRunInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  actionItemsPostRun?: InputMaybe<Array<InputMaybe<UpdateByIdRunPlanRunActionItemsPreRunInput>>>;
  actionItemsPreRun?: InputMaybe<Array<InputMaybe<UpdateByIdRunPlanRunActionItemsPreRunInput>>>;
  /** Background color for the run in run plan view. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** e.g. Baseline Run, Option A, … */
  description?: InputMaybe<Scalars['String']['input']>;
  /** True if fuel was drained before the run. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequence?: InputMaybe<Array<InputMaybe<UpdateByIdLapSequenceLapsInput>>>;
  /** Amount of fuel to be refilled at the end of this run. */
  mFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumRunPlanRunPriority>;
  /** Things you need to remember to tell the driver. */
  reminder?: InputMaybe<Scalars['String']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  selectedDriverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Setup changes anticipated. */
  setupChanges?: InputMaybe<Scalars['String']['input']>;
  /** Amount of time for refuelling at the end of this run. */
  tFuelRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Time to wait before starting the run. */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tyreFLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreFRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRLID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreRRID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdRunSheetInput = {
  /** Fuel density, if working in volume (overrides `DFuel` from event) */
  DFuel?: InputMaybe<Scalars['Float']['input']>;
  /** Run number */
  NRun?: InputMaybe<Scalars['Float']['input']>;
  /** Run number for timing services */
  NRunTiming?: InputMaybe<Scalars['Float']['input']>;
  SoCRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  TCellMaxRunStart?: InputMaybe<Scalars['Float']['input']>;
  /** Volume of fuel added at the start of the run. This field will not be automatically calculated by the API, so should be set along with `tRefuel` and `qRefuel` as their product. */
  VFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  associatedKpiFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brakeComment?: InputMaybe<Scalars['String']['input']>;
  brakeFL?: InputMaybe<UpdateByIdRunBrakeInput>;
  brakeFR?: InputMaybe<UpdateByIdRunBrakeInput>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakeMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakeMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePostRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePostRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsFR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsFR?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of rear-left measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRL: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRL?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of front-right measurement points to brake disc thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `brakePreRunMeasurementsRR: [["left", 5], ["marker1", 6]]`. */
  brakePreRunMeasurementsRR?: InputMaybe<Scalars['JSON']['input']>;
  brakeRL?: InputMaybe<UpdateByIdRunBrakeInput>;
  brakeRR?: InputMaybe<UpdateByIdRunBrakeInput>;
  /** Link to a cloud storage location where raw run data is kept. */
  cloudStorageURL?: InputMaybe<Scalars['String']['input']>;
  /** Fuel/SoC/Energy consumptions for each track layout in this run sheet. Acts as an override for the consumptions from the parent event. */
  consumptions?: InputMaybe<Array<InputMaybe<UpdateByIdLayoutConsumptionInput>>>;
  contestantID?: InputMaybe<Scalars['MongoID']['input']>;
  controlsComment?: InputMaybe<Scalars['String']['input']>;
  dashboard?: InputMaybe<UpdateByIdDashboardInput>;
  dataServiceFileNameOverride?: InputMaybe<Scalars['String']['input']>;
  dilComments?: InputMaybe<Scalars['String']['input']>;
  driverComments?: InputMaybe<Scalars['String']['input']>;
  driverID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Car data service run end time */
  endTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  /** Laptime service run end time */
  endTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  /** Manual run end time (used to override calculation in case run was cut short but don't want to delete the drafted laps */
  endTimeManual?: InputMaybe<Scalars['Date']['input']>;
  energyRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  engineerComments?: InputMaybe<Scalars['String']['input']>;
  engineerID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Time by which tyre heating schedule should be finished */
  finishTyreHeatingBy?: InputMaybe<Scalars['Date']['input']>;
  /** Used for fuel calculation. If true, mFuelAdded is treated as the total fuel at run start. */
  fuelDrainedBeforeRun?: InputMaybe<Scalars['Boolean']['input']>;
  fuelRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  historyIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  info?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isLockedByLaptimeService?: InputMaybe<Scalars['Boolean']['input']>;
  issueIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  jobIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Used to save the file name where the kpi data is retreived from */
  kpiFileName?: InputMaybe<Scalars['String']['input']>;
  kpiStatus?: InputMaybe<EnumRunSheetKpiStatus>;
  kpiUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** `addLap`, `forceAddLap`, `updateLap`, and `removeLap` mutations are preferred unless you want to completely replace the laps with new data. */
  laps?: InputMaybe<Array<InputMaybe<UpdateByIdLapInput>>>;
  laptimeThresholds?: InputMaybe<UpdateByIdLaptimeThresholdsInput>;
  /** Fuel added at the start of the run */
  mFuelAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the catch tank after the run */
  mFuelDrainedCatchTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel removed from the main tank after the run */
  mFuelDrainedMainTank?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel remaining at the end of the run */
  mFuelRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Fuel used before run start i.e. for pre-run fireup */
  mFuelUsedPreRun?: InputMaybe<Scalars['Float']['input']>;
  nextRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  performanceComments?: InputMaybe<Scalars['String']['input']>;
  prevRunSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  problemComments?: InputMaybe<Scalars['String']['input']>;
  /** Flow rate when refuelling at the start of the run, in m³/s */
  qRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Energy charged to this value at the start of the run */
  rEnergyAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Energy level at the end of the run */
  rEnergyRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Battery charged to this value at the start of the run */
  rSOCAdded?: InputMaybe<Scalars['Float']['input']>;
  /** Battery state of charge at the end of the run */
  rSOCRunEnd?: InputMaybe<Scalars['Float']['input']>;
  /** Short comment of the objective of the run */
  runDescription?: InputMaybe<Scalars['String']['input']>;
  /** Map of run KPI fields to their values. Input syntax is array of tuples, like `lapKPI: [["sample", 0], ["nested", {a: 1, b: 2}]]`. Note that unlike other Map fields, changes will not be merged, but will overwrite existing data. */
  runKPI?: InputMaybe<Scalars['JSON']['input']>;
  runSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Running time in seconds */
  runTime?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the job list template used for this run */
  selectedJobListTemplateID?: InputMaybe<Scalars['MongoID']['input']>;
  sessionID?: InputMaybe<Scalars['MongoID']['input']>;
  setupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of the simulation results associated with this run. */
  simResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  skidComment?: InputMaybe<Scalars['String']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidMeasurement: [["left", 5], ["marker1", 6]]`. */
  skidMeasurement?: InputMaybe<Scalars['JSON']['input']>;
  skidPlateID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPostRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPostRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  /** Map of measurement points to skid thickness values. Keys are names of the points and values are the measurements. Input syntax is array of key-value tuples, like `skidPreRunMeasurements: [["left", 5], ["marker1", 6]]`. */
  skidPreRunMeasurements?: InputMaybe<Scalars['JSON']['input']>;
  startTimeCDS?: InputMaybe<Scalars['Date']['input']>;
  startTimeLTS?: InputMaybe<Scalars['Date']['input']>;
  startTimeManual?: InputMaybe<Scalars['Date']['input']>;
  /** Time at which to start tyre heating schedule */
  startTyreHeatingAt?: InputMaybe<Scalars['Date']['input']>;
  summaryComments?: InputMaybe<Scalars['String']['input']>;
  systemsComments?: InputMaybe<Scalars['String']['input']>;
  /** Time spent refuelling at the start of the run */
  tRefuel?: InputMaybe<Scalars['Float']['input']>;
  /** Override for session time remaining (in seconds) */
  tSessionRemainingOverride?: InputMaybe<Scalars['Float']['input']>;
  /** Time spent in garage before run */
  tWaitBeforeRun?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of this run in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartyRunID?: InputMaybe<Scalars['String']['input']>;
  /** Should the timing service pretend that this run sheet does not exist? */
  timingServiceShouldIgnore?: InputMaybe<Scalars['Boolean']['input']>;
  tyreComments?: InputMaybe<Scalars['String']['input']>;
  /** The tyre compound used, reported by the timing service. */
  tyreCompoundTiming?: InputMaybe<Scalars['String']['input']>;
  tyreFL?: InputMaybe<UpdateByIdRunTyreInput>;
  tyreFR?: InputMaybe<UpdateByIdRunTyreInput>;
  tyrePressureSettings?: InputMaybe<UpdateByIdTyrePressureSettingsInput>;
  tyreRL?: InputMaybe<UpdateByIdRunTyreInput>;
  tyreRR?: InputMaybe<UpdateByIdRunTyreInput>;
  tyreSetID?: InputMaybe<Scalars['MongoID']['input']>;
  weather?: InputMaybe<UpdateByIdWeatherDataInput>;
  writeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdRunSheetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<RunSheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRunSheetStyleInput = {
  blocks?: InputMaybe<Array<InputMaybe<UpdateByIdGenericRunSheetStyleBlockInput>>>;
  energyType?: InputMaybe<EnumEnergyType>;
  lapFlags?: InputMaybe<UpdateByIdLapFlagLabelsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdRunSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<RunSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRunTyreInput = {
  /** Track reference temperature at which the reference pressure is given */
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre temperature */
  TTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Expected tyre temperature in parc ferme */
  TTyreParcFermeExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre temperature */
  TTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed at temperature */
  TTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed at temperature */
  TTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference temperature at which the reference pressure is given */
  TTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre temperature (e.g. in the evening with cold tyre) */
  TTyreSetdown?: InputMaybe<Scalars['Float']['input']>;
  /** Array of manual surface temperature measurements */
  TTyreSurface?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Array of manual tyre tread depth measurements */
  hTyreTread?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Tyre pressure */
  pTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure at the start of the run */
  pTyreMinStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure */
  pTyrePostRun?: InputMaybe<Scalars['Float']['input']>;
  /** Post-run tyre pressure bleed */
  pTyrePostRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Pre-run tyre pressure bleed */
  pTyrePreRunBleed?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre reference pressure */
  pTyreReference?: InputMaybe<Scalars['Float']['input']>;
  /** Set down tyre pressure (e.g. in the evening with cold tyre) */
  pTyreSetDown?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre pressure at the start of the run */
  pTyreStartRun?: InputMaybe<Scalars['Float']['input']>;
  /** Target tyre pressure during running */
  pTyreTarget?: InputMaybe<Scalars['Float']['input']>;
  tyreID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdSandboxUnitsInput = {
  acceleration?: InputMaybe<UpdateByIdAccelerationInput>;
  angle?: InputMaybe<UpdateByIdAngleInput>;
  angularVelocity?: InputMaybe<UpdateByIdAngularVelocityInput>;
  area?: InputMaybe<UpdateByIdAreaInput>;
  current?: InputMaybe<UpdateByIdCurrentInput>;
  dampingRate?: InputMaybe<UpdateByIdDampingRateInput>;
  density?: InputMaybe<UpdateByIdDensityInput>;
  energy?: InputMaybe<UpdateByIdEnergyInput>;
  force?: InputMaybe<UpdateByIdForceInput>;
  frequency?: InputMaybe<UpdateByIdFrequencyInput>;
  length?: InputMaybe<UpdateByIdLengthInput>;
  mass?: InputMaybe<UpdateByIdMassInput>;
  momentOfInertia?: InputMaybe<UpdateByIdMomentOfInertiaInput>;
  power?: InputMaybe<UpdateByIdPowerInput>;
  pressure?: InputMaybe<UpdateByIdPressureInput>;
  ratio?: InputMaybe<UpdateByIdRatioInput>;
  springRate?: InputMaybe<UpdateByIdSpringRateInput>;
  temperature?: InputMaybe<UpdateByIdTemperatureInput>;
  torque?: InputMaybe<UpdateByIdTorqueInput>;
  torsionRate?: InputMaybe<UpdateByIdTorsionRateInput>;
  velocity?: InputMaybe<UpdateByIdVelocityInput>;
  voltage?: InputMaybe<UpdateByIdVoltageInput>;
  volume?: InputMaybe<UpdateByIdVolumeInput>;
};

export type UpdateByIdSandboxUnitsPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SandboxUnits>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSeasonInput = {
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Position after which a driver no longer gets points for fastest lap. */
  fastestLapsPositionCutoff?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Championship points per fastest lap in a session. Example: `[1]` means fastest lap gets 1 point, then second and beyond gets nothing. */
  pointsPerFastestLap?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Whether the fastest lap points are awarded to the team or the driver. */
  pointsPerFastestLapTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Championship points per driver position in a race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPosition?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per driver position in a sprint race session. Example: `[9, 6, 3, 1]` means first place gets 9 points, second gets 6, …, then fifth and beyond gets nothing. */
  pointsPerPositionSprintRace?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Championship points per qualifying rank at an event. Example: `[3, 2, 1]` means first/second/third drivers get 3/2/1 points, then fourth and beyond gets nothing. */
  pointsPerQualifyingRank?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsSystemQualiAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemQualiDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceAlternateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemRaceDefaultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyres which are owned by the team for this season. */
  tyreIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** IDs of all tyre sets which are owned by the team for this season. */
  tyreSetIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdSeasonPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Season>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSessionContestantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of the chassis used, if different for this session. */
  chassisIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** e.g. Pro, Am, Pro/Am, … */
  class?: InputMaybe<Scalars['String']['input']>;
  /** IDs of drivers of this car, if different for this session. */
  driverIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdSessionInput = {
  assignedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bestValuesID?: InputMaybe<Scalars['MongoID']['input']>;
  bopID?: InputMaybe<Scalars['MongoID']['input']>;
  contestants?: InputMaybe<Array<InputMaybe<UpdateByIdSessionContestantsInput>>>;
  /** Add custom simulation payload to this field. You as a user are responsible to have meaningful data in there. */
  customSimulationPayload?: InputMaybe<Scalars['JSON']['input']>;
  debriefNotes?: InputMaybe<Scalars['String']['input']>;
  debriefNotesMode?: InputMaybe<EnumSessionDebriefNotesMode>;
  disableForwardPropagation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted driver championship standings during and immediately after this session. */
  driverChampionshipStandings?: InputMaybe<Array<InputMaybe<UpdateByIdDriverChampionshipStandingInput>>>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  /** This flag is used to tell the laptime service that this session might span multiple timing sessions. */
  isLinkedSession?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this a timing test session, to be shown only to admin users? */
  isTimingTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorted standings of this session, as they were last updated */
  liveStandings?: InputMaybe<Array<InputMaybe<UpdateByIdLiveStandingInput>>>;
  /** Greatest lap number processed for live standings. Use to determine if the data is current and up to date. */
  liveStandingsCurrentLap?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the next session in this event */
  nextSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreFRMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRLMinSession?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum mandatory tyre pressure for this session */
  pTyreRRMinSession?: InputMaybe<Scalars['Float']['input']>;
  participantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  pointsSystemOverrideIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted driver championship standings from before the start of this session. */
  prevDriverChampionshipStandings?: InputMaybe<Array<InputMaybe<UpdateByIdDriverChampionshipStandingInput>>>;
  /** ID of the previous session in this event */
  prevSessionID?: InputMaybe<Scalars['MongoID']['input']>;
  /** e.g. Test, Practice, Qualifying, Race */
  sessionType?: InputMaybe<EnumSessionType>;
  /** Short name like D1, FP2, etc. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Time of the session end in local time */
  tSessionEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Time of the session start in local time */
  tSessionStart?: InputMaybe<Scalars['Date']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Sorted team championship standings during and immediately after this session. */
  teamChampionshipStandings?: InputMaybe<Array<InputMaybe<UpdateByIdTeamChampionshipStandingInput>>>;
  /** ID of this session in a third party system (e.g. iRacing, simulation software, etc.) */
  thirdPartySessionID?: InputMaybe<Scalars['String']['input']>;
  /** Seconds until end of session, updated by the timing service very infrequently. Zero if session has already ended. */
  timeRemaining?: InputMaybe<Scalars['Float']['input']>;
  /** ID of this session for Transcribble's legacy API */
  transcribbleSessionID?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateByIdSessionPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Session>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSetupOverviewConfigFieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Gain to apply to the value/s. Use an array of one number for a single cell and an array of two numbers for a double cell. */
  gain?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Field names to pull data from in the car setup, like `"frontLeft.hRide"`. Use an array of one key for a single cell, and an array of two keys for a double cell. */
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Suffix to show as a unit for values. */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSetupOverviewConfigInput = {
  /** WARNING: this field should be deprecated after SI migrations have taken place */
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdSetupOverviewConfigFieldInput>>>;
  /** Set to true if every user can see this plot page config. Otherwise only the use who created it can see it. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Array<InputMaybe<UpdateByIdSetupOverviewConfigRowInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSetupOverviewConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SetupOverviewConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSetupOverviewConfigRowElementInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** Number of decimal places to display. */
  decimals?: InputMaybe<Scalars['Int']['input']>;
  /** Path of field in car setup, e.g. aero.aFlapF */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Gain to apply to the value. */
  gain?: InputMaybe<Scalars['Float']['input']>;
  /** Suffix to put as a unit for values. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<UpdateByIdBaseTypedUnitFieldInput>;
};

export type UpdateByIdSetupOverviewConfigRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  elements?: InputMaybe<Array<InputMaybe<UpdateByIdSetupOverviewConfigRowElementInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSetupSheetGroupInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Array<UpdateByIdSetupSheetStyleRowInput>>;
};

export type UpdateByIdSetupSheetStyleBlockInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** The height of the block within the grid */
  height?: InputMaybe<Scalars['Int']['input']>;
  tabs?: InputMaybe<Array<UpdateByIdSetupSheetStyleTabInput>>;
  /** The width of the block within the grid */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The x position of the block within the grid */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** The y position of the block within the grid */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateByIdSetupSheetStyleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blocks?: InputMaybe<Array<UpdateByIdSetupSheetStyleBlockInput>>;
  /** Chassis specification to use for suggesting field keys. You may need to look for more recent iterations of this spec to get up-to-date field keys. */
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  hideAddPartButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to show/hide units for the input fields */
  hideUnits?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetEventType?: InputMaybe<EnumSetupSheetStyleTargetEventType>;
  targetRoles?: InputMaybe<Array<EnumPersonRole>>;
  targetUserIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumSetupSheetStyleType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSetupSheetStylePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SetupSheetStyle>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSetupSheetStyleRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  items: Array<SetupSheetStyleItemInput>;
};

export type UpdateByIdSetupSheetStyleTabInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  groups?: InputMaybe<Array<UpdateByIdSetupSheetGroupInput>>;
  massConfig?: InputMaybe<UpdateByIdSetupSheetStyleTabMassConfigInput>;
  mileageConfig?: InputMaybe<UpdateByIdSetupSheetStyleTabMileageConfigInput>;
  rows?: InputMaybe<Array<UpdateByIdSetupSheetStyleRowInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumSetupSheetStyleTabType>;
};

export type UpdateByIdSetupSheetStyleTabMassConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  massOption?: InputMaybe<Scalars['String']['input']>;
  showMinWeightFromSpec?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdSetupSheetStyleTabMileageConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  showManualInput?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdSimRequestInput = {
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  relatedSimResultIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  requesterSlot?: InputMaybe<EnumSimRequestRequesterSlot>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  simResultID?: InputMaybe<Scalars['MongoID']['input']>;
  simType?: InputMaybe<EnumSimRequestSimType>;
  simulationService?: InputMaybe<EnumSimModelType>;
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSimRequestPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SimRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSimResultDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** Sampling rate of the channel in Hz, if overriding `defaultChannelTime` without `channelTime` */
  channelSamplingRate?: InputMaybe<Scalars['Float']['input']>;
  /** Use this to override `defaultChannelTime` */
  channelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Actual channel data values */
  channelValue?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  interpolationMethod?: InputMaybe<EnumSimResultDataInterpolationMethod>;
  /** Should values in this channel be treated as timestamps? */
  isTimeChannel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display unit of channel values (e.g. m/s) */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSimResultInput = {
  /** Ambient temperature in °K */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  carSetupID?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Array<InputMaybe<UpdateByIdSimResultDataInput>>>;
  /** Each data channel is assumed to use this unless it specifies `channelSamplingRate` or `channelTime` */
  defaultChannelTime?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ambient pressure in Pa */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Relative humidity as a ratio [0,1] */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Map containing reference values from car setup. Example: aerobalance in a car manual. Input syntax is array of key-value tuples, like `refValues: [["rAeroBalF", 48.5], ["rLatBalF", 51.4]]`. */
  refValues?: InputMaybe<Scalars['JSON']['input']>;
  requesterID?: InputMaybe<Scalars['MongoID']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the ORH service used to generate the sim result */
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  simType?: InputMaybe<EnumSimResultSimType>;
  simulationDriveFileID?: InputMaybe<Scalars['MongoID']['input']>;
  simulationService?: InputMaybe<EnumSimModelType>;
  /** Service which generated this sim result, for example Canopy */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Reference for this sim result, to find it in the simulation service */
  sourceReferenceID?: InputMaybe<Scalars['String']['input']>;
  /** Specification this sim result is based on. May represent an override of the specification from the car setup's linked chassis. If this is for a model request, this decides what is retrieved. */
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumSimResultStatus>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackLayoutID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Version of the third-party service used to generate the sim result */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSimResultPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SimResult>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSimulationDriveFileInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumSimulationDriveFileStatus>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userEnumTypeID?: InputMaybe<Scalars['MongoID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSimulationDriveFilePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SimulationDriveFile>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSkidPlateInput = {
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  initialThickness?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdSkidPlatePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SkidPlate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSpecificationACamberInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationACamberReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationACamberUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdSpecificationAdminInput = {
  CxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  FSpringSetup?: InputMaybe<UpdateByIdAdjustableForceInput>;
  aCamber?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  aCaster?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  aCasterMeasurementGain?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurementOffset?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  adjustableProperties?: InputMaybe<Array<InputMaybe<UpdateByIdAdjustablePropertyInput>>>;
  aeroElementInterpolationMethod?: InputMaybe<EnumSpecificationAdminAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  aeroElementType?: InputMaybe<EnumSpecificationAdminAeroElementType>;
  aeroPackageSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  aeroPackageSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  antiRollBarConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdAntiRollBarConfigInput>>>;
  antiRollBarDisplayLocation?: InputMaybe<EnumSpecificationAdminAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: InputMaybe<Array<InputMaybe<UpdateByIdAssignedGearInput>>>;
  attachable?: InputMaybe<Scalars['Boolean']['input']>;
  axle?: InputMaybe<EnumSpecificationAdminAxle>;
  bevelSetSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetVisible?: InputMaybe<Scalars['Boolean']['input']>;
  bumpRubberReference?: InputMaybe<EnumSpecificationAdminBumpRubberReference>;
  bumpRubberSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bumpStopGapMethod?: InputMaybe<EnumSpecificationAdminBumpStopGapMethod>;
  calculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: InputMaybe<Scalars['String']['input']>;
  chassisMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  copyReferencePackageID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customSimulationModels?: InputMaybe<Array<InputMaybe<UpdateByIdSpecificationCustomSimulationModelsInput>>>;
  customSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  customSpecType?: InputMaybe<Scalars['String']['input']>;
  customTables?: InputMaybe<Array<InputMaybe<UpdateByIdSpecificationCustomTablesInput>>>;
  damperAdjusters?: InputMaybe<Array<InputMaybe<UpdateByIdDamperAdjusterInput>>>;
  damperConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdDamperConfigInput>>>;
  damperSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  denominator?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  differentialConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdDifferentialConfigInput>>>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  drawingNumber?: InputMaybe<Scalars['String']['input']>;
  dropGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  elasticType?: InputMaybe<EnumSpecificationAdminElasticType>;
  forceTable?: InputMaybe<UpdateByIdForceTableInput>;
  gearType?: InputMaybe<EnumSpecificationAdminGearType>;
  hRide?: InputMaybe<UpdateByIdSpecificationHRideInput>;
  hasToBeInSubAssembly?: InputMaybe<Scalars['Boolean']['input']>;
  headGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  helperSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  initialChassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of all iterations of this specification. */
  iterationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Spring constant of the elastic element. */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  kinematicsExternalModels?: InputMaybe<Array<InputMaybe<UpdateByIdKinematicsExternalModelInput>>>;
  kinematicsExternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kinematicsInternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerReference?: InputMaybe<Scalars['String']['input']>;
  mass?: InputMaybe<UpdateByIdChassisMassInput>;
  massProperties?: InputMaybe<UpdateByIdMassPropertiesInput>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: InputMaybe<UpdateByIdChassisMeasurementsInput>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: InputMaybe<Array<InputMaybe<EnumSpecificationAdminModelTypes>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  numerator?: InputMaybe<Scalars['Float']['input']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  polyCxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  positionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  powerUnits?: InputMaybe<Array<InputMaybe<UpdateByIdChassisPowerUnitInput>>>;
  powertrain?: InputMaybe<UpdateByIdChassisPowertrainInput>;
  powertrainLocation?: InputMaybe<EnumSpecificationAdminPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  rBrakeBias?: InputMaybe<UpdateByIdAdjustableRatioInput>;
  /** Position of the specification on the car */
  readingsAllowable?: InputMaybe<Array<InputMaybe<EnumSpecificationAdminReadingsAllowable>>>;
  readingsRequired?: InputMaybe<EnumSpecificationAdminReadingsRequired>;
  reboundSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regulationSets?: InputMaybe<Array<InputMaybe<UpdateByIdRegulationSetInput>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: InputMaybe<Scalars['Boolean']['input']>;
  /** Original version of this specification — same as the first entry in `iterationIDs`. Intended to make part tracking easier. */
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  setupChangesFilter?: InputMaybe<UpdateByIdSpecificationSetupChangesFilterInput>;
  setupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  /** Locations/areas that components can be installed in. */
  sockets?: InputMaybe<Array<InputMaybe<UpdateByIdChassisSocketInput>>>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationGroupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  springReference?: InputMaybe<EnumSpecificationAdminSpringReference>;
  springSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  torsionBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumSpecificationAdminType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** User-supplied version of this specification. */
  version?: InputMaybe<Scalars['String']['input']>;
  xBumpRubberRef?: InputMaybe<Scalars['Float']['input']>;
  xBumpRubberSetup?: InputMaybe<UpdateByIdAdjustableLengthInput>;
  xBumpStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperSetupDefault?: InputMaybe<Scalars['Float']['input']>;
  xDroopStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  /** Length of the elastic element under no force */
  xFree?: InputMaybe<Scalars['Float']['input']>;
  xShaftDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xSpringPlatformOffset?: InputMaybe<Scalars['Float']['input']>;
  xSpringRef?: InputMaybe<Scalars['Float']['input']>;
  xSpringSetup?: InputMaybe<UpdateByIdAdjustableLengthInput>;
  xToe?: InputMaybe<UpdateByIdSpecificationHRideInput>;
};

export type UpdateByIdSpecificationAdminPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SpecificationAdmin>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSpecificationCustomSimulationModelsInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  dataMapping?: InputMaybe<EnumSpecificationCustomSimulationModelsDataMapping>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serverPort?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSpecificationCustomTablesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<UpdateByIdTableInput>;
};

export type UpdateByIdSpecificationGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSpecificationGroupPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SpecificationGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSpecificationHRideInput = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  /** Do not copy when copying from a setup */
  doNotCopy?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum value */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value */
  minValue?: InputMaybe<Scalars['Float']['input']>;
  readingsRequired?: InputMaybe<EnumSpecificationHRideReadingsRequired>;
  /** Always show +/- sign when displaying values */
  sign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Increment to suggest values in, if applicable */
  step?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumSpecificationHRideUnit>;
  /** Names to associate with values array */
  valueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allowable values. Overrides step and min/max values */
  values?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateByIdSpecificationInput = {
  CxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  CzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  FSpringSetup?: InputMaybe<UpdateByIdAdjustableForceInput>;
  aCamber?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  aCaster?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  aCasterMeasurementGain?: InputMaybe<Scalars['Float']['input']>;
  aCasterMeasurementOffset?: InputMaybe<Scalars['Float']['input']>;
  aToe?: InputMaybe<UpdateByIdSpecificationACamberInput>;
  adjustableProperties?: InputMaybe<Array<InputMaybe<UpdateByIdAdjustablePropertyInput>>>;
  aeroElementInterpolationMethod?: InputMaybe<EnumAeroElementInterpolationMethod>;
  aeroElementSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  aeroElementType?: InputMaybe<EnumAeroElementType>;
  aeroPackageSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  aeroPackageSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Gear numbers that this gear can be assigned to */
  allowableGearNums?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** IDs of specifications that can contain this specification. */
  allowableParentSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Names of sockets that this can be plugged in to. */
  allowableSockets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  antiRollBarConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdAntiRollBarConfigInput>>>;
  antiRollBarDisplayLocation?: InputMaybe<EnumAntiRollBarDisplayLocation>;
  antiRollBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Array should be in ascending gear order (1st, 2nd, 3rd, ... */
  assignedGears?: InputMaybe<Array<InputMaybe<UpdateByIdAssignedGearInput>>>;
  attachable?: InputMaybe<Scalars['Boolean']['input']>;
  axle?: InputMaybe<EnumAxle>;
  bevelSetSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetDisplayLocationID?: InputMaybe<Scalars['MongoID']['input']>;
  buildSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  buildSheetVisible?: InputMaybe<Scalars['Boolean']['input']>;
  bumpRubberReference?: InputMaybe<EnumKinematicsInternalReference>;
  bumpRubberSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bumpStopGapMethod?: InputMaybe<EnumBumpStopGapMethod>;
  calculationIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** User-supplied version of the canopy service used. */
  canopyVersion?: InputMaybe<Scalars['String']['input']>;
  chassisMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Can parts that use this specification be used in multiple places at once? */
  concurrentUseAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this specification only defines configuration properties and should not be used by parts. */
  configurationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  copyReferencePackageID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customSimulationModels?: InputMaybe<Array<InputMaybe<UpdateByIdSpecificationCustomSimulationModelsInput>>>;
  customSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  customSpecType?: InputMaybe<Scalars['String']['input']>;
  customTables?: InputMaybe<Array<InputMaybe<UpdateByIdSpecificationCustomTablesInput>>>;
  damperAdjusters?: InputMaybe<Array<InputMaybe<UpdateByIdDamperAdjusterInput>>>;
  damperConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdDamperConfigInput>>>;
  damperSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Should this specification be used in new parts or setups? */
  decommissioned?: InputMaybe<Scalars['Boolean']['input']>;
  denominator?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  differentialConfigs?: InputMaybe<Array<InputMaybe<UpdateByIdDifferentialConfigInput>>>;
  differentialSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  drawingNumber?: InputMaybe<Scalars['String']['input']>;
  dropGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  elasticType?: InputMaybe<EnumElasticType>;
  forceTable?: InputMaybe<UpdateByIdForceTableInput>;
  gearType?: InputMaybe<EnumGearType>;
  hRide?: InputMaybe<UpdateByIdSpecificationHRideInput>;
  hasToBeInSubAssembly?: InputMaybe<Scalars['Boolean']['input']>;
  headGearSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  helperSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  initialChassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  /** If true, this gear is the head gear of the gear box, applies to standard gears only */
  isHeadGear?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spring constant of the elastic element. */
  kSpring?: InputMaybe<Scalars['Float']['input']>;
  kinematicsExternalModels?: InputMaybe<Array<InputMaybe<UpdateByIdKinematicsExternalModelInput>>>;
  kinematicsExternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kinematicsInternalSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  manufacturerID?: InputMaybe<Scalars['MongoID']['input']>;
  manufacturerReference?: InputMaybe<Scalars['String']['input']>;
  mass?: InputMaybe<UpdateByIdChassisMassInput>;
  massProperties?: InputMaybe<UpdateByIdMassPropertiesInput>;
  /** Details of how measurements should be made for this chassis. */
  measurements?: InputMaybe<UpdateByIdChassisMeasurementsInput>;
  /** Models that can be used for simulation with this chassis. */
  modelTypes?: InputMaybe<Array<InputMaybe<EnumSimModelType>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the previous iteration of this specification. */
  nextIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  numerator?: InputMaybe<Scalars['Float']['input']>;
  /** Other setup sheet styles that can be used with this chassis spec. */
  otherSetupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  polyCxT?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzF?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  polyCzR?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  positionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  powerUnits?: InputMaybe<Array<InputMaybe<UpdateByIdChassisPowerUnitInput>>>;
  powertrain?: InputMaybe<UpdateByIdChassisPowertrainInput>;
  powertrainLocation?: InputMaybe<EnumSpecificationPowertrainLocation>;
  /** The ID of the next iteration upon this specification. */
  prevIterationID?: InputMaybe<Scalars['MongoID']['input']>;
  rBrakeBias?: InputMaybe<UpdateByIdAdjustableRatioInput>;
  /** Position of the specification on the car */
  readingsAllowable?: InputMaybe<Array<InputMaybe<EnumSpecificationReadingsAllowable>>>;
  readingsRequired?: InputMaybe<EnumSpecificationReadingsRequired>;
  reboundSpringSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  regulationSets?: InputMaybe<Array<InputMaybe<UpdateByIdRegulationSetInput>>>;
  /** The date this specification was released internally, to help keep track make sense of its versions. */
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** Is this specification finalised and available to use? Once set to true, this iteration becomes read-only. */
  released?: InputMaybe<Scalars['Boolean']['input']>;
  setupChangesFilter?: InputMaybe<UpdateByIdSpecificationSetupChangesFilterInput>;
  setupSheetStyleIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** ID of the  setup sheet style to use in the simulation page for this chassis. */
  setupSheetStyleSimulationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** ID of the setup sheet style to use in the setup table for this chassis. */
  setupSheetStyleTableID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Is this specification available to use in simulations? */
  simulationAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object containing simulation model definitions (`Record<string, any>`). Format should be like `{ canopy: { ... }, custom: { ... } }`. `canopy` and `chassisSim` are known model names to use with their respective services, but any model name can be used for custom models. */
  simulationModels?: InputMaybe<Scalars['JSON']['input']>;
  /** Locations/areas that components can be installed in. */
  sockets?: InputMaybe<Array<InputMaybe<UpdateByIdChassisSocketInput>>>;
  specificationGroupID?: InputMaybe<Scalars['MongoID']['input']>;
  specificationGroupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  springReference?: InputMaybe<EnumKinematicsInternalReference>;
  springSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  torsionBarSpecIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingItemIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackingSourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumSpecificationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** User-supplied version of this specification. */
  version?: InputMaybe<Scalars['String']['input']>;
  xBumpRubberRef?: InputMaybe<Scalars['Float']['input']>;
  xBumpRubberSetup?: InputMaybe<UpdateByIdAdjustableLengthInput>;
  xBumpStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xDamperSetupDefault?: InputMaybe<Scalars['Float']['input']>;
  xDroopStopGapDefault?: InputMaybe<Scalars['Float']['input']>;
  /** Length of the elastic element under no force */
  xFree?: InputMaybe<Scalars['Float']['input']>;
  xShaftDroopDefault?: InputMaybe<Scalars['Float']['input']>;
  xSpringPlatformOffset?: InputMaybe<Scalars['Float']['input']>;
  xSpringRef?: InputMaybe<Scalars['Float']['input']>;
  xSpringSetup?: InputMaybe<UpdateByIdAdjustableLengthInput>;
  xToe?: InputMaybe<UpdateByIdSpecificationHRideInput>;
};

export type UpdateByIdSpecificationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Specification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSpecificationSetupChangesFilterInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of setup fields to hide */
  blackListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of setup fields to show */
  whiteListFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdSpringRateInput = {
  /** N/m */
  newtonsPerMetre?: InputMaybe<Scalars['Float']['input']>;
  /** N/mm */
  newtonsPerMillimetre?: InputMaybe<Scalars['Float']['input']>;
  /** lb/in */
  poundsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdSteeringInput = {
  rSteerF?: InputMaybe<Scalars['Float']['input']>;
  steeringArm?: InputMaybe<Scalars['String']['input']>;
  steeringPinion?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTableInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  columnNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columnValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Table data in 1d vector. It's up to the consumer to reshape appropriately. OneRacehub internally uses row chunks. */
  data?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  decimals?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  rowNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sliceValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<EnumTagType>;
};

export type UpdateByIdTagPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTeamChampionshipStandingInput = {
  contestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  points?: InputMaybe<Scalars['Int']['input']>;
  /** 1-indexed rank of this driver in the championship based on their points. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  teamDrivers?: InputMaybe<Array<InputMaybe<UpdateByIdDriverChampionshipStandingInput>>>;
  teamID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdTeamInput = {
  /** Default color to use for this team where applicable. */
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Used only for filtering to limit which teams are displayed in a list. */
  raceSeriesID?: InputMaybe<Scalars['MongoID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdTeamPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Team>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTemperatureInput = {
  /** °C */
  celsius?: InputMaybe<Scalars['Float']['input']>;
  /** °F */
  fahrenheit?: InputMaybe<Scalars['Float']['input']>;
  /** °K */
  kelvin?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTemplateJobInput = {
  assigneeIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<EnumJobPriority>;
};

export type UpdateByIdTemplateJobListInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  jobs?: InputMaybe<Array<InputMaybe<UpdateByIdTemplateJobInput>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTemplateJobListPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TemplateJobList>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTemplateSessionDebriefInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumTemplateSessionDebriefMode>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTemplateSessionDebriefPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TemplateSessionDebrief>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTimeSheetEntryInput = {
  /** Whether a person did work on this day */
  absent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notes about what was done during this time */
  description?: InputMaybe<Scalars['String']['input']>;
  personID?: InputMaybe<Scalars['MongoID']['input']>;
  projectID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Clock-out time */
  tEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Clock-in time */
  tStart?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTimeSheetEntryPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TimeSheetEntry>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTimingServiceConfigInput = {
  /** Whether the timingServiceConfig should be considered active by the service */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** API event ID. This finds the correct event by its _id field. */
  eventID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Use schedule-based session matching as fallback. */
  fallbackScheduleBasedSessionMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of timed sectors on track. Used as fallback in case timing data does not provide it. */
  fallbackTimedSectorsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Car numbers to follow. */
  followedCarNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Activate live standings to see the driver championship points live. Only working properly if all drivers of a given season are added as contestants. */
  liveStandingsActive?: InputMaybe<Scalars['Boolean']['input']>;
  logLevel?: InputMaybe<EnumTimingServiceConfigLogLevel>;
  /** Capture incoming data stream for replay at a later time? */
  logStream?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<EnumTimingServiceConfigMode>;
  /** Name for this set of configuration settings. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Use string equality to match timing session names in One Racehub. Otherwise default sequence matching is used. */
  strictSessionNameMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** One Timing server port. */
  timingPort?: InputMaybe<Scalars['Int']['input']>;
  /** Race series name to filter on in the timing feed when multiple series are running at an event. */
  timingRaceSeries?: InputMaybe<Scalars['String']['input']>;
  /** One Timing server address. */
  timingURL?: InputMaybe<Scalars['String']['input']>;
  /** Write data to the API? Can be switched off for testing purposes. */
  writeData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdTimingServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TimingServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTorqueInput = {
  /** Nm */
  newtonMetres?: InputMaybe<Scalars['Float']['input']>;
  /** Nmm */
  newtonMillimetres?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft */
  poundForceFeet?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·in */
  poundForceInches?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTorsionRateInput = {
  /** Nm/° */
  newtonMetresPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** Nm/rad */
  newtonMetresPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/° */
  poundForceFeetPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf·ft/rad */
  poundForceFeetPerRadian?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/° */
  poundForceInchesPerDegree?: InputMaybe<Scalars['Float']['input']>;
  /** lbf-in/rad */
  poundForceInchesPerRadian?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  /** Track height above sea level. */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  geoLocation?: InputMaybe<UpdateByIdGeoLocationInput>;
  /** IDs of the available track layouts */
  layoutIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Must be a valid tz database name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Storage ID of track picture file in s3. */
  trackPicture?: InputMaybe<Scalars['String']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdTrackLayoutInput = {
  ATKModeGain?: InputMaybe<Scalars['Float']['input']>;
  ATKModeLocation?: InputMaybe<Scalars['Float']['input']>;
  ATKModePenalty?: InputMaybe<Scalars['Float']['input']>;
  FCYLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Full-course yellow probability */
  FCYProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of sectors the timing provides */
  NSectorsTiming?: InputMaybe<Scalars['Float']['input']>;
  SCLapTime?: InputMaybe<Scalars['Float']['input']>;
  /** Safety car probability */
  SCProbability?: InputMaybe<Scalars['Float']['input']>;
  SoCRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  acronym?: InputMaybe<Scalars['String']['input']>;
  bumpiness?: InputMaybe<Scalars['Float']['input']>;
  cameras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code60LapTime?: InputMaybe<Scalars['Float']['input']>;
  crossoverWetToSlick?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  energyRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  expectedRaceLaps?: InputMaybe<Scalars['Float']['input']>;
  firstLapOffset?: InputMaybe<Scalars['Float']['input']>;
  fuelRequired?: InputMaybe<UpdateByIdRunEnergyInput>;
  inLapTime?: InputMaybe<Scalars['Float']['input']>;
  lapLengthCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthInLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapCarData?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapOfficial?: InputMaybe<Scalars['Float']['input']>;
  lapLengthOutLapRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapLengthRoulette?: InputMaybe<Scalars['Float']['input']>;
  lapZero?: InputMaybe<Scalars['Boolean']['input']>;
  lapsUntilFullRegen?: InputMaybe<Scalars['Float']['input']>;
  mapElevation?: InputMaybe<Scalars['String']['input']>;
  mapEmergencyExits?: InputMaybe<Scalars['String']['input']>;
  mapPitLane?: InputMaybe<Scalars['String']['input']>;
  mapTrack?: InputMaybe<Scalars['String']['input']>;
  mapTrackGPS?: InputMaybe<Scalars['String']['input']>;
  mapTrackLatLonCsv?: InputMaybe<Scalars['String']['input']>;
  mapTrackXyCsv?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Layout */
  name?: InputMaybe<Scalars['String']['input']>;
  outLapTime?: InputMaybe<Scalars['Float']['input']>;
  overtakingThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Whole distance from entry to exit inlcuding approach and leave */
  pitDistance?: InputMaybe<Scalars['Float']['input']>;
  /** Length of pit lane between the pit lane entry and exit loop (used for mileage calculation of pitlane lap types) */
  pitLength?: InputMaybe<Scalars['Float']['input']>;
  pitLoss?: InputMaybe<Scalars['Float']['input']>;
  pitLossDriveThrough?: InputMaybe<Scalars['Float']['input']>;
  /** Indicates whether the pole position is on the left- or right-hand side */
  polePosition?: InputMaybe<EnumTrackLayoutPolePosition>;
  prepLapTime?: InputMaybe<Scalars['Float']['input']>;
  pushLapTime?: InputMaybe<Scalars['Float']['input']>;
  sectorDistance?: InputMaybe<Scalars['Float']['input']>;
  sectorLengths?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Downforce sensitivity (seconds per 10pts) */
  sensDownforce?: InputMaybe<Scalars['Float']['input']>;
  /** Drag sensitivity (seconds per 10pts) */
  sensDrag?: InputMaybe<Scalars['Float']['input']>;
  sensEP?: InputMaybe<Scalars['Float']['input']>;
  /** Energy sensitivity (seconds per 0.1kWh) */
  sensEnergy?: InputMaybe<Scalars['Float']['input']>;
  /** Grip sensitivity (seconds per %) */
  sensGrip?: InputMaybe<Scalars['Float']['input']>;
  /** Mass sensitivity (seconds per 10kg) */
  sensMass?: InputMaybe<Scalars['Float']['input']>;
  /** Power sensitivity */
  sensPower?: InputMaybe<Scalars['Float']['input']>;
  simulationModels?: InputMaybe<Array<InputMaybe<UpdateByIdTrackLayoutSimulationModelInput>>>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  trackEvolution?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the track this layout belongs to */
  trackID?: InputMaybe<Scalars['MongoID']['input']>;
  trackLayoutType?: InputMaybe<EnumTrackLayoutTrackLayoutType>;
  trackRecordQuali?: InputMaybe<Scalars['Float']['input']>;
  trackRecordRace?: InputMaybe<Scalars['Float']['input']>;
  weatherStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdTrackLayoutPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackLayout>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackLayoutSimulationModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  canopyID?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<EnumSimModelType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTrackPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Track>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackStateInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  flag?: InputMaybe<EnumTrackStateFlag>;
  message?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTrackableInput = {
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the original version of the specifications to track. */
  rootSpecificationID?: InputMaybe<Scalars['MongoID']['input']>;
  unitType?: InputMaybe<UpdateByIdBaseTypedUnitFieldInput>;
  /** Comparison to use when checking if the tracked value is in the warning/critical range. */
  warningDirection?: InputMaybe<EnumTrackableWarningDirection>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackablePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Trackable>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingItemInput = {
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  arrayElements?: InputMaybe<Scalars['Float']['input']>;
  criticalCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  criticalValue?: InputMaybe<Scalars['Float']['input']>;
  cumulativeCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  isArray?: InputMaybe<Scalars['Boolean']['input']>;
  /** Base64 encoded data URL of a custom logo image (e.g. data:image/png;base64,...) */
  measurementImage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<EnumTrackingItemOperator>;
  resettable?: InputMaybe<Scalars['Boolean']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
  warningCumulativeValue?: InputMaybe<Scalars['Float']['input']>;
  warningValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingItemPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingMeasurementDefaultCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingMeasurementDefaultRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingMeasurementInput = {
  defaultCoordinates?: InputMaybe<UpdateByIdTrackingMeasurementDefaultCoordinatesInput>;
  defaultRotation?: InputMaybe<UpdateByIdTrackingMeasurementDefaultRotationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  specificationID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Check if this measurement property should be sent to the flattened simulation payload */
  useInSimulation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdTrackingMeasurementPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingMeasurement>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingMeasurementRecordCoordinatesInput = {
  /** Coordinate value x */
  x?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value y */
  y?: InputMaybe<Scalars['Float']['input']>;
  /** Coordinate value z */
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingMeasurementRecordInput = {
  assemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  coordinates?: InputMaybe<UpdateByIdTrackingMeasurementRecordCoordinatesInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  rotation?: InputMaybe<UpdateByIdTrackingMeasurementRecordRotationInput>;
  trackingMeasurementID?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTrackingMeasurementRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingMeasurementRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingMeasurementRecordRotationInput = {
  /** Rotation value I */
  I?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value J */
  J?: InputMaybe<Scalars['Float']['input']>;
  /** Rotation value K */
  K?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingRecordInput = {
  arrayValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  chassisAssemblyID?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateResolved?: InputMaybe<Scalars['Date']['input']>;
  forceTable?: InputMaybe<UpdateByIdForceTableInput>;
  location?: InputMaybe<UpdateByIdLocationInput>;
  mass?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partID?: InputMaybe<Scalars['MongoID']['input']>;
  qualityCheckID?: InputMaybe<Scalars['MongoID']['input']>;
  recordErrors?: InputMaybe<Scalars['String']['input']>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  statusEnumID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingItemID?: InputMaybe<Scalars['MongoID']['input']>;
  trackingSourceID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTrackingRecordType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedByID?: InputMaybe<Scalars['MongoID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTrackingRecordPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingRecord>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingSourceAliasInput = {
  aliasString?: InputMaybe<Scalars['String']['input']>;
  aliasType?: InputMaybe<EnumTrackingSourceAliasAliasType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTrackingSourceAliasPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingSourceAlias>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTrackingSourceInput = {
  NDecimals?: InputMaybe<Scalars['Float']['input']>;
  chassisSpecID?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<EnumDisplayUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdTrackingSourcePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TrackingSource>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTyreHeatingScheduleEntryInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTyreInput = {
  /** Flag if the tyre is scrapped (no longer available for use). */
  BTyreScrapped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tyre Circumference */
  CTyre?: InputMaybe<Scalars['Float']['input']>;
  /** Arbitrary string to sort or filter by */
  additionalSortProperty?: InputMaybe<Scalars['String']['input']>;
  axle?: InputMaybe<EnumTyreAxle>;
  barcodeManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Barcode from the regulatory body (e.g. FIA) */
  barcodeRegulation?: InputMaybe<Scalars['String']['input']>;
  barcodeRim?: InputMaybe<Scalars['String']['input']>;
  barcodeTPMS?: InputMaybe<Scalars['String']['input']>;
  batteryTPMS?: InputMaybe<Scalars['String']['input']>;
  compound?: InputMaybe<Scalars['String']['input']>;
  compoundComment?: InputMaybe<Scalars['String']['input']>;
  constructionComment?: InputMaybe<Scalars['String']['input']>;
  constructionSpec?: InputMaybe<Scalars['String']['input']>;
  heatingSchedule?: InputMaybe<Array<InputMaybe<UpdateByIdTyreHeatingScheduleEntryInput>>>;
  initialCondition?: InputMaybe<EnumTyreInitialCondition>;
  /** Tyre Spring Rate */
  kTyre?: InputMaybe<Scalars['Float']['input']>;
  mTyre?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Tyre mold information */
  mold?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Tyre minimum pressure defined by regulation or manufacturer */
  pTyreMinRegulation?: InputMaybe<Scalars['Float']['input']>;
  /** Tyre minimum pressure defined by team (i.e. chief engineer) */
  pTyreMinTeam?: InputMaybe<Scalars['Float']['input']>;
  rimPartID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Initial mileage before use in One Racehub. */
  sRunInitial?: InputMaybe<Scalars['Float']['input']>;
  seasonID?: InputMaybe<Scalars['MongoID']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  wearMeasurementIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdTyrePayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tyre>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTyrePressureSettingsInput = {
  TAirReference?: InputMaybe<Scalars['Float']['input']>;
  TTrackReference?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTyreSetInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tyreIDFL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDFR?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRL?: InputMaybe<Scalars['MongoID']['input']>;
  tyreIDRR?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdTyreSetPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TyreSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTyreTableBlockRowInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<EnumTyreTableField>;
  highlightChanges?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lowerLimit?: InputMaybe<UpdateByIdValueLimitInput>;
  upperLimit?: InputMaybe<UpdateByIdValueLimitInput>;
};

export type UpdateByIdTyreWearInput = {
  /** Time at which this measurement was made. */
  date?: InputMaybe<Scalars['Date']['input']>;
  runSheetID?: InputMaybe<Scalars['MongoID']['input']>;
  tyreID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Raw wear data formatted however the user chooses, probably from a scanner. */
  wearData?: InputMaybe<Scalars['String']['input']>;
  /** Map of marker names to wear values. Input syntax is array of key-value tuples, like `wearMarkers: [["inner", 0.8], ["1", 0.3]]`. */
  wearMarkers?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdTyreWearPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TyreWear>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdUserEnumInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserEnumType>;
};

export type UpdateByIdUserEnumPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<UserEnum>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdUserSimulationSettingsInput = {
  TAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  pAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  rHumidityPreferred?: InputMaybe<Scalars['Float']['input']>;
  /** User defined run sim slot colours, index corresponds to run slot number. */
  runSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** User defined setup sim slot colours, index corresponds to setup slot number. */
  setupSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** IDs of the two user defined setups */
  userDefinedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdValueLimitInput = {
  /** Background color to use if the value goes beyond this limit. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Text color to use if the value goes beyond this limit. */
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdVelocityInput = {
  /** ft/s */
  feetPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** kph */
  kilometresPerHour?: InputMaybe<Scalars['Float']['input']>;
  /** m/s */
  metresPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** mph */
  milesPerHour?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdViewConfigInput = {
  /** Should tyre mileages be highlighted according to `yellowTyreMileageThreshold` and `redTyreMileageThreshold`? */
  highlightTyreMileages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted red instead of yellow. */
  redTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Should the user see runsheet via scrolling or via tabs? */
  showRunSheetsAsTabs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted yellow instead of green. */
  yellowTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdVoltageInput = {
  /** mV */
  millivolts?: InputMaybe<Scalars['Float']['input']>;
  /** V */
  volts?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdVolumeInput = {
  /** cm³ */
  cubicCentimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft³ */
  cubicFeet?: InputMaybe<Scalars['Float']['input']>;
  /** in³ */
  cubicInches?: InputMaybe<Scalars['Float']['input']>;
  /** m³ */
  cubicMetres?: InputMaybe<Scalars['Float']['input']>;
  /** gal (US fluid) */
  gallonsUS?: InputMaybe<Scalars['Float']['input']>;
  /** L */
  litres?: InputMaybe<Scalars['Float']['input']>;
  /** mL */
  millilitres?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdWeatherDataInput = {
  /** Air temperature (mean in historical data) */
  TAir?: InputMaybe<Scalars['Float']['input']>;
  /** Predicted air temperature for given session. E.g. for tyre pressure calculation */
  TAirExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum air temperature (for use in historical data) */
  TAirMax?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum air temperature (for use in historical data) */
  TAirMin?: InputMaybe<Scalars['Float']['input']>;
  /** Air temperature from official sources (e.g. FIA) */
  TAirOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient temperature */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Temperature to which air must be cooled to become saturated with water vapor */
  TDewPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station internal temperature */
  TInternal?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature */
  TTrack?: InputMaybe<Scalars['Float']['input']>;
  /** Expected track temperature. E.g. for tyre pressure calculation */
  TTrackExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature from official sources (e.g. FIA) */
  TTrackOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Wind chill factor */
  TWindChill?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station battery voltage */
  VBattery?: InputMaybe<Scalars['Float']['input']>;
  /** Wind direction in radians (0 = North, π/2 = East, π = South, 3π/2 = West) */
  aWind?: InputMaybe<Scalars['Float']['input']>;
  /** Main wind direction during the saving interval */
  aWindMain?: InputMaybe<Scalars['Float']['input']>;
  /** Verbal describing ambient condition like cloudy, sunny, overcast, miserable, … */
  ambientCondition?: InputMaybe<Scalars['String']['input']>;
  globalRadiation?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient pressure */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Humidity ratio */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of rain in m³/m² (so m) */
  rainIntensity?: InputMaybe<Scalars['Float']['input']>;
  /** Rain chance as a ratio */
  rainProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Time stamp for this datum */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Verbal describing track condition like dry, damp, … */
  trackCondition?: InputMaybe<Scalars['String']['input']>;
  /** Wind velocity */
  vWind?: InputMaybe<Scalars['Float']['input']>;
  /** Average wind velocity */
  vWindAverage?: InputMaybe<Scalars['Float']['input']>;
  /** Peak wind velocity */
  vWindPeak?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdWeatherInput = {
  /** Height above sea level (for air density for example). */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  data?: InputMaybe<Array<InputMaybe<UpdateByIdWeatherDataInput>>>;
  /** References to events this weather data was made for, if applicable */
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  geoLocation?: InputMaybe<UpdateByIdGeoLocationInput>;
  /** User notes for completing a forecast for a race */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Forecast/measurement source (website, weather station, timekeeping, …) */
  source?: InputMaybe<Scalars['String']['input']>;
  /** For predictions, indicates the time at which the prediction was made. For measurements, indicates the time of the first measurement in the array. */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Prediction, measurement, historical */
  type?: InputMaybe<EnumWeatherType>;
  /** Weather station ID */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdWeatherPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Weather>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdWeatherServiceConfigInput = {
  /** API Key. Used for Open Weather Map and Wunderground */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** API Secret. Used for Weather Link */
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  eventIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Password. Currently used for meteomatics */
  password?: InputMaybe<Scalars['String']['input']>;
  refreshInterval?: InputMaybe<Scalars['Float']['input']>;
  requestLocation?: InputMaybe<UpdateByIdGeoLocationInput>;
  /** Location or weather station */
  requestType?: InputMaybe<EnumWeatherServiceConfigRequestType>;
  /** Weather client to specify the source where to retrieve the data from. */
  source?: InputMaybe<EnumWeatherServiceConfigSource>;
  type?: InputMaybe<EnumWeatherServiceConfigType>;
  /** Username. Currently used for meteomatics */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Weather Station ID. Used for Weather Underground */
  weatherStationID?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdWeatherServiceConfigPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<WeatherServiceConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateCarSetupResult = {
  updatedCarSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type UpdateCommentResult = {
  comment?: Maybe<Comment>;
  recordId: Scalars['MongoID']['output'];
};

export type UpdateMeInput = {
  /** 3-letter acronym for drivers */
  acronym?: InputMaybe<Scalars['String']['input']>;
  behaviour?: InputMaybe<UpdateByIdBehaviourConfigInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  canopyCredentials?: InputMaybe<UpdateByIdCanopyCredentialsInput>;
  carUpdateMethod?: InputMaybe<EnumMeCarUpdateMethod>;
  defaultFlexLayoutConfigs?: InputMaybe<UpdateByIdDefaultFlexLayoutConfigsInput>;
  defaultRunSheetCompareStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStyleID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultRunSheetStylePhoneID?: InputMaybe<Scalars['MongoID']['input']>;
  defaultTyreReferenceTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Default string for tyre set naming, where x=Chassis, i=Info, s=SetNumber, (c=Corner or a=Axle) */
  defaultTyreSetNameFormat?: InputMaybe<Scalars['String']['input']>;
  displayColor?: InputMaybe<Scalars['String']['input']>;
  dynoConfigID?: InputMaybe<Scalars['MongoID']['input']>;
  /** IDs of contestants editable to this person when logged in. */
  editableContestantIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotificationConfig?: InputMaybe<UpdateByIdNotificationConfigInput>;
  /** Should this user be able to track his working time? */
  isTimeTracker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this user be able to see, update and approve working times for other users? */
  isTimeTrackerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lapSequenceTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  localConnections?: InputMaybe<Array<InputMaybe<UpdateByIdLocalConnectionInput>>>;
  mileageUnit?: InputMaybe<EnumLengthUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportPicture?: InputMaybe<Scalars['String']['input']>;
  /** Collection of favourite plot page config IDs. */
  plotPageConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  privateMobile?: InputMaybe<Scalars['Float']['input']>;
  privatePhone?: InputMaybe<Scalars['Float']['input']>;
  /** Collection of favourite setup overview config IDs. */
  setupOverviewConfigIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  ssoRefs?: InputMaybe<Scalars['JSON']['input']>;
  timeTrackerApprovalByPersonID?: InputMaybe<Scalars['MongoID']['input']>;
  /** Collection of personal setup IDs. */
  userSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  userSimulationSettings?: InputMaybe<UpdateByIdUserSimulationSettingsInput>;
  viewConfig?: InputMaybe<UpdateByIdViewConfigInput>;
  /** IDs of teams visible to this person when logged in. */
  visibleTeamIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  workMobile?: InputMaybe<Scalars['Float']['input']>;
  workPhone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMigrationsResult = {
  success: Scalars['Boolean']['output'];
};

export type UpdateRunSheetLapKpiPayload = {
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateServerSettingsResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSetupSheetLayoutChassisSpecResult = {
  setupSheetStyle?: Maybe<SetupSheetStyle>;
  status?: Maybe<Scalars['String']['output']>;
};

export type UpdateTimingStatusResult = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTrackingSourceSourceValueInAssemblyResult = {
  success?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateTyresInSetResult = {
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdatedChassisSpecVersionOnCarSetups = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertCarBuildResult = {
  chassisAssemblyID?: Maybe<Scalars['MongoID']['output']>;
  runSheetID?: Maybe<Scalars['MongoID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserEnum = UserEnumAssemblyType | UserEnumBuildSheetGroup | UserEnumPartStatus | UserEnumPartType | UserEnumRunPlannerActionItem | UserEnumSimulationDriveFileType | UserEnumTrackingSeverity;

/** Use this enum to have a custom level of filtering / sorting for your assemblies. */
export type UserEnumAssemblyType = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumAssemblyTypeType;
};

export type UserEnumBuildSheetGroup = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumBuildSheetGroupType;
};

/** List of items with pagination. */
export type UserEnumPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<UserEnum>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UserEnumPartStatus = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumPartStatusType;
};

export type UserEnumPartType = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumPartTypeType;
};

export type UserEnumRunPlannerActionItem = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumRunPlannerActionItemType;
};

export type UserEnumSimulationDriveFileType = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumSimulationDriveFileTypeType;
};

export type UserEnumTrackingSeverity = AnyUserEnum & {
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  type: EnumUserEnumTrackingSeverityType;
};

export type UserSimulationSettings = {
  TAmbientPreferred?: Maybe<Scalars['Float']['output']>;
  pAmbientPreferred?: Maybe<Scalars['Float']['output']>;
  rHumidityPreferred?: Maybe<Scalars['Float']['output']>;
  /** User defined run sim slot colours, index corresponds to run slot number. */
  runSimSlotColours?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** User defined setup sim slot colours, index corresponds to setup slot number. */
  setupSimSlotColours?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** IDs of the two user defined setups */
  userDefinedSetupIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type UserSimulationSettingsInput = {
  TAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  pAmbientPreferred?: InputMaybe<Scalars['Float']['input']>;
  rHumidityPreferred?: InputMaybe<Scalars['Float']['input']>;
  /** User defined run sim slot colours, index corresponds to run slot number. */
  runSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** User defined setup sim slot colours, index corresponds to setup slot number. */
  setupSimSlotColours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** IDs of the two user defined setups */
  userDefinedSetupIDs?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type ValidationError = ErrorInterface & {
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidatorError = {
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ValueLimit = {
  /** Background color to use if the value goes beyond this limit. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Float']['output']>;
  /** Text color to use if the value goes beyond this limit. */
  textColor?: Maybe<Scalars['String']['output']>;
};

export type ValueLimitInput = {
  /** Background color to use if the value goes beyond this limit. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Text color to use if the value goes beyond this limit. */
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type Velocity = {
  /** ft/s */
  feetPerSecond: Scalars['Float']['output'];
  /** kph */
  kilometresPerHour: Scalars['Float']['output'];
  /** m/s */
  metresPerSecond: Scalars['Float']['output'];
  /** mph */
  milesPerHour: Scalars['Float']['output'];
};

export type VelocityInput = {
  /** ft/s */
  feetPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** kph */
  kilometresPerHour?: InputMaybe<Scalars['Float']['input']>;
  /** m/s */
  metresPerSecond?: InputMaybe<Scalars['Float']['input']>;
  /** mph */
  milesPerHour?: InputMaybe<Scalars['Float']['input']>;
};

export type VelocityUnitField = {
  unit: EnumVelocityUnit;
};

export type ViewConfig = {
  /** Should tyre mileages be highlighted according to `yellowTyreMileageThreshold` and `redTyreMileageThreshold`? */
  highlightTyreMileages?: Maybe<Scalars['Boolean']['output']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted red instead of yellow. */
  redTyreMileageThreshold?: Maybe<Scalars['Float']['output']>;
  /** Should the user see runsheet via scrolling or via tabs? */
  showRunSheetsAsTabs?: Maybe<Scalars['Boolean']['output']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted yellow instead of green. */
  yellowTyreMileageThreshold?: Maybe<Scalars['Float']['output']>;
};

export type ViewConfigInput = {
  /** Should tyre mileages be highlighted according to `yellowTyreMileageThreshold` and `redTyreMileageThreshold`? */
  highlightTyreMileages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted red instead of yellow. */
  redTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Should the user see runsheet via scrolling or via tabs? */
  showRunSheetsAsTabs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mileage in metres at which a tyre's mileage should be highlighted yellow instead of green. */
  yellowTyreMileageThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type Voltage = {
  /** mV */
  millivolts: Scalars['Float']['output'];
  /** V */
  volts: Scalars['Float']['output'];
};

export type VoltageInput = {
  /** mV */
  millivolts?: InputMaybe<Scalars['Float']['input']>;
  /** V */
  volts?: InputMaybe<Scalars['Float']['input']>;
};

export type Volume = {
  /** cm³ */
  cubicCentimetres: Scalars['Float']['output'];
  /** ft³ */
  cubicFeet: Scalars['Float']['output'];
  /** in³ */
  cubicInches: Scalars['Float']['output'];
  /** m³ */
  cubicMetres: Scalars['Float']['output'];
  /** gal (US fluid) */
  gallonsUS: Scalars['Float']['output'];
  /** L */
  litres: Scalars['Float']['output'];
  /** mL */
  millilitres: Scalars['Float']['output'];
};

export type VolumeInput = {
  /** cm³ */
  cubicCentimetres?: InputMaybe<Scalars['Float']['input']>;
  /** ft³ */
  cubicFeet?: InputMaybe<Scalars['Float']['input']>;
  /** in³ */
  cubicInches?: InputMaybe<Scalars['Float']['input']>;
  /** m³ */
  cubicMetres?: InputMaybe<Scalars['Float']['input']>;
  /** gal (US fluid) */
  gallonsUS?: InputMaybe<Scalars['Float']['input']>;
  /** L */
  litres?: InputMaybe<Scalars['Float']['input']>;
  /** mL */
  millilitres?: InputMaybe<Scalars['Float']['input']>;
};

export type VolumeUnitField = {
  unit: EnumVolumeUnit;
};

export type Weather = {
  _id: Scalars['MongoID']['output'];
  /** Height above sea level (for air density for example). */
  altitude?: Maybe<Scalars['Float']['output']>;
  data: Array<Maybe<WeatherData>>;
  /** References to events this weather data was made for, if applicable */
  eventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Events this weather data was made for, if applicable */
  events: Array<Event>;
  geoLocation?: Maybe<GeoLocation>;
  /** User notes for completing a forecast for a race */
  notes?: Maybe<Scalars['String']['output']>;
  /** Forecast/measurement source (website, weather station, timekeeping, …) */
  source?: Maybe<Scalars['String']['output']>;
  /** For predictions, indicates the time at which the prediction was made. For measurements, indicates the time of the first measurement in the array. */
  time?: Maybe<Scalars['Date']['output']>;
  /** Prediction, measurement, historical */
  type: EnumWeatherType;
  /** Weather station ID */
  weatherStationID?: Maybe<Scalars['String']['output']>;
};

export type WeatherBoxBlock = AnyRunSheetStyleBlock & {
  _id: Scalars['MongoID']['output'];
  blockBackgroundColour?: Maybe<Scalars['String']['output']>;
  /** A map of colorable things to colors */
  colorMap?: Maybe<Scalars['JSON']['output']>;
  defaultOpenState?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the block within the grid */
  height?: Maybe<Scalars['Int']['output']>;
  isShownWhenFolded?: Maybe<Scalars['Boolean']['output']>;
  pressureUnit?: Maybe<EnumPressureUnit>;
  /** Defines the visibility of the ambient and track condition in the weather block */
  showAmbientAndTrackCondition?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `weatherItems` to select what to show instead. */
  showOfficial?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use other fields to style the block instead */
  style?: Maybe<EnumRunSheetStyleBlockStyle>;
  temperatureUnit?: Maybe<EnumTemperatureUnit>;
  unitSystem?: Maybe<EnumUnitSystem>;
  /** Ordered weather block fields to show */
  weatherFieldOrder?: Maybe<Array<EnumWeatherBlockField>>;
  /** The width of the block within the grid */
  width?: Maybe<Scalars['Int']['output']>;
  /** The x position of the block within the grid */
  x?: Maybe<Scalars['Int']['output']>;
  /** The y position of the block within the grid */
  y?: Maybe<Scalars['Int']['output']>;
};

export type WeatherData = {
  /** Air density */
  DAir?: Maybe<Scalars['Float']['output']>;
  /** Air temperature (mean in historical data) */
  TAir?: Maybe<Scalars['Float']['output']>;
  /** Predicted air temperature for given session. E.g. for tyre pressure calculation */
  TAirExpected?: Maybe<Scalars['Float']['output']>;
  /** Maximum air temperature (for use in historical data) */
  TAirMax?: Maybe<Scalars['Float']['output']>;
  /** Minimum air temperature (for use in historical data) */
  TAirMin?: Maybe<Scalars['Float']['output']>;
  /** Air temperature from official sources (e.g. FIA) */
  TAirOfficial?: Maybe<Scalars['Float']['output']>;
  /**
   * Ambient temperature
   * @deprecated Use TAir or TAirOfficial instead.
   */
  TAmbient?: Maybe<Scalars['Float']['output']>;
  /** Temperature to which air must be cooled to become saturated with water vapor */
  TDewPoint?: Maybe<Scalars['Float']['output']>;
  /** Weather station internal temperature */
  TInternal?: Maybe<Scalars['Float']['output']>;
  /** Track temperature */
  TTrack?: Maybe<Scalars['Float']['output']>;
  /** Expected track temperature. E.g. for tyre pressure calculation */
  TTrackExpected?: Maybe<Scalars['Float']['output']>;
  /** Track temperature from official sources (e.g. FIA) */
  TTrackOfficial?: Maybe<Scalars['Float']['output']>;
  /** Wind chill factor */
  TWindChill?: Maybe<Scalars['Float']['output']>;
  /** Weather station battery voltage */
  VBattery?: Maybe<Scalars['Float']['output']>;
  /** Wind direction in radians (0 = North, π/2 = East, π = South, 3π/2 = West) */
  aWind?: Maybe<Scalars['Float']['output']>;
  /** Main wind direction during the saving interval */
  aWindMain?: Maybe<Scalars['Float']['output']>;
  /** Verbal describing ambient condition like cloudy, sunny, overcast, miserable, … */
  ambientCondition?: Maybe<Scalars['String']['output']>;
  globalRadiation?: Maybe<Scalars['Float']['output']>;
  /** Ambient pressure */
  pAmbient?: Maybe<Scalars['Float']['output']>;
  /** Humidity ratio */
  rHumidity?: Maybe<Scalars['Float']['output']>;
  /** Amount of rain in m³/m² (so m) */
  rainIntensity?: Maybe<Scalars['Float']['output']>;
  /** Rain chance as a ratio */
  rainProbability?: Maybe<Scalars['Float']['output']>;
  /** Time stamp for this datum */
  time?: Maybe<Scalars['Date']['output']>;
  /** Verbal describing track condition like dry, damp, … */
  trackCondition?: Maybe<Scalars['String']['output']>;
  /** Wind velocity */
  vWind?: Maybe<Scalars['Float']['output']>;
  /** Average wind velocity */
  vWindAverage?: Maybe<Scalars['Float']['output']>;
  /** Peak wind velocity */
  vWindPeak?: Maybe<Scalars['Float']['output']>;
};

export type WeatherDataInput = {
  /** Air temperature (mean in historical data) */
  TAir?: InputMaybe<Scalars['Float']['input']>;
  /** Predicted air temperature for given session. E.g. for tyre pressure calculation */
  TAirExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum air temperature (for use in historical data) */
  TAirMax?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum air temperature (for use in historical data) */
  TAirMin?: InputMaybe<Scalars['Float']['input']>;
  /** Air temperature from official sources (e.g. FIA) */
  TAirOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient temperature */
  TAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Temperature to which air must be cooled to become saturated with water vapor */
  TDewPoint?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station internal temperature */
  TInternal?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature */
  TTrack?: InputMaybe<Scalars['Float']['input']>;
  /** Expected track temperature. E.g. for tyre pressure calculation */
  TTrackExpected?: InputMaybe<Scalars['Float']['input']>;
  /** Track temperature from official sources (e.g. FIA) */
  TTrackOfficial?: InputMaybe<Scalars['Float']['input']>;
  /** Wind chill factor */
  TWindChill?: InputMaybe<Scalars['Float']['input']>;
  /** Weather station battery voltage */
  VBattery?: InputMaybe<Scalars['Float']['input']>;
  /** Wind direction in radians (0 = North, π/2 = East, π = South, 3π/2 = West) */
  aWind?: InputMaybe<Scalars['Float']['input']>;
  /** Main wind direction during the saving interval */
  aWindMain?: InputMaybe<Scalars['Float']['input']>;
  /** Verbal describing ambient condition like cloudy, sunny, overcast, miserable, … */
  ambientCondition?: InputMaybe<Scalars['String']['input']>;
  globalRadiation?: InputMaybe<Scalars['Float']['input']>;
  /** Ambient pressure */
  pAmbient?: InputMaybe<Scalars['Float']['input']>;
  /** Humidity ratio */
  rHumidity?: InputMaybe<Scalars['Float']['input']>;
  /** Amount of rain in m³/m² (so m) */
  rainIntensity?: InputMaybe<Scalars['Float']['input']>;
  /** Rain chance as a ratio */
  rainProbability?: InputMaybe<Scalars['Float']['input']>;
  /** Time stamp for this datum */
  time?: InputMaybe<Scalars['Date']['input']>;
  /** Verbal describing track condition like dry, damp, … */
  trackCondition?: InputMaybe<Scalars['String']['input']>;
  /** Wind velocity */
  vWind?: InputMaybe<Scalars['Float']['input']>;
  /** Average wind velocity */
  vWindAverage?: InputMaybe<Scalars['Float']['input']>;
  /** Peak wind velocity */
  vWindPeak?: InputMaybe<Scalars['Float']['input']>;
};

/** List of items with pagination. */
export type WeatherPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Weather>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type WeatherServiceConfig = {
  _id: Scalars['MongoID']['output'];
  /** API Key. Used for Open Weather Map and Wunderground */
  apiKey?: Maybe<Scalars['String']['output']>;
  /** API Secret. Used for Weather Link */
  apiSecret?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  eventIDs?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** Events this weather data was made for, if applicable */
  events: Array<Event>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Password. Currently used for meteomatics */
  password?: Maybe<Scalars['String']['output']>;
  refreshInterval: Scalars['Float']['output'];
  requestLocation?: Maybe<GeoLocation>;
  /** Location or weather station */
  requestType: EnumWeatherServiceConfigRequestType;
  /** Weather client to specify the source where to retrieve the data from. */
  source: EnumWeatherServiceConfigSource;
  type: EnumWeatherServiceConfigType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Username. Currently used for meteomatics */
  username?: Maybe<Scalars['String']['output']>;
  /** Weather Station ID. Used for Weather Underground */
  weatherStationID?: Maybe<Scalars['String']['output']>;
};

/** List of items with pagination. */
export type WeatherServiceConfigPagination = {
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<WeatherServiceConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type GetBopForTrackerTableQueryVariables = Exact<{
  sessionIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type GetBopForTrackerTableQuery = { sessions?: { items?: Array<{ _id: string, name: string, shortName?: string | null, tSessionStart?: string | null, bop?: { _id: string, name?: string | null, sessionID: string, session?: { _id: string, name: string, shortName?: string | null } | null, carBop?: Array<{ highlightColour?: string | null, aCamberFmax?: number | null, aCamberFmin?: number | null, aCamberRmax?: number | null, aCamberRmin?: number | null, aRakeMax?: number | null, aRakeMin?: number | null, aWingRmax?: number | null, aWingRmin?: number | null, zWingMin?: number | null, carSpec?: string | null, homologation?: string | null, hRideFmin?: number | null, hRideRmin?: number | null, make?: string | null, mCarBallastMin?: number | null, mCarWeightEmptyMin?: number | null, mCarWeightTotalMin?: number | null, mFuelMassCapacityMax?: number | null, modelYear?: string | null, mRefuelMassMax?: number | null, nEngineMax?: number | null, pEngineBoost?: string | null, PEngineMax?: number | null, rLambdaMin?: number | null, vCarMax?: number | null, VFuelVolumeCapacityMax?: number | null, vPowerCurveBelowRefVelocity?: number | null, rPowerCurveReference?: number | null, rPowerGainAboveRefVelocity?: number | null, vPowerGainReference?: number | null, VRefuelVolumeMax?: number | null, xAirRestrictorMax?: number | null, xFuelRestrictorMax?: number | null, xRefuelRestrictorMax?: number | null, EStintMax?: number | null, _id?: string | null } | null> | null, sessionBop?: { EStintEnergyMax?: number | null, EStintEnergyRefillRateMax?: number | null, fuelType?: string | null, mRefuelRateMax?: number | null, pAmbientSessionOfficial?: number | null, tyreModel?: string | null, VRefuelRateMax?: number | null, xStintlengthMax?: number | null, _id?: string | null } | null } | null }> | null } | null };


export const GetBopForTrackerTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBopForTrackerTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_operators"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionIds"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"TSESSIONSTART_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"tSessionStart"}},{"kind":"Field","name":{"kind":"Name","value":"bop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sessionID"}},{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carBop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlightColour"}},{"kind":"Field","name":{"kind":"Name","value":"aCamberFmax"}},{"kind":"Field","name":{"kind":"Name","value":"aCamberFmin"}},{"kind":"Field","name":{"kind":"Name","value":"aCamberRmax"}},{"kind":"Field","name":{"kind":"Name","value":"aCamberRmin"}},{"kind":"Field","name":{"kind":"Name","value":"aRakeMax"}},{"kind":"Field","name":{"kind":"Name","value":"aRakeMin"}},{"kind":"Field","name":{"kind":"Name","value":"aWingRmax"}},{"kind":"Field","name":{"kind":"Name","value":"aWingRmin"}},{"kind":"Field","name":{"kind":"Name","value":"zWingMin"}},{"kind":"Field","name":{"kind":"Name","value":"carSpec"}},{"kind":"Field","name":{"kind":"Name","value":"homologation"}},{"kind":"Field","name":{"kind":"Name","value":"hRideFmin"}},{"kind":"Field","name":{"kind":"Name","value":"hRideRmin"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"mCarBallastMin"}},{"kind":"Field","name":{"kind":"Name","value":"mCarWeightEmptyMin"}},{"kind":"Field","name":{"kind":"Name","value":"mCarWeightTotalMin"}},{"kind":"Field","name":{"kind":"Name","value":"mFuelMassCapacityMax"}},{"kind":"Field","name":{"kind":"Name","value":"modelYear"}},{"kind":"Field","name":{"kind":"Name","value":"mRefuelMassMax"}},{"kind":"Field","name":{"kind":"Name","value":"nEngineMax"}},{"kind":"Field","name":{"kind":"Name","value":"pEngineBoost"}},{"kind":"Field","name":{"kind":"Name","value":"PEngineMax"}},{"kind":"Field","name":{"kind":"Name","value":"rLambdaMin"}},{"kind":"Field","name":{"kind":"Name","value":"vCarMax"}},{"kind":"Field","name":{"kind":"Name","value":"VFuelVolumeCapacityMax"}},{"kind":"Field","name":{"kind":"Name","value":"vPowerCurveBelowRefVelocity"}},{"kind":"Field","name":{"kind":"Name","value":"rPowerCurveReference"}},{"kind":"Field","name":{"kind":"Name","value":"rPowerGainAboveRefVelocity"}},{"kind":"Field","name":{"kind":"Name","value":"vPowerGainReference"}},{"kind":"Field","name":{"kind":"Name","value":"VRefuelVolumeMax"}},{"kind":"Field","name":{"kind":"Name","value":"xAirRestrictorMax"}},{"kind":"Field","name":{"kind":"Name","value":"xFuelRestrictorMax"}},{"kind":"Field","name":{"kind":"Name","value":"xRefuelRestrictorMax"}},{"kind":"Field","name":{"kind":"Name","value":"EStintMax"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionBop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EStintEnergyMax"}},{"kind":"Field","name":{"kind":"Name","value":"EStintEnergyRefillRateMax"}},{"kind":"Field","name":{"kind":"Name","value":"fuelType"}},{"kind":"Field","name":{"kind":"Name","value":"mRefuelRateMax"}},{"kind":"Field","name":{"kind":"Name","value":"pAmbientSessionOfficial"}},{"kind":"Field","name":{"kind":"Name","value":"tyreModel"}},{"kind":"Field","name":{"kind":"Name","value":"VRefuelRateMax"}},{"kind":"Field","name":{"kind":"Name","value":"xStintlengthMax"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBopForTrackerTableQuery, GetBopForTrackerTableQueryVariables>;